webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventBus_js__ = __webpack_require__(10);






var Ui = function () {
  function Ui() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Ui);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Ui, null, [{
    key: 'setTitle',
    value: function setTitle(title) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_TITLE', title);
      __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$emit('compute_folded');
    }
  }, {
    key: 'setTitleName',
    value: function setTitleName(lead) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_TITLE_NAME', lead);
      __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$emit('compute_folded');
    }
  }, {
    key: 'setBreadcrumbs',
    value: function setBreadcrumbs(breadcrumbs) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_BREADCRUMBS', breadcrumbs);
      __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$emit('compute_folded');

      // Breadcrumbs and subtitle/page level are incompatible
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_SUBTITLE', '');
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_LEVEL', '1');
    }
  }, {
    key: 'setSubtitle',
    value: function setSubtitle(title) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_SUBTITLE', title);
      __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$emit('compute_folded');

      // Breadcrumbs and subtitle/page level are incompatible
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_BREADCRUMBS', []);
    }
  }, {
    key: 'setPageLevel',
    value: function setPageLevel(level) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_LEVEL', level);
      __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$emit('compute_folded');

      // Breadcrumbs and subtitle/page level are incompatible
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_BREADCRUMBS', []);
    }
  }, {
    key: 'setPageType',
    value: function setPageType(level) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_PAGE_TYPE', level);
      __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$emit('compute_folded');
    }
  }, {
    key: 'setHeaderButtons',
    value: function setHeaderButtons(buttons) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_HEADER_BUTTONS', buttons);
      __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$emit('compute_folded');
    }
  }, {
    key: 'clearHeaderButtons',
    value: function clearHeaderButtons() {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_HEADER_BUTTONS', null);
    }
  }, {
    key: 'setSecondaryHeaderTabs',
    value: function setSecondaryHeaderTabs(tabs) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_SECONDARY_HEADER_TABS', tabs);
      __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$emit('compute_folded');
    }
  }, {
    key: 'setPageNumber',
    value: function setPageNumber(page_number) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_CURRENT_PAGE', page_number);
      __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$emit('compute_folded');
    }
  }, {
    key: 'getLevel',
    value: function getLevel() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.page_level;
    }
  }, {
    key: 'getCurrentPageProjects',
    value: function getCurrentPageProjects() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getCurrentPageProjects;
    }
  }, {
    key: 'getCurrentPageSegments',
    value: function getCurrentPageSegments() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getCurrentPageSegments;
    }
  }, {
    key: 'getCurrentPageLeads',
    value: function getCurrentPageLeads() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getCurrentPageLeads;
    }
  }, {
    key: 'getCurrentPageLeadMasks',
    value: function getCurrentPageLeadMasks() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getCurrentPageLeadMasks;
    }
  }, {
    key: 'getCurrentPageUsers',
    value: function getCurrentPageUsers() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getCurrentPageUsers;
    }
  }, {
    key: 'getCurrentPageExternalForms',
    value: function getCurrentPageExternalForms() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getCurrentPageExternalForms;
    }
  }, {
    key: 'getCurrentPageOrganizations',
    value: function getCurrentPageOrganizations() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getCurrentPageOrganizations;
    }
  }, {
    key: 'getCurrentPageEmailTemplates',
    value: function getCurrentPageEmailTemplates() {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getCurrentPageEmailTemplates;
    }
  }, {
    key: 'startLoading',
    value: function startLoading() {
      var div = document.querySelector('.main-content');
      if (div !== null) {
        div.classList.add('is-loading');
      }
    }
  }, {
    key: 'finishLoading',
    value: function finishLoading() {
      var div = document.querySelector('.main-content');
      if (div !== null) {
        div.classList.remove('is-loading');
      }
    }
  }]);

  return Ui;
}();

/* harmony default export */ __webpack_exports__["a"] = (Ui);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(751),
  /* template */
  __webpack_require__(1902),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(90);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_static_permissions__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(65);







// An agnostic class that help determine
// if an operation is permitted or not

var Permission = function () {
  function Permission() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Permission);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Permission, null, [{
    key: 'loadPermissions',


    // will load the static_permissions content
    value: function loadPermissions() {
      var user = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.current_user;

      if (!user) return {};

      var perms = __WEBPACK_IMPORTED_MODULE_4__config_static_permissions__[user.role + "_permission"];
      if (user.role == 'admin') {
        // If the user is an admin, then also merge in all user permissions
        var userPerms = __WEBPACK_IMPORTED_MODULE_4__config_static_permissions__["user_permission"];
        _.merge(userPerms, perms);
        return userPerms;
      }
      return perms;
    }

    // @param operations (object) is the permission object returned by auth action

  }, {
    key: 'readPermissions',
    value: function readPermissions(operations) {
      var newOperations = {};

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(operations).map(function (modelName, index) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(operations[modelName]) === "object") {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(operations[modelName]).map(function (operationName, index) {
            var keyname = modelName + '.' + operationName;
            newOperations[keyname] = operations[modelName][operationName];
          });
        } else {
          newOperations[modelName] = operations[modelName];
        }
      });

      return newOperations;
    }
  }, {
    key: 'getRole',
    value: function getRole() {
      var user = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.current_user;
      if (!user) return null;
      return user.role;
    }
  }, {
    key: 'isRoot',
    value: function isRoot() {
      return Permission.getRole() === 'root';
    }

    // @param permissions (object) return of the readPermissions method
    // @param operation (string) the operation name
    // @return (boolean) true if allowed, false if not

  }, {
    key: 'can',
    value: function can(permissions, operation) {

      if (permissions == null) {
        permissions = Permission.loadPermissions();
      } else if (arguments.length == 1 && typeof permissions == 'string') {
        // Also support a single argument, which is just "operation"
        operation = _.cloneDeep(permissions);
        permissions = Permission.loadPermissions();
      }

      if (permissions.role == "root") {
        return true;
      }

      var perm = Permission.readPermissions(permissions);
      if (perm[operation]) {
        return perm[operation];
      } else {
        return false;
      }
    }
  }, {
    key: 'planCan',
    value: function planCan(operation) {
      var plan = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.getCurrentOrganizationPlan;
      if (plan) {
        var _permissions = plan.rules;
        if (_permissions[operation]) {
          return _permissions[operation];
        }
      }
      return false;
    }
  }]);

  return Permission;
}();

/* harmony default export */ __webpack_exports__["a"] = (Permission);

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Session__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_config__ = __webpack_require__(83);





// eslint-disable-next-line vue/no-invalid-v-if
__webpack_require__(428).polyfill();





// Abstract class, meant to be extended, no instancieated

var Api = function () {
  function Api() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "v1";

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Api);

    var jwt = __WEBPACK_IMPORTED_MODULE_7__classes_Session__["a" /* default */].getJwtCookie();

    this.http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
      baseURL: __WEBPACK_IMPORTED_MODULE_8__config_config__["a" /* apiUrl */] + version + "/",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (jwt === undefined) {
      __WEBPACK_IMPORTED_MODULE_7__classes_Session__["a" /* default */].logout();
      jwt = "";
    } else {
      this.set_jwt(jwt);
    }

    this.page_length = 25;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Api, [{
    key: "getProject",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.http.get("projects" + "/" + params);

              case 2:
                response = _context.sent;
                return _context.abrupt("return", response.data.resource);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getProject(_x2) {
        return _ref.apply(this, arguments);
      }

      return getProject;
    }()
  }, {
    key: "getLead",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.http.get("leads" + "/" + params);

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", response.data.resource);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getLead(_x3) {
        return _ref2.apply(this, arguments);
      }

      return getLead;
    }()
  }, {
    key: "getBusinessKits",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                response = void 0;

                if (!params) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return this.http.get("businesskits" + "/" + params);

              case 4:
                response = _context3.sent;
                _context3.next = 10;
                break;

              case 7:
                _context3.next = 9;
                return this.http.get("businesskits");

              case 9:
                response = _context3.sent;

              case 10:
                return _context3.abrupt("return", response.data.resource);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getBusinessKits(_x4) {
        return _ref3.apply(this, arguments);
      }

      return getBusinessKits;
    }()
  }, {
    key: "getUserInfo",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.http.get("users" + "/" + params);

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", response.data.resource);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getUserInfo(_x5) {
        return _ref4.apply(this, arguments);
      }

      return getUserInfo;
    }()

    // Returns multiple entities based on filter. Watch out for browsers character limit

  }, {
    key: "getMultiple",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(entity) {
        var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "id";
        var value = arguments[2];
        var representer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "full";
        var enforceAllstatuses = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'false';
        var enforceArchived = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'false';
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.http.get(entity + "?filter_by=" + filter + "&filter_value=" + value + "&representer=" + representer + "&disable_pagination=true&enforce_all_statuses=" + enforceAllstatuses + "&enforce_archived=" + enforceArchived);

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", response.data.resources);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getMultiple(_x6) {
        return _ref5.apply(this, arguments);
      }

      return getMultiple;
    }()
  }, {
    key: "searchAutoComplete",
    value: function searchAutoComplete(params) {
      var _this = this;

      if (!params.per_page) {
        params.per_page = 50;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.http.get("/companies/search", { params: params }).then(function (response) {
          // eslint-disable-next-line no-debugger
          resolve(response.data.resources);
        }).catch(function (e) {
          _this.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "set_jwt",
    value: function set_jwt(jwt_token) {
      this.http.defaults.headers.common["Authorization"] = "Bearer " + jwt_token;
    }
  }, {
    key: "model_name",
    value: function model_name() {
      return this.constructor.name.toLowerCase();
    }
  }, {
    key: "all",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _ref7, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (!params.per_page) {
                  params.per_page = this.page_length;
                }

                _context6.next = 4;
                return this.http.get(this.path, { params: params });

              case 4:
                _ref7 = _context6.sent;
                data = _ref7.data;

                if (!(data.resources && !Array.isArray(data.resources))) {
                  _context6.next = 8;
                  break;
                }

                throw 'Non-array returned from list endpoint';

              case 8:

                if (!data.resources) {
                  data.resources = [];
                }

                return _context6.abrupt("return", data);

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);

                this.handleError(_context6.t0);
                throw _context6.t0;

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 12]]);
      }));

      function all() {
        return _ref6.apply(this, arguments);
      }

      return all;
    }()
  }, {
    key: "search",
    value: function search(params, searchQuery) {
      var _this2 = this;

      if (!params.per_page) {
        params.per_page = this.page_length;
      }
      params.query = searchQuery;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.get(_this2.path + "/search", { params: params }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }

    // retrieve all the elements formatted for easy-vue-form-field collections
    // @params name : the field that will be displayed in the select (default: 'name')

  }, {
    key: "all_for_association",
    value: function all_for_association() {
      var _this3 = this;

      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "name";
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!params.per_page) {
        params.per_page = 1000;
      }
      if (!params.sort_by) {
        params.sort_by = name;
        params.sort_order = "ASC";
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.http.get(_this3.path, { params: params }).then(function (response) {
          var finalArray = [];
          response.data.resources.forEach(function (item) {
            finalArray.push({ value: item.id, name: eval("item." + name) });
          });
          resolve(finalArray);
        }).catch(function (e) {
          console.log(e);
          // this.handleError(e)
          reject(e);
        });
      });
    }
  }, {
    key: "show",
    value: function show(id) {
      var _this4 = this;

      var id_name = this.model_name() + "_id";
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.http.get(_this4.path + "/" + id).then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this4.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "myProfile",
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.http.get("users/me");

              case 3:
                response = _context7.sent;
                return _context7.abrupt("return", response.data.resource);

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);

                this.handleError(_context7.t0);
                throw _context7.t0;

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7]]);
      }));

      function myProfile() {
        return _ref8.apply(this, arguments);
      }

      return myProfile;
    }()
  }, {
    key: "userName",
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.http.get("users" + "/" + id);

              case 3:
                response = _context8.sent;
                return _context8.abrupt("return", response.data.resource.display_name);

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](0);

                this.handleError(_context8.t0);
                throw _context8.t0;

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 7]]);
      }));

      function userName(_x14) {
        return _ref9.apply(this, arguments);
      }

      return userName;
    }()
  }, {
    key: "autofillForm",
    value: function autofillForm(id) {
      var _this5 = this;

      var id_name = this.model_name() + "_id";
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.http.get("leads" + "/" + id).then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this5.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "statistics",
    value: function statistics(id) {
      var _this6 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var id_name = this.model_name() + "_id";
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.http.get(_this6.path + "/" + id + "/statistics", params).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this6.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "post",
    value: function post(data) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (data.id) {
          _this7.http.put(_this7.path + "/" + data.id, data).then(function (response) {
            resolve(response.data.resource);
          }).catch(function (e) {
            _this7.handleError(e);
            reject(e);
          });
        } else {
          _this7.http.post(_this7.path, data).then(function (response) {
            resolve(response.data.resource);
          }).catch(function (e) {
            _this7.handleError(e);
            reject(e);
          });
        }
      });
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      var _this8 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this8.http.delete(_this8.path + "/" + id).then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this8.handleError(e);
          reject(e);
        });
      });
    }

    // Ajax error handling

  }, {
    key: "handleError",
    value: function handleError(error) {
      var message = "";
      if (error.response) {
        switch (error.response.status) {
          case 404:
            return error.response;
          case 403:
            if (error.response.data.errors[0].code.includes("authorization.plan.forbidden")) {
              this.handlePlanNotAllowed();
            }
            return error.response;
          case 422:
            // Unprocessable entity
            return error.response;
          case 401:
            this.handleUnauthorized(error);
            break;
          default:
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch("routerGo", -1);
            message = "errors." + error.response.data.errors[0].code;
            __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch("addAxiosError", message);
            break;
        }
      } else if (error.request) {
        // The request was made but no response was received
        message.push("errors." + error.response.data.errors[0].code);
        router.go(-1);
        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch("addAxiosError", message[0]);
      } else {
        // Something happened in setting up the request that triggered an Error
        // Should not happen
        console.log("Error", error.message);
      }
    }

    // Handle an unauthorized error.
    // If no special case is found send user to login screen with error.

  }, {
    key: "handleUnauthorized",
    value: function handleUnauthorized(error) {
      var code = error.response.data.errors[0].code;
      switch (code) {
        case "authentication.inactive_plan":
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit("SET_CURRENT_ORGANIZATION_PLAN_ACTIVE", false);
          break;
        default:
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch("redirectTo", {
            name: "login",
            query: { source: "logout" }
          });
      }
    }

    // Show modal.

  }, {
    key: "handlePlanNotAllowed",
    value: function handlePlanNotAllowed() {
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit("SET_NOT_ALLOWED_MODAL_SHOWN", true);
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Api__ = __webpack_require__(15);












var Project = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(Project, _Api);

  function Project() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "v1";

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Project);

    var _this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Project.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(Project)).call(this, version));

    _this.path = "projects";
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(Project, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.get("/projects").then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }

    // Calls simplified and optimized endpoint for listing projects.
    // The response is much shorter comparing to a regular list endpoint.
    // Essentially the response contains id and name of the project and few more fields like tags.

  }, {
    key: "getShortList",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(queryParams) {
        var defaultQueryParams, query, queryString, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                defaultQueryParams = {
                  sort_by: 'name',
                  disable_pagination: true,
                  enforce_all_statuses: false,
                  enforce_archived: false
                };
                query = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(defaultQueryParams, queryParams);
                queryString = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(query).map(function (param) {
                  return param.join('=');
                }).join('&');
                _context.next = 5;
                return this.http.get("projects/short_list?" + queryString);

              case 5:
                response = _context.sent;
                return _context.abrupt("return", response.data.resources);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getShortList(_x2) {
        return _ref.apply(this, arguments);
      }

      return getShortList;
    }()
  }, {
    key: "get_project",
    value: function get_project(project_id) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.http.get("/projects/" + project_id).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this3.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "assign_user",
    value: function assign_user(user_id, project_id) {
      return this.assign_users([user_id], project_id);
    }
  }, {
    key: "assign_users",
    value: function assign_users(user_ids, project_id) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.http.put(_this4.path + "/" + project_id + "/assign_users", {
          user_ids: user_ids,
          overwrite: true
        }).then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this4.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "statistics_leads_count",
    value: function statistics_leads_count(id) {
      var _this5 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var id_name = this.model_name() + "_id";
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.http.get("/statistics/projects/" + id + "/leads_count", { params: params }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this5.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "unassign_user",
    value: function unassign_user(user_id, project_id) {
      return this.unassign_users([user_id], project_id);
    }
  }, {
    key: "unassign_users",
    value: function unassign_users(users_ids, project_id) {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.http.put(_this6.path + "/" + project_id + "/unassign_users", {
          user_ids: users_ids
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this6.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "assign_businesskit",
    value: function assign_businesskit(businesskit_id, project_id) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.http.put(_this7.path + "/" + project_id + "/assign_businesskit", {
          businesskit_id: businesskit_id
        }).then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this7.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "assign_businesskits",
    value: function assign_businesskits(businesskit_ids, project_id) {
      var _this8 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this8.http.put(_this8.path + "/" + project_id + "/assign_businesskits", {
          businesskit_ids: businesskit_ids,
          overwrite: true
        }).then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this8.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "unassign_businesskit",
    value: function unassign_businesskit(businesskit_id, project_id) {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this9.http.put(_this9.path + "/" + project_id + "/unassign_businesskit", {
          businesskit_id: businesskit_id
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this9.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "send_xls",
    value: function send_xls(project_id, email, locale) {
      var _this10 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this10.http.put("/projects/" + project_id + "/send_lead_export_via_email", {
          params: { email: email, locale: locale }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this10.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "lead_mask",
    value: function lead_mask(id) {
      var _this11 = this;

      var id_name = this.model_name() + "_id";
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this11.http.get(_this11.path + "/" + id + "/lead_mask").then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this11.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "duplicate",
    value: function duplicate(project_id) {
      var _this12 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this12.http.post(_this12.path + "/" + project_id + "/clone").then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this12.handleError(e);
          reject(e);
        });
      });
    }

    // retrieve all the elements formatted for easy-vue-form-field collections
    // @params name : the field that will be displayed in the select (default: 'name')

  }, {
    key: "all_for_association",
    value: function all_for_association() {
      var _this13 = this;

      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "name";
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!params.per_page) {
        params.per_page = 1000;
      }
      if (!params.sort_by) {
        params.sort_by = name;
        params.sort_order = "ASC";
      }
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this13.http.get(_this13.path + "/short_list", { params: params }).then(function (response) {
          var finalArray = [];
          response.data.resources.forEach(function (item) {
            finalArray.push({ value: item.id, name: eval("item." + name) });
          });
          resolve(finalArray);
        }).catch(function (e) {
          console.log(e);
          // this.handleError(e)
          reject(e);
        });
      });
    }
  }]);

  return Project;
}(__WEBPACK_IMPORTED_MODULE_10__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Project);

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1335)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(780),
  /* template */
  __webpack_require__(1923),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Api__ = __webpack_require__(15);










var Organization = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Organization, _Api);

  function Organization() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Organization);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Organization.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Organization)).call(this, version));

    _this.path = 'organizations';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Organization, [{
    key: 'getAll',
    value: function getAll() {
      var enforceAllstatuses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'false';
      var enforceArchived = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'false';

      var _this2 = this;

      var sortBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
      var disablePagination = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'true';

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.get('/organizations?representer=full&sort_by=' + sortBy + '&disable_pagination=' + disablePagination + '&enforce_all_statuses=' + enforceAllstatuses + '&enforce_archived=' + enforceArchived).then(function (response) {
          resolve(response.data.resources);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'projects_crm_sync',
    value: function projects_crm_sync(organization_id) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.http.put('/organizations/' + organization_id + '/enqueue_crm_sync').then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this3.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'projectsList',
    value: function projectsList(organizationId, params) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.http.get('/organizations/' + organizationId + '/projects', {
          params: {
            search: params['search'],
            per_page: 10
          }
        }).then(function (response) {
          resolve(response.data.resources);
        }).catch(function (e) {
          _this4.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'companiesList',
    value: function companiesList(organizationId, params) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.http.get('/organizations/' + organizationId + '/companies', {
          params: {
            search: params['search'],
            per_page: 10
          }
        }).then(function (response) {
          resolve(response.data.resources);
        }).catch(function (e) {
          _this5.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'configuration',
    value: function configuration(organization_id) {
      var _this6 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.http.get('/organizations/' + organization_id + '/organization_configurations', { params: params }).then(function (response) {
          resolve(response.data.resources);
        }).catch(function (e) {
          _this6.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'crm',
    value: function crm(organization_id) {
      var _this7 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.http.get('/organizations/' + organization_id + '/crm', { params: params }).then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this7.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'update_configuration',
    value: function update_configuration(organization_id, configuration) {
      var _this8 = this;

      var configuration_collection = [];

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(configuration).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        configuration_collection.push({ key: key,
          content: val['content'],
          configuration_type: val['configuration_type'] });
      });
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this8.http.put('/organizations/' + organization_id + '/organization_configurations/create_or_update_multiple', { configurations: configuration_collection }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this8.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return Organization;
}(__WEBPACK_IMPORTED_MODULE_8__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Organization);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Api__ = __webpack_require__(15);








var User = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(User, _Api);

  function User() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, User);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (User.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(User)).call(this, version));

    _this.path = 'users';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(User, [{
    key: 'getUserDetailsByToken',
    value: function getUserDetailsByToken(token) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.get(_this2.path + '/retrieve_by_token/' + token).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'invite',
    value: function invite(user) {
      var _this3 = this;

      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';

      user.locale = locale;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.http.post(_this3.path + '/invite', user).then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this3.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'inviteXls',
    value: function inviteXls(formData) {
      var _this4 = this;

      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';

      formData.locale = locale;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.http.post(_this4.path + '/import_xls', formData).then(function (response) {
          resolve(response);
        }).catch(function (e) {
          _this4.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return User;
}(__WEBPACK_IMPORTED_MODULE_6__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1330)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(789),
  /* template */
  __webpack_require__(1916),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Configuration__ = __webpack_require__(233);








global.cookie = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a;

var Session = function () {
  function Session() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Session);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Session, null, [{
    key: 'init',
    value: function init() {
      var token = Session.getJwtCookie();
      if (token && token != null) {
        Session.login(token);
      } else {
        Session.logout();
      }
    }
  }, {
    key: 'login',
    value: function login(jwt_token) {
      var expiration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      var user = Session.getUser(jwt_token);
      Session.setJwtCookie(jwt_token, expiration);

      var api = new __WEBPACK_IMPORTED_MODULE_5__api_Api__["a" /* default */]();
      api.set_jwt(jwt_token);
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('SET_CURRENT_USER', Session.getUser(jwt_token));

      api.myProfile().then(function (result) {
        var merged = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, user, result);
        merged.overwrite = true;
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('SET_CURRENT_USER', merged);
      });

      __WEBPACK_IMPORTED_MODULE_6__classes_Configuration__["a" /* default */].setOrganizationConfig(user);
    }

    // get the current user from token payload

  }, {
    key: 'getUser',
    value: function getUser(jwt_token) {
      try {
        var payload = jwt_token.split('.')[1];
        return JSON.parse(atob(payload));
      } catch (e) {
        Session.logout();
      }
    }
  }, {
    key: 'logout',
    value: function logout() {
      // remove xtable sortings
      localStorage.removeItem('contactsTableSettings');
      localStorage.removeItem('companiesTableSettings');
      localStorage.removeItem('segmentsTableSettings');

      Session.deleteJwtCookie();
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('EMPTY_CURRENT_USER');
    }
  }, {
    key: 'setJwtCookie',
    value: function setJwtCookie(jwt_token) {
      var expiration_time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      if (expiration_time) {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('jwt_token', jwt_token, { expires: expiration_time });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('jwt_token', jwt_token);
      }
    }
  }, {
    key: 'getJwtCookie',
    value: function getJwtCookie() {
      return __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('jwt_token');
    }
  }, {
    key: 'deleteJwtCookie',
    value: function deleteJwtCookie() {
      __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.remove('jwt_token');
    }
  }]);

  return Session;
}();

global.session = Session;

/* harmony default export */ __webpack_exports__["a"] = (Session);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return collectionMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_Pagination__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Permission__ = __webpack_require__(12);








/*
  Using this mixin requires the follow configuration filled out in the components data:

  collectionMixinConfig: {
    storeResetPage: 'RESET_CURRENT_PAGE_PROJECTS', // Vuex store method to call when resetting page
    routerName: 'projects',                        // The name of the route in router.js
    emptyState: 'projects',                        // If an empty state should be set if no records are found
    default_filters: default_filters,              // passing the specific default filter as JSON
    default_sort_by: default_sort_by,              // Default sort by
    default_sort_order: default_sort_order         // Default sort order
  }
*/

var collectionMixin = {
  components: { Collection: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_Pagination___default.a },
  data: function data() {
    return {
      items: [],
      page: 1,
      total_pages: 1,
      params: {},
      level: 1,
      query: {},
      has_searched: false
    };
  },

  computed: {
    singular_model: function singular_model() {
      return this.model.slice(0, -1);
    },
    add_button: function add_button() {
      return this.button !== undefined ? this.button : this.singular_model;
    },
    currentPage: function currentPage() {
      if (this.$route.name === 'projects') {
        return this.$store.getters.getCurrentPageProjects;
      } else if (this.$route.name === 'segments') {
        return this.$store.getters.getCurrentPageSegments;
      } else if (this.$route.name === 'project_leads') {
        return this.$store.getters.getCurrentPageLeads;
      } else if (this.$route.name === 'users') {
        return this.$store.getters.getCurrentPageUsers;
      } else if (this.$route.name === 'external_forms') {
        return this.$store.getters.getCurrentPageExternalForms;
      } else if (this.$route.name === 'email_templates') {
        return this.$store.getters.getCurrentPageEmailTemplates;
      } else if (this.$route.name === 'organizations') {
        return this.$store.getters.getCurrentPageOrganizations;
      } else if (this.$route.name === 'lead_masks') {
        return this.$store.getters.getCurrentPageLeadMasks;
      } else if (this.$route.name === 'workflows') {
        return this.$store.getters.getCurrentPageWorkflows;
      }
    }
  },
  created: function created() {
    this.initQuery();
  },
  mounted: function mounted() {
    var permissions = __WEBPACK_IMPORTED_MODULE_6__classes_Permission__["a" /* default */].loadPermissions();

    if (__WEBPACK_IMPORTED_MODULE_6__classes_Permission__["a" /* default */].can(permissions, this.model + '.list')) {
      __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].startLoading();
      __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].setTitle({ label: this.title });
      __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].setHeaderButtons([{
        name: this.add_button,
        action: this.model + ".new",
        classes: "btn-primary",
        icon: "",
        function: this.addButtonFunction
      }]);
      __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].setPageLevel(this.level);
      __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].setPageType(this.singular_model);
      this.retrieve();
    } else {
      this.$store.commit('ADD_ERROR', {
        type: 'warning',
        message: 'errors.unauthorized'
      });
      this.$router.push({ name: 'unauthorized' });
    }
  },

  methods: {
    itemDelete: function itemDelete(item) {
      var _this = this;

      this.api.delete(item.id).then(function () {
        _this.retrieve();
      });
    },
    goToPage: function goToPage(page) {
      if (this.page !== page) {
        this.query.page = page;
        this.page = page;
        __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].setPageNumber(this.page);
        __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].startLoading();
        this.retrieve();
      }
    },

    // Set an empty stage variable in Vuex which makes the application show an empty state instead of an empty list
    handleEmptyState: function handleEmptyState() {
      if (this.collectionMixinConfig && "emptyState" in this.collectionMixinConfig) {
        this.$store.commit("SET_EMPTY_STATE", this.collectionMixinConfig["emptyState"]);
      }
    },
    resetEmptyState: function resetEmptyState() {
      this.$store.commit("SET_EMPTY_STATE", null);
    },
    generateRouterParams: function generateRouterParams(data) {
      var params = { id: this.id };
      var query = {};
      if (data.page != 1) {
        query.page = data.page;
      }
      if (data.search != "") {
        query.search = data.search;
      }
      if (data.sort_by != this.default_sort_by) {
        query.sort_by = data.sort_by;
      }
      if (data.sort_order != this.default_sort_order) {
        query.sort_order = data.sort_order;
      }
      query.filter_by = data.filter_by;
      query.filter_value = data.filter_value;

      if (data.filters) {
        if (!_.isEqual(data.filters, this.collectionMixinConfig.default_filters)) {
          query.filters = btoa(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.filters));
        }
      }
      return { name: this.collectionMixinConfig.routerName, query: query, params: params };
    },
    search: function search(str) {
      this.query.search = str;
      this.query.page = 1;
      var current_page = this.$route.name;
      this.$store.commit(this.collectionMixinConfig.storeResetPage);
      var routerParams = this.generateRouterParams(this.query);
      this.$router.push(routerParams);
    },
    filterUpdate: function filterUpdate(filters) {
      this.query.filters = filters;
      var routerParams = this.generateRouterParams(this.query);
      this.$router.push(routerParams);
    },
    filterReset: function filterReset() {
      this.query.filters = null;
      var routerParams = this.generateRouterParams(this.query);
      this.$router.push(routerParams);
    },
    sorting: function sorting(params) {
      this.query.sort_by = params.sort_by;
      this.query.sort_order = params.sort_order;
      var routerParams = this.generateRouterParams(this.query);
      this.$router.push(routerParams);
    },
    initQuery: function initQuery() {
      // when we do a search or we sort we add this.query information to the specific method(sort, filter etc...)
      if (this.collectionMixinConfig.default_sort_by) {
        this.query.sort_by = this.collectionMixinConfig.default_sort_by;
        this.query.sort_order = this.collectionMixinConfig.default_sort_order;
      }
      this.query.search = "";

      // from url
      var query = this.$route.query;

      if (query.page) {
        this.query.page = query.page;
      }
      if (query.search) {
        this.query.search = query.search;
      }
      if (query.sort_by) {
        this.query.sort_by = query.sort_by;
      }
      if (query.sort_order) {
        this.query.sort_order = query.sort_order;
      }
      if (query.filter_by) {
        this.query.filter_by = query.filter_by;
      }
      if (query.filter_value) {
        this.query.filter_value = query.filter_value;
      }

      if (query.filters) {
        this.query.filters = JSON.parse(atob(query.filters));
        this.filterDisplay = true;
      } else {
        this.query.filters = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.collectionMixinConfig.default_filters));
      }
    },
    handleSearch: function handleSearch() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchCollection('search');

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleFetchAll: function handleFetchAll() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.fetchCollection();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    execFetch: function execFetch(method) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(method === 'search')) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 3;
                return _this4.api.search(_this4.query, _this4.query.search);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 6:
                _context3.next = 8;
                return _this4.api.all(_this4.query);

              case 8:
                return _context3.abrupt('return', _context3.sent);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    handleResourceNotFound: function handleResourceNotFound() {
      // Don't show empty state if we are searching or filtering
      var isSearching = this.query.search !== '' || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.query.filters) !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.collectionMixinConfig.default_filters);
      if (!isSearching) {
        this.handleEmptyState();
      }
    },
    fetchCollection: function fetchCollection(method) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var items;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this5.execFetch(method);

              case 3:
                items = _context4.sent;

                // If results are not found we might have to do something specific
                if ('resources' in items && items.resources.length === 0 || items.length === 0) {
                  _this5.handleResourceNotFound();
                }
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0;

              case 10:
                _context4.prev = 10;

                _this5.has_searched = true;
                __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].finishLoading();
                _this5.$store.commit("SET_IS_RETRIEVING", false);
                return _context4.finish(10);

              case 15:
                _this5.items = items.resources;
                _this5.page = items.current_page;
                _this5.total_pages = items.total_pages;

              case 18:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 7, 10, 15]]);
      }))();
    },
    retrieve: function retrieve() {
      this.resetEmptyState();
      this.$store.commit("SET_IS_RETRIEVING", true);
      this.query.page = this.page;
      this.has_searched = false;
      if (this.query.search) {
        this.handleSearch();
      } else {
        this.handleFetchAll();
      }
    }
  },
  watch: {
    currentPage: function currentPage(val) {
      this.goToPage(val);
    }
  }
};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field__);




var updateMixin = {
  props: ['id'],
  components: { Field: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field___default.a },
  data: function data() {
    return {
      item: {},
      type: '',
      errors: [],
      level: 2,
      retrieve_method: 'show'
    };
  },

  computed: {
    title: function title() {
      return 'ui.pages.item-' + this.type;
    },
    singular_model: function singular_model() {
      return this.model.slice(0, -1);
    },
    redirection: function redirection() {
      return { name: this.model };
    }
  },
  mounted: function mounted() {
    this.init();
  },

  methods: {
    update: function update() {
      var _this = this;

      this.api.post(this.item).then(function (item) {

        _this.item = item;
        if (_this.$route.name === "user_edit" && item.id === _this.$store.state.current_user.id) {
          _this.updateCurrentUser(item);
        }

        if (_this.$route.name === 'user_profile') {
          item.firstname = _this.currentUser.firstname;
          item.lastname = _this.currentUser.lastname;
          _this.updateCurrentUser(item);
        }
        _this.$router.push('/');
        _this.$store.commit('SET_NOTIFICATION', {
          'title': 'models.' + _this.singular_model + '.message.' + _this.type,
          'type': 'success'
        });
        _this.$router.push(_this.redirection);
      }).catch(function (e) {
        console.log(e.response.data);
        _this.errors = e.response.data.errors;
      });
    },
    updateCurrentUser: function updateCurrentUser(item) {
      item.overwrite = true;
      this.$store.commit('SET_CURRENT_USER', item);
    },
    cancel: function cancel() {
      this.$router.push(this.redirection);
    },
    retrieve: function retrieve(id) {
      var _this2 = this;

      this.api[this.retrieve_method](id).then(function (item) {
        _this2.item = item;
        __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setTitle({ label: _this2.title, params: { name: item.name } });
        __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setPageType(_this2.singular_model);
        __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].finishLoading();
        _this2.afterRetrieve();
      }).catch(function (error) {
        console.log(error);
      });
    },
    afterRetrieve: function afterRetrieve() {},
    init: function init() {
      this.item = {};
      var permissions = __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].loadPermissions();
      if (this.id || this.retrieve_method !== "show") {
        this.type = "update";
      } else {
        this.type = "create";
      }
      if (__WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].can(permissions, this.model + '.' + this.type)) {
        __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setPageLevel(this.level);
        __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].startLoading();

        if (this.type == "update") {
          this.retrieve(this.id);
        } else {
          __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setTitle({ label: this.title });
          __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].finishLoading();
        }
      } else {
        this.$store.commit('ADD_ERROR', {
          type: 'warning',
          message: 'errors.unauthorized'
        });
        this.$router.push({ name: 'unauthorized' });
      }
    }
  },
  watch: {
    '$route.params.id': function $routeParamsId(newId, oldId) {
      this.init();
    }
  }
};

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_i18n__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locales__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vue_i18n__["a" /* default */]);
window.moment = __WEBPACK_IMPORTED_MODULE_2_moment___default.a;

var i18n = new __WEBPACK_IMPORTED_MODULE_0_vue_i18n__["a" /* default */]({
  locale: 'de',
  fallbackLocale: 'en',
  dateTimeFormats: __WEBPACK_IMPORTED_MODULE_3__locales__["a" /* datetime */],
  messages: __WEBPACK_IMPORTED_MODULE_3__locales__["b" /* messages */],
  silentTranslationWarn: true
});

var language = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('language');
if (language !== undefined) {
  i18n.locale = language;
  __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale(language);
} else {
  // default locale
  i18n.locale = 'de';
  __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('de');
}
/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_router__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(64);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var generateUuidv4 = function generateUuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var state = {
  header: {
    compressed: false
  },
  footer: {
    display: true
  },
  current_user: null,
  currentProject: null,
  organization_config: {},
  current_organization_plan_active: true,
  page_title: "",
  page_breadcrumbs: [],
  parent_page_title: { name: '', link: {} },
  page_type: "",
  error: "",
  page_level: '2',
  folded_navigation_width: 0,
  folded_navigation_hidden_items: [],
  drawer_visible: false,
  header_buttons: [],
  notifications: [],
  maxNotificationsCount: 5,
  tabs: [],
  active_tab: '',
  currentPage: {
    projects: 1,
    segments: 1,
    leads: 1,
    users: 1,
    externalForms: 1,
    organizations: 1,
    leadMasks: 1,
    emailTemplates: 1,
    workflows: 1
  },
  dragEditor: {
    unpublishedChanges: 0,
    edited: false,
    activeItem: {},
    activeTab: {},
    currentStructureObject: {},
    currentStructure: [],
    submitButton: null
  },
  lead: {},
  intercomInitialized: false,
  emptyState: null,
  isRetrieving: false,
  projectWizard: {
    customBusinessKit: false,
    step: 1,
    errors: []
  },
  AppDownloadScreen: false,
  notAllowedModalShown: false, // User clicked a menu item they are not allowed to use
  mainContainerClasses: [], // extra classes for main container. Can be built dynamically
  secondaryHeaderTabs: [],
  language: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].locale
};

var mutations = {
  SET_FOOTER_DISPLAY: function SET_FOOTER_DISPLAY(state, payload) {
    state.footer.display = payload;
  },
  SET_HEADER_COMPRESSED: function SET_HEADER_COMPRESSED(state, payload) {
    state.header.compressed = payload;
  },
  RESET_DRAG_EDITOR: function RESET_DRAG_EDITOR(state) {
    state.dragEditor.unpublishedChanges = 0;
    state.dragEditor.activeTab = {};
  },
  SET_DRAG_EDITOR_ACTIVE_TAB: function SET_DRAG_EDITOR_ACTIVE_TAB(state, payload) {
    state.dragEditor.activeTab = payload;
  },
  SET_DRAG_EDITOR_SUBMIT_BUTTON: function SET_DRAG_EDITOR_SUBMIT_BUTTON(state, payload) {
    state.dragEditor.submitButton = payload;
  },
  SET_DRAG_EDITOR_CURRENT_STRUCTURE: function SET_DRAG_EDITOR_CURRENT_STRUCTURE(state, payload) {
    state.dragEditor.currentStructure = payload;
  },
  SET_DRAG_EDITOR_EDITED: function SET_DRAG_EDITOR_EDITED(state, payload) {
    state.dragEditor.edited = payload;
  },
  SET_DRAG_EDITOR_UNPUBLISHED_CHANGES: function SET_DRAG_EDITOR_UNPUBLISHED_CHANGES(state, payload) {
    state.dragEditor.unpublishedChanges = payload;
  },
  SET_DRAG_EDITOR_ACTIVE: function SET_DRAG_EDITOR_ACTIVE(state, payload) {
    if (payload && payload.collection) {
      delete payload.collection;
      delete payload.collectionIdx;
    }
    if (payload) {
      state.dragEditor.activeItem = payload;
    }
  },
  UPDATE_DRAG_EDITOR_ACTIVE: function UPDATE_DRAG_EDITOR_ACTIVE(state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.dragEditor.activeItem, payload.attribute, payload.value);
    state.dragEditor.edited = true;
  },
  CHANGE_LANGUAGE: function CHANGE_LANGUAGE(state, language) {
    __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].locale = language;
    __WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale(language);
    state.language = language;
    __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('language', language);
  },
  EMPTY_LEAD: function EMPTY_LEAD(state) {
    state.lead = {};
  },
  UPDATE_CURRENT_LEAD: function UPDATE_CURRENT_LEAD(state, params) {
    // Overwrite parameters from lead if conflict
    var update_lead = _.extend({}, state.lead, params);
    state.lead = update_lead;
  },
  SET_SECONDARY_HEADER_TABS: function SET_SECONDARY_HEADER_TABS(state, tabs) {
    // Setting secondaryHeaderTabs adds an array of objects as tabs to
    // the secondNavigation component
    state.secondaryHeaderTabs = tabs;
  },
  SET_CURRENT_ORG_CONFIG: function SET_CURRENT_ORG_CONFIG(state, title) {
    state.organization_config = title;
  },
  SET_MAIN_CONTAINER_CLASSES: function SET_MAIN_CONTAINER_CLASSES(state, payload) {
    state.mainContainerClasses = payload;
  },
  SET_CURRENT_ORGANIZATION_PLAN_ACTIVE: function SET_CURRENT_ORGANIZATION_PLAN_ACTIVE(state, bool) {
    state.current_organization_plan_active = bool;
  },
  SET_EMPTY_STATE: function SET_EMPTY_STATE(state, emptyState) {
    state.emptyState = emptyState;
  },
  SET_CURRENT_PROJECT: function SET_CURRENT_PROJECT(state, payload) {
    state.currentProject = payload;
  },
  SET_NOT_ALLOWED_MODAL_SHOWN: function SET_NOT_ALLOWED_MODAL_SHOWN(state, payload) {
    state.notAllowedModalShown = payload;
  },
  EMPTY_CURRENT_PROJECT: function EMPTY_CURRENT_PROJECT(state) {
    state.currentProject = null;
  },
  SET_IS_RETRIEVING: function SET_IS_RETRIEVING(state, isRetrieving) {
    state.isRetrieving = isRetrieving;
  },
  INCREMENT_PROJECT_WIZARD_STEP: function INCREMENT_PROJECT_WIZARD_STEP(state, steps) {
    if (state.projectWizard.step < 3) {
      state.projectWizard.step += steps;
    }
  },
  SET_PROJECT_WIZARD_STEP: function SET_PROJECT_WIZARD_STEP(state, step) {
    if (step > 4) {
      throw new Error('Step length out of bounds');
    }
    state.projectWizard.step = step;
  },
  PROJECT_WIZARD_CUSTOM_BUSINESS_KIT: function PROJECT_WIZARD_CUSTOM_BUSINESS_KIT(state, bool) {
    state.projectWizard.customBusinessKit = bool;
  },
  ADD_PROJECT_WIZARD_ERROR: function ADD_PROJECT_WIZARD_ERROR(state, error) {
    // Don't add if an error is already there for the field
    if (!state.projectWizard.errors.some(function (e) {
      return e.field_name === error.field_name;
    })) {
      state.projectWizard.errors.push(error);
    }
  },
  RESET_PROJECT_WIZARD_ERRORS: function RESET_PROJECT_WIZARD_ERRORS(state) {
    state.projectWizard.errors = [];
  },
  SET_NOTIFICATION: function SET_NOTIFICATION(state, notification) {
    notification.visible = true;
    notification.id = generateUuidv4();
    if (!notification.type || !['info', 'error', 'success'].includes(notification.type)) {
      notification.type = 'info';
    }
    if (!notification.classes) {
      notification.classes = ['animateOpen'];
    }
    if (!notification.duration_ms && notification.duration_ms !== 0) {
      notification.duration_ms = 50 * notification.title.length;
      // Set minimum
      if (notification.duration_ms < 4500) {
        notification.duration_ms = 4500;
      } else if (notification.duration_ms > 7500) {
        notification.duration_ms = 7500;
      }
    }
    if (state.notifications.length <= state.maxNotificationsCount) {
      state.notifications.push(notification);
    }
  },
  SET_NOTIFICATION_CLOSED: function SET_NOTIFICATION_CLOSED(state, id) {
    var notificationIndex = state.notifications.indexOf(state.notifications.find(function (notification) {
      return notification.id === id;
    }));
    // Can be undefined if notifications are emptied
    if (notificationIndex !== undefined) {
      state.notifications.splice(notificationIndex, 1);
    }
    state.notifications.forEach(function (notification) {
      notification.classes.splice(notification.classes.indexOf('animateOpen', 1));
    });
  },
  EMPTY_NOTIFICATION: function EMPTY_NOTIFICATION(state) {
    state.notifications = [];
  },
  SET_PAGE_TITLE: function SET_PAGE_TITLE(state, title) {
    state.page_title = title;
  },
  SET_CURRENT_PAGE: function SET_CURRENT_PAGE(state, page_number) {
    if (state.page_type == 'project') {
      state.currentPage.projects = parseInt(page_number);
    } else if (state.page_type == 'project_lead') {
      state.currentPage.leads = parseInt(page_number);
    } else if (state.page_type == 'user') {
      state.currentPage.users = parseInt(page_number);
    } else if (state.page_type == 'external_form') {
      state.currentPage.externalForms = parseInt(page_number);
    } else if (state.page_type == 'organization') {
      state.currentPage.organizations = parseInt(page_number);
    } else if (state.page_type == 'lead_mask') {
      state.currentPage.leadMasks = parseInt(page_number);
    } else if (state.page_type == 'email_template') {
      state.currentPage.emailTemplates = parseInt(page_number);
    }
  },
  RESET_CURRENT_PAGE_PROJECTS: function RESET_CURRENT_PAGE_PROJECTS(state) {
    state.currentPage.projects = 1;
  },
  RESET_CURRENT_PAGE_LEADS: function RESET_CURRENT_PAGE_LEADS(state) {
    state.currentPage.leads = 1;
  },
  RESET_CURRENT_PAGE_LEAD_MASKS: function RESET_CURRENT_PAGE_LEAD_MASKS(state) {
    state.currentPage.leadMasks = 1;
  },
  RESET_CURRENT_PAGE_USERS: function RESET_CURRENT_PAGE_USERS(state) {
    state.currentPage.users = 1;
  },
  RESET_CURRENT_PAGE_EXTERNAL_FORMS: function RESET_CURRENT_PAGE_EXTERNAL_FORMS(state) {
    state.currentPage.externalForms = 1;
  },
  RESET_CURRENT_PAGE_ORGANIZATIONS: function RESET_CURRENT_PAGE_ORGANIZATIONS(state) {
    state.currentPage.organizations = 1;
  },
  RESET_CURRENT_PAGE_EMAIL_TEMPLATES: function RESET_CURRENT_PAGE_EMAIL_TEMPLATES(state) {
    state.currentPage.emailTemplates = 1;
  },
  RESET_CURRENT_PAGE_WORKFLOWS: function RESET_CURRENT_PAGE_WORKFLOWS(state) {
    state.currentPage.workflows = 1;
  },
  RESET_ALL_PAGES: function RESET_ALL_PAGES(state) {
    state.currentPage.organizations = 1;
    state.currentPage.users = 1;
    state.currentPage.projects = 1;
    state.currentPage.leads = 1;
    state.currentPage.emailTemplates = 1;
    state.currentPage.externalForms = 1;
    state.currentPage.leadMasks = 1;
    state.currentPage.workflows = 1;
  },
  SET_PAGE_TITLE_NAME: function SET_PAGE_TITLE_NAME(state, lead) {
    var string = '';
    lead.firstname ? string += lead.firstname : string;
    string += ' ';
    lead.lastname ? string += lead.lastname : string;
    string = string.trim();
    if (string) {
      state.page_title = { label: string };
    } else {
      state.page_title = { label: lead.email };
    }
  },
  SET_PAGE_BREADCRUMBS: function SET_PAGE_BREADCRUMBS(state, breadcrumbs) {
    state.page_breadcrumbs = breadcrumbs;
  },
  SET_PAGE_SUBTITLE: function SET_PAGE_SUBTITLE(state, title) {
    state.parent_page_title = title;
  },
  SET_PAGE_LEVEL: function SET_PAGE_LEVEL(state, level) {
    state.page_level = level;
  },
  SET_PAGE_TYPE: function SET_PAGE_TYPE(state, type) {
    state.page_type = type;
  },
  SET_HEADER_BUTTONS: function SET_HEADER_BUTTONS(state, buttons) {
    state.header_buttons = buttons;
  },
  ADD_ERROR: function ADD_ERROR(state, error) {
    state.error = error;
  },
  EMPTY_ERROR: function EMPTY_ERROR(state) {
    state.error = "";
  },
  EMPTY_FOLDED_NAVIGATION_HIDDEN_ITEMS: function EMPTY_FOLDED_NAVIGATION_HIDDEN_ITEMS(state) {
    state.folded_navigation_hidden_items = [];
  },
  ADD_FOLDED_NAVIGATION_HIDDEN_ITEMS: function ADD_FOLDED_NAVIGATION_HIDDEN_ITEMS(state, item) {
    state.folded_navigation_hidden_items.push(item);
  },
  SET_DRAWER_VISIBLE: function SET_DRAWER_VISIBLE(state, boolean) {
    state.drawer_visible = boolean;
  },
  SET_CURRENT_USER: function SET_CURRENT_USER(state, user) {
    if (user.overwrite) {
      state.current_user = user;
    } else if (state.current_user === null) {
      state.current_user = user;
    }
  },
  SET_CURRENT_USER_FIRSTNAME: function SET_CURRENT_USER_FIRSTNAME(state, firstName) {
    state.current_user.firstname = firstName;
  },
  SET_CURRENT_USER_LASTNAME: function SET_CURRENT_USER_LASTNAME(state, lastName) {
    state.current_user.lastname = lastName;
  },
  SET_CURRENT_USER_ONBOARDED: function SET_CURRENT_USER_ONBOARDED(state) {
    state.current_user.is_onboarded = true;
  },
  SET_CURRENT_USER_HAS_SEEN_SCREEN: function SET_CURRENT_USER_HAS_SEEN_SCREEN(state) {
    state.app_download_screen = true;
  },
  EMPTY_CURRENT_USER: function EMPTY_CURRENT_USER(state) {
    state.current_user = null;
  },
  SET_TABS: function SET_TABS(state, tabs) {
    state.tabs = tabs;
  },
  SET_TABS_IN_EDITOR: function SET_TABS_IN_EDITOR(state, tabs) {
    state.tabs = tabs;
  },
  EMPTY_TABS: function EMPTY_TABS(state) {
    state.tabs = [];
  },
  SET_ACTIVE_TAB: function SET_ACTIVE_TAB(state, name) {
    state.active_tab = name;
  },
  NEXT_TAB: function NEXT_TAB(state) {
    var newTab = void 0;
    state.tabs.forEach(function (tab, key) {
      if (tab.name == state.active_tab) {
        var newKey = key + 1;
        if (state.tabs[newKey]) {
          newTab = state.tabs[newKey].name;
        }
      }
    });
    if (newTab) {
      state.active_tab = newTab;
    }
  },
  PREV_TAB: function PREV_TAB(state) {
    var newTab = void 0;
    state.tabs.forEach(function (tab, key) {
      if (tab.name == state.active_tab) {
        var newKey = key - 1;
        if (state.tabs[newKey]) {
          newTab = state.tabs[newKey].name;
        }
      }
    });
    if (newTab) {
      state.active_tab = newTab;
    }
  },
  SET_INTERCOM_INITIALIZED: function SET_INTERCOM_INITIALIZED(state, bool) {
    state.intercomInitialized = bool;
  }
};

var actions = {
  addAxiosError: function addAxiosError(context, error_message) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'error';

    context.commit('SET_NOTIFICATION', {
      'title': error_message,
      'type': type
    });
  },
  redirectTo: function redirectTo(context, route) {
    __WEBPACK_IMPORTED_MODULE_3__config_router__["a" /* default */].push(route);
  },
  routerGo: function routerGo(context, steps) {
    __WEBPACK_IMPORTED_MODULE_3__config_router__["a" /* default */].go(steps);
    // clear route
  }
};

var getters = {
  getHeaderState: function getHeaderState(state) {
    return state.header;
  },
  getDragEditorActiveTab: function getDragEditorActiveTab(state) {
    return state.dragEditor.activeTab;
  },
  getDragEditorSubmitButton: function getDragEditorSubmitButton() {
    return state.dragEditor.submitButton;
  },
  getDragEditorCurrentStructure: function getDragEditorCurrentStructure() {
    return state.dragEditor.currentStructure;
  },
  getDragEditorActiveItem: function getDragEditorActiveItem(state) {
    return state.dragEditor.activeItem;
  },
  getDragEditorUnpublishedChanges: function getDragEditorUnpublishedChanges(state) {
    return state.dragEditor.unpublishedChanges;
  },
  getDragEditorEdited: function getDragEditorEdited(state) {
    return state.dragEditor.edited;
  },
  getErrors: function getErrors(state) {
    return state.errors;
  },
  getMainContainerClasses: function getMainContainerClasses(state) {
    return state.mainContainerClasses;
  },
  getHeaderButtons: function getHeaderButtons(state) {
    return state.header_buttons;
  },
  getNotifications: function getNotifications(state) {
    return state.notifications;
  },
  currentUser: function currentUser(state) {
    return state.current_user;
  },
  getCurrentProject: function getCurrentProject(state) {
    return state.currentProject;
  },
  getCurrentUserIsAdmin: function getCurrentUserIsAdmin(state) {
    if (!state.current_user) {
      return false;
    }
    var role = state.current_user.role;
    return role === 'admin' || role === 'root';
  },
  getCurrentUserIsRoot: function getCurrentUserIsRoot(state) {
    if (!state.current_user) {
      return false;
    }
    var role = state.current_user.role;
    return role === 'root';
  },
  getTitle: function getTitle(state) {
    return state.page_title;
  },
  getEmptyState: function getEmptyState(state) {
    return state.emptyState;
  },
  getProjectWizardStep: function getProjectWizardStep(state) {
    return state.projectWizard.step;
  },
  getProjectWizardErrors: function getProjectWizardErrors(state) {
    return state.projectWizard.errors;
  },
  getProjectWizardCustomBusinessKit: function getProjectWizardCustomBusinessKit(state) {
    return state.projectWizard.customBusinessKit;
  },
  getIsRetrieving: function getIsRetrieving(state) {
    return state.isRetrieving;
  },
  getBreadcrumbs: function getBreadcrumbs(state) {
    return state.page_breadcrumbs;
  },
  getSubtitle: function getSubtitle(state) {
    return state.parent_page_title;
  },
  getOrganizationConfigs: function getOrganizationConfigs(state) {
    return state.organization_config;
  },

  getOrganizationConfig: function getOrganizationConfig(state) {
    return function (config_name) {
      var prop = 'organization_config.' + config_name + '.content';
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(state, prop);
    };
  },
  getCurrentPageProjects: function getCurrentPageProjects(state) {
    return state.currentPage.projects;
  },
  getCurrentPageSegments: function getCurrentPageSegments(state) {
    return state.currentPage.segments;
  },
  getCurrentPageLeads: function getCurrentPageLeads(state) {
    return state.currentPage.leads;
  },
  getCurrentLead: function getCurrentLead(state) {
    return state.lead;
  },
  getCurrentPageLeadMasks: function getCurrentPageLeadMasks(state) {
    return state.currentPage.leadMasks;
  },
  getCurrentPageUsers: function getCurrentPageUsers(state) {
    return state.currentPage.users;
  },
  getCurrentPageOrganizations: function getCurrentPageOrganizations(state) {
    return state.currentPage.organizations;
  },
  getCurrentPageExternalForms: function getCurrentPageExternalForms(state) {
    return state.currentPage.externalForms;
  },
  getCurrentPageEmailTemplates: function getCurrentPageEmailTemplates(state) {
    return state.currentPage.emailTemplates;
  },
  getCurrentPageWorkflows: function getCurrentPageWorkflows(state) {
    return state.currentPage.workflows;
  },
  getCurrentOrganizationPlanActive: function getCurrentOrganizationPlanActive(state) {
    return state.current_organization_plan_active;
  },
  getCurrentOrganizationPlan: function getCurrentOrganizationPlan(state) {
    if (!state.current_user || !state.current_user.organization) {
      return null;
    }
    return state.current_user.organization.plan;
  },
  getCurrentPlanIsTalent: function getCurrentPlanIsTalent(state) {
    if (!state.current_user || !state.current_user.organization) {
      // If the plan is not set (fx on login page) use the URL as a fallback
      return window.location.hostname.includes('talent');
    }
    return state.current_user.organization.plan.name === 'TALENT';
  },
  getNotAllowedModalShown: function getNotAllowedModalShown(state) {
    return state.notAllowedModalShown;
  },
  getIntercomSettings: function getIntercomSettings(state) {
    if (!state.current_user || !state.current_user.organization) {
      return null;
    }
    return {
      "role": state.current_user.role,
      "user_id": state.current_user.id,
      "email": state.current_user.email,
      "name": state.current_user.display_name,
      "created_at": state.current_user.created_at,
      "plan_name": state.current_user.organization.plan.name,
      "app_id": "qsyfi6lp",
      "project_count": state.current_user.organization.project_count,
      "lead_count": state.current_user.organization.lead_count,
      "company": {
        "id": state.current_user.organization.id,
        "name": state.current_user.organization.name,
        "created_at": state.current_user.organization.created_at,
        "eventbaxx_event_count": state.current_user.organization.eventbaxx_event_count
      }
    };
  },
  getIntercomInitialized: function getIntercomInitialized(state) {
    return state.intercomInitialized;
  },
  getUserIsOnboarded: function getUserIsOnboarded(state) {
    if (state.current_user && 'is_onboarded' in state.current_user) {
      return state.current_user.is_onboarded;
    }
    return true;
  },
  getAppDownloadScreen: function getAppDownloadScreen(state) {
    return state.getAppDownloadScreen;
  },
  getSecondaryHeaderTabs: function getSecondaryHeaderTabs(state) {
    return state.secondaryHeaderTabs;
  },
  getActiveTab: function getActiveTab(state) {
    return state.active_tab;
  },
  getCurrentLanguage: function getCurrentLanguage(state) {
    return state.language;
  },
  getBusinessKitLink: function getBusinessKitLink(state, getters) {
    var config = state.organization_config.eventbaxx_auth_token;
    var url = undefined;
    var isStaging = window.location.hostname.includes('staging');

    var eventbaxxUrl = undefined;

    if (eventbaxxUrl) {
      url = eventbaxxUrl + '/auth_login/';
    } else if (isStaging) {
      url = 'https://events-staging.fanomena.io/auth_login/';
    } else {
      var talent = getters.getCurrentPlanIsTalent;
      if (talent) {
        url = 'https://talentkit.fanomena.io/auth_login/';
      } else {
        url = 'https://businesskit.fanomena.io/auth_login/';
      }
    }
    // Append eventbaxx token for automatic login
    if (config) {
      url += config.content;
    }
    return url;
  },
  getFavIcoAndTitle: function getFavIcoAndTitle(state, getters) {
    var talent = getters.getCurrentPlanIsTalent;
    if (talent) {
      return {
        ico: "/static/talents_logo.ico",
        title: "Talent"
      };
    } else {
      return {
        ico: "/static/logo_sign.ico",
        title: "Leads"
      };
    }
  },
  getFooterLinks: function getFooterLinks(state, getters) {
    var talent = getters.getCurrentPlanIsTalent;
    if (talent) {
      return {
        'imprint': 'https://fanomena.io/impressum/',
        'privacy': 'https://fanomena.io/datenschutz/',
        'terms': '#'
      };
    } else {
      return {
        'imprint': 'https://fanomena.io/impressum/',
        'privacy': 'https://fanomena.io/datenschutz/',
        'terms': 'https://fanomena.io/impressum/'
      };
    }
  },
  getFooterDisplay: function getFooterDisplay(state) {
    return state.footer.display;
  },
  getHileadzzPublicFormUrl: function getHileadzzPublicFormUrl(state) {
    // Return JS for displaying hileadzz forms
    // Return an overwriteUrl as well so we can target a specific API
    if (false) {
      return {
        js: 'http://localhost:4567/js/hileadzz_form.js',
        apiOverwrite: 'http://localhost:4567'
      };
    } else {
      // In this case the apiOverwrite is so that our staging server, which runs in production,
      // can overwrite the URL and use the staging API
      return {
        js: "https://forms.fanomena.io/" + '/js/hileadzz_form-min.js',
        apiOverwrite: "https://forms.fanomena.io/"
      };
    }
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters,
  strict: "production" !== 'production'
});

// global.store = store

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1384)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(1978),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Api__ = __webpack_require__(15);








var ExternalForm = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ExternalForm, _Api);

  function ExternalForm() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ExternalForm);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExternalForm.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ExternalForm)).call(this, version));

    _this.path = 'businesskits';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ExternalForm, [{
    key: 'assign',
    value: function assign(business_kit_id, project_id) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.put(_this2.path + '/' + business_kit_id + '/assign_project', { project_id: project_id }).then(function (response) {
          resolve(response.data.resource);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'send',
    value: function send(business_kit_id, lead_id) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.http.put(_this3.path + '/' + business_kit_id + '/send', { lead_id: lead_id }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this3.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return ExternalForm;
}(__WEBPACK_IMPORTED_MODULE_6__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ExternalForm);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fullNavigation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formUrl; });
var fullNavigation = [{ name: "projects", title: "Projects", icon: "icon icon-file", credential: "projects.list" }, { name: "lead_masks", title: "Lead sheets", icon: 'icon icon-layout1', access: "allowed_custom_leadsheets", credential: "lead_masks.list" }, { name: "users", title: "Manage users", icon: "icon icon-users", credential: "users.list" }, { name: "organizations", title: "Manage organizations", icon: "icon icon-globe1", credential: "organizations.list" }, { name: "content_manager", title: "Content Manager", icon: 'icon icon-grid1', class: "content_manager", credential: "external_forms.list" }, { name: "external_forms", title: "Forms", credential: "external_forms.list", class: "nested", access: "allowed_forms" }, { name: "projects_synchronize", title: "", credential: "projects.synchronize", class: "sync-item", icon: "icon icon-refresh-ccw1", access: "allowed_crm" }];

var apiUrl = "https://api.fanomena.io/";
//     Please don't remove these:
//     apiUrl  = "https://api-test.fanomena.io/"
//     apiUrl  = "https://api-staging.fanomena.io/"
//     apiUrl  = "https://api.fanomena.io/"

// Default fallback logic when API_URL was not specified explicitly
if (!apiUrl) {
  if (true) {
    apiUrl = "/api/";
  } else {
    apiUrl = "http://localhost:3000/";
  }
}

var formUrl = "https://forms.fanomena.io/";
// Default fallback logic when FORM_URL was not specified explicitly
if (!formUrl) {
  if (true) {
    formUrl = "/hileadzzform/";
  } else {
    formUrl = "http://localhost:4567/";
  }
}



/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_Session__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_config__ = __webpack_require__(83);




/* eslint-disable no-debugger */
__webpack_require__(428).polyfill();




// Abstract class, meant to be extended, no instancieated

var Charts = function () {
  function Charts() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "v2";

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Charts);

    var jwt = __WEBPACK_IMPORTED_MODULE_5__classes_Session__["a" /* default */].getJwtCookie();

    this.http = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
      baseURL: __WEBPACK_IMPORTED_MODULE_6__config_config__["a" /* apiUrl */] + version + "/",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (jwt === undefined) {
      __WEBPACK_IMPORTED_MODULE_5__classes_Session__["a" /* default */].logout();
      jwt = "";
    } else {
      this.set_jwt(jwt);
    }

    this.page_length = 25;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Charts, [{
    key: "set_jwt",
    value: function set_jwt(jwt_token) {
      this.http.defaults.headers.common["Authorization"] = "Bearer " + jwt_token;
    }
  }, {
    key: "postQuery",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(params) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.http.post("/statistixx", { params: params });

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function postQuery(_x2) {
        return _ref.apply(this, arguments);
      }

      return postQuery;
    }()
  }]);

  return Charts;
}();

/* harmony default export */ __webpack_exports__["a"] = (Charts);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__classes_Session__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_config__ = __webpack_require__(83);















var ContactsApi = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(ContactsApi, _Api);

  function ContactsApi() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "public/v2";

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ContactsApi);

    var _this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContactsApi.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(ContactsApi)).call(this, version));

    var jwt = __WEBPACK_IMPORTED_MODULE_11__classes_Session__["a" /* default */].getJwtCookie();

    _this.http = __WEBPACK_IMPORTED_MODULE_10_axios___default.a.create({
      baseURL: __WEBPACK_IMPORTED_MODULE_13__config_config__["a" /* apiUrl */] + version + "/",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (jwt === undefined) {
      __WEBPACK_IMPORTED_MODULE_11__classes_Session__["a" /* default */].logout();
      jwt = "";
    } else {
      _this.set_jwt(jwt);
    }
    _this.page_length = 25;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ContactsApi, [{
    key: "import",
    value: function _import(formData) {
      var _this2 = this;

      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "de";

      formData.locale = locale;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.post("contacts/import", formData).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }

    //this request gets all contacts and also performs filtering and searching on the contact table

  }, {
    key: "getAllContacts",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (params) {
                  params = {
                    contact_filters: params["contact_filters"] ? params["contact_filters"] : {},
                    search: params["search"] ? params["search"] : "",
                    per_page: params["per_page"] ? params["per_page"] : 25,
                    page: params["page"] ? params["page"] : 1,
                    sort_by: params["sort_by"] ? params["sort_by"] : "id",
                    sort_order: params["sort_order"] ? params["sort_order"] : "ASC"
                  };
                } else {
                  params = {};
                }

                _context.next = 3;
                return this.http.get("contacts", {
                  params: params
                });

              case 3:
                response = _context.sent;
                return _context.abrupt("return", response);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllContacts() {
        return _ref.apply(this, arguments);
      }

      return getAllContacts;
    }()
  }, {
    key: "getContactsCompany",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.http.get("companies" + "/" + params);

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", response.data.resource);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getContactsCompany(_x4) {
        return _ref2.apply(this, arguments);
      }

      return getContactsCompany;
    }()
  }, {
    key: "getContact",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.http.get("contacts/" + params);

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", response.data.resource);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getContact(_x5) {
        return _ref3.apply(this, arguments);
      }

      return getContact;
    }()
  }, {
    key: "delete",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
        var ids, report, numSucceeded, numFailed, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _id, results;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                ids = [];

                if (Array.isArray(id)) {
                  ids = id;
                } else {
                  ids = [id];
                }
                report = {};
                numSucceeded = 0;
                numFailed = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 8;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(ids);

              case 10:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 20;
                  break;
                }

                _id = _step.value;
                _context4.next = 14;
                return this.http.delete("contacts/" + _id);

              case 14:
                results = _context4.sent;

                if (results.status == 204) {
                  numSucceeded += 1;
                } else {
                  numFailed += 1;
                }
                report[_id] = {
                  status: results.status,
                  statusText: results.statusText
                };

              case 17:
                _iteratorNormalCompletion = true;
                _context4.next = 10;
                break;

              case 20:
                _context4.next = 26;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 26:
                _context4.prev = 26;
                _context4.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 29:
                _context4.prev = 29;

                if (!_didIteratorError) {
                  _context4.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context4.finish(29);

              case 33:
                return _context4.finish(26);

              case 34:
                report["summary"] = {
                  num_succeeded: numSucceeded,
                  num_failed: numFailed
                };
                return _context4.abrupt("return", report);

              case 36:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[8, 22, 26, 34], [27,, 29, 33]]);
      }));

      function _delete(_x6) {
        return _ref4.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "exportContacts",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.http.put("contacts/export_contacts", params);

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", response);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function exportContacts() {
        return _ref5.apply(this, arguments);
      }

      return exportContacts;
    }()
  }, {
    key: "updateContact",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(id, params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.http.put("contacts/" + id, params);

              case 2:
                response = _context6.sent;


                if (response.status == 201) {
                  __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.contacts.actions.success",
                    type: "success"
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.contacts.actions.error",
                    type: "error"
                  });
                }

                return _context6.abrupt("return", response.data.resource);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateContact(_x8, _x9) {
        return _ref6.apply(this, arguments);
      }

      return updateContact;
    }()
  }, {
    key: "updateContactsCompany",
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.http.put("contacts/company_update", {
                  company_id: params["companyId"],
                  contact_ids: params["contactIds"]
                });

              case 2:
                response = _context7.sent;

                if (response.status == 204) {
                  __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.contacts.actions.success",
                    type: "success"
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.contacts.actions.error",
                    type: "error"
                  });
                }

                return _context7.abrupt("return", response.data.resource);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateContactsCompany(_x10) {
        return _ref7.apply(this, arguments);
      }

      return updateContactsCompany;
    }()
  }, {
    key: "sendBusinessKits",
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.http.post("contacts/send_business_kits", {
                  business_kit_id: params["businessKitId"],
                  project_name: params["projectName"],
                  segment_id: params["segmentId"],
                  organization_id: params["organizationId"],
                  contact_ids: params["contactIds"]
                });

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", response);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function sendBusinessKits() {
        return _ref8.apply(this, arguments);
      }

      return sendBusinessKits;
    }()
  }, {
    key: "addToProject",
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.http.post("contacts/add_to_project", {
                  project_id: params["projectId"],
                  segment_id: params["segmentId"],
                  organization_id: params["organizationId"],
                  contact_ids: params["contactIds"]
                });

              case 2:
                response = _context9.sent;
                return _context9.abrupt("return", response);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function addToProject() {
        return _ref9.apply(this, arguments);
      }

      return addToProject;
    }()
  }, {
    key: "send_xls",
    value: function send_xls(contact_id, email, locale) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.http.put("/contacts/" + contact_id + "/send_lead_export_via_email", {
          params: { email: email, locale: locale }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this3.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "search",
    value: function search(params, searchQuery) {
      var _this4 = this;

      if (!params.per_page) {
        params.per_page = this.page_length;
      }

      params.query = searchQuery;
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.http.get("contacts/search", { params: params }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this4.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return ContactsApi;
}(__WEBPACK_IMPORTED_MODULE_9__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ContactsApi);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Api__ = __webpack_require__(15);










var Lead = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Lead, _Api);

  function Lead() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Lead);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Lead.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Lead)).call(this, version));

    _this.path = 'leads';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Lead, [{
    key: 'upload_business_card',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data) {
        var _this2 = this;

        var bk_data, dataLength, formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                bk_data = data.business_card_data;
                dataLength = parseInt(bk_data.replace(/=/g, "").length * 0.75);
                formData = new FormData();
                _context.next = 5;
                return this.rightSize(bk_data);

              case 5:
                bk_data = _context.sent;


                formData.append('project_id', data.project_id);
                formData.append('origin', "web_app");

                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this2.base64toFile(bk_data, 'a.jpg').then(function (file) {
                    formData.append('business_card_data', file);

                    _this2.http.post('/leads/create_from_businesscard', formData).then(function (response) {
                      resolve(response.data.resource);
                    }).catch(function (e) {
                      _this2.handleError(e);
                      reject(e);
                    });
                  });
                }));

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function upload_business_card(_x2) {
        return _ref.apply(this, arguments);
      }

      return upload_business_card;
    }()
  }, {
    key: 'rightSize',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dataURI) {
        var maxLength, maxSize, sizes, ratio, newDataURI;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                maxLength = 2000000;
                maxSize = 1200;
                _context2.next = 4;
                return this.base64sizes(dataURI);

              case 4:
                sizes = _context2.sent;
                ratio = 0;


                if (sizes.width > sizes.height) {
                  ratio = maxSize / sizes.width;
                } else {
                  ratio = maxSize / sizes.height;
                }

                _context2.next = 9;
                return this.resizedataURL(dataURI, sizes.width * ratio, sizes.height * ratio);

              case 9:
                newDataURI = _context2.sent;
                return _context2.abrupt('return', newDataURI);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function rightSize(_x3) {
        return _ref2.apply(this, arguments);
      }

      return rightSize;
    }()
  }, {
    key: 'resizedataURL',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(datas, wantedWidth, wantedHeight) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                  // We create an image to receive the Data URI
                  var img = document.createElement('img');

                  // When the event "onload" is triggered we can resize the image.
                  img.onload = function () {
                    // We create a canvas and get its context.
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');

                    // We set the dimensions at the wanted size.
                    canvas.width = wantedWidth;
                    canvas.height = wantedHeight;

                    // We resize the image with the canvas method drawImage();
                    ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

                    var dataURI = canvas.toDataURL('image/jpeg', 0.65);
                    resolve(dataURI);
                  };
                  img.src = datas;
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function resizedataURL(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
      }

      return resizedataURL;
    }()
  }, {
    key: 'resizedataURL',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(datas, wantedWidth, wantedHeight) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                  // We create an image to receive the Data URI
                  var img = document.createElement('img');

                  // When the event "onload" is triggered we can resize the image.
                  img.onload = function () {
                    // We create a canvas and get its context.
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');

                    // We set the dimensions at the wanted size.
                    canvas.width = wantedWidth;
                    canvas.height = wantedHeight;

                    // We resize the image with the canvas method drawImage();
                    ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

                    var dataURI = canvas.toDataURL('image/jpeg', 0.65);

                    resolve(dataURI);
                  };
                  img.src = datas;
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function resizedataURL(_x7, _x8, _x9) {
        return _ref4.apply(this, arguments);
      }

      return resizedataURL;
    }()
  }, {
    key: 'base64sizes',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var i = new Image();
                  i.onload = function () {
                    resolve({ width: i.width, height: i.height });
                  };
                  i.src = data;
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function base64sizes(_x10) {
        return _ref5.apply(this, arguments);
      }

      return base64sizes;
    }()
  }, {
    key: 'base64toFile',
    value: function base64toFile(url, filename, mimeType) {
      mimeType = mimeType || (url.match(/^data:([^;]+);/) || '')[1];
      return fetch(url).then(function (res) {
        return res.arrayBuffer();
      }).then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
    }

    // download_xls(project_id) {
    //   return new Promise((resolve, reject) => {
    //     this.http.get('/leads/download_xls', { params: { project_id: project_id } }).then(response => {
    //       resolve(response.data)
    //     }).catch(e => {
    //       this.handleError(e)
    //       reject(e)
    //     })
    //   });
    // }

  }, {
    key: 'download_pdf',
    value: function download_pdf(lead_id) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.http.get('/leads/' + lead_id + '/download_pdf').then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this3.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return Lead;
}(__WEBPACK_IMPORTED_MODULE_8__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Lead);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Api__ = __webpack_require__(15);








var LeadMask = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(LeadMask, _Api);

  function LeadMask() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, LeadMask);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LeadMask.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(LeadMask)).call(this, version));

    _this.path = 'lead_masks';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(LeadMask, [{
    key: 'duplicate',
    value: function duplicate(lead_mask_id) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.put(_this2.path + '/' + lead_mask_id + '/clone').then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return LeadMask;
}(__WEBPACK_IMPORTED_MODULE_6__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LeadMask);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DashboardWidget__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DashboardWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DashboardWidget__);







var DEFAULT_PERIOD = 7; // 7 Days
var WIDGET_TIMEOUT = 1000 * 20; // 20 seconds

// @vue/component
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashboardWidget: __WEBPACK_IMPORTED_MODULE_4__DashboardWidget___default.a
  },

  props: {
    filter: {
      type: Object,
      default: function _default() {
        return {
          organizationId: null,
          projectId: null,
          period: null
        };
      }
    }
  },

  data: function data() {
    return {
      error: undefined,
      eventBus: __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */],
      isError: false,
      isLoading: true,
      period: DEFAULT_PERIOD,
      project: 'all',
      timeoutFn: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.eventBus.$on('widget-loaded', function (identifier) {
      // We timeout every request that takes longer than defined in "WIDGET_TIMEOUT".
      // We cancel this timeout if the widget is loaded before the amount of "WIDGET_TIMEOUT" has been reached
      if (__WEBPACK_IMPORTED_MODULE_2_lodash_eq___default()(identifier, _this.identifier)) {
        clearTimeout(_this.timeoutFn);
      }
    });
  },


  watch: {
    isError: function isError() {
      // Always timeout on error case
      if (this.isError) {
        this.timeout();
      }
    },
    isLoading: function isLoading() {
      if (this.isLoading) {
        // Reset error state and hope this time it works
        this.setIsError(false);
        this.setError(undefined);

        // Start the timeout countdown
        this.timeoutFn = setTimeout(this.timeout, WIDGET_TIMEOUT);
      }
    },
    filter: function filter() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.refresh();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },

  methods: {
    refresh: function refresh() {
      // Should be overriden in the parent widget components

      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    setError: function setError(error) {
      this.error = error;
    },
    setIsError: function setIsError(isError) {
      this.isError = isError;
    },
    setIsLoading: function setIsLoading(isLoading) {
      this.isLoading = isLoading;
    },


    // Handle timed out requests
    timeout: function timeout() {
      this.setIsLoading(false);

      this.eventBus.$emit('widget-loaded', this.identifier);
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_lt__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_lt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_lt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_gt__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_gt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_gt__);
// This mixin is used to build queries to be sent to GraphQL resolver






/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // TODO: Now seeing the actual usage and essential difference of the queries
    //       I would rather reduce this method a go with raw declaration of the query
    //       in each place where it is used. I think it would be more obvious.
    getQuery: function getQuery(tuples, resolver, schema) {
      var resolverParams = tuples.map(function (_ref) {
        var key = _ref.key,
            value = _ref.value;
        return key + ': ' + value;
      }).join(', ');
      var resolverWithParams = resolver + '(' + resolverParams + ')';

      var query = resolverWithParams;

      if (schema) {
        query = '\n          ' + resolverWithParams + ' {\n            ' + schema + '\n          }\n        ';
      }

      return query;
    }
  }
});

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1364)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(1953),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(15);






var Tracking = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Tracking, _Api);

  function Tracking() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Tracking);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tracking.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Tracking)).call(this, version));

    _this.path = 'trackings';
    return _this;
  }

  return Tracking;
}(__WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Tracking);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
// This mixin is used everywhere where a widget requires time relative querying



var DEFAULT_FORMAT = 'YYYY-MM-DD 00:00 Z';

// @vue/component
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Returns today minus period days in a form of "YYYY-MM-DD"
    from: function from(period) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(period, 'days').format(DEFAULT_FORMAT);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var en = [{ name: "English", value: "en", text: "English" }, { name: "German", value: "de", text: "German" }];

var de = [{ name: "Englisch", value: "en", text: "Englisch" }, { name: "Deutsch", value: "de", text: "Deutsch" }];
var output = { de: de, en: en };

/* harmony default export */ __webpack_exports__["a"] = (output);

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(749),
  /* template */
  __webpack_require__(1837),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(753),
  /* template */
  __webpack_require__(1793),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1381)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(754),
  /* template */
  __webpack_require__(1975),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1356)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(758),
  /* template */
  __webpack_require__(1946),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1262)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1835),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fd3b2be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1287)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(802),
  /* template */
  __webpack_require__(1865),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */,
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The list of all countries with their 2 digit values (ISO 3166-2)
 *
 * @see http://data.okfn.org/data/core/country-list
 */

var en = [{
  "name": "Afghanistan",
  "value": "AF"
}, {
  "name": "Åland Islands",
  "value": "AX"
}, {
  "name": "Albania",
  "value": "AL"
}, {
  "name": "Algeria",
  "value": "DZ"
}, {
  "name": "American Samoa",
  "value": "AS"
}, {
  "name": "Andorra",
  "value": "AD"
}, {
  "name": "Angola",
  "value": "AO"
}, {
  "name": "Anguilla",
  "value": "AI"
}, {
  "name": "Antarctica",
  "value": "AQ"
}, {
  "name": "Antigua and Barbuda",
  "value": "AG"
}, {
  "name": "Argentina",
  "value": "AR"
}, {
  "name": "Armenia",
  "value": "AM"
}, {
  "name": "Aruba",
  "value": "AW"
}, {
  "name": "Australia",
  "value": "AU"
}, {
  "name": "Austria",
  "value": "AT"
}, {
  "name": "Azerbaijan",
  "value": "AZ"
}, {
  "name": "Bahamas",
  "value": "BS"
}, {
  "name": "Bahrain",
  "value": "BH"
}, {
  "name": "Bangladesh",
  "value": "BD"
}, {
  "name": "Barbados",
  "value": "BB"
}, {
  "name": "Belarus",
  "value": "BY"
}, {
  "name": "Belgium",
  "value": "BE"
}, {
  "name": "Belize",
  "value": "BZ"
}, {
  "name": "Benin",
  "value": "BJ"
}, {
  "name": "Bermuda",
  "value": "BM"
}, {
  "name": "Bhutan",
  "value": "BT"
}, {
  "name": "Bolivia, Plurinational State of",
  "value": "BO"
}, {
  "name": "Bonaire, Sint Eustatius and Saba",
  "value": "BQ"
}, {
  "name": "Bosnia and Herzegovina",
  "value": "BA"
}, {
  "name": "Botswana",
  "value": "BW"
}, {
  "name": "Bouvet Island",
  "value": "BV"
}, {
  "name": "Brazil",
  "value": "BR"
}, {
  "name": "British Indian Ocean Territory",
  "value": "IO"
}, {
  "name": "Brunei Darussalam",
  "value": "BN"
}, {
  "name": "Bulgaria",
  "value": "BG"
}, {
  "name": "Burkina Faso",
  "value": "BF"
}, {
  "name": "Burundi",
  "value": "BI"
}, {
  "name": "Cambodia",
  "value": "KH"
}, {
  "name": "Cameroon",
  "value": "CM"
}, {
  "name": "Canada",
  "value": "CA"
}, {
  "name": "Cape Verde",
  "value": "CV"
}, {
  "name": "Cayman Islands",
  "value": "KY"
}, {
  "name": "Central African Republic",
  "value": "CF"
}, {
  "name": "Chad",
  "value": "TD"
}, {
  "name": "Chile",
  "value": "CL"
}, {
  "name": "China",
  "value": "CN"
}, {
  "name": "Christmas Island",
  "value": "CX"
}, {
  "name": "Cocos (Keeling) Islands",
  "value": "CC"
}, {
  "name": "Colombia",
  "value": "CO"
}, {
  "name": "Comoros",
  "value": "KM"
}, {
  "name": "Congo",
  "value": "CG"
}, {
  "name": "Congo, the Democratic Republic of the",
  "value": "CD"
}, {
  "name": "Cook Islands",
  "value": "CK"
}, {
  "name": "Costa Rica",
  "value": "CR"
}, {
  "name": "Côte d'Ivoire",
  "value": "CI"
}, {
  "name": "Croatia",
  "value": "HR"
}, {
  "name": "Cuba",
  "value": "CU"
}, {
  "name": "Curaçao",
  "value": "CW"
}, {
  "name": "Cyprus",
  "value": "CY"
}, {
  "name": "Czech Republic",
  "value": "CZ"
}, {
  "name": "Denmark",
  "value": "DK"
}, {
  "name": "Djibouti",
  "value": "DJ"
}, {
  "name": "Dominica",
  "value": "DM"
}, {
  "name": "Dominican Republic",
  "value": "DO"
}, {
  "name": "Ecuador",
  "value": "EC"
}, {
  "name": "Egypt",
  "value": "EG"
}, {
  "name": "El Salvador",
  "value": "SV"
}, {
  "name": "Equatorial Guinea",
  "value": "GQ"
}, {
  "name": "Eritrea",
  "value": "ER"
}, {
  "name": "Estonia",
  "value": "EE"
}, {
  "name": "Ethiopia",
  "value": "ET"
}, {
  "name": "Falkland Islands (Malvinas)",
  "value": "FK"
}, {
  "name": "Faroe Islands",
  "value": "FO"
}, {
  "name": "Fiji",
  "value": "FJ"
}, {
  "name": "Finland",
  "value": "FI"
}, {
  "name": "France",
  "value": "FR"
}, {
  "name": "French Guiana",
  "value": "GF"
}, {
  "name": "French Polynesia",
  "value": "PF"
}, {
  "name": "French Southern Territories",
  "value": "TF"
}, {
  "name": "Gabon",
  "value": "GA"
}, {
  "name": "Gambia",
  "value": "GM"
}, {
  "name": "Georgia",
  "value": "GE"
}, {
  "name": "Germany",
  "value": "DE"
}, {
  "name": "Ghana",
  "value": "GH"
}, {
  "name": "Gibraltar",
  "value": "GI"
}, {
  "name": "Greece",
  "value": "GR"
}, {
  "name": "Greenland",
  "value": "GL"
}, {
  "name": "Grenada",
  "value": "GD"
}, {
  "name": "Guadeloupe",
  "value": "GP"
}, {
  "name": "Guam",
  "value": "GU"
}, {
  "name": "Guatemala",
  "value": "GT"
}, {
  "name": "Guernsey",
  "value": "GG"
}, {
  "name": "Guinea",
  "value": "GN"
}, {
  "name": "Guinea-Bissau",
  "value": "GW"
}, {
  "name": "Guyana",
  "value": "GY"
}, {
  "name": "Haiti",
  "value": "HT"
}, {
  "name": "Heard Island and McDonald Islands",
  "value": "HM"
}, {
  "name": "Holy See (Vatican City State)",
  "value": "VA"
}, {
  "name": "Honduras",
  "value": "HN"
}, {
  "name": "Hong Kong",
  "value": "HK"
}, {
  "name": "Hungary",
  "value": "HU"
}, {
  "name": "Iceland",
  "value": "IS"
}, {
  "name": "India",
  "value": "IN"
}, {
  "name": "Indonesia",
  "value": "ID"
}, {
  "name": "Iran, Islamic Republic of",
  "value": "IR"
}, {
  "name": "Iraq",
  "value": "IQ"
}, {
  "name": "Ireland",
  "value": "IE"
}, {
  "name": "Isle of Man",
  "value": "IM"
}, {
  "name": "Israel",
  "value": "IL"
}, {
  "name": "Italy",
  "value": "IT"
}, {
  "name": "Jamaica",
  "value": "JM"
}, {
  "name": "Japan",
  "value": "JP"
}, {
  "name": "Jersey",
  "value": "JE"
}, {
  "name": "Jordan",
  "value": "JO"
}, {
  "name": "Kazakhstan",
  "value": "KZ"
}, {
  "name": "Kenya",
  "value": "KE"
}, {
  "name": "Kiribati",
  "value": "KI"
}, {
  "name": "Korea, Democratic People's Republic of",
  "value": "KP"
}, {
  "name": "Korea, Republic of",
  "value": "KR"
}, {
  "name": "Kuwait",
  "value": "KW"
}, {
  "name": "Kyrgyzstan",
  "value": "KG"
}, {
  "name": "Lao People's Democratic Republic",
  "value": "LA"
}, {
  "name": "Latvia",
  "value": "LV"
}, {
  "name": "Lebanon",
  "value": "LB"
}, {
  "name": "Lesotho",
  "value": "LS"
}, {
  "name": "Liberia",
  "value": "LR"
}, {
  "name": "Libya",
  "value": "LY"
}, {
  "name": "Liechtenstein",
  "value": "LI"
}, {
  "name": "Lithuania",
  "value": "LT"
}, {
  "name": "Luxembourg",
  "value": "LU"
}, {
  "name": "Macao",
  "value": "MO"
}, {
  "name": "Macedonia, the Former Yugoslav Republic of",
  "value": "MK"
}, {
  "name": "Madagascar",
  "value": "MG"
}, {
  "name": "Malawi",
  "value": "MW"
}, {
  "name": "Malaysia",
  "value": "MY"
}, {
  "name": "Maldives",
  "value": "MV"
}, {
  "name": "Mali",
  "value": "ML"
}, {
  "name": "Malta",
  "value": "MT"
}, {
  "name": "Marshall Islands",
  "value": "MH"
}, {
  "name": "Martinique",
  "value": "MQ"
}, {
  "name": "Mauritania",
  "value": "MR"
}, {
  "name": "Mauritius",
  "value": "MU"
}, {
  "name": "Mayotte",
  "value": "YT"
}, {
  "name": "Mexico",
  "value": "MX"
}, {
  "name": "Micronesia, Federated States of",
  "value": "FM"
}, {
  "name": "Moldova, Republic of",
  "value": "MD"
}, {
  "name": "Monaco",
  "value": "MC"
}, {
  "name": "Mongolia",
  "value": "MN"
}, {
  "name": "Montenegro",
  "value": "ME"
}, {
  "name": "Montserrat",
  "value": "MS"
}, {
  "name": "Morocco",
  "value": "MA"
}, {
  "name": "Mozambique",
  "value": "MZ"
}, {
  "name": "Myanmar",
  "value": "MM"
}, {
  "name": "Namibia",
  "value": "NA"
}, {
  "name": "Nauru",
  "value": "NR"
}, {
  "name": "Nepal",
  "value": "NP"
}, {
  "name": "Netherlands",
  "value": "NL"
}, {
  "name": "New Caledonia",
  "value": "NC"
}, {
  "name": "New Zealand",
  "value": "NZ"
}, {
  "name": "Nicaragua",
  "value": "NI"
}, {
  "name": "Niger",
  "value": "NE"
}, {
  "name": "Nigeria",
  "value": "NG"
}, {
  "name": "Niue",
  "value": "NU"
}, {
  "name": "Norfolk Island",
  "value": "NF"
}, {
  "name": "Northern Mariana Islands",
  "value": "MP"
}, {
  "name": "Norway",
  "value": "NO"
}, {
  "name": "Oman",
  "value": "OM"
}, {
  "name": "Pakistan",
  "value": "PK"
}, {
  "name": "Palau",
  "value": "PW"
}, {
  "name": "Palestine, State of",
  "value": "PS"
}, {
  "name": "Panama",
  "value": "PA"
}, {
  "name": "Papua New Guinea",
  "value": "PG"
}, {
  "name": "Paraguay",
  "value": "PY"
}, {
  "name": "Peru",
  "value": "PE"
}, {
  "name": "Philippines",
  "value": "PH"
}, {
  "name": "Pitcairn",
  "value": "PN"
}, {
  "name": "Poland",
  "value": "PL"
}, {
  "name": "Portugal",
  "value": "PT"
}, {
  "name": "Puerto Rico",
  "value": "PR"
}, {
  "name": "Qatar",
  "value": "QA"
}, {
  "name": "Réunion",
  "value": "RE"
}, {
  "name": "Romania",
  "value": "RO"
}, {
  "name": "Russian Federation",
  "value": "RU"
}, {
  "name": "Rwanda",
  "value": "RW"
}, {
  "name": "Saint Barthélemy",
  "value": "BL"
}, {
  "name": "Saint Helena, Ascension and Tristan da Cunha",
  "value": "SH"
}, {
  "name": "Saint Kitts and Nevis",
  "value": "KN"
}, {
  "name": "Saint Lucia",
  "value": "LC"
}, {
  "name": "Saint Martin (French part)",
  "value": "MF"
}, {
  "name": "Saint Pierre and Miquelon",
  "value": "PM"
}, {
  "name": "Saint Vincent and the Grenadines",
  "value": "VC"
}, {
  "name": "Samoa",
  "value": "WS"
}, {
  "name": "San Marino",
  "value": "SM"
}, {
  "name": "Sao Tome and Principe",
  "value": "ST"
}, {
  "name": "Saudi Arabia",
  "value": "SA"
}, {
  "name": "Senegal",
  "value": "SN"
}, {
  "name": "Serbia",
  "value": "RS"
}, {
  "name": "Seychelles",
  "value": "SC"
}, {
  "name": "Sierra Leone",
  "value": "SL"
}, {
  "name": "Singapore",
  "value": "SG"
}, {
  "name": "Sint Maarten (Dutch part)",
  "value": "SX"
}, {
  "name": "Slovakia",
  "value": "SK"
}, {
  "name": "Slovenia",
  "value": "SI"
}, {
  "name": "Solomon Islands",
  "value": "SB"
}, {
  "name": "Somalia",
  "value": "SO"
}, {
  "name": "South Africa",
  "value": "ZA"
}, {
  "name": "South Georgia and the South Sandwich Islands",
  "value": "GS"
}, {
  "name": "South Sudan",
  "value": "SS"
}, {
  "name": "Spain",
  "value": "ES"
}, {
  "name": "Sri Lanka",
  "value": "LK"
}, {
  "name": "Sudan",
  "value": "SD"
}, {
  "name": "Suriname",
  "value": "SR"
}, {
  "name": "Svalbard and Jan Mayen",
  "value": "SJ"
}, {
  "name": "Swaziland",
  "value": "SZ"
}, {
  "name": "Sweden",
  "value": "SE"
}, {
  "name": "Switzerland",
  "value": "CH"
}, {
  "name": "Syrian Arab Republic",
  "value": "SY"
}, {
  "name": "Taiwan, Province of China",
  "value": "TW"
}, {
  "name": "Tajikistan",
  "value": "TJ"
}, {
  "name": "Tanzania, United Republic of",
  "value": "TZ"
}, {
  "name": "Thailand",
  "value": "TH"
}, {
  "name": "Timor-Leste",
  "value": "TL"
}, {
  "name": "Togo",
  "value": "TG"
}, {
  "name": "Tokelau",
  "value": "TK"
}, {
  "name": "Tonga",
  "value": "TO"
}, {
  "name": "Trinidad and Tobago",
  "value": "TT"
}, {
  "name": "Tunisia",
  "value": "TN"
}, {
  "name": "Turkey",
  "value": "TR"
}, {
  "name": "Turkmenistan",
  "value": "TM"
}, {
  "name": "Turks and Caicos Islands",
  "value": "TC"
}, {
  "name": "Tuvalu",
  "value": "TV"
}, {
  "name": "Uganda",
  "value": "UG"
}, {
  "name": "Ukraine",
  "value": "UA"
}, {
  "name": "United Arab Emirates",
  "value": "AE"
}, {
  "name": "United Kingdom",
  "value": "GB"
}, {
  "name": "United States",
  "value": "US"
}, {
  "name": "United States Minor Outlying Islands",
  "value": "UM"
}, {
  "name": "Uruguay",
  "value": "UY"
}, {
  "name": "Uzbekistan",
  "value": "UZ"
}, {
  "name": "Vanuatu",
  "value": "VU"
}, {
  "name": "Venezuela, Bolivarian Republic of",
  "value": "VE"
}, {
  "name": "Viet Nam",
  "value": "VN"
}, {
  "name": "Virgin Islands, British",
  "value": "VG"
}, {
  "name": "Virgin Islands, U.S.",
  "value": "VI"
}, {
  "name": "Wallis and Futuna",
  "value": "WF"
}, {
  "name": "Western Sahara",
  "value": "EH"
}, {
  "name": "Yemen",
  "value": "YE"
}, {
  "name": "Zambia",
  "value": "ZM"
}, {
  "name": "Zimbabwe",
  "value": "ZW"
}];

var de = [{
  "name": "Afghanistan",
  "value": "AF"
}, {
  "name": "Åland-Inseln",
  "value": "AX"
}, {
  "name": "Albanien",
  "value": "AL"
}, {
  "name": "Algerien",
  "value": "DZ"
}, {
  "name": "Amerikanisch-Samoa",
  "value": "AS"
}, {
  "name": "Andorra",
  "value": "AD"
}, {
  "name": "Angola",
  "value": "AO"
}, {
  "name": "Anguilla",
  "value": "AI"
}, {
  "name": "Antarktis",
  "value": "AQ"
}, {
  "name": "Antigua und Barbuda",
  "value": "AG"
}, {
  "name": "Argentinien",
  "value": "AR"
}, {
  "name": "Armenien",
  "value": "AM"
}, {
  "name": "Aruba",
  "value": "AW"
}, {
  "name": "Australien",
  "value": "AU"
}, {
  "name": "Österreich",
  "value": "AT"
}, {
  "name": "Aserbaidschan",
  "value": "AZ"
}, {
  "name": "Bahamas",
  "value": "BS"
}, {
  "name": "Bahrain",
  "value": "BH"
}, {
  "name": "Bangladesch",
  "value": "BD"
}, {
  "name": "Barbados",
  "value": "BB"
}, {
  "name": "Belarus",
  "value": "BY"
}, {
  "name": "Belgien",
  "value": "BE"
}, {
  "name": "Belize",
  "value": "BZ"
}, {
  "name": "Benin",
  "value": "BJ"
}, {
  "name": "Bermuda",
  "value": "BM"
}, {
  "name": "Bhutan",
  "value": "BT"
}, {
  "name": "Bolivien, plurinationaler Staat",
  "value": "BO"
}, {
  "name": "Bonaire, Sint Eustatius und Saba",
  "value": "BQ"
}, {
  "name": "Bosnien und Herzegowina",
  "value": "BA"
}, {
  "name": "Botswana",
  "value": "BW"
}, {
  "name": "Bouvetinsel",
  "value": "BV"
}, {
  "name": "Brasilien",
  "value": "BR"
}, {
  "name": "Britisches Territorium im Indischen Ozean",
  "value": "IO"
}, {
  "name": "Brunei Darussalam",
  "value": "BN"
}, {
  "name": "Bulgarien",
  "value": "BG"
}, {
  "name": "Burkina Faso",
  "value": "BF"
}, {
  "name": "Burundi",
  "value": "BI"
}, {
  "name": "Kambodscha",
  "value": "KH"
}, {
  "name": "Kamerun",
  "value": "CM"
}, {
  "name": "Kanada",
  "value": "CA"
}, {
  "name": "Kap Verde",
  "value": "Lebenslauf"
}, {
  "name": "Kaimaninseln",
  "value": "KY"
}, {
  "name": "Zentralafrikanische Republik",
  "value": "CF"
}, {
  "name": "Tschad",
  "value": "TD"
}, {
  "name": "Chile",
  "value": "CL"
}, {
  "name": "China",
  "value": "CN"
}, {
  "name": "Weihnachtsinsel",
  "value": "CX"
}, {
  "name": "Cocos (Keeling) Inseln",
  "value": "CC"
}, {
  "name": "Kolumbien",
  "value": "CO"
}, {
  "name": "Komoren",
  "value": "KM"
}, {
  "name": "Kongo",
  "value": "CG"
}, {
  "name": "Kongo, die Demokratische Republik",
  "value": "CD"
}, {
  "name": "Cookinseln",
  "value": "CK"
}, {
  "name": "Costa Rica",
  "value": "CR"
}, {
  "name": "Côte d'Ivoire",
  "value": "CI"
}, {
  "name": "Kroatien",
  "value": "HR"
}, {
  "name": "Kuba",
  "value": "CU"
}, {
  "name": "Curaçao",
  "value": "CW"
}, {
  "name": "Zypern",
  "value": "CY"
}, {
  "name": "Tschechische Republik",
  "value": "CZ"
}, {
  "name": "Dänemark",
  "value": "DK"
}, {
  "name": "Dschibuti",
  "value": "DJ"
}, {
  "name": "Dominica",
  "value": "DM"
}, {
  "name": "Dominikanische Republik",
  "value": "TUN"
}, {
  "name": "Ecuador",
  "value": "EC"
}, {
  "name": "Ägypten",
  "value": "EG"
}, {
  "name": "El Salvador",
  "value": "SV"
}, {
  "name": "Äquatorialguinea",
  "value": "GQ"
}, {
  "name": "Eritrea",
  "value": "ER"
}, {
  "name": "Estland",
  "value": "EE"
}, {
  "name": "Äthiopien",
  "value": "ET"
}, {
  "name": "Falklandinseln (Malvinas)",
  "value": "FK"
}, {
  "name": "Färöer Inseln",
  "value": "FO"
}, {
  "name": "Fidschi",
  "value": "FJ"
}, {
  "name": "Finnland",
  "value": "FI"
}, {
  "name": "Frankreich",
  "value": "FR"
}, {
  "name": "Französisch-Guayana",
  "value": "GF"
}, {
  "name": "Französisch-Polynesien",
  "value": "PF"
}, {
  "name": "Französische Südgebiete",
  "value": "TF"
}, {
  "name": "Gabun",
  "value": "GA"
}, {
  "name": "Gambia",
  "value": "GM"
}, {
  "name": "Georgien",
  "value": "GE"
}, {
  "name": "Deutschland",
  "value": "DE"
}, {
  "name": "Ghana",
  "value": "GH"
}, {
  "name": "Gibraltar",
  "value": "GI"
}, {
  "name": "Griechenland",
  "value": "GR"
}, {
  "name": "Grönland",
  "value": "GL"
}, {
  "name": "Grenada",
  "value": "GD"
}, {
  "name": "Guadeloupe",
  "value": "GP"
}, {
  "name": "Guam",
  "value": "GU"
}, {
  "name": "Guatemala",
  "value": "GT"
}, {
  "name": "Guernsey",
  "value": "GG"
}, {
  "name": "Guinea",
  "value": "GN"
}, {
  "name": "Guinea-Bissau",
  "value": "GW"
}, {
  "name": "Guyana",
  "value": "GY"
}, {
  "name": "Haiti",
  "value": "HT"
}, {
  "name": "Heard Island und McDonald Islands",
  "value": "HM"
}, {
  "name": "Heiliger Stuhl (Vatikanstadt)",
  "value": "VA"
}, {
  "name": "Honduras",
  "value": "HN"
}, {
  "name": "Hongkong",
  "value": "HK"
}, {
  "name": "Ungarn",
  "value": "HU"
}, {
  "name": "Island",
  "value": "IS"
}, {
  "name": "Indien",
  "value": "IN"
}, {
  "name": "Indonesien",
  "value": "ID"
}, {
  "name": "Iran, Islamische Republik",
  "value": "IR"
}, {
  "name": "Irak",
  "value": "IQ"
}, {
  "name": "Irland",
  "value": "IE"
}, {
  "name": "Isle of Man",
  "value": "IM"
}, {
  "name": "Israel",
  "value": "IL"
}, {
  "name": "Italien",
  "value": "IT"
}, {
  "name": "Jamaika",
  "value": "JM"
}, {
  "name": "Japan",
  "value": "JP"
}, {
  "name": "Jersey",
  "value": "JE"
}, {
  "name": "Jordanien",
  "value": "JO"
}, {
  "name": "Kasachstan",
  "value": "KZ"
}, {
  "name": "Kenia",
  "value": "KE"
}, {
  "name": "Kiribati",
  "value": "KI"
}, {
  "name": "Korea, Demokratische Volksrepublik",
  "value": "KP"
}, {
  "name": "Korea, Republik",
  "value": "KR"
}, {
  "name": "Kuwait",
  "value": "KW"
}, {
  "name": "Kirgisistan",
  "value": "KG"
}, {
  "name": "Demokratische Volksrepublik Laos",
  "value": "LA"
}, {
  "name": "Lettland",
  "value": "LV"
}, {
  "name": "Libanon",
  "value": "LB"
}, {
  "name": "Lesotho",
  "value": "LS"
}, {
  "name": "Liberia",
  "value": "LR"
}, {
  "name": "Libyen",
  "value": "LY"
}, {
  "name": "Liechtenstein",
  "value": "LI"
}, {
  "name": "Litauen",
  "value": "LT"
}, {
  "name": "Luxemburg",
  "value": "LU"
}, {
  "name": "Macao",
  "value": "MO"
}, {
  "name": "Mazedonien, die ehemalige jugoslawische Republik",
  "value": "MK"
}, {
  "name": "Madagaskar",
  "value": "MG"
}, {
  "name": "Malawi",
  "value": "MW"
}, {
  "name": "Malaysia",
  "value": "MY"
}, {
  "name": "Malediven",
  "value": "MV"
}, {
  "name": "Mali",
  "value": "ML"
}, {
  "name": "Malta",
  "value": "MT"
}, {
  "name": "Marshallinseln",
  "value": "MH"
}, {
  "name": "Martinique",
  "value": "MQ"
}, {
  "name": "Mauretanien",
  "value": "MR"
}, {
  "name": "Mauritius",
  "value": "MU"
}, {
  "name": "Mayotte",
  "value": "YT"
}, {
  "name": "Mexiko",
  "value": "MX"
}, {
  "name": "Mikronesien, Föderierte Staaten von",
  "value": "FM"
}, {
  "name": "Republik Moldau",
  "value": "MD"
}, {
  "name": "Monaco",
  "value": "MC"
}, {
  "name": "Mongolei",
  "value": "MN"
}, {
  "name": "Montenegro",
  "value": "ICH"
}, {
  "name": "Montserrat",
  "value": "MS"
}, {
  "name": "Marokko",
  "value": "MA"
}, {
  "name": "Mosambik",
  "value": "MZ"
}, {
  "name": "Myanmar",
  "value": "MM"
}, {
  "name": "Namibia",
  "value": "NA"
}, {
  "name": "Nauru",
  "value": "NR"
}, {
  "name": "Nepal",
  "value": "NP"
}, {
  "name": "Niederlande",
  "value": "NL"
}, {
  "name": "Neukaledonien",
  "value": "NC"
}, {
  "name": "Neuseeland",
  "value": "NZ"
}, {
  "name": "Nicaragua",
  "value": "NI"
}, {
  "name": "Niger",
  "value": "NE"
}, {
  "name": "Nigeria",
  "value": "NG"
}, {
  "name": "Niue",
  "value": "NU"
}, {
  "name": "Norfolkinsel",
  "value": "NF"
}, {
  "name": "Nördliche Marianen",
  "value": "MP"
}, {
  "name": "Norwegen",
  "value": "NEIN"
}, {
  "name": "Oman",
  "value": "OM"
}, {
  "name": "Pakistan",
  "value": "PK"
}, {
  "name": "Palau",
  "value": "PW"
}, {
  "name": "Palästina, Staat",
  "value": "PS"
}, {
  "name": "Panama",
  "value": "PA"
}, {
  "name": "Papua-Neuguinea",
  "value": "PG"
}, {
  "name": "Paraguay",
  "value": "PY"
}, {
  "name": "Peru",
  "value": "PE"
}, {
  "name": "Philippinen",
  "value": "PH"
}, {
  "name": "Pitcairn",
  "value": "PN"
}, {
  "name": "Polen",
  "value": "PL"
}, {
  "name": "Portugal",
  "value": "PT"
}, {
  "name": "Puerto Rico",
  "value": "PR"
}, {
  "name": "Katar",
  "value": "QA"
}, {
  "name": "Réunion",
  "value": "RE"
}, {
  "name": "Rumänien",
  "value": "RO"
}, {
  "name": "Russische Föderation",
  "value": "RU"
}, {
  "name": "Ruanda",
  "value": "RW"
}, {
  "name": "Saint Barthélemy",
  "value": "BL"
}, {
  "name": "St. Helena, Ascension und Tristan da Cunha",
  "value": "SH"
}, {
  "name": "St. Kitts und Nevis",
  "value": "KN"
}, {
  "name": "St. Lucia",
  "value": "LC"
}, {
  "name": "Saint Martin (französischer Teil)",
  "value": "MF"
}, {
  "name": "Saint Pierre und Miquelon",
  "value": "PM"
}, {
  "name": "St. Vincent und die Grenadinen",
  "value": "VC"
}, {
  "name": "Samoa",
  "value": "WS"
}, {
  "name": "San Marino",
  "value": "SM"
}, {
  "name": "Sao Tome und Principe",
  "value": "ST"
}, {
  "name": "Saudi-Arabien",
  "value": "SA"
}, {
  "name": "Senegal",
  "value": "SN"
}, {
  "name": "Serbien",
  "value": "RS"
}, {
  "name": "Seychellen",
  "value": "SC"
}, {
  "name": "Sierra Leone",
  "value": "SL"
}, {
  "name": "Singapur",
  "value": "SG"
}, {
  "name": "Sint Maarten (niederländischer Teil)",
  "value": "SX"
}, {
  "name": "Slowakei",
  "value": "SK"
}, {
  "name": "Slowenien",
  "value": "SI"
}, {
  "name": "Salomonen",
  "value": "SB"
}, {
  "name": "Somalia",
  "value": "SO"
}, {
  "name": "Südafrika",
  "value": "ZA"
}, {
  "name": "Südgeorgien und die Südlichen Sandwichinseln",
  "value": "GS"
}, {
  "name": "Südsudan",
  "value": "SS"
}, {
  "name": "Spanien",
  "value": "ES"
}, {
  "name": "Sri Lanka",
  "value": "LK"
}, {
  "name": "Sudan",
  "value": "SD"
}, {
  "name": "Suriname",
  "value": "SR"
}, {
  "name": "Svalbard und Jan Mayen",
  "value": "SJ"
}, {
  "name": "Swasiland",
  "value": "SZ"
}, {
  "name": "Schweden",
  "value": "SE"
}, {
  "name": "Schweiz",
  "value": "CH"
}, {
  "name": "Arabische Republik Syrien",
  "value": "SY"
}, {
  "name": "Taiwan, Provinz China",
  "value": "TW"
}, {
  "name": "Tadschikistan",
  "value": "TJ"
}, {
  "name": "Tansania, Vereinigte Republik",
  "value": "TZ"
}, {
  "name": "Thailand",
  "value": "TH"
}, {
  "name": "Timor-Leste",
  "value": "TL"
}, {
  "name": "Togo",
  "value": "TG"
}, {
  "name": "Tokelau",
  "value": "TK"
}, {
  "name": "Tonga",
  "value": "TO"
}, {
  "name": "Trinidad und Tobago",
  "value": "TT"
}, {
  "name": "Tunesien",
  "value": "TN"
}, {
  "name": "Türkei",
  "value": "TR"
}, {
  "name": "Turkmenistan",
  "value": "TM"
}, {
  "name": "Turks- und Caicosinseln",
  "value": "TC"
}, {
  "name": "Tuvalu",
  "value": "TV"
}, {
  "name": "Uganda",
  "value": "UG"
}, {
  "name": "Ukraine",
  "value": "UA"
}, {
  "name": "Vereinigte Arabische Emirate",
  "value": "AE"
}, {
  "name": "Vereinigtes Königreich",
  "value": "GB"
}, {
  "name": "Vereinigte Staaten",
  "value": "US"
}, {
  "name": "Minor Outlying Islands der Vereinigten Staaten",
  "value": "UM"
}, {
  "name": "Uruguay",
  "value": "UY"
}, {
  "name": "Usbekistan",
  "value": "UZ"
}, {
  "name": "Vanuatu",
  "value": "VU"
}, {
  "name": "Venezuela, Bolivarische Republik",
  "value": "VE"
}, {
  "name": "Vietnam",
  "value": "VN"
}, {
  "name": "Britische Jungferninseln",
  "value": "VG"
}, {
  "name": "Amerikanische Jungferninseln",
  "value": "VI"
}, {
  "name": "Wallis und Futuna",
  "value": "WF"
}, {
  "name": "Westsahara",
  "value": "EH"
}, {
  "name": "Jemen",
  "value": "JA"
}, {
  "name": "Sambia",
  "value": "ZM"
}, {
  "name": "Simbabwe",
  "value": "ZW"
}];

var output = { de: de, en: en };

/* harmony default export */ __webpack_exports__["a"] = (output);

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-default.268a779.svg";

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(1936),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1271)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(781),
  /* template */
  __webpack_require__(1845),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27a5ea0f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1380)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(814),
  /* template */
  __webpack_require__(1974),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af7186a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_config__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(64);








var Auth = function () {
  function Auth() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Auth);

    this.http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
      baseURL: __WEBPACK_IMPORTED_MODULE_5__config_config__["a" /* apiUrl */] + version + '/',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Auth, [{
    key: 'requestResetPassword',
    value: function requestResetPassword(email) {
      var _this = this;

      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.http.post('/users/request_password_reset', { email: email, locale: locale }).then(function (response) {
          resolve(response);
        }).catch(function (e) {
          _this.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'resetPassword',
    value: function resetPassword(token, password, password_confirmation) {
      var _this2 = this;

      var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'de';

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.post('/users/reset_password', { token: token, password: password, password_confirmation: password_confirmation, locale: locale }).then(function (response) {
          resolve(response);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'confirmAccount',
    value: function confirmAccount(token, password, password_confirmation, firstname, lastname) {
      var _this3 = this;

      var locale = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'de';

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.http.post('/users/accept_invitation', { token: token, password: password, password_confirmation: password_confirmation, firstname: firstname, lastname: lastname, locale: locale }).then(function (response) {
          resolve(response);
        }).catch(function (e) {
          _this3.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'auth',
    value: function auth(email, password, firstname, lastname) {
      var _this4 = this;

      if (!this.validateEmail(email)) {
        var message = __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('errors.authentication.wrong_email');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('addAxiosError', message);
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          reject({ response: { data: { errors: [{ code: 'authentication.wrong_email' }] } } });
        });
      } else if (!this.validatePassword(password)) {
        var _message = __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('errors.authentication.wrong_password');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('addAxiosError', _message);
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          reject({ response: { data: { errors: [{ code: 'authentication.wrong_password' }] } } });
        });
      } else {
        // If basic validations passed, we send the request
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          _this4.http.post('auth', { email: email, password: password, firstname: firstname, lastname: lastname }).then(function (response) {
            resolve(response);
          }).catch(function (e) {
            _this4.handleError(e);
            reject(e);
          });
        });
      }
    }

    // basic format validation

  }, {
    key: 'validateEmail',
    value: function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    // 1 letter, 1 number & 6 characters

  }, {
    key: 'validatePassword',
    value: function validatePassword(password) {
      return password.length > 0;
    }

    // sha256 ? md5 ?

  }, {
    key: 'passwordEncryption',
    value: function passwordEncryption(password) {
      if (password.length < 8) {
        return false;
      }
      var numberRegex = /[0-9]/;
      if (!numberRegex.test(password)) {
        return false;
      }
      var letterRegex = /[a-z]/;
      if (!letterRegex.test(password)) {
        return false;
      }
      return true;
    }

    // Ajax error handling

  }, {
    key: 'handleError',
    value: function handleError(error) {
      if (error.response) {
        // The request was made and the server responded with a status code outside of 2xx
        if (error.response.status === 401) {
          var message = __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('errors.' + error.response.data.errors[0].code);
          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('addAxiosError', message);
        } else {
          console.log(error.response);
        }
      } else if (error.request) {
        // The request was made but no response was received
        var _message2 = __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('errors.server_unreachable');
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('addAxiosError', _message2);
      } else {
        // Something happened in setting up the request that triggered an Error
        // Should not happen
        console.log('Error', error.message);
      }
    }
  }]);

  return Auth;
}();

/* harmony default export */ __webpack_exports__["a"] = (Auth);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(65);











var CompanyApi = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(CompanyApi, _Api);

  function CompanyApi() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "public/v2";

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, CompanyApi);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CompanyApi.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(CompanyApi)).call(this, version));

    _this.path = "companies";
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(CompanyApi, [{
    key: "allAutocomplete",
    value: function allAutocomplete(params) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.get(_this2.path, { params: params }).then(function (response) {
          resolve(response.data.resources);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "getCompany",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.http.get("companies/" + params);

              case 2:
                response = _context.sent;
                return _context.abrupt("return", response.data.resource);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCompany(_x2) {
        return _ref.apply(this, arguments);
      }

      return getCompany;
    }()
  }, {
    key: "updateCompany",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id, params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.http.put("companies/" + id, params);

              case 2:
                response = _context2.sent;


                if (response.status === 201) {
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.company.actions.success",
                    type: "success"
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.company.actions.error",
                    type: "error"
                  });
                }

                return _context2.abrupt("return", response.data.resource);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateCompany(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return updateCompany;
    }()
  }, {
    key: "createCompany",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.http.post("companies/", params);

              case 2:
                response = _context3.sent;


                if (response.status == 201) {
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.company.actions.success_create",
                    type: "success"
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.company.actions.error_create",
                    type: "error"
                  });
                }

                return _context3.abrupt("return", response.data.resource);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createCompany(_x5) {
        return _ref3.apply(this, arguments);
      }

      return createCompany;
    }()
  }, {
    key: "deleteCompany",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.http.delete("companies/" + params);

              case 2:
                response = _context4.sent;


                if (response.status === 204) {
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.company.actions.success_delete",
                    type: "success"
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.company.actions.error_delete",
                    type: "error"
                  });
                }

                return _context4.abrupt("return", response.status);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteCompany(_x6) {
        return _ref4.apply(this, arguments);
      }

      return deleteCompany;
    }()
  }, {
    key: "getCompanyContact",
    value: function getCompanyContact(params) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.http.get("companies" + "/" + params + "/" + "contacts").then(function (response) {
          resolve(response.data.resources);
        }).catch(function (e) {
          _this3.handleError(e);
          reject(e);
        });
      });
    }
  }, {
    key: "getAllCompanies",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (params) {
                  params = {
                    search: params["search"] ? params["search"] : "",
                    per_page: params["per_page"] ? params["per_page"] : 5,
                    page: params["page"] ? params["page"] : 1,
                    sort_by: params["sort_by"] ? params["sort_by"] : "id",
                    sort_order: params["sort_order"] ? params["sort_order"] : "ASC"
                  };
                }

                _context5.next = 3;
                return this.http.get("companies", {
                  params: params
                });

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", response);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getAllCompanies() {
        return _ref5.apply(this, arguments);
      }

      return getAllCompanies;
    }()
  }, {
    key: "search",
    value: function search(params, searchQuery) {
      var _this4 = this;

      if (!params.per_page) {
        params.per_page = this.page_length;
      }
      params.query = searchQuery;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.http.get(_this4.path + "/search", { params: params }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this4.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return CompanyApi;
}(__WEBPACK_IMPORTED_MODULE_8__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CompanyApi);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Api__ = __webpack_require__(15);








var ExternalForm = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ExternalForm, _Api);

  function ExternalForm() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ExternalForm);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExternalForm.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ExternalForm)).call(this, version));

    _this.path = 'external_forms';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ExternalForm, [{
    key: 'duplicate',
    value: function duplicate(external_form_id) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.put(_this2.path + '/' + external_form_id + '/clone').then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return ExternalForm;
}(__WEBPACK_IMPORTED_MODULE_6__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ExternalForm);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__classes_Session__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_config__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(65);













var SegmentsApi = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(SegmentsApi, _Api);

  function SegmentsApi() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "v2";

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SegmentsApi);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SegmentsApi.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(SegmentsApi)).call(this, version));

    var jwt = __WEBPACK_IMPORTED_MODULE_9__classes_Session__["a" /* default */].getJwtCookie();

    _this.http = __WEBPACK_IMPORTED_MODULE_8_axios___default.a.create({
      baseURL: __WEBPACK_IMPORTED_MODULE_10__config_config__["a" /* apiUrl */] + version + "/",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (jwt === undefined) {
      __WEBPACK_IMPORTED_MODULE_9__classes_Session__["a" /* default */].logout();
      jwt = "";
    } else {
      _this.set_jwt(jwt);
    }
    _this.page_length = 25;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(SegmentsApi, [{
    key: "getSegments",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (params) {
                  params = {
                    search: params["search"] ? params["search"] : "",
                    per_page: params["per_page"] ? params["per_page"] : 25,
                    page: params["page"] ? params["page"] : 1,
                    sort_by: params["sort_by"] ? params["sort_by"] : "id",
                    sort_order: params["sort_order"] ? params["sort_order"] : "ASC"
                  };
                } else {
                  params = {};
                }

                _context.next = 3;
                return this.http.get("segments", {
                  params: params
                });

              case 3:
                response = _context.sent;
                return _context.abrupt("return", response);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSegments(_x2) {
        return _ref.apply(this, arguments);
      }

      return getSegments;
    }()
  }, {
    key: "getSegment",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.http.get("segments/" + id);

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", response.data.resource);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSegment(_x3) {
        return _ref2.apply(this, arguments);
      }

      return getSegment;
    }()
  }, {
    key: "updateSegment",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id, params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.http.put("segments/" + id, params);

              case 2:
                response = _context3.sent;


                if (response.status == 200) {
                  __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.segments.actions.success",
                    type: "success"
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit("SET_NOTIFICATION", {
                    title: "ui.segments.actions.error",
                    type: "error"
                  });
                }

                return _context3.abrupt("return", response.data.resource);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateSegment(_x4, _x5) {
        return _ref3.apply(this, arguments);
      }

      return updateSegment;
    }()
  }, {
    key: "deleteSegment",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.http.delete("segments" + "/" + id);

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", response.data.resource);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteSegment(_x6) {
        return _ref4.apply(this, arguments);
      }

      return deleteSegment;
    }()
  }, {
    key: "createSegment",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(params) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.http.post("segments", params);

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", response.data.resource);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createSegment(_x7) {
        return _ref5.apply(this, arguments);
      }

      return createSegment;
    }()
  }]);

  return SegmentsApi;
}(__WEBPACK_IMPORTED_MODULE_7__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SegmentsApi);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_data_dragDefaultElements__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(64);









// Some functions for Drag elements etc.

var Drag = function () {
  function Drag() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Drag);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Drag, null, [{
    key: 'generateElement',
    value: function generateElement(elementType, parentTitle) {
      var element = {
        name: '',
        class: '',
        element_type: elementType,
        parentTitle: parentTitle
      };
      if (elementType == 'text') {
        element.data_type = 'text';
      }
      if (Drag.allowedElementsList().includes(elementType)) {
        element.allowed_values = [];
        element.default_value = null;
        element.enrich_tags = false;
      }
      if (Drag.allowedElementsListWithButtons().includes(elementType)) {
        element.allowed_values = [];
        element.default_value = null;
        element.show_as_buttons = false;
        element.enrich_tags = false;
      }
      if (Drag.allowedSpecialElementsList().includes(elementType)) {
        element.allowed_values = [];
      }
      if (Drag.textInputElementsList().includes(elementType)) {
        element.placeholder = '';
        element.default_value = null;
      }
      if (!Drag.textElementsList().includes(elementType)) {
        element.required = false;
        element.hidden = false;
      } else {
        element.content = '';
      }
      return element;
    }
  }, {
    key: 'generateDefaultElements',
    value: function generateDefaultElements(editorType) {

      if (editorType == 'lead_sheet') {
        var title_standard = __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('ui.drag_editor.dragElements.standard');
        var elements_standard = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__config_data_dragDefaultElements__["a" /* defaultLeadMaskElementsStandard */])().map(function (element) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, Drag.generateElement(element.element_type, title_standard), element);
        });

        var title_advanced = __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('ui.drag_editor.dragElements.advanced');
        var elements_advanced = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__config_data_dragDefaultElements__["b" /* defaultLeadMaskElementsAdvanced */])().map(function (element) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, Drag.generateElement(element.element_type, title_advanced), element);
        });

        return [{
          title: title_standard,
          items: elements_standard
        }, {
          title: title_advanced,
          items: elements_advanced
        }];

        items = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(elements_advanced));
      } else {
        var title = __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t('ui.drag_editor.dragElements.generic');
        var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__config_data_dragDefaultElements__["c" /* defaultExternalFormElements */])().map(function (element) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, Drag.generateElement(element.element_type, title), element);
        });

        return [{
          title: title,
          items: items
        }];
      }
    }
  }, {
    key: 'generateDefaultSubmitButton',
    value: function generateDefaultSubmitButton() {
      return {
        class: "",
        content: "Submit",
        element_type: "submit",
        hidden: false,
        name: "submit_button",
        parent_element: "root"
      };
    }

    // Convert Array format to structured Object required by LeadMasks and ExternalForms

  }, {
    key: 'arrayToStructure',
    value: function arrayToStructure(array) {
      var structure = new Object();
      array.forEach(function (item, idx) {
        item.position = idx.toString();
        structure[item.name] = item;
      });
      return structure;
    }

    // Since our newer external form implementation we have to convert some older elements

  }, {
    key: 'sanitizeOldFormElements',
    value: function sanitizeOldFormElements(item, tabs, activeTab) {
      // Validate and sanitize parent element
      var parentElement = item.parent_element;
      if (!parentElement) {
        parentElement = activeTab.name;
      } else if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tabs).includes(parentElement)) {
        parentElement = activeTab.name;
      } else if (['top', 'bottom', 'container'].some(function (e) {
        return parentElement.includes(e);
      })) {
        // We have removed the old 'top' and 'bottom' containers and instead just use the tab
        parentElement = item.tab;
      }
      item.parent_element = parentElement;

      // Some old buggy elements have allowed_value set and no content although they should have
      if (Drag.textInputElementsList().includes(item.element_type) && item.allowed_values) {
        delete item.allowed_values;
        item.content = '';
      }

      // Remove custom element types
      if (item.element_type.includes('_custom')) {
        item.element_type = item.element_type.replace(/_custom/, '');
      } else if (item.element_type == 'hidden') {
        item.element_type = 'text';
        item.hidden = true;
        item.required = false;
      }
      return item;
    }

    // the elements defined here will have an influence on the canEdit method on the DragItemEdit component
    // this should get refactored in favor of the elements and what attributes are allowed to get edited

  }, {
    key: 'textInputElementsList',
    value: function textInputElementsList() {
      return ['text', 'textarea', 'readonly'];
    }
  }, {
    key: 'allowedElementsList',
    value: function allowedElementsList() {
      return ['select'];
    }
  }, {
    key: 'allowedElementsListWithButtons',
    value: function allowedElementsListWithButtons() {
      return ['radio', 'checkbox'];
    }
  }, {
    key: 'allowedSpecialElementsList',
    value: function allowedSpecialElementsList() {
      return ['quantity_selection'];
    }
  }, {
    key: 'textElementsList',
    value: function textElementsList() {
      return ['confirmation', 'paragraph', 'title'];
    }
  }]);

  return Drag;
}();

/* harmony default export */ __webpack_exports__["a"] = (Drag);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_Drag__ = __webpack_require__(179);







var Mask = function () {
  function Mask() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Mask);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Mask, null, [{
    key: 'buildStructure',


    /**
     * Just a wrap for iterateElements
     *
     * @param {Object} data - The whole dataset
     */
    value: function buildStructure(data) {
      var root_el = this.findChildren(data, "root");
      var root_el_keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(root_el).sort(function (keya, keyb) {
        return root_el[keya].position - root_el[keyb].position;
      });
      var elements = this.iterateElements(data, root_el_keys);
      return elements;
    }

    /**
     * Will list every field inside elements list
     *
     * @param {Object} data - The whole dataset
     * @return {Array} data - the list of fields
     */

  }, {
    key: 'listFields',
    value: function listFields(data) {
      if (!data) {
        return [];
      }
      var fields = [];
      var removeFields = ['position', 'parent_element', 'required'];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
        var element = data[key];
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(element).forEach(function (eKey) {
          if (removeFields.includes(eKey)) {
            delete element[key];
          }
        });
        // Set the elements name into the object also
        element.name = key;
        var defaultAttributes = __WEBPACK_IMPORTED_MODULE_5__classes_Drag__["a" /* default */].generateElement(element.element_type);
        element = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultAttributes, element);
        fields.push(element);
      });
      return fields;
    }

    /**
     * Will check if there is children elements, if there is
     * the function called itself with the same data and a
     * different data_keys
     *
     * @param {Object} data - The whole dataset
     * @param {Array} data_keys - List of elements
     */

  }, {
    key: 'iterateElements',
    value: function iterateElements(data, data_keys) {
      var _this = this;

      var elements = [];

      var _loop = function _loop(i) {
        var element = data[data_keys[i]];
        element.name = data_keys[i];
        elements[i] = element;

        var children = _this.findChildren(data, data_keys[i]);
        // We sort the keys by position
        var children_keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(children).sort(function (keya, keyb) {
          return children[keya].position - children[keyb].position;
        });
        if (children_keys.length > 0) {
          elements[i].children = _this.iterateElements(data, children_keys);
        }
        // Set shouldNotChangeRoute in order to make folded navigation work in lead edit screen
        elements[i].shouldNotChangeRoute = true;
      };

      for (var i = 0; i < data_keys.length; i++) {
        _loop(i);
      }
      return elements;
    }

    /**
     * Will find all elements that has the parent_name
     * as `parent_element`
     * @param {Object} data - The whole dataset
     * @param {String} parent_name - List of elements
     * @return {Object} Filtered data object
     */

  }, {
    key: 'findChildren',
    value: function findChildren(data, parent_name) {
      return _.pickBy(data, function (element) {
        return element.parent_element == parent_name;
      });
    }
  }]);

  return Mask;
}();

/* harmony default export */ __webpack_exports__["a"] = (Mask);

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-business-card.f05d490.svg";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-kit-activity.edc6c7f.svg";

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1291)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(1870),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1311)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(1894),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1306)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(1888),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1374)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(760),
  /* template */
  __webpack_require__(1963),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8eeaf86a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1391)
  __webpack_require__(1392)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(1985),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bdc78956",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */,
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Api__ = __webpack_require__(15);








var EmailTemplate = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(EmailTemplate, _Api);

  function EmailTemplate() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, EmailTemplate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EmailTemplate.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(EmailTemplate)).call(this, version));

    _this.path = 'email_templates';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EmailTemplate, [{
    key: 'duplicate',
    value: function duplicate(email_template_id) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.put(_this2.path + '/' + email_template_id + '/clone').then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return EmailTemplate;
}(__WEBPACK_IMPORTED_MODULE_6__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (EmailTemplate);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(15);






var Plan = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Plan, _Api);

  function Plan() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Plan);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Plan.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Plan)).call(this, version));

    _this.path = 'plans';
    return _this;
  }

  return Plan;
}(__WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Plan);

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Api__ = __webpack_require__(15);









var Workflow = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Workflow, _Api);

  function Workflow() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Workflow);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Workflow.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Workflow)).call(this, version));

    _this.path = 'workflows';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Workflow, [{
    key: 'duplicate',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(workflow_id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.http.put(this.path + '/' + workflow_id + '/clone');

              case 3:
                response = _context.sent;
                return _context.abrupt('return', response.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                this.handleError(_context.t0);
                return _context.abrupt('return', _context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function duplicate(_x2) {
        return _ref.apply(this, arguments);
      }

      return duplicate;
    }()
  }, {
    key: 'trigger',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(workflow_id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.http.post(this.path + '/' + workflow_id + '/trigger');

              case 3:
                response = _context2.sent;
                return _context2.abrupt('return', response.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                this.handleError(_context2.t0);
                return _context2.abrupt('return', _context2.t0);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function trigger(_x3) {
        return _ref2.apply(this, arguments);
      }

      return trigger;
    }()
  }]);

  return Workflow;
}(__WEBPACK_IMPORTED_MODULE_7__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Workflow);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Organization__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Permission__ = __webpack_require__(12);









var Configuration = function () {
  function Configuration() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Configuration);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Configuration, null, [{
    key: 'setOrganizationConfig',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(user) {
        var organization, org_id, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                organization = new __WEBPACK_IMPORTED_MODULE_5__api_Organization__["a" /* default */]();
                org_id = user.organization_id;
                params = {};
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  organization.configuration(org_id, params).then(function (org) {
                    var allowedCrm = false;
                    var permission = __WEBPACK_IMPORTED_MODULE_7__classes_Permission__["a" /* default */].loadPermissions();
                    var allowedCrm = __WEBPACK_IMPORTED_MODULE_7__classes_Permission__["a" /* default */].can(permission, "is_admin");
                    if (allowedCrm) {
                      organization.crm(org_id, params).then(function (crm) {
                        var mappedOrg = Configuration.mapConfiguration(org);
                        if (crm || user.role === 'root') {
                          mappedOrg.crm_presence = { configuration_type: 'ui', content: true };
                        } else {
                          mappedOrg.crm_presence = { configuration_type: 'ui', content: false };
                        }
                        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('SET_CURRENT_ORG_CONFIG', mappedOrg);
                        resolve(mappedOrg);
                      });
                    }
                  }).catch(function (e) {
                    reject(e);
                  });
                }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setOrganizationConfig(_x) {
        return _ref.apply(this, arguments);
      }

      return setOrganizationConfig;
    }()
  }, {
    key: 'mapConfiguration',
    value: function mapConfiguration(configuration) {
      var output = {};
      configuration.forEach(function (value, key) {
        output[value['key']] = {
          content: value['content'],
          configuration_type: value['configuration_type']
        };
      });
      return output;
    }
  }]);

  return Configuration;
}();

/* harmony default export */ __webpack_exports__["a"] = (Configuration);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




// fetching parameters from the URL

var GetUrlQueries = function () {
  function GetUrlQueries() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GetUrlQueries);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GetUrlQueries, null, [{
    key: 'urlQueries',
    value: function urlQueries(query) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).forEach(function (key) {
        return query[key] === undefined ? delete query[key] : '';
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).forEach(function (key) {
        return key === 'filters' ? delete query[key] : '';
      });

      return '/?' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(query[key]);
      }).join('&');
    }
  }]);

  return GetUrlQueries;
}();

/* harmony default export */ __webpack_exports__["a"] = (GetUrlQueries);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus_js__ = __webpack_require__(10);




var WIDGETS = 6;

// @vue/component
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      eventBus: __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */],
      isDisabled: false,

      // Amount of widgets loaded
      loaded: 0
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.eventBus.$on('widget-loaded', function () {
      return _this.loaded++;
    });
    this.eventBus.$on('filter-selected', function () {
      return _this.setIsDisabled(true);
    });
  },


  watch: {
    loaded: function loaded() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash_eq___default()(this.loaded, WIDGETS)) {
        this.setIsDisabled(false);
        this.setLoaded(0);
      }
    }
  },

  methods: {
    emitHandler: function emitHandler(event) {
      this.$emit('change', event);
      this.eventBus.$emit('filter-selected');
    },
    setIsDisabled: function setIsDisabled(isDisabled) {
      this.isDisabled = isDisabled;
    },
    setLoaded: function setLoaded(loaded) {
      this.loaded = loaded;
    }
  }
});

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bk.95eb0dc.svg";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/businesskit.cd824dd.svg";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/company.6f1783d.svg";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dragable-smaller.5e69610.svg";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leadsheet-advanced.fe2403d.svg";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leadsheet-standard.604b4ec.svg";

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project-empty.7db26b6.svg";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scan-card.8a2ae9f.svg";

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/success-password.660aef6.svg";

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/warning-message.86523ce.svg";

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1336)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(1926),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65aea052",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1329)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(1915),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5aca2029",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1395)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(739),
  /* template */
  __webpack_require__(1988),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(2009),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1288)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(748),
  /* template */
  __webpack_require__(1866),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1377)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(761),
  /* template */
  __webpack_require__(1968),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9a0c4c28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(785),
  /* template */
  __webpack_require__(1794),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1312)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1895),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1363)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(805),
  /* template */
  __webpack_require__(1952),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1256)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(817),
  /* template */
  __webpack_require__(1827),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a07c857",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1337)
  __webpack_require__(1338)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(1927),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65eb306e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1263)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(827),
  /* template */
  __webpack_require__(1836),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1334)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(1922),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1405)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(1998),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1259)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1831),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dbd9b00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1258)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(1830),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d8ef3e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1270)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(1844),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25db670a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1277)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(901),
  /* template */
  __webpack_require__(1854),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d2e6531",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */,
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Group-14.svg": 1419,
	"./arrow_left.svg": 429,
	"./arrow_right.svg": 430,
	"./bk.svg": 285,
	"./businesskit.svg": 286,
	"./collaborators.svg": 431,
	"./company-card.svg": 1422,
	"./company.svg": 287,
	"./contacts.svg": 1423,
	"./conversion-1.svg": 1424,
	"./conversion-2.svg": 1425,
	"./conversion-3.svg": 1426,
	"./crm-integration.svg": 1427,
	"./dragable-smaller.svg": 288,
	"./dragable.svg": 1428,
	"./empty-business-card.svg": 203,
	"./empty-dashboard.svg": 432,
	"./empty-default.svg": 157,
	"./empty-funnel.svg": 433,
	"./empty-kit-activity.svg": 204,
	"./empty-kit.svg": 434,
	"./empty-leads.svg": 435,
	"./empty-projects.svg": 436,
	"./enter-email.svg": 437,
	"./forms.svg": 438,
	"./forms_empty.svg": 439,
	"./goto-webinar.svg": 1430,
	"./green-circle.svg": 1431,
	"./hileadzz_logo.svg": 1432,
	"./icon-crm.svg": 440,
	"./icon-external-form.svg": 441,
	"./icon-manual-import.svg": 442,
	"./icon-mobile-app.svg": 443,
	"./icon-unknown.svg": 444,
	"./icon-upload.svg": 1433,
	"./icon-web-app.svg": 445,
	"./icons/icon-clearbit.svg": 446,
	"./icons/icon-fb.svg": 447,
	"./icons/icon-field-password.svg": 1434,
	"./icons/icon-field-user.svg": 1435,
	"./icons/icon-linkedin.svg": 448,
	"./icons/icon-twitter.svg": 449,
	"./icons/icon-upload.svg": 450,
	"./import.svg": 451,
	"./info-message.svg": 452,
	"./info.svg": 453,
	"./kit-thumbnail.svg": 1436,
	"./latest-activity-created.svg": 454,
	"./latest-activity-deleted.svg": 1437,
	"./latest-activity-list-update.svg": 455,
	"./latest-activity-updated.svg": 1438,
	"./lead-count-cold-green.svg": 456,
	"./leads-count-blue-icon.svg": 457,
	"./leads-count-gray.svg": 458,
	"./leads-count-red.svg": 459,
	"./leads-count-yellow.svg": 460,
	"./leadsheet-advanced.svg": 289,
	"./leadsheet-standard.svg": 290,
	"./leadsheet.svg": 461,
	"./logo_fanomena.svg": 1440,
	"./logo_sign.svg": 1441,
	"./logo_sign_grey.svg": 1442,
	"./logo_sign_login.svg": 1443,
	"./logo_text.svg": 1444,
	"./logo_text_black.svg": 1445,
	"./most-active-leads_empty.svg": 1446,
	"./onboarding-step1.svg": 462,
	"./onboarding-step2.svg": 463,
	"./onboarding-step3.svg": 464,
	"./password-request-illustration.svg": 1447,
	"./plus-icon.svg": 1448,
	"./project-created.svg": 465,
	"./project-empty.svg": 291,
	"./scan-card.svg": 292,
	"./segment-icon.svg": 1449,
	"./sources-1.svg": 1450,
	"./static_tracking.svg": 1451,
	"./status-green.svg": 1452,
	"./status-grey.svg": 1453,
	"./success-icon.svg": 466,
	"./success-password.svg": 293,
	"./talents_logo.svg": 1454,
	"./talents_logo_grey.svg": 1455,
	"./talents_logo_login.svg": 1456,
	"./warning-message.svg": 294
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 342;

/***/ }),
/* 343 */,
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










var Statistic = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Statistic, _Api);

  function Statistic() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Statistic);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Statistic.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Statistic)).call(this, version));

    _this.path = 'statistics';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Statistic, [{
    key: 'userRankings',
    value: function userRankings(project_id) {
      var _this2 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var defaultParams = {
        limit: 10,
        end_date: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format(),
        start_date: __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(50, 'd').format()
      };
      var mergedParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(defaultParams, params);

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.http.get(_this2.path + '/projects/' + project_id + '/user_ranking', { params: mergedParams }).then(function (response) {
          resolve(response.data);
        }).catch(function (e) {
          _this2.handleError(e);
          reject(e);
        });
      });
    }
  }]);

  return Statistic;
}(__WEBPACK_IMPORTED_MODULE_7__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Statistic);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLeadName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flow__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_filter__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_join__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isUndefined__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_trim__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNull__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_constant__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_constant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_constant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_cond__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_cond___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_cond__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_stubTrue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_stubTrue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_stubTrue__);
// Service functions for dashboard












// Generates the name from a lead. Returns, depending on what's available:
// 
// - First name and last name
// - First name
// - Last name
// - E-mail
// - Given placeholder
var getLeadName = function getLeadName(lead, fallback) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_flow___default()([__WEBPACK_IMPORTED_MODULE_1_lodash_fp_filter___default()(function (name) {
    return !__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isUndefined___default()(name) || !__WEBPACK_IMPORTED_MODULE_5_lodash_isNull___default()(name);
  }), __WEBPACK_IMPORTED_MODULE_2_lodash_fp_join___default()(' '), __WEBPACK_IMPORTED_MODULE_4_lodash_fp_trim___default.a, function (name) {
    return __WEBPACK_IMPORTED_MODULE_8_lodash_cond___default()([
    // If name is not empty, return it
    [function (name) {
      return !__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(name);
    }, __WEBPACK_IMPORTED_MODULE_7_lodash_constant___default()(name)],

    // If email is set, return email
    [function () {
      return !__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isUndefined___default()(lead.email) || !__WEBPACK_IMPORTED_MODULE_5_lodash_isNull___default()(lead.email);
    }, __WEBPACK_IMPORTED_MODULE_7_lodash_constant___default()(lead.email)],

    // If we have no email or name, return fallback
    [__WEBPACK_IMPORTED_MODULE_9_lodash_stubTrue___default.a, __WEBPACK_IMPORTED_MODULE_7_lodash_constant___default()(fallback)]])(name);
  }])([lead.firstname, lead.lastname]);
};



/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
// This mixin introduces a date filter



var DEFAULT_FORMAT = 'YYYY-MM-DD';

// @vue/component
/* harmony default export */ __webpack_exports__["a"] = ({
  filters: {
    // Returns formatted date
    date: function date(_date) {
      var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(_date).locale(language).format(DEFAULT_FORMAT);
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return round; });
var round = function round(number, precision) {
  var shift = function shift(number, precision, reverseShift) {
    if (reverseShift) {
      precision = -precision;
    }
    var numArray = ("" + number).split("e");
    return +(numArray[0] + "e" + (numArray[1] ? +numArray[1] + precision : precision));
  };
  return shift(Math.round(shift(number, precision, false)), precision, true);
};



/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_organizations_Organizations__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_organizations_Organizations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_organizations_Organizations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_organizations_OrganizationUpdate__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_organizations_OrganizationUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_organizations_OrganizationUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_lead_masks_LeadMasks__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_lead_masks_LeadMasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_lead_masks_LeadMasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_lead_masks_LeadMaskUpdate__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_lead_masks_LeadMaskUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_lead_masks_LeadMaskUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_users_Users__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_users_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_users_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_users_UserUpdate__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_users_UserUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_users_UserUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_users_UserProfile__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_users_UserProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_users_UserProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_external_forms_ExternalForms__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_external_forms_ExternalForms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_external_forms_ExternalForms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_external_forms_ExternalFormUpdate__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_external_forms_ExternalFormUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_external_forms_ExternalFormUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_external_forms_ExternalFormEditor__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_external_forms_ExternalFormEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_external_forms_ExternalFormEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_external_forms_ExternalFormPreview__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_external_forms_ExternalFormPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_external_forms_ExternalFormPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_external_forms_ExternalFormOptions__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_external_forms_ExternalFormOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_external_forms_ExternalFormOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_projects_Projects__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_projects_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_projects_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_projects_ProjectsSynchronize__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_projects_ProjectsSynchronize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_projects_ProjectsSynchronize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_projects_ProjectAssignments__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_projects_ProjectAssignments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_projects_ProjectAssignments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_projects_ProjectUpdate__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_projects_ProjectUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_projects_ProjectUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_projects_ProjectWizard__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_projects_ProjectWizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_projects_ProjectWizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_projects_ProjectUpdateAssignement__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_projects_ProjectUpdateAssignement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_projects_ProjectUpdateAssignement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_statistics_Statistics__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_statistics_Statistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_statistics_Statistics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_contacts_Contacts__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_contacts_Contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_contacts_Contacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_companies_Companies__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_companies_Companies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_companies_Companies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_companies_Company__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_companies_Company___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_companies_Company__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_segments_Segments__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_segments_Segments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_segments_Segments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_lead_masks_LeadMaskEditor__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_lead_masks_LeadMaskEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_lead_masks_LeadMaskEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_lead_masks_LeadMaskOptions__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_lead_masks_LeadMaskOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_lead_masks_LeadMaskOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_segments_Segment__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_segments_Segment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_segments_Segment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_contacts_Contact__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_contacts_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_contacts_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_project_leads_Leads__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_project_leads_Leads___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_project_leads_Leads__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_project_leads_LeadUpdate__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_project_leads_LeadUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_project_leads_LeadUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_project_leads_LeadDetailedStatistics__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_project_leads_LeadDetailedStatistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_project_leads_LeadDetailedStatistics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_project_leads_LeadDetailedStatisticsFrame__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_project_leads_LeadDetailedStatisticsFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_project_leads_LeadDetailedStatisticsFrame__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_project_leads_LeadCreate__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_project_leads_LeadCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_project_leads_LeadCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_projects_ProjectStatistics__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_projects_ProjectStatistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__pages_projects_ProjectStatistics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_projects_ProjectTrackings__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_projects_ProjectTrackings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__pages_projects_ProjectTrackings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_projects_ProjectTrackingsFrame__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_projects_ProjectTrackingsFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__pages_projects_ProjectTrackingsFrame__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_email_templates_EmailTemplates__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_email_templates_EmailTemplates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__pages_email_templates_EmailTemplates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_dashboard_Dashboard__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_dashboard_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__pages_dashboard_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_email_templates_EmailTemplateUpdate__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_email_templates_EmailTemplateUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__pages_email_templates_EmailTemplateUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_content_manager_ContentManager__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_content_manager_ContentManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__pages_content_manager_ContentManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_auth_Login__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_auth_PasswordResetRequest__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_auth_PasswordResetRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_auth_PasswordResetRequest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_auth_PasswordReset__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_auth_PasswordReset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_auth_PasswordReset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_auth_Invitation__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_auth_Invitation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_auth_Invitation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_Unauthorized__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_Unauthorized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__pages_Unauthorized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_pages_plans_PlanUpdate__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_pages_plans_PlanUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_pages_plans_PlanUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_pages_plans_Plans__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_pages_plans_Plans___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_pages_plans_Plans__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_pages_workflows_Workflows__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_pages_workflows_Workflows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_pages_workflows_Workflows__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_pages_workflows_WorkflowUpdate__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_pages_workflows_WorkflowUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_pages_workflows_WorkflowUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_vue_meta__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_vue_meta__);














































// import Segment from "@/components/pages/Segment";











var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/login",
    name: "login",
    component: __WEBPACK_IMPORTED_MODULE_44__components_auth_Login___default.a,
    meta: {
      layout: "public"
    }
  }, {
    path: "/password_reset_request",
    name: "password_reset_request",
    component: __WEBPACK_IMPORTED_MODULE_45__components_auth_PasswordResetRequest___default.a,
    meta: {
      layout: "public"
    }
  }, {
    path: "/reset_password/:token",
    name: "password_reset",
    component: __WEBPACK_IMPORTED_MODULE_46__components_auth_PasswordReset___default.a,
    meta: {
      layout: "public"
    }
  }, {
    path: "/accept_invitation/:token",
    name: "accept_invitation",
    component: __WEBPACK_IMPORTED_MODULE_47__components_auth_Invitation___default.a,
    public: true,
    meta: {
      layout: "public"
    }
  }, {
    path: "/logout",
    name: "logout",
    redirect: {
      name: "login",
      query: {
        source: "logout"
      }
    }
  }, {
    path: "/",
    name: "home",
    redirect: { name: "dashboard" }
  }, {
    path: "/ext-forms",
    name: "external_forms",
    component: __WEBPACK_IMPORTED_MODULE_12__pages_external_forms_ExternalForms___default.a,
    meta: {
      layout: "classic"
    }
  }, {
    path: "/ext-form/:id/",
    name: "external_form_edit",
    component: __WEBPACK_IMPORTED_MODULE_13__pages_external_forms_ExternalFormUpdate___default.a,
    props: true,
    meta: {
      layout: "classic"
    },
    children: [{
      path: "edit",
      name: "external_form_editor",
      component: __WEBPACK_IMPORTED_MODULE_14__pages_external_forms_ExternalFormEditor___default.a,
      meta: {
        externalFormEdit: true
      }
    }, {
      path: "preview",
      name: "external_form_preview",
      component: __WEBPACK_IMPORTED_MODULE_15__pages_external_forms_ExternalFormPreview___default.a,
      meta: {
        externalFormEdit: true
      }
    }, {
      path: "options",
      name: "external_form_options",
      component: __WEBPACK_IMPORTED_MODULE_16__pages_external_forms_ExternalFormOptions___default.a,
      meta: {
        externalFormEdit: true
      }
    }]
  }, {
    path: "/plans",
    name: "plans",
    component: __WEBPACK_IMPORTED_MODULE_50__components_pages_plans_Plans___default.a
  }, {
    path: "/dashboard",
    name: "dashboard",
    component: __WEBPACK_IMPORTED_MODULE_41__pages_dashboard_Dashboard___default.a,
    meta: {
      layout: "dashboard"
    }
  }, {
    path: "/plans/:id/edit",
    name: "plan_edit",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_49__components_pages_plans_PlanUpdate___default.a
  }, {
    path: "/plans/:id",
    name: "plan_show",
    redirect: {
      name: "plan_edit"
    }
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.projects"),
    name: "projects",
    component: __WEBPACK_IMPORTED_MODULE_17__pages_projects_Projects___default.a,
    children: [{
      path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/new",
      name: "project_new",
      component: __WEBPACK_IMPORTED_MODULE_21__pages_projects_ProjectWizard___default.a,
      meta: {
        showModal: true
      }
    }]
  }, {
    path: "/projects_synchronize",
    name: "projects_synchronize",
    component: __WEBPACK_IMPORTED_MODULE_18__pages_projects_ProjectsSynchronize___default.a
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id/edit",
    name: "project_edit",
    component: __WEBPACK_IMPORTED_MODULE_20__pages_projects_ProjectUpdate___default.a,
    props: true,
    meta: {
      layout: "classic"
    }
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id/assignments",
    name: "project_assignments_edit",
    component: __WEBPACK_IMPORTED_MODULE_19__pages_projects_ProjectAssignments___default.a
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id/statistics",
    name: "project_statistics",
    component: __WEBPACK_IMPORTED_MODULE_37__pages_projects_ProjectStatistics___default.a,
    props: true
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id/statistics/trackings",
    name: "project_statistics_trackings",
    component: __WEBPACK_IMPORTED_MODULE_38__pages_projects_ProjectTrackings___default.a,
    props: true
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id/statistics/trackings/frame",
    name: "project_statistics_trackings_frame",
    component: __WEBPACK_IMPORTED_MODULE_39__pages_projects_ProjectTrackingsFrame___default.a,
    props: true,
    meta: {
      layout: "empty"
    }
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id/assignement",
    name: "project_edit_assignement",
    component: __WEBPACK_IMPORTED_MODULE_22__pages_projects_ProjectUpdateAssignement___default.a,
    props: true
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id",
    name: "project_show",
    redirect: {
      name: "project_leads"
    }
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project_leads") + "/",
    name: "project_leads",
    component: __WEBPACK_IMPORTED_MODULE_32__pages_project_leads_Leads___default.a,
    props: true
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project_leads") + "/:lead_id/edit/:query?",
    name: "project_lead_edit",
    component: __WEBPACK_IMPORTED_MODULE_33__pages_project_leads_LeadUpdate___default.a,
    props: true
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project") + "/:id/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project_leads") + "/:lead_id/statistics",
    name: "project_lead_stats",
    component: __WEBPACK_IMPORTED_MODULE_34__pages_project_leads_LeadDetailedStatistics___default.a,
    props: true
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project_leads") + "/:lead_id/statistics/frame",
    name: "project_lead_detailed_stats",
    component: __WEBPACK_IMPORTED_MODULE_35__pages_project_leads_LeadDetailedStatisticsFrame___default.a,
    props: true,
    meta: {
      layout: "empty"
    }
  }, {
    path: "/" + __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].t("routes.project_leads") + "/:id/leads/new",
    name: "project_lead_new",
    component: __WEBPACK_IMPORTED_MODULE_36__pages_project_leads_LeadCreate___default.a,
    props: true
  }, {
    path: "/organizations",
    name: "organizations",
    component: __WEBPACK_IMPORTED_MODULE_5__pages_organizations_Organizations___default.a
  }, {
    path: "/contacts",
    name: "contacts",
    component: __WEBPACK_IMPORTED_MODULE_24__pages_contacts_Contacts___default.a,
    props: function props(route) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, route.params);
    },
    meta: {
      layout: "classic",
      createSegment: false
    }
  }, {
    path: "/companies",
    name: "companies",
    component: __WEBPACK_IMPORTED_MODULE_25__pages_companies_Companies___default.a,
    meta: {
      layout: "classic",
      createSegment: false
    }
  }, {
    path: "/company/:id",
    name: "company",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_26__pages_companies_Company___default.a,
    meta: {
      layout: "classic",
      createSegment: false
    }
  }, {
    path: "/segments",
    name: "segments",
    component: __WEBPACK_IMPORTED_MODULE_27__pages_segments_Segments___default.a,
    meta: {
      layout: "classic"
    }
  }, {
    path: "/segments/:id/edit",
    name: "segment_edit",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_30__pages_segments_Segment___default.a,
    meta: {
      layout: "classic"
    }
  }, {
    path: "/contact/:contactId",
    name: "contacts_edit",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_31__pages_contacts_Contact___default.a,
    meta: {
      layout: "classic"
    }
  }, {
    path: "/organization/:id/edit",
    name: "organization_edit",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_6__pages_organizations_OrganizationUpdate___default.a
  }, {
    path: "/organization/new",
    name: "organization_new",
    component: __WEBPACK_IMPORTED_MODULE_6__pages_organizations_OrganizationUpdate___default.a
  }, {
    path: "/contacts",
    name: "segment_new",
    component: __WEBPACK_IMPORTED_MODULE_24__pages_contacts_Contacts___default.a,
    meta: {
      layout: "classic",
      createSegment: true
    }
  }, {
    path: "/lead_masks",
    name: "lead_masks",
    component: __WEBPACK_IMPORTED_MODULE_7__pages_lead_masks_LeadMasks___default.a
  }, {
    path: "/lead_mask/:id/",
    name: "lead_mask_edit",
    component: __WEBPACK_IMPORTED_MODULE_8__pages_lead_masks_LeadMaskUpdate___default.a,
    props: true,
    meta: {
      layout: "classic"
    },
    children: [{
      path: "edit",
      name: "lead_mask_editor",
      component: __WEBPACK_IMPORTED_MODULE_28__pages_lead_masks_LeadMaskEditor___default.a
    }, {
      path: "options",
      name: "lead_mask_options",
      component: __WEBPACK_IMPORTED_MODULE_29__pages_lead_masks_LeadMaskOptions___default.a
    }]
  }, {
    path: "/lead_mask/new",
    name: "lead_mask_new",
    component: __WEBPACK_IMPORTED_MODULE_8__pages_lead_masks_LeadMaskUpdate___default.a,
    meta: {
      layout: "classic"
    }
  }, {
    path: "/email_templates",
    name: "email_templates",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_40__pages_email_templates_EmailTemplates___default.a
  }, {
    path: "/email_templates/new",
    name: "email_template_new",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_42__pages_email_templates_EmailTemplateUpdate___default.a
  }, {
    path: "/email_templates/:id/edit",
    name: "email_template_edit",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_42__pages_email_templates_EmailTemplateUpdate___default.a
  }, {
    path: "/statistics",
    name: "statistics",
    component: __WEBPACK_IMPORTED_MODULE_23__pages_statistics_Statistics___default.a
  }, {
    path: "/content_manager",
    name: "content_manager",
    component: __WEBPACK_IMPORTED_MODULE_43__pages_content_manager_ContentManager___default.a
  }, {
    path: "/users",
    name: "users",
    component: __WEBPACK_IMPORTED_MODULE_9__pages_users_Users___default.a
  }, {
    path: "/user/:id?/edit",
    name: "user_edit",
    component: __WEBPACK_IMPORTED_MODULE_10__pages_users_UserUpdate___default.a,
    props: true
  }, {
    path: "/user/:id?/profile",
    name: "user_profile",
    component: __WEBPACK_IMPORTED_MODULE_11__pages_users_UserProfile___default.a,
    props: true
  }, {
    path: "/unauthorized",
    name: "unauthorized",
    component: __WEBPACK_IMPORTED_MODULE_48__pages_Unauthorized___default.a
  }, {
    path: "/workflows",
    name: "workflows",
    component: __WEBPACK_IMPORTED_MODULE_51__components_pages_workflows_Workflows___default.a
  }, {
    path: "/workflow/:id/edit",
    name: "workflow_edit",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_52__components_pages_workflows_WorkflowUpdate___default.a
  }]
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_53_vue_meta___default.a);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow_left.883a373.svg";

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow_right.12549b6.svg";

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/collaborators.e8216ae.svg";

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-dashboard.26c8e17.svg";

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-funnel.a2d9fa0.svg";

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-kit.3e968a6.svg";

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-leads.a0f64cc.svg";

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-projects.556e368.svg";

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/enter-email.f5d8ef9.svg";

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/forms.bf6e902.svg";

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/forms_empty.0dbb8f4.svg";

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-crm.6927c0c.svg";

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-external-form.be5549b.svg";

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-manual-import.8753e21.svg";

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-mobile-app.3586ca1.svg";

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-unknown.0b29a28.svg";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-web-app.38b39ea.svg";

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-clearbit.d5110ad.svg";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-fb.168db43.svg";

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-linkedin.639d611.svg";

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-twitter.5269333.svg";

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-upload.8fa3985.svg";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/import.dd21190.svg";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/info-message.2773260.svg";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/info.fd1b670.svg";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/latest-activity-created.b06aae7.svg";

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/latest-activity-list-update.cc598e5.svg";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lead-count-cold-green.6ab726d.svg";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leads-count-blue-icon.cf7a2c9.svg";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leads-count-gray.6021aba.svg";

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leads-count-red.5249ec9.svg";

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leads-count-yellow.9cfc17f.svg";

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leadsheet.de1e761.svg";

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onboarding-step1.5463b5e.svg";

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onboarding-step2.17bb50c.svg";

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onboarding-step3.6970c41.svg";

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project-created.f1e27fd.svg";

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/success-icon.798e5cd.svg";

/***/ }),
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(1815),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1331)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(1917),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ba7ffae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1409)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(2003),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(1983),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(1981),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1345)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(736),
  /* template */
  __webpack_require__(1935),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6caa521c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1232)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(738),
  /* template */
  __webpack_require__(1792),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1254)
  __webpack_require__(1253)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(742),
  /* template */
  __webpack_require__(1824),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16b5a4a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1382)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(752),
  /* template */
  __webpack_require__(1976),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1350)
  __webpack_require__(1349)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(770),
  /* template */
  __webpack_require__(1940),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70087889",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1369)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(776),
  /* template */
  __webpack_require__(1958),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f849f41",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1276)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(779),
  /* template */
  __webpack_require__(1852),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1278)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(782),
  /* template */
  __webpack_require__(1855),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ee8e774",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1283)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(783),
  /* template */
  __webpack_require__(1860),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(1868),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1260)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(806),
  /* template */
  __webpack_require__(1833),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1242)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(809),
  /* template */
  __webpack_require__(1808),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-083f5ea3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(813),
  /* template */
  __webpack_require__(1853),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1401)
  __webpack_require__(1402)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(815),
  /* template */
  __webpack_require__(1995),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cd77954e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1243)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(828),
  /* template */
  __webpack_require__(1809),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(1797),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04ad6520",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(859),
  /* template */
  __webpack_require__(1885),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1385)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1979),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b5f731de",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1404)
  __webpack_require__(1403)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(1997),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cdf8d584",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */,
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quasar_framework_dist_umd_quasar_mat_css__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quasar_framework_dist_umd_quasar_mat_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_quasar_framework_dist_umd_quasar_mat_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_quasar_framework_dist_quasar_mat_esm__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_app_scss__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_frappe__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_plugin_load_script__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_localstorage__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_datepicker_dist_locale__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bugsnag_js__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bugsnag_plugin_vue__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__bugsnag_plugin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_ClickOutside__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_Can__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_CanDom__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__i18n__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config_router__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__classes_Permission__ = __webpack_require__(12);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.























if (true) {
  var bugsnagClient = __WEBPACK_IMPORTED_MODULE_12__bugsnag_js___default()("4ed8fa978dd2b69d2b47bae6d1cbd39a");

  bugsnagClient.use(__WEBPACK_IMPORTED_MODULE_13__bugsnag_plugin_vue___default.a, __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]);
}

// For loading external scripts
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_plugin_load_script__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue2_frappe__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_quasar_framework_dist_quasar_mat_esm__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_localstorage___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive("click-outside", __WEBPACK_IMPORTED_MODULE_15__directives_ClickOutside__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive("can", __WEBPACK_IMPORTED_MODULE_16__directives_Can__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive("can-dom", __WEBPACK_IMPORTED_MODULE_17__directives_CanDom__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive("focus", {
  inserted: function inserted(el) {
    el.focus();
  }
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.keyCodes.backspace = 8;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.keyCodes.comma = 188;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].mixin({
  methods: {
    deepUpdate: function deepUpdate(object, key, value) {
      var newValues = {};
      newValues[key] = value;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object, newValues);
    },
    generateUuidv4: function generateUuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    hasPermission: function hasPermission(operation) {
      var permission = __WEBPACK_IMPORTED_MODULE_21__classes_Permission__["a" /* default */].loadPermissions();
      return __WEBPACK_IMPORTED_MODULE_21__classes_Permission__["a" /* default */].can(permission, operation);
    },
    formatDateTimeNatural: function formatDateTimeNatural(datetime) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


      // datetime = A valid date/time string
      // or, set to NULL for now

      // Options:
      // includeTime = true
      // excludeSameYear = true
      // useDateExpressions = true
      // useTimeExpressions = true

      if (datetime === undefined || datetime === '') {
        return '';
      }

      var date = moment(datetime);
      if (!date.isValid()) {
        return '';
      }

      var now = moment();

      // If the time is just a few minutes ago, return an expression
      if (options.useTimeExpressions !== false && date.isSame(now, 'day')) {
        if (now.diff(date, 'seconds') < 20) {
          return this.$t('ui.global.date_time.seconds_ago');
        }
        if (now.diff(date, 'seconds') < 60) {
          return this.$t('ui.global.date_time.less_than_minute');
        }
        if (now.diff(date, 'minutes') < 5) {
          return this.$t('ui.global.date_time.minutes_ago');
        }
      }

      var text = '';

      // If the date is today or yesterday, just return those terms
      if (options.useDateExpressions !== false) {
        text = date.isSame(now, 'day') ? this.$t('ui.global.date_time.today') : date.isSame(now.subtract(1, 'day'), 'day') ? this.$t('ui.global.date_time.yesterday') : '';
      }

      if (text == '') {
        // Otherwise, return a date and year
        text = date.format('D MMM');
        if (date.isSame(now, 'year') == false || options.excludeSameYear === false) {
          // Only include the year if it's not this year
          text += ' ' + date.format('YYYY');
        }
      }

      if (options.includeTime !== false) {
        text += ' ' + this.$t('ui.global.date_time.at') + ' ' + date.format('H:mm');
      }

      return text;
    },
    getDatePickerLanguage: function getDatePickerLanguage() {
      if (this.$store.getters.getCurrentLanguage === 'de') {
        return __WEBPACK_IMPORTED_MODULE_11_vuejs_datepicker_dist_locale__["de"];
      } else {
        return __WEBPACK_IMPORTED_MODULE_11_vuejs_datepicker_dist_locale__["en"];
      }
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  store: __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_19__i18n__["a" /* default */],
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_20__config_router__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_18__App___default.a }
});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/yule-icon-set.ttf";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/yule-icon-set.woff";

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hileadzz_models_yml__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hileadzz_models_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__hileadzz_models_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hileadzz_models_de_yml__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hileadzz_models_de_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__hileadzz_models_de_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hileadzz_errors_yml__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hileadzz_errors_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__hileadzz_errors_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hileadzz_errors_de_yml__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hileadzz_errors_de_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__hileadzz_errors_de_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hileadzz_ui_yml__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hileadzz_ui_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__hileadzz_ui_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hileadzz_ui_de_yml__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hileadzz_ui_de_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__hileadzz_ui_de_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hileadzz_datetime_yml__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hileadzz_datetime_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__hileadzz_datetime_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hileadzz_datetime_de_yml__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hileadzz_datetime_de_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__hileadzz_datetime_de_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hileadzz_statistics_yml__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hileadzz_statistics_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__hileadzz_statistics_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hileadzz_statistics_de_yml__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hileadzz_statistics_de_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__hileadzz_statistics_de_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hileadzz_routes_yml__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hileadzz_routes_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__hileadzz_routes_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__talents_models_en_tal_yml__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__talents_models_en_tal_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__talents_models_en_tal_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__talents_models_de_tal_yml__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__talents_models_de_tal_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__talents_models_de_tal_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__talents_errors_en_tal_yml__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__talents_errors_en_tal_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__talents_errors_en_tal_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__talents_errors_de_tal_yml__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__talents_errors_de_tal_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__talents_errors_de_tal_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__talents_ui_en_tal_yml__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__talents_ui_en_tal_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__talents_ui_en_tal_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__talents_ui_de_tal_yml__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__talents_ui_de_tal_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__talents_ui_de_tal_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__talents_statistics_en_tal_yml__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__talents_statistics_en_tal_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__talents_statistics_en_tal_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__talents_statistics_de_tal_yml__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__talents_statistics_de_tal_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__talents_statistics_de_tal_yml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__talents_routes_yml__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__talents_routes_yml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__talents_routes_yml__);
// Hileadzz












// Talents










/* harmony default export */ __webpack_exports__["a"] = ([
  __WEBPACK_IMPORTED_MODULE_10__hileadzz_routes_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_19__talents_routes_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_0__hileadzz_models_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_1__hileadzz_models_de_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_11__talents_models_en_tal_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_12__talents_models_de_tal_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_2__hileadzz_errors_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_3__hileadzz_errors_de_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_13__talents_errors_en_tal_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_14__talents_errors_de_tal_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_4__hileadzz_ui_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_5__hileadzz_ui_de_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_15__talents_ui_en_tal_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_16__talents_ui_de_tal_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_6__hileadzz_datetime_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_7__hileadzz_datetime_de_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_8__hileadzz_statistics_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_9__hileadzz_statistics_de_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_17__talents_statistics_en_tal_yml___default.a,
  __WEBPACK_IMPORTED_MODULE_18__talents_statistics_de_tal_yml___default.a
]);


/***/ }),
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_frappe_charts_dist_frappe_charts_min_esm__ = __webpack_require__(1457);

//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        id: {
            required: true,
            type: String,
            default: null
        },

        dataSets: {
            required: false
        },

        labels: {
            required: false,
            type: Array,
            default: function _default() {
                return [];
            }
        },

        startDate: {
            required: false,
            type: Date,
            default: null
        },

        endDate: {
            required: false,
            type: Date,
            default: null
        },

        dataPoints: {
            required: false,
            type: Object,
            default: function _default() {}
        },

        countLabel: {
            required: false,
            type: String,
            default: 'Count'
        },

        title: {
            required: false,
            type: String
        },

        height: {
            required: false,
            type: Number,
            default: 300
        },

        type: {
            required: false,
            type: String,
            default: 'bar'
        },

        yMarkers: {
            required: false,
            type: Array,
            default: function _default() {
                return null;
            }
        },

        yRegions: {
            required: false,
            type: Array,
            default: function _default() {
                return null;
            }
        },

        colors: {
            required: false,
            type: Array,
            default: function _default() {
                return ['purple', '#ffa3ef', 'light-blue'];
            }
        },

        isNavigable: {
            required: false,
            type: Boolean,
            default: false
        },

        valuesOverPoints: {
            required: false,
            type: Boolean,
            default: false
        },

        lineOptions: {
            required: false,
            type: Object,
            default: function _default() {
                return {
                    dotSize: 4,
                    hideLine: 0,
                    hideDots: 0,
                    heatline: 0,
                    regionFill: 0,
                    areaFill: 0
                };
            }
        },

        axisOptions: {
            required: false,
            type: Object,
            default: function _default() {
                return {
                    yAxisMode: '',
                    xAxisMode: '',
                    xIsSeries: 0
                };
            }
        },

        maxLegendPoints: {
            required: false,
            type: Number,
            default: 20
        },

        maxSlices: {
            required: false,
            type: Number,
            default: 20
        },

        barOptions: {
            required: false,
            type: Object,
            default: function _default() {
                return {
                    height: 20,
                    depth: 2,
                    spaceRatio: 0.5,
                    stacked: 0
                };
            }
        },

        discreteDomains: {
            required: false,
            type: Boolean,
            default: true
        },

        tooltipOptions: {
            required: false,
            type: Object,
            default: function _default() {
                return {
                    formatTooltipX: function formatTooltipX(d) {
                        return (d + '').toUpperCase();
                    },
                    formatTooltipY: function formatTooltipY(d) {
                        return d + ' pts';
                    }
                };
            }
        }
    },

    data: function data() {
        return {
            chart: null,
            data: {
                labels: this.labels,
                datasets: this.dataSets,
                yMarkers: this.yMarkers,
                yRegions: this.yRegions
            },
            heatmapData: {
                dataPoints: this.dataPoints,
                start: this.startDate,
                end: this.endDate,
                countLabel: this.countLabel
            }
        };
    },


    watch: {
        labels: function labels() {
            this.update();
        },
        dataSets: function dataSets() {
            this.update();
        },
        yMarkers: function yMarkers() {
            this.update();
        },
        yRegions: function yRegions() {
            this.update();
        }
    },

    mounted: function mounted() {
        this.startChart();
    },


    methods: {
        startChart: function startChart() {
            var baseOptions = {
                type: this.type,
                discreteDomains: this.discreteDomains,
                colors: this.colors,
                height: this.height,
                title: this.title,
                isNavigable: this.isNavigable
            };

            var heatMapOptions = {
                data: this.heatmapData
            };

            var chartOptions = {
                data: this.data,
                tooltipOptions: this.tooltipOptions,
                valuesOverPoints: this.valuesOverPoints,
                barOptions: this.barOptions,
                lineOptions: this.lineOptions,
                axisOptions: this.axisOptions,
                maxLegendPoints: this.maxLegendPoints,
                maxSlices: this.maxSlices
            };

            var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(baseOptions, this.type === 'heatmap' ? heatMapOptions : chartOptions);

            this.chart = new __WEBPACK_IMPORTED_MODULE_1_frappe_charts_dist_frappe_charts_min_esm__["a" /* Chart */]('#' + this.id, options);
        },
        export: function _export() {
            this.chart.export();
        },
        addDataPoint: function addDataPoint(label, valueFromEachDataset, index) {
            this.chart.addDataPoint(label, valueFromEachDataset, index);
        },
        removeDataPoint: function removeDataPoint(index) {
            this.chart.removeDataPoint(index);
        },
        updateDataset: function updateDataset(datasetValues, index) {
            this.chart.updateDataset(datasetValues, index);
        },
        update: function update() {
            var data = {
                labels: this.labels,
                datasets: this.dataSets,
                yMarkers: this.yMarkers,
                yRegions: this.yRegions
            };
            this.chart.update(data);
        },
        unbindWindowEvents: function unbindWindowEvents() {
            this.chart.unbindWindowEvents();
        }
    }
});

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _start_of_month = __webpack_require__(1216);

var _start_of_month2 = _interopRequireDefault(_start_of_month);

var _end_of_month = __webpack_require__(1204);

var _end_of_month2 = _interopRequireDefault(_end_of_month);

var _each_day = __webpack_require__(1203);

var _each_day2 = _interopRequireDefault(_each_day);

var _get_day = __webpack_require__(1206);

var _get_day2 = _interopRequireDefault(_get_day);

var _format = __webpack_require__(1205);

var _format2 = _interopRequireDefault(_format);

var _start_of_day = __webpack_require__(421);

var _start_of_day2 = _interopRequireDefault(_start_of_day);

var _is_equal = __webpack_require__(1209);

var _is_equal2 = _interopRequireDefault(_is_equal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var AM = 'AM';
var PM = 'PM';
exports.default = {
  name: 'datetime-picker',
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD h:i:s'
    },
    name: {
      type: String
    },
    width: {
      type: String
    },
    value: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    firstDayOfWeek: {
      default: 0,
      validator: function validator(value) {
        try {
          var val = parseInt(value, 10);
          return val >= 0 && val <= 1;
        } catch (e) {
          console.warn(e.message);
          return false;
        }
      },
      message: 'Only 0 (Sunday) and 1 (Monday) are supported.'
    }
  },
  data: function data() {
    return {
      date: this.value,
      hideCal: true,
      activePort: null,
      timeStamp: new Date(),
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days: [],
      monthIndex: 0,
      hourIndex: 0,
      minuteIndex: 0,
      year: 2017,
      portsHolder: [],
      minute: '00',
      hour: '01',
      day: 1,
      minuteSelectorVisible: false,
      hourSelectorVisible: false,
      period: AM,
      periodStyle: 12
    };
  },

  methods: {
    leftMonth: function leftMonth() {
      var index = this.months.indexOf(this.month);
      if (index === 0) {
        this.monthIndex = 11;
      } else {
        this.monthIndex = index - 1;
      }
      this.updateCalendar();
    },
    rightMonth: function rightMonth() {
      var index = this.months.indexOf(this.month);
      if (index === 11) {
        this.monthIndex = 0;
      } else {
        this.monthIndex = index + 1;
      }
      this.updateCalendar();
    },
    rightYear: function rightYear() {
      this.year++;
      this.updateCalendar();
    },
    leftYear: function leftYear() {
      this.year--;
      this.updateCalendar();
    },
    updateActivePortFromWeek: function updateActivePortFromWeek(week, weekIndex) {
      var currentActive = (0, _start_of_day2.default)(this.timeStamp);
      var index = week.findIndex(function (day) {
        return (0, _is_equal2.default)(currentActive, day);
      });
      if (index !== -1) {
        this.activePort = weekIndex * 7 + index;
      }
    },
    updateCalendar: function updateCalendar() {
      var _this = this;

      var date = new Date(this.year, this.monthIndex, 1, 0, 0, 0);
      var weeks = [];
      var week = null;
      var weekDays = new Array(7);
      // let index = 0;
      this.activePort = null;
      (0, _each_day2.default)(date, (0, _end_of_month2.default)(date)).forEach(function (day) {
        var weekday = (0, _get_day2.default)(day);
        if (weekday === _this.normalizedFirstDayOfWeek) {
          if (week) {
            weeks.push(week);
            // Add those days that were not part of the month to the index
            // index += week.filter(d => d === null).length;
            _this.updateActivePortFromWeek(weekDays, weeks.length - 1);
            weekDays = new Array(7);
          }
          week = new Array(7);
        } else if (week === null) {
          week = new Array(7);
        }
        var idx = (weekday - _this.normalizedFirstDayOfWeek + 7) % 7;
        week[idx] = (0, _format2.default)(day, 'DD');
        weekDays[idx] = day;
      });
      if (week && week.some(function (n) {
        return n;
      })) {
        weeks.push(week);
        this.updateActivePortFromWeek(weekDays, weeks.length - 1);
      }
      this.weeks = weeks;
    },
    setDay: function setDay(index, port) {
      if (port) {
        this.activePort = index;
        this.day = parseInt(port, 10);
        this.timeStamp = new Date(this.year, this.monthIndex, this.day);
      }
    },
    setMinute: function setMinute(index, closeAfterSet) {
      this.minuteIndex = index;
      this.minute = this.minutes[index];
      if (closeAfterSet) {
        this.minuteSelectorVisible = false;
      }
    },
    setHour: function setHour(index, closeAfterSet) {
      this.hourIndex = index;
      this.hour = this.hours[index];
      if (closeAfterSet) {
        this.hourSelectorVisible = false;
      }
    },
    showHourSelector: function showHourSelector() {
      this.hourSelectorVisible = true;
      this.minuteSelectorVisible = false;
    },
    showMinuteSelector: function showMinuteSelector() {
      this.minuteSelectorVisible = true;
      this.hourSelectorVisible = false;
    },
    keyIsDown: function keyIsDown(event) {
      var key = event.which || event.keycode;
      if (key === 38) {
        if (this.minuteSelectorVisible && this.minuteIndex > 0) {
          this.setMinute(this.minuteIndex - 1, false);
          this.scrollTopMinute();
        } else if (this.hourSelectorVisible && this.hourIndex > 0) {
          this.setHour(this.hourIndex - 1, false);
          this.scrollTopHour();
        }
      } else if (key === 40) {
        if (this.minuteSelectorVisible && this.minuteIndex < this.minutes.length - 1) {
          this.setMinute(this.minuteIndex + 1, false);
          this.scrollTopMinute();
        } else if (this.hourSelectorVisible && this.hourIndex < this.hours.length - 1) {
          this.setHour(this.hourIndex + 1, false);
          this.scrollTopHour();
        }
      } else if (key === 13) {
        this.minuteSelectorVisible = false;
        this.hourSelectorVisible = false;
      }
      if (this.minuteSelectorVisible || this.hourSelectorVisible) {
        event.preventDefault();
        this.minuteSelectorVisible = false;
        this.hourSelectorVisible = false;
      }
    },
    scrollTopMinute: function scrollTopMinute() {
      var mHeight = this.$refs.minuteScroller.scrollHeight;
      var wHeight = this.$refs.minuteScrollerWrapper.clientHeight;
      var top = mHeight * (this.minuteIndex / (this.minutes.length - 1)) - wHeight / 2;
      this.$refs.minuteScroller.scrollTop = top;
    },
    scrollTopHour: function scrollTopHour() {
      var mHeight = this.$refs.hourScroller.scrollHeight;
      var wHeight = this.$refs.hourScrollerWrapper.clientHeight;
      var top = mHeight * (this.hourIndex / (this.hours.length - 1)) - wHeight / 2;
      this.$refs.hourScroller.scrollTop = top;
    },
    changePeriod: function changePeriod() {
      this.period = this.period === AM ? PM : AM;
    },
    calendarClicked: function calendarClicked(event) {
      if (event.target.id !== 'j-hour' && event.target.id !== 'j-minute') {
        this.minuteSelectorVisible = false;
        this.hourSelectorVisible = false;
      }
      event.cancelBubble = true;
      if (event.stopPropagation) {
        event.stopPropagation();
      }
    },
    documentClicked: function documentClicked(event) {
      if (event.target.id !== 'tj-datetime-input') {
        this.hideCal = true;
      }
    },
    toggleCal: function toggleCal() {
      this.hideCal = !this.hideCal;
    },
    setPeriodStyle: function setPeriodStyle() {
      if (this.dateFormat.indexOf('H') !== -1) {
        this.periodStyle = 24;
        this.period = null;
      } else {
        this.periodStyle = 12;
      }
    },
    setDate: function setDate() {
      var d = null;

      this.setPeriodStyle();

      var h = this.hour + '';

      if (this.periodStyle === 12) {
        if (h === '12') {
          h = this.period === AM ? '00' : '12';
        } else if (this.period === PM && parseInt(h) < 12) {
          h = parseInt(h) + 12;
          h = '' + h;
        } else if (this.period === AM && parseInt(h) > 12) {
          h = parseInt(h) - 12;
          h = '' + h;
        }
      }
      d = this.dateFormat;
      d = d.replace('YYYY', this.year);
      d = d.replace('DD', this.day < 10 ? '0' + this.day : this.day);
      var m = this.monthIndex + 1;
      d = d.replace('MM', m < 10 ? '0' + m : m);
      this.minute += '';
      d = d.replace(this.periodStyle === 24 ? 'H' : 'h', h.length < 2 ? '0' + h : '' + h);
      d = d.replace('i', this.minute.length < 2 ? '0' + this.minute : '' + this.minute);
      d = d.replace('s', '00');
      this.$emit('input', d);
      this.date = d;
      this.hideCal = true;
    },

    /**
    `*Creates a date object from a given date string
    */
    makeDateObject: function makeDateObject(val) {
      // handle support for eu date format
      var dateAndTime = val.split(' ');
      var arr = [];
      if (this.format.indexOf('-') !== -1) {
        arr = dateAndTime[0].split('-');
      } else {
        arr = dateAndTime[0].split('/');
      }
      var year = 0;
      var month = 0;
      var day = 0;
      if (this.format.indexOf('DD/MM/YYYY') === 0 || this.format.indexOf('DD-MM-YYYY') === 0) {
        year = arr[2];
        month = arr[1];
        day = arr[0];
      } else if (this.format.indexOf('YYYY/MM/DD') === 0 || this.format.indexOf('YYYY-MM-DD') === 0) {
        year = arr[0];
        month = arr[1];
        day = arr[2];
      } else {
        year = arr[2];
        month = arr[0];
        day = arr[1];
      }

      var date = new Date();
      if (this.hideDate) {
        // time only
        var splitTime = dateAndTime[0].split(':');
        // handle date format without seconds
        var secs = splitTime.length > 2 ? parseInt(splitTime[2]) : 0;
        date.setHours(parseInt(splitTime[0]), parseInt(splitTime[1]), secs, 0);
      } else if (this.hideTime) {
        // date only
        date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      } else {
        // we have both date and time
        var _splitTime = dateAndTime[1].split(':');
        // handle date format without seconds
        var _secs = _splitTime.length > 2 ? parseInt(_splitTime[2]) : 0;
        date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(_splitTime[0]), parseInt(_splitTime[1]), _secs);
      }

      return date;
    },
    clearDate: function clearDate() {
      this.date = '';
      this.$emit('input', '');
      this.toggleCal();
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.value) {
      try {
        this.timeStamp = this.makeDateObject(this.value);

        // set #period (am or pm) based on date hour
        if (this.timeStamp.getHours() >= 12) {
          this.period = PM;
        } else {
          this.period = AM;
        }
      } catch (e) {
        this.timeStamp = new Date();
        console.log(e);
      }
    }

    this.year = this.timeStamp.getFullYear();
    this.monthIndex = this.timeStamp.getMonth();
    this.day = this.timeStamp.getDate();
    this.hour = this.timeStamp.getHours();
    this.hour = this.hour < 10 ? '0' + this.hour : '' + this.hour;
    this.minute = this.timeStamp.getMinutes();
    this.minute = this.minute < 10 ? '0' + this.minute : '' + this.minute;
    this.updateCalendar();
    days.forEach(function (day, idx) {
      _this2.days[(idx - _this2.normalizedFirstDayOfWeek + 7) % 7] = day;
    });
    document.addEventListener('keydown', this.keyIsDown);
    document.addEventListener('click', this.documentClicked);
    // this.setDate()
    this.setPeriodStyle();
  },

  watch: {
    value: function value(newVal, oldVal) {
      if (newVal) {
        this.value = newVal;
        try {
          this.timeStamp = this.makeDateObject(this.value);
        } catch (e) {
          console.warn(e.message + '. Current date is being used.');
          this.timeStamp = new Date();
        }
        this.year = this.timeStamp.getFullYear();
        this.monthIndex = this.timeStamp.getMonth();
        this.day = this.timeStamp.getDate();
        this.hour = this.timeStamp.getHours();
        this.hour = this.hour < 10 ? '0' + this.hour : '' + this.hour;
        this.minute = this.timeStamp.getMinutes();
        this.minute = this.minute < 10 ? '0' + this.minute : '' + this.minute;
        this.updateCalendar();
        this.setDate();
      }
    }
  },
  destroyed: function destroyed() {
    document.removeEventListener('keydown', this.keyIsDown);
    document.removeEventListener('click', this.documentClicked);
  },
  computed: {
    normalizedFirstDayOfWeek: function normalizedFirstDayOfWeek() {
      return parseInt(this.firstDayOfWeek, 10);
    },
    ports: {
      get: function get() {
        var p = [];
        if (this.portsHolder.length === 0) {
          for (var i = 0; i < 42; i++) {
            p.push('');
          }
        } else {
          p = this.portsHolder;
        }
        return p;
      },
      set: function set(newValue) {
        this.portsHolder = newValue;
      }
    },
    month: function month() {
      return this.months[this.monthIndex];
    },
    dateTime: function dateTime() {
      return this.timeStamp.getFullYear() + '-' + (this.timeStamp.getMonth() + 1) + '-' + this.timeStamp.getUTCDay();
    },
    minutes: function minutes() {
      var arr = [];
      for (var i = 0; i < 60; i++) {
        i < 10 ? arr.push('0' + i) : arr.push('' + i);
      }
      return arr;
    },
    hours: function hours() {
      var arr = [];
      if (this.periodStyle === 24) {
        for (var i = 0; i < this.periodStyle; i++) {
          i < 10 ? arr.push('0' + i) : arr.push('' + i);
        }
      } else {
        for (var _i = 1; _i <= this.periodStyle; _i++) {
          _i < 10 ? arr.push('0' + _i) : arr.push('' + _i);
        }
      }
      return arr;
    },
    dateFormat: function dateFormat() {
      var f = 'YYYY-MM-DD h:i:s';
      var allowedFormats = ['YYYY-MM-DD h:i:s', 'DD-MM-YYYY h:i:s', 'MM-DD-YYYY h:i:s', 'YYYY-MM-DD h:i', 'DD-MM-YYYY h:i', 'MM-DD-YYYY h:i', 'YYYY-MM-DD H:i:s', 'DD-MM-YYYY H:i:s', 'MM-DD-YYYY H:i:s', 'YYYY-MM-DD H:i', 'DD-MM-YYYY H:i', 'MM-DD-YYYY H:i', 'YYYY-MM-DD', 'DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY/MM/DD', 'DD/MM/YYYY', 'MM/DD/YYYY', 'h:i:s', 'H:i:s', 'h:i', 'H:i', 'YYYY/MM/DD h:i:s', 'DD/MM/YYYY h:i:s', 'MM/DD/YYYY h:i:s', 'YYYY/MM/DD h:i', 'DD/MM/YYYY h:i', 'MM/DD/YYYY h:i', 'YYYY/MM/DD H:i:s', 'DD/MM/YYYY H:i:s', 'MM/DD/YYYY H:i:s', 'YYYY/MM/DD H:i', 'DD/MM/YYYY H:i', 'MM/DD/YYYY H:i'];
      if (this.format) {
        f = this.format;
      }
      if (allowedFormats.indexOf(f) < 0) {
        console.warn('Invalid date format supplied. Current default date format is being used.');
        // return default date format if date format is invalid
        return 'YYYY-MM-DD h:i:s';
      } else {
        return f;
      }
    },
    hideTime: function hideTime() {
      return this.dateFormat.indexOf('h:i:s') === -1 && this.dateFormat.indexOf('H:i:s') === -1 && this.dateFormat.indexOf('h:i') === -1 && this.dateFormat.indexOf('H:i') === -1;
    },
    hideDate: function hideDate() {
      return this.dateFormat === 'h:i:s' || this.dateFormat === 'H:i:s' || this.dateFormat === 'h:i' || this.dateFormat === 'H:i';
    }
  }
};

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Session__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_Layout__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layouts_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_FluidLayout__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_FluidLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layouts_FluidLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layouts_PublicLayout__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layouts_PublicLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_layouts_PublicLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layouts_DashboardLayout__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layouts_DashboardLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_layouts_DashboardLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Configuration__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layouts_EmptyLayout__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layouts_EmptyLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_layouts_EmptyLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_Notification__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_Notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_Notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_layouts_partials_Modals__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_layouts_partials_Modals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_layouts_partials_Modals__);


//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  metaInfo: function metaInfo() {
    return {
      title: "Admin",
      titleTemplate: "%s | " + this.favIcoAndTitle["title"]
    };
  },

  components: {
    Layout: __WEBPACK_IMPORTED_MODULE_3__components_layouts_Layout___default.a,
    PublicLayout: __WEBPACK_IMPORTED_MODULE_5__components_layouts_PublicLayout___default.a,
    FluidLayout: __WEBPACK_IMPORTED_MODULE_4__components_layouts_FluidLayout___default.a,
    EmptyLayout: __WEBPACK_IMPORTED_MODULE_8__components_layouts_EmptyLayout___default.a,
    Modals: __WEBPACK_IMPORTED_MODULE_10__components_layouts_partials_Modals___default.a,
    DashboardLayout: __WEBPACK_IMPORTED_MODULE_6__components_layouts_DashboardLayout___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_Notification___default.a
  },
  mounted: function mounted() {
    this.setLayout();
    this.setUserLocaleByPlan(this.currentPlanIsTalent);
    this.setFavIcoAndTitle();
    __WEBPACK_IMPORTED_MODULE_2__classes_Session__["a" /* default */].init();
    this.is_ready = true;
    this.userInit();
  },
  data: function data() {
    return {
      is_ready: false,
      layout: ""
    };
  },

  computed: {
    favIcoAndTitle: function favIcoAndTitle() {
      return this.$store.getters.getFavIcoAndTitle;
    },
    current_user: function current_user() {
      return this.$store.getters.currentUser;
    },
    intercomSettingsHash: function intercomSettingsHash() {
      return this.$store.getters.getIntercomSettings;
    },
    intercomInitialized: function intercomInitialized() {
      return this.$store.getters.getIntercomInitialized;
    },
    mainClasses: function mainClasses() {
      return this.$store.getters.getMainContainerClasses;
    },
    currentPlanIsTalent: function currentPlanIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent;
    }
  },
  methods: {
    setFavIcoAndTitle: function setFavIcoAndTitle() {
      var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.favIcoAndTitle["ico"];
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    hideIntercom: function hideIntercom() {
      window.Intercom("shutdown");
    },
    initIntercom: function initIntercom() {
      if (!this.intercomSettingsHash) {
        return;
      }
      if (!this.intercomInitialized) {
        window.Intercom("boot", this.intercomSettingsHash);
        this.$store.commit("SET_INTERCOM_INITIALIZED", true);
      } else {
        window.Intercom("update", this.intercomSettingsHash);
      }
    },
    login: function login() {
      if (this.current_user) {
        this.layout = "classic";
      } else {
        this.layout = "public";
      }
    },
    logout: function logout() {
      window.Intercom("shutdown");
      if (this.current_user) {
        this.layout = "classic";
      } else {
        this.layout = "public";
      }
    },
    userInit: function userInit() {
      // Just for having the '/login' in url if not connected
      if (!this.current_user && this.layout !== "public") {
        this.$router.push("/login");
        location.reload();
      }
      // Unallow logged in users to view public pages
      if (this.current_user && this.layout == "public") {
        this.layout = "classic";
        this.$router.push("/");
      }
    },
    setLanguage: function setLanguage(locale) {
      this.$store.commit("CHANGE_LANGUAGE", locale);
    },

    // If the users current plan is talent we need to use specific language files
    // If user has talent language in cookies but plan is not talent we need to fix the locale
    setUserLocaleByPlan: function setUserLocaleByPlan(planIsTalent) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var currentLocale, locale, localeIsTalent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return cookie.get("language");

              case 2:
                currentLocale = _context.sent;
                locale = currentLocale ? currentLocale : "de";
                localeIsTalent = locale.includes("-tal");

                // If current plan is talent but locale is not we force it

                if (planIsTalent && !localeIsTalent) {
                  locale = locale + "-tal";
                } else if (!planIsTalent && localeIsTalent) {
                  // If current plan is not talent but locale is we force it
                  locale = "de";
                }

                _this.setLanguage(locale);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setLayout: function setLayout() {
      var layout = this.$route.meta.layout;
      if (layout) {
        this.layout = layout;
      } else {
        this.layout = "classic";
      }
    }
  },
  watch: {
    $route: function $route() {
      this.setLayout();
    },
    current_user: function current_user(value) {
      if (value && !this.currentPlanIsTalent) {
        this.initIntercom();
      } else {
        this.hideIntercom();
      }
    },
    currentPlanIsTalent: function currentPlanIsTalent(value) {
      if (typeof value === "boolean") {
        this.setUserLocaleByPlan(value);
      }
    }
  }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Auth__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_User_js__ = __webpack_require__(33);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default.a },
  metaInfo: function metaInfo() {
    return {
      title: this.$t("ui.meta_info.invitation")
    };
  },
  data: function data() {
    return {
      password: '',
      password_confirmation: '',
      firstname: '',
      lastname: '',
      success: false,
      error: '',
      token: '',
      userFoundByToken: Boolean
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.token = this.$route.params.token;

    var userApi = new __WEBPACK_IMPORTED_MODULE_2__api_User_js__["a" /* default */]();
    userApi.getUserDetailsByToken(this.token).then(function (item) {
      _this.userFoundByToken = true;
      _this.firstname = item['resource']['firstname'];
      _this.lastname = item['resource']['lastname'];
    }).catch(function (e) {
      _this.userFoundByToken = false;
    });
  },

  methods: {
    checkFields: function checkFields() {
      var _this2 = this;

      var auth = new __WEBPACK_IMPORTED_MODULE_1__api_Auth__["a" /* default */]();
      this.errros = [];
      if (this.firstname === '' || this.firstname === null) {
        this.$store.commit('SET_NOTIFICATION', {
          'title': this.$t('errors.authentication.empty_firstname'),
          'type': 'error'
        });
      } else if (this.lastname === '' || this.lastname === null) {
        this.$store.commit('SET_NOTIFICATION', {
          'title': this.$t('errors.authentication.empty_lastname'),
          'type': 'error'
        });
      } else if (this.password == this.password_confirmation) {
        if (this.password === '' || this.password === null) {
          this.$store.commit('SET_NOTIFICATION', {
            'title': this.$t('errors.authentication.empty_password'),
            'type': 'error'
          });
        } else if (!this.validatePassword(this.password)) {
          this.$store.commit('SET_NOTIFICATION', {
            'title': this.$t('errors.authentication.wrong_password'),
            'type': 'error'
          });
        } else {
          this.error = null;
          auth.confirmAccount(this.token, this.password, this.password_confirmation, this.firstname, this.lastname, this.$i18n.locale).then(function (result) {
            _this2.success = true;
          }).catch(function (e) {
            _this2.error = e.response.data.errors[0];
          });
        }
      } else {
        this.$store.commit('SET_NOTIFICATION', {
          'title': this.$t('errors.authentication.wrong_password_confirmation'),
          'type': 'error'
        });
      }
    },
    validatePassword: function validatePassword(password) {
      if (password.length < 8) {
        return false;
      }
      var numberRegex = /[0-9]/;
      if (!numberRegex.test(password)) {
        return false;
      }
      var letterRegex = /[a-z]/;
      if (!letterRegex.test(password)) {
        return false;
      }
      return true;
    }
  }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Logo__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordResetRequest__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordResetRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordResetRequest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Auth__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Session__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_FormSwitch__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_FormSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_FormSwitch__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field___default.a,
    PasswordResetRequest: __WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordResetRequest___default.a,
    FormSwitch: __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_FormSwitch___default.a,
    Logo: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Logo___default.a
  },
  metaInfo: {
    title: 'Login'
  },
  data: function data() {
    return {
      email: '',
      password: '',
      remember_me: false,
      error: '',
      source: 'classic',
      icon: '\u2022'
    };
  },

  computed: {
    placeholder: function placeholder() {
      return this.icon.repeat(8);
    }
  },
  mounted: function mounted() {
    if (this.$route.query) {
      this.source = this.$route.query.source;
    }
    if (this.source === 'logout') {
      this.$store.commit('SET_NOTIFICATION', {
        'title': this.$t('errors.authentication.logout'),
        'type': 'success'
      });
      __WEBPACK_IMPORTED_MODULE_6__classes_Session__["a" /* default */].logout();
      this.$emit('logout');
    }
  },

  methods: {
    passwordReset: function passwordReset() {
      this.mode = "request_password_reset";
    },
    login: function login() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var auth;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                auth = new __WEBPACK_IMPORTED_MODULE_5__api_Auth__["a" /* default */]();


                auth.auth(_this.email, _this.password).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                    var user;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            user = null;

                            if (_this.remember_me) {
                              user = __WEBPACK_IMPORTED_MODULE_6__classes_Session__["a" /* default */].login(response.data.jwt_token, 7);
                            } else {
                              user = __WEBPACK_IMPORTED_MODULE_6__classes_Session__["a" /* default */].login(response.data.jwt_token);
                            }

                            _this.$emit('login');
                            _this.$router.push({ name: 'home' });

                          case 4:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (e) {
                  console.log(e);
                  _this.error = e.response.data.errors[0];
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Auth__ = __webpack_require__(175);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default.a },
  metaInfo: function metaInfo() {
    return {
      title: this.$t("ui.meta_info.reset_password")
    };
  },
  data: function data() {
    return {
      password: '',
      password_confirmation: '',
      success: false,
      error: '',
      token: ''
    };
  },
  mounted: function mounted() {
    this.token = this.$route.params.token;
  },

  methods: {
    resetPassword: function resetPassword() {
      var _this = this;

      var auth = new __WEBPACK_IMPORTED_MODULE_1__api_Auth__["a" /* default */]();
      this.errros = [];
      if (this.password == this.password_confirmation) {
        if (this.password == '') {
          this.error = { code: 'authentication.empty_password' };
        } else if (!this.validatePassword(this.password)) {
          this.error = { code: 'authentication.wrong_password' };
        } else {
          this.error = null;
          auth.resetPassword(this.token, this.password, this.password_confirmation, this.$i18n.locale).then(function (result) {
            _this.success = true;
          }).catch(function (e) {
            _this.error = e.response.data.errors[0];
          });
        }
      } else {
        this.error = { code: 'authentication.wrong_password_confirmation' };
      }
    },
    validatePassword: function validatePassword(password) {
      if (password.length < 8) {
        return false;
      }
      var numberRegex = /[0-9]/;
      if (!numberRegex.test(password)) {
        return false;
      }
      var letterRegex = /[a-z]/;
      if (!letterRegex.test(password)) {
        return false;
      }
      return true;
    }
  }
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Auth__ = __webpack_require__(175);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default.a,
    Logo: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: this.$t("ui.meta_info.reset_password")
    };
  },
  data: function data() {
    return {
      email: '',
      error: '',
      success: false
    };
  },

  methods: {
    resetPassword: function resetPassword() {
      var _this = this;

      var auth = new __WEBPACK_IMPORTED_MODULE_2__api_Auth__["a" /* default */]();
      if (!this.validateEmail(this.email)) {
        this.error = { code: "authentication.wrong_email" };
        return false;
      }
      auth.requestResetPassword(this.email, this.$i18n.locale).then(function (result) {
        _this.success = true;
      }).catch(function (e) {
        _this.error = e.response.data.errors[0];
      });
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  This component is an expandable accordion that can contain another Vue component.
  It's used like this:

  <accordion :defaultActive="true" :overwriteActive="accordionOneActive" title="ui.project_wizard.step2-invite-users" @click="accordionClick()">
    <component :is="accordionOne"></component>
  </accordion>
  <accordion :overwriteActive="accordionTwoActive" title="ui.project_wizard.step2-assign-users" @click="accordionClick()">
    <component :is="accordionTwo" v-bind="objectTwoProps"></component>
  </accordion>
*/

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    defaultActive: {
      type: Boolean
    },
    overwriteActive: {
      type: Boolean
    },
    title: {
      type: String
    }
  },
  data: function data() {
    return {
      active: false
    };
  },

  watch: {
    overwriteActive: function overwriteActive() {
      this.active = this.overwriteActive;
    }
  },
  mounted: function mounted() {
    if (this.defaultActive) {
      this.active = this.defaultActive;
    }
  },

  methods: {
    handleClick: function handleClick() {
      this.active = !this.active;
      this.$emit('click');
    }
  }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Company_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Organization_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Api_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field__);


var _name$components$prop;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var defaultClass = "autocomplete-results";

/* harmony default export */ __webpack_exports__["default"] = (_name$components$prop = {
  name: "autocomplete",
  components: { Field: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field___default.a },
  props: {
    item: Object,
    lead_id: "",
    newLabel: String,
    name: String,
    model: String,
    init: {
      // WTF does this do?
      type: String,
      default: "none"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    acMinCharacters: {
      type: Number,
      default: 4
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    label: String,
    isAsync: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      results: [],
      assocFields: [],
      companyFields: {},
      projectFields: {},
      items: [],
      arrowCounter: 0,
      initCompanyName: "",
      classes: [defaultClass, "hidden"],
      search: "",
      searched: "",
      fireCounter: 0,
      focused: false
    };
  },

  computed: {
    initialValue: function initialValue() {
      return this.item[this.name];
    }
  },
  mounted: function mounted() {
    this.addListeners();
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$debouncedMethod = _.debounce(this.autoComplete, 400, {
      leading: true
    });
    this.close();
    this.autoCompleteComp = "";
  },
  updated: function updated() {
    if (!this.autoCompleteComp) {
      this.close();
    }
    if (this.autoCompleteComp) {
      if (this.autoCompleteComp.length < this.acMinCharacters) {
        this.close();
      } else if (this.autoCompleteComp.length > this.acMinCharacters && this.fireCounter > 1) {}
    }
  },
  destroyed: function destroyed() {
    this.destroyListeners();
  },

  methods: {
    debouncer: function debouncer(item) {
      if (item) {
        if (item.length < this.acMinCharacters) {
          this.results = [];
          this.close();
        }
      }
      // Uses lodash debounce method from a variable in the mounted hook to stop the user firing more queries than required
      if (item && item.length >= this.acMinCharacters) {
        this.$debouncedMethod(item);
      }
    },
    autoComplete: function autoComplete(search) {
      var _this = this;

      // stops query being fired on load of component
      if (this.searched != search) {
        if (this.fireCounter > 0 || this.search == "") {
          this.autoCompleteApi(search).then(function (items) {
            _this.results = items;
            _this.open();
            _this.fireCounter++;
            if (items.length < 1) {
              _this.close();
            }
          });
        }
      }
    },
    autoCompleteApi: function autoCompleteApi(search) {
      this.query = {};
      this.query.query = search;

      if (this.model == "organization-projects") {
        return new __WEBPACK_IMPORTED_MODULE_3__api_Organization_js__["a" /* default */]().projectsList(this.$store.state.current_user.organization_id, { search: search });
      } else if (this.model == "organization-companies") {
        return new __WEBPACK_IMPORTED_MODULE_3__api_Organization_js__["a" /* default */]().companiesList(this.$store.state.current_user.organization_id, { search: search });
      } else {
        return new __WEBPACK_IMPORTED_MODULE_4__api_Api_js__["a" /* default */]().searchAutoComplete(this.query, this.query.search);
      }
    },
    close: function close() {
      this.classes = defaultClass + " hidden";
    },
    focus: function focus() {
      this.focus = !this.focus;
    },
    open: function open() {
      this.classes = defaultClass;
    },
    handleEvent: function handleEvent(event) {
      // If it's a string we simply set this.search equal and continue.
      if (event != undefined) {
        this.search = event;
      }
    },
    filterResultsBySearch: function filterResultsBySearch() {
      var _this2 = this;

      if (!this.item[this.name]) {
        this.results = this.items;
        return;
      }
      this.results = this.items.filter(function (company) {
        return company.name.toString().toLowerCase().includes(_this2.item[_this2.name].toString().toLowerCase());
      });
    },
    emitResult: function emitResult(result) {
      // Go into Vuex when we at some point switch to that
      this.$emit("change", result);
      this.populateFields(result);
      this.close();
    },
    populateFields: function populateFields(result) {
      var resulty = result;

      if (this.model == "organization-projects") {
        this.projectFields.name = resulty.name;
        this.$emit("populate-fields", this.projectFields);
      } else if (this.model == "organization-companies") {
        this.companyFields.name = resulty.name;
        this.$emit("populate-fields", this.companyFields);
      } else {
        this.companyFields.city = resulty.city;
        this.companyFields.country = resulty.country;
        this.companyFields.company_website = resulty.website;
        this.companyFields.phone_company = resulty.phone_company;
        this.companyFields.company = resulty.name;
        this.companyFields.zip = resulty.zip;
        this.companyFields.street = resulty.street;
        this.companyFields.street_number = resulty.street_number;
        this.$emit("populate-fields", this.companyFields);
      }
    },
    setResult: function setResult(result) {
      this.search = result.name;
      this.$emit("change", result);
      this.close();
    },
    onArrowDown: function onArrowDown(evt) {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp: function onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter: function onEnter() {
      this.search = this.results[this.arrowCounter];
      this.close();
      this.arrowCounter = -1;
    },
    handleClickOutside: function handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.close();
        this.arrowCounter = -1;
      }
    },
    initResults: function initResults() {
      // Set results equal to items
      this.results = this.items;
    },
    addListeners: function addListeners() {
      document.addEventListener("click", this.handleClickOutside);
    },
    destroyListeners: function destroyListeners() {
      document.removeEventListener("click", this.handleClickOutside);
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "computed", {
  autoCompleteComp: {
    set: function set(val) {
      if (!this.initCompanyName) {
        this.search = val;
        this.close();
      } else if (val.length < this.acMinCharacters) this.results = [];
    },
    get: function get() {
      return this.init;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "watch", {
  initCompanyName: function initCompanyName() {
    return this.init;
  },
  autoCompleteComp: function autoCompleteComp() {
    if (this.autoCompleteComp < this.acMinCharacters) {
      this.close();
    }
  }
}), _name$components$prop);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CollectionValue__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CollectionValue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CollectionValue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_Specific_Loading_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collection',
  components: {
    CollectionValue: __WEBPACK_IMPORTED_MODULE_0__CollectionValue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_1__components_helpers_Specific_Loading_vue___default.a
  },
  data: function data() {
    return {
      sortKey: '',
      reverse: true
    };
  },

  props: {
    structure: {},
    data: {},
    params: {},
    model: String,
    loading: Boolean,
    has_searched: Boolean
  },
  computed: {
    sortedData: function sortedData() {
      if (_.get(this, 'params.global_sorting') == true) {
        return this.data;
      }
      if (this.sortKey == '') {
        return this.data;
      } else {
        return this.data ? this.data.sort(this.dynamicSort(this.sortKey)) : [];
      }
    }
  },
  mounted: function mounted() {
    this.initOrder();
  },

  watch: {
    params: {
      deep: true,
      handler: function handler() {
        this.initOrder();
      }
    }
  },
  methods: {
    searchBarPresent: function searchBarPresent() {
      this.$route.name !== "projects" && this.$route.name !== "project_leads";
    },
    collectionPresent: function collectionPresent() {
      return this.sortedData && this.sortedData.length > 0;
    },
    noResultsHandler: function noResultsHandler() {
      return this.has_searched && this.sortedData.length == 0;
    },
    loadingCollection: function loadingCollection() {
      if (this.searchBarPresent()) {
        return !this.has_searched && this.data.length == 0;
      }
    },
    initOrder: function initOrder() {
      if (_.get(this, 'params.sort_by')) {
        this.sortKey = this.params.sort_by;
      }
      if (_.get(this, 'params.sort_order')) {
        this.reverse = this.params.sort_order == 'DESC';
      }
    },
    sortBy: function sortBy(sortKey) {
      this.reverse = this.sortKey == sortKey ? !this.reverse : false;
      this.sortKey = sortKey;
      if (_.get(this, 'params.global_sorting') == true) {
        var sort_order = this.reverse ? 'DESC' : 'ASC';
        this.$emit('sorting', { sort_by: sortKey, sort_order: sort_order });
      }
    },
    dynamicSort: function dynamicSort(property) {
      var sortOrder = this.reverse ? -1 : 1;
      return function (a, b) {
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    itemDelete: function itemDelete(item) {
      this.$emit('itemDelete', item);
    },
    classes: function classes(column) {
      return ['value', this.model + '-' + column.name];
    },
    textToShow: function textToShow(item, column) {
      var output = void 0;

      if (this.column.type != 'edit') {
        try {
          output = eval('item.' + this.column.name);
        } catch (e) {
          if (e instanceof SyntaxError) {
            console.log(e.message);
          }
        }
      }
      return output;
    }
  }
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CollectionValues_CollectionValueShow__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CollectionValues_CollectionValueShow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CollectionValues_CollectionValueShow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CollectionValues_CollectionValueShowWithLink__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CollectionValues_CollectionValueShowWithLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CollectionValues_CollectionValueShowWithLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollectionValues_CollectionValueShowWithEditLink__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollectionValues_CollectionValueShowWithEditLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CollectionValues_CollectionValueShowWithEditLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CollectionValues_CollectionValueCrudAction__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CollectionValues_CollectionValueCrudAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CollectionValues_CollectionValueCrudAction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollectionValues_CollectionValueCrudActionFolded__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollectionValues_CollectionValueCrudActionFolded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CollectionValues_CollectionValueCrudActionFolded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CollectionValues_CollectionValueShowAction__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CollectionValues_CollectionValueShowAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CollectionValues_CollectionValueShowAction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CollectionValues_CollectionValueEditAction__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CollectionValues_CollectionValueEditAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CollectionValues_CollectionValueEditAction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CollectionValues_CollectionValueDeleteAction__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CollectionValues_CollectionValueDeleteAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CollectionValues_CollectionValueDeleteAction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CollectionValues_CollectionValueStatus__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CollectionValues_CollectionValueStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__CollectionValues_CollectionValueStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CollectionValues_CollectionValueLeadName__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CollectionValues_CollectionValueLeadName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__CollectionValues_CollectionValueLeadName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CollectionValues_CollectionValuePeriod__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CollectionValues_CollectionValuePeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CollectionValues_CollectionValuePeriod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CollectionValues_CollectionValueClassification__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CollectionValues_CollectionValueClassification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CollectionValues_CollectionValueClassification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CollectionValues_CollectionValueProgress__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CollectionValues_CollectionValueProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__CollectionValues_CollectionValueProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CollectionValues_CollectionValueDate__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CollectionValues_CollectionValueDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CollectionValues_CollectionValueDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CollectionValues_CollectionValueUnassign__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CollectionValues_CollectionValueUnassign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CollectionValues_CollectionValueUnassign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CollectionValues_CollectionValueProjectName__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CollectionValues_CollectionValueProjectName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__CollectionValues_CollectionValueProjectName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CollectionValues_CollectionValueUnsyncedCount__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CollectionValues_CollectionValueUnsyncedCount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__CollectionValues_CollectionValueUnsyncedCount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CollectionValues_CollectionValueCrmStatus__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CollectionValues_CollectionValueCrmStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__CollectionValues_CollectionValueCrmStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CollectionValues_CollectionValueOrigin__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CollectionValues_CollectionValueOrigin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__CollectionValues_CollectionValueOrigin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CollectionValues_CollectionValueImportOrigin__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CollectionValues_CollectionValueImportOrigin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__CollectionValues_CollectionValueImportOrigin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CollectionValues_CollectionValueCompany__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CollectionValues_CollectionValueCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__CollectionValues_CollectionValueCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CollectionValues_CollectionValueActionDuplicate__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CollectionValues_CollectionValueActionDuplicate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__CollectionValues_CollectionValueActionDuplicate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CollectionValues_CollectionValueProjectLink__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CollectionValues_CollectionValueProjectLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__CollectionValues_CollectionValueProjectLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CollectionValues_CollectionValueValidEmail__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CollectionValues_CollectionValueValidEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__CollectionValues_CollectionValueValidEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__CollectionValues_CollectionValueFullname__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__CollectionValues_CollectionValueFullname___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__CollectionValues_CollectionValueFullname__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CollectionValues_CollectionValueFormSlug__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CollectionValues_CollectionValueFormSlug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__CollectionValues_CollectionValueFormSlug__);
//
//
//
//
//
//
//
//
//
//
//
//
//




























/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model', 'params'],
  components: {
    CollectionValueShow: __WEBPACK_IMPORTED_MODULE_0__CollectionValues_CollectionValueShow___default.a,
    CollectionValueShowWithLink: __WEBPACK_IMPORTED_MODULE_1__CollectionValues_CollectionValueShowWithLink___default.a,
    CollectionValueShowWithEditLink: __WEBPACK_IMPORTED_MODULE_2__CollectionValues_CollectionValueShowWithEditLink___default.a,
    CollectionValueShowAction: __WEBPACK_IMPORTED_MODULE_5__CollectionValues_CollectionValueShowAction___default.a,
    CollectionValueCrudAction: __WEBPACK_IMPORTED_MODULE_3__CollectionValues_CollectionValueCrudAction___default.a,
    CollectionValueCrudActionFolded: __WEBPACK_IMPORTED_MODULE_4__CollectionValues_CollectionValueCrudActionFolded___default.a,
    CollectionValueEditAction: __WEBPACK_IMPORTED_MODULE_6__CollectionValues_CollectionValueEditAction___default.a,
    CollectionValueDeleteAction: __WEBPACK_IMPORTED_MODULE_7__CollectionValues_CollectionValueDeleteAction___default.a,
    CollectionValueStatus: __WEBPACK_IMPORTED_MODULE_8__CollectionValues_CollectionValueStatus___default.a,
    CollectionValueLeadName: __WEBPACK_IMPORTED_MODULE_9__CollectionValues_CollectionValueLeadName___default.a,
    CollectionValuePeriod: __WEBPACK_IMPORTED_MODULE_10__CollectionValues_CollectionValuePeriod___default.a,
    CollectionValueClassification: __WEBPACK_IMPORTED_MODULE_11__CollectionValues_CollectionValueClassification___default.a,
    CollectionValueProgress: __WEBPACK_IMPORTED_MODULE_12__CollectionValues_CollectionValueProgress___default.a,
    CollectionValueDate: __WEBPACK_IMPORTED_MODULE_13__CollectionValues_CollectionValueDate___default.a,
    CollectionValueUnassign: __WEBPACK_IMPORTED_MODULE_14__CollectionValues_CollectionValueUnassign___default.a,
    CollectionValueProjectName: __WEBPACK_IMPORTED_MODULE_15__CollectionValues_CollectionValueProjectName___default.a,
    CollectionValueUnsyncedCount: __WEBPACK_IMPORTED_MODULE_16__CollectionValues_CollectionValueUnsyncedCount___default.a,
    CollectionValueCrmStatus: __WEBPACK_IMPORTED_MODULE_17__CollectionValues_CollectionValueCrmStatus___default.a,
    CollectionValueOrigin: __WEBPACK_IMPORTED_MODULE_18__CollectionValues_CollectionValueOrigin___default.a,
    CollectionValueImportOrigin: __WEBPACK_IMPORTED_MODULE_19__CollectionValues_CollectionValueImportOrigin___default.a,
    CollectionValueCompany: __WEBPACK_IMPORTED_MODULE_20__CollectionValues_CollectionValueCompany___default.a,
    CollectionValueActionDuplicate: __WEBPACK_IMPORTED_MODULE_21__CollectionValues_CollectionValueActionDuplicate___default.a,
    CollectionValueProjectLink: __WEBPACK_IMPORTED_MODULE_22__CollectionValues_CollectionValueProjectLink___default.a,
    CollectionValueValidEmail: __WEBPACK_IMPORTED_MODULE_23__CollectionValues_CollectionValueValidEmail___default.a,
    CollectionValueFullname: __WEBPACK_IMPORTED_MODULE_24__CollectionValues_CollectionValueFullname___default.a,
    CollectionValueFormSlug: __WEBPACK_IMPORTED_MODULE_25__CollectionValues_CollectionValueFormSlug___default.a
  },
  methods: {
    itemDelete: function itemDelete(item) {
      this.$emit('itemDelete', item);
    }
  },
  computed: {
    classes: function classes() {
      return ['value', this.model + '-' + this.column.name];
    },
    subComponent: function subComponent() {
      var type = this.column.type === undefined ? "Show" : _.upperFirst(_.camelCase(this.column.type));
      return _.kebabCase("CollectionValue " + type);
    }
  }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventBus_js__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  methods: {
    duplicate: function duplicate() {
      var event_name = this.model + '_duplicate';
      // @TODO: add name feature here
      var payload = { id: this.item.id };
      __WEBPACK_IMPORTED_MODULE_0__EventBus_js__["a" /* EventBus */].$emit(event_name, payload);
    }
  }
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    value: function value() {
      return eval('this.item.' + this.column.name);
    }
  }
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model']
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    computedClass: function computedClass() {
      var classes = ["sensual-badge"];
      var status = this.item.sync_status;
      if (this.item.sync_disabled) {
        classes.push('grey-dark');
      } else if (status === 'not_synced') {
        classes.push('yellow');
      } else if (status === 'not_sync_ready') {
        classes.push('grey');
      } else if (status === 'sync_ready') {
        classes.push('indigo');
      } else if (status === 'processing') {
        classes.push('blue');
      } else if (status === 'sync_error') {
        classes.push('red');
      } else if (status === 'synced') {
        classes.push('green');
      }
      return classes;
    },
    label: function label() {
      if (this.item.sync_disabled) {
        return 'sync_disabled';
      }
      return this.item.sync_status;
    }
  }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CollectionValueShowAction__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CollectionValueShowAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CollectionValueShowAction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CollectionValueEditAction__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CollectionValueEditAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CollectionValueEditAction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollectionValueDeleteAction__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollectionValueDeleteAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CollectionValueDeleteAction__);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  components: {
    CollectionValueShowAction: __WEBPACK_IMPORTED_MODULE_0__CollectionValueShowAction___default.a,
    CollectionValueEditAction: __WEBPACK_IMPORTED_MODULE_1__CollectionValueEditAction___default.a,
    CollectionValueDeleteAction: __WEBPACK_IMPORTED_MODULE_2__CollectionValueDeleteAction___default.a
  },
  computed: {
    exclude: function exclude() {
      if (this.column.exclude) {
        return this.column.exclude;
      } else {
        return [];
      }
    }
  }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_Modal__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus_js__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'model', 'column', 'duplicateDescriptionText'],
  components: { Modal: __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_Modal___default.a },
  computed: {
    renderDuplicateDescriptionText: function renderDuplicateDescriptionText() {
      return this.duplicateDescriptionText || this.$t('models.duplicate_desc');
    },
    showRouteParams: function showRouteParams() {
      return { name: this.model + '_show', params: { id: this.item.id } };
    },
    editRouteParams: function editRouteParams() {
      if (this.model === "project_lead") {
        return { name: this.model + '_edit', params: { project_id: this.item.user_id, lead_id: this.item.id } };
      } else {
        return { name: this.model + '_edit', params: { id: this.item.id } };
      }
    },
    exclude: function exclude() {
      if (this.column.exclude) {
        return this.column.exclude;
      } else {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },

  methods: {
    duplicate: function duplicate() {
      var event_name = this.model + '_duplicate';
      // @TODO: add name feature here
      var payload = { id: this.item.id };
      __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].$emit(event_name, payload);
    },
    outsideClick: function outsideClick() {
      this.visible = false;
    },
    toggleVisible: function toggleVisible() {
      this.visible = !this.visible;
    },
    action: function action(name) {
      if (name === "valid") {
        this.$emit('itemDelete', this.item);
      }
    }
  }
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    value: function value() {
      var value = eval('this.item.' + this.column.name);
      if (value === undefined) {
        return "–";
      }
      if (this.column.relative) {
        return moment(value).fromNow();
      } else if (this.column.time) {
        return moment(value).format("DD.MM.YYYY HH:mm:ss");
      } else {
        return moment(value).format("DD.MM.YYYY");
      }
    }
  }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_Modal__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_Modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["item", "model", "column"],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_Modal___default.a
  },
  methods: {
    action: function action(name) {
      if (name === "valid") {
        this.$emit("itemDelete", this.item);
      }
    }
  },
  computed: {
    routeParams: function routeParams() {
      return { name: this.model + "_delete", params: { id: this.item.id } };
    }
  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'model', 'column'],
  computed: {
    routeParams: function routeParams() {
      return { name: this.model + '_edit', params: { id: this.item.id } };
    }
  }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config__ = __webpack_require__(83);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  data: function data() {
    return {
      formUrl: __WEBPACK_IMPORTED_MODULE_0__config_config__["b" /* formUrl */]
    };
  },

  computed: {
    value: function value() {
      return eval('this.item.' + this.column.name);
    },
    url: function url() {
      return __WEBPACK_IMPORTED_MODULE_0__config_config__["b" /* formUrl */] + 'form/' + this.value;
    }
  }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    fullname: function fullname() {
      return this.item.firstname + ' ' + this.item.lastname;
    }
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    value: function value() {
      return eval('this.item.' + this.column.name);
    },
    icon: function icon() {
      if (this.value == 'crm') {
        return "assignment";
      }
    }
  }
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_GetUrlQueries__ = __webpack_require__(234);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'structure', 'model', 'params'],
  methods: {
    getLeadPathWithQueries: function getLeadPathWithQueries(project_id, lead_id) {
      var url_queries = __WEBPACK_IMPORTED_MODULE_0__classes_GetUrlQueries__["a" /* default */].urlQueries(this.$route.query);
      return '/' + this.$t("routes.project") + '/' + project_id + '/' + this.$t("routes.project_leads") + '/' + lead_id + '/edit' + url_queries;
    }
  },

  computed: {
    companyFunction: function companyFunction() {
      if (_.get(this.column, 'lead_mask.company_function.params.no_i18n')) {
        var allowed_values = _.get(this.column, 'lead_mask.company_function.allowed_values');
        if (allowed_values) {
          var index = _.findIndex(allowed_values, { 'value': this.item.company_function });
          if (allowed_values[index]) {
            return allowed_values[index].name;
          } else {
            return '';
          }
        } else {
          return '';
        }
      } else {
        if (this.$t('models.select_company_function.' + this.item.company_function).includes("models.select_company_function")) return this.item.company_function;else return this.$t('models.select_company_function.' + this.item.company_function);
      }
    }
  }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    value: function value() {
      return eval('this.item.' + this.column.name);
    },
    icon: function icon() {
      if (this.value == 'mobile_app') {
        return "phone_iphone";
      } else if (this.value == 'web_app') {
        return "cloud";
      }
    }
  }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    value: function value() {
      var str = "";
      if (this.start_date) {
        str += this.start_date;
        if (this.end_date) {
          str += ' - ' + this.end_date;
        }
        return str;
      } else {
        return '';
      }
    },
    start_date: function start_date() {
      if (this.item.start_date) {
        return moment(this.item.start_date, "YYYY MM DD").format("DD/MM/YY");
      } else {
        return false;
      }
    },
    end_date: function end_date() {
      if (this.item.end_date) {
        return moment(this.item.end_date, "YYYY MM DD").format("DD/MM/YY");
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  components: { ProgressBar: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar___default.a },
  computed: {
    value: function value() {
      return parseFloat(eval('this.item.' + this.column.name)) * 100;
    }
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    routeParams: function routeParams() {
      return { name: 'project_show', params: { id: this.item.project_id } };
    }
  }
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    routeParams: function routeParams() {
      return { name: this.model + '_show', params: { id: this.item.id } };
    }
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    value: function value() {
      if (this.column.i18n) {
        return this.$t('models.' + this.model + '.collection.' + this.column.name + '.' + this.item[this.column.name]);
      } else {
        var shouldEvaluate = true;
        var _this = this;
        var splitValues = this.column.name.split('.');

        if (splitValues.length > 1) {
          var splitValue = void 0;

          splitValues.forEach(function (split, index) {
            if (shouldEvaluate) {
              splitValue = eval('_this.item.' + splitValues.slice(0, index + 1).join('.'));

              if (!splitValue) shouldEvaluate = false;
            }
          });
        }

        if (shouldEvaluate) {
          return eval('this.item.' + this.column.name);
        }
      }
    }
  }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'model', 'column'],
  computed: {
    routeParams: function routeParams() {
      return { name: this.model + '_show', params: { id: this.item.id } };
    }
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    value: function value() {
      return eval('this.item.' + this.column.name);
    },
    routeParams: function routeParams() {
      return { name: this.model + '_edit', params: { id: this.item.id } };
    }
  }
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    value: function value() {
      return eval('this.item.' + this.column.name);
    },
    routeParams: function routeParams() {
      return { name: this.model + '_show', params: { id: this.item.id } };
    }
  }
});

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    computedClass: function computedClass() {
      var classes = ["sensual-badge"];
      if (this.value == 'active' || this.value == 'confirmed') {
        classes.push('green');
      } else if (this.value == 'review') {
        classes.push('yellow');
      } else if (this.value == 'pre_review') {
        classes.push('red');
      } else if (this.value == 'inactive' || this.value == 'unconfirmed') {
        classes.push('grey');
      } else if (this.value == 'pending') {
        classes.push('blue');
      }
      return classes;
    },
    value: function value() {
      return eval('this.item.' + this.column.name);
    }
  }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["item", "model", "column"],
  components: {},
  methods: {
    unassign: function unassign() {
      this.$emit("itemDelete", this.item);
    }
  },
  computed: {
    routeParams: function routeParams() {
      return { name: this.model + "_delete", params: { id: this.item.id } };
    }
  }
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    computedClass: function computedClass() {
      var classes = ["sensual-badge"];
      if (this.value > 0) {
        classes.push('yellow');
      } else {
        classes.push('green');
      }
      return classes;
    },
    value: function value() {
      return eval('this.item.' + this.column.name);
    }
  }
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'column', 'model'],
  computed: {
    value: function value() {
      return eval('this.item.' + this.column.name);
    },
    classes: function classes() {
      if (this.isValid()) {
        return 'is-valid';
      } else {
        return 'is-not-valid';
      }
    }
  },
  methods: {
    isValid: function isValid() {
      if (this.item.has_valid_email) {
        return true;
      } else if (typeof this.item.has_valid_email == 'undefined') {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: {
    contact: Object
  },
  data: function data() {
    return {};
  },

  methods: {
    userInitials: function userInitials() {
      if (this.contact.firstname && this.contact.lastname) {
        return this.contact.firstname.charAt(0) + this.contact.lastname.charAt(0);
      } else if (this.contact.firstname) {
        return this.contact.firstname.charAt(0);
      } else if (this.contact.lastname) {
        return this.contact.lastname.charAt(0);
      } else if (this.contact.company.email) {
        return this.contact.company.email.charAt(0);
      } else {
        return '?';
      }
    }
  }
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value']
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CrawledInfo__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CrawledInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CrawledInfo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {}
  },
  components: { CrawledInfo: __WEBPACK_IMPORTED_MODULE_0__CrawledInfo___default.a },
  computed: {
    data: function data() {
      if (this.item.meta_information != undefined) {
        if (this.item.meta_information.clearbit != undefined) {
          return this.item.meta_information.clearbit.content.company;
        }
      } else {
        return {};
      }
    },
    tags: function tags() {
      return this.data.tags.join(', ');
    },
    phoneNumbers: function phoneNumbers() {
      return this.data.site.phoneNumbers.join(' ');
    },
    category: function category() {
      var str = '';
      if (this.data.category.sector) {
        str += this.data.category.sector + ', ';
      }
      if (this.data.category.industryGroup) {
        str += this.data.category.industryGroup + ', ';
      }
      if (this.data.category.industry) {
        str += this.data.category.industry + ', ';
      }
      if (this.data.category.subIndustry) {
        str += this.data.category.subIndustry;
      }
      return str;
    }
  },

  methods: {
    has: function has(obj, key) {
      return _.get(obj, key);
    }
  }
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chartist__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chartist__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['series', 'total'],
  methods: {
    init: function init() {
      var labels = this.labels();
      if (labels.length > 0) {
        new __WEBPACK_IMPORTED_MODULE_0_chartist___default.a.Pie(this.$refs.donut_chart, {
          series: this.series,
          labels: labels
        }, {
          donut: true,
          donutWidth: 55,
          donutSolid: true,
          startAngle: 270,
          showLabel: true
        });
      }
    },
    labels: function labels() {
      var labels = [];
      var series = this.series;
      var total = this.total;
      series.forEach(function (number, key) {
        if (number === undefined) {
          return false;
        }
        if (number === 0) {
          labels[key] = " ";
        } else {
          var result = number / total * 100;
          labels[key] = Math.round(result) + "%";
        }
      });
      return labels;
    }
  },
  mounted: function mounted() {
    this.init();
  },

  computed: {},
  watch: {
    series: function series() {
      this.init();
    }
  }
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_AddButton_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_AddButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_AddButton_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AddButton: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_AddButton_vue___default.a
  },
  props: {
    name: {
      type: String,
      default: 'default'
    },
    heading: {
      type: String
    },
    subtitle: {
      type: String
    },
    button: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      imageSrc: __webpack_require__(2044)("./empty-" + this.name + '.svg')
    };
  }
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_AddButton_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_AddButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_AddButton_vue__);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AddButton: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_AddButton_vue___default.a
  },
  props: {
    name: {
      type: String,
      default: "default"
    },
    heading: {
      type: String
    },
    subtitle: {
      type: String
    },
    button: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      imageSrc: __webpack_require__(342)("./" + this.name + ".svg")
    };
  }
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Company__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_NewModal_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_NewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_NewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_company_svg__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_company_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_company_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_companies_CompanyEdit_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_companies_CompanyEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_companies_CompanyEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_XTable__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_XTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_XTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__classes_Permission__ = __webpack_require__(12);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XTable: __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_XTable___default.a, Modal: __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_NewModal_vue___default.a, CompanyCreate: __WEBPACK_IMPORTED_MODULE_8__components_pages_companies_CompanyEdit_vue___default.a },
  props: {
    refresh: {
      type: [Number, Boolean],
      default: 0
    }
  },
  data: function data() {
    return {
      companies: [],
      company: {},
      Api: new __WEBPACK_IMPORTED_MODULE_4__api_Company__["a" /* default */](),
      searchKeywords: "",
      loading: false,
      totalCount: 0,
      defaultPagination: {},
      columns: [{
        name: "name",
        field: function field(company) {
          return company.name;
        },
        label: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t("ui.company.columns.name"),
        required: true,
        isLink: true,
        isBold: true,
        hideByDefault: false,
        icon: __WEBPACK_IMPORTED_MODULE_7__assets_company_svg___default.a
      }, {
        name: "id",
        label: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t("ui.company.columns.id"),
        field: function field(company) {
          return company.id;
        },
        credentials: "root",
        hideByDefault: __WEBPACK_IMPORTED_MODULE_10__classes_Permission__["a" /* default */].isRoot() ? false : true
      }, {
        name: "website",
        label: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t("ui.company.columns.website"),
        field: function field(company) {
          return company.website;
        },
        isLink: true,
        isUrl: true,
        hideByDefault: false
      }, {
        name: "created_at",
        field: function field(company) {
          return company.created_at;
        },
        label: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t("ui.company.columns.created"),
        type: "dateTime",
        hideByDefault: false
      }, {
        name: "updated_at",
        field: function field(company) {
          return company.updated_at;
        },
        type: "dateTime",
        label: __WEBPACK_IMPORTED_MODULE_6__i18n__["a" /* default */].t("ui.company.columns.updated"),
        hideByDefault: false
      }]
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },

  methods: {
    updatePagination: function updatePagination(pagination) {
      // We just respond to the updatePagination event so that we
      // get the whole default pagination, including any XTable defaults
      this.defaultPagination = pagination;
    },
    updateSearch: function updateSearch(searchkeywords) {
      this.searchKeywords = searchkeywords;
      this.$emit("updateSearch", searchkeywords);
    },
    emitTotalTableCount: function emitTotalTableCount(totalTableCount) {
      this.$emit("emitTotalTableCount", totalTableCount);
    },
    fetchData: function fetchData() {
      var _this = this;

      var fetchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var request, requestResponse;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Build the API request
                if (fetchParams.searchKeywords) {
                  _this.searchKeywords = fetchParams.searchKeywords;
                }

                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(fetchParams.searchFilters) == "object" && fetchParams.searchFilters) {
                  _this.searchFilters = fetchParams.searchFilters;
                }

                request = {
                  search: _this.searchKeywords,
                  page: _this.defaultPagination.page,
                  per_page: _this.defaultPagination.rowsPerPage,
                  sort_by: _this.defaultPagination.sortBy,
                  sort_order: _this.defaultPagination.descending ? "DESC" : "ASC"
                };


                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(fetchParams.pagination) == "object" && fetchParams.pagination) {
                  request.per_page = fetchParams.pagination.rowsPerPage;
                  request.sort_by = fetchParams.pagination.sortBy;
                  request.sort_order = fetchParams.pagination.descending ? "DESC" : "ASC";
                }

                _this.loading = true;

                // Make the request
                requestResponse = null;
                _context.prev = 6;
                _context.next = 9;
                return _this.Api.getAllCompanies(request);

              case 9:
                requestResponse = _context.sent;

              case 10:
                _context.prev = 10;

                _this.loading = false;
                _this.$emit("fetchDataComplete");
                return _context.finish(10);

              case 14:

                // Display both the returned company page and the total number of companies
                _this.companies = requestResponse.data.resources;
                _this.totalCount = requestResponse.data.total_results;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[6,, 10, 14]]);
      }))();
    },
    clickCell: function clickCell(id, fieldName) {
      if (fieldName == "name") {
        this.$router.push({ path: "/company/" + id });
      }
    }
  },
  watch: {
    refresh: {
      handler: function handler() {
        this.fetchData();
      }
    }
  }
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Contacts__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_Segments__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_Project__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_contacts_ChangeCompany_vue__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_contacts_ChangeCompany_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_contacts_ChangeCompany_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_helpers_DataDisplay_XTable__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_helpers_DataDisplay_XTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_helpers_DataDisplay_XTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__classes_Permission__ = __webpack_require__(12);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    refresh: {
      type: [Number, Boolean],
      default: 0
    },
    segment: {
      type: Object,
      default: function _default() {
        return {
          filters: {},
          search: ""
        };
      }
    },
    filtersFromParams: {
      type: [Object, Boolean],
      default: false
    },
    mode: {
      type: String,
      default: "contacts" // contacts or segment
    },
    tableSettingsName: {
      type: String,
      default: "contacts" // contacts or segment
    }
  },
  components: { XTable: __WEBPACK_IMPORTED_MODULE_12__components_helpers_DataDisplay_XTable___default.a, Modal: __WEBPACK_IMPORTED_MODULE_13__components_helpers_Layout_NewModal___default.a, ChangeCompany: __WEBPACK_IMPORTED_MODULE_10__components_pages_contacts_ChangeCompany_vue___default.a },
  data: function data() {
    return {
      contactsApi: new __WEBPACK_IMPORTED_MODULE_7__api_Contacts__["a" /* default */](),
      segmentsApi: new __WEBPACK_IMPORTED_MODULE_8__api_Segments__["a" /* default */](),
      projectsApi: new __WEBPACK_IMPORTED_MODULE_9__api_Project__["a" /* default */](),
      contacts: [],
      selectedIdCount: 0,
      deleteContactsModalOpen: false,
      currentSelectedIds: [],
      searchKeywords: this.segment.search,
      searchFilters: this.segment.filters,
      loading: false,
      payload: 0,
      totalCount: 0,
      companyChangeOpen: false,
      defaultPagination: {},
      filterDefinitions: [{
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.project.label"),
        attribute: "project_name",
        type: "text",
        predicate: "eq",
        include_none: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.project.none"),
        auto_complete: "organization-projects"
      }, {
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.gender.label"),
        attribute: "gender",
        type: "set",
        predicate: "eq",
        options: [{
          name: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.gender.options.male"),
          value: "male"
        }, {
          name: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.gender.options.female"),
          value: "female"
        }],
        include_none: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.general.none")
      }, {
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.language.label"),
        attribute: "language",
        type: "set",
        predicate: "eq",
        options: [{
          name: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.language.options.de"),
          value: "de"
        }, {
          name: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.language.options.en"),
          value: "en"
        }],
        include_none: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.general.none")
      }, {
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.invalid_email.label"),
        condition_label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.invalid_email.condition_label"),
        attribute: "has_invalid_email",
        type: "set",
        predicate: "eq",
        options: [{
          name: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.invalid_email.options.valid"),
          value: false
        }, {
          name: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.invalid_email.options.not_valid"),
          value: true
        }]
      }, {
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.company.label"),
        attribute: "company_id",
        type: "text",
        predicate: "eq",
        include_none: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.company.none"),
        auto_complete: "organization-companies",
        match_by_id: true
      }, {
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.created.label"),
        attribute: "created_at",
        type: "date"
      }, {
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.updated.label"),
        attribute: "updated_at",
        type: "date"
      }, {
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.city.label"),
        attribute: "city",
        type: "text",
        predicate: "eq",
        include_none: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.general.none")
      }, {
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.country.label"),
        attribute: "country",
        type: "set",
        predicate: "eq",
        include_none: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.general.none")
      }],
      defaultProjectFilterDefinitions: [{
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.tags.label"),
        attribute: "tags",
        type: "set",
        method: "chips",
        predicate: ["has_any", "has_all"],
        default_predicate: "has_any",
        include_none: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.general.none")
      }, {
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.classification.label"),
        attribute: "classification",
        type: "set",
        predicate: "has_any",
        options: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.classification.options"),
        include_none: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.filters.general.none")
      }],
      // This is a hash, because we may eventually support multiple projects in the search
      projectFilterDefinitions: {},
      actions: this.getActions(),
      columns: [{
        name: "contact_name",
        field: function field(contact) {
          return contact.name;
        },
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.columns.name"),
        required: true,
        isLink: true,
        isSticky: true,
        isBold: true,
        hideByDefault: false
      }, {
        name: "id",
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.columns.id"),
        field: function field(contact) {
          return contact.id;
        },
        credentials: "root",
        hideByDefault: __WEBPACK_IMPORTED_MODULE_14__classes_Permission__["a" /* default */].isRoot() ? false : true
      },
      // company_name is removed if plan is talent
      {
        name: "company_name",
        field: function field(contact) {
          return contact.company ? contact.company.name : "";
        },
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.columns.company"),
        isBold: true,
        isLink: true,
        hideByDefault: false
      }, {
        name: "created_at",
        field: function field(contact) {
          return contact.created_at;
        },
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.columns.created"),
        type: "dateTime",
        hideByDefault: false
      }, {
        name: "updated_at",
        field: function field(contact) {
          return contact.updated_at;
        },
        type: "dateTime",
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.columns.updated"),
        hideByDefault: false
      }, {
        name: "source",
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.columns.source"),
        field: function field(contact) {
          return __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contact.sources." + contact.source);
        },
        hideByDefault: true
      }, {
        name: "contact_email",
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.columns.email"),
        type: "email",
        field: function field(contact) {
          return contact.email;
        },
        hideByDefault: false
      }, {
        name: "gender",
        label: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].t("ui.contacts.columns.gender"),
        field: function field(contact) {
          return contact.gender;
        },
        hideByDefault: true
      }]
    };
  },
  beforeMount: function beforeMount() {
    if (!_.isEmpty(this.filtersFromParams && this.filtersFromParams.group)) {
      this.segment.filters = this.filtersFromParams;
    }
    this.addLeadSheetConditions();
  },
  mounted: function mounted() {
    this.fetchData();
  },

  methods: {
    filteredColumns: function filteredColumns(columns) {
      // filter copmany_name column if plan is talent
      if (this.$store.getters.getCurrentPlanIsTalent) {
        columns = columns.filter(function (column) {
          return column.name !== "company_name";
        });
      }
      return columns;
    },
    getActions: function getActions() {
      var actions = [{
        name: this.$t("ui.contacts.actions.export"),
        function: this.actionExport
      }];
      // For now, these are only included when in the context of the segment page,
      // because these two actions are defined there. They should be moved into this vue.
      if (this.mode == "segment") {
        actions = actions.concat([{
          name: this.$t("ui.contacts.actions.send_businesskit"),
          function: this.actionSendBusinesskit
        }, {
          name: this.$t("ui.contacts.actions.save_to_project"),
          function: this.actionAddToProject
        }]);
      }
      if (this.mode == "contacts") {
        actions = actions.concat([{
          name: this.$t("ui.contacts.actions.update_company"),
          selectedOnly: true,
          class: "contact-action",
          function: this.bulkAddToCompany
        }, {
          name: this.$t("ui.contacts.actions.delete"),
          separator: true,
          selectedOnly: true,
          class: "contact-action-delete",
          function: this.warnActionDelete
        }]);
      }
      return actions;
    },
    updatePagination: function updatePagination(pagination) {
      // We just respond to the updatePagination event so that we
      // get the whole default pagination, including any XTable defaults
      this.defaultPagination = pagination;
    },
    emitId: function emitId(payload) {
      this.$emit("companyId", payload);
      this.companyChangeOpen = false;
    },
    bulkAddToCompany: function bulkAddToCompany() {
      var _this = this;

      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.companyChangeOpen = true;
                _this.currentSelectedIds = ids;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getFilterDefinitions: function getFilterDefinitions() {
      // Add any project-specific filters as sub-menus
      // For now, we just add them directly to the filter list menu
      // But when we support multiple project filters, they can
      // be made available as fly-out menus
      var additional = [];

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.projectFilterDefinitions).forEach(function (defs) {
        additional = additional.concat(defs);
      });

      if (additional.length > 0) {
        // Add a separator above the first one
        additional[0].separator = true;
      } else {
        additional = [{
          label: this.$t("ui.contacts.filters.custom_placeholder"),
          disabled: true,
          separator: true
        }];
      }

      return this.filterDefinitions.concat(additional);
    },
    showCompanyChange: function showCompanyChange(bool) {
      this.companyChangeOpen = bool;
    },
    getStandardFilterAttributes: function getStandardFilterAttributes() {
      return this.filterDefinitions.map(function (def) {
        return def.attribute;
      });
    },
    openModalBulk: function openModalBulk() {
      this.openModalBulk = true;
    },
    convertLeadSheetToConditions: function convertLeadSheetToConditions(projectId, dependsOnId, leadSheet) {
      var _this2 = this;

      var standardFilterAttributes = this.getStandardFilterAttributes();
      var conditions = {};

      // First, add default project flter definitions
      var defaultsConditions = _.cloneDeep(this.defaultProjectFilterDefinitions);
      defaultsConditions.forEach(function (newCondition) {
        newCondition.depends_on = dependsOnId;
        newCondition.static = {
          project_id: projectId
        };
        conditions[newCondition.label] = newCondition;
      });

      // Then, add the filters defined by the project lead sheet
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(leadSheet.structure).forEach(function (item) {
        var isContainer = /^container/.test(item.element_type);
        var exists = standardFilterAttributes.includes(item.name);

        if (isContainer == false && exists == false) {
          // Basic condition parameters
          var newCondition = {
            label: item.label,
            attribute: item.name,
            type: "text",
            predicate: "eq",
            include_none: _this2.$t("ui.contacts.filters.general.none"),
            depends_on: dependsOnId,
            static: {
              project_id: projectId
            }
          };

          // Type-specific parameters
          if (["select", "radio", "radio_custom"].includes(item.element_type)) {
            newCondition = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(newCondition, {
              type: "set",
              options: []
            });
            item.allowed_values.forEach(function (option) {
              newCondition.options.push({
                name: option.name,
                value: option.value
              });
            });
          } else if (["country_select"].includes(item.element_type)) {
            // For country, we don't need to include options,
            // because the country-select field already includes them
            newCondition = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(newCondition, {
              type: "set"
            });
          } else if (["checkbox", "checkbox_custom"].includes(item.element_type)) {
            newCondition = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(newCondition, {
              type: "set",
              predicate: "in",
              options: []
            });
            item.allowed_values.forEach(function (option) {
              newCondition.options.push({
                name: option.name,
                value: option.value
              });
            });
          } else if (["text", "textarea"].includes(item.element_type)) {
            // No additional parameters
          } else if (["free_drawing", "drawing", "title", "crawled_info", "readonly"].includes(item.element_type)) {
            // Ignore these
            newCondition = null;
          } else {
            console.warn("Unsupported attribute type", item.element_type, item);
            newCondition = null;
          }

          if (newCondition != null) {
            conditions[item.label] = newCondition;
          }
        }
      });

      // Sort by attribute label
      var ordered = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(conditions).sort().forEach(function (label) {
        ordered[label] = conditions[label];
      });

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(ordered);
    },
    addLeadSheetConditions: function addLeadSheetConditions() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var projectConditions, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, projectName, projectCondition, projectId, condId, leadSheet, remaining;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof _this3.searchFilters.group == "undefined")) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:

                // Get a list of all project name conditions
                projectConditions = [];

                _this3.searchFilters.group.conditions.forEach(function (cond) {
                  if (cond.attribute == "project_name" && cond.predicate != "has_none") {
                    projectConditions[cond.value] = cond;
                  }
                });

                // Find any that are new, and load their corresponding lead sheet as additional filter conditions
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 7;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(projectConditions));

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 22;
                  break;
                }

                projectName = _step.value;

                if (!(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this3.projectFilterDefinitions).includes(projectName) == false)) {
                  _context2.next = 19;
                  break;
                }

                projectCondition = projectConditions[projectName];
                projectId = projectCondition.value_id;
                condId = projectCondition.id;
                _context2.next = 17;
                return _this3.projectsApi.lead_mask(projectId);

              case 17:
                leadSheet = _context2.sent;

                _this3.projectFilterDefinitions[projectName] = _this3.convertLeadSheetToConditions(projectId, condId, leadSheet);

              case 19:
                _iteratorNormalCompletion = true;
                _context2.next = 9;
                break;

              case 22:
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](7);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 28:
                _context2.prev = 28;
                _context2.prev = 29;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 31:
                _context2.prev = 31;

                if (!_didIteratorError) {
                  _context2.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context2.finish(31);

              case 35:
                return _context2.finish(28);

              case 36:

                // Drop any that are no longer included in the conditions
                remaining = {};

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this3.projectFilterDefinitions).forEach(function (name) {
                  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(projectConditions).includes(name)) {
                    remaining[name] = _this3.projectFilterDefinitions[name];
                  }
                });

                _this3.projectFilterDefinitions = remaining;

              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[7, 24, 28, 36], [29,, 31, 35]]);
      }))();
    },
    updateFilters: function updateFilters(filters) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.searchFilters = filters;
                _context3.next = 3;
                return _this4.addLeadSheetConditions();

              case 3:
                _this4.$emit("updateFilters", _this4.searchFilters);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    updateSearch: function updateSearch(searchkeywords) {
      this.searchKeywords = searchkeywords;
      this.$emit("updateSearch", searchkeywords);
    },
    selectedItemsChange: function selectedItemsChange(selectedItems) {
      this.$emit("selectedItemsChange", selectedItems);
      this.selectedIdCount = selectedItems.length;
    },
    emitTotalTableCount: function emitTotalTableCount(totalTableCount) {
      this.$emit("emitTotalTableCount", totalTableCount);
    },
    openDeleteContactsModal: function openDeleteContactsModal() {
      this.deleteContactsModalOpen = true;
    },
    closeDeleteContactsModal: function closeDeleteContactsModal() {
      this.deleteContactsModalOpen = false;
      this.currentSelectedIds = [];
    },
    warnActionDelete: function warnActionDelete() {
      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.openDeleteContactsModal();
      this.currentSelectedIds = ids;
    },
    actionDelete: function actionDelete() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var ids, results;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                ids = _this5.currentSelectedIds;
                _context4.next = 3;
                return _this5.contactsApi.delete(ids);

              case 3:
                results = _context4.sent;


                if (results.summary.num_failed == 0) {
                  _this5.$store.commit("SET_NOTIFICATION", {
                    title: "ui.segments.delete.success",
                    type: "success"
                  });
                } else {
                  _this5.$store.commit("SET_NOTIFICATION", {
                    title: "ui.segments.delete.error",
                    type: "error"
                  });
                }

                _this5.closeDeleteContactsModal();

                if (!(results.summary.num_succeeded > 0)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 9;
                return _this5.fetchData();

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    actionExport: function actionExport() {
      var _this6 = this;

      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this6.contactsApi.exportContacts({
                  contact_ids: ids,
                  contact_filters: _this6.searchFilters,
                  search: _this6.searchKeywords
                });

              case 2:
                response = _context5.sent;


                if (response.status == 200) {
                  _this6.$store.commit("SET_NOTIFICATION", {
                    title: "ui.segments.export.success",
                    type: "success"
                  });
                } else {
                  _this6.$store.commit("SET_NOTIFICATION", {
                    title: "ui.segments.export.error",
                    type: "error"
                  });
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    actionSendBusinesskit: function actionSendBusinesskit() {
      var _this7 = this;

      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.$emit("activateBusinessKitModal", ids);

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    actionAddToProject: function actionAddToProject() {
      var _this8 = this;

      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.$emit("activateAddToProjectModal", ids);

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    fetchData: function fetchData() {
      var _this9 = this;

      var fetchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var filters, request, requestResponse;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // Build the API request
                if (fetchParams.searchKeywords) {
                  _this9.searchKeywords = fetchParams.searchKeywords;
                }

                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(fetchParams.searchFilters) == "object" && fetchParams.searchFilters) {
                  _this9.searchFilters = fetchParams.searchFilters;
                }

                filters = _.cloneDeep(_this9.searchFilters);


                if (Array.isArray(_.get(filters, "group.conditions"))) {
                  filters.group.conditions = filters.group.conditions.map(function (condition) {
                    if (condition.definition.match_by_id === true) {
                      condition.value = condition.value_id;
                    }

                    // Remove attributes which the API does not use
                    delete condition.definition;
                    delete condition.id;
                    delete condition.depends_on;
                    delete condition.value_id;

                    return condition;
                  });
                }

                request = {
                  search: _this9.searchKeywords,
                  contact_filters: filters,
                  page: _this9.defaultPagination.page,
                  per_page: _this9.defaultPagination.rowsPerPage,
                  sort_by: _this9.defaultPagination.sortBy,
                  sort_order: _this9.defaultPagination.descending ? "DESC" : "ASC"
                };


                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(fetchParams.pagination) == "object" && fetchParams.pagination) {
                  request.per_page = fetchParams.pagination.rowsPerPage;
                  request.sort_by = fetchParams.pagination.sortBy;
                  request.sort_order = fetchParams.pagination.descending ? "DESC" : "ASC";
                }

                _this9.loading = true;

                // Make the request
                requestResponse = null;
                _context8.prev = 8;
                _context8.next = 11;
                return _this9.contactsApi.getAllContacts(request);

              case 11:
                requestResponse = _context8.sent;

              case 12:
                _context8.prev = 12;

                _this9.loading = false;
                _this9.$emit("fetchDataComplete");
                return _context8.finish(12);

              case 16:

                // Display both the returned contacts page and the total number of contacts
                _this9.contacts = requestResponse.data.resources;
                _this9.totalCount = requestResponse.data.total_results;

              case 18:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this9, [[8,, 12, 16]]);
      }))();
    },
    clickCell: function clickCell(id, fieldName) {
      if (fieldName == "contact_name") {
        this.$router.push({ path: "/contact/" + id });
      }
      if (fieldName == "company_name") {
        // Find the company ID for this contact ID
        var contact = this.contacts.find(function (contact) {
          return contact.id == id;
        });
        if ((typeof contact === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(contact)) == "object" && _.get(contact, "company.id", null) != null) {
          this.$router.push({ path: "/company/" + contact.company.id });
        }
      }
    }
  },
  watch: {
    refresh: {
      handler: function handler() {
        this.fetchData();
      }
    }
  }
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["percentage"],
  computed: {
    rotation: function rotation() {
      return this.percentage / 200;
    }
  }
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_PopOver__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_PopOver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_PopOver__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    popperOptions: {
      type: Object,
      default: {}
    },
    size: {
      type: String
    }
  },
  components: {
    PopOver: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_PopOver___default.a
  },
  computed: {
    popperOptionsComputed: function popperOptionsComputed() {
      return {
        content: this.popperOptions.content,
        options: this.popperOptions
      };
    }
  }
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  This component is rendered always from App.vue. This means that any component in the app can add a notification to the store
  and it will automatically be displayed. A max of 5 notifications can be displayed at the same time. Any excess notifications are ignored.
  Add a notification like so:

  this.$store.commit('SET_NOTIFICATION', {
    'title': 'models.project_lead.found_existing', // Required
    'type': 'success',                             // Optional - defaults to info
    'duration_ms': 6000,                           // Optional - defaults to 50ms per character with a minimum of 4500ms and maximum of 7500ms
    'classes': ['cssClass1', 'cssClass2']          // Optional - extra CSS classes
  })
*/
/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    notifications: function notifications() {
      return this.$store.getters.getNotifications;
    }
  },
  watch: {
    notifications: {
      handler: function handler() {
        if (this.notifications.length > 0) {
          this.setCloseAutomaticallyTimeouts();
        }
      }
    }
  },
  methods: {
    close: function close(notification) {
      var _this = this;

      var dom_element = this.$refs[notification.id][0];
      if (dom_element) {
        dom_element.classList.add('closed');
        // For some reason we have to remove the older animation
        dom_element.classList.remove('animateOpen');
        setTimeout(function () {
          _this.$store.commit('SET_NOTIFICATION_CLOSED', notification.id);
        }, 700);
      }
    },
    setCloseAutomaticallyTimeouts: function setCloseAutomaticallyTimeouts() {
      var _this2 = this;

      // Close notifications automatically after max duration is reached
      this.notifications.forEach(function (notification) {
        if (notification.duration_ms > 0) {
          setTimeout(function () {
            _this2.close(notification);
            clearTimeout();
          }, notification.duration_ms);
        }
      });
    },
    isStatic: function isStatic(notification) {
      return notification.duration_ms === 0;
    },
    classes: function classes(notification) {
      var classes = [notification.type, notification.classes];
      if (this.isStatic(notification)) {
        classes.push('is-static');
      } else {
        classes.push('is-flash');
      }
      return classes;
    }
  }
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_popperjs__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_popperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_popperjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          options: {
            placement: 'top'
          }
        };
      }
    }
  },
  components: {
    Popper: __WEBPACK_IMPORTED_MODULE_0_vue_popperjs___default.a
  },
  computed: {
    optionsComputed: function optionsComputed() {
      var options = _.cloneDeep(this.options.options);
      if (!options.modifiers) {
        options.modifiers = {
          offset: {
            offset: '0,5px',
            arrow: '0,5px'
          }
        };
      }
      if (!options.placement) {
        options.placement = 'top';
      }
      return {
        'data-value': this.options.content,
        'visible-arrow': true,
        options: options
      };
    }
  }
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: String,
    percentage: Number,
    isMini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    advancement: function advancement() {
      if (this.percentage <= 0) {
        return "progress-bar-empty";
      } else if (this.percentage < 40) {
        return "progress-bar-low";
      } else if (this.percentage >= 40 && this.percentage <= 59) {
        return "progress-bar-middle1";
      } else if (this.percentage >= 60 && this.percentage <= 75) {
        return "progress-bar-middle";
      } else {
        return "progress-bar-high";
      }
    }
  }
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Contacts__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Project__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataDisplay_AutoComplete__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataDisplay_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_DataDisplay_AutoComplete__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Modal: __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_NewModal___default.a, Field: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field___default.a, AutoComplete: __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataDisplay_AutoComplete___default.a },
  props: {
    segment: {
      type: Object,
      default: {}
    },
    addToProjectModalOpen: {
      type: Boolean,
      default: false
    },
    contactIds: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      projects: [],
      project: {
        id: null,
        value: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.retrieveProjects();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    selectProject: function selectProject(value) {
      this.project.id = value.id;
      this.project.value = value.name;
    },
    retrieveProjects: function retrieveProjects() {
      var _this2 = this;

      var projectApi = new __WEBPACK_IMPORTED_MODULE_3__api_Project__["a" /* default */]();

      projectApi.getAll().then(function (result) {
        var projects = [];

        result.resources.forEach(function (p) {
          projects.push({
            "name": p.name,
            "value": p.id
          });
        });

        _this2.projects = projects;
      });
    },
    closeAddToProjectModalOpen: function closeAddToProjectModalOpen() {
      this.project = {
        id: null,
        value: ''
      }, this.$emit('closeAddToProjectModal');
    },
    addToProject: function addToProject() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var contactsApi, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                contactsApi = new __WEBPACK_IMPORTED_MODULE_2__api_Contacts__["a" /* default */]();
                _context2.next = 3;
                return contactsApi.addToProject({
                  projectId: _this3.project.id,
                  segmentId: _this3.segment.id,
                  organizationId: _this3.segment.organization.id,
                  contactIds: _this3.contactIds
                });

              case 3:
                response = _context2.sent;


                if (response.status == 204) {
                  _this3.closeAddToProjectModalOpen();

                  _this3.$store.commit("SET_NOTIFICATION", {
                    title: "ui.segments.add_to_project.success",
                    type: "success",
                    duration_ms: 0
                  });
                } else {
                  _this3.closeAddToProjectModalOpen();

                  _this3.$store.commit("SET_NOTIFICATION", {
                    title: "ui.segments.add_to_project.error",
                    type: "error",
                    duration_ms: 0
                  });
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Contacts__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_BusinessKit__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Modal: __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_NewModal___default.a, Field: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_Field___default.a },
  props: {
    segment: {
      type: Object,
      default: {}
    },
    sendBusinessKitModalOpen: {
      type: Boolean,
      default: false
    },
    contactIds: {
      type: Array,
      default: []
    },
    totalTableCount: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      businessKits: [],
      selectedBusinessKitId: null,
      selectedBusinessKitUrl: '',
      emailTemplatesChecked: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.retrieveBusinessKits();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    contactsCount: function contactsCount() {
      if (this.contactIds.length) {
        return this.contactIds.length;
      }

      return this.totalTableCount;
    }
  },
  methods: {
    selectBusinessKit: function selectBusinessKit(val) {
      this.selectedBusinessKitId = val;

      var selectedBusinessKit = this.businessKits.find(function (bk) {
        return bk.value == val;
      });

      if (selectedBusinessKit) {
        this.selectedBusinessKitUrl = selectedBusinessKit.url;
      }
    },
    retrieveBusinessKits: function retrieveBusinessKits() {
      var _this2 = this;

      var businessKitApi = new __WEBPACK_IMPORTED_MODULE_3__api_BusinessKit__["a" /* default */]();

      businessKitApi.all({ disable_pagination: 'true' }).then(function (_ref) {
        var resources = _ref.resources;

        var businessKits = [];

        resources.forEach(function (bk) {
          businessKits.push({
            "name": bk.name,
            "value": bk.id,
            "url": bk.preview_url
          });
        });

        _this2.businessKits = businessKits;
      });
    },
    closeSendBusinessKitModalOpen: function closeSendBusinessKitModalOpen() {
      this.$emit('closeBusinessKitModal');
    },
    sendBusinessKits: function sendBusinessKits() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var contactsApi, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                contactsApi = new __WEBPACK_IMPORTED_MODULE_2__api_Contacts__["a" /* default */]();
                _context2.next = 3;
                return contactsApi.sendBusinessKits({
                  businessKitId: _this3.selectedBusinessKitId,
                  projectName: _this3.segment.name,
                  segmentId: _this3.segment.id,
                  organizationId: _this3.segment.organization.id,
                  contactIds: _this3.contactIds
                });

              case 3:
                response = _context2.sent;


                if (response.status == 204) {
                  _this3.closeSendBusinessKitModalOpen();

                  _this3.$store.commit("SET_NOTIFICATION", {
                    title: "ui.segments.business_kit.success",
                    type: "success"
                  });
                } else {
                  _this3.closeSendBusinessKitModalOpen();

                  _this3.$store.commit("SET_NOTIFICATION", {
                    title: "ui.segments.business_kit.error",
                    type: "error"
                  });
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_PopOver__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_PopOver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_PopOver__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    color: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    popperOptions: {
      type: Object,
      default: null
    }
  },
  components: {
    PopOver: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_PopOver___default.a
  },
  computed: {
    popperOptionsComputed: function popperOptionsComputed() {
      if (!this.popperOptions) {
        return {};
      }
      return {
        content: this.popperOptions.content,
        options: this.popperOptions
      };
    },
    computedClasses: function computedClasses() {
      var classes = ["sensual-badge"];
      if (this.color === 'yellow') {
        classes.push('yellow');
      } else if (this.color === 'green') {
        classes.push('green');
      } else if (this.color === 'red') {
        classes.push('red');
      } else if (this.color === 'grey') {
        classes.push('grey');
      } else if (this.color === 'grey-dark') {
        classes.push('grey-dark');
      } else if (this.color === 'dark') {
        classes.push('dark');
      } else if (this.color === 'indigo') {
        classes.push('indigo');
      } else if (this.color === 'blue') {
        classes.push('blue');
      }
      return classes;
    }
  }
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  This modal appears if the API has run into a submodel problem that it can't intelligently solve by itself
  so user input is needed.
*/
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    error: Object,
    includeCtaButton: Boolean,
    ctaButtonText: String,
    listItems: Array,
    title: String,
    caption: String,
    choice: {
      selected: false,
      choiceBoxClass: []
    }
  },
  data: function data() {
    return {
      buttonClasses: [],
      selected: false
    };
  },

  computed: {
    choices: function choices() {
      if (this.error.meta_data) {
        return this.error.meta_data;
      } else {
        return {};
      }
    }
  },
  methods: {
    resolve: function resolve(choice) {
      // Resolve chosen item to parent
      this.buttonClasses.push('is-loading');
      this.$emit('resolve', false, choice);
    },
    resolveCta: function resolveCta() {
      this.$emit('resolve', true, {});
    }
  }
});

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_XFilter__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_XFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_XFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_helpers_DataInput_Field__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XFilter: __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_XFilter___default.a, Modal: __WEBPACK_IMPORTED_MODULE_10__components_helpers_Layout_NewModal___default.a, Field: __WEBPACK_IMPORTED_MODULE_11__components_helpers_DataInput_Field___default.a },
  name: "XTable",
  props: {
    title: {
      type: String,
      required: true,
      default: "xtable"
    },
    columns: {
      type: Array,
      required: true
    },
    rowKey: {
      type: String,
      default: "id"
    },
    rowsPerPage: {
      type: Array,
      default: function _default() {
        return [5, 7, 10, 15, 25, 50, 100, 200];
      }
    },
    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rowsAreClickable: {
      type: Boolean,
      dafault: false
    },
    enableSearch: {
      type: Boolean,
      default: true
    },
    searchKeywords: {
      type: String,
      default: ""
    },
    fetchOnSearchUpdate: {
      type: Boolean,
      default: true
    },
    enableFilter: {
      type: Boolean,
      default: false
    },
    filterDefinitions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fetchOnFilterUpdate: {
      type: Boolean,
      default: true
    },
    showLoader: {
      type: Boolean,
      default: false
    },
    totalResults: {
      type: [Number, Boolean],
      default: false
    },
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    actionsLocation: {
      type: String,
      default: "menu" // menu or row
    },
    selectionType: {
      type: String,
      default: "none"
    },
    pagination: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    savedSearchParams: {
      type: Object,
      default: function _default() {
        return {
          enabled: false,
          title: __WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* default */].t("ui.xtable.save_search_title"),
          label: __WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* default */].t("ui.xtable.name"),
          saveFunction: null,
          saveEvent: null
        };
      }
    },
    emptyStateLabel: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* default */].t("ui.xtable.empty_state_label")
    },
    tableSettingsName: {
      type: String,
      default: "contacts"
    }
  },
  data: function data() {
    return {
      fetchParams: {
        searchKeywords: "",
        searchFilters: {},
        pagination: this.paginationSettings()
      },
      tableClasses: [],
      allColumns: [],
      visibleColumns: [],
      separator: "horizontal",
      totalCount: 0,
      selectedItems: [],
      loading: this.showLoader,
      key: 0,
      savedSearchModalOpen: false,
      savedSearchName: ""
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var storedTableVisibleColumns = this.$localStorage.get(this.storedTableVisibleColumns());

    if (storedTableVisibleColumns) {
      storedTableVisibleColumns = storedTableVisibleColumns.split(",");
    }

    // Override the default icons used for column sorting
    this.$q.icon.table.arrowUp = "keyboard_arrow_up";

    // Merge the parent's pagination object with our defaults
    var merged = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, this.fetchParams.pagination, this.pagination);
    // And then feed the merged object back to the parent
    this.updatePagination({ pagination: merged }, false);

    // Set fetch search parameters
    this.fetchParams.searchKeywords = this.searchKeywords;
    this.fetchParams.searchFilters = this.filters;

    if (this.selectionType != 'none') {
      this.tableClasses.push('has-sticky-column');
    }

    // Convert column structure to that expected by QTable
    this.columns.forEach(function (col) {
      // First, check if the logged-in user can see this column
      var canSee = true;
      if (col.credentials) {
        var tableName = _this.title.toLowerCase().trim().replace(/\s+/, "_");
        canSee = __WEBPACK_IMPORTED_MODULE_9__classes_Permission__["a" /* default */].can(null, "table." + tableName + "." + col.name + ".view");
        delete col.credentials;
      }

      if (canSee) {
        var classes = col.classes || "";
        classes = classes.trim().split(/\s*[\s,]\s*/);
        if (classes[0] == "") {
          classes = [];
        }

        // Convert some attributes into classes
        if (col.isSticky === true) {
          classes.push("column-sticky");
          _this.tableClasses.push('has-sticky-column');
        }
        delete col.isSticky;

        classes.push("column-standard");

        if (col.isLink === true) {
          classes.push("column-link");
        }
        delete col.isLink;

        if (col.isBold === true) {
          classes.push("column-bold");
        }
        delete col.isBold;

        // Determine which columns should be initially visible
        if (col.required !== true && col.hideByDefault != true) {
          _this.visibleColumns.push(col.name);
        }
        delete col.hideByDefault;

        // Apply formatting to some column types
        if (col.type == "dateTime") {
          col.format = function (datetime) {
            return _this.formatDateTimeNatural(datetime, { useTimeExpressions: false });
          };
        }
        delete col.type;

        // Set some defaults
        if (typeof col.sortable == "undefined") {
          col.sortable = true;
        }

        if (typeof col.align == "undefined") {
          col.align = "left";
        }

        // Dedup and join into string
        classes = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(classes)));
        col.classes = classes.join(" ");

        _this.allColumns.push(col);
      }
    });

    this.tableClasses = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(this.tableClasses)));
    this.tableClasses = this.tableClasses.join(" ");

    if (storedTableVisibleColumns && storedTableVisibleColumns.length > 0) {
      this.visibleColumns = storedTableVisibleColumns;
    }
  },

  methods: {
    columnChange: function columnChange(visibleColumns) {
      this.$localStorage.set(this.storedTableVisibleColumns(), visibleColumns);
    },
    paginationSettings: function paginationSettings() {
      var storedTableSettings = JSON.parse(this.$localStorage.get(this.storedTableSettingsValue()));

      if (_.isEmpty(storedTableSettings)) {
        return {
          sortBy: null,
          descending: false,
          page: 1,
          rowsPerPage: 25
        };
      } else {
        return storedTableSettings;
      }
    },
    handleAction: function handleAction(action) {
      var _this2 = this;

      var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // If the selection type is single or multiple,
                // then the ids are available in the selectedItems array
                // Otherwise, they're passed directly to this handler
                if (_this2.selectionType != "none") {
                  ids = [];
                  if (_this2.selectedItems.length > 0) {
                    _this2.selectedItems.forEach(function (item) {
                      ids.push(item.id);
                    });
                  }
                }

                // If the action has provided an event, emit it
                if (action.event) {
                  _this2.$emit(action.event, ids);
                }

                // If a handler function has been provided, call it

                if (!(typeof action.function == "function")) {
                  _context.next = 10;
                  break;
                }

                _this2.loading = true;

                _context.prev = 4;
                _context.next = 7;
                return action.function(ids);

              case 7:
                _context.prev = 7;

                _this2.loading = false;
                return _context.finish(7);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4,, 7, 10]]);
      }))();
    },
    isEmpty: function isEmpty(value) {
      return value === null || value === undefined || value === '';
    },
    defaultValue: function defaultValue(column) {
      return this.$t('ui.xtable.empty_cell_value', { name: column.label.toLowerCase() });
    },
    resetPagePaginationSettings: function resetPagePaginationSettings() {
      var storedTableSettings = JSON.parse(this.$localStorage.get(this.storedTableSettingsValue()));

      storedTableSettings.page = 1;

      this.updatePagination({ pagination: storedTableSettings }, false);
    },
    updateFilters: function updateFilters(filters) {
      this.resetPagePaginationSettings();

      this.fetchParams.searchFilters = filters;
      this.$emit("updateFilters", this.fetchParams.searchFilters);

      if (this.fetchOnFilterUpdate) {
        this.triggerFetch();
      }
    },
    updateSearch: function updateSearch() {
      var searchKeywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var triggerFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.resetPagePaginationSettings();

      if (searchKeywords == null) {
        searchKeywords = this.fetchParams.searchKeywords;
      }
      this.$emit("updateSearch", searchKeywords);
      if (this.fetchOnSearchUpdate || triggerFetch) {
        this.triggerFetch();
      }
    },
    storedTableSettingsValue: function storedTableSettingsValue() {
      return this._.toLower(this.tableSettingsName) + "TableSettings";
    },
    storedTableVisibleColumns: function storedTableVisibleColumns() {
      return this._.toLower(this.tableSettingsName) + "VisibleColumns";
    },
    updatePagination: function updatePagination(payload) {
      var triggerFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var payloadPagination = {
        sortBy: payload.pagination.sortBy,
        descending: payload.pagination.descending,
        page: payload.pagination.page,
        rowsPerPage: payload.pagination.rowsPerPage
      };

      this.$localStorage.set(this.storedTableSettingsValue(), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload.pagination));

      this.fetchParams.pagination = payload.pagination;
      this.$emit("updatePagination", payload.pagination);
      if (triggerFetch) {
        this.triggerFetch();
      }
    },
    triggerFetch: function triggerFetch() {
      this.$emit("fetchData", this.fetchParams);
    },
    clickRow: function clickRow(id) {
      if (this.rowsAreClickable) {
        this.$emit("clickRow", id);
      }
    },
    clickCell: function clickCell(id, fieldName) {
      this.$emit("clickCell", id, fieldName);
    },
    openSavedSearchModal: function openSavedSearchModal() {
      this.savedSearchName = "";
      this.savedSearchModalOpen = true;
    },
    closeSavedSearchModal: function closeSavedSearchModal() {
      this.savedSearchModalOpen = false;
    },
    saveSearch: function saveSearch() {
      this.openSavedSearchModal();
    },
    saveSearchCommit: function saveSearchCommit() {
      this.closeSavedSearchModal();
      var payload = {
        name: this.savedSearchName,
        search: this.fetchParams
      };
      if (this.savedSearchParams.saveEvent) {
        this.$emit(this.savedSearchParams.saveEvent, payload);
      }
      if (typeof this.savedSearchParams.saveFunction == "function") {
        this.savedSearchParams.saveFunction(payload);
      }
    }
  },
  watch: {
    tableData: function tableData() {

      // Reset item selections when the tabele data updates
      this.selectedItems = [];

      // Force the table to re-render
      this.key++;

      // Set the 'left' attribute of sticky columns to their initial position
      // (There does not seem to be any pure CSS way to to this for non-left-most columns)
      this.$nextTick(function () {
        var stickyColumns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.getElementsByClassName("column-sticky"));

        stickyColumns.forEach(function (col) {
          if (col.offsetLeft != 0) {
            col.style.left = col.offsetLeft - 1 + "px";
          }
        });
      });
    },
    selectedItems: {
      deep: true,
      handler: function handler() {
        this.$emit("selectedItemsChange", this.selectedItems);
      }
    },
    totalResults: function totalResults() {
      this.totalCount = this.totalResults;
      this.fetchParams.pagination.rowsNumber = this.totalCount;
      this.$emit("emitTotalTableCount", this.totalCount);
    },
    showLoader: function showLoader() {
      this.loading = this.showLoader;
    }
  }
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_FormField__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_data_countries__ = __webpack_require__(143);

//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Field: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_FormField___default.a },
  props: {
    label: String,
    classes: Array,
    name: String,
    value: [String, Boolean],
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: 'en'
    },
    params: {
      type: Object,
      default: function _default() {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      countries: {},
      newValue: '',
      favorites: []
    };
  },
  created: function created() {
    var _this = this;

    if (_.get(this, 'params.favorites')) {
      this.favorites = this.params.favorites;
    }

    // to use favorites, put a prop to the country-select item like this:
    // :params="{favorites: ['DE', 'CH']}"

    var countries = _.orderBy(__WEBPACK_IMPORTED_MODULE_2__config_data_countries__["a" /* default */][this.language], ['name'], ['asc']);

    var evens = _.remove(countries, function (n) {
      return _this.favorites.includes(n.value);
    });

    if (evens.length > 0) {
      countries.unshift({ name: '----', value: null });
      countries.unshift.apply(countries, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(evens));
    }

    this.countries = countries;
    this.newValue = this.value;
  },

  watch: {
    value: function value() {
      this.newValue = this.value;
    },
    newValue: function newValue() {
      this.$emit('input', this.newValue);
    }
  }
});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: String,
    classes: Array,
    name: String,
    value: Array,
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newValue: Array,
      error: "",
      tag: "",
      regex: regex,
      backspace_count: 1
    };
  },

  methods: {
    handleBackspace: function handleBackspace() {
      if (this.tag == "") {
        if (this.backspace_count == 0) {
          this.backspace_count++;
        } else {
          this.removeLastTag();
        }
      } else {
        this.backspace_count = 0;
      }
    },
    removeLastTag: function removeLastTag() {
      var index = this.newValue.length - 1;
      this.removeTag(index);
    },
    removeTag: function removeTag(index) {
      this.newValue.splice(index, 1);
    },
    validate: function validate(tag) {

      return this.regex.test(tag);
    },
    addTagKey: function addTagKey() {
      var tag = this.tag;
      this.tag = tag.substring(0, tag.length - 1);
      this.addTag();
    },
    addTag: function addTag() {
      if (this.newValue === undefined) {
        this.newValue = [];
      }
      if (this.tag != '') {
        if (this.validate(this.tag)) {
          this.newValue.push(this.tag);
          this.tag = "";
          this.error = "";
        } else {
          this.error = "errors.wrong_email_format";
        }
      }
    }
  },
  created: function created() {
    this.newValue = this.value;
  },

  watch: {
    value: function value() {
      this.newValue = this.value;
    },
    newValue: function newValue() {
      this.$emit('input', this.newValue);
    }
  }
});

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField___default.a },
  props: {
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    classes: Array,
    name: String,
    autocomplete: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    helpIcon: {
      type: Boolean,
      default: false
    },
    helpIconOptions: {
      type: Object
    },
    value: {},
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      default: null
    },
    enrich_tags: false,
    collection: {},
    params: {
      type: Object,
      default: function _default() {}
    },
    errors: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    model: String,
    fromLeadMask: false
  },
  data: function data() {
    return {
      newValue: "",
      error: undefined
    };
  },
  mounted: function mounted() {
    this.newValue = this.value;
  },

  methods: {
    change: function change(name, value) {
      this.newValue = value;
      this.$emit("change", this.newValue, this.name, name); // see: LeadUpdate#change for reasoning
    },
    removeObjectEvent: function removeObjectEvent(val) {
      // We have one unexpected extra item in our newValue event from 'FormField'.
      // This causes an extra item in our diff in LeadUpdate.diff().
      // We simply remove the extra item.
      if (val) {
        for (var value in val) {
          if (value == "[object Event]") {
            delete val["[object Event]"];
          }
        }
      }
    }
  },
  computed: {
    newLabel: function newLabel() {
      if (this.label) {
        if (this.label === "empty") {
          return "";
        }
        return this.label;
      } else {
        // here we return a fallback label, but only if we are not rendering from the LeadMask
        if (this.fromLeadMask) {
          return "";
        }
        return "models." + this.model + "." + this.name;
      }
    },
    newCollection: function newCollection() {
      var _this = this;

      if (!Array.isArray(this.collection)) {
        return this.collection;
      }

      if (this.collection) {
        var newCollection = [];
        this.collection.forEach(function (item) {
          var newItem = void 0;

          if (_.get(_this.params, "no_i18n")) {
            newItem = { value: item.value, name: item.name };
          } else if (!_this.label || _this.label.length < 2) {
            newItem = {
              value: item.value,
              name: _this.$t("models.select_" + _this.name + "." + item.value)
            };
          } else {
            newItem = { value: item.value, name: item.name };
          }

          if (item.disabled) {
            newItem.disabled = item.disabled;
          }
          newCollection.push(newItem);
        });

        if (this.type == "radio") {
          if (_.get(this.params, 'empty_choice')) {
            newCollection.push({ value: "", name: "-" });
          }
        }
        return newCollection;
      }
    }
  },
  watch: {
    errors: function errors(_errors) {
      var _this2 = this;

      this.error = undefined;
      this.errors.forEach(function (error) {
        if (error.field_name == _this2.name) {
          _this2.error = _this2.$t("errors." + error.code);
        }
      });
    },
    value: function value(val) {
      if (val !== this.newValue) {
        this.newValue = val;
      }
    },
    newValue: function newValue(val) {
      if (this.value !== val) {
        this.removeObjectEvent(val);
        this.$emit("input", val);
      }
    }
  }
});

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    values: {
      type: Array,
      required: true
    },
    elements: {
      required: true
    },
    elementName: {}
  },
  methods: {
    fill: function fill(value) {
      this.insertSomething(value.content);
    },
    insertSomething: function insertSomething(insert) {
      var tArea = this.elements[this.elementName].$el.querySelector('textarea, input');

      // get cursor's position:
      var startPos = tArea.selectionStart;
      var endPos = tArea.selectionEnd;
      var cursorPos = startPos;
      var tmpStr = tArea.value;

      // insert:
      var newContent = tmpStr.substring(0, startPos) + insert + tmpStr.substring(endPos, tmpStr.length);

      this.$emit('input', newContent);

      // move cursor:
      setTimeout(function () {
        cursorPos += insert.length;
        tArea.selectionStart = cursorPos;
        tArea.selectionEnd = cursorPos;
        tArea.focus();
      }, 10);
    }
  }
});

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_HelpIcon__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_HelpIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_HelpIcon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    classes: [Array, String],
    label: String,
    name: String,
    value: {},
    autocomplete: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    helpIcon: {
      type: Boolean,
      default: false
    },
    helpIconOptions: {
      type: Object
    },
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      default: null
    },
    collection: {},
    error: String,
    enrich_tags: false
  },
  components: {
    HelpIcon: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_HelpIcon___default.a
  },
  data: function data() {
    return {
      newValue: '',
      newValues: [],
      oldValue: null,
      tagEnrichmentInitiated: false
    };
  },

  computed: {
    computedClass: function computedClass() {
      if (typeof this.classes === 'string') {
        return this.classes;
      } else {
        var str = 'field field-' + this.type;
        if (this.classes) {
          if (Array.isArray(this.classes)) {
            str += ' ' + this.classes.toString(' ');
          }
        }
        if (this.error !== undefined) {
          str += ' is-unvalid';
        }
        if (this.required === false) {
          str += ' is-optional';
        } else {
          str += ' is-required';
        }
        if (this.readonly === true || this.disabled === true) {
          str += ' is-disabled';
        }
        if (this.autofocus === true) {
          str += ' is-autofocused';
        }
        return str;
      }
    }
  },
  mounted: function mounted() {

    // Set focus on the first text element
    // I'm not sure why the setTimeout() is necessary, but otherwise the element won't receive focus
    var firstInput = document.querySelector('.is-autofocused .text-input, .textarea-input, .field--select');
    if (firstInput != null) {
      setTimeout(function () {
        firstInput.focus();
      }, 0);
    }

    if (this.value) {
      this.newValue = this.value;
    } else {
      this.newValue = this.defaultValue;
    }
  },

  methods: {
    onChange: function onChange(event) {
      var clickedValue = event.target.value;

      if (this.enrich_tags) {
        this.enrichTags(clickedValue);
      }
    },
    onClick: function onClick(value) {
      var clickedValue = event.target.value;
      // If type is radio we want to allow user to unselect the field by clicking on the selected field again.
      if (this.type === 'radio') {
        if (this.oldValue === clickedValue) {
          this.resetField();
        } else {
          // this is needed to remove the old value
          if (this.enrich_tags) {
            this.enrichTags(this.oldValue);
          }
          this.oldValue = clickedValue;
        }
      }
      if (this.enrich_tags) {
        this.enrichTags(clickedValue);
      }
    },
    resetField: function resetField() {
      this.oldValue = null;
      this.newValue = this.defaultValue;
    },

    // if we want to enrich tags we have to update the tag list accordingly to avoid unnecessary parameters
    // we enrich tags on watched and we enrich on each new click
    // NOTE: tags should get enriched on mounted but there is a problem with "this.value" not being available
    // this can mean we also remove enriched tags, if they already exist in the tags array
    enrichTags: function enrichTags(value) {
      var removeIfExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.tagEnrichmentInitiated = true;
      EventBus.$emit('enrich_tags', value, removeIfExists);
    }
  },
  watch: {
    value: function value(val) {
      if (val !== this.newValue) {
        this.newValue = val;

        // init old value for radios
        if (this.type === 'radio') {
          this.oldValue = val;
        }
      }
    },
    newValue: function newValue(newVal) {

      // enrich tags in tag-list component
      if (this.newValue) {
        if (this.enrich_tags && !this.tagEnrichmentInitiated) {
          var value = [];
          if (typeof this.newValue == 'string') {
            value = this.newValue.split(' ');
          } else if (Array.isArray(this.newValue)) {
            value = this.newValue;
          }
          EventBus.$emit('enrich_tags_on_init', value);
          this.tagEnrichmentInitiated = true;
        }
      }

      // Initialized and with no default value text type field is (null). When we type content and remove it, it becames an empty string & save pop-up still showing
      // To be able to untrack these changes we remove "" and we reemplace it with defaultValue (null as default).
      // * There was a problem When newVal was boolean and false. It was overwritting the checkbox from false to the default value.
      if (!newVal && typeof newVal !== 'boolean') {
        this.newValue = this.defaultValue;
        newVal = this.defaultValue;
      }
      this.$emit('input', newVal);
    },
    newValues: function newValues(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default.a },
  data: function data() {
    return {
      newValue: false
    };
  },

  props: {
    label: String,
    name: String,
    value: Boolean,
    reverse: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function _default() {}
    },
    errors: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    model: String
  },
  methods: {
    valueSwitch: function valueSwitch() {
      this.newValue = !this.newValue;
    }
  },
  computed: {
    newClasses: function newClasses() {
      if (this.newValue === undefined) {
        return "value-undefined";
      }
      if (this.reverse === true) {
        return "value-" + !this.newValue;
      } else {
        return "value-" + this.newValue;
      }
    },
    newLabel: function newLabel() {
      if (this.label) {
        if (this.label === "empty") {
          return "";
        }
        return this.label;
      } else {
        return "models." + this.model + "." + this.name;
      }
    }
  },
  // this is the git flow test
  mounted: function mounted() {
    this.newValue = this.value;
  },

  watch: {
    value: function value(val) {
      if (val !== this.newValue) {
        this.newValue = val;
      }
    },
    newValue: function newValue(val) {
      this.$emit("input", val);
    }
  }
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_signature_pad__ = __webpack_require__(1626);

//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: String,
    classes: Array,
    name: String,
    value: String,
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newValue: String,
      error: "",
      canvas: null,
      wrapper: null,
      signaturePad: null,
      width: 1026,
      height: 450,
      viewportWidth: Number,
      leftScrollable: Boolean,
      rightScrollable: Boolean
    };
  },

  methods: {
    canvasClean: function canvasClean() {
      this.signaturePad.clear();
    },
    canvasExport: function canvasExport() {
      this.newValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.signaturePad.toData());
    },
    displayCanvas: function displayCanvas() {
      this.signaturePad = new __WEBPACK_IMPORTED_MODULE_1_signature_pad__["a" /* default */](this.canvas);
      this.$nextTick(function () {
        if (typeof this.value != 'undefined') {
          try {
            if (this.value) {
              this.signaturePad.fromData(JSON.parse(this.value));
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    scroll: function scroll(offset) {
      var left = this.wrapper.scrollLeft;
      this.wrapper.scrollTo(left + parseInt(offset), 0);
      this.leftScrollable = this.isLeftScrollable();
      this.rightScrollable = this.isRightScrollable();
    },
    isLeftScrollable: function isLeftScrollable() {
      if (this.wrapper.scrollLeft == 0) {
        return false;
      } else {
        return true;
      }
    },
    isRightScrollable: function isRightScrollable() {
      this.viewportWidth = this.wrapper.offsetWidth;
      if (this.viewportWidth + this.wrapper.scrollLeft >= this.width) {
        return false;
      } else {
        return true;
      }
    },
    init: function init() {
      this.canvas = document.querySelector(".draw-canvas");
      this.displayCanvas();
      this.wrapper = document.querySelector(".draw-canvas-wrapper");
      this.viewportWidth = this.wrapper.offsetWidth;
      this.scroll(0);
    }
  },
  created: function created() {
    this.newValue = this.value;
  },
  mounted: function mounted() {
    this.init();
  },

  watch: {
    value: function value() {
      this.newValue = this.value;
      this.displayCanvas();
      this.init();
    },
    newValue: function newValue() {
      this.$emit('input', this.newValue);
    }
  }
});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuantitySelectionItem__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuantitySelectionItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__QuantitySelectionItem__);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { QuantitySelectionItem: __WEBPACK_IMPORTED_MODULE_0__QuantitySelectionItem___default.a },
  props: {
    label: String,
    classes: Array,
    name: String,
    value: {},
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    },
    collection: {},
    params: {
      type: Object,
      default: function _default() {}
    },
    errors: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    model: String
  },
  data: function data() {
    return {
      newValue: '',
      error: undefined
    };
  },
  mounted: function mounted() {
    this.newValue = this.value;
  },

  methods: {
    change: function change(name, value) {
      this.newValue[name] = value;
    }
  },
  computed: {
    newLabel: function newLabel() {
      if (this.label) {
        return this.label;
      } else {
        return 'models.' + this.model + '.' + this.name;
      }
    },
    newCollection: function newCollection() {
      if (this.collection) {
        var newCollection = [];
        this.collection.forEach(function (item) {

          newCollection.push({ value: item.value, name: item.name });
        });
        if (this.type == "radio") {
          if (_.get(this.params, 'empty_choice')) {
            newCollection.push({ value: "", name: "-" });
          }
        }
        return newCollection;
      }
    }
  },
  watch: {
    errors: function errors(_errors) {
      var _this = this;

      this.error = undefined;
      this.errors.forEach(function (error) {
        if (error.field_name == _this.name) {
          _this.error = _this.$t('errors.' + error.code);
        }
      });
    },
    value: function value(val) {
      if (val !== this.newValue) {
        this.newValue = val;
      }
    },
    newValue: function newValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


var defaultStartValue = '0';
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'value'],
  data: function data() {
    return {
      selectRange: 10,
      newValue: defaultStartValue
    };
  },
  mounted: function mounted() {
    this.init();
  },

  methods: {
    init: function init() {
      if (this.value) {
        var value = this.value[this.item.value];
        if (value) {
          this.newValue = this.value[this.item.value];
        }
      }
    },
    change: function change(event) {
      var value = event.target.value;
      this.newValue = value;
      this.$emit('change', this.item.value, this.newValue);
      event.target.value = -1;
    },
    reset: function reset() {
      if (this.value) {
        var value = this.value[this.item.value];
        if (value) {
          this.newValue = this.value[this.item.value];
        } else {
          this.newValue = defaultStartValue;
        }
      }
    }
  },
  computed: {
    itemValue: function itemValue() {
      if (this.newValue) {
        return this.newValue;
      }
      return "0";
    }
  },
  watch: {
    value: {
      handler: function handler() {
        this.reset();
      },

      deep: true
    }
  }
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['choices'],
  data: function data() {
    return {
      date: Number
    };
  },

  methods: {
    choose: function choose(date) {
      this.date = date;
      this.$emit('change', date);
    }
  },
  mounted: function mounted() {
    this.choose(this.choices[0]);
  }
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField___default.a },
  props: {
    label: String,
    classes: Array,
    name: String,
    value: {},
    required: {
      type: Boolean,
      default: false
    },
    collection: {},
    params: {
      type: Object,
      default: function _default() {}
    },
    errors: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    model: String,
    set_state: String
  },
  data: function data() {
    return {
      newValue: '',
      error: null,
      state: 'secret'
    };
  },
  mounted: function mounted() {
    if (this.set_state && this.set_state !== '') {
      this.state = this.set_state;
    }
  },

  computed: {
    newLabel: function newLabel() {
      if (this.label) {
        return this.label;
      } else {
        return 'models.' + this.model + '.' + this.name;
      }
    },
    placeholder: function placeholder() {
      return '●●●●●●●●●●●●●●●●●●●';
    }
  },
  methods: {
    stateSwitch: function stateSwitch() {
      var _this = this;

      this.newValue = "";
      if (this.state == 'secret') {
        this.state = "field";
        setTimeout(function () {
          _this.$refs['real-field'].focus();
        }, 50);
      } else {
        this.state = "secret";
      }
    }
  },
  watch: {
    errors: function errors(_errors) {
      var _this2 = this;

      this.error = undefined;
      this.errors.forEach(function (error) {
        if (error.field_name == _this2.name) {
          _this2.error = _this2.$t('errors.' + error.code);
        }
      });
    },
    newValue: function newValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: String,
    classes: Array,
    name: String,
    value: Array,
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newValue: Array,
      displayOnlyTags: [],
      error: '',
      tag: '',
      regex: /^[-a-zA-Z0-9äöüÄÖÜß_]*$/,
      backspace_count: 1,
      displayTagsInitialized: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    // reset displayTags
    this.displayOnlyTags = [];

    // listens to tag adding from the tag enrichment feature
    EventBus.$on('enrich_tags', function (tag, removeIfExists) {
      if (tag) {
        _this.tag = tag;
        _this.displayOnlyTags.push(_this.tag);
        _this.addOrRemoveTag(removeIfExists);
      }
    });

    // if emitted, this method will add tags to the value array if it does not exist yet
    // it will also add tags to the displayOnlyTags array which then is used to decide whether a tag can be deleted or not
    EventBus.$on('enrich_tags_on_init', function (tags) {
      if (tags) {
        tags.forEach(function (tag) {
          _this.tag = tag;
          _this.displayOnlyTags.push(_this.tag);
          // prevent multiple tags of the same value in the value array
          if (_this.value.indexOf(tag) === -1) {
            _this.addOrRemoveTag();
          }
          _this.tag = '';
        });
      }
    });
  },

  methods: {
    getClass: function getClass() {
      if (this.classes && this.classes.length > 0) {
        return "tag-list-input " + this.classes[0];
      } else {
        return "tag-list-input";
      }
    },
    emitBlur: function emitBlur() {
      this.$emit('blur');
    },
    emitFocus: function emitFocus() {
      this.$emit('focus');
    },

    // TODO: remove tag by name
    removeTag: function removeTag(index) {
      this.value.splice(index, 1);
      this.$emit('remove', this.value);
    },
    validate: function validate(tag) {
      return this.regex.test(tag);
    },
    addTagKey: function addTagKey() {
      var tag = this.tag;
      this.tag = tag.substring(0, tag.length - 1);
      this.addOrRemoveTag();
    },

    // if tag is in this array, it shall be protected from deletion because it was enriched automatically
    isProtected: function isProtected(tag) {
      var index = this.displayOnlyTags.indexOf(tag);
      return index > -1;
    },

    // adds a tag
    // if requested, also removes tags. usually used when tags are added from the outside (enrich_tags)
    addOrRemoveTag: function addOrRemoveTag() {
      var removeIfExists = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.tag != '') {

        var index = this.value.indexOf(this.tag);
        if (removeIfExists && index > -1) {
          this.removeTag(index);
          this.tag = '';
          return;
        }

        if (this.validate(this.tag)) {
          this.value.push(this.tag);

          this.$emit('setTag', this.tag);
          this.error = '';
          this.tag = '';
        } else {
          this.error = "errors.lead.wrong_tag_format";
        }
      }
    }
  },
  computed: {
    labelText: function labelText() {
      return this.label == 'empty' ? '' : this.label || this.$t('ui.taglist.label');
    }
  }
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_icon_upload_svg__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_icon_upload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_icons_icon_upload_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      file: null,
      upload_icon: __WEBPACK_IMPORTED_MODULE_0__assets_icons_icon_upload_svg___default.a
    };
  },

  methods: {
    fileUpload: function fileUpload(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.file = files[0];
      this.$emit('change', this.file);
    },
    emptyFile: function emptyFile() {
      this.file = null;
      this.$emit('change', null);
    },
    formatBytes: function formatBytes(bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
          dm = decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
  }
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      video: '',
      src: '',
      stream: undefined,
      deviceIndex: -1,
      devices: [],
      hasUserMedia: false,
      facingModes: ['environment', 'back'],
      currentFacingMode: 0,
      styleObject: {
        minWidth: "0px",
        minHeight: "0px"
      }
    };
  },

  props: {
    autoplay: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 300
    },
    mirror: {
      type: Boolean,
      default: true
    },
    screenshotFormat: {
      type: String,
      default: 'image/jpeg'
    }
  },
  computed: {
    streamIsPresent: function streamIsPresent() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.stream) == 'object';
    }
  },
  mounted: function mounted() {
    this.video = this.$refs.video;
    this.listVideoMedia();
  },

  beforeDestroy: function beforeDestroy() {
    if (this.video) {
      this.video.pause();
    }
    this.src = '';
    this.stopRecording();
  },
  methods: {
    displayDevice: function displayDevice(deviceId) {
      var _this = this;

      var config = {
        deviceId: deviceId,
        facingMode: this.facingModes[this.currentFacingMode],
        video: true,
        audio: false
      };
      this.closeStream();
      navigator.mediaDevices.getUserMedia({ video: config }).then(function (stream) {
        _this.stream = stream;
        // We have to set the min size of the wrapper div the first time the stream loads.
        // This is to prevent the div from resizing when switching between cameras.
        _this.$nextTick(function (e) {
          this.$refs.video.addEventListener("loadedmetadata", function (e) {
            this.setMinSizes();
          }.bind(this), false);
        });
        _this.hasUserMedia = true;
      }).catch(function (err) {
        console.log(err);
      });
    },

    // We set the min size of the wrapper to prevent it from resizing when we switch streams (fx when switching front->back camera)
    setMinSizes: function setMinSizes() {
      // Only set them once
      if (this.styleObject.minHeight === '0px' && this.styleObject.minWidth === '0px') {
        this.styleObject = {
          minHeight: this.$refs.video.clientHeight + "px",
          minWidth: this.$refs.video.clientWidth + "px"
        };
      }
    },
    stopRecording: function stopRecording() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.closeStream();
        _this2.stream = undefined;
      });
    },
    switchDevice: function switchDevice() {
      var index = this.deviceIndex;
      this.changeFacingMode();
      if (this.devices[index + 1] !== undefined) {
        this.displayDevice(this.devices[index + 1].deviceId);
        this.deviceIndex = index + 1;
      } else {
        this.displayDevice(this.devices[0].deviceId);
        this.deviceIndex = 0;
      }
    },
    closeStream: function closeStream() {
      if (this.streamIsPresent) {
        this.stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
    },
    changeFacingMode: function changeFacingMode() {
      this.currentFacingMode = this.currentFacingMode == 0 ? 1 : 0;
    },
    changeDevice: function changeDevice(deviceId) {
      this.displayDevice(deviceId);
    },
    listVideoMedia: function listVideoMedia() {
      var _this3 = this;

      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        _this3.devices = _.filter(devices, { kind: "videoinput" });
        _this3.devices.forEach(function (device) {
          if (device.label.includes('back')) {
            _this3.displayDevice(device);
            _this3.deviceIndex = _this3.devices.indexOf(device);
          }
        });
        // Fallback
        if (_this3.deviceIndex == -1) {
          _this3.displayDevice(_this3.devices[0]);
          _this3.currentFacingMode = 1;
          _this3.deviceIndex = 0;
        }
      });
    },
    getPhoto: function getPhoto() {
      if (!this.hasUserMedia) return null;
      var canvas = this.getCanvas();
      return canvas.toDataURL(this.screenshotFormat);
    },
    getCanvas: function getCanvas() {
      if (!this.hasUserMedia) return null;
      var video = this.$refs.video;
      if (!this.ctx) {
        var _canvas = document.createElement('canvas');
        _canvas.height = video.clientHeight;
        _canvas.width = video.clientWidth;
        this.canvas = _canvas;
        this.ctx = _canvas.getContext('2d');
      }
      var ctx = this.ctx,
          canvas = this.canvas;

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas;
    }
  }
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_XFilterGroup__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_XFilterGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_XFilterGroup__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XFilterGroup: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_XFilterGroup___default.a },
  props: {
    filterDefinitions: {
      type: Array,
      required: true
    },
    defaultfilters: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      filters: {},
      workingFilterDefinitions: null
    };
  },
  beforeMount: function beforeMount() {
    // Initialise and add any defaults
    this.filters = _.clone(this.defaultfilters);

    if (typeof this.filters.group == 'undefined' || typeof this.filters.group.conditions == 'undefined') {
      this.filters = {
        group: {
          merge: "",
          conditions: []
        }
      };
    }

    this.createWorkingDefinitions();
  },

  methods: {
    createWorkingDefinitions: function createWorkingDefinitions() {
      var _this = this;

      this.workingFilterDefinitions = _.cloneDeep(this.filterDefinitions);

      this.workingFilterDefinitions.forEach(function (def) {
        if (def.type == 'date') {

          // If no options are provided, use the defaults
          if (Array.isArray(def.options) == false || def.options.length == 0) {
            var defaultDateRanges = _this.$t('ui.xfilters.date_ranges');
            def.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(defaultDateRanges).map(function (key) {
              return {
                name: defaultDateRanges[key],
                value: key
              };
            });
          }

          // If the options are provided as an array of names, convert into name/value pairs
          if (Array.isArray(def.options) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(def.options[0]) != 'object') {
            def.options = def.options.map(function (rangeName) {
              return {
                name: rangeName,
                value: rangeName.toLowerCase().replace(/\s+/g, '_')
              };
            });
          }

          // If no 'custom' value has been provided, add it
          var exists = def.options.some(function (option) {
            return option.value == 'custom';
          });
          if (!exists) {
            def.options = [{
              name: _this.$t('ui.xfilters.date_ranges.custom'),
              value: 'custom'
            }].concat(def.options);
          }
        }
      });
    },
    getRootGroup: function getRootGroup() {
      return _.get(this.filters, 'group', {});
    },
    updateGroup: function updateGroup(group, index) {
      // We can ignore index, since we only ever have one root group
      this.filters.group = group;
      this.$emit('update', this.filters);
    }
  },
  watch: {
    filterDefinitions: {
      deep: true,
      handler: function handler() {
        this.createWorkingDefinitions();
      }
    }
  }
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_data_countries__ = __webpack_require__(143);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    condition: {
      type: Object,
      required: true
    },
    operator: {
      type: String,
      required: true
    },
    isLast: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},

  methods: {
    getConditionType: function getConditionType() {
      return _.get(this.condition, 'definition.type', 'text');
    },
    getConditionAttribute: function getConditionAttribute() {
      return _.get(this.condition, 'definition.attribute', 'text');
    },
    getConditionLabel: function getConditionLabel() {
      return _.get(this.condition, 'definition.condition_label', _.get(this.condition, 'definition.label', '??'));
    },
    getConditionValue: function getConditionValue() {
      return _.get(this.condition, 'value', null);
    },
    getConditionPredicate: function getConditionPredicate() {
      return _.get(this.condition, 'predicate', 'eq');
    },
    getConditionValuesFormatted: function getConditionValuesFormatted() {

      var values = this.getConditionValue();
      if (values === null) {
        return [];
      }

      if (Array.isArray(values) == false) {
        values = [values];
      }

      var type = this.getConditionType();
      var predicate = this.getConditionPredicate();

      var labels = values;
      if (type == 'set' || type == 'date' && predicate == 'in_range') {
        var options = this.getConditionOptions();
        labels = values.map(function (value) {
          var match = options.find(function (option) {
            return option.value == value;
          });
          if (match == undefined) {
            return '??';
          }
          return type == 'date' ? match.name.toLowerCase() : match.name;
        });
      }

      if (type == 'date' && predicate != 'in_range') {
        labels = values.map(function (value, idx) {
          // First convert each date to a moment object
          // For the second (to) date, we subtract one day, because we store it as +1 day
          // (see XFilterGroup.addCondition())
          return value ? idx == 0 ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(value) : __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).subtract(1, 'day') : null;
        }).filter(function (date) {
          // Then filter out any that are null
          return date != null;
        }).map(function (date) {
          // Finally format the remainder
          // In the interest of compactness, we only show the year if it is not this year
          var label = date.format('D MMM');
          if (date.year() != __WEBPACK_IMPORTED_MODULE_0_moment___default()().year()) {
            label += ', ' + date.format('YYYY');
          }
          return label;
        });
      }

      if (labels.length == 1) {
        return labels;
      } else if (type == 'date') {
        if (labels[0] == labels[1]) {
          return [labels[0]];
        } else {
          return labels;
        }
      } else {
        var last = labels.pop();
        return [labels.join(', ') + ' ' + this.$t('ui.xfilters.conditions.operators.or') + ' ' + last];
      }
    },
    getConditionOptions: function getConditionOptions() {

      var options = _.get(this.condition, 'definition.options', []);

      // If no options have been defined and the attribute is of type country,
      // then we load in the default list of countries.
      if (options == false && this.getConditionAttribute() == 'country') {
        options = [];
        var language = this.$store.getters.getCurrentLanguage || 'en';
        __WEBPACK_IMPORTED_MODULE_1__config_data_countries__["a" /* default */][language].forEach(function (country) {
          options.push({
            name: country.name,
            value: country.value
          });
        });
      }

      // If no options have been defined and the attribute is of type tags,
      // then we use the values themselves as the option names
      if (options == false && this.getConditionAttribute() == 'tags') {
        var values = this.getConditionValue();
        if (values === null) {
          values = [];
        }
        if (Array.isArray(values) == false) {
          values = [values];
        }
        values.forEach(function (value) {
          options.push({
            name: value,
            value: value
          });
        });
      }

      if (options == false) {
        options = [];
      }

      return options;
    },
    getConditionSummaryTemplate: function getConditionSummaryTemplate() {

      var predicate = this.getConditionPredicate();
      var type = this.getConditionType();
      var value = this.getConditionValue();

      if (type == 'date') {
        if (predicate == 'in_range') {
          return (/^past_/.test(value) ? 'ui.xfilters.conditions.summary.date_in_range' : 'ui.xfilters.conditions.summary.date_in_range_simple'
          );
        }
        if (Array.isArray(value) && value[0] && value[1]) {
          if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(value[0]).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_0_moment___default()(value[1]).subtract(1, 'day').format('YYYY-MM-DD')) {
            return 'ui.xfilters.conditions.summary.date_on';
          } else {
            return 'ui.xfilters.conditions.summary.date_between';
          }
        }
        if (Array.isArray(value) && !value[1]) {
          return 'ui.xfilters.conditions.summary.date_since';
        }
        if (Array.isArray(value) && !value[0]) {
          return 'ui.xfilters.conditions.summary.date_before';
        }
      }

      if (predicate == 'eq') {
        return 'ui.xfilters.conditions.summary.is';
      }

      if (['has_any', 'has_all'].includes(predicate)) {
        if (Array.isArray(value) && value.length == 1) {
          return 'ui.xfilters.conditions.summary.includes';
        } else if (predicate == 'has_any') {
          return 'ui.xfilters.conditions.summary.has_any';
        } else if (predicate == 'has_all') {
          return 'ui.xfilters.conditions.summary.has_all';
        }
      }

      if (predicate == 'has_none') {
        return 'ui.xfilters.conditions.summary.is_not_assigned';
      }

      return 'ui.xfilters.conditions.summary.is';
    },
    getConditionSummary: function getConditionSummary() {
      // Get the i18n key used for this conidition and values
      var template = this.getConditionSummaryTemplate();

      // Get an array of all values, formatted as necessary
      var formattedValues = this.getConditionValuesFormatted();

      // Add the condition label to front of the final array
      var label = this.getConditionLabel();
      var templateValues = formattedValues;
      templateValues.unshift(label);

      // Resolve i18n key with all values inserted
      var summary = this.$t(template, templateValues);

      // Format it by uppercasing only the first character
      summary = summary.toLowerCase();
      summary = summary.charAt(0).toUpperCase() + summary.slice(1);

      return summary;
    },
    removeCondition: function removeCondition() {
      // Delegate to the parent group
      this.$emit('removeCondition', this.condition.id);
    }
  }
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_XFilterCondition__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_XFilterCondition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_XFilterCondition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_XFilterModal__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_XFilterModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_XFilterModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XFilterCondition: __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_XFilterCondition___default.a, XFilterModal: __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_XFilterModal___default.a, Modal: __WEBPACK_IMPORTED_MODULE_10__components_helpers_Layout_NewModal___default.a },
  props: {
    group: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    filterDefinitions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      workingGroup: null,
      filterDefinition: {},
      filterModalOpen: false,
      confirmationModalOpen: false,
      confirmationParameters: null,
      modalKey: 0
    };
  },
  beforeMount: function beforeMount() {
    this.workingGroup = _.cloneDeep(this.group);

    this.convertConditionsFromCanonical(this.workingGroup);

    if (this.workingGroup.conditions) {
      //this.updateGroup()
    }
  },
  mounted: function mounted() {},

  methods: {
    getAllConditions: function getAllConditions() {
      return _.get(this.workingGroup, 'conditions', []);
    },
    getCondition: function getCondition(id) {

      // Find the filter condition that matches the given id
      var conditions = this.getAllConditions();

      var found = null;
      conditions.forEach(function (condition, idx) {
        if (condition.id == id) {
          found = condition;
          found.index = idx;
        }
      });

      return found;
    },
    getConditionByAttribute: function getConditionByAttribute(attribute) {

      // Find the first filter condition that matches the given attribute
      var conditions = this.getAllConditions();

      var found = null;
      conditions.forEach(function (condition, idx) {
        if (condition.attribute == attribute) {
          found = condition;
          found.index = idx;
        }
      });

      return found;
    },
    getOperator: function getOperator() {
      return _.get(this.workingGroup, 'operator', 'and');
    },
    isSet: function isSet(value) {
      var _this = this;

      if (Array.isArray(value)) {
        if (value.length == 0) {
          return false;
        }
        return value.reduce(function (acc, cur) {
          return acc || _this.isSet(cur);
        });
      } else {
        return typeof value !== 'undefined' && value !== '' && value !== null;
      }
    },
    openAddConditionModal: function openAddConditionModal(definition) {
      if (definition.disabled) {
        return;
      }
      this.filterDefinition = definition;
      this.filterModalOpen = true;
      this.modalKey++;
    },
    addCondition: function addCondition(definition, data) {
      var _this2 = this;

      var hasNone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var condition, prevCondition, prevRemoved;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                // Basic condition fields
                condition = {
                  id: _this2.generateUuidv4(),
                  depends_on: definition.depends_on,
                  attribute: definition.attribute,
                  predicate: data.predicate || definition.predicate,
                  value_id: data.value_id,
                  value: data.value,
                  definition: definition

                  // Add any static fields defined by the definition
                };
                if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(definition.static) == 'object' && definition.static != null) {
                  condition = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(condition, definition.static);
                }

                if (definition.type == 'date') {
                  if (data.dateRange != 'custom') {
                    condition.predicate = 'in_range';
                    condition.value = data.dateRange;
                  } else {
                    condition.value = [data.value ? __WEBPACK_IMPORTED_MODULE_11_moment___default()(data.value).startOf('day').format('YYYY-MM-DD') : null,
                    // We add one day to the end date because we use the "lt" predicate,
                    // but the end date should be included.
                    data.value2 ? __WEBPACK_IMPORTED_MODULE_11_moment___default()(data.value2).add(1, 'day').startOf('day').format('YYYY-MM-DD') : null];
                  }
                }

                // Add type-specific fields
                if (hasNone) {
                  condition.predicate = 'has_none';
                  condition.value = null;
                }

                // Only add condition if it includes actionable values

                if (!(condition.predicate == 'has_none' || _this2.isSet(condition.value))) {
                  _context.next = 12;
                  break;
                }

                // First remove any existing condition for the same attribute
                prevCondition = _this2.getConditionByAttribute(condition.attribute);
                prevRemoved = true;

                if (!prevCondition) {
                  _context.next = 11;
                  break;
                }

                _context.next = 10;
                return _this2.removeCondition(prevCondition.id, false);

              case 10:
                prevRemoved = _context.sent;

              case 11:

                // Then add new condition
                if (prevRemoved) {
                  _this2.workingGroup.conditions.push(condition);
                  _this2.updateGroup();
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getDependantConditions: function getDependantConditions(condition) {
      var dependants = [];
      this.workingGroup.conditions.forEach(function (cond) {
        if (cond.depends_on && condition.id && cond.depends_on == condition.id) {
          dependants.push(cond);
        }
      });
      return dependants;
    },
    removeCondition: function removeCondition(id) {
      var _this3 = this;

      var updateParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var confirmDependancies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var condition, dependantConditions, confirmed, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, dependant;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                condition = _this3.getCondition(id);

                if (!(condition !== null)) {
                  _context2.next = 39;
                  break;
                }

                // Get a list of any dependant conditions
                dependantConditions = _this3.getDependantConditions(condition);

                // If there are some dependencies, then ask for confirmation

                confirmed = true;

                if (!(dependantConditions.length > 0 && confirmDependancies)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return _this3.confirmDelete();

              case 7:
                confirmed = _context2.sent;

              case 8:
                if (!confirmed) {
                  _context2.next = 38;
                  break;
                }

                // First, remove the requested condition
                // (We need to do this now so that the index is valid)
                _this3.workingGroup.conditions.splice(condition.index, 1);

                // Then remove any dependant conditions
                // If any have their own dependancies, then we assume confirmation

                if (!(dependantConditions.length > 0)) {
                  _context2.next = 37;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 14;
                _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(dependantConditions);

              case 16:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 23;
                  break;
                }

                dependant = _step.value;
                _context2.next = 20;
                return _this3.removeCondition(dependant.id, false, false);

              case 20:
                _iteratorNormalCompletion = true;
                _context2.next = 16;
                break;

              case 23:
                _context2.next = 29;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2["catch"](14);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 29:
                _context2.prev = 29;
                _context2.prev = 30;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 32:
                _context2.prev = 32;

                if (!_didIteratorError) {
                  _context2.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context2.finish(32);

              case 36:
                return _context2.finish(29);

              case 37:

                if (updateParent) {
                  _this3.updateGroup();
                }

              case 38:
                return _context2.abrupt("return", confirmed);

              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[14, 25, 29, 37], [30,, 32, 36]]);
      }))();
    },
    confirmDelete: function confirmDelete() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Open the confirmation modal and return a Promise
                // which is resolved according to the confirmation choice
                _this4.confirmationModalOpen = true;
                return _context3.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this4.confirmationParameters = {
                    resolve: resolve,
                    reject: reject
                  };
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    deleteConfirmed: function deleteConfirmed() {
      this.confirmationModalOpen = false;
      if (this.confirmationParameters != null) {
        this.confirmationParameters.resolve(true);
      }
      this.confirmationParameters = null;
    },
    deleteCancelled: function deleteCancelled() {
      this.confirmationModalOpen = false;
      if (this.confirmationParameters != null) {
        this.confirmationParameters.resolve(false);
      }
      this.confirmationParameters = null;
    },

    // The cononical filter conditions (those saved to db), specify date
    // ranges (from/to) as seperate conditions (gt/lt). But internall,
    // these are combined as a single condition, because that is how it's
    // displayed in the UI
    convertConditionsToCanonical: function convertConditionsToCanonical(group) {

      var conditions = [];

      if (Array.isArray(group.conditions) == false) {
        group.conditions = [];
      }

      group.conditions.forEach(function (condition) {

        var modCondition = _.cloneDeep(condition);

        if (modCondition.definition.type == 'date' && modCondition.predicate != 'in_range') {
          // Split condition into two and rename attribute
          var secondCondition = _.cloneDeep(modCondition);
          modCondition.attribute = modCondition.attribute;
          modCondition.predicate = 'gt';
          modCondition.value = modCondition.value[0];
          secondCondition.attribute = secondCondition.attribute;
          secondCondition.predicate = 'lt';
          secondCondition.value = secondCondition.value[1];

          if (modCondition.value != null && secondCondition.value != null) {
            conditions.push(secondCondition);
          } else {
            if (modCondition.value == null) {
              modCondition = secondCondition;
            }
          }
        }
        conditions.push(modCondition);
      });

      group.conditions = conditions;
    },

    // See convertConditionsToCanonical() above.
    convertConditionsFromCanonical: function convertConditionsFromCanonical(group) {

      var conditions = [];
      var dateConditions = {};

      if (Array.isArray(group.conditions) == false) {
        group.conditions = [];
      }

      group.conditions.forEach(function (condition) {

        var modCondition = _.cloneDeep(condition);

        if (condition.definition.type == 'date' && condition.predicate != 'in_range') {

          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dateConditions).includes(condition.attribute) == false) {
            modCondition.value = [null, null];
            modCondition.predicate = null;
            dateConditions[modCondition.attribute] = modCondition;
          }

          if (condition.predicate == 'gt') {
            dateConditions[condition.attribute].value[0] = condition.value;
          }
          if (condition.predicate == 'lt') {
            dateConditions[condition.attribute].value[1] = condition.value;
          }
        } else {
          conditions.push(modCondition);
        }
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(dateConditions).forEach(function (dateCondition) {
        conditions.push(dateCondition);
      });

      group.conditions = conditions;
    },
    updateGroup: function updateGroup() {
      var toUpdate = _.cloneDeep(this.workingGroup);
      this.convertConditionsToCanonical(toUpdate);
      this.$emit('updateGroup', toUpdate, this.index);
    }
  }
});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_FormField__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_AutoComplete__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_CountrySelect__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_CountrySelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_CountrySelect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */], Field: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_FormField___default.a, AutoComplete: __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_AutoComplete___default.a, CountrySelect: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_CountrySelect___default.a, Modal: __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal___default.a },
  props: {
    filterDefinition: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      open: false,
      hasNone: false,
      data: {
        value_id: null,
        value: '',
        predicate: null,
        dateRange: 'today'
      },
      key: 0
    };
  },
  beforeMount: function beforeMount() {
    // Override the default icons used for the chip close button
    this.$q.icon.chip.close = "close";

    if (['in', 'has_any', 'has_all'].includes(this.filterDefinition.predicate) || this.filterDefinition.method == 'chips') {
      this.data.value = [];
    }
    if (this.filterDefinition.type == 'date') {
      // If no 'today' range exists, use the first as the default
      var exists = this.filterDefinition.options.some(function (option) {
        return option.value == 'today';
      });
      if (!exists) {
        this.data.dateRange = this.filterDefinition.options[0].value;
      }
    }
    if (typeof this.filterDefinition.default_predicate != 'undefined') {
      this.data.predicate = this.filterDefinition.default_predicate;
    }
    this.open = this.isOpen;
  },
  mounted: function mounted() {},

  methods: {
    closeModal: function closeModal() {
      this.open = false;
    },
    openModal: function openModal(filterCondition) {
      this.open = true;
    },
    addCondition: function addCondition() {
      this.$emit('addCondition', this.filterDefinition, this.data, this.hasNone);
      this.closeModal();
    },
    autoSelect: function autoSelect(value) {
      this.data.value_id = value.id;
      this.data.value = value.name;
    },
    enableRelativeRanges: function enableRelativeRanges() {
      // If not specified, then default is true
      return typeof this.filterDefinition.enableRelativeRanges == 'undefined' || this.filterDefinition.enableRelativeRanges == true;
    },
    dateRangeChange: function dateRangeChange() {
      // If a date range is selected, then this is a relative date,
      // and the static from/to dates are cleared
      if (this.data.dateRange != 'custom') {
        this.data.value = null;
        this.data.value2 = null;
        this.key++;
      }
    },
    dateChanged: function dateChanged() {
      // If either of the from/to dates are selected,
      // then we considere them fixed dates, so the relative range is custom
      this.data.dateRange = 'custom';
    }
  },
  watch: {
    isOpen: {
      handler: function handler() {
        this.open = this.isOpen;
      }
    }
  }
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_integrations_Integration__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_integrations_Integration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_integrations_Integration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_TagList__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_TagList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_TagList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    active: {
      type: Boolean,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  components: {
    Integration: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_integrations_Integration___default.a,
    TagList: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_TagList___default.a
  },
  data: function data() {
    return {
      label: 'go-to-webinar',
      logoSrc: 'goto-webinar',
      internalActive: this.active,
      internalKeys: this.value
    };
  },

  methods: {
    updateActive: function updateActive() {
      this.$emit('activeInput', this.internalActive);
    }
  },
  watch: {
    active: function active() {
      this.internalActive = this.active;
    },
    value: function value() {
      this.internalKeys = this.value;
    }
  }
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormSwitch__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormSwitch__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FormSwitch: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormSwitch___default.a
  },
  props: {
    logoSrc: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    value: {
      type: Boolean
    }
  },
  computed: {
    computedLogoSrc: function computedLogoSrc() {
      return __webpack_require__(342)("./" + this.logoSrc + '.svg');
    }
  },
  methods: {
    updateActive: function updateActive(val) {
      if (val != this.value) {
        this.$emit('input', val);
      }
    }
  }
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DragNDrop_DragItemEdit__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DragNDrop_DragItemEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DragNDrop_DragItemEdit__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var whitelistedAttributes = ['name', 'label', 'title', 'content', 'required', 'element_type', 'placeholder', 'class'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    limitEditing: {
      type: Boolean,
      default: false
    },
    editorName: {
      type: String
    }
  },
  components: {
    DragItemEdit: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DragNDrop_DragItemEdit___default.a
  },
  computed: {
    activeItem: function activeItem() {
      var item = this.$store.getters.getDragEditorActiveItem;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item).length === 0) {
        return false;
      }
      return true;
    },
    emptyStateSrc: function emptyStateSrc() {
      return __webpack_require__(439);
    }
  },
  methods: {
    deleteElement: function deleteElement(item) {
      this.$emit('delete', item);
    },
    editElement: function editElement(element) {
      this.$emit('edit', element);
    }
  }
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_smooth_dnd__ = __webpack_require__(341);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    groupName: {
      type: String,
      required: true
    },
    // Apply class to item on drag
    dragClass: {
      type: String
    },
    // Remove item from parent after it is dropped
    shouldRemoveOnDrop: {
      type: Boolean,
      default: false
    },
    // Collection of items within container.
    // Needed to get child payload
    collection: {
      type: Array,
      required: true
    },
    collectionByTab: {
      type: Array
    },
    collectionDrag: {
      type: Array
    },
    showTabs: {
      type: Boolean,
      default: false
    },
    nonDragAreaSelector: {
      type: String
    },
    dropPlaceholderOptions: {
      type: Object,
      default: function _default() {
        return {
          className: 'drag-ghost'
        };
      }
    },
    // If anything is droppable here
    shouldAcceptDrops: {
      type: Boolean,
      default: true
    },
    behaviour: {
      type: String
    },
    lockAxis: {
      type: String
    },
    tag: {
      type: Object
    },
    orientation: {
      type: String
    }
  },
  components: {
    Container: __WEBPACK_IMPORTED_MODULE_1_vue_smooth_dnd__["Container"]
  },
  // these are all methods provided by the dnd library
  methods: {
    getChildPayload: function getChildPayload(index) {
      var payload = {};
      // the index provided by the dnd library is casted on the collection by tab if we are in tabs
      // thats why we need to look for the payload there

      if (this.collectionDrag) {
        payload = this.collectionDrag[index];
        payload.collectionDrag = this.collectionDrag;
      }

      if (this.collectionByTab && this.showTabs) {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).length) {
          payload = this.collectionByTab[index];
        }
        payload.isInTab = true;
        payload.collectionByTab = this.collectionByTab;
      } else {
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).length) {
          payload = this.collection[index];
        }
      }

      payload.collectionIdx = this.collection.indexOf(payload);
      payload.collection = this.collection;

      if (this.shouldRemoveOnDrop || payload.shouldBeDeleted) {
        payload.shouldBeDeleted = true;
      }

      return payload;
    },
    onDrop: function onDrop(dropResult) {
      this.$emit('onDrop', dropResult);
    },
    getShouldAcceptDrop: function getShouldAcceptDrop(sourceContainerOptions, payload) {
      return this.shouldAcceptDrops;
    }
  }
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_smooth_dnd__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_DragContainer__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_DragContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_DragContainer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    limitEditing: {
      type: Boolean,
      default: false
    },
    collection: {
      type: Array,
      required: true
    },
    defaultValue: {
      required: false
    },
    element_type: {
      type: String
    }
  },
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default.a,
    DragContainer: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_DragContainer___default.a,
    Draggable: __WEBPACK_IMPORTED_MODULE_1_vue_smooth_dnd__["Draggable"]
  },
  data: function data() {
    return {
      internalCollection: [],
      internalDefaultValue: null,
      defaultValueIsArray: false,
      editing: null,
      editingAttr: null
    };
  },

  computed: {
    dragIcon: function dragIcon() {
      return __webpack_require__(288);
    }
  },
  mounted: function mounted() {
    this.internalCollection = _.cloneDeep(this.collection);
    this.setupInternalDefaultValue();
  },

  methods: {
    isDefaultValue: function isDefaultValue(item) {
      if (this.defaultValueIsArray) {
        return this.defaultValue.includes(item.value);
      } else {
        return this.defaultValue === item.value;
      }
    },
    onDrop: function onDrop(dropResult) {
      var droppedItem = dropResult.payload;
      var startIdx = this.internalCollection.indexOf(droppedItem);
      // startIdx can be -1 if an item is dropped from another div      
      if (startIdx === -1) {
        return;
      }
      var endIdx = dropResult.addedIndex;
      this.internalCollection.splice(startIdx, 1);
      this.internalCollection.splice(endIdx, 0, droppedItem);
      this.updateOptions();
    },
    isEditing: function isEditing(item, attr) {
      if (!this.editing) {
        return false;
      }
      return item == this.editing && attr == this.editingAttr;
    },
    removeEditing: function removeEditing() {
      this.editing = null;
      this.updateOptions();
    },
    updateOptions: function updateOptions() {
      this.$emit('input', this.internalCollection);
    },
    setEditing: function setEditing(item, attr) {
      this.editing = item;
      this.editingAttr = attr;
    },
    deleteElement: function deleteElement(item) {
      this.$emit('delete', item);
    },
    setEditingFocused: function setEditingFocused() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.editing && _this.$refs.editing.length > 0) {
          _this.$refs.editing[0].focus();
        }
      });
    },
    setupInternalDefaultValue: function setupInternalDefaultValue() {
      this.internalDefaultValue = this.defaultValue;
      if (Array.isArray(this.internalDefaultValue)) {
        this.defaultValueIsArray = true;
      }
    }
  },
  watch: {
    internalDefaultValue: function internalDefaultValue(val) {
      if (val !== this.defaultValue) {
        this.$emit('updateDefault', val);
      }
    },
    collection: function collection() {
      this.internalCollection = _.cloneDeep(this.collection);
    },
    editing: function editing() {
      this.setEditingFocused();
    },

    internalCollection: {
      deep: true,
      handler: function handler() {
        this.setEditingFocused();
      }
    },
    defaultValue: function defaultValue(val) {
      this.setupInternalDefaultValue();
    }
  }
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_DoubleOptInDelete__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_DoubleOptInDelete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_DoubleOptInDelete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_SensualBadge__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_SensualBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_SensualBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DragNDrop_DragEditorItemOptions__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DragNDrop_DragEditorItemOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_DragNDrop_DragEditorItemOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_FieldFiller__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_FieldFiller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_FieldFiller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_CountrySelect__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_CountrySelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_CountrySelect__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    limitEditing: {
      // Turning this to true stops the user from editing certain parameters of fields.
      // This is used in the lead sheet editor for example to limit editing to option values.
      // its set for gender to false as we dont want to get it edited
      type: Boolean,
      default: false
    },
    editorName: {
      type: String,
      required: true
    }
  },
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field___default.a,
    DragEditorItemOptions: __WEBPACK_IMPORTED_MODULE_6__components_helpers_DragNDrop_DragEditorItemOptions___default.a,
    DoubleOptInDelete: __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_DoubleOptInDelete___default.a,
    SensualBadge: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_SensualBadge___default.a,
    FieldFiller: __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_FieldFiller___default.a,
    CountrySelect: __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_CountrySelect___default.a
  },
  data: function data() {
    return {
      dataTypes: [],
      limitEditingLocal: false,
      permitEditAttributes: [],
      permitEditAttributesSubmit: ["content", "class"],
      // Allow root to click "Edit selected element" text to display
      // data of object. For testing purposes.
      showExtraInfo: false,
      textAreaHtmlElements: [{
        name: "anchor_tag",
        code: "ui.drag_editor.placeholders.anchor",
        content: '<a href=""></a>'
      }, {
        name: "bold",
        code: "ui.drag_editor.placeholders.bold",
        content: "<b></b>"
      }, {
        name: "italic",
        code: "ui.drag_editor.placeholders.italic",
        content: "<i></i>"
      }, {
        name: "underline",
        code: "ui.drag_editor.placeholders.underline",
        content: "<u></u>"
      }]
    };
  },
  beforeUpdate: function beforeUpdate() {
    __WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* EventBus */].$emit("doubleDeleteReset");
  },

  computed: {
    item: function item() {
      var item = this.$store.getters.getDragEditorActiveItem;
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item).length === 0) {
        return null;
      }
      return item;
    },
    language: function language() {
      return this.$store.getters.getCurrentLanguage;
    },
    popperOptions: function popperOptions() {
      if (!this.item.popperContent) {
        return null;
      }
      return {
        placement: "top",
        content: this.item.popperContent
      };
    },
    badgeText: function badgeText() {
      var type = this.item.element_type.replace(/_/g, " ");
      return _.startCase("" + type);
    },
    canDelete: function canDelete() {
      var undeletableAttributes = ["submit"];
      return !undeletableAttributes.includes(this.item.element_type);
    },

    // Sadly this is the least verbose way I could find to change Vuex values
    // without getting errors in the console
    name: {
      get: function get() {
        return this.item.name;
      },
      set: function set(value) {
        this.set("name", value);
      }
    },
    placeholder: {
      get: function get() {
        return this.item.placeholder;
      },
      set: function set(value) {
        this.set("placeholder", value);
      }
    },
    klass: {
      get: function get() {
        return this.item["class"];
      },
      set: function set(value) {
        this.set("class", value);
      }
    },
    required: {
      get: function get() {
        return this.item.required;
      },
      set: function set(value) {
        this.set("required", value);
      }
    },
    hidden: {
      get: function get() {
        return this.item.hidden;
      },
      set: function set(value) {
        this.set("hidden", value);
      }
    },
    show_as_buttons: {
      get: function get() {
        return this.item.show_as_buttons;
      },
      set: function set(value) {
        this.set("show_as_buttons", value);
      }
    },
    data_type: {
      get: function get() {
        return this.item.data_type;
      },
      set: function set(value) {
        this.set("data_type", value);
      }
    },
    enrich_tags: {
      get: function get() {
        return this.item.enrich_tags;
      },
      set: function set(value) {
        this.set("enrich_tags", value);
      }
    },
    label: {
      get: function get() {
        return this.item.label;
      },
      set: function set(value) {
        this.set("label", value);
      }
    },
    allowedValues: {
      get: function get() {
        return this.item.allowed_values;
      },
      set: function set(value) {
        this.set("allowed_values", value);
      }
    },
    validation: {
      get: function get() {
        return this.item.validation.message;
      },
      set: function set(value) {
        var validation = this.item.validation;
        validation.message = value;
        this.set("validation", validation);
      }
    },
    defaultValue: {
      get: function get() {
        return this.item.default_value;
      },
      set: function set(value) {
        this.set("default_value", value);
      }
    },
    defaultValueOptions: function defaultValueOptions() {
      if (this.item.allowed_values) {
        var defaultValue = this.item.default_value;
        var allowedValue = this.item.allowed_values.find(function (allowed) {
          return allowed.value === defaultValue;
        });
        if (allowedValue) {
          return allowedValue.name;
        } else {
          return this.item.default_value;
        }
      }
      return null;
    },

    content: {
      get: function get() {
        return this.item.content;
      },
      set: function set(value) {
        this.set("content", value);
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.limitEditingLocal = this.limitEditing;

    this.dataTypes = [];
    var dataTypesObject = this.$t('ui.drag_editor.fields.data_types');
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataTypesObject).forEach(function (value) {
      _this.dataTypes.push({
        name: dataTypesObject[value],
        value: value
      });
    });
  },
  mounted: function mounted() {
    this.setPermitEditAttributes();
  },

  methods: {
    setPermitEditAttributes: function setPermitEditAttributes() {
      this.limitEditingLocal = this.limitEditing;
      if (this.item) {
        if (this.item.element_type === "submit") {
          this.setupSubmit();
        } else if (this.item.element_type === "container_tab") {
          this.permitEditAttributes = ["label"];
        } else {
          this.permitEditAttributes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.item)));
        }

        // limit editing for gender as we dont want to manipulate the values
        if (this.item.name == 'gender') {
          this.limitEditingLocal = true;
        }
      }
    },
    setupSubmit: function setupSubmit() {
      // We have some certain rules for the submit button. Fx. don't allowed setting hidden/required
      this.permitEditAttributes = this.permitEditAttributesSubmit;
    },
    changeDefaultValue: function changeDefaultValue(value) {
      this.defaultValue = value;
    },
    deleteAllowedValue: function deleteAllowedValue(item) {
      var clonedAllowedValues = _.cloneDeep(this.allowedValues);
      var foundValue = clonedAllowedValues.find(function (val) {
        return val.value === item.value;
      });
      var idx = clonedAllowedValues.indexOf(foundValue);
      clonedAllowedValues.splice(idx, 1);
      this.allowedValues = clonedAllowedValues;
    },
    changeAllowedValues: function changeAllowedValues(value) {
      this.allowedValues = value;
    },
    deleteElement: function deleteElement() {
      this.$emit("delete", this.item);
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE", {});
    },
    set: function set(attribute, value) {
      this.$store.commit("UPDATE_DRAG_EDITOR_ACTIVE", {
        attribute: attribute,
        value: value
      });
    },
    hasAllowedValues: function hasAllowedValues() {
      // check if this item has allowed values
      if (this.allowedValues) {
        return true;
      } else {
        return false;
      }
    },
    canEdit: function canEdit(key) {
      // Shorthand to check if key is allowed to be edited
      return this.permitEditAttributes.includes(key);
    },
    addItem: function addItem() {
      var allowed_values = _.cloneDeep(this.allowedValues);
      allowed_values.push({
        name: "Name",
        value: "value_" + (allowed_values.length + 1)
      });
      this.changeAllowedValues(allowed_values);
    },
    setClassGrid: function setClassGrid(col, item) {
      this.set("class", col);
    },
    shouldShowName: function shouldShowName(editorName) {
      if (editorName == "ExternalForm") {
        return false;
      }
      return !["paragraph", "title", "container_tab", "submit"].includes(this.item.element_type);
    }
  },
  watch: {
    item: function item() {
      // Reset allowed attributes
      this.setPermitEditAttributes();
    }
  }
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    button: {
      type: Object,
      required: true
    }
  }
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    tab: {
      type: Object,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    }
  },
  mounted: function mounted() {
    // this removes the hover from the tab buttons
    var tabButtons = document.querySelector(".tab-btns > button.q-btn.inline.relative-position.q-btn-item.non-selectable.q-btn-rectangle.q-focusable.q-hoverable.q-btn-dropdown-current");
    tabButtons.classList.remove("q-hoverable");
    tabButtons.classList.remove("q-focusable");
    var tabDropDownArrow = document.querySelector(".tab-btns > button.q-btn.inline.relative-position.q-btn-item.non-selectable.q-btn-dropdown-arrow.q-btn-rectangle.q-focusable.q-hoverable");
    tabDropDownArrow.classList.remove("q-hoverable");
    tabDropDownArrow.classList.remove("q-focusable");
  },


  computed: {
    active: function active() {
      if (this.tab && this.$store.getters.getDragEditorActiveTab) {
        return this.$store.getters.getDragEditorActiveTab.name === this.tab.name;
      }
    },
    klass: function klass() {
      var arr = ['tab-btns'];
      if (this.active) {
        arr.push("active-tab");
      }
      return arr;
    },

    // this can be deprecated once all tab titles disappeared
    // we only use tab labels going forward
    getLabel: function getLabel() {
      if (this.tab.label) {
        return this.tab.label;
      } else {
        return this.tab.title;
      }
    }
  },
  methods: {
    click: function click() {
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE", this.tab);
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE_TAB", this.tab);
    },
    moveRight: function moveRight() {
      var current_tab_index = this.tabs.indexOf(this.tab);
      var new_tab_index = current_tab_index + 1;

      if (current_tab_index == this.tabs.length) {
        return;
      }

      this.reArrangeTabs(new_tab_index, this.tabs, this.tab);
    },
    moveLeft: function moveLeft() {
      var current_tab_index = this.tabs.indexOf(this.tab);
      var new_tab_index = current_tab_index - 1;

      if (current_tab_index == 0) {
        return;
      }

      this.reArrangeTabs(new_tab_index, this.tabs, this.tab);
    },
    reArrangeTabs: function reArrangeTabs(new_tab_index, tabs, tab) {
      _.remove(tabs, tab);

      tabs.splice(new_tab_index, 0, tab);
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE", tab);
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE_TAB", tab);
      this.$store.commit("SET_DRAG_EDITOR_EDITED", true);
    }
  }
});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_DragTab__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_DragTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_DragTab__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    tabs: {
      type: Array,
      required: true
    },
    editorName: {
      type: String
    }
  },
  components: {
    DragTab: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_DragTab___default.a
  },
  computed: {
    activeTab: function activeTab() {
      return this.$store.getters.getDragEditorActiveTab;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // For some reason won't work without this. Probably has to do with
              // the tabs being set empty first and then become filled in afterwards
              _this.setFirstTabActive();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setFirstTabActive: function setFirstTabActive() {
      // if we are in Lead Sheet Editor we have to ignore the main_tab and switch to the first tab instead
      if (this.editorName == 'LeadMask') {
        this.$store.commit('SET_DRAG_EDITOR_ACTIVE', this.tabs[0]);
        this.$store.commit('SET_DRAG_EDITOR_ACTIVE_TAB', this.tabs[0]);
      } else {
        this.$store.commit('SET_DRAG_EDITOR_ACTIVE', this.activeTab);
        this.$store.commit('SET_DRAG_EDITOR_ACTIVE_TAB', this.activeTab);
      }
    },
    addTab: function addTab() {

      var random_tab_name = Math.random().toString(36).substring(7) + '_tab';

      var position_last_item = parseInt(this.tabs.length);
      var item = {
        element_type: "container_tab",
        name: random_tab_name,
        parent_element: "root",
        label: 'Tab ' + (position_last_item + 1)
      };

      this.tabs.push(item);
    }
  }
});

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_Drag__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_EmptyState__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_EmptyState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_EmptyState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBus_js__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_Drag__["a" /* default */]],
  props: {
    limitEditing: {
      // Turning this to true stops the user from editing certain parameters of fields.
      // This is used in the lead sheet editor for example to limit editing to option values.
      type: Boolean,
      default: false
    },
    showTabs: {
      type: Boolean,
      default: false
    },
    editorName: {
      type: String
    }
  },
  components: {
    EmptyState: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_EmptyState___default.a
  },
  data: function data() {
    return {
      dragClass: "drag-dragging",
      windowWidth: window.innerWidth,
      resizeInterval: null
    };
  },

  computed: {
    emptyStateOptions: function emptyStateOptions() {
      return {
        heading: this.$t('ui.drag_editor.screenTooSmall.title'),
        subtitle: this.$t('ui.drag_editor.screenTooSmall.subtitle')
      };
    },
    submitButtonIsActive: function submitButtonIsActive() {
      return this.$store.getters.getDragEditorActiveItem === this.internalSubmitButton;
    },
    screenSizeIsTooSmall: function screenSizeIsTooSmall() {
      return this.windowWidth <= 766;
    }
  },
  mounted: function mounted() {
    this.$store.commit('SET_FOOTER_DISPLAY', false);
    __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].$on('action', this.handleAction);
    this.listenToSizeChanges();

    // NB! This is very important for the editor to work properly. If this is not done for some reason
    // the draggable part of the DragContainer will be skewed downwards and to the right - therefore
    // unaligning it with the editor itself. This means you have to drag items outside the boundary
    // of the editor in order to successfully drop them.
    // See: https://github.com/kutlugsahin/vue-smooth-dnd/issues/107
    this.resizeInterval = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 500);
  },
  destroyed: function destroyed() {
    if (this.resizeInterval) {
      clearInterval(this.resizeInterval);
    }
  },

  methods: {
    getGroupName: function getGroupName() {
      if (this.activeTab) {
        return this.activeTab.name;
      } else {
        return "target";
      }
    },
    listenToSizeChanges: function listenToSizeChanges() {
      var _this = this;

      window.onresize = function () {
        _this.windowWidth = window.innerWidth;
      };
    },
    handleAction: function handleAction(payload) {
      var action = payload.split('.')[1];
      var structure = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.internalStructure), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.internalTabs));

      // if submit button should be included, push here to the structure
      if (this.shouldIncludeSubmit) {
        structure.push(this.internalSubmitButton);
      }

      if (action === 'save') {
        this.$emit('save', structure);
      } else if (action === 'publish') {
        this.$emit('publish', structure);
      }
    },
    getItemGrid: function getItemGrid(item, editorName) {

      if (editorName == 'ExternalForm') {
        return 'col-12';
      } else {
        if (item.class) {
          return item.class;
        } else {
          return "col-12";
        }
      }
    },
    setSubmitActive: function setSubmitActive() {
      this.$store.commit('SET_DRAG_EDITOR_ACTIVE', this.internalSubmitButton);
    },
    internalStructureItems: function internalStructureItems() {
      if (this.showTabs) {
        return this.internalStructureByTab;
      } else {
        return this.internalStructure;
      }
    },
    cleanSectionItems: function cleanSectionItems(sectionItems, structure) {

      var clean_section_items = [];

      // here we filter all items that are UNIQUE in the Editor and are already present
      // isUniqueInCollection = item shall only exist one time on the Editor (usually a standard item like "firstname")
      // belongsToLeadSheet = used in FormEditor, it shall also only exist one time because its part of the LeadSheet
      sectionItems.forEach(function (item) {
        if (item.isUniqueInCollection || item.belongsToLeadSheet) {
          if (!structure.find(function (x) {
            return x.name === item.name;
          })) {
            clean_section_items.push(item);
          }
        } else {
          clean_section_items.push(item);
        }
      });

      return clean_section_items;
    },
    getMainDragContainerClass: function getMainDragContainerClass(editorName) {
      if (editorName == 'ExternalForm') {
        return "min-full-height-forms row gutter-xs";
      } else if (editorName == 'LeadMask') {
        return "min-full-height-lead-sheet row gutter-xs";
      } else {
        return "min-full-height row gutter-xs";
      }
    },
    tabsAvailable: function tabsAvailable() {
      if (this.internalTabs && this.internalTabs.length > 0 && this.internalStructure.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SET_FOOTER_DISPLAY', true);
    this.$store.commit('SET_DRAG_EDITOR_ACTIVE', {});
  }
});

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_smooth_dnd__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_SensualBadge__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_SensualBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_SensualBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_data_countries__ = __webpack_require__(143);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      countries: {}
    };
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: 'small'
    },
    setActiveOnClick: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Draggable: __WEBPACK_IMPORTED_MODULE_0_vue_smooth_dnd__["Draggable"],
    SensualBadge: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_SensualBadge___default.a
  },
  created: function created() {
    var countries = _.orderBy(__WEBPACK_IMPORTED_MODULE_2__config_data_countries__["a" /* default */]['de'], ['name'], ['asc']);
    this.countries = countries;
  },

  computed: {
    defaultValueSelectCountry: function defaultValueSelectCountry() {
      if (this.item.default_value) {
        return this.item.default_value;
      }
    },
    defaultValueSelect: function defaultValueSelect() {
      var _this = this;

      // We have to show the name of the object that is set as default_value - not the value
      if (this.item.default_value) {
        var val = this.item.allowed_values.find(function (e) {
          return e.value == _this.item.default_value;
        });
        if (val) {
          return val.name;
        }
      } else {
        return null;
      }
    },
    textBindings: function textBindings() {
      if (this.item.default_value) {
        return {
          value: this.item.default_value
        };
      }
      return {
        placeholder: this.item.placeholder
      };
    },
    name: function name() {
      var name = '';
      if (this.item.content) {
        name = this.item.content;
      } else {
        name = this.item.label;
      }
      if (this.item.required) {
        name += " *";
      }
      return name;
    },
    shownAllowedValues: function shownAllowedValues() {
      return this.item.allowed_values.slice(0, 5);
    },
    extraAllowedValuesText: function extraAllowedValuesText() {
      var sliceAmount = 5;
      if (this.item.element_type === 'select') {
        sliceAmount = 1;
      }
      return this.$t('ui.drag_editor.extra_values', { num: this.item.allowed_values.length - sliceAmount });
    },
    active: function active() {
      return this.$store.getters.getDragEditorActiveItem === this.item;
    },
    dragIcon: function dragIcon() {
      return __webpack_require__(288);
    },
    classes: function classes() {
      var arr = [];
      if (this.size === 'small') {
        arr.push('drag-item-small');
      } else if (this.size === 'big') {
        arr.push('drag-item-big');
      }
      if (this.active) {
        arr.push('active');
      }
      return arr;
    }
  },
  methods: {
    isSelected: function isSelected(item) {
      if (Array.isArray(this.item.default_value)) {
        return this.item.default_value.includes(item.value);
      } else {
        return this.item.default_value === item.value;
      }
    },
    labelClasses: function labelClasses(item) {
      if (item.element_type.includes('title')) {
        return ['drag-title'];
      }
      return [];
    },
    setActive: function setActive() {
      if (this.setActiveOnClick) {
        this.$store.commit('SET_DRAG_EDITOR_ACTIVE', this.item);
      }
    }
  }
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    items: {}
  },
  data: function data() {
    return {
      visible: false
    };
  },

  methods: {
    outsideClick: function outsideClick() {
      this.visible = false;
    },
    toggleVisible: function toggleVisible() {
      this.visible = !this.visible;
    }
  }
});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['content', 'title', 'btnClass', 'footer', 'actions'],
  methods: {
    close: function close() {
      this.isOpen = false;
    },
    open: function open() {
      this.isOpen = true;
    },
    actionTrigger: function actionTrigger(name) {
      this.$emit('action', name);
      this.close();
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  computed: {
    btnClassComputed: function btnClassComputed() {
      if (this.btnClass) {
        return this.btnClass;
      } else {
        return "btn";
      }
    }
  }
});

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    open: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    type: {
      // Allow different types of modals to exist
      type: String,
      default: "create",
      validator: function validator(val) {
        return ["create", "warning"].indexOf(val) !== -1;
      }
    },
    showCancelForWarning: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: "ui.global.cancel"
    },
    saveText: {
      type: String,
      default: "ui.global.save"
    },
    // Include buttons
    buttons: {
      type: Boolean,
      default: true
    },
    clickOutsideClose: {
      type: Boolean,
      default: true
    },
    saveDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      payload: {}
    };
  },

  computed: {
    warningSrc: function warningSrc() {
      return __webpack_require__(294);
    },
    computedModalComponentClass: function computedModalComponentClass() {
      var classes = [];
      if (this.type === "warning") {
        classes.push("warning");
      }
      return classes;
    },
    computedModalFooterButtonClass: function computedModalFooterButtonClass() {
      var classes = [];
      if (this.type === "warning" && this.showCancelForWarning == false || !this.cancelText) {
        classes.push("single--footer-button");
      }
      if (this.type == "create") {
        classes = classes.concat(["btn-primary", "btn-save"]);
      } else {
        classes = classes.concat(["btn-primary"]);
      }
      return classes;
    },
    computedModalInnerClass: function computedModalInnerClass() {
      var classes = [];
      if (!this.buttons) {
        classes.push("is-padding-bottom-0");
      }
      return classes;
    }
  },
  methods: {
    clickOutside: function clickOutside() {
      if (this.clickOutsideClose) {
        this.$emit("cancel");
      }
    },
    clickInside: function clickInside(event) {
      if (this.clickOutsideClose) {
        event.stopImmediatePropagation();
      }
    },
    cancel: function cancel() {
      this.$emit("cancel");
    },
    save: function save() {
      if (this) this.$emit("save");
    }
  }
});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isModified: {
      default: true
    },
    changeCount: {
      default: 0
    },
    sticky: {
      default: false
    }
  },
  computed: {
    classes: function classes() {
      var classes = ['page-saver'];
      if (this.sticky) {
        classes.push('sticky');
      }
      return classes;
    }
  },
  methods: {
    save: function save() {
      this.$emit('save');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tabs', 'active'],
  methods: {
    changeTab: function changeTab(key) {
      this.$emit('update', key);
    }
  }
});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    page: Number,
    totalPages: Number,
    pagesToDisplay: {
      type: Number,
      default: 3
    }
  },
  computed: {
    pages: function pages() {
      var output = [];
      if (this.totalPages <= this.pagesToDisplay * 4) {
        for (var i = 1; i <= this.totalPages; i++) {
          output.push(i);
        }
        return output;
      }

      for (var _i = 1; _i <= this.pagesToDisplay; _i++) {
        output.push(_i);
      }

      if (this.page > this.pagesToDisplay * 2 + 1) {
        output.push(-1);
      }
      if (this.page > this.pagesToDisplay) {
        for (var _i2 = this.page - this.pagesToDisplay; _i2 <= this.page; _i2++) {
          output.push(_i2);
        }
      }

      if (this.page <= this.totalPages - this.pagesToDisplay) {
        for (var _i3 = this.page; _i3 <= this.page + this.pagesToDisplay; _i3++) {
          output.push(_i3);
        }
      }

      if (this.page <= this.totalPages - (this.pagesToDisplay * 2 + 1)) {
        output.push(-2);
      }

      for (var _i4 = this.totalPages - this.pagesToDisplay + 1; _i4 <= this.totalPages; _i4++) {
        output.push(_i4);
      }
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(output)));
    }
  },
  methods: {
    goToPage: function goToPage(number) {
      this.$emit('goToPage', number);
    },
    prev: function prev() {
      var prev = this.page - 1;
      if (prev > 0) {
        this.goToPage(prev);
      }
    },
    next: function next() {
      var next = this.page + 1;
      if (next <= this.totalPages) {
        this.goToPage(next);
      }
    }
  }
});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventBus__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hasClicked: false
    };
  },

  // Allows double opt in for delete action.
  // Note that parent must reset this component if navigating away.
  //
  // beforeUpdate() {
  //   EventBus.$emit("doubleDeleteReset");
  // },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__EventBus__["a" /* EventBus */].$on("doubleDeleteReset", this.reset);
  },

  methods: {
    reset: function reset() {
      this.hasClicked = false;
    },
    click: function click(event) {
      this.hasClicked = true;
      // Allows our v-click-outside to work
      event.stopPropagation();
    },
    onDelete: function onDelete() {
      this.$emit("delete");
      this.hasClicked = false;
    }
  }
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded__);
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Collection: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection___default.a, DeleteAction: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded___default.a },
  props: ['loading', 'data', 'structure', 'id', 'params', 'has_searched', 'model'],
  methods: {
    sorting: function sorting(payload) {
      this.$emit('sorting', payload);
    },
    itemDelete: function itemDelete(payload) {
      this.$emit('itemDelete', payload);
    },
    date: function date(_date) {
      return moment(_date).format("DD.MM.YYYY");
    }
  },
  computed: {
    actionDeleteColumn: function actionDeleteColumn() {
      return _.find(this.structure, { name: 'action' });
    }
  }
});

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_resize_detector__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);

//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    leadsCount: {
      type: Object
    },
    dateFormat: {
      type: String,
      default: "DD/MM"
    },
    startDate: String,
    endDate: String
  },
  data: function data() {
    return {
      stats: [],
      labels: [],
      precision: 'day'
    };
  },
  mounted: function mounted() {
    if (this.leadsCount) {
      this.setupPrecision();
      this.processTrackings(this.leadsCount, this.precision);
      this.drawChart();
    }
    var erd = __WEBPACK_IMPORTED_MODULE_1_element_resize_detector___default()();
    erd.listenTo(document.querySelector(".chart"), function (element) {});
  },

  methods: {
    date: function date(_date) {
      return moment(_date).fromNow();
    },
    setupPrecision: function setupPrecision() {
      var start_date = new moment(this.startDate);
      var end_date = new moment(this.endDate);

      var differenceDay = end_date.diff(start_date, 'days');

      if (differenceDay <= 3) {
        this.precision = "hour";
      } else if (differenceDay <= 80) {
        this.precision = "day";
      } else {
        this.precision = "week";
      }
    },
    processTrackings: function processTrackings(trackings, breakdown) {
      var _this = this;

      this.labels = [];
      this.stats = [];
      if (trackings) {
        var start_date = new moment(this.startDate);
        var end_date = new moment(this.endDate);

        var _loop = function _loop(i) {
          _this.labels.push(i.format("hh:mm HH m M MM"));
          var result = void 0;
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(trackings).map(function (objectKey, index) {
            var count = trackings[objectKey];
            var date = moment(objectKey);
            if (date.isSame(i, breakdown)) {
              result = count;
              return;
            }
          });
          if (result) {
            _this.stats.push({ y: result, x: i.format() });
          } else {
            _this.stats.push({ y: 0, x: i.format() });
          }
        };

        for (var i = start_date; i <= end_date; i.add(1, breakdown + 's')) {
          _loop(i);
        }
      }
    },
    drawChart: function drawChart() {
      var data = [];
      this.stats.forEach(function (tracking) {
        var formatted = { x: new Date(tracking.time), y: 1 };
        data.push(formatted);
      });
      var options = {
        tooltips: {
          enabled: false
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: "time",
            time: {
              unit: 'day'
            } }],
          axesY: [{
            ticks: {
              scaleMinSpace: 50,
              stepSize: 1,
              min: 0,
              autoSkip: true
            }
          }]
        },
        maintainAspectRatio: false,
        padding: {
          left: 0, right: 0, top: 0, bottom: 0
        }
      };

      var chart = new Chart(this.$refs.chart.getContext('2d'), {
        type: 'line',
        data: { datasets: [{
            data: this.stats,
            lineTension: 0.2,
            fill: false,
            borderColor: '#1B88FD'
          }] },
        options: options
      });
    }
  },
  watch: {
    trackings: function trackings() {
      if (this.leadsCount) {
        this.setupPrecision();
        this.processTrackings(this.leadsCount, this.precision);
        this.drawChart();
      }
    }
  }
});

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(229);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      newFilters: {},
      syncStatusCollection: [{ value: 'not_synced' }, { value: 'not_sync_ready' }, { value: 'sync_ready' }, { value: 'sync_error' }, { value: 'synced' }, { value: 'no_crm' }],
      originCollection: [{ value: "web_app" }, { value: "mobile_app" }, { value: "external_form" }],
      syncDisabledCollection: [{ value: "true" }, { value: "false" }],
      importOriginCollection: [{ value: "xls" }, { value: "crm" }]
    };
  },

  props: ['filters'],
  beforeMount: function beforeMount() {
    this.init();
  },

  methods: {
    init: function init() {
      if (!_.isEmpty(this.filters.filters)) {
        this.newFilters = this.filters.filters;
      } else {
        this.newFilters = { sync_status: { value: [] }, sync_disabled: { value: [] }, origin: { value: [] }, import_origin: { value: [] }, start_date: { start: null, end: null, type: 'date' } };
      }

      if (!this.newFilters.sync_status) {
        this.newFilters.sync_status.value = [];
      }
      if (!this.newFilters.origin) {
        this.newFilters.origin.value = [];
      }
      if (!this.newFilters.import_origin) {
        this.newFilters.import_origin.value = [];
      }
      if (!this.newFilters.sync_disabled) {
        this.newFilters.sync_disabled.value = [];
      }
      if (!this.newFilters.start_date) {
        this.newFilters.start_date = {};
        this.newFilters.start_date.start = null;
        this.newFilters.start_date.end = null;
        this.newFilters.start_date.type = 'date';
      }
      if (!this.newFilters.tags) {
        this.newFilters.tags = {};
        this.newFilters.tags.value = [];
        this.newFilters.tags.type = 'tag';
      }
    },
    reset: function reset() {
      this.$emit('reset', this.newFilters);
    },
    apply: function apply() {
      this.$emit('apply', this.newFilters);
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: function handler() {
        this.newFilters = this.filters.filters;
      }
    }
  }
});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrmStatus__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrmStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrmStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_ProgressBar__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_ProgressBar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Collection: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection___default.a, CrmStatus: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrmStatus___default.a, DeleteAction: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded___default.a, ProgressBar: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_ProgressBar___default.a },
  props: ["loading", "data", "structure", "id", "params", "has_searched"],
  methods: {
    sorting: function sorting(payload) {
      this.$emit("sorting", payload);
    },
    itemDelete: function itemDelete(payload) {
      this.$emit("itemDelete", payload);
    },
    date: function date(_date) {
      return moment(_date).format("DD.MM.YYYY");
    }
  },
  computed: {
    crmStatusColumn: function crmStatusColumn() {
      return _.find(this.structure, { name: "sync_status" });
    },
    progressColumn: function progressColumn() {
      return _.find(this.structure, { name: "sync_status" });
    },
    actionDeleteColumn: function actionDeleteColumn() {
      return _.find(this.structure, { name: "action" });
    }
  }
});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading'
});

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      salesPageURL: "https://fanomena.io"
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_MAIN_CONTAINER_CLASSES', ['locked']);
  },
  destroyed: function destroyed() {
    this.$store.commit('SET_MAIN_CONTAINER_CLASSES', []);
  },

  methods: {
    navigateSalesPage: function navigateSalesPage() {
      window.location.href = this.salesPageURL;
    },
    close: function close() {
      this.$store.commit('SET_NOT_ALLOWED_MODAL_SHOWN', false);
    }
  }
});

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrmStatus__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrmStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrmStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_ProgressBar__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_ProgressBar__);
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Collection: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_Collection___default.a, CrmStatus: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_CollectionValues_CollectionValueCrmStatus___default.a, DeleteAction: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_CollectionValues_CollectionValueCrudActionFolded___default.a, ProgressBar: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_ProgressBar___default.a },
  props: ['loading', 'data', 'structure', 'id', 'params', 'has_searched'],
  methods: {
    sorting: function sorting(payload) {
      this.$emit('sorting', payload);
    },
    itemDelete: function itemDelete(payload) {
      this.$emit('itemDelete', payload);
    },
    date: function date(_date) {
      return moment(_date).format("DD.MM.YYYY");
    }
  },
  computed: {
    actionDeleteColumn: function actionDeleteColumn() {
      return _.find(this.structure, { name: 'action' });
    }
  }
});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Specific_TrackingChart__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Specific_TrackingChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_Specific_TrackingChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['stats', 'trackings', 'startDate', 'endDate'],
  components: { TrackingChart: __WEBPACK_IMPORTED_MODULE_0__components_helpers_Specific_TrackingChart___default.a },
  methods: {
    percentage: function percentage(base, number) {
      if (base == 0) {
        return 0;
      }
      return Math.floor(number / base * 100);
    },
    baseOne: function baseOne(base, number) {
      if (base == 0) {
        base = 1;
      }
      if (number == 0) {
        number = 1;
      }
      return Math.floor(number / base * 100) / 100;
    },
    actionsPerDay: function actionsPerDay(actions) {
      var difference = moment(this.endDate).diff(moment(this.startDate), 'days');
      return Math.floor(actions / difference * 100) / 100;
    }
  }

});

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_resize_detector__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    trackings: {
      type: Array
    },
    dateFormat: {
      type: String,
      default: "DD/MM"
    },
    startDate: String,
    endDate: String
  },
  data: function data() {
    return {
      stats: [],
      labels: [],
      precision: 'day'
    };
  },

  methods: {
    date: function date(_date) {
      return moment(_date).fromNow();
    },
    setupPrecision: function setupPrecision() {
      var start_date = new moment(this.startDate);
      var end_date = new moment(this.endDate);

      var differenceDay = end_date.diff(start_date, 'days');

      if (differenceDay <= 3) {
        this.precision = "hour";
      } else if (differenceDay <= 80) {
        this.precision = "day";
      } else {
        this.precision = "week";
      }
    },
    processTrackings: function processTrackings(trackings, breakdown) {
      var _this = this;

      this.labels = [];
      this.stats = [];
      if (trackings.length > 0) {
        var start_date = new moment(this.startDate);
        var end_date = new moment(this.endDate);

        var _loop = function _loop(i) {
          _this.labels.push(i.format("hh:mm HH m M MM"));
          var result = trackings.filter(function (obj) {
            return moment(obj.time).isSame(i, breakdown);
          });
          _this.stats.push({ y: result.length, x: i.format() });
        };

        for (var i = start_date; i <= end_date; i.add(1, breakdown + 's')) {
          _loop(i);
        }
      }
    },
    drawChart: function drawChart() {
      var data = [];
      this.stats.forEach(function (tracking) {
        var formatted = { x: new Date(tracking.time), y: 1 };
        data.push(formatted);
      });
      var options = {
        tooltips: {
          enabled: false
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: "time",
            time: {
              unit: 'day'
            } }],
          yAxes: [{
            ticks: {
              stepSize: 1,
              min: 0
            }
          }]
        },
        maintainAspectRatio: false,
        padding: {
          left: 0, right: 0, top: 0, bottom: 0
        }
      };

      var chart = new Chart(this.$refs.chart.getContext('2d'), {
        type: 'line',
        data: { datasets: [{
            data: this.stats,
            lineTension: 0.2,
            fill: false,
            borderColor: '#1B88FD'
          }] },
        options: options
      });
    }
  },
  mounted: function mounted() {
    if (this.trackings) {
      this.setupPrecision();
      this.processTrackings(this.trackings, this.precision);
      this.drawChart();
    }
    var erd = __WEBPACK_IMPORTED_MODULE_0_element_resize_detector___default()();
    erd.listenTo(document.querySelector(".chart"), function (element) {});
  },

  watch: {
    trackings: function trackings() {
      if (this.trackings) {
        this.setupPrecision();
        this.processTrackings(this.trackings, this.precision);
        this.drawChart();
      }
    }
  }
});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      salesPageURL: "https://fanomena.io"
    };
  },

  methods: {
    navigateSalesPage: function navigateSalesPage() {
      window.location.href = this.salesPageURL;
    }
  }
});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    firstname: {
      type: String,
      default: ''
    },
    lastname: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: ''
    }
  },

  methods: {
    userInitials: function userInitials() {
      if (this.firstname && this.lastname) {
        return this.firstname.charAt(0) + this.lastname.charAt(0);
      } else if (this.firstname) {
        return this.firstname.charAt(0);
      } else if (this.lastname) {
        return this.lastname.charAt(0);
      } else if (this.email) {
        return this.email.charAt(0);
      } else {
        return '?';
      }
    }
  }
});

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_data_user_roles_js__ = __webpack_require__(923);
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-role-select',
  components: { Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField___default.a },
  props: {
    label: String,
    classes: Array,
    name: String,
    value: [String, Boolean],
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      roles: __WEBPACK_IMPORTED_MODULE_1__config_data_user_roles_js__["a" /* default */],
      newValue: ''
    };
  },
  created: function created() {
    this.newValue = this.value;
  },

  watch: {
    value: function value() {
      this.newValue = this.value;
    },
    newValue: function newValue() {
      this.$emit('input', this.newValue);
    }
  }
});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_data_user_statuses_js__ = __webpack_require__(924);
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-status-select',
  components: { Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_FormField___default.a },
  props: {
    label: String,
    classes: Array,
    name: String,
    value: [String, Boolean],
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      statuses: __WEBPACK_IMPORTED_MODULE_1__config_data_user_statuses_js__["a" /* default */],
      newValue: ''
    };
  },
  created: function created() {
    this.newValue = this.value;
  },

  watch: {
    value: function value() {
      this.newValue = this.value;
    },
    newValue: function newValue() {
      this.$emit('input', this.newValue);
    }
  }
});

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_MobileNavigation_vue__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_MobileNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_MobileNavigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_SecondaryHeader_vue__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_SecondaryHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_SecondaryHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordReset_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordReset_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordReset_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layouts_partials_AppFooter__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layouts_partials_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_layouts_partials_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_Session__ = __webpack_require__(61);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "dashboard-layout",
  components: {
    AppFooter: __WEBPACK_IMPORTED_MODULE_6__components_layouts_partials_AppFooter___default.a,
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue___default.a,
    MobileNavigation: __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_MobileNavigation_vue___default.a,
    SecondaryHeader: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_SecondaryHeader_vue___default.a,
    Searchbar: __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue___default.a
  },
  computed: {
    computedClasses: function computedClasses() {
      return "level-" + __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].getLevel();
    },
    tabs: function tabs() {
      return this.$store.state.tabs.length > 0;
    },
    isPageLead: function isPageLead() {
      return this.$route.name == "project_lead_edit";
    },
    isPageLeads: function isPageLeads() {
      return this.$route.name == "project_leads";
    },
    isPageProjects: function isPageProjects() {
      return this.$route.name == "projects";
    },
    isPageProjectNew: function isPageProjectNew() {
      return this.$route.name == "project_new";
    },
    isPageContent: function isPageContent() {
      return this.$route.name == "content_manager";
    },
    isEmptyState: function isEmptyState() {
      return this.$store.getters.getEmptyState;
    },
    emptyStateProjects: function emptyStateProjects() {
      return this.isEmptyState === "projects" && (this.$route.name == "projects" || "project_new");
    },
    emptyStateLeads: function emptyStateLeads() {
      return this.isEmptyState === "leads" && this.$route.name == "project_leads";
    },
    isRetrieving: function isRetrieving() {
      return this.$store.getters.getIsRetrieving;
    },
    isShowingOnboarding: function isShowingOnboarding() {
      return !this.$store.getters.getUserIsOnboarded;
    },
    isFormBuilder: function isFormBuilder() {
      return this.$route.name == "external_form_edit";
    }
  },
  watch: {
    $route: function $route() {
      // We also close the drawer everytime we change page
      this.$store.commit("SET_DRAWER_VISIBLE", false);
    }
  }
});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_SecondaryHeader_vue__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_SecondaryHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_SecondaryHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Searchbar_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Searchbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Searchbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_PasswordReset_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_PasswordReset_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_auth_PasswordReset_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_AppFooter__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Session__ = __webpack_require__(61);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout',
  components: {
    AppFooter: __WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_AppFooter___default.a,
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue___default.a,
    SecondaryHeader: __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_SecondaryHeader_vue___default.a,
    Searchbar: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Searchbar_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_Loading_vue___default.a
  },
  computed: {
    computedClasses: function computedClasses() {
      return 'level-' + __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].getLevel();
    },
    tabs: function tabs() {
      return this.$store.state.tabs.length > 0;
    },
    isPageLead: function isPageLead() {
      return this.$route.name == "project_lead_edit";
    },
    isPageLeads: function isPageLeads() {
      return this.$route.name == "project_leads";
    },
    isPageProjects: function isPageProjects() {
      return this.$route.name == "projects";
    },
    isPageProjectNew: function isPageProjectNew() {
      return this.$route.name == "project_new";
    },
    isPageContent: function isPageContent() {
      return this.$route.name == "content_manager";
    },
    isEmptyState: function isEmptyState() {
      return this.$store.getters.getEmptyState;
    },
    emptyStateProjects: function emptyStateProjects() {
      return this.isEmptyState === 'projects' && (this.$route.name == "projects" || "project_new");
    },
    emptyStateLeads: function emptyStateLeads() {
      return this.isEmptyState === 'leads' && this.$route.name == "project_leads";
    },
    isRetrieving: function isRetrieving() {
      return this.$store.getters.getIsRetrieving;
    },
    isShowingOnboarding: function isShowingOnboarding() {
      return !this.$store.getters.getUserIsOnboarded;
    },
    isFormBuilder: function isFormBuilder() {
      return this.$route.name == "external_form_edit";
    }
  },
  watch: {
    $route: function $route() {
      // We also close the drawer everytime we change page
      this.$store.commit('SET_DRAWER_VISIBLE', false);
    }
  }
});

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_MobileNavigation_vue__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_MobileNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_MobileNavigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_SecondaryHeader_vue__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_SecondaryHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_SecondaryHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordReset_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordReset_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_auth_PasswordReset_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layouts_partials_AppFooter__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layouts_partials_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_layouts_partials_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_Session__ = __webpack_require__(61);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout',
  components: {
    AppFooter: __WEBPACK_IMPORTED_MODULE_6__components_layouts_partials_AppFooter___default.a,
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Navigation_vue___default.a,
    SecondaryHeader: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_SecondaryHeader_vue___default.a,
    MobileNavigation: __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_MobileNavigation_vue___default.a,
    Searchbar: __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue___default.a
  },
  computed: {
    computedClasses: function computedClasses() {
      return 'level-' + __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].getLevel();
    },
    tabs: function tabs() {
      return this.$store.state.tabs.length > 0;
    },
    isPageLead: function isPageLead() {
      return this.$route.name == "project_lead_edit";
    },
    isPageLeads: function isPageLeads() {
      return this.$route.name == "project_leads";
    },
    isPageProjects: function isPageProjects() {
      return this.$route.name == "projects";
    },
    isPageProjectNew: function isPageProjectNew() {
      return this.$route.name == "project_new";
    },
    isPageContent: function isPageContent() {
      return this.$route.name == "content_manager";
    },
    isEmptyState: function isEmptyState() {
      return this.$store.getters.getEmptyState;
    },
    emptyStateProjects: function emptyStateProjects() {
      return this.isEmptyState === 'projects' && (this.$route.name == "projects" || "project_new");
    },
    emptyStateLeads: function emptyStateLeads() {
      return this.isEmptyState === 'leads' && this.$route.name == "project_leads";
    },
    isRetrieving: function isRetrieving() {
      return this.$store.getters.getIsRetrieving;
    },
    isShowingOnboarding: function isShowingOnboarding() {
      return !this.$store.getters.getUserIsOnboarded;
    }
  },
  watch: {
    $route: function $route() {
      // We also close the drawer everytime we change page
      this.$store.commit('SET_DRAWER_VISIBLE', false);
    }
  }
});

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_auth_Login__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_auth_Login__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Login: __WEBPACK_IMPORTED_MODULE_0__components_auth_Login___default.a }
});

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus_js__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttons: function buttons() {
      return this.$store.getters.getHeaderButtons;
    }
  },
  methods: {
    allowedAccess: function allowedAccess(button) {
      if (button.access) {
        return __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].planCan(button.access);
      } else {
        return true;
      }
    },
    action: function action(button) {
      // define event name, fallback to 'action' if none used

      var event_name = "action";
      if (button.event_name) {
        event_name = button.event_name;
      }

      if (button.access) {
        if (!this.allowedAccess(button)) {
          this.$store.commit("SET_NOT_ALLOWED_MODAL_SHOWN", true);
          return;
        }
      }
      if (button.function) {
        button.function();
        return;
      }
      if (button.action.includes(".new")) {
        this.$router.push({ name: button.name + "_new" });
      } else {
        // check debouncing
        if (button.debounce) {
          document.getElementById(button.action).disabled = true;

          __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].$emit(event_name, button.action);
          setTimeout(function () {
            document.getElementById(button.action).disabled = false;
          }, button.debounce);
        } else {
          __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].$emit(event_name, button.action);
        }
      }
    },
    can: function can(button) {
      // hide button if its not supposed to be shown (e.g. due to the parent component telling so)
      if (button.show == false) {
        return false;
      }

      var permission = __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].loadPermissions();
      return __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].can(permission, button.action);
    }
  }
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['hasX', 'hasMask', 'canClickMask'],

  methods: {
    clickX: function clickX() {
      this.$emit('toggle');
    },
    clickMask: function clickMask() {
      if (this.canClickMask) {
        this.$emit('toggle');
      }
    }
  }
});

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AppDownloadModal__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AppDownloadModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AppDownloadModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_User__ = __webpack_require__(33);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var MAX_AGE_COOKIE = 60 * 60 * 24 * 7 * 4 * 12 * 10; // 10 years
var COOKIE_KEY_VALUE = 'is-seen-app-download-modal=true';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AppDownloadModal: __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AppDownloadModal___default.a
  },
  data: function data() {
    return {
      modal: {
        screenIsOpen: false,
        hasMask: false
      }
    };
  },
  mounted: function mounted() {
    // Show modal only if not seen before
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_eq___default()(document.cookie.indexOf(COOKIE_KEY_VALUE), -1)) {
      this.modal.screenIsOpen = true;
    }
  },


  methods: {
    toggleModal: function toggleModal() {
      this.modal.screenIsOpen = !this.modal.screenIsOpen;
    },
    finish: function finish() {
      this.modal.screenIsOpen = false;
      document.cookie = COOKIE_KEY_VALUE + ';max-age=' + MAX_AGE_COOKIE;
    }
  }
});

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_Copyright__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_Copyright__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo___default.a,
    Copyright: __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_Copyright___default.a
  },
  computed: {
    footerLinksHref: function footerLinksHref() {
      return this.$store.getters.getFooterLinks;
    },
    shouldDisplay: function shouldDisplay() {
      return this.$store.getters.getFooterDisplay;
    },
    footerLinks: function footerLinks() {
      return [{
        href: this.footerLinksHref.imprint,
        title: 'imprint'
      }, {
        href: this.footerLinksHref.privacy,
        title: 'privacy'
      }, {
        href: this.footerLinksHref.terms,
        title: 'terms'
      }];
    }
  }
});

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModalElement__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModalElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModalElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_AssignmentModalSearchBar__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_AssignmentModalSearchBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_AssignmentModalSearchBar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    // Which attribute to use as label
    displayName: {
      type: String,
      default: 'name'
    },
    searchPlaceholder: {
      type: String,
      required: true
    },
    collection: {
      type: Array,
      required: true
    },
    assignedCollection: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AssignmentModalSearchBar: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_AssignmentModalSearchBar___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal___default.a,
    AssignmentModalElement: __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModalElement___default.a
  },
  data: function data() {
    return {
      // Copy assignedCollection so we can alter it and only save
      // when save is clicked
      internalAssignedCollection: _.clone(this.assignedCollection),
      filteredCollection: [],
      shouldFocusSearchbar: false
    };
  },
  mounted: function mounted() {
    this.resetFilteredCollection();
  },

  methods: {
    setShouldFocus: function setShouldFocus() {
      this.shouldFocusSearchbar = false;
    },
    search: function search(term) {
      var _this = this;

      if (term) {
        var searchCollection = this.collection.filter(function (item) {
          return item[_this.displayName].toLowerCase().includes(term.toLowerCase());
        });
        this.filteredCollection = searchCollection;
      } else {
        this.resetFilteredCollection();
      }
    },
    resetFilteredCollection: function resetFilteredCollection() {
      this.filteredCollection = this.collection;
    },
    assign: function assign(item, val) {
      if (val) {
        if (!this.internalAssignedCollection.includes(item)) {
          this.internalAssignedCollection.push(item);
        }
      } else {
        if (this.internalAssignedCollection.includes(item)) {
          var idx = this.internalAssignedCollection.indexOf(item);
          this.internalAssignedCollection.splice(idx, 1);
        }
      }
      this.shouldFocusSearchbar = true;
    },
    save: function save() {
      this.$emit('save', this.internalAssignedCollection);
    },
    resetInternalCollection: function resetInternalCollection() {
      // Clone so that we don't get the listeners
      this.internalAssignedCollection = _.clone(this.assignedCollection);
    },
    cancel: function cancel() {
      this.resetInternalCollection();
      this.$emit('close');
    }
  },
  watch: {
    assignedCollection: function assignedCollection() {
      this.resetInternalCollection();
    },
    open: function open(val) {
      // If it switched to open reset the collection
      if (val) {
        this.resetFilteredCollection();
      }
    }
  }
});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    displayName: {
      // Which attribute to use for label
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    assignedCollection: {
      type: Array,
      required: true
    }
  },
  computed: {
    assigned: function assigned() {
      return this.assignedCollection.includes(this.item);
    },
    label: function label() {
      return this.item[this.displayName];
    }
  },
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default.a
  },
  methods: {
    input: function input(val) {
      // If outer div is clicked val will be a click object
      if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(val)) === 'object') {
        val = !this.$refs.input.value;
      }
      this.$emit("input", this.item, val);
    }
  }
});

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    placeholder: {
      type: String,
      required: true
    },
    shouldFocus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedPlaceholder: function computedPlaceholder() {
      return this.$t('ui.searchbar.placeholder.' + this.placeholder);
    }
  },
  data: function data() {
    return {
      term: null
    };
  },
  mounted: function mounted() {
    this.$refs.searchbar.focus();
  },

  methods: {
    search: function search() {
      this.$emit('search', this.term);
    }
  },
  watch: {
    term: function term() {
      this.search();
    },
    shouldFocus: function shouldFocus(val) {
      if (val) {
        this.$refs.searchbar.focus();
        this.$emit('shouldFocusChange');
      }
    }
  }
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_Permission__ = __webpack_require__(12);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    bindings: {
      type: Object
    },
    label: {
      type: String
    },
    auth: {}
  },
  data: function data() {
    return {
      unauthorizedBindings: {
        "to": "",
        "disable": true
      },
      unauthorizedTalentBindings: {
        "to": "",
        "hidden": true
      }
    };
  },

  computed: {
    authorized: function authorized() {
      if (this.auth) {
        return __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].planCan(this.auth);
      }
      return true;
    },
    planIsTalent: function planIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent;
    },
    objectBindings: function objectBindings() {
      if (!this.authorized) {
        if (this.planIsTalent) {
          return this.unauthorizedTalentBindings;
        }
        return this.unauthorizedBindings;
      }
      return this.bindings;
    },
    translatedLabel: function translatedLabel() {
      return this.$t("ui.menu." + this.label);
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.authorized) {
        this.$store.commit('SET_NOT_ALLOWED_MODAL_SHOWN', true);
        this.$emit('close', true);
      }
    }
  }
});

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentYear: function currentYear() {
      var currentDate = new Date();
      return currentDate.getFullYear();
    }
  }
});

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FoldedNavigationItem_vue__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FoldedNavigationItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FoldedNavigationItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus__ = __webpack_require__(10);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "folded-navigation",
  components: {
    FoldedNavigationItem: __WEBPACK_IMPORTED_MODULE_0__FoldedNavigationItem_vue___default.a
  },
  props: {
    items: {}
  },
  data: function data() {
    return {
      overflow: null
    };
  },
  mounted: function mounted() {
    this.handleVisibility();
    __WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* EventBus */].$off("compute_folded");
    __WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* EventBus */].$on("compute_folded", this.handleVisibility);
    window.addEventListener("resize", this.handleVisibility);
    __WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* EventBus */].$off("compute_folded");
  },
  unmounted: function unmounted() {
    window.removeEventListener("resize", this.handleVisibility);
  },

  computed: {
    filteredItems: function filteredItems() {
      var permission = __WEBPACK_IMPORTED_MODULE_1__classes_Permission__["a" /* default */].loadPermissions();
      return this.items.filter(function (i) {
        if (!i.credential) {
          return true;
        }
        return __WEBPACK_IMPORTED_MODULE_1__classes_Permission__["a" /* default */].can(permission, i.credential);
      });
    }
  },
  methods: {
    isOverflown: function isOverflown(element) {
      if (element) {
        return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
      }
    },
    handleVisibility: function handleVisibility() {
      var _this = this;

      var elem = this.$refs.listContainer;
      setTimeout(function () {
        _this.overflow = _this.isOverflown(elem);
        if (!!_this.overflow) {
          _this.$emit("overflow", _this.overflow);
        }
      }, 350);
    }
  },
  watch: {
    $route: function $route() {
      this.handleVisibility();
    }
  }
});

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_NavigationLockedItem_vue__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_NavigationLockedItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_NavigationLockedItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_Permission__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'folded-navigation-item',
  props: ['item', 'parentWidth'],
  components: {
    NavigationLockedItem: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_NavigationLockedItem_vue___default.a
  },
  computed: {
    itemClasses: function itemClasses() {
      var classes = ['folded-navigation-item', this.item.name];
      if (this.overflow === true) {
        classes.push('is-hidden');
      }
      if (this.item.shouldNotChangeRoute && this.isActive) {
        classes.push('is-active');
      }
      return classes;
    },
    activeTab: function activeTab() {
      return this.$store.getters.getActiveTab;
    },

    isActive: function isActive() {
      if (this.item.name && this.activeTab === this.item.name) {
        return true;
      } else if (this.$route.name === this.item.name) {
        return true;
      } else {
        return false;
      }
    },
    allowedAccess: function allowedAccess() {
      if (this.item.access) {
        return __WEBPACK_IMPORTED_MODULE_1__classes_Permission__["a" /* default */].planCan(this.item.access);
      } else {
        return true;
      }
    }
  },
  data: function data() {
    return {
      overflow: false
    };
  },

  methods: {
    calculateNavigation: function calculateNavigation() {
      this.overflow = false;

      var element = this.$el;
      var width = element.clientWidth;
      var left = element.offsetLeft;

      if (this.parentWidth < width + left + 10 || width + left + 10 === 10) {
        this.overflow = true;
        this.$store.commit('ADD_FOLDED_NAVIGATION_HIDDEN_ITEMS', this.item);
      } else {
        this.overflow = false;
      }
    },

    // we want to clean the pagination from the leads when we click on folded navigation
    onClick: function onClick() {
      if (this.item.name === 'project_leads' && this.$route.name == "project_leads") {
        this.$store.commit('RESET_CURRENT_PAGE_LEADS');
      } else if (this.item.name === "external_forms" && this.$route.name == "external_forms") {
        this.$store.commit('RESET_CURRENT_PAGE_EXTERNAL_FORMS');
      }

      if (this.item.shouldNotChangeRoute) {
        this.$store.commit('SET_ACTIVE_TAB', this.item.name);
      }
    }
  }
});

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

var _languages = {
  hileadzz: [{
    label: 'English',
    value: 'en'
  }, {
    label: 'Deutsch',
    value: 'de'
  }],
  talents: [{
    label: 'English',
    value: 'en-tal'
  }, {
    label: 'Deutsch',
    value: 'de-tal'
  }]
};
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      otherLanguage: {
        label: undefined,
        value: undefined
      }
    };
  },

  computed: {
    label: function label() {
      return this.$t('ui.menu.change-language');
    },
    currentLanguage: function currentLanguage() {
      return this.$store.getters.getCurrentLanguage;
    },
    planIsTalents: function planIsTalents() {
      return this.$store.getters.getCurrentPlanIsTalent;
    },
    languages: function languages() {
      if (!this.planIsTalents) {
        return _languages.hileadzz;
      } else {
        return _languages.talents;
      }
    }
  },
  mounted: function mounted() {
    this.calculateOtherLanguage();
  },

  methods: {
    changeLanguage: function changeLanguage() {
      var language = this.otherLanguage.value;
      this.$store.commit('CHANGE_LANGUAGE', language);
    },
    calculateOtherLanguage: function calculateOtherLanguage() {
      var _this = this;

      this.otherLanguage = this.languages.find(function (o) {
        return o.value !== _this.currentLanguage;
      });
    }
  },
  watch: {
    planIsTalents: function planIsTalents() {
      this.calculateOtherLanguage();
    },
    currentLanguage: function currentLanguage() {
      this.calculateOtherLanguage();
    }
  }
});

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    logoType: {
      type: String
    },
    greyscale: {
      type: Boolean,
      default: false
    },
    lowOpacity: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      classes: []
    };
  },

  computed: {
    shouldNotShowLogoYet: function shouldNotShowLogoYet() {
      // If the organization plan is not set and we're not on the login screen don't show logo.
      // Otherwise if plan is Talent the normal Leads logo will show for 1 second before it changes to Talent logo.
      // On login screen always show logo.
      var isLoginPage = this.$route.name === 'login';
      var planExists = !!this.$store.getters.getCurrentOrganizationPlan;
      return !isLoginPage && !planExists;
    },
    currentPlanIsTalent: function currentPlanIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent;
    },
    logoSrc: function logoSrc() {
      if (this.shouldNotShowLogoYet) {
        return;
      }
      var path = undefined;
      if (this.currentPlanIsTalent) {
        path = "talents_logo";
      } else {
        path = "logo_sign";
      }
      if (this.logoType === "login") {
        path += "_login";
      }
      if (this.logoType === "grey") {
        path += "_grey";
      }
      return __webpack_require__(342)("./" + path + ".svg");
    }
  }
});

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AuthenticatedNavigationItem__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AuthenticatedNavigationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AuthenticatedNavigationItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_LanguageSwitcher_vue__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_LanguageSwitcher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_LanguageSwitcher_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_AddButton_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_AddButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_AddButton_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "mobile-navigation",
  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_Logo___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_LanguageSwitcher_vue___default.a,
    AuthenticatedNavigationItem: __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AuthenticatedNavigationItem___default.a,
    AddButton: __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_AddButton_vue___default.a
  },
  data: function data() {
    return {
      LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_LanguageSwitcher_vue___default.a,
      drawer: false
    };
  },

  computed: {
    compressed: function compressed() {
      return this.$store.getters.getHeaderState.compressed;
    },
    compressedUnpublishedChanges: function compressedUnpublishedChanges() {
      // Right now only works for DragNDropEditor but can be made to use anything
      return this.$store.getters.getDragEditorUnpublishedChanges;
    },
    compressedTitle: function compressedTitle() {
      var pageTitle = this.$store.state.page_title;
      if (pageTitle.params) {
        return this.$t(pageTitle.label, pageTitle.params);
      } else {
        return this.$t(pageTitle.label);
      }
    },
    userId: function userId() {
      return this.$store.getters.currentUser.id;
    },
    mobileNavigation: function mobileNavigation() {
      return [{
        label: "dashboard",
        page: {
          name: "dashboard"
        },
        credential: "dashboard.list"
      }, {
        label: "projects",
        page: {
          name: "projects"
        },
        credential: "projects.list"
      }, {
        label: "contacts",
        page: {
          name: "contacts"
        },
        credential: "contacts.list"
      }, {
        label: "segments",
        page: {
          name: "segments"
        },
        credential: "segments.list"
      }, {
        label: "companies",
        page: {
          name: "companies"
        },
        credential: "companies.show"
      }, {
        label: "users",
        page: {
          name: "users"
        },
        credential: "users.list"
      }, {
        label: "organizations",
        page: {
          name: "organizations"
        },
        credential: "organizations.list"
      }, {
        label: "plans",
        page: {
          name: "plans"
        },
        credential: "plans.list"
      }, {
        label: "external_forms",
        page: {
          name: "external_forms"
        },
        credential: "external_forms.list",
        auth: "allowed_forms"
      }, {
        label: "lead_masks",
        page: {
          name: "lead_masks"
        },
        credential: "lead_masks.list",
        auth: "allowed_custom_leadsheets"
      }, {
        label: "workflows",
        page: {
          name: "workflows"
        },
        credential: "workflows.list",
        //auth: "allowed_custom_leadsheets",
        classes: ["dropdown--item"]
      }];
    },
    account: function account() {
      var menu = [{
        label: "sync",
        credential: "projects.synchronize",
        auth: "allowed_crm"
      }, {
        label: "profile",
        credential: "users.me",
        page: {
          name: "user_edit",
          params: {
            id: this.userId
          }
        }
      }, {
        label: "logout",
        page: {
          name: "logout"
        }
      }];
      return menu;
    }
  },
  methods: {
    getBindings: function getBindings(item) {
      var bindings = {
        to: {},
        class: []
      };
      if (item.page) {
        bindings.to = item.page;
      }
      if (item.classes) {
        bindings.class = item.classes;
      }
      return bindings;
    },
    close: function close() {
      this.drawer = false;
    },
    businessKitLink: function businessKitLink() {
      var config = this.$store.state.organization_config.eventbaxx_auth_token;
      if (config) {
        return "https://businesskit.fanomena.io/auth_login/" + config.content;
      } else {
        return "https://businesskit.fanomena.io/auth_login/";
      }
    },
    onClick: function onClick() {
      this.$store.commit("RESET_ALL_PAGES");
      this.close();
    }
  }
});

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_OnBoarding__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_OnBoarding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_OnBoarding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_Specific_UpgradeFreeTrial__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_Specific_UpgradeFreeTrial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_Specific_UpgradeFreeTrial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_PermissionNotAllowedModal__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_PermissionNotAllowedModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_PermissionNotAllowedModal__);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Onboarding: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_OnBoarding___default.a,
    UpgradeFreeTrial: __WEBPACK_IMPORTED_MODULE_1__components_helpers_Specific_UpgradeFreeTrial___default.a,
    PermissionNotAllowedModal: __WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_PermissionNotAllowedModal___default.a
  },
  computed: {
    shouldShowOnboarding: function shouldShowOnboarding() {
      return !this.$store.getters.getUserIsOnboarded;
    },
    current_plan_active: function current_plan_active() {
      return this.$store.getters.getCurrentOrganizationPlanActive;
    },
    shouldShowNotAllowedModal: function shouldShowNotAllowedModal() {
      return this.$store.getters.getNotAllowedModalShown;
    }
  }
});

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Logo__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_LanguageSwitcher_vue__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_LanguageSwitcher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_LanguageSwitcher_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_AuthenticatedNavigationItem__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_AuthenticatedNavigationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_AuthenticatedNavigationItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_AddButton_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_AddButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_AddButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserImage__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserImage__);



var _computed;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_Logo___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_LanguageSwitcher_vue___default.a,
    AuthenticatedNavigationItem: __WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_AuthenticatedNavigationItem___default.a,
    AddButton: __WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_AddButton_vue___default.a,
    UserImage: __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserImage___default.a
  },
  computed: (_computed = {
    currentUser: {
      get: function get() {
        return this.$store.getters.currentUser;
      }
    },
    compressed: function compressed() {
      return this.$store.getters.getHeaderState.compressed;
    }
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, "currentUser", function currentUser() {
    return this.$store.getters.currentUser;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, "accountLabel", function accountLabel() {
    if (this.currentUser.firstname || this.currentUser.lastname) {
      var label = "";
      if (this.currentUser.firstname) {
        label += this.currentUser.firstname + " ";
      }
      if (this.currentUser.lastname) {
        label += this.currentUser.lastname;
      }
      return label;
    }
    return this.currentUser.email;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, "userId", function userId() {
    return this.$store.getters.currentUser.id;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, "businessKitLink", function businessKitLink() {
    return this.$store.getters.getBusinessKitLink;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, "compressedSubtitle", function compressedSubtitle() {
    return this.$store.getters.getSubtitle;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, "compressedUnpublishedChanges", function compressedUnpublishedChanges() {
    // Right now only works for DragNDropEditor but can be made to use anything
    return this.$store.getters.getDragEditorUnpublishedChanges;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, "compressedTitle", function compressedTitle() {
    var pageTitle = this.$store.state.page_title;
    if (pageTitle.params) {
      return this.$t(pageTitle.label, pageTitle.params);
    } else {
      return this.$t(pageTitle.label);
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, "account", function account() {
    var menu = [{
      id: 7,
      label: "sync",
      credential: "projects.synchronize",
      auth: "allowed_crm",
      page: "/projects_synchronize"
    }, {
      id: 8,
      label: "profile",
      credential: "users.me",
      page: {
        name: "user_profile",
        params: {
          id: this.userId
        }
      }
    }, {
      id: 9,
      label: "logout",
      page: {
        name: "logout"
      }
    }];
    return menu;
  }), _computed),
  data: function data() {
    return {
      LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_LanguageSwitcher_vue___default.a,
      mainNavigation: [{
        label: "people",
        credential: "contact_manager.show",
        submenu: [{
          label: "contacts",
          page: {
            name: "contacts"
          },

          credential: "contacts.show",
          classes: ["dropdown--item"]
        }, {
          label: "segments",
          page: {
            name: "segments"
          },
          credential: "segments.show",
          classes: ["dropdown--item"]
        }, {
          label: "companies",
          page: {
            name: "companies"
          },
          credential: "companies.show",
          classes: ["dropdown--item"]
        }]
      }, {
        label: "projects",
        page: {
          name: "projects"
        },
        credential: "projects.list"
      }],
      contentManager: [{
        label: "menu_tab_lead_capture",
        classes: ["menu-title-tab"],
        credential: "lead_masks.list"
      }, {
        label: "lead_masks",
        page: {
          name: "lead_masks"
        },
        credential: "lead_masks.list",
        auth: "allowed_custom_leadsheets",
        classes: ["dropdown--item"]
      }, {
        label: "external_forms",
        page: {
          name: "external_forms"
        },
        credential: "external_forms.list",
        auth: "allowed_forms",
        classes: ["dropdown--item"]
      }, {
        label: "menu_tab_settings",
        classes: ["menu-title-tab"],
        credential: "lead_masks.list"
      }, {
        label: "users",
        page: {
          name: "users"
        },
        credential: "users.list"
      }, {
        label: "workflows",
        page: {
          name: "workflows"
        },
        credential: "workflows.list",
        //auth: "allowed_custom_leadsheets",
        classes: ["dropdown--item"]
      }, {
        id: 3,
        label: "organizations",
        page: {
          name: "organizations"
        },
        credential: "organizations.list"
      }, {
        id: 4,
        label: "plans",
        page: {
          name: "plans"
        },
        credential: "plans.list"
      }],
      mainNavigationUser: [{
        id: 2,
        label: "users",
        page: {
          name: "users"
        },
        credential: "users.list"
      }],
      accountDropdown: [{
        id: 9,
        label: "logout",
        page: {
          name: "logout"
        }
      }],
      crmSyncButton: {
        id: 7,
        label: "sync",
        credential: "projects.synchronize",
        auth: "allowed_crm",
        page: "/projects_synchronize"
      }
    };
  },

  methods: {
    getBindings: function getBindings(item) {
      var bindings = {
        to: {},
        class: []
      };

      if (item.page) {
        bindings.to = item.page;
      }
      if (item.classes) {
        bindings.class = item.classes;
      }

      return bindings;
    },

    // Close the pop overs
    close: function close() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$refs).forEach(function (key) {
        var ref = _this.$refs[key];
        ref.hide();
      });
    },
    onClick: function onClick() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (item && (item.disabled === true || Array.isArray(item.submenu))) {
        return;
      }
      this.$store.commit("RESET_ALL_PAGES");
    },
    accountDropdownItems: function accountDropdownItems() {
      // add Sync Button if CRM is connected
      if (this.$store.getters.getOrganizationConfig("crm_presence")) {
        this.accountDropdown.unshift(this.crmSyncButton);
      }
      return this.accountDropdown;
    },
    allowedInPlan: function allowedInPlan(label) {
      if (this.$store.getters.getCurrentOrganizationPlan) {
        var navigationRules = this.$store.getters.getCurrentOrganizationPlan.rules.exclude_from_navigation;
        if (navigationRules) {
          return !navigationRules.includes(label);
        }
      }
      return true;
    }
  }
});

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object
    }
  },
  computed: {},
  methods: {
    showModal: function showModal() {
      this.$store.commit('SET_NOT_ALLOWED_MODAL_SHOWN', true);
    }
  }
});

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_OnboardingModal__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_OnboardingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_OnboardingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_User__ = __webpack_require__(33);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    OnboardingModal: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_OnboardingModal___default.a
  },
  data: function data() {
    return {
      modal: {
        isOpen: false,
        hasMask: true,
        canClickMask: false,
        hasX: false
      },
      step: 1,
      max: 1,
      showDots: true,
      orientation: 'row'
    };
  },

  computed: {
    isLastStep: function isLastStep() {
      return this.step === this.max;
    },
    hasDots: function hasDots() {
      return this.max > 1 && this.showDots;
    },
    x_multiplier: function x_multiplier() {
      return this.orientation === 'row' ? -1 : 0;
    },
    y_multiplier: function y_multiplier() {
      return this.orientation === 'row' ? 0 : -1;
    },
    axis: function axis() {
      return this.orientation === 'row' ? 'row' : 'column';
    },
    axisReverse: function axisReverse() {
      return this.orientation === 'row' ? 'row-reverse' : 'column-reverse';
    },
    cross: function cross() {
      return this.orientation === 'row' ? 'column' : 'row';
    },
    crossReverse: function crossReverse() {
      return this.orientation === 'row' ? 'column-reverse' : 'row-reverse';
    }
  },
  watch: {
    orientation: 'setCssVars'
  },
  mounted: function mounted() {
    this.toggleModal();
  },

  methods: {
    toggleModal: function toggleModal(step) {
      step = step || 1;
      this.modal.isOpen = !this.modal.isOpen;
      if (this.modal.isOpen) {
        var self = this;
        setTimeout(function () {
          self.$sections = self.$el.querySelectorAll('section');
          self.max = self.$sections.length;
          self.goToStep(step);
        }, 1);
      }
    },
    setCssVars: function setCssVars() {
      this.$el.style.setProperty('--x', (this.step * 100 - 100) * this.x_multiplier + '%');
      this.$el.style.setProperty('--y', (this.step * 100 - 100) * this.y_multiplier + '%');
      this.$el.style.setProperty('--axis', this.axis);
      this.$el.style.setProperty('--axis-reverse', this.axisReverse);
      this.$el.style.setProperty('--cross', this.cross);
      this.$el.style.setProperty('--cross-reverse', this.crossReverse);
      // this.$el.style.setProperty('--vision', this.xray)
    },
    goToStep: function goToStep(step) {
      this.step = step > this.max ? this.max : step < 1 ? 1 : step;
      this.currentSection = this.$sections[this.step - 1];
      this.$sections.forEach(function (section) {
        section.classList.remove('current');
      });
      this.currentSection.classList.add('current');
      this.currentSection.scrollTop = 0;
      this.setCssVars();
    },
    skip: function skip(step) {
      this.step += step;
      this.goToStep(this.step);
    },
    reset: function reset() {
      this.goToStep(1);
    },
    updateUserIsOnboarded: function updateUserIsOnboarded() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var api, user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Set user is onboarded and send PATCH to API
                _this.$store.commit('SET_CURRENT_USER_ONBOARDED');
                api = new __WEBPACK_IMPORTED_MODULE_3__api_User__["a" /* default */]();
                user = _this.$store.getters.currentUser;

                api.post(user);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    finish: function finish() {
      this.toggleModal();
      this.updateUserIsOnboarded();
    }
  }
});

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['hasX', 'hasMask', 'canClickMask'],
  methods: {
    clickX: function clickX() {
      this.$emit('toggle');
    },
    clickMask: function clickMask() {
      if (this.canClickMask) {
        this.$emit('toggle');
      }
    }
  }
});

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      searchTerm: '',
      searchResults: [],
      isOpen: false
    };
  },

  props: {
    value: String,
    model: String
  },
  watch: {
    value: function value() {
      this.searchTerm = this.value;
    }
  },
  mounted: function mounted() {
    this.searchTerm = this.value;
  },

  methods: {
    search: function search() {
      this.$emit('search', this.searchTerm);
    }
  }
});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_FoldedNavigation_vue__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_FoldedNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_FoldedNavigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_Layout_DotNavigation_vue__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_Layout_DotNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_Layout_DotNavigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_AddButton_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_AddButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_AddButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_GetUrlQueries__ = __webpack_require__(234);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FoldedNavigation: __WEBPACK_IMPORTED_MODULE_0__components_layouts_partials_FoldedNavigation_vue___default.a,
    DotNavigation: __WEBPACK_IMPORTED_MODULE_1__components_helpers_Layout_DotNavigation_vue___default.a,
    AddButton: __WEBPACK_IMPORTED_MODULE_2__components_layouts_partials_AddButton_vue___default.a
  },
  data: function data() {
    return {
      folded: false
    };
  },

  computed: {
    compressed: function compressed() {
      return this.$store.getters.getHeaderState.compressed;
    },
    computedSecondaryHeaderClass: function computedSecondaryHeaderClass() {
      var classes = ['second-nav container-fluid'];
      if (this.compressed) {
        classes.push('compressed');
      }
      return classes;
    },
    isPageContent: function isPageContent() {
      return this.$route.name == "content_manager";
    },
    headerTabs: function headerTabs() {
      return this.$store.getters.getSecondaryHeaderTabs;
    },
    level: function level() {
      return this.$store.state.page_level;
    },
    type: function type() {
      return this.$store.state.page_type;
    },
    title: function title() {
      var pageTitle = this.$store.state.page_title;
      if (pageTitle.params) {
        return this.$t(pageTitle.label, pageTitle.params);
      } else {
        return this.$t(pageTitle.label);
      }
    },
    breadcrumbs: function breadcrumbs() {
      return this.$store.getters.getBreadcrumbs || [];
    },
    subtitle: function subtitle() {
      return this.$store.getters.getSubtitle;
    }
  },
  methods: {
    overflowHandler: function overflowHandler(payload) {
      this.folded = payload;
    },
    projectLeads: function projectLeads() {
      return this.$route.name === "project_leads";
    },
    projectLeadEdit: function projectLeadEdit() {
      return this.$route.name === "project_lead_edit";
    },
    onClick: function onClick() {
      //  We want to reset the leads page when we come back to the speficic project list page
      if (this.$route.name === "projects") {
        this.$store.commit('RESET_CURRENT_PAGE_LEADS');
      }
    },
    getProjectName: function getProjectName() {
      if (this.$store.getters.getSubtitle.name) {
        return this.$store.getters.getSubtitle.name;
      }
    },
    getProjectPathWithQueries: function getProjectPathWithQueries() {
      return '/' + this.$t("routes.project") + '/' + this.$route.params.id + '/' + this.$t("routes.project_leads") + __WEBPACK_IMPORTED_MODULE_3__classes_GetUrlQueries__["a" /* default */].urlQueries(this.$route.query);
    }
  }
});

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    tabs: function tabs() {
      return this.$store.state.tabs;
    },
    activeTab: function activeTab() {
      return this.$store.state.active_tab;
    }
  },
  methods: {
    setTab: function setTab(name) {
      this.$store.commit('SET_ACTIVE_TAB', name);
      this.$emit('change_tab', name);
    }
  }
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    error: function error() {
      var error = this.$store.state.error;
      if (error) {
        return error.message;
      } else {
        return "";
      }
    }
  }
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_companies_CompanyEdit_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_companies_CompanyEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_companies_CompanyEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Company__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataDisplay_FilterResults_Companies__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataDisplay_FilterResults_Companies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_DataDisplay_FilterResults_Companies__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FilterResults: __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataDisplay_FilterResults_Companies___default.a, Loading: __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_Loading_vue___default.a, Modal: __WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal_vue___default.a, CompanyCreate: __WEBPACK_IMPORTED_MODULE_4__components_pages_companies_CompanyEdit_vue___default.a },
  data: function data() {
    return {
      key: 0,
      open: false,
      loading: false,
      modalTitleEdit: "Create Company",
      company: {
        name: "",
        company_website: "",
        address: {
          street: "",
          street_number: "",
          city: "",
          zip: "",
          country: ""
        }
      }
    };
  },
  beforeMount: function beforeMount() {
    this.loading = true;
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__classes_Ui__["a" /* default */].setPageLevel("2");
    __WEBPACK_IMPORTED_MODULE_2__classes_Ui__["a" /* default */].setSecondaryHeaderTabs({});
    __WEBPACK_IMPORTED_MODULE_2__classes_Ui__["a" /* default */].setTitle({ label: "ui.pages.companies" });
    this.setHeaderButtons();
  },

  methods: {
    setHeaderButtons: function setHeaderButtons() {
      __WEBPACK_IMPORTED_MODULE_2__classes_Ui__["a" /* default */].setHeaderButtons([{
        name: "createcompany",
        action: "companies.create",
        classes: "btn-primary",
        function: this.setOpen
      }]);
    },
    setIsOpen: function setIsOpen(bool) {
      this.open = bool;
      if (!bool && !this.currentPlanIsTalent) {
        this.view = null;
      }
    },
    setOpen: function setOpen() {
      this.open = true;
      this.key++;
    },
    create: function create(payload) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var api;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                api = new __WEBPACK_IMPORTED_MODULE_5__api_Company__["a" /* default */]();

                if (!payload) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return api.createCompany(payload);

              case 4:
                _this.setIsOpen(false);
                _this.key++;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchDataComplete: function fetchDataComplete() {
      this.loading = false;
    }
  }
});

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Company__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_Contacts__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_data_countries__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_ContactInitials__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_ContactInitials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_ContactInitials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_Specific_UserImage__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_Specific_UserImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_helpers_Specific_UserImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_companies_CompanyEdit_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_companies_CompanyEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pages_companies_CompanyEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_helpers_DataDisplay_EmptyStateContacts__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_helpers_DataDisplay_EmptyStateContacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_helpers_DataDisplay_EmptyStateContacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_helpers_DataInput_Field__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EmptyState: __WEBPACK_IMPORTED_MODULE_13__components_helpers_DataDisplay_EmptyStateContacts___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_Loading_vue___default.a,
    ContactInitials: __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_ContactInitials___default.a,
    UserImage: __WEBPACK_IMPORTED_MODULE_10__components_helpers_Specific_UserImage___default.a,
    CompanyEdit: __WEBPACK_IMPORTED_MODULE_12__components_pages_companies_CompanyEdit_vue___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_14__components_helpers_Layout_NewModal___default.a,
    Field: __WEBPACK_IMPORTED_MODULE_15__components_helpers_DataInput_Field___default.a
  },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data: function data() {
    return {
      company: {},
      totalContacts: 0,
      isOpen: false,
      deleteModalOpen: false,
      deleteCompanyNameConfirm: '',
      standardCompanyFields: [{ internal_name: "name", display_name: "Company", val: "" }, { internal_name: "street", display_name: "Street", val: "" }, { internal_name: "street_number", display_name: "Street Number", val: "" }, { internal_name: "city", display_name: "City", val: "" }, { internal_name: "zip", display_name: "Post Code", val: "" }, { internal_name: "country", display_name: "Country", val: "" }],
      filters: {
        group: {
          merge: "",
          conditions: [{
            attribute: "company_id",
            predicate: "eq",
            value: "",
            value_id: null,
            definition: {
              label: "Company",
              attribute: "company_id",
              match_by_id: true,
              type: "text"
            }
          }]
        }
      },
      contacts: [],
      loading: true
    };
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    emptyState: function emptyState() {
      return this.$store.getters.getEmptyState;
    },
    userLanguage: function userLanguage() {
      return this.$store.getters.getCurrentLanguage;
    },
    country: function country() {
      if (this.company.address && this.company.address.country) {
        var countryCode = this.company.address.country.toUpperCase();
        var code = "";
        var language = this.userLanguage;
        __WEBPACK_IMPORTED_MODULE_8__config_data_countries__["a" /* default */][language].forEach(function (country) {
          if (countryCode == country.value) {
            code = country.name;
          }
        });
        return code;
      }
    },
    deleteCompanySubtitle: function deleteCompanySubtitle() {
      var subtitle = this.$t('ui.company.modals.delete.subtitle', { companyName: this.company.name });
      if (this.totalContacts > 0) {
        var contacsCount = this.$tc('ui.contacts.enumeration', this.totalContacts, { n: this.totalContacts });
        subtitle += '. ' + this.$t('ui.company.modals.delete.warning', { things: contacsCount });
      }
      return subtitle;
    }
  },
  beforeMount: function beforeMount() {
    __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setSecondaryHeaderTabs({});
    this.setHeaderButtons();

    __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setBreadcrumbs([{
      label: "ui.company.breadcrumb_back",
      link: { name: "companies" }
    }]);
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getCompany(_this.id);

            case 3:
              _this.filters.group.conditions[0].value = _this.company.name;
              _this.filters.group.conditions[0].value_id = _this.company.id;
              _context.next = 7;
              return _this.getContacts(_this.id);

            case 7:

              __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setTitle({ label: _this.company.name });

            case 8:
              _context.prev = 8;

              // Switch from the loader to the main page
              _this.loading = false;
              return _context.finish(8);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0,, 8, 11]]);
    }))();
  },

  methods: {
    setHeaderButtons: function setHeaderButtons() {
      __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setHeaderButtons([{
        action: "companies.delete",
        classes: "btn-delete",
        function: this.openDeleteModal
      }]);
    },
    getCompany: function getCompany(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var companyApi;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Get the basic details for this contact
                companyApi = new __WEBPACK_IMPORTED_MODULE_5__api_Company__["a" /* default */]();
                _context2.next = 3;
                return companyApi.getCompany(id);

              case 3:
                _this2.company = _context2.sent;


                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.company).forEach(function (entry) {
                  _this2.standardCompanyFields.forEach(function (field) {
                    if (field.internal_name == entry) {
                      field.val = _this2.company[entry];
                    }
                  });
                });

                // Add to our array of standard fields the matching values for Company Address
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_this2.company.address) == "object" && _this2.company.address !== null) {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.company.address).forEach(function (entry) {
                    _this2.standardCompanyFields.forEach(function (field) {
                      if (field.internal_name == entry) {
                        field.val = _this2.company.address[entry];
                      }
                    });
                  });
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getContacts: function getContacts() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var contactApi, filters, request, requestResponse;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                contactApi = new __WEBPACK_IMPORTED_MODULE_6__api_Contacts__["a" /* default */]();
                filters = _.cloneDeep(_this3.filters);
                // TODO: It would probably be better for the API to do this.

                filters.group.conditions[0].value = filters.group.conditions[0].value_id;

                request = {
                  search: _this3.searchKeywords,
                  contact_filters: filters,
                  page: 1,
                  per_page: 10,
                  sort_by: "created_at",
                  sort_order: "DESC"
                };


                _this3.loading = true;

                // Make the request
                requestResponse = null;
                _context3.prev = 6;
                _context3.next = 9;
                return contactApi.getAllContacts(request);

              case 9:
                requestResponse = _context3.sent;

              case 10:
                _context3.prev = 10;

                _this3.loading = false;
                _this3.$emit("fetchDataComplete");
                return _context3.finish(10);

              case 14:

                // Display both the returned contacts page and the total number of contacts
                _this3.contacts = requestResponse.data.resources;
                _this3.totalContacts = requestResponse.data.total_results;

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[6,, 10, 14]]);
      }))();
    },
    updateCompany: function updateCompany(company) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var api, res;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:

                _this4.isOpen = false;

                if (!(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(company) == __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this4.company))) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                api = new __WEBPACK_IMPORTED_MODULE_5__api_Company__["a" /* default */]();
                _context4.next = 6;
                return api.updateCompany(_this4.company.id, company).then(function (rs) {
                  _this4.company = rs;
                  __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setTitle({ label: _this4.company.name });
                });

              case 6:
                res = _context4.sent;


                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this4.company).forEach(function (entry) {
                  _this4.standardCompanyFields.forEach(function (field) {
                    if (field.internal_name == entry) {
                      field.val = _this4.company[entry];
                    }
                  });
                });

                // Add to our array of standard fields the matching values for Company Address
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_this4.company.address) == "object" && _this4.company.address !== null) {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this4.company.address).forEach(function (entry) {
                    _this4.standardCompanyFields.forEach(function (field) {
                      if (field.internal_name == entry) {
                        field.val = _this4.company.address[entry];
                      }
                    });
                  });
                }

                _this4.key++;

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    setIsOpen: function setIsOpen(bool) {
      this.isOpen = bool;
    },
    openDeleteModal: function openDeleteModal() {
      var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.deleteModalOpen = isOpen;
      this.deleteCompanyNameConfirm = '';
    },
    deleteCompany: function deleteCompany() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var api, id, status;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this5.deleteCompanyNameConfirm === _this5.$t('ui.company.modals.delete.confirm_word'))) {
                  _context5.next = 8;
                  break;
                }

                api = new __WEBPACK_IMPORTED_MODULE_5__api_Company__["a" /* default */]();
                id = _this5.company.id;

                if (!id) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 6;
                return api.deleteCompany(id);

              case 6:
                status = _context5.sent;

                if (status == 204) {
                  _this5.$router.push('/companies');
                }

              case 8:

                _this5.openDeleteModal(false);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    goToContact: function goToContact(contactId) {
      this.$router.push({
        path: "/contact/" + contactId
      });
    },
    goToContacts: function goToContacts() {
      this.$router.push({
        name: "contacts",
        params: {
          filtersFromParams: this.filters
        }
      });
    }
  }
});

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_CountrySelect_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_CountrySelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_CountrySelect_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Field: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default.a, CountrySelect: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_CountrySelect_vue___default.a, Modal: __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue___default.a },
  props: {
    company: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      workingCompany: {},
      workingCountry: ""
    };
  },
  beforeMount: function beforeMount() {
    this.init();
  },

  watch: {
    isOpen: function isOpen() {
      return this.init();
    }
  },
  methods: {
    init: function init() {
      this.workingCompany = _.cloneDeep(this.company);
      if (!this.workingCompany.address) {
        this.workingCompany.address = {};
      }
      this.workingCountry = _.get(this.workingCompany, "address.country", "").toUpperCase();
    },
    setCountry: function setCountry(val) {
      this.workingCountry = val;
    },
    save: function save() {
      this.workingCompany.address.country = this.workingCountry;
      this.$emit("save", this.workingCompany);
    },
    cancel: function cancel() {
      this.$emit("cancel");
    }
  }
});

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_AutoComplete__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_AutoComplete__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AutoComplete: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataDisplay_AutoComplete___default.a, Modal: __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue___default.a },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    idCount: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      item: {},
      selected: 0,
      confirmUpdateOpen: false
    };
  },
  beforeMount: function beforeMount() {
    this.init();
  },

  watch: {
    isOpen: function isOpen() {
      return this.init();
    },
    idCount: function idCount() {
      return this.init();
    }
  },
  computed: {
    warningSrc: function warningSrc() {
      return __webpack_require__(294);
    }
  },
  methods: {
    init: function init() {
      this.item = {
        id: null,
        value: ""
      };
      this.selected = this.idCount;
    },
    updateVal: function updateVal(payload) {
      this.item = payload;
      this.item.value = payload.name;
    },
    save: function save() {
      if (this.item && this.item.id) {
        this.confirmUpdateOpen = true;
      }
    },
    update: function update() {
      if (this.item && this.item.id) {
        this.$emit("save", this.item.id);
        this.confirmUpdateOpen = false;
      }
    },
    cancel: function cancel() {
      this.$emit("cancel");
    }
  }
});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Contacts__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_Api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_contacts_ContactEdit_vue__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_contacts_ContactEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_contacts_ContactEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_contacts_ChangeCompany_vue__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_contacts_ChangeCompany_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_contacts_ChangeCompany_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_UserImage__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_UserImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_UserImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_data_countries__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config_data_languages__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_helpers_Specific_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_helpers_DataDisplay_EmptyStateContacts__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_helpers_DataDisplay_EmptyStateContacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_helpers_DataDisplay_EmptyStateContacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  components: { EmptyState: __WEBPACK_IMPORTED_MODULE_16__components_helpers_DataDisplay_EmptyStateContacts___default.a, ContactEdit: __WEBPACK_IMPORTED_MODULE_9__components_pages_contacts_ContactEdit_vue___default.a, ChangeCompany: __WEBPACK_IMPORTED_MODULE_10__components_pages_contacts_ChangeCompany_vue___default.a, UserImage: __WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_UserImage___default.a, Loading: __WEBPACK_IMPORTED_MODULE_15__components_helpers_Specific_Loading_vue___default.a },
  props: {
    contactId: {
      type: [Number, String],
      required: true
    }
  },
  data: function data() {
    return {
      contact: {},
      isOpen: false,
      companyChangeOpen: false,
      company: {},
      leads: [],
      key: 0,
      projects: [],
      hiddenFields: ["company_role", "company", "firstname", "lastname", "email", "crawled_infos", "paragraph", "title", "drawing", "street_number", "company_name", "company_function", "company_streetaddress", "branch", "company_department", "crawled_infos", "academic_title", "free_drawing", "uuid"],
      tags: {},
      standardCompanyFields: [{ internal_name: "name", display_name: "Company", val: "" }, { internal_name: "website", display_name: "Company Website", val: "" }, { internal_name: "street", display_name: "Street", val: "" }, {
        internal_name: "street_number",
        display_name: "Street Number",
        val: ""
      }, { internal_name: "city", display_name: "City", val: "" }, { internal_name: "zip", display_name: "Post Code", val: "" }, { internal_name: "country", display_name: "Country", val: "" }],
      standardPersonalFields: [{
        internal_name: "business_card_job_title",
        display_name: "Job Title",
        val: ""
      }, {
        internal_name: "company_department",
        display_name: "Department",
        val: ""
      }, {
        internal_name: "phone_mobile",
        display_name: "Mobile Phone",
        val: ""
      }, {
        internal_name: "phone_company",
        display_name: "Company Phone",
        val: ""
      }, {
        internal_name: "phone_private",
        display_name: "Private Phone",
        val: ""
      }, { internal_name: "gender", display_name: "Gender", val: "" }, { internal_name: "language", display_name: "Language", val: "" }],
      leadSheets: [],
      leadsheetTabs: {},
      loading: true
    };
  },

  computed: {
    planIsTalent: function planIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent;
    },
    userLanguage: function userLanguage() {
      return this.$store.getters.getCurrentLanguage;
    },

    // eslint-disable-next-line vue/return-in-computed-property
    country: function country() {
      if (this.company.address && this.company.address.country) {
        var countryCode = this.company.address.country.toUpperCase();
        var code = "";
        var language = this.userLanguage;
        __WEBPACK_IMPORTED_MODULE_13__config_data_countries__["a" /* default */][language].forEach(function (country) {
          if (countryCode == country.value) {
            code = country.name;
          }
        });
        return code;
      }
    },
    language: function language() {
      var countryCode = this.contact.language;
      var code = "";

      if (!this.userLanguage) {
        this.userLanguage = "en";
      }
      if (__WEBPACK_IMPORTED_MODULE_14__config_data_languages__["a" /* default */][this.userLanguage] != undefined) {
        __WEBPACK_IMPORTED_MODULE_14__config_data_languages__["a" /* default */][this.userLanguage].forEach(function (language) {
          if (countryCode == language.value) {
            code = language.name;
          }
        });
      }
      if (code != "") {
        return code;
      } else return "-";
    },
    emptyState: function emptyState() {
      return this.$store.getters.getEmptyState;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Override the default icons used for column sorting
              _this.$q.icon.collapsible.icon = "keyboard_arrow_up";

              __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setSecondaryHeaderTabs({});
              __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setHeaderButtons({});

              __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setBreadcrumbs([{
                label: "ui.contact.breadcrumb_back",
                link: { name: "contacts" }
              }]);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var leadIds, projectIds;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this2.getContact(_this2.contactId);

            case 3:
              if (_this2.contact) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", false);

            case 5:

              __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setTitle({ label: _this2.contact.name });

              // Load all leads for this contact
              leadIds = [];

              _this2.contact.projects.forEach(function (project) {
                leadIds.push(project.lead_id);
              });
              _context2.next = 10;
              return _this2.getLeads(leadIds);

            case 10:

              // Load the full project details for each lead
              projectIds = [];

              _this2.contact.projects.forEach(function (project) {
                projectIds.push(project.id);
              });

              _context2.next = 14;
              return _this2.getProjects(projectIds);

            case 14:

              // Sort project list by when the lead was created, in reverse order
              _this2.contact.projects = _this2.contact.projects.sort(function (a, b) {
                var aLead = _this2.getLeadById(a.lead_id);
                var bLead = _this2.getLeadById(b.lead_id);
                if (aLead === null || bLead === null) {
                  return 0;
                }
                return __WEBPACK_IMPORTED_MODULE_17_moment___default()(aLead.created_at).isBefore(bLead.created_at) ? 1 : -1;
              });

              // Get all tags for each lead
              _this2.tags = {};
              _this2.leads.forEach(function (lead) {
                _this2.tags[lead.project_id] = lead.tags_list || [];
              });

              // Process all of the lead sheets for the projects
              _this2.getLeadSheets();

            case 18:
              _context2.prev = 18;

              // Switch from the loader to the main page
              _this2.loading = false;
              return _context2.finish(18);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0,, 18, 21]]);
    }))();
  },

  methods: {
    getContact: function getContact(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var contactsApi;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Get the basic details for this contact
                contactsApi = new __WEBPACK_IMPORTED_MODULE_7__api_Contacts__["a" /* default */]();
                _context3.next = 3;
                return contactsApi.getContact(id);

              case 3:
                _this3.contact = _context3.sent;

                if (_this3.contact) {
                  _context3.next = 8;
                  break;
                }

                _this3.$store.commit("SET_NOTIFICATION", {
                  title: _this3.$t("errors.contact.not_found"),
                  type: "error"
                });
                _this3.$router.push("/contacts");

                return _context3.abrupt("return");

              case 8:

                _this3.company = _this3.contact.company;

                _this3.updateFields();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    updateFields: function updateFields() {
      var _this4 = this;

      // Build array of standard fields with values for Contact
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.contact).forEach(function (entry) {
        _this4.standardPersonalFields.forEach(function (field) {
          if (field.internal_name == entry) {
            field.val = _this4.contact[entry];
          }
        });
      });

      // Build array of standard fields with values for Company
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.company).forEach(function (entry) {
        _this4.standardCompanyFields.forEach(function (field) {
          if (field.internal_name == entry) {
            field.val = _this4.company[entry];
          }
        });
      });

      // Add to our array of standard fields the matching values for Company Address
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.company.address) == "object" && this.company.address !== null) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.company.address).forEach(function (entry) {
          _this4.standardCompanyFields.forEach(function (field) {
            if (field.internal_name == entry) {
              field.val = _this4.company.address[entry];
            }
          });
        });
      }

      // Add to our array of standard personal fields the matching values from company
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.company).forEach(function (entry) {
        _this4.standardPersonalFields.forEach(function (field) {
          if (field.internal_name == entry) {
            field.val = _this4.company[entry];
          }
        });
      });
    },
    getLeads: function getLeads(leadIds) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var leadApi;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                leadApi = new __WEBPACK_IMPORTED_MODULE_8__api_Api__["a" /* default */]();
                _context4.next = 3;
                return leadApi.getMultiple("leads", "id", leadIds);

              case 3:
                _this5.leads = _context4.sent;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    updateContact: function updateContact(contact) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var api, res;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.isOpen = false;

                if (!(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(contact) == __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this6.contact))) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                api = new __WEBPACK_IMPORTED_MODULE_7__api_Contacts__["a" /* default */]();
                _context5.next = 6;
                return api.updateContact(_this6.contact.id, contact).then(function (rs) {
                  _this6.contact = rs;
                  _this6.company = rs.company;
                  __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setTitle({ label: _this6.contact.name });

                  _this6.updateFields();
                });

              case 6:
                res = _context5.sent;

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    changeCompany: function changeCompany(companyId) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var api, res;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.companyChangeOpen = false;
                api = new __WEBPACK_IMPORTED_MODULE_7__api_Contacts__["a" /* default */]();
                _context6.next = 4;
                return api.updateContact(_this7.contact.id, { company_id: companyId }).then(function (rs) {
                  _this7.contact = rs;
                  _this7.company = rs.company;
                  __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setTitle({ label: _this7.contact.name });

                  _this7.updateFields();
                });

              case 4:
                res = _context6.sent;

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    getProjects: function getProjects(projectIds) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var leadApi;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // Get projects assigned to this contact (as a lead)
                leadApi = new __WEBPACK_IMPORTED_MODULE_8__api_Api__["a" /* default */]();
                _context7.next = 3;
                return leadApi.getMultiple("projects", "id", projectIds);

              case 3:
                _this8.projects = _context7.sent;

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    getLeadById: function getLeadById(leadId) {
      var found = this.leads.find(function (lead) {
        return lead.id == leadId;
      });
      if (found == undefined) {
        found = null;
      }
      return found;
    },
    getLeadSheets: function getLeadSheets() {
      var _this9 = this;

      // Get all of the lead sheets assigned to the projects
      this.leadSheets = [];
      if (this.projects.length > 0) {
        this.projects.forEach(function (project) {
          _this9.leadSheets[project.id] = project.lead_mask;
          _this9.leadSheets[project.id].project_id = project.id;
          _this9.sortLeadSheets(_this9.leadSheets[project.id]);
        });
      }
    },
    sortLeadSheets: function sortLeadSheets(unstrucutedSheets) {
      var projectId = unstrucutedSheets.project_id;
      var leadsheet = {};
      leadsheet = unstrucutedSheets;
      var arrayAttributes = [];
      var tabs = [];

      // create an array from the leadsheet object so we can mainpulate it better
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(leadsheet.structure).forEach(function (attribute) {
        arrayAttributes.push(leadsheet.structure[attribute]);
      });

      // leadsheets tab names come in different types for the form editor, here we are splitting these into their tabs as we are not concerned about tab position
      arrayAttributes.forEach(function (attribute) {
        if (attribute.parent_element) {
          var tabName = attribute.parent_element.split("_")[0];
          tabName = tabName.charAt(0).toUpperCase() + tabName.substr(1);
          tabs.push(tabName);
        }
      });

      // de-duplicate the different tab names and make an array of them
      var dedupedTabs = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(tabs)));

      this.sortTabs(projectId, _.cloneDeep(arrayAttributes), _.cloneDeep(dedupedTabs));
    },
    sortTabs: function sortTabs(projectId, arrayAttributes, tabs) {
      var newtabs = {};
      tabs.forEach(function (tab) {
        newtabs[tab] = [];
      });

      // here we want to push relevant attr's to the tabs we have created
      arrayAttributes.forEach(function (attribute) {
        if (attribute.parent_element) {
          var tabName = attribute.parent_element.split("_")[0];
          tabName = tabName.charAt(0).toUpperCase() + tabName.substr(1);
          if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(newtabs).indexOf(tabName) > -1) {
            newtabs[tabName].push(attribute);
          }
        }
      });

      // delete known tabs that we do not want to show
      delete newtabs.Root;
      if (newtabs.kits || newtabs.statistics) {
        delete newtabs.kits;
        delete newtabs.statistics;
      }

      var listToDisplay = {};
      tabs.forEach(function (tab) {
        listToDisplay[tab] = [];
      });

      var personalFields = [];
      this.standardPersonalFields.forEach(function (field) {
        personalFields.push(field.internal_name);
      });

      var companyFields = [];
      this.standardCompanyFields.forEach(function (field) {
        companyFields.push(field.internal_name);
      });

      var filteredTabs = [];
      var companyFieldsArray = [];

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.company).forEach(function (field) {
        if (!companyFields.includes(field)) {
          if (field) {
            companyFieldsArray.push(field);
          }
        }
      });

      var hiddenFields = this.hiddenFields;

      // remove all entries from project section that are a standard leadsheet attr
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(newtabs).forEach(function (newtab) {
        newtabs[newtab].forEach(function (item) {
          if (item.label) {
            if (!personalFields.includes(item.name) && !companyFields.includes(item.name) && !hiddenFields.includes(item.name) && !hiddenFields.includes(item.name.split("-")[0])) {
              filteredTabs.push(item);
            }
          }
        });
      });

      var projectLead = undefined;
      if (Array.isArray(this.leads)) {
        projectLead = this.leads.find(function (lead) {
          return lead.project_id == projectId;
        });
      }

      if (projectLead == undefined) {
        return;
      }

      // Combine lead sheet with lead attributes
      filteredTabs.forEach(function (attribute) {
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(projectLead).indexOf(attribute.name) >= 0) {
          // Grab the value for this lead sheet attribute from the lead
          var rawValue = projectLead[attribute.name];
          var value = null;

          // If the attribute has a list of options, then convert the lead
          // value (or values) to the corresponding option label
          if (Array.isArray(attribute.allowed_values)) {
            // At this point, the lead value can either be a single scalar value,
            // an array of values, or an object of value/subValue pairs.
            // Here, we convert each type to a simple array, so that
            // we can process them the same way.
            var valueType = "scalar";
            var aValues = [];
            if (Array.isArray(rawValue)) {
              aValues = rawValue;
              valueType = "array";
            } else if ((typeof rawValue === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(rawValue)) == "object" && rawValue !== null) {
              aValues = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(rawValue);
              valueType = "object";
            } else {
              aValues = [rawValue];
            }

            // Match each raw value to the label from the lead sheet
            var processedValues = aValues.map(function (val) {
              var found = attribute.allowed_values.find(function (option) {
                return option.value == val;
              });
              var foundVal = val;
              if (found != undefined) {
                foundVal = found.name;
              }
              if (valueType === "object") {
                foundVal = {
                  label: foundVal,
                  value: rawValue[val]
                };
              }
              return foundVal;
            });

            if (attribute.element_type == "quantity_selection") {
              // Special case for Quanity Selectio types: remove any with a value of 0
              processedValues = processedValues.filter(function (value) {
                return value.value > 0;
              });
            }

            // convert back to a scalar if necessary
            if (valueType == "scalar") {
              value = processedValues[0];
            } else {
              value = processedValues;
            }
          } else {
            value = rawValue;
          }

          var tabName = attribute.parent_element.split("_")[0];
          tabName = tabName.charAt(0).toUpperCase() + tabName.substr(1);

          var element = {
            name: attribute.name,
            label: attribute.label,
            value: value,
            content: attribute.content,
            type: attribute.element_type
          };

          listToDisplay[tabName].push(element);
        }
      });

      delete listToDisplay.Root;

      this.leadsheetTabs[projectId] = listToDisplay;
    },
    setIsOpen: function setIsOpen(bool) {
      this.isOpen = bool;
    },
    showCompanyChange: function showCompanyChange(bool) {
      this.companyChangeOpen = bool;
    },
    goToLead: function goToLead(projectId, leadId) {
      this.$router.push({
        path: "/project/" + projectId + "/leads/" + leadId + "/edit/"
      });
    },
    goToCompany: function goToCompany(id) {
      this.$router.push({
        path: "/company/" + id
      });
    },
    getProjectSubLabel: function getProjectSubLabel(project) {
      var placeLabel = project.location ? project.location : "";

      var startDate = this.formatDateTimeNatural(project.start_date, {
        includeTime: false
      });
      var endDate = this.formatDateTimeNatural(project.end_date, {
        includeTime: false
      });

      var dateLabel = "";
      if (startDate == endDate) {
        dateLabel = startDate;
      } else {
        if (startDate != "") {
          dateLabel = startDate;
        }
        if (startDate != "" && endDate != "") {
          dateLabel += " > ";
        }
        if (endDate != "") {
          dateLabel += endDate;
        }
      }

      if (placeLabel != "" && dateLabel != "") {
        return placeLabel + " - " + dateLabel;
      }
      if (placeLabel != "") {
        return placeLabel;
      }
      return dateLabel;
    },
    convertArrayForDisplay: function convertArrayForDisplay(array) {
      var operator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "and";

      if (array.length == 0) {
        return "";
      }
      if (array.length == 1) {
        return array[0];
      }

      var last = array.pop();
      return array.join(", ") + " " + this.$t("ui.xfilters.conditions.operators." + operator) + " " + last;
    }
  }
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Field: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default.a, Modal: __WEBPACK_IMPORTED_MODULE_0__components_helpers_Layout_NewModal_vue___default.a },
  props: {
    contact: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      workingContact: {},
      workingCompany: {}
    };
  },
  beforeMount: function beforeMount() {
    this.init();
  },

  watch: {
    isOpen: function isOpen() {
      return this.init();
    }
  },
  methods: {
    init: function init() {
      this.workingContact = _.cloneDeep(this.contact);
      this.workingCompany = {};
      this.workingCompany = _.cloneDeep(this.workingContact.company);
    },
    save: function save() {
      if (this.workingContact.company) {
        this.workingContact.company = {};
      }
      this.workingContact.company = this.workingCompany;
      this.$emit('save', this.workingContact);
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Segments__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Contacts__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_contacts_UploadContacts__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_contacts_UploadContacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_contacts_UploadContacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_helpers_Specific_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_FilterResults_Contacts__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_FilterResults_Contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_FilterResults_Contacts__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { UploadContacts: __WEBPACK_IMPORTED_MODULE_5__components_pages_contacts_UploadContacts___default.a, FilterResults: __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_FilterResults_Contacts___default.a, Loading: __WEBPACK_IMPORTED_MODULE_9__components_helpers_Specific_Loading_vue___default.a, Modal: __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal___default.a, Field: __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_Field___default.a },
  props: {
    filtersFromParams: {
      type: [Object, Boolean],
      default: false
    }
  },
  data: function data() {
    return {
      segmentsApi: new __WEBPACK_IMPORTED_MODULE_3__api_Segments__["a" /* default */](),
      importOpen: false,
      key: 0,
      loading: false,
      createSegmentOpen: false,
      createSegmentName: "",
      segmentOriginal: {},
      segmentSave: {},
      selectedItems: []
    };
  },
  beforeMount: function beforeMount() {
    this.loading = true;
  },
  mounted: function mounted() {
    if (this.$route.meta.createSegment) {
      __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setPageLevel("3");
      __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setSubtitle({ link: { name: "segments" } });
    } else {
      __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setPageLevel("2");
    }
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setSecondaryHeaderTabs({});
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setTitle({ label: "ui.pages.contacts" });
    this.setHeaderButtons();
  },

  methods: {
    setHeaderButtons: function setHeaderButtons() {
      __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setHeaderButtons([{
        name: "importcontacts",
        action: "contacts.import",
        classes: "btn-tertiary",
        function: this.startImporter
      }, {
        name: "saveassegment",
        action: "contacts.save_as_segment",
        classes: "btn-primary",
        disabled: this.selectedItems.length != 0,
        function: this.startCreateSegment
      }]);
    },
    selectedItemsChange: function selectedItemsChange(items) {
      this.selectedItems = items;
      this.setHeaderButtons();
    },
    bulkAddToCompany: function bulkAddToCompany(payload) {
      var contactIds = [];
      this.selectedItems.forEach(function (item) {
        contactIds.push(item.id);
      });
      var companyId = payload;
      var api = new __WEBPACK_IMPORTED_MODULE_4__api_Contacts__["a" /* default */]();
      var params = { companyId: companyId, contactIds: contactIds };
      api.updateContactsCompany(params);
      this.key++;
    },
    updateFilters: function updateFilters(filters) {
      this.segmentSave.filters = filters;
      this.segmentSave = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.segmentSave));
    },
    updateSearch: function updateSearch(searchkeywords) {
      this.segmentSave.search = searchkeywords;
      this.segmentSave = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.segmentSave));
    },
    createSegment: function createSegment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.segmentsApi.updateSegment(_this.id, _this.segmentSave);

              case 2:
                _this.segment = _context.sent;

                _this.segmentOriginal = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.segment));
                _this.segmentSave = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.segment));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    startImporter: function startImporter() {
      this.importOpen = true;
    },
    contactUploadComplete: function contactUploadComplete(results) {
      this.importOpen = false;
      this.key++;
    },
    contactUploadCancelled: function contactUploadCancelled() {
      this.importOpen = false;
      this.key++;
    },
    startCreateSegment: function startCreateSegment() {
      this.createSegmentName = "";
      this.createSegmentOpen = true;
    },
    createSegmentCommit: function createSegmentCommit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var payload, resource;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                payload = {
                  name: _this2.createSegmentName,
                  filters: _this2.segmentSave.filters,
                  search: _this2.segmentSave.search
                };
                _context2.next = 3;
                return _this2.segmentsApi.createSegment(payload);

              case 3:
                resource = _context2.sent;


                _this2.$router.push({ name: "segment_edit", params: { id: resource.id } });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeCreateSegmentModal: function closeCreateSegmentModal() {
      this.createSegmentOpen = false;
    },
    fetchDataComplete: function fetchDataComplete() {
      this.loading = false;
    }
  }
});

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_UploadField__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_UploadField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_UploadField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Contacts__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_Loading_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UploadContacts",
  components: {
    UploadField: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_UploadField___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_Loading_vue___default.a
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      contactsApi: new __WEBPACK_IMPORTED_MODULE_1__api_Contacts__["a" /* default */](),
      open: false,
      uploading: false,
      file: null,
      error: "",
      importReportOpen: false,
      importReport: {}
    };
  },

  computed: {
    modalSaveText: function modalSaveText() {
      return this.$t("ui.button.users.upload_xls");
    },
    modalTitle: function modalTitle() {
      return this.$t("ui.contacts.import.title");
    }
  },
  beforeMount: function beforeMount() {
    this.open = this.isOpen;
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__EventBus_js__["a" /* EventBus */].$on("action", this.handleAction);
  },

  methods: {
    fileChange: function fileChange(payload) {
      this.file = payload;
      this.error = "";
    },
    fileUpload: function fileUpload() {
      var _this = this;

      var formData = new FormData();
      formData.append("file", this.file);
      this.uploading = true;
      this.$emit("contactUploadStarted");
      this.contactsApi.import(formData, this.$i18n.locale).then(function (response) {
        _this.$store.commit("SET_NOTIFICATION", {
          title: "ui.contacts.import.success_flash",
          type: "success"
        });
        __WEBPACK_IMPORTED_MODULE_2__EventBus_js__["a" /* EventBus */].$emit("action", "user_invited");
        _this.$emit("contactUploadComplete", response);
        _this.importReport = response;
        _this.importReportOpen = true;
      }).catch(function (e) {
        _this.error = _this.$t("errors.users.xls_import.wrong_file");
      }).finally(function () {
        _this.uploading = false;
      });
    },
    handleAction: function handleAction(action) {
      if (action == "users.invite_xls") {
        this.error = '';
        this.open = true;
      }
    },
    cancel: function cancel() {
      this.$emit("contactUploadCancelled");
      this.open = false;
      this.error = '';
    },
    importReportClose: function importReportClose() {
      this.importReportOpen = false;
      this.importReport = {};
    }
  },
  watch: {
    isOpen: function isOpen() {
      this.open = this.isOpen;
    }
  }
});

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_external_forms_ExternalFormCreate__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_external_forms_ExternalFormCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_external_forms_ExternalFormCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Permission__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ExternalFormCreate: __WEBPACK_IMPORTED_MODULE_0__pages_external_forms_ExternalFormCreate___default.a },
  data: function data() {
    return {
      isOpen: false
    };
  },

  computed: {
    allowedAccessForms: function allowedAccessForms() {
      return __WEBPACK_IMPORTED_MODULE_2__classes_Permission__["a" /* default */].planCan('allowed_forms');
    },
    currentPlanIsTalent: function currentPlanIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent;
    }
  },
  methods: {
    openForms: function openForms() {
      if (!this.allowedAccessForms) {
        this.$store.commit('SET_NOT_ALLOWED_MODAL_SHOWN', true);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].$emit('open', true);
      }
    },
    businessKitLink: function businessKitLink() {
      var config = this.$store.state.organization_config.eventbaxx_auth_token;
      if (config) {
        return 'https://businesskit.fanomena.io/auth_login/' + config.content;
      } else {
        return 'https://businesskit.fanomena.io/auth_login/';
      }
    }
  }
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters_PeriodFilter__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters_PeriodFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__filters_PeriodFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters_ProjectFilter__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters_ProjectFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__filters_ProjectFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters_OrganizationFilter__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters_OrganizationFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__filters_OrganizationFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_DashboardWidget__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_DashboardWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__widgets_DashboardWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_widgets_LatestActivityWidget__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_widgets_LatestActivityWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__widgets_widgets_LatestActivityWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_widgets_KitsActivityWidget__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_widgets_KitsActivityWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__widgets_widgets_KitsActivityWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_widgets_LeadsOverTimeWidget__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_widgets_LeadsOverTimeWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__widgets_widgets_LeadsOverTimeWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_widgets_LeadsCollectedWidget__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_widgets_LeadsCollectedWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__widgets_widgets_LeadsCollectedWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__widgets_widgets_MostActiveLeadsWidget__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__widgets_widgets_MostActiveLeadsWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__widgets_widgets_MostActiveLeadsWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__widgets_widgets_MostActiveProjectsWidget__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__widgets_widgets_MostActiveProjectsWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__widgets_widgets_MostActiveProjectsWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__widgets_widgets_ConversionFunnelWidget__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__widgets_widgets_ConversionFunnelWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__widgets_widgets_ConversionFunnelWidget__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        PeriodFilter: __WEBPACK_IMPORTED_MODULE_1__filters_PeriodFilter___default.a,
        ProjectFilter: __WEBPACK_IMPORTED_MODULE_2__filters_ProjectFilter___default.a,
        OrganizationFilter: __WEBPACK_IMPORTED_MODULE_3__filters_OrganizationFilter___default.a,
        DashboardWidget: __WEBPACK_IMPORTED_MODULE_4__widgets_DashboardWidget___default.a,
        LatestActivityWidget: __WEBPACK_IMPORTED_MODULE_5__widgets_widgets_LatestActivityWidget___default.a,
        LeadsOverTimeWidget: __WEBPACK_IMPORTED_MODULE_7__widgets_widgets_LeadsOverTimeWidget___default.a,
        LeadsCollectedWidget: __WEBPACK_IMPORTED_MODULE_8__widgets_widgets_LeadsCollectedWidget___default.a,
        MostActiveLeadsWidget: __WEBPACK_IMPORTED_MODULE_9__widgets_widgets_MostActiveLeadsWidget___default.a,
        MostActiveProjectsWidget: __WEBPACK_IMPORTED_MODULE_10__widgets_widgets_MostActiveProjectsWidget___default.a,
        ConversionFunnelWidget: __WEBPACK_IMPORTED_MODULE_11__widgets_widgets_ConversionFunnelWidget___default.a,
        KitsActivityWidget: __WEBPACK_IMPORTED_MODULE_6__widgets_widgets_KitsActivityWidget___default.a
    },

    data: function data() {
        return {
            organizationId: null,
            projectId: null,
            period: "7"
        };
    },

    mounted: function mounted() {
        var currentUserOrgId = this.$store.state.current_user.organization_id;
        this.onOrganizationChange(currentUserOrgId);
    },


    computed: {
        filter: function filter() {
            return {
                organizationId: this.organizationId,
                projectId: this.projectId,
                period: this.period
            };
        },


        isRoot: __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].isRoot
    },

    methods: {
        onOrganizationChange: function onOrganizationChange(organizationId) {
            this.organizationId = organizationId;
            this.projectId = null;
        },
        onProjectChange: function onProjectChange(projectId) {
            this.projectId = projectId;
        },
        onPeriodChange: function onPeriodChange(period) {
            this.period = period;
        }
    }
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isDisabled: {
      type: Boolean
    }
  }
});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DashboardFilter__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DashboardFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DashboardFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Organization_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_FilterMixin__ = __webpack_require__(235);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_FilterMixin__["a" /* default */]],

    components: {
        DashboardFilter: __WEBPACK_IMPORTED_MODULE_3__DashboardFilter___default.a
    },

    props: {
        organizationId: {
            type: Number
        }
    },

    data: function data() {
        return {
            organizations: []
        };
    },

    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.get();

                        case 2:
                            _this.organizations = _context.sent;

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    methods: {
        get: function get() {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
                    var api, organizations;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.prev = 0;
                                    api = new __WEBPACK_IMPORTED_MODULE_4__api_Organization_js__["a" /* default */]();
                                    _context2.next = 4;
                                    return api.getAll('true', 'true');

                                case 4:
                                    organizations = _context2.sent;


                                    resolve(organizations);
                                    _context2.next = 11;
                                    break;

                                case 8:
                                    _context2.prev = 8;
                                    _context2.t0 = _context2['catch'](0);

                                    reject(_context2.t0);

                                case 11:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this2, [[0, 8]]);
                }));

                return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    }
});

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardFilter__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DashboardFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FilterMixin__ = __webpack_require__(235);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_FilterMixin__["a" /* default */]],

  components: {
    DashboardFilter: __WEBPACK_IMPORTED_MODULE_1__DashboardFilter___default.a
  },

  computed: {
    all: {
      get: function get() {
        // Day when Leads has been founded
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()('20170101'), 'days') + 1;
      }
    }
  }
});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_sortBy__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_flow__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DashboardFilter__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DashboardFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DashboardFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_FilterMixin__ = __webpack_require__(235);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_FilterMixin__["a" /* default */]],

  components: {
    DashboardFilter: __WEBPACK_IMPORTED_MODULE_6__DashboardFilter___default.a
  },

  props: ['organizationId'],

  data: function data() {
    return {
      projects: []
    };
  },

  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refresh();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  watch: {
    organizationId: function organizationId() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.refresh();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  methods: {
    refresh: function refresh() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var projects;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.get();

              case 2:
                projects = _context3.sent;

                _this3.projects = _this3.transform(projects);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    get: function get() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
          var projectApi, projects;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  projectApi = new __WEBPACK_IMPORTED_MODULE_7__api_Project_js__["a" /* default */]();
                  _context4.next = 4;
                  return projectApi.getShortList({ filter_by: 'organization_id', filter_value: _this4.organizationId });

                case 4:
                  projects = _context4.sent;


                  resolve(projects);
                  _context4.next = 11;
                  break;

                case 8:
                  _context4.prev = 8;
                  _context4.t0 = _context4['catch'](0);

                  reject(_context4.t0);

                case 11:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this4, [[0, 8]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },


    transform: function transform(projects) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_flow___default()([__WEBPACK_IMPORTED_MODULE_4_lodash_fp_sortBy___default()(['name']), __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map___default()(function (_ref2) {
        var name = _ref2.name,
            id = _ref2.id;
        return { name: name, id: id };
      })])(projects);
    }
  }
});

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    error: {
      type: undefined
    },

    isError: {
      type: Boolean,
      default: false
    },

    isPanel: {
      type: Boolean,
      default: false
    },

    isLoading: {
      default: false,
      type: Boolean
    },

    isLoadingSpinner: {
      default: true,
      type: Boolean
    }
  }
});

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_plotly_js_dist__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_plotly_js_dist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_plotly_js_dist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_random__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_random__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    colors: {
      type: Array,
      default: function _default() {
        return ['yellow', 'red'];
      }
    },

    identifier: {
      type: String,
      default: function _default() {
        return '_' + Math.random().toString(36).substr(2, 9);
      }
    },

    labels: {
      type: Array,
      required: true
    },

    rotation: {
      type: Number,
      default: 0
    },

    values: {
      type: Array,
      required: true,
      default: function _default() {
        return [0, 100];
      }
    }
  },

  data: function data() {
    return {
      chart: {
        configuration: {
          responsive: true,
          displayModeBar: false
        },

        layout: {
          height: 32,
          width: 32,
          paper_bgcolor: 'rgba(0,0,0,0)',
          plot_bgcolor: 'rgba(0,0,0,0)',
          showlegend: false,
          margin: {
            t: 0,
            b: 0,
            l: 0,
            r: 0,
            p: 0
          }
        }
      }
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_plotly_js_dist___default.a.newPlot(this.identifier, [{
      sort: false,
      direction: 'clockwise',
      rotation: this.rotation,
      values: this.values,
      labels: this.labels,
      marker: { colors: this.colors },
      type: 'pie',
      textinfo: 'none',
      hoverinfo: 'none'
    }], this.chart.layout, this.chart.configuration);
  }
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNull__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_join__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_gt__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_gt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_gt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_size__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_flow__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_sum__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_round__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isEmpty__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fp_slice__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fp_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_fp_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fp_reject__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fp_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_fp_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_defaultTo__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_defaultTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_defaultTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_cond__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_cond___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_cond__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_constant__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_constant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_constant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_stubTrue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_stubTrue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_stubTrue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_each__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__api_Charts_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__api_Api_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mixins_WidgetMixin__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mixins_WidgetPeriodMixin__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mixins_WidgetQueryMixin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__mixins_WidgetPercentageMixin__ = __webpack_require__(918);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




























// Returns the ratio of two values. Handles also the case where one of the values is zero
var ratio = function ratio(x, y) {
  return __WEBPACK_IMPORTED_MODULE_18_lodash_cond___default()([[function (_ref) {
    var x = _ref.x,
        y = _ref.y;
    return x === 0 || y === 0;
  }, __WEBPACK_IMPORTED_MODULE_19_lodash_constant___default()(0)], [__WEBPACK_IMPORTED_MODULE_20_lodash_stubTrue___default.a, function (_ref2) {
    var x = _ref2.x,
        y = _ref2.y;
    return __WEBPACK_IMPORTED_MODULE_17_lodash_defaultTo___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_round___default()(x / y * 100, 1), 0);
  }]])({ x: x, y: y });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_24__mixins_WidgetMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__mixins_WidgetPeriodMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__mixins_WidgetQueryMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__mixins_WidgetPercentageMixin__["a" /* default */]],

  props: {
    identifier: {
      type: String,
      default: 'conversion-funnel'
    },

    segmentColors: {
      type: Array,
      // One more than the number of chart segments, if gradiation is used
      default: function _default() {
        return ['#e8f2fe', '#bad8fa', '#3c8af5', '#2565c3', '#0e284d'];
      }
    },

    isGradientColors: {
      type: Boolean,
      default: true
    },

    isAnimated: {
      type: Boolean,
      default: true
    },

    animationTime: {
      type: String,
      default: '0.5s'
    }
  },

  data: function data() {
    return {
      chartSegments: [],
      ratios: {
        leadsSendouts: 0,
        sendoutsVisits: 0,
        visitsInteractions: 0
      },

      key: 0
    };
  },

  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.eventBus.$on('widget-loaded', function () {
                var animator = _this.$refs['funnel-chart-animator'];
                if (animator) {
                  animator.classList.remove('animate');
                  setTimeout(function () {
                    return animator.classList.add('animate');
                  }, 10);
                }
              });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    refresh: function refresh() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var conversionFunnel;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.setIsLoading(true);

                _context2.prev = 1;
                _context2.next = 4;
                return _this2.get(_this2.from(_this2.filter.period), _this2.filter.projectId);

              case 4:
                conversionFunnel = _context2.sent;

                _this2.transform(conversionFunnel);
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                _this2.setError(_context2.t0);
                _this2.setIsError(true);

              case 12:
                _context2.prev = 12;

                _this2.setIsLoading(false);
                _this2.key++;
                _this2.eventBus.$emit('widget-loaded', _this2.identifier);
                return _context2.finish(12);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8, 12, 17]]);
      }))();
    },
    get: function get(from, project) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                    var charts, tuples, querySchema, query, _ref4, conversionFunnel;

                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            charts = new __WEBPACK_IMPORTED_MODULE_22__api_Charts_js__["a" /* default */]();
                            tuples = [{ key: 'from', value: '"' + from + '"' }];


                            if (!!project) {
                              tuples.push({ key: 'projectId', value: project });
                            }

                            querySchema = '\n          leads_count\n          sendouts_count\n          visits_count\n          interactions_count\n        ';
                            query = _this3.getQuery(tuples, 'conversionFunnel', querySchema);
                            _context3.next = 7;
                            return charts.postQuery({
                              organization_id: _this3.filter.organizationId,
                              operationName: null,
                              variables: {},
                              query: 'query Query {\n            ' + query + '\n          }'
                            }).catch(reject);

                          case 7:
                            _ref4 = _context3.sent;
                            conversionFunnel = _ref4.conversion_funnel;


                            resolve(conversionFunnel);

                          case 10:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x, _x2) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },


    // Transform for easier rendering
    transform: function transform(conversionFunnel) {
      this.chartSegments = [{
        label: this.$t('ui.dashboard.conversion_funnel.leads'),
        value: conversionFunnel.leads_count
      }, {
        label: this.$t('ui.dashboard.conversion_funnel.sendouts'),
        value: conversionFunnel.sendouts_count
      }, {
        label: this.$t('ui.dashboard.conversion_funnel.visits'),
        value: conversionFunnel.visits_count
      }, {
        label: this.$t('ui.dashboard.conversion_funnel.interactions'),
        value: conversionFunnel.interactions_count
      }];

      var total = 0;
      __WEBPACK_IMPORTED_MODULE_21_lodash_each___default()(this.chartSegments, function (chartSegment, index) {
        if (__WEBPACK_IMPORTED_MODULE_8_lodash_eq___default()(index, 0)) {
          total = chartSegment.value;

          chartSegment.conversion = chartSegment.value > 0 ? 100 : 0;
        } else {
          chartSegment.conversion = ratio(chartSegment.value, total);
        }
      });
    }
  }
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_reject__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_flow__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isUndefined__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isNull__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_reduce__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_slice__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_includes__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_sum__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_join__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_find__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_size__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_gt__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_gt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_gt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_defaultTo__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_defaultTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_defaultTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_cond__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_cond___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_cond__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_stubTrue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_stubTrue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_stubTrue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__api_Charts_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__api_Api_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mixins_WidgetMixin__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mixins_WidgetPeriodMixin__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_helpers_Specific_UserImage__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_helpers_Specific_UserImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_helpers_Specific_UserImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__mixins_WidgetQueryMixin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__services_DashboardService_js__ = __webpack_require__(354);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





























var ACTIVITIES_LIMIT = 10;
var INTERACTIONS_VIEW = ['EMAIL_OPENED', 'VIEW_COUPON'];
var INTERACTIONS_CLICK = ['VIEW_WEBSITE_COUPON', 'SHARE_FACEBOOK_BAG', 'SHARE_FACEBOOK_COUPON', 'CONFIRM_REDEEM_COUPON', 'SHARE_FACEBOOK_MESSENGER_BAG', 'SHARE_TWITTER_BAG', 'CTA_COUPON', 'SHARE_TWITTER_COUPON', 'BOOKMARK_COUPON', 'UNBOOKMARK_COUPON', 'SHARE_FACEBOOK_MESSENGER_COUPON'];
var OPEN_BAG = 'OPEN_BAG';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_24__mixins_WidgetMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__mixins_WidgetPeriodMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__mixins_WidgetQueryMixin__["a" /* default */]],

  components: {
    UserImage: __WEBPACK_IMPORTED_MODULE_26__components_helpers_Specific_UserImage___default.a
  },

  props: {
    identifier: {
      type: String,
      default: 'kits-activity'
    }
  },

  data: function data() {
    return {
      activities: []
    };
  },

  methods: {
    refresh: function refresh() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var activites;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsLoading(true);

                _context.prev = 1;
                _context.next = 4;
                return _this.get(_this.from(_this.filter.period), _this.filter.projectId);

              case 4:
                activites = _context.sent;

                _this.activities = _this.transform(activites);
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                _this.setError(_context.t0);
                _this.setIsError(true);

              case 12:
                _context.prev = 12;

                _this.setIsLoading(false);
                _this.eventBus.$emit('widget-loaded', _this.identifier);
                return _context.finish(12);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8, 12, 16]]);
      }))();
    },
    get: function get(from, project) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
                    var charts, margin, tuples, querySchema, query, _ref2, kitActivities, api, leadIds, leads;

                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            charts = new __WEBPACK_IMPORTED_MODULE_22__api_Charts_js__["a" /* default */]();

                            // Temporary query more events for the case if some are archived
                            // or doesn't match the actual leads

                            margin = 5;
                            tuples = [{ key: 'from', value: '"' + from + '"' }, { key: 'perPage', value: ACTIVITIES_LIMIT + margin }];


                            if (!!project) {
                              tuples.push({ key: 'projectId', value: project });
                            }

                            querySchema = '\n          entries {\n            lead_id\n            interaction_counts\n            last_interaction_date\n            event_id\n            business_kit_name\n          }\n\n          paginationMeta {\n            page\n            perPage\n            hasNextPage\n          }\n        ';
                            query = _this2.getQuery(tuples, 'kitActivity', querySchema);
                            _context2.next = 8;
                            return charts.postQuery({
                              organization_id: _this2.filter.organizationId,
                              operationName: null,
                              variables: {},
                              query: 'query Query {\n            ' + query + '\n          }'
                            }).catch(reject);

                          case 8:
                            _ref2 = _context2.sent;
                            kitActivities = _ref2.kit_activity.entries;

                            if (!__WEBPACK_IMPORTED_MODULE_16_lodash_eq___default()(__WEBPACK_IMPORTED_MODULE_17_lodash_size___default()(kitActivities), 0)) {
                              _context2.next = 13;
                              break;
                            }

                            resolve(kitActivities);

                            return _context2.abrupt('return');

                          case 13:
                            api = new __WEBPACK_IMPORTED_MODULE_23__api_Api_js__["a" /* default */]();
                            leadIds = __WEBPACK_IMPORTED_MODULE_14_lodash_join___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_map___default()(function (_ref3) {
                              var lead_id = _ref3.lead_id;
                              return lead_id;
                            })(kitActivities));
                            _context2.next = 17;
                            return api.getMultiple('leads', 'id', leadIds, undefined, 'true', 'true').catch(reject);

                          case 17:
                            leads = _context2.sent;


                            __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map___default()(function (kitActivity) {
                              // Get lead
                              if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isNull___default()(kitActivity.lead_id)) {
                                kitActivity.lead = __WEBPACK_IMPORTED_MODULE_15_lodash_find___default()(leads, ['id', kitActivity.lead_id]);
                              }

                              return kitActivity;
                            })(kitActivities);

                            resolve(kitActivities);

                          case 20:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    transform: function transform(activities) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_lodash_flow___default()([__WEBPACK_IMPORTED_MODULE_4_lodash_fp_reject___default()(function (activity) {
        return __WEBPACK_IMPORTED_MODULE_6_lodash_isUndefined___default()(activity.lead);
      }), __WEBPACK_IMPORTED_MODULE_9_lodash_fp_slice___default()(0, ACTIVITIES_LIMIT),
      // Assign all clicks and views and determinate if bag has been opened
      __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map___default()(function (activity) {
        return {
          isOpenedBag: __WEBPACK_IMPORTED_MODULE_18_lodash_gt___default()(activity.interaction_counts[OPEN_BAG], 0),
          interactions: {
            clicks: __WEBPACK_IMPORTED_MODULE_8_lodash_reduce___default()(activity.interaction_counts, function (clicks, amount, interaction) {
              if (__WEBPACK_IMPORTED_MODULE_11_lodash_includes___default()(INTERACTIONS_CLICK, interaction)) {
                clicks += amount;
              }

              return clicks;
            }, 0),

            views: __WEBPACK_IMPORTED_MODULE_8_lodash_reduce___default()(activity.interaction_counts, function (views, amount, interaction) {
              if (__WEBPACK_IMPORTED_MODULE_11_lodash_includes___default()(INTERACTIONS_VIEW, interaction)) {
                views += amount;
              }

              return views;
            }, 0)
          },

          lead: activity.lead,
          name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__services_DashboardService_js__["a" /* getLeadName */])(activity.lead, _this3.$t('ui.dashboard.latest_activity.incomplete_lead')),
          business_kit_name: __WEBPACK_IMPORTED_MODULE_19_lodash_defaultTo___default()(activity.business_kit_name, 'a Kit'),
          event_id: activity.event_id
        };
      }),

      // Determinate if there are any views or clicks.
      // @todo Try to iterate only once
      __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map___default()(function (_ref4) {
        var isOpenedBag = _ref4.isOpenedBag,
            _ref4$interactions = _ref4.interactions,
            clicks = _ref4$interactions.clicks,
            views = _ref4$interactions.views,
            lead = _ref4.lead,
            name = _ref4.name,
            business_kit_name = _ref4.business_kit_name,
            event_id = _ref4.event_id;
        return {
          interactions: {
            isOpened: isOpenedBag && __WEBPACK_IMPORTED_MODULE_16_lodash_eq___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_sum___default()([clicks, views]), 0),
            clicks: clicks,
            views: views
          },

          lead: lead,
          name: name,
          business_kit_name: business_kit_name,
          event_id: event_id
        };
      })])(activities);
    }
  }
});

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_map__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_reject__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_flow__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cond__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cond___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_cond__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNull__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_slice__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_join__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_find__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_size__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_stubTrue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_stubTrue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_stubTrue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_constant__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_constant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_constant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_Charts_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_Api_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_WidgetMixin__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_WidgetPeriodMixin__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mixins_WidgetDateMixin__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mixins_WidgetQueryMixin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__services_DashboardService_js__ = __webpack_require__(354);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























var ACTIVITIES_LIMIT = 10;
var LEAD_CREATE = 'LEAD_CREATE';
var LEAD_UPDATE = 'LEAD_UPDATE';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_21__mixins_WidgetMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__mixins_WidgetPeriodMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__mixins_WidgetQueryMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__mixins_WidgetDateMixin__["a" /* default */]],

  props: {
    identifier: {
      type: String,
      default: 'latest-activity'
    }
  },

  data: function data() {
    return {
      activities: [],
      LEAD_CREATE: LEAD_CREATE,
      LEAD_UPDATE: LEAD_UPDATE
    };
  },

  methods: {
    refresh: function refresh() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var activities;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsLoading(true);

                _context.prev = 1;
                _context.next = 4;
                return _this.get(_this.from(_this.filter.period), _this.filter.projectId);

              case 4:
                activities = _context.sent;

                _this.activities = _this.transform(activities);
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                _this.setError(_context.t0);
                _this.setIsError(true);

              case 12:
                _context.prev = 12;

                _this.setIsLoading(false);
                _this.eventBus.$emit('widget-loaded', _this.identifier);
                return _context.finish(12);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8, 12, 16]]);
      }))();
    },
    get: function get(from, project) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
                    var charts, margin, tuples, querySchema, query, _ref2, latestActivities, api, projectApi, userIds, usersPromise, projectIds, projectQueryParams, projectsPromise, leadIds, leadsPromise;

                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            charts = new __WEBPACK_IMPORTED_MODULE_18__api_Charts_js__["a" /* default */]();

                            // Temporary query more events for the case if some are archived
                            // or doesn't match the actual leads

                            margin = 5;
                            tuples = [{ key: 'from', value: '"' + from + '"' }, { key: 'limit', value: ACTIVITIES_LIMIT + margin }, { key: 'eventNames', value: '[LEAD_CREATE, LEAD_UPDATE]' }];


                            if (!!project) {
                              tuples.push({ key: 'projectId', value: project });
                            }

                            querySchema = '\n          name\n          happened_at\n          project_id\n          lead_id\n          user_id\n        ';
                            query = _this2.getQuery(tuples, 'latestEvents', querySchema);
                            _context2.next = 8;
                            return charts.postQuery({
                              organization_id: _this2.filter.organizationId,
                              operationName: null,
                              variables: {},
                              query: 'query Query {\n            ' + query + '\n          }'
                            }).catch(reject);

                          case 8:
                            _ref2 = _context2.sent;
                            latestActivities = _ref2.latest_events;

                            if (!__WEBPACK_IMPORTED_MODULE_13_lodash_eq___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_size___default()(latestActivities), 0)) {
                              _context2.next = 13;
                              break;
                            }

                            resolve([]);

                            return _context2.abrupt('return');

                          case 13:
                            api = new __WEBPACK_IMPORTED_MODULE_19__api_Api_js__["a" /* default */]();
                            projectApi = new __WEBPACK_IMPORTED_MODULE_20__api_Project_js__["a" /* default */]();
                            userIds = __WEBPACK_IMPORTED_MODULE_11_lodash_join___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_map___default()(function (_ref3) {
                              var user_id = _ref3.user_id;
                              return user_id;
                            })(latestActivities));
                            usersPromise = api.getMultiple('users', 'id', userIds, undefined, 'true', 'true');
                            projectIds = latestActivities.map(function (_ref4) {
                              var project_id = _ref4.project_id;
                              return project_id;
                            }).filter(function (project_id, index, self) {
                              return self.indexOf(project_id) === index;
                            }).join(',');
                            projectQueryParams = {
                              enforce_all_statuses: true,
                              enforce_archived: true,
                              filter_by: 'id',
                              filter_value: projectIds
                            };
                            projectsPromise = projectApi.getShortList(projectQueryParams);
                            leadIds = __WEBPACK_IMPORTED_MODULE_11_lodash_join___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_map___default()(function (_ref5) {
                              var lead_id = _ref5.lead_id;
                              return lead_id;
                            })(latestActivities));
                            leadsPromise = api.getMultiple('leads', 'id', leadIds, undefined, 'true', 'true').catch(reject);


                            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([usersPromise, projectsPromise, leadsPromise]).then(function (_ref6) {
                              var _ref7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref6, 3),
                                  users = _ref7[0],
                                  projects = _ref7[1],
                                  leads = _ref7[2];

                              __WEBPACK_IMPORTED_MODULE_4_lodash_fp_map___default()(function (latestActivity) {
                                // Get user
                                if (!__WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default()(latestActivity.user_id)) {
                                  latestActivity.user = __WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(users, ['id', latestActivity.user_id]);
                                }

                                // Get project
                                if (!__WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default()(latestActivity.project_id)) {
                                  latestActivity.project = __WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(projects, ['id', latestActivity.project_id]);
                                }

                                // Get lead
                                if (!__WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default()(latestActivity.lead_id)) {
                                  latestActivity.lead = __WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(leads, ['id', latestActivity.lead_id]);
                                }

                                return latestActivity;
                              })(latestActivities);

                              resolve(latestActivities);
                            }).catch(reject);

                          case 23:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },


    // Transform for easier handling and limit
    transform: function transform(activities) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_lodash_flow___default()([__WEBPACK_IMPORTED_MODULE_5_lodash_fp_reject___default()(function (activity) {
        return __WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined___default()(activity.lead) || __WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined___default()(activity.project);
      }), __WEBPACK_IMPORTED_MODULE_9_lodash_fp_slice___default()(0, ACTIVITIES_LIMIT), __WEBPACK_IMPORTED_MODULE_4_lodash_fp_map___default()(function (activity) {
        return {
          at: activity.happened_at,
          activity: activity.name,
          by: __WEBPACK_IMPORTED_MODULE_7_lodash_cond___default()([[function (activity) {
            return __WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined___default()(activity.user);
          }, __WEBPACK_IMPORTED_MODULE_17_lodash_constant___default()(void 0)], [__WEBPACK_IMPORTED_MODULE_16_lodash_stubTrue___default.a, function (activity) {
            return activity.user.display_name;
          }]])(activity),

          lead: {
            identifier: activity.lead.id
          },

          person: {
            name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__services_DashboardService_js__["a" /* getLeadName */])(activity.lead, _this3.$t('ui.dashboard.latest_activity.incomplete_lead')),
            identifier: activity.lead.user_id
          },

          project: {
            name: activity.project.name,
            identifier: activity.project.id
          }
        };
      })])(activities);
    }
  }
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sum__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_round__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_assign__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_Charts_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_PieChart__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__types_PieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardWidget__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DashboardWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_WidgetMixin__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_WidgetPeriodMixin__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_WidgetQueryMixin__ = __webpack_require__(96);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var getDefaultCharts = function getDefaultCharts() {
  return {
    hot: {
      absolute: 0,
      relative: 0
    },

    warm: {
      absolute: 0,
      relative: 0
    },

    cold: {
      absolute: 0,
      relative: 0
    },

    unclassified: {
      absolute: 0,
      relative: 0
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DashboardWidget: __WEBPACK_IMPORTED_MODULE_10__DashboardWidget___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_9__types_PieChart___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_WidgetMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_WidgetPeriodMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_WidgetQueryMixin__["a" /* default */]],

  props: {
    identifier: {
      type: String,
      default: 'leads-collected'
    }
  },

  data: function data() {
    return {
      leads: 0,
      charts: getDefaultCharts()
    };
  },

  computed: {
    // Determinates if values are ready to be plotted
    isCharts: {
      get: function get() {
        return !this.isLoading;
      }
    }
  },

  methods: {
    refresh: function refresh() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var leadsOverTime, _transform, leads, charts;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsLoading(true);

                _context.prev = 1;

                _this.charts = getDefaultCharts();
                _context.next = 5;
                return _this.get(_this.from(_this.filter.period), _this.filter.projectId);

              case 5:
                leadsOverTime = _context.sent;
                _transform = _this.transform(leadsOverTime), leads = _transform.leads, charts = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_transform, ['leads']);


                _this.charts = charts;
                _this.leads = leads;
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                _this.setError(_context.t0);
                _this.setIsError(true);

              case 15:
                _context.prev = 15;

                _this.setIsLoading(false);
                _this.eventBus.$emit('widget-loaded', _this.identifier);
                return _context.finish(15);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 11, 15, 19]]);
      }))();
    },
    get: function get(from, project) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
                    var initial, charts, tuples, query, _ref2, leadsCollected;

                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            initial = {
                              hot: 0,
                              warm: 0,
                              cold: 0,
                              unclassified: 0
                            };
                            charts = new __WEBPACK_IMPORTED_MODULE_8__api_Charts_js__["a" /* default */]();
                            tuples = [{ key: 'from', value: '"' + from + '"' }];


                            if (!!project) {
                              tuples.push({ key: 'projectId', value: project });
                            }

                            query = _this2.getQuery(tuples, 'classificationCounts');
                            _context2.next = 7;
                            return charts.postQuery({
                              organization_id: _this2.filter.organizationId,
                              operationName: null,
                              variables: {},
                              query: 'query Query {\n              ' + query + '\n            }'
                            }).catch(reject);

                          case 7:
                            _ref2 = _context2.sent;
                            leadsCollected = _ref2.classification_counts;


                            leadsCollected = __WEBPACK_IMPORTED_MODULE_7_lodash_assign___default()(initial, leadsCollected);

                            resolve(leadsCollected);

                          case 11:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },


    transform: function transform(_ref3) {
      var cold = _ref3.cold,
          warm = _ref3.warm,
          hot = _ref3.hot,
          unclassified = _ref3.unclassified;
      return {
        cold: {
          absolute: cold ? cold : 0,
          relative: 100 * (cold / __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default()([cold, warm, hot, unclassified])) ? 100 * (cold / __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default()([cold, warm, hot, unclassified])) : 0
        },

        warm: {
          absolute: warm ? warm : 0,
          relative: 100 * (warm / __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default()([cold, warm, hot, unclassified])) ? 100 * (warm / __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default()([cold, warm, hot, unclassified])) : 0
        },

        hot: {
          absolute: hot ? hot : 0,
          relative: 100 * (hot / __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default()([cold, warm, hot, unclassified])) ? 100 * (hot / __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default()([cold, warm, hot, unclassified])) : 0
        },

        unclassified: {
          absolute: unclassified ? unclassified : 0,
          relative: 100 * (unclassified / __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default()([cold, warm, hot, unclassified])) ? 100 * (unclassified / __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default()([cold, warm, hot, unclassified])) : 0
        },

        leads: __WEBPACK_IMPORTED_MODULE_4_lodash_sum___default()([cold, warm, hot, unclassified])
      };
    },

    // E. g. 50 % equals 180 °
    percentageToDegrees: function percentageToDegrees(percentage) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_round___default()(percentage * 360 / 100, 0);
    }
  }
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_head__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_last__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_reverse__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flow__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_constant__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_constant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_constant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_cond__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_cond___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_cond__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_defaultTo__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_defaultTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_defaultTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_stubTrue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_stubTrue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_stubTrue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_plotly_js_dist__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_plotly_js_dist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_plotly_js_dist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_Charts_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_WidgetMixin__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__LeadsCollectedWidget__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__LeadsCollectedWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__LeadsCollectedWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_WidgetQueryMixin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_WidgetDateMixin__ = __webpack_require__(355);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















var each = __WEBPACK_IMPORTED_MODULE_4_lodash_fp___default.a.each.convert({ cap: false });

var getDefaultTrace = function getDefaultTrace() {
  return {
    x: [],
    y: []
  };
};

var AXIS_LAYOUT = {
  fixedrange: true,
  autorange: true,
  showgrid: false,
  rangemode: 'tozero'

  // See: https://bl.ocks.org/zanarmstrong/raw/ca0adb7e426c12c06a95/
};var DEFAULT_D3_DATE_FORMAT = '%d %b %Y';
var D3_HOUR_DATE_FORMAT = '%H:%M';

// See: https://momentjs.com/docs/#/displaying/format/
var DEFAULT_MOMENT_DATE_FORMAT = 'YYYY-MM-DD';
var MOMENT_HOUR_DATE_FORMAT = 'YYYY-MM-DD HH:mm';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_18__mixins_WidgetMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__mixins_WidgetQueryMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__mixins_WidgetDateMixin__["a" /* default */]],

  components: {
    LeadsCollectedWidget: __WEBPACK_IMPORTED_MODULE_19__LeadsCollectedWidget___default.a
  },

  filters: {
    // Formats the date according to period. It shows hours when period is equal zero. It doesn't show
    // hours when period is not equal zero
    format: function format(date) {
      var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
      var period = arguments[2];

      var format = DEFAULT_MOMENT_DATE_FORMAT;
      if (period === '0') {
        format = MOMENT_HOUR_DATE_FORMAT;
      }

      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(date).locale(language).format(format);
    }
  },

  props: {
    identifier: {
      type: String,
      default: 'leads-over-time'
    }
  },

  data: function data() {
    return {
      chart: {
        configuration: {
          staticPlot: false,
          responsive: true,
          displayModeBar: false
        },

        layout: {
          hovermode: 'x',
          paper_bgcolor: 'rgba(0,0,0,0)',
          plot_bgcolor: 'rgba(0,0,0,0)',
          showlegend: false,
          xaxis: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            showspikes: false,
            spikedash: 'solid',

            // Determines the drawing mode for the spike line. If "toaxis", the line is drawn from the data point to the
            // axis the series is plotted on. If "across", the line is drawn across the entire plot area, and supercedes
            // "toaxis". If "marker", then a marker dot is drawn on the axis the series is plotted on
            spikemode: 'toaxis',

            // Determines whether spikelines are stuck to the cursor or to the closest datapoints
            spikesnap: 'data',
            spikethickness: 1, // 1 pixel
            spikedistance: 50, // 50 pixels
            hoverdistance: 50, // 50 pixels
            tickfont: {
              family: 'Poppins, sans-serif',
              color: '#9198AB'
            }
          }, AXIS_LAYOUT),

          yaxis: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            tickfont: {
              family: 'Poppins, sans-serif',
              color: '#0263CA'
            },

            tickformat: ',d'
          }, AXIS_LAYOUT),

          yaxis2: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            tickfont: {
              family: 'Poppins, sans-serif',
              color: '#9198AB'
            },

            side: 'right',
            overlaying: 'y'
          }, AXIS_LAYOUT),

          margin: {
            l: 30,
            r: 30,
            b: 20,
            t: 5,
            pad: 10
          }
        },

        linear: getDefaultTrace(),
        cumulated: getDefaultTrace(),
        total: 0,
        tooltip: {
          display: 'none',
          top: 0,
          left: 0,
          cumulative: 0,
          leads: 0,
          date: new Date()
        }
      }
    };
  },

  computed: {
    // CSS Style for dynamic tooltip presentation
    tooltip: {
      get: function get() {
        return {
          display: this.chart.tooltip.display,
          left: this.chart.tooltip.left + 'px',
          top: this.chart.tooltip.top + 'px'
        };
      }
    },

    // Represents the tick format for a Plotly.js axis. It shows hours when period is equal zero. It
    // doesn't show hours when period is not equal zero
    tickFormat: {
      get: function get() {
        if (this.filter.period === '0') {
          return D3_HOUR_DATE_FORMAT;
        }

        return DEFAULT_D3_DATE_FORMAT;
      }
    }
  },

  methods: {
    refresh: function refresh() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var leadsOverTime;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsLoading(true);

                _context.prev = 1;
                _context.next = 4;
                return _this.get(_this.filter.period, _this.filter.projectId);

              case 4:
                leadsOverTime = _context.sent;


                _this.chart.linear = getDefaultTrace();
                _this.chart.cumulated = getDefaultTrace();

                _this.transform(leadsOverTime);
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                _this.setError(_context.t0);
                _this.setIsError(true);

              case 14:
                _context.prev = 14;

                _this.plot();

                _this.setIsLoading(false);
                _this.eventBus.$emit('widget-loaded', _this.identifier);
                return _context.finish(14);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 10, 14, 19]]);
      }))();
    },
    get: function get(period, project) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
                    var charts, tuples, userTimeZone, querySchema, query, _ref2, leadsOverTime;

                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            charts = new __WEBPACK_IMPORTED_MODULE_17__api_Charts_js__["a" /* default */]();
                            tuples = [{ key: 'daysAgo', value: period }];


                            if (!!project) {
                              tuples.push({ key: 'projectId', value: project });
                            }

                            userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                            tuples.push({ key: 'inTimeZone', value: '"' + userTimeZone + '"' });

                            querySchema = '\n          count\n          dateTimeStep\n        ';
                            query = _this2.getQuery(tuples, 'leadsCountPerPeriod', querySchema);
                            _context2.next = 9;
                            return charts.postQuery({
                              organization_id: _this2.filter.organizationId,
                              operationName: null,
                              variables: {},
                              query: 'query Query {\n              ' + query + '\n            }'
                            }).catch(reject);

                          case 9:
                            _ref2 = _context2.sent;
                            leadsOverTime = _ref2.leads_count_per_period;


                            resolve(leadsOverTime);

                          case 12:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x2, _x3) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    setItVisibleTooltip: function setItVisibleTooltip(isVisibleTooltip) {
      this.chart.tooltip.display = isVisibleTooltip ? 'block' : 'none';
    },
    plot: function plot() {
      var _this3 = this;

      var plot = __WEBPACK_IMPORTED_MODULE_15_plotly_js_dist___default.a.newPlot(this.identifier, [{
        name: this.$t('ui.dashboard.leads_over_time.linear'),
        yaxis: 'y2',
        x: this.chart.linear.x,
        y: this.chart.linear.y,
        line: {
          color: '#C4CDD5',
          shape: 'linear'
        },

        fill: 'tozeroy',
        fillcolor: 'rgba(255, 255, 247, 0.05)',
        type: 'scatter',
        mode: 'lines+markers',
        hoverinfo: 'none'
      }, {
        name: this.$t('ui.dashboard.leads_over_time.cumulated'),
        x: this.chart.cumulated.x,
        y: this.chart.cumulated.y,
        line: {
          color: '#2487f7',
          shape: 'spline'
        },

        fill: 'tozeroy',
        fillcolor: 'rgba(36, 135, 247, 0.15)',
        type: 'scatter',
        mode: 'lines',
        hoverinfo: 'none'
      }], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.chart.layout, {
        xaxis: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
          tickformat: this.tickFormat
        }, this.chart.layout.xaxis)
      }), this.chart.configuration);

      // To force responsiveness
      window.dispatchEvent(new Event('resize'));

      // Show tooltip on hover
      this.$refs[this.identifier].on('plotly_hover', function (_ref3) {
        var points = _ref3.points,
            event = _ref3.event;

        _this3.chart.tooltip.left = event.clientX;
        _this3.chart.tooltip.top = event.clientY;

        var leads = __WEBPACK_IMPORTED_MODULE_5_lodash_head___default()(points);
        var cumulative = __WEBPACK_IMPORTED_MODULE_6_lodash_last___default()(points);

        _this3.chart.tooltip.leads = leads.y;
        _this3.chart.tooltip.cumulative = cumulative.y;
        _this3.chart.tooltip.date = leads.x;

        _this3.chart.tooltip.display = 'block';
      });
    },


    // @todo Return instead of mutate global state
    transform: function transform(leadsOverTime) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_8_lodash_flow___default()([__WEBPACK_IMPORTED_MODULE_7_lodash_fp_reverse___default.a, each(function (_ref4, index) {
        var dateTimeStep = _ref4.dateTimeStep,
            count = _ref4.count;

        _this4.chart.linear.x.push(dateTimeStep);
        _this4.chart.linear.y.push(count);

        var previous = __WEBPACK_IMPORTED_MODULE_13_lodash_defaultTo___default()(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(_this4.chart.cumulated.y, index - 1), 0);
        _this4.chart.cumulated.x.push(dateTimeStep);
        _this4.chart.cumulated.y.push(previous + count);
      })])(leadsOverTime);
    }
  }
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_join__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNull__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_flow__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_map__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_slice__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_fp_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_reject__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_fp_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_Charts_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_Api_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_WidgetMixin__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_WidgetPeriodMixin__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_WidgetQueryMixin__ = __webpack_require__(96);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















var MOST_ACTIVE_LEADS_LIMIT = 5;

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_14__mixins_WidgetMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_WidgetPeriodMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_WidgetQueryMixin__["a" /* default */]],

  props: {
    identifier: {
      type: String,
      default: 'most-active-leads'
    }
  },

  data: function data() {
    return {
      mostActiveLeads: []
    };
  },

  methods: {
    refresh: function refresh() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var mostActiveLeads;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsLoading(true);

                _context.prev = 1;
                _context.next = 4;
                return _this.get(_this.from(_this.filter.period), _this.filter.projectId);

              case 4:
                mostActiveLeads = _context.sent;

                _this.mostActiveLeads = _this.transform(mostActiveLeads);
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                _this.setError(_context.t0);
                _this.setIsError(true);

              case 12:
                _context.prev = 12;

                _this.setIsLoading(false);
                _this.eventBus.$emit('widget-loaded', _this.identifier);
                return _context.finish(12);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8, 12, 16]]);
      }))();
    },
    get: function get(from, project) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
          var charts, tuples, querySchema, query, _ref2, mostActiveLeads, api, _leads;

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  charts = new __WEBPACK_IMPORTED_MODULE_12__api_Charts_js__["a" /* default */]();
                  tuples = [{ key: 'from', value: '"' + from + '"' }, { key: 'limit', value: ACTIVITIES_LIMIT }];


                  if (!!project) {
                    tuples.push({ key: 'projectId', value: project });
                  }

                  querySchema = '\n          lead_id\n          interactions_count\n        ';
                  query = _this2.getQuery(tuples, 'latestEvents', querySchema);
                  _context2.next = 7;
                  return charts.postQuery({
                    organization_id: _this2.filter.organizationId,
                    operationName: null,
                    variables: {},
                    query: 'query Query {\n            ' + query + '\n          }'
                  });

                case 7:
                  _ref2 = _context2.sent;
                  mostActiveLeads = _ref2.most_active_leads;
                  api = new __WEBPACK_IMPORTED_MODULE_13__api_Api_js__["a" /* default */]();
                  _context2.prev = 10;
                  _context2.next = 13;
                  return api.getMultiple('leads', 'id', __WEBPACK_IMPORTED_MODULE_3_lodash_join___default()(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_map___default()(function (_ref3) {
                    var lead_id = _ref3.lead_id;
                    return lead_id;
                  })(mostActiveLeads)));

                case 13:
                  _leads = _context2.sent;
                  _context2.next = 19;
                  break;

                case 16:
                  _context2.prev = 16;
                  _context2.t0 = _context2['catch'](10);

                  reject(_context2.t0);

                case 19:

                  mostActiveLeads = __WEBPACK_IMPORTED_MODULE_9_lodash_fp_map___default()(function (mostActiveLead) {
                    // Get lead
                    if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isNull___default()(mostActiveLead.lead_id)) {
                      mostActiveLead.lead = __WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(leads, ['id', mostActiveLead.lead_id]);
                    }

                    return mostActiveLead;
                  })(mostActiveLeads);

                  resolve(mostActiveLeads);

                case 21:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2, [[10, 16]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },


    transform: function transform(mostActiveLeads) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_flow___default()([__WEBPACK_IMPORTED_MODULE_11_lodash_fp_reject___default()(function (activity) {
        return __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined___default()(activity.lead) || __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined___default()(activity.project);
      }), __WEBPACK_IMPORTED_MODULE_9_lodash_fp_map___default()(function (mostActiveLead, index) {
        return {
          index: index,
          classification: mostActiveLead.lead.classification,
          company: mostActiveLead.lead.company,
          name: mostActiveLead.lead.firstname + ' ' + mostActiveLead.lead.lastname
        };
      })])(mostActiveLeads);
    }
  }
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNull__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_join__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_size__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_flow__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_slice__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_fp_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp_reject__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_fp_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_Charts_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_Api_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_WidgetMixin__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_WidgetPeriodMixin__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_WidgetQueryMixin__ = __webpack_require__(96);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















var MOST_ACTIVE_PROJECTS_LIMIT = 2;

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_WidgetMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_WidgetPeriodMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_WidgetQueryMixin__["a" /* default */]],

  props: {
    identifier: {
      type: String,
      default: 'most-active-projects'
    }
  },

  data: function data() {
    return {
      projects: []
    };
  },

  computed: {
    userIdentifier: {
      get: function get() {
        return this.$store.state.current_user.id || this.$store.state.current_user.user_id;
      }
    }
  },

  methods: {
    refresh: function refresh() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var projects;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.setIsLoading(true);

                _context2.prev = 1;
                _context2.next = 4;
                return _this.get(_this.from(_this.filter.period), _this.filter.projectId);

              case 4:
                projects = _context2.sent;

                _this.projects = _this.transform(projects);

                // After loaded once, the widget should immediately indicate that loading is finished
                // since it's independent from project filter
                _this.eventBus.$on('project', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          return _context.abrupt('return', _this.eventBus.$emit('widget-loaded', _this.identifier));

                        case 1:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                })));
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                _this.setError(_context2.t0);
                _this.setIsError(true);

              case 13:
                _context2.prev = 13;

                _this.setIsLoading(false);
                _this.eventBus.$emit('widget-loaded', _this.identifier);
                return _context2.finish(13);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[1, 9, 13, 17]]);
      }))();
    },
    get: function get(from, project) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                    var charts, margin, tuples, querySchema, query, _ref3, mostActiveProjects, api, projectIds, projects;

                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            charts = new __WEBPACK_IMPORTED_MODULE_13__api_Charts_js__["a" /* default */]();

                            // Temporary query more events for the case if some are archived
                            // or doesn't match the actual leads

                            margin = 15;
                            tuples = [{ key: 'from', value: '"' + from + '"' }, { key: 'userId', value: _this2.userIdentifier }, { key: 'limit', value: MOST_ACTIVE_PROJECTS_LIMIT + margin }];


                            if (!!project) {
                              tuples.push({ key: 'projectId', value: project });
                            }

                            querySchema = '\n          project_id\n          leads_count\n          users_leads_count\n        ';
                            query = _this2.getQuery(tuples, 'mostActiveProjects', querySchema);
                            _context3.next = 8;
                            return charts.postQuery({
                              organization_id: _this2.filter.organizationId,
                              operationName: null,
                              variables: {},
                              query: 'query Query {\n              ' + query + '\n            }'
                            }).catch(reject);

                          case 8:
                            _ref3 = _context3.sent;
                            mostActiveProjects = _ref3.most_active_projects;

                            if (!__WEBPACK_IMPORTED_MODULE_8_lodash_eq___default()(__WEBPACK_IMPORTED_MODULE_9_lodash_size___default()(mostActiveProjects), 0)) {
                              _context3.next = 13;
                              break;
                            }

                            resolve(mostActiveProjects);

                            return _context3.abrupt('return');

                          case 13:
                            api = new __WEBPACK_IMPORTED_MODULE_14__api_Api_js__["a" /* default */]();
                            projectIds = __WEBPACK_IMPORTED_MODULE_6_lodash_join___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(mostActiveProjects, function (_ref4) {
                              var project_id = _ref4.project_id;
                              return project_id;
                            }));
                            _context3.next = 17;
                            return api.getMultiple('projects', 'id', projectIds).catch(reject);

                          case 17:
                            projects = _context3.sent;


                            mostActiveProjects = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(mostActiveProjects, function (mostActiveProject) {
                              // Get project
                              if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isNull___default()(mostActiveProject.project_id)) {
                                mostActiveProject.project = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(projects, ['id', mostActiveProject.project_id]);
                              }

                              return mostActiveProject;
                            });

                            resolve(mostActiveProjects);

                          case 20:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x, _x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },


    // Transform for easier handling and limit
    transform: function transform(mostActiveProjects) {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_flow___default()([__WEBPACK_IMPORTED_MODULE_12_lodash_fp_reject___default()(['project', void 0]), __WEBPACK_IMPORTED_MODULE_11_lodash_fp_slice___default()(0, MOST_ACTIVE_PROJECTS_LIMIT)])(mostActiveProjects);
    }
  }
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_EmailTemplate_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_FieldFiller__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_FieldFiller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_FieldFiller__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var default_color = '#000000';

var placeholderSalutationCollection = [{ name: 'formal', code: 'ui.email_template.placeholders.formal', content: '[[formal]]' }, { name: 'informal', code: 'ui.email_template.placeholders.informal', content: '[[informal]]' }, { name: 'gender', code: 'ui.email_template.placeholders.gender', content: '[[gender]]' }];

var placeholderBodyCollection = [{ name: 'form_title', code: 'ui.email_template.placeholders.form_title', content: '[[form_title]]' }];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_Update__["a" /* updateMixin */]],
  components: { FieldFiller: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_FieldFiller___default.a },
  data: function data() {
    return {
      model: "email_templates",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_EmailTemplate_js__["a" /* default */](),
      projects: [],
      primary_color: null,
      placeholderBodyCollection: placeholderBodyCollection,
      placeholderSalutationCollection: placeholderSalutationCollection
    };
  },
  mounted: function mounted() {
    this.colorInit();
  },

  methods: {
    afterRetrieve: function afterRetrieve() {
      this.colorInit();
    },
    colorInit: function colorInit() {
      if (!this.item.primary_color) {
        this.item.primary_color = default_color;
      }
      this.primary_color = this.item.primary_color;
    }
  },
  watch: {
    primary_color: {
      deep: true,
      handler: function handler(val) {
        this.item.primary_color = val.hex;
      }
    }
  }
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_EmailTemplate__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_Collection__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_Searchbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_Searchbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_Searchbar__);
//
//
//
//
//
//
//
//
//







var structure = [{ name: 'id', credentials: 'root' }, { name: 'name', type: 'show_with_edit_link', sortable: true }, { name: 'language', sortable: true }, { name: 'action', type: 'crud_action_folded' }];

var default_sort_by = "created_at";
var default_sort_order = "DESC";
var default_filters = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_Collection__["a" /* collectionMixin */]],
  components: {
    Searchbar: __WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_Searchbar___default.a
  },
  data: function data() {
    return {
      model: "email_templates",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_EmailTemplate__["a" /* default */](),
      collectionData: structure,
      title: "ui.pages.email-templates",
      emailNavigation: [{ name: "external_forms", action: "external_forms.list", title: "Forms", credential: "external_forms.list" }, { name: "email_templates", action: "email_templates.list", title: "Email templates", credential: "email_templates.list" }],
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_EMAIL_TEMPLATES',
        routerName: 'email_templates',
        emptyState: 'email_templates',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    };
  },
  mounted: function mounted() {
    if (this.page != __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].getCurrentPageEmailTemplates()) {
      this.goToPage(__WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].getCurrentPageEmailTemplates());
    }
    this.query.sort_by = default_sort_by;
    this.query.sort_order = default_sort_order;

    __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setSecondaryHeaderTabs(this.emailNavigation);
    __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].$off('email_template_duplicate');
    __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].$on('email_template_duplicate', this.duplicate);
  },

  methods: {
    duplicate: function duplicate(payload) {
      var _this = this;

      this.api.duplicate(payload.id).then(function (data) {
        _this.retrieve();
        var newForm = data.resource;
        var route = { name: 'email_template_edit', params: { id: newForm.id } };
        _this.$router.push(route);
      });
    }
  }
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_BusinessKit__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_EmailTemplate__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_EmailList__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_EmailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_EmailList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_TagList__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_TagList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_TagList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_integrations_GoToWebinar__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_integrations_GoToWebinar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_integrations_GoToWebinar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default.a,
    EmailList: __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_EmailList___default.a,
    TagList: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_TagList___default.a,
    GoToWebinar: __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_integrations_GoToWebinar___default.a
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // collections
      businessKitCollection: [],
      emailTemplateCollection: [],
      defaultConfig: {
        actions: {
          board_businesskit: {
            status: 'disabled',
            send_directly: false,
            eventbaxx_event_foreign_id: null
          },
          board_citrix: {
            citrix_webinar_keys: [],
            status: 'disabled'
          },
          redirect_to: {
            status: 'disabled',
            url: ''
          },
          send_lead_confirmation_mail: {
            email_template_foreign_id: null,
            cta_text: '',
            status: 'disabled',
            subject: '',
            url: ''
          },
          send_team_confirmation_mail: {
            emails: [],
            status: 'disabled'
          },
          success_message: {
            content: 'Thank you!',
            status: 'enabled'
          },
          board_mailchimp: {
            mailchimp_merge_field_configuration: {},
            status: 'disabled'
          }
        }
      }
    };
  },

  computed: {
    config: function config() {
      var _this = this;

      // Use value prop but also Validate that it contains all necessary attributes
      var configuration = this.defaultConfig;
      if (!this.value.actions) {
        return configuration;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.value.actions).forEach(function (key) {
        var hash = _this.value.actions[key];
        // If key is not present in defaultConfig we add it
        if (!configuration['actions'][key]) {
          configurations['actions'][key] = hash;
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(hash).forEach(function (keyInner) {
          var valueInner = hash[keyInner];
          configuration['actions'][key][keyInner] = valueInner;
        });
      });
      return configuration;
    }
  },
  mounted: function mounted() {
    this.retrieve();
  },

  methods: {
    switchCitrixStatus: function switchCitrixStatus() {
      // Flip from 'disabled' to 'enabled' or other wa
      var status = 'disabled';
      if (this.config.actions.board_citrix.status === 'disabled') {
        status = 'enabled';
      }
      this.config.actions.board_citrix.status = status;
    },
    retrieve: function retrieve() {
      var _this2 = this;

      var bk_api = new __WEBPACK_IMPORTED_MODULE_2__api_BusinessKit__["a" /* default */]();
      bk_api.all_for_association().then(function (items) {
        _this2.businessKitCollection = items;
      });
      var et_api = new __WEBPACK_IMPORTED_MODULE_3__api_EmailTemplate__["a" /* default */]();
      et_api.all_for_association().then(function (items) {
        _this2.emailTemplateCollection = items;
      });
    },
    handleSendTeamConfirmationMailStatus: function handleSendTeamConfirmationMailStatus() {
      var options = this.config.actions.send_team_confirmation_mail;
      var enabled = "disabled";
      if (options.emails.length > 0) {
        enabled = "enabled";
      }
      this.config.actions.send_team_confirmation_mail.status = enabled;
    },
    handleRedirectToAndSuccessMessage: function handleRedirectToAndSuccessMessage(origin) {
      // Flip the two actions
      if (origin === 'success_message') {
        this.config.actions.redirect_to.status = 'disabled';
      } else {
        this.config.actions.success_message.status = 'disabled';
      }
    },
    NoPresentEmailTemplateOrDisabled: function NoPresentEmailTemplateOrDisabled(config) {
      return config.actions.send_lead_confirmation_mail.status === 'disabled' || config.actions.send_lead_confirmation_mail.email_template_foreign_id === null;
    }
  },
  watch: {
    'config.actions.send_lead_confirmation_mail.status': function configActionsSend_lead_confirmation_mailStatus(val) {
      if (val === 'disabled') {
        this.config.actions.send_lead_confirmation_mail.url = '';
        this.config.actions.send_lead_confirmation_mail.cta_text = '';
        this.config.actions.send_lead_confirmation_mail.subject = '';
        this.config.actions.send_lead_confirmation_mail.email_template_foreign_id = null;
      }
    },
    'config.actions.board_businesskit.status': function configActionsBoard_businesskitStatus(val) {
      if (val === 'disabled') {
        this.config.actions.board_businesskit.eventbaxx_event_foreign_id = null;
        this.config.actions.board_businesskit.send_directly = false;
      }
    },
    'config.actions.success_message.status': function configActionsSuccess_messageStatus(val) {
      // Only one can be turned on at any time
      if (val === 'enabled') {
        this.handleRedirectToAndSuccessMessage('success_message');
      }
    },
    'config.actions.redirect_to.status': function configActionsRedirect_toStatus(val) {
      // Only one can be turned on at any time
      if (val === 'enabled') {
        this.handleRedirectToAndSuccessMessage('redirect_to');
      }
    },
    'config.actions.send_team_confirmation_mail.emails': function configActionsSend_team_confirmation_mailEmails() {
      // Automatically turn feature on/off depending on if emails are present in input
      this.handleSendTeamConfirmationMailStatus();
    },

    config: {
      deep: true,
      handler: function handler(val) {
        this.$emit('input', val);
      }
    }
  }
});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Project__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_ExternalForm__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_data_languages__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal___default.a,
    Field: __WEBPACK_IMPORTED_MODULE_3__helpers_DataInput_Field___default.a
  },
  props: ["language"],
  data: function data() {
    return {
      isOpen: false,
      item: {},
      errors: [],
      projects: [],
      languages: __WEBPACK_IMPORTED_MODULE_6__config_data_languages__["a" /* default */]
    };
  },

  computed: {
    currentLanguage: function currentLanguage() {
      return this.$store.getters.getCurrentLanguage;
    },
    languageGetter: function languageGetter() {
      var language = this.currentLanguage || "en";
      var translatedLangs = [];
      var selectedLanguage = this.languages[language];

      if (!selectedLanguage) {
        selectedLanguage = this.languages['en'];
      }

      selectedLanguage.forEach(function (lang) {
        translatedLangs.push(lang);
      });
      return translatedLangs;
    },
    createTitle: function createTitle() {
      return this.$t("ui.pages.external-forms-create-button");
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* EventBus */].$on("action", this.handleAction);
    this.retrieve_projects();
    __WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* EventBus */].$on("open", function (open) {
      _this.isOpen = true;
    });
  },

  methods: {
    create: function create() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var api, item;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                api = new __WEBPACK_IMPORTED_MODULE_5__api_ExternalForm__["a" /* default */]();
                item = _this2.initItem(_this2.item);
                _context.prev = 2;
                _context.next = 5;
                return api.post(item);

              case 5:
                item = _context.sent;

                _this2.$store.commit("SET_NOTIFICATION", {
                  title: "models.external_form.message.create",
                  type: "success"
                });
                _this2.$router.push({
                  name: "external_form_edit",
                  params: { id: item.id }
                });
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);

                _this2.errors = _context.t0.response.data.errors;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 10]]);
      }))();
    },
    initItem: function initItem(item) {
      item.additional_data = {};
      item.configuration = {};
      var structure = {
        submit_button: {
          content: "Submit",
          element_type: "submit",
          name: "submit_button",
          parent_element: "root",
          position: "0",
          hidden: false,
          class: ""
        }
      };

      item.structure = structure;
      return item;
    },
    handleAction: function handleAction(action) {
      if (action == "external_form.add_popup") {
        this.isOpen = true;
      }
    },
    retrieve_projects: function retrieve_projects() {
      var _this3 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_4__api_Project__["a" /* default */]();
      api.all_for_association("name", {
        sort_by: "updated_at",
        sort_order: "DESC"
      }).then(function (items) {
        _this3.projects = items;
      }).catch(function (error) {});
    },
    cancel: function cancel() {
      this.isOpen = false;
    },
    save: function save() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.create();

              case 2:
                if (_this4.errors.length == 0) {
                  _this4.isOpen = false;
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_Drag__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Mask__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DragNDrop_Editor__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DragNDrop_Editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_DragNDrop_Editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_Ui__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    item_saved: {
      type: Object,
      required: true
    }
  },
  components: {
    Editor: __WEBPACK_IMPORTED_MODULE_7__components_helpers_DragNDrop_Editor___default.a
  },
  data: function data() {
    return {
      dragElements: [__WEBPACK_IMPORTED_MODULE_5__classes_Drag__["a" /* default */].generateDefaultElements("external_form")]
    };
  },

  computed: {
    dragEditorEdited: function dragEditorEdited() {
      return this.$store.getters.getDragEditorEdited;
    },
    orderedUnpublishedStructure: function orderedUnpublishedStructure() {
      var structure = this.item.unpublished_structure;
      var clonedStructure = _.cloneDeep(structure);
      var fields = __WEBPACK_IMPORTED_MODULE_6__classes_Mask__["a" /* default */].listFields(structure);
      var array = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(fields)));
      // Sort by position value of objects
      array.sort(function (a, b) {
        return Number(a.position) - Number(b.position);
      });
      return array;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setLeadMaskElements();

            case 2:
              _this.setupHeader();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.dragEditorEdited) {
      var shouldLeave = window.confirm(this.$t("ui.drag_editor.popup.unsaved_changes"));
      if (shouldLeave) {
        this.setEdited(false);
        this.removeHeaderButtons();
      }
      next(shouldLeave);
    } else {
      this.removeHeaderButtons();
      next();
    }
  },

  methods: {
    removeHeaderButtons: function removeHeaderButtons() {
      __WEBPACK_IMPORTED_MODULE_8__classes_Ui__["a" /* default */].setHeaderButtons([]);
    },
    setupHeader: function setupHeader() {
      __WEBPACK_IMPORTED_MODULE_8__classes_Ui__["a" /* default */].setHeaderButtons([{
        name: "external_form_save",
        action: "external_form.save",
        classes: "btn-tertiary"
      }, {
        name: "external_form_publish",
        action: "external_form.publish",
        classes: "btn-primary"
      }]);
    },
    save: function save(structureArray) {
      var structure = __WEBPACK_IMPORTED_MODULE_5__classes_Drag__["a" /* default */].arrayToStructure(_.cloneDeep(structureArray));
      this.item.unpublished_structure = structure;
      this.$emit("update", this.item);
      this.setEdited(false);
    },
    publish: function publish(structureArray) {
      var structure = __WEBPACK_IMPORTED_MODULE_5__classes_Drag__["a" /* default */].arrayToStructure(structureArray);
      this.item.unpublished_structure = structure;
      this.item.structure = structure;
      this.$emit("update", this.item);
      this.setEdited(false);
    },
    setEdited: function setEdited(bool) {
      this.$store.commit("SET_DRAG_EDITOR_EDITED", bool);
    },

    // Fetch lead mask elements for editor
    setLeadMaskElements: function setLeadMaskElements() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var projectApi, res, fields, title;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.item.project_id) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", []);

              case 2:
                projectApi = new __WEBPACK_IMPORTED_MODULE_4__api_Project_js__["a" /* default */]();
                _context2.next = 5;
                return projectApi.lead_mask(_this2.item.project_id);

              case 5:
                res = _context2.sent;
                fields = __WEBPACK_IMPORTED_MODULE_6__classes_Mask__["a" /* default */].listFields(res.structure);
                // Set some values that are needed by the editor

                title = _this2.$t("ui.drag_editor.dragElements.leadMask");

                fields.forEach(function (field) {
                  field.shouldBeDeleted = true;
                  field.parentTitle = title;
                });
                // Remove existing if it is present
                if (_this2.dragElements.some(function (o) {
                  return o.title === title;
                })) {
                  // JavaScript ......
                  delete _this2.dragElements[_this2.dragElements.indexOf(_this2.dragElements.find(function (o) {
                    if (o) {
                      return o.title === title;
                    }
                  }))];
                }
                _this2.dragElements.push({
                  title: title,
                  shouldBeFiltered: true,
                  items: fields
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  watch: {
    "item.project_id": {
      deep: true,
      handler: function handler() {
        this.setLeadMaskElements();
      }
    }
  }
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_ExternalForm_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExternalFormConfiguration__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExternalFormConfiguration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ExternalFormConfiguration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_PageSaver__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_PageSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_PageSaver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_data_languages__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_deep_object_diff__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_deep_object_diff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_deep_object_diff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__classes_Ui__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var tempConfiguration = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    item_saved: {
      type: Object,
      required: true
    }
  },
  components: {
    ExternalFormConfiguration: __WEBPACK_IMPORTED_MODULE_6__ExternalFormConfiguration___default.a,
    PageSaver: __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_PageSaver___default.a,
    Field: __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_Field___default.a
  },
  data: function data() {
    return {
      api: new __WEBPACK_IMPORTED_MODULE_4__api_ExternalForm_js__["a" /* default */](),
      errors: [],
      isRawDisplayed: false,
      projects: [],
      languages: __WEBPACK_IMPORTED_MODULE_8__config_data_languages__["a" /* default */],
      tempItem: {}
    };
  },

  computed: {
    currentLanguage: {
      get: function get() {
        return this.$store.getters.getCurrentLanguage;
      }
    },
    unsavedChanges: function unsavedChanges() {
      // Diff item and item_saved
      return this.generateDiffLength(this.item, this.item_saved) > 0;
    },
    structure: function structure() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.item.structure);
    },
    configuration: function configuration() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.item.configuration);
    },
    additional_data: function additional_data() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.item.additional_data);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.retrieve_projects();

            case 2:
              _this.setupHeader();

              tempConfiguration = _.cloneDeep(_this.item.configuration);
              _this.tempItem = {
                name: _this.item.name,
                language: _this.item.language,
                project_id: _this.item.project_id
              };

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges) {
      var shouldContinue = window.confirm(this.$t('ui.drag_editor.popup.unsaved_changes'));
      next(shouldContinue);
    } else {
      next();
    }
  },

  methods: {
    setupHeader: function setupHeader() {
      __WEBPACK_IMPORTED_MODULE_11__classes_Ui__["a" /* default */].setHeaderButtons([]);
    },
    generateDiffLength: function generateDiffLength(itemOne, itemTwo) {
      var diffObj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_deep_object_diff__["diff"])(itemOne, itemTwo);
      // We delete these since you edit them separately in the editor
      delete diffObj.unpublished_structure;
      delete diffObj.structure;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(diffObj).length;
    },
    retrieve_projects: function retrieve_projects() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var api, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                api = new __WEBPACK_IMPORTED_MODULE_5__api_Project_js__["a" /* default */]();
                _context2.next = 3;
                return api.all_for_association('name', { sort_by: 'updated_at', sort_order: 'DESC' });

              case 3:
                res = _context2.sent;

                _this2.projects = res;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    update: function update() {
      this.$emit('update', this.item);
    },
    cancel: function cancel() {
      this.item.name = this.tempItem.name;
      this.item.language = this.tempItem.language;
      this.item.project_id = this.tempItem.project_id;
      this.item.configuration = _.cloneDeep(tempConfiguration);
    },
    structureChange: function structureChange(val) {
      try {
        this.item.unpublished_structure = JSON.parse(val);
        this.item.structure = JSON.parse(val);
        this.errors = [];
      } catch (e) {
        this.errors.push({ code: "external_form.json.invalid", field_name: "structure" });
      }
    },
    configurationChange: function configurationChange(val) {
      try {
        this.item.configuration = JSON.parse(val);
        this.errors = [];
      } catch (e) {
        this.errors.push({ code: "external_form.json.invalid", field_name: "configuration" });
      }
    },
    additional_dataChange: function additional_dataChange(val) {
      try {
        this.item.additional_data = JSON.parse(val);
        this.errors = [];
      } catch (e) {
        this.errors.push({ code: "external_form.json.invalid", field_name: "additional_data" });
      }
    }
  }
});

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus_js__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      formId: "hileadzz-form-preview"
    };
  },

  computed: {
    slug: function slug() {
      return this.item.slug;
    },
    structure: function structure() {
      if (this.item) {
        return this.item.unpublished_structure;
      }
    },
    hileadzzPublicFormUrl: function hileadzzPublicFormUrl() {
      return this.$store.getters.getHileadzzPublicFormUrl;
    },
    headCode: function headCode() {
      var code = '&lt;head&gt;<br>';
      code += '  &lt;script src="http://forms.fanomena.io/js/fanomena_form-min.js"&gt;&lt;/script&gt;<br>';
      code += '&lt;/head&gt;';
      return code;
    },
    htmlCode: function htmlCode() {
      var code = '&lt;body&gt;<br>';
      code += '  &lt;div id="fanomena-form"/&gt;<br>';
      code += '&lt;/body&gt;';
      return code;
    },
    scriptCode: function scriptCode() {
      var code = '&lt;script&gt;<br>';
      code += '  fanomenaForms.loadForm("' + this.slug + '","fanomena-form")<br>';
      code += '&lt;/script&gt;';
      return code;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var loaded;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.commit('SET_FOOTER_DISPLAY', false);
              _context.next = 3;
              return _this.loadScript();

            case 3:
              loaded = _context.sent;

              if (loaded) {
                _this.setPreview();
                __WEBPACK_IMPORTED_MODULE_2__EventBus_js__["a" /* EventBus */].$on('external_form_update', _this.setPreview);
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  onRouteEnters: function onRouteEnters(to, from, next) {
    this.setPreview();
    next();
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SET_FOOTER_DISPLAY', true);
  },

  methods: {
    loadScript: function loadScript() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.$loadScript(_this2.hileadzzPublicFormUrl.js);

              case 3:
                return _context2.abrupt('return', true);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

                console.log('Failed loading Leads Form script');
                return _context2.abrupt('return', false);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 6]]);
      }))();
    },
    setPreview: function setPreview() {
      // Only load preview if form JS is loaded
      if (typeof hileadzzPublicForms !== 'undefined') {
        if (this.hileadzzPublicFormUrl.apiOverwrite) {
          hileadzzPublicForms.loadFormPreview(this.structure, this.formId, this.hileadzzPublicFormUrl.apiOverwrite);
        } else {
          hileadzzPublicForms.loadFormPreview(this.structure, this.formId);
        }
      }
    },
    disableForm: function disableForm() {
      // disables the form so that no leads are created if the user fills it out
      var form = document.getElementById('form-slug-form');
      var submitButton = document.getElementById('form-submit');
      if (submitButton) {
        submitButton.disabled = true;
      }
      if (form) {
        form.onsubmit = function () {
          return false;
        };
      }
    }
  },
  watch: {
    item: function item() {
      this.setPreview();
    }
  }
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_Layout_PageTabs__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_Layout_PageTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_Layout_PageTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExternalFormCreate__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExternalFormCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ExternalFormCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_data_languages__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_deep_object_diff__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_deep_object_diff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_deep_object_diff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_ExternalForm_js__ = __webpack_require__(177);

//
//
//
//
//
//
//
//
//
//












var tabs = [{ name: 'external_form_editor' }, { name: 'external_form_options' }, { name: 'external_form_preview' }];
/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_Update__["a" /* updateMixin */]],
  data: function data() {
    return {
      tabs: tabs,
      api: new __WEBPACK_IMPORTED_MODULE_10__api_ExternalForm_js__["a" /* default */](),
      model: "external_forms",
      item_saved: {},
      languages: __WEBPACK_IMPORTED_MODULE_7__config_data_languages__["a" /* default */]
    };
  },

  components: {
    ExternalFormCreate: __WEBPACK_IMPORTED_MODULE_4__ExternalFormCreate___default.a,
    PageTabs: __WEBPACK_IMPORTED_MODULE_2__components_helpers_Layout_PageTabs___default.a
  },
  props: ['language'],
  computed: {
    currentTab: function currentTab() {
      return this.$store.state.active_tab || 'editor';
    },
    unpublishedChanges: function unpublishedChanges() {
      // Diff the unpublished and published changes
      // I tried to clean this code up a little by combining the two loops
      // but it didn't work and I am in a rush :)
      if (!this.item || !this.item.structure || !this.item.unpublished_structure) {
        return 0;
      }
      return this.generateDiffLength();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.commit('RESET_DRAG_EDITOR');
    this.$store.commit('SET_HEADER_COMPRESSED', false);
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // necessary as otherwise the redirect in created() would trigger again
    if (to.name === 'external_form_edit') {
      this.$router.push({
        name: 'external_forms'
      });
    }
    this.$store.commit('SET_ACTIVE_TAB', to.name);
    next();
  },
  created: function created() {
    // Navigate to editor directly
    if (this.$route.name === 'external_form_edit') {
      this.$router.push({
        name: 'external_form_editor'
      });
    }
  },
  mounted: function mounted() {
    this.$store.commit('SET_ACTIVE_TAB', this.tabs[0].name);
    this.$store.commit('SET_HEADER_COMPRESSED', true);
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setSecondaryHeaderTabs(this.tabs);
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setPageLevel(3);
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setSubtitle({ link: { name: 'external_forms' } });
    if (!this.item.configuration) {
      this.item.configuration = {};
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('EMPTY_TABS');
    this.$store.commit('EMPTY_NOTIFICATION');
    this.$store.commit('SET_SECONDARY_HEADER_TABS', []);
    window.removeEventListener('onbeforeunload', function () {});
  },

  methods: {
    generateDiffLength: function generateDiffLength() {
      var clonedStructure = _.cloneDeep(this.item.structure);
      var clonedUnpublishedStructure = _.cloneDeep(this.item.unpublished_structure);
      var diffObj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_deep_object_diff__["diff"])(clonedStructure, clonedUnpublishedStructure);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(diffObj).length;
    },
    afterRetrieve: function afterRetrieve() {
      this.item_saved = _.clone(this.item);
    },
    isDisabled: function isDisabled() {
      if (this.value.actions.board_businesskit.status === 'disabled') {
        this.value.actions.board_businesskit.send_directly = false;
        return true;
      }
      return false;
    },
    update: function update(item) {
      var _this = this;

      if (!item) {
        item = this.item;
      }
      this.api.post(item).then(function (item) {
        _this.item = item;
        _this.item_saved = _.clone(item);
        _this.errors = [];
        _this.$store.commit('SET_NOTIFICATION', {
          'title': 'models.' + _this.singular_model + '.message.' + _this.type,
          'type': 'success'
        });
        __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].$emit('external_form_update', _this.item);
      }).catch(function (e) {
        _this.errors = e.response.data.errors;
        _this.$store.commit('SET_NOTIFICATION', {
          'title': 'errors.' + e.response.data.errors[0].code,
          'type': 'error'
        });
      });
    }
  },
  watch: {
    unpublishedChanges: function unpublishedChanges(val) {
      this.$store.commit('SET_DRAG_EDITOR_UNPUBLISHED_CHANGES', val);
    }
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_ExternalForm__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_Collection__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExternalFormCreate__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExternalFormCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ExternalFormCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_Searchbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_Searchbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_Searchbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_GeneralListing__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_GeneralListing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_GeneralListing__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var structure = [{ name: 'id', sortable: true, credentials: 'root' }, { name: 'name', type: 'show_with_edit_link', sortable: true }, { name: 'project_name', type: 'project_link', sortable: true }, { name: 'slug', type: 'form_slug' }, { name: 'action', type: 'crud_action_folded' }];

var default_sort_by = "created_at";
var default_sort_order = "DESC";
var default_filters = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ExternalFormCreate: __WEBPACK_IMPORTED_MODULE_4__ExternalFormCreate___default.a,
    Searchbar: __WEBPACK_IMPORTED_MODULE_5__components_layouts_partials_Searchbar___default.a,
    GeneralListing: __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_GeneralListing___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_Collection__["a" /* collectionMixin */]],
  data: function data() {
    return {
      model: "external_forms",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_ExternalForm__["a" /* default */](),
      collectionData: structure,
      title: "ui.pages.external-forms",
      loading: false,
      query: {},
      formNavigation: [{ name: "external_forms", action: "external_forms.list", credential: "external_forms.list" }, { name: "email_templates", action: "email_templates.list", credential: "email_templates.list" }],
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_EXTERNAL_FORMS',
        routerName: 'external_forms',
        emptyState: 'external_forms',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    };
  },
  mounted: function mounted() {
    if (this.page != __WEBPACK_IMPORTED_MODULE_3__classes_Ui__["a" /* default */].getCurrentPageExternalForms()) {
      this.goToPage(__WEBPACK_IMPORTED_MODULE_3__classes_Ui__["a" /* default */].getCurrentExternalForms());
    }

    __WEBPACK_IMPORTED_MODULE_3__classes_Ui__["a" /* default */].setHeaderButtons([{ name: "external_form", action: "external_form.add_popup", classes: "btn-primary" }]);
    __WEBPACK_IMPORTED_MODULE_3__classes_Ui__["a" /* default */].setSecondaryHeaderTabs(this.formNavigation);

    __WEBPACK_IMPORTED_MODULE_2__EventBus_js__["a" /* EventBus */].$off('external_form_duplicate');
    __WEBPACK_IMPORTED_MODULE_2__EventBus_js__["a" /* EventBus */].$on('external_form_duplicate', this.duplicate);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SET_SECONDARY_HEADER_TABS', []);
  },
  created: function created() {
    //  In case we generate a query, we create it before to be able to retrieve it in collection and display the specific list.
    this.initQuery();
  },

  methods: {
    duplicate: function duplicate(payload) {
      var _this = this;

      this.api.duplicate(payload.id).then(function (data) {
        _this.retrieve();
        var newForm = data.resource;
        var route = { name: 'external_form_edit', params: { id: newForm.id } };
        _this.$router.push(route);
      });
    }
  }
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__);

//
//
//
//
//
//
//



var defaultConfig = {
  actions: {}
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default.a
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return defaultConfig;
      }
    }
  },
  computed: {
    config: function config() {
      var _this = this;

      // Use value prop but also Validate that it contains all necessary attributes
      var configuration = defaultConfig;
      if (!this.value.actions) {
        return configuration;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.value.actions).forEach(function (key) {
        var hash = _this.value.actions[key];
        // If key is not present in defaultConfig we add it
        if (!configuration['actions'][key]) {
          configurations['actions'][key] = hash;
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(hash).forEach(function (keyInner) {
          var valueInner = hash[keyInner];
          configuration['actions'][key][keyInner] = valueInner;
        });
      });
      return configuration;
    }
  },
  watch: {
    config: {
      deep: true,
      handler: function handler(val) {
        this.$emit('input', val);
      }
    }
  }
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Organization__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_LeadMask__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_data_languages__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_NewModal__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_NewModal___default.a,
    Field: __WEBPACK_IMPORTED_MODULE_3__helpers_DataInput_Field___default.a
  },
  props: ["language"],
  data: function data() {
    return {
      isOpen: false,
      item: {},
      errors: [],
      organizations: [],
      languages: __WEBPACK_IMPORTED_MODULE_7__config_data_languages__["a" /* default */]
    };
  },

  computed: {
    currentLanguage: function currentLanguage() {
      return this.$store.getters.getCurrentLanguage;
    },
    languageGetter: function languageGetter() {
      var language = this.currentLanguage || 'en';
      var translatedLangs = [];
      var selectedLanguage = this.languages[language];

      if (!selectedLanguage) {
        selectedLanguage = this.languages['en'];
      }

      selectedLanguage.forEach(function (lang) {
        translatedLangs.push(lang);
      });
      return translatedLangs;
    },
    createTitle: function createTitle() {
      return this.$t("ui.pages.lead-mask-create-button");
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* EventBus */].$on("action", this.handleAction);
    this.retrieve_associations();
    __WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* EventBus */].$on("open", function (open) {
      _this.isOpen = true;
    });
  },

  methods: {
    create: function create() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var api, item;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                api = new __WEBPACK_IMPORTED_MODULE_6__api_LeadMask__["a" /* default */]();
                item = _this2.initItem(_this2.item);
                _context.prev = 2;
                _context.next = 5;
                return api.post(item);

              case 5:
                item = _context.sent;

                _this2.$store.commit("SET_NOTIFICATION", {
                  title: "models.lead_mask.message.create",
                  type: "success"
                });
                _this2.$router.push({ name: "lead_mask_edit", params: { id: item.id } });
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);

                _this2.errors = _context.t0.response.data.errors;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 10]]);
      }))();
    },
    initItem: function initItem(item) {
      item.additional_data = {};
      item.configuration = {};
      item.structure = {};
      return item;
    },
    handleAction: function handleAction(action) {
      if (action == "lead_masks.add_popup") {
        this.isOpen = true;
      }
    },
    retrieve_associations: function retrieve_associations() {
      var _this3 = this;

      var permission = __WEBPACK_IMPORTED_MODULE_5__classes_Permission__["a" /* default */].loadPermissions();

      if (__WEBPACK_IMPORTED_MODULE_5__classes_Permission__["a" /* default */].can(permission, "organizations.list")) {
        var api = new __WEBPACK_IMPORTED_MODULE_4__api_Organization__["a" /* default */]();
        api.all_for_association().then(function (items) {
          _this3.organizations = items;
        }).catch(function (error) {});
      }
    },
    cancel: function cancel() {
      this.isOpen = false;
    },
    save: function save() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.create();

              case 2:
                console.log(_this4.errors);
                if (_this4.errors.length == 0) {
                  _this4.isOpen = false;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_Drag__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Mask__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DragNDrop_Editor__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DragNDrop_Editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_DragNDrop_Editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_Ui__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    item_saved: {
      type: Object,
      required: true
    }
  },
  components: {
    Editor: __WEBPACK_IMPORTED_MODULE_7__components_helpers_DragNDrop_Editor___default.a
  },
  data: function data() {
    return {
      dragElements: [__WEBPACK_IMPORTED_MODULE_5__classes_Drag__["a" /* default */].generateDefaultElements('lead_sheet')]
    };
  },

  computed: {
    dragEditorEdited: function dragEditorEdited() {
      return this.$store.getters.getDragEditorEdited;
    },
    orderedUnpublishedStructure: function orderedUnpublishedStructure() {
      var structure = this.item.unpublished_structure;
      var clonedStructure = _.cloneDeep(structure);
      var fields = __WEBPACK_IMPORTED_MODULE_6__classes_Mask__["a" /* default */].listFields(structure);
      var array = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(fields)));
      // Sort by position value of objects
      array.sort(function (a, b) {
        return Number(a.position) - Number(b.position);
      });
      return array;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setupHeader();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.dragEditorEdited) {
      var shouldLeave = window.confirm(this.$t('ui.drag_editor.popup.unsaved_changes'));
      if (shouldLeave) {
        this.setEdited(false);
        this.removeHeaderButtons();
      }
      next(shouldLeave);
    } else {
      this.removeHeaderButtons();
      next();
    }
  },

  methods: {
    removeHeaderButtons: function removeHeaderButtons() {
      __WEBPACK_IMPORTED_MODULE_8__classes_Ui__["a" /* default */].setHeaderButtons([]);
    },
    setupHeader: function setupHeader() {
      __WEBPACK_IMPORTED_MODULE_8__classes_Ui__["a" /* default */].setHeaderButtons([{ name: "lead_mask_save", action: "lead_mask.save", classes: "btn-tertiary" }, { name: "lead_mask_publish", action: "lead_mask.publish", classes: "btn-primary" }]);
    },
    save: function save(structureArray) {
      var structure = __WEBPACK_IMPORTED_MODULE_5__classes_Drag__["a" /* default */].arrayToStructure(_.cloneDeep(structureArray));
      this.item.unpublished_structure = structure;
      this.$emit('update', this.item);
      this.setEdited(false);
    },
    publish: function publish(structureArray) {
      var structure = __WEBPACK_IMPORTED_MODULE_5__classes_Drag__["a" /* default */].arrayToStructure(structureArray);
      this.item.unpublished_structure = structure;
      this.item.structure = structure;
      this.$emit('update', this.item);
      this.setEdited(false);
    },
    setEdited: function setEdited(bool) {
      this.$store.commit('SET_DRAG_EDITOR_EDITED', bool);
    }
  }
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_LeadMask_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Organization_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeadMaskConfiguration__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeadMaskConfiguration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LeadMaskConfiguration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_PageSaver__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_PageSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_PageSaver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_data_languages__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_deep_object_diff__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_deep_object_diff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_deep_object_diff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classes_Ui__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    item_saved: {
      type: Object,
      required: true
    }
  },
  components: {
    LeadMaskConfiguration: __WEBPACK_IMPORTED_MODULE_6__LeadMaskConfiguration___default.a,
    PageSaver: __WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_PageSaver___default.a,
    Field: __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataInput_Field___default.a
  },
  data: function data() {
    return {
      api: new __WEBPACK_IMPORTED_MODULE_4__api_LeadMask_js__["a" /* default */](),
      errors: [],
      isRawDisplayed: false,
      organizations: [],
      languages: __WEBPACK_IMPORTED_MODULE_9__config_data_languages__["a" /* default */],
      tempItem: {}
    };
  },

  computed: {
    currentLanguage: {
      get: function get() {
        return this.$store.getters.getCurrentLanguage;
      }
    },
    unsavedChanges: function unsavedChanges() {
      // Diff item and item_saved
      return this.generateDiffLength(this.item, this.item_saved) > 0;
    },
    structure: function structure() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.item.structure);
    },
    configuration: function configuration() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.item.configuration);
    },
    additional_data: function additional_data() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.item.additional_data);
    },
    selectableLanguages: function selectableLanguages() {
      var language = this.currentLanguage || "en";
      var translatedLangs = [];
      var selectedLanguage = this.languages[language];

      if (!selectedLanguage) {
        selectedLanguage = this.languages['en'];
      }

      selectedLanguage.forEach(function (lang) {
        translatedLangs.push(lang);
      });

      return translatedLangs;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.retrieve_associations();
              _this.setupHeader();
              _this.tempItem.name = _this.item.name;
              _this.tempItem.language = _this.item.language;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges) {
      var shouldContinue = window.confirm(this.$t('ui.drag_editor.popup.unsaved_changes'));
      next(shouldContinue);
    } else {
      next();
    }
  },

  methods: {
    setupHeader: function setupHeader() {
      __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setHeaderButtons([]);
    },
    generateDiffLength: function generateDiffLength(itemOne, itemTwo) {
      var diffObj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_deep_object_diff__["diff"])(itemOne, itemTwo);
      // We delete these since you edit them separately in the editor
      delete diffObj.unpublished_structure;
      delete diffObj.structure;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(diffObj).length;
    },
    update: function update() {
      this.$emit('update', this.item);
    },
    structureChange: function structureChange(val) {
      try {
        this.item.unpublished_structure = JSON.parse(val);
        this.item.structure = JSON.parse(val);
        this.errors = [];
      } catch (e) {
        this.errors.push({ code: "lead_mask.json.invalid", field_name: "structure" });
      }
    },
    configurationChange: function configurationChange(val) {
      try {
        this.item.configuration = JSON.parse(val);
        this.errors = [];
      } catch (e) {
        this.errors.push({ code: "lead_mask.json.invalid", field_name: "configuration" });
      }
    },
    additional_dataChange: function additional_dataChange(val) {
      try {
        this.item.additional_data = JSON.parse(val);
        this.errors = [];
      } catch (e) {
        this.errors.push({ code: "lead_mask.json.invalid", field_name: "additional_data" });
      }
    },
    retrieve_associations: function retrieve_associations() {
      var _this2 = this;

      var permission = __WEBPACK_IMPORTED_MODULE_7__classes_Permission__["a" /* default */].loadPermissions();

      if (__WEBPACK_IMPORTED_MODULE_7__classes_Permission__["a" /* default */].can(permission, 'organizations.list')) {
        var api = new __WEBPACK_IMPORTED_MODULE_5__api_Organization_js__["a" /* default */]();
        api.all_for_association().then(function (items) {
          _this2.organizations = items;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    cancel: function cancel() {
      this.item.name = this.tempItem.name;
      this.item.language = this.tempItem.language;
    }
  }
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_LeadMask_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Organization_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_PageTabs__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_PageTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_PageTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_PageSaver__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_PageSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_PageSaver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_lead_masks_LeadMaskEditor__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_lead_masks_LeadMaskEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_lead_masks_LeadMaskEditor__);

//
//
//
//
//
//
//
//
//
//











var tabs = [{ name: 'lead_mask_editor' }, { name: 'lead_mask_options' }];
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PageTabs: __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_PageTabs___default.a,
    PageSaver: __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_PageSaver___default.a,
    Editor: __WEBPACK_IMPORTED_MODULE_8__components_pages_lead_masks_LeadMaskEditor___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_Update__["a" /* updateMixin */]],
  data: function data() {
    return {
      tabs: tabs,
      model: "lead_masks",
      api: new __WEBPACK_IMPORTED_MODULE_1__api_LeadMask_js__["a" /* default */](),
      organizations: [],
      isRawDisplayed: false,
      item_saved: {}
    };
  },

  computed: {
    structure: function structure() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.item.structure);
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // necessary as otherwise the redirect in created() would trigger again
    if (to.name === 'lead_mask_edit') {
      this.$router.push({
        name: 'lead_masks'
      });
    }
    next();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.commit('RESET_DRAG_EDITOR');
    this.$store.commit('SET_HEADER_COMPRESSED', false);
    next();
  },
  created: function created() {
    // Navigate to editor directly
    if (this.$route.name === 'lead_mask_edit') {
      this.$router.push({
        name: 'lead_mask_editor'
      });
    }
  },
  mounted: function mounted() {
    this.$store.commit('SET_ACTIVE_TAB', this.tabs[0].name);
    this.$store.commit('SET_HEADER_COMPRESSED', true);
    this.retrieve_organizations();
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setSecondaryHeaderTabs(this.tabs);
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setPageLevel(3);
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setSubtitle({ link: { name: 'lead_masks' } });
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('EMPTY_TABS');
    this.$store.commit('EMPTY_NOTIFICATION');
    this.$store.commit('SET_SECONDARY_HEADER_TABS', []);
  },

  methods: {
    newLeadMaskPath: function newLeadMaskPath() {
      return this.$route.path === '/lead_mask/new';
    },
    retrieve_organizations: function retrieve_organizations() {
      var _this = this;

      var permission = __WEBPACK_IMPORTED_MODULE_7__classes_Permission__["a" /* default */].loadPermissions();
      if (__WEBPACK_IMPORTED_MODULE_7__classes_Permission__["a" /* default */].can(permission, 'organizations.list')) {
        var api = new __WEBPACK_IMPORTED_MODULE_3__api_Organization_js__["a" /* default */]();
        api.all_for_association().then(function (items) {
          _this.organizations = items;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    changeTab: function changeTab(name) {
      this.currentTab = name;
    },
    structureChange: function structureChange(val) {
      try {
        this.item.structure = JSON.parse(val);
        this.errors = [];
      } catch (e) {
        this.errors.push({ code: "lead_mask.json.invalid", field_name: "structure" });
      }
    },
    afterRetrieve: function afterRetrieve() {
      this.item_saved = _.clone(this.item);
    },
    update: function update(item) {
      var _this2 = this;

      if (!item) {
        item = this.item;
      }
      this.api.post(item).then(function (item) {
        _this2.item = item;
        _this2.item_saved = _.clone(item);
        _this2.errors = [];
        _this2.$store.commit('SET_NOTIFICATION', {
          'title': 'models.' + _this2.singular_model + '.message.' + _this2.type,
          'type': 'success'
        });
        EventBus.$emit('lead_mask_update', _this2.item);
      }).catch(function (e) {
        console.error('err:', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
        if (e.response) {
          _this2.errors = e.response.data.errors;
          _this2.$store.commit('SET_NOTIFICATION', {
            'title': 'errors.' + e.response.data.errors[0].code,
            'type': 'error'
          });
        }
      });
    }
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_LeadMask__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_Collection__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_Searchbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_Searchbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_Searchbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeadMaskCreate__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeadMaskCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LeadMaskCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_GeneralListing__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_GeneralListing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_GeneralListing__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var structure = [{ name: 'id', sortable: true, credentials: 'root' }, { name: 'name', type: 'show_with_edit_link', sortable: true }, { name: 'language', sortable: true }, { name: 'organization.name', sortable: true, credentials: 'root', alias: 'organization_name' }, { name: 'action', type: 'crud_action_folded' }];

var default_sort_by = "created_at";
var default_sort_order = "DESC";
var default_filters = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_Collection__["a" /* collectionMixin */]],
  components: {
    Searchbar: __WEBPACK_IMPORTED_MODULE_4__components_layouts_partials_Searchbar___default.a,
    LeadMaskCreate: __WEBPACK_IMPORTED_MODULE_5__LeadMaskCreate___default.a,
    GeneralListing: __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_GeneralListing___default.a
  },
  data: function data() {
    return {
      model: "lead_masks",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_LeadMask__["a" /* default */](),
      collectionData: structure,
      title: "ui.pages.lead-masks",
      loading: false,
      query: {},
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_LEAD_MASKS',
        routerName: 'lead_masks',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    };
  },
  created: function created() {
    //  In case we generate a query, we create it before to be able to retrieve it in collection and display the specific list.
    this.initQuery();
  },
  mounted: function mounted() {
    if (this.page != __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].getCurrentPageLeadMasks()) {
      this.goToPage(__WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].getCurrentPageLeadMasks());
    }
    __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setHeaderButtons([{ name: 'lead_mask',
      action: "lead_masks.add_popup",
      classes: "btn-primary"
    }]);
    __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].$off('lead_mask_duplicate');
    __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].$on('lead_mask_duplicate', this.duplicate);
  },

  methods: {
    duplicate: function duplicate(payload) {
      var _this = this;

      this.api.duplicate(payload.id).then(function (data) {
        _this.retrieve();
        var newForm = data.resource;
        var route = { name: 'lead_mask_edit', params: { id: newForm.id } };
        _this.$router.push(route);
      });
    }
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Organization_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Plan_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_CountrySelect__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_CountrySelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_CountrySelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_SecretField__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_SecretField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_SecretField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_Configuration__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_UploadField__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_UploadField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_UploadField__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var configuration_list = [{ name: 'ranking_display', type: 'ui' }, { name: 'eventbaxx_auth_token', type: 'api' }, { name: 'api_token_eventbaxx', type: 'secret' }, { name: 'enrichment_disabled', type: 'api' }, { name: 'mailchimp_api_key', type: 'secret' }, { name: 'xing_consumer_key', type: 'secret' }];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_Update__["a" /* updateMixin */]],
  components: { CountrySelect: __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_CountrySelect___default.a, FormSwitch: __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch___default.a, SecretField: __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_SecretField___default.a, UploadField: __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataInput_UploadField___default.a },
  data: function data() {
    return {
      model: "organizations",
      api: new __WEBPACK_IMPORTED_MODULE_2__api_Organization_js__["a" /* default */](),
      configuration: {},
      plans: [],
      company_logo_data: null
    };
  },

  computed: {
    currentUserIsRoot: function currentUserIsRoot() {
      return this.$store.getters.currentUser.role === 'root';
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var configuration;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.fetchPlans();

              if (!(_this.type == 'update')) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return _this.retrieveConfiguration();

            case 4:
              configuration = _context.sent;

              _this.configuration = __WEBPACK_IMPORTED_MODULE_8__classes_Configuration__["a" /* default */].mapConfiguration(configuration);
              configuration_list.forEach(function (configuration) {
                if (_.isEmpty(_this.configuration[configuration['name']])) {
                  _this.configuration[configuration['name']] = {
                    configuration_type: configuration['type']
                  };
                }
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    retrieveConfiguration: function retrieveConfiguration() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var organization_id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                organization_id = _this2.id;
                _context2.next = 3;
                return _this2.api.configuration(organization_id);

              case 3:
                return _context2.abrupt('return', _context2.sent);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchPlans: function fetchPlans() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var planApi, _ref, resources;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                planApi = new __WEBPACK_IMPORTED_MODULE_3__api_Plan_js__["a" /* default */]();
                _context3.next = 3;
                return planApi.all({ disable_pagination: 'true' });

              case 3:
                _ref = _context3.sent;
                resources = _ref.resources;

                // Only grab name attribute
                _this3.plans = resources.reduce(function (prev, curr, idx) {
                  prev.push({ name: curr.name, value: curr.name });
                  return prev;
                }, []);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    update: function update() {
      var _this4 = this;

      // update organization
      this.api.post(this.item).then(function (item) {
        _this4.item = item;
        // update organization configuration
        if (_this4.type == 'update') {
          _this4.api.update_configuration(_this4.id, _this4.configuration).then(function (config) {
            _this4.configuration = config;

            _this4.$store.commit('SET_NOTIFICATION', {
              'title': 'models.' + _this4.singular_model + '.message.' + _this4.type,
              'type': 'success'
            });
            __WEBPACK_IMPORTED_MODULE_8__classes_Configuration__["a" /* default */].setOrganizationConfig(_this4.$store.getters.currentUser);
            _this4.$router.push(_this4.redirection);
          }).catch(function (e) {
            _this4.errors = e.response.data.errors;
            _this4.$store.commit('SET_NOTIFICATION', {
              'title': 'errors.' + e.response.data.errors[0].code,
              'type': 'error'
            });
          });
        } else {
          _this4.$router.push(_this4.redirection);
        }
      }).catch(function (e) {
        _this4.errors = e.response.data.errors;
      });
    },
    logoUpload: function logoUpload(payload) {
      var _this5 = this;

      var file = payload;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        _this5.company_logo_data = reader.result;
        _this5.item.company_logo_url = null;
        _this5.item.company_logo_data = reader.result;
      };
    },
    mapConfiguration: function mapConfiguration(configuration) {
      var output = {};
      configuration.forEach(function (value, key) {
        output[value['key']] = {
          content: value['content'],
          configuration_type: value['configuration_type']
        };
      });
      return output;
    }
  }
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_Organization__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_Collection__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue__);
//
//
//
//
//
//
//
//
//






var structure = [{ name: 'status', type: 'status' }, { name: 'id', sortable: true }, { name: 'name', type: 'show_with_edit_link', sortable: true }, { name: 'users__count' }, { name: 'action', type: 'edit_action' }, { name: 'action_delete', type: 'delete_action' }];

var default_sort_by = "created_at";
var default_sort_order = "DESC";
var default_filters = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Searchbar: __WEBPACK_IMPORTED_MODULE_3__components_layouts_partials_Searchbar_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_Collection__["a" /* collectionMixin */]],
  mounted: function mounted() {
    if (this.page != __WEBPACK_IMPORTED_MODULE_2__classes_Ui__["a" /* default */].getCurrentPageOrganizations()) {
      this.goToPage(__WEBPACK_IMPORTED_MODULE_2__classes_Ui__["a" /* default */].getCurrentPageOrganizations());
    }
  },
  data: function data() {
    return {
      model: "organizations",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_Organization__["a" /* default */](),
      collectionData: structure,
      title: "ui.pages.organizations",
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_ORGANIZATIONS',
        routerName: 'organizations',
        emptyState: 'organizations',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    };
  }
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    organizations: {
      type: Array
    }
  }
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_plans_PlanRuleListItem__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_plans_PlanRuleListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pages_plans_PlanRuleListItem__);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    rules: {
      type: Object
    }
  },
  components: {
    PlanRuleListItem: __WEBPACK_IMPORTED_MODULE_0__components_pages_plans_PlanRuleListItem___default.a
  }
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_FormSwitch__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_FormSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_FormSwitch__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      type: String
    },
    value: {},
    rules: {
      type: Object
    }
  },
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default.a,
    FormSwitch: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_FormSwitch___default.a
  },
  data: function data() {
    return {
      errors: []
    };
  },

  computed: {
    isBoolean: function isBoolean() {
      var potentialBoolValue = this.value === 'true' ? true : this.value === 'false' ? false : this.value;
      return typeof potentialBoolValue === 'boolean';
    }
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_Plan_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_Accordion__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_Accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_Accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_plans_PlanRuleList__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_plans_PlanRuleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_plans_PlanRuleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_plans_PlanOrganizationList__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_plans_PlanOrganizationList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_plans_PlanOrganizationList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Layout_PageSaver__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Layout_PageSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_Layout_PageSaver__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_Update__["a" /* updateMixin */]],
  components: {
    PlanRuleList: __WEBPACK_IMPORTED_MODULE_3__components_pages_plans_PlanRuleList___default.a,
    PlanOrganizationList: __WEBPACK_IMPORTED_MODULE_4__components_pages_plans_PlanOrganizationList___default.a,
    PageSaver: __WEBPACK_IMPORTED_MODULE_6__components_helpers_Layout_PageSaver___default.a,
    Accordion: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_Accordion___default.a
  },
  data: function data() {
    return {
      model: "plans",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_Plan_js__["a" /* default */](),
      name: "plan",
      errors: [],
      accordionOne: 'PlanRuleList',
      accordionTwo: 'PlanOrganizationList'
    };
  },

  computed: {
    accordionOneProps: function accordionOneProps() {
      return { rules: this.item.rules };
    },
    accordionTwoProps: function accordionTwoProps() {
      return { organizations: this.item.organizations };
    }
  },
  mounted: function mounted() {
    this.init();
    __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].clearHeaderButtons();
    this.setHeaderButtons();
  },

  methods: {
    setHeaderButtons: function setHeaderButtons() {
      __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setPageLevel(3);
      __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setSubtitle({
        link: { name: "plans", path: "/plans" }
      });
    }
  }
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Plan__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_Collection__ = __webpack_require__(62);

//
//
//
//
//
//






var structure = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({ name: 'id', credentials: 'admin', sortable: true }, 'credentials', 'root'), { name: 'name', type: 'project_name', title: 'Name', sortable: true }, { name: 'price', title: 'Price', sortable: true }, { name: 'organizations_count', title: 'Organizations', sortable: true }];

var default_sort_by = "id";
var default_sort_order = "DESC";
var default_filters = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_Collection__["a" /* collectionMixin */]],
  components: {
    Collection: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection___default.a
  },
  data: function data() {
    return {
      model: "plans",
      api: new __WEBPACK_IMPORTED_MODULE_1__api_Plan__["a" /* default */](),
      collectionData: structure,
      query: {},
      title: "ui.pages.plans",
      loading: false,
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_PLANS',
        routerName: 'plans',
        emptyState: 'plans',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    };
  },
  created: function created() {
    this.initQuery();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__classes_Ui__["a" /* default */].clearHeaderButtons();
  }
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_User__ = __webpack_require__(33);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['project_id'],
  data: function data() {
    return {
      errors: []
    };
  },
  mounted: function mounted() {
    this.retrieve();
  },

  methods: {
    retrieve: function retrieve() {
      var _this = this;

      var api = new __WEBPACK_IMPORTED_MODULE_0__api_User__["a" /* default */]();
      api.all({ project_id: this.project_id }).then(function (items) {}).catch(function (e) {
        _this.errors = e.response.data.errors;
      });
    }
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_project_leads_LeadCreate__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_project_leads_LeadCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pages_project_leads_LeadCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_empty_business_card_svg__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_empty_business_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_empty_business_card_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item', 'open'],
  data: function data() {
    return {
      isOpen: false,
      image: __WEBPACK_IMPORTED_MODULE_2__assets_empty_business_card_svg___default.a
    };
  },

  components: { LeadCreate: __WEBPACK_IMPORTED_MODULE_1__components_pages_project_leads_LeadCreate___default.a },
  mounted: function mounted() {
    this.isOpen = this.open;
  },

  methods: {
    closePopup: function closePopup() {
      this.isOpen = false;
    },
    openPopup: function openPopup() {
      this.isOpen = true;
    }
  },
  watch: {
    open: function open() {
      this.isOpen = true;
    }
  }
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_VueWebcam__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_VueWebcam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_VueWebcam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_Lead__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_detect_browser__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_detect_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_detect_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_UserApiChoice__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_UserApiChoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_UserApiChoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_layouts_partials_AppDownloadScreen__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_layouts_partials_AppDownloadScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_layouts_partials_AppDownloadScreen__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_Field___default.a,
    VueWebcam: __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_VueWebcam___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_helpers_Specific_Loading_vue___default.a,
    UserApiChoice: __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_UserApiChoice___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_11__components_helpers_Layout_NewModal___default.a,
    AppDownloadScreen: __WEBPACK_IMPORTED_MODULE_13__components_layouts_partials_AppDownloadScreen___default.a
  },
  props: ["id"],
  data: function data() {
    var _ref;

    return _ref = {
      isOpen: false,
      email: null,
      apiError: {},
      errors: [],
      view: null
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "email", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "photo", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "loading", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "browser", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_detect_browser__["detect"])()), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "debug", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "apiErrorAttributes", ["website", "street", "street_number", "zip", "city"]), _ref;
  },

  computed: {
    modalTitleCreate: function modalTitleCreate() {
      return this.$t("ui.pages.lead-create");
    },
    modalSaveTextEmail: function modalSaveTextEmail() {
      return this.$t("ui.button.project_leads.create");
    },
    modalSaveTextWebcam: function modalSaveTextWebcam() {
      return this.$t("ui.button.project_leads.create");
    },
    modalSaveTextContinue: function modalSaveTextContinue() {
      return this.$t("ui.button.project_leads.continue");
    },
    currentPlanIsTalent: function currentPlanIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent;
    },
    realDebug: function realDebug() {
      return this.debug;
    },
    lead: function lead() {
      return this.$store.getters.getCurrentLead;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_8__classes_Ui__["a" /* default */].setPageLevel(3);
    // set subtitle
    var project_api = new __WEBPACK_IMPORTED_MODULE_7__api_Project_js__["a" /* default */]();
    project_api.show(this.id);

    // Empty lead data to go  in Vuex
    this.$store.commit("EMPTY_LEAD");

    __WEBPACK_IMPORTED_MODULE_12__EventBus_js__["a" /* EventBus */].$on("action", this.handleAction);

    // If current plan is Talent we don't support capturing with scan
    if (this.currentPlanIsTalent) {
      this.view = "email";
    }
  },

  methods: {
    uploadedImage: function uploadedImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var _this = this;

      var reader = new FileReader();
      reader.onload = function (e) {
        var dataURI = e.target.result;
        if (dataURI) {
          _this.$emit("load", dataURI);
          _this.photo = dataURI;
          _this.createFromBusinessCard();
        }
      };
      reader.readAsDataURL(file);
    },
    mailChange: function mailChange() {},
    handleAction: function handleAction(action) {
      if (action == "project_leads.add_popup") {
        this.setIsOpen(true);
      }
    },
    setIsOpen: function setIsOpen(bool) {
      this.isOpen = bool;
      if (!bool && !this.currentPlanIsTalent) {
        this.view = null;
      }
    },
    takePhoto: function takePhoto() {
      this.photo = this.$refs.webcam.getPhoto();
      this.createFromBusinessCard();
    },
    changeView: function changeView(view) {
      if (view === null) {
        this.photo = null;
        this.lead.email = null;
      }
      this.view = view;
    },
    createFromBusinessCard: function createFromBusinessCard() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var api, data, item;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_8__classes_Ui__["a" /* default */].startLoading();
                api = new __WEBPACK_IMPORTED_MODULE_6__api_Lead__["a" /* default */]("v2");
                data = {
                  project_id: _this2.id,
                  business_card_data: _this2.photo,
                  origin: "web_app"
                };
                _context.prev = 3;
                _context.next = 6;
                return api.upload_business_card(data);

              case 6:
                item = _context.sent;

                _this2.new_lead = item;
                _this2.setNotification(item);
                _this2.closePopupAndContinue(item);
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](3);

                _this2.errors = _context.t0.response.data.errors;
                _this2.handleApiError(_context.t0);

              case 16:
                _context.prev = 16;

                __WEBPACK_IMPORTED_MODULE_8__classes_Ui__["a" /* default */].finishLoading();
                _this2.loading = false;
                return _context.finish(16);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 12, 16, 20]]);
      }))();
    },
    createFromEmail: function createFromEmail() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var api, item;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                api = new __WEBPACK_IMPORTED_MODULE_6__api_Lead__["a" /* default */]();
                _context2.prev = 1;

                _this3.lead.origin = "web_app";
                _context2.next = 5;
                return api.post(_this3.lead);

              case 5:
                item = _context2.sent;

                _this3.new_lead = item;
                _this3.setNotification(item);
                _this3.closePopupAndContinue(item);
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);

                _this3.errors = _context2.t0.response.data.errors;
                _this3.handleApiError(_context2.t0);

              case 15:
                _context2.prev = 15;

                _this3.loading = false;
                return _context2.finish(15);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 11, 15, 18]]);
      }))();
    },
    handleApiError: function handleApiError(error) {
      var apiResponse = JSON.parse(error.request.response);
      if (apiResponse.errors.length === 0) {
        // TODO add error handling
      } else {
        this.apiError = apiResponse;
        this.view = "api-error";
      }
    },
    setNotification: function setNotification(res) {
      // If it includes lead it means the lead already exists. Don't show a notification.
      if (!res.found_existing || !res.found_existing.includes("lead")) {
        this.$store.commit("SET_NOTIFICATION", {
          title: this.$t("models.project_lead.created"),
          type: "success"
        });
      }
      if (res.found_existing && res.found_existing.length > 0) {
        if (res.found_existing.includes("name")) {
          this.$store.commit("SET_NOTIFICATION", {
            title: "models.project_lead.predicted_name",
            type: "info"
          });
        } else {
          this.$store.commit("SET_NOTIFICATION", {
            title: "models.project_lead.found_existing",
            type: "info"
          });
        }
      }
    },
    capitalize: function capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    resolveApiError: function resolveApiError(isCta, choice) {
      if (!isCta) {
        this.updateLead({
          company: choice.name
        });
      } else {
        this.updateLead({
          overwrite_conflict: true
        });
      }
      this.confirmEmail();
    },
    confirmEmail: function confirmEmail() {
      this.loading = true;
      this.$store.commit("UPDATE_CURRENT_LEAD", {
        email: this.email,
        project_id: this.id
      });
      this.createFromEmail();
    },
    updateLead: function updateLead(params) {
      this.$store.commit("UPDATE_CURRENT_LEAD", params);
    },
    closePopupAndContinue: function closePopupAndContinue(item) {
      var params = { lead_id: item.id, project_id: this.id };
      this.$store.commit("SET_EMPTY_STATE", null);
      this.$emit("close");
      this.$router.push({ name: "project_lead_edit", params: params });
    }
  }
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Tracking__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrackingTable__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrackingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TrackingTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_TrackingChart__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_TrackingChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_TrackingChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_RelativeDateChoser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_RelativeDateChoser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_RelativeDateChoser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Lead_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_Project_js__ = __webpack_require__(19);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: { TrackingTable: __WEBPACK_IMPORTED_MODULE_3__TrackingTable___default.a, TrackingChart: __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_TrackingChart___default.a, RelativeDateChoser: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_RelativeDateChoser___default.a },
  data: function data() {
    return {
      trackings: [],
      tracking_api: new __WEBPACK_IMPORTED_MODULE_2__api_Tracking__["a" /* default */](),
      start_date: Object,
      end_date: Object,
      trackingsSorted: [],
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
      api: new __WEBPACK_IMPORTED_MODULE_7__api_Lead_js__["a" /* default */]()
    };
  },
  mounted: function mounted() {
    this.newDate(1);
    this.validateLeadPresent();
    this.validateProjectPresent();
  },

  computed: {
    lead_id: function lead_id() {
      return this.$route.params.lead_id;
    }
  },
  methods: {
    validateLeadPresent: function validateLeadPresent() {
      if (typeof this.$store.state.page_title == 'undefined' || this.$store.state.page_title == '') {
        // re-set level when statistics are reached outside edit (then, level was 2)
        __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setPageLevel(3);
        this.retrieve_lead();
      }
    },
    validateProjectPresent: function validateProjectPresent() {
      if (typeof this.$store.state.parent_page_title.name == 'undefined' || this.$store.state.parent_page_title.name == '') {
        this.retrieve_project();
      }
    },

    // lead retriving
    retrieve_lead: function retrieve_lead() {
      this.api['show'](this.lead_id).then(function (item) {
        __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setTitleName(item);
      }).catch(function (error) {
        console.log(error);
      });
    },
    retrieve_project: function retrieve_project() {
      var project_api = new __WEBPACK_IMPORTED_MODULE_8__api_Project_js__["a" /* default */]();
      project_api.show(this.id).then(function (item) {
        __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setSubtitle({ link: { name: "project_show", params: { id: item.id } }, name: item.name });
      }).catch(function (error) {
        console.log(error);
      });
    },
    newDate: function newDate(date) {
      this.start_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(date, 'days');
      this.end_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
      this.trackings = [];
      this.trackingsSorted = [];
      console.log("init");
      this.retrieve();
    },
    retrieve: function retrieve() {
      var _this = this;

      var params = {
        start_date: this.start_date,
        end_date: this.end_date,
        sort_by: 'time',
        sort_order: 'DESC'
      };
      this.tracking_api.all(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ lead_id: this.lead_id }, params)).then(function (items) {
        _this.trackings = items.resources;
        _this.initTrackings();
      }).catch(function (error) {});
    },
    initTrackings: function initTrackings() {
      var _this2 = this;

      // sort trackings
      this.trackings.sort(function (a, b) {
        var dateA = new Date(a.time);
        var dateB = new Date(b.time);
        if (dateA < dateB) return 1;else if (dateA > dateB) return -1;else return 0;
      });

      var currentTrackings = [];
      this.trackingsSorted = [];

      this.trackings.forEach(function (tracking, index) {
        if (index == 0) {
          currentTrackings.push(tracking);
          return;
        }
        var currentDate = new Date(tracking.time);
        var lastDate = new Date(_this2.trackings[index - 1].time);

        if (_this2.sameDay(currentDate, lastDate)) {
          currentTrackings.push(tracking);
        } else {
          _this2.trackingsSorted.push(currentTrackings);
          currentTrackings = [tracking];
        }
      });
      this.trackingsSorted.push(currentTrackings);
    },
    sameDay: function sameDay(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    }
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Tracking__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrackingTable__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrackingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TrackingTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_TrackingChart__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_TrackingChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_TrackingChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_RelativeDateChoser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_RelativeDateChoser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_RelativeDateChoser__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['leadId'],
  components: { TrackingTable: __WEBPACK_IMPORTED_MODULE_3__TrackingTable___default.a, TrackingChart: __WEBPACK_IMPORTED_MODULE_4__components_helpers_Specific_TrackingChart___default.a, RelativeDateChoser: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_RelativeDateChoser___default.a },
  data: function data() {
    return {
      trackings: [],
      tracking_api: new __WEBPACK_IMPORTED_MODULE_2__api_Tracking__["a" /* default */](),
      start_date: Object,
      end_date: Object,
      trackingsSorted: [],
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a
    };
  },
  mounted: function mounted() {
    this.newDate(1);
  },

  methods: {
    newDate: function newDate(date) {
      this.start_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(date, 'days');
      this.end_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
      this.trackings = [];
      this.trackingsSorted = [];
      this.retrieve();
    },
    retrieve: function retrieve() {
      var _this = this;

      var params = {
        start_date: this.start_date,
        end_date: this.end_date,
        sort_by: 'time',
        sort_order: 'DESC'
      };
      this.tracking_api.all(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ lead_id: this.leadId }, params)).then(function (items) {
        _this.trackings = items.resources;
        _this.initTrackings();
      });
    },
    initTrackings: function initTrackings() {
      var _this2 = this;

      // sort trackings
      this.trackings.sort(function (a, b) {
        var dateA = new Date(a.time);
        var dateB = new Date(b.time);
        if (dateA < dateB) return 1;else if (dateA > dateB) return -1;else return 0;
      });

      var currentTrackings = [];
      this.trackingsSorted = [];

      this.trackings.forEach(function (tracking, index) {
        if (index == 0) {
          currentTrackings.push(tracking);
          return;
        }
        var currentDate = new Date(tracking.time);
        var lastDate = new Date(_this2.trackings[index - 1].time);

        if (_this2.sameDay(currentDate, lastDate)) {
          currentTrackings.push(tracking);
        } else {
          _this2.trackingsSorted.push(currentTrackings);
          currentTrackings = [tracking];
        }
      });
      this.trackingsSorted.push(currentTrackings);
    },
    sameDay: function sameDay(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    }
  }
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_project_leads_LeadMaskElement__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_project_leads_LeadMaskElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pages_project_leads_LeadMaskElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_Mask__ = __webpack_require__(180);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { LeadMaskElement: __WEBPACK_IMPORTED_MODULE_0__components_pages_project_leads_LeadMaskElement___default.a },
  props: ['item', 'elements', 'errors', 'language'],
  methods: {
    autofill: function autofill(autofillItem) {
      this.$emit('autofill-lead', autofillItem);
    },

    // see: LeadUpdate#change for reasoning
    change: function change(object, label, name) {
      this.$emit('change', object, label, name);
    },
    populateFields: function populateFields(companyFields) {
      this.$emit('populate-fields', companyFields);
    },
    getItemGrid: function getItemGrid(item) {

      if (item.class) {
        return item.class;
      } else {
        return "col-12";
      }
    }
  }
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_project_leads_LeadMaskElement__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_project_leads_LeadMaskElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pages_project_leads_LeadMaskElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_CountrySelect__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_CountrySelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_CountrySelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_TagList__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_TagList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_TagList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_QuantitySelection__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_QuantitySelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_QuantitySelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataDisplay_CrawledInfos__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataDisplay_CrawledInfos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_DataDisplay_CrawledInfos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_FreeDrawing__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_FreeDrawing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_FreeDrawing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_AutoComplete__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_AutoComplete__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

window.EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { LeadMaskElement: __WEBPACK_IMPORTED_MODULE_1__components_pages_project_leads_LeadMaskElement___default.a, AutoComplete: __WEBPACK_IMPORTED_MODULE_9__components_helpers_DataDisplay_AutoComplete___default.a, FreeDrawing: __WEBPACK_IMPORTED_MODULE_8__components_helpers_DataInput_FreeDrawing___default.a, QuantitySelection: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataInput_QuantitySelection___default.a, CountrySelect: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_CountrySelect___default.a, TagList: __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_TagList___default.a, Field: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field___default.a, CrawledInfos: __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataDisplay_CrawledInfos___default.a, Datepicker: __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker__["a" /* default */] },
  name: "lead-mask-element",
  props: {
    name: String,
    language: String,
    item: Object,
    type: String,
    element: Object,
    errors: Array,
    params: String,
    value: String
  },
  data: function data() {
    return {
      elem_class: "",
      elem_type: "",
      newValue: "",
      placeholder: "",
      label: "",
      search: '',
      results: [],
      isOpen: true,
      required: false,
      items: []
    };
  },

  methods: {
    findValue: function findValue() {
      return eval('this.item.' + name);
    },
    populateFields: function populateFields(companyFields) {
      this.$emit('populate-fields', companyFields);
    },
    change: function change(object, label, name) {
      EventBus.$emit('change', object, label, name);
    },
    updateName: function updateName(result) {
      this.$set(this.item, 'company', result.name);
    },
    hiddenElement: function hiddenElement() {
      if (this.element.hidden) {
        return "hidden";
      }
    }
  },
  mounted: function mounted() {
    if (this.element.class) {
      this.elem_class = this.element.class;
    }
    this.elem_type = this.type;
    this.newValue = this.value;

    if (this.element.required) {
      this.required = this.element.required;
    }
    if (this.element.placeholder) {
      this.placeholder = this.element.placeholder;
    }
    if (this.element.label) {
      this.label = this.element.label;
    }

    if (this.groupType == "container") {
      switch (this.type) {
        case "container_tab":
          this.elem_class += "tab";
          break;
        case "container_grid":
          this.elem_class += " grid";
          break;
        case "container_top":
          this.elem_class += " form-part";
          break;
        case "container_bottom":
          this.elem_class += " bottom-zone";
          break;
        case "container":
          this.elem_class += " container";
          break;
      }
    } else {
      if (this.type == "checkbox_custom" || this.type == "radio_custom" || this.element.show_as_buttons) {
        this.elem_type = this.type.replace('_custom', '');
        this.elem_class += " is-buttonned";
      }
      if (this.elem_type == "checkbox") {
        this.newValue = new Array();
      }
      if (this.elem_type == "date") {
        this.newValue = new Date();
        this.elem_class += " input--datepicker";
      }
    }
    EventBus.$on('input', this.handleAutoComplete);

    // This is to stop the browsers native autocomplete overlaying our own autocomplete component
    this.$nextTick(function () {
      var isFirefox = typeof InstallTrigger !== 'undefined';

      // check for existance
      if (document.querySelector("#name")) {
        if (!isFirefox) {
          document.querySelector("#name").setAttribute('autocomplete', 'usedforstoppingAC');
        } else {
          document.querySelector("#name").setAttribute('autocomplete', 'off');
        }
      }
    });
  },

  computed: {
    groupType: function groupType() {
      if (this.type.includes('container')) {
        return "container";
      } else if (this.type == "country_select") {
        return "country_select";
      } else if (this.type == "quantity_selection") {
        return "quantity_selection";
      } else if (this.type == "tag_list") {
        return "tag_list";
      } else if (this.type == "crawled_info") {
        return "crawled_info";
      } else if (this.type == "readonly") {
        return "readonly";
      } else if (this.type == 'title') {
        return "title";
      } else if (this.type == 'drawing') {
        return "free_drawing";
      } else if (this.type == 'paragraph') {
        return "paragraph";
      } else if (this.type == 'date') {
        return "date";
      } else {
        return "field";
      }
    },
    isBlank: function isBlank() {
      return this.value == '';
    },
    containerClass: function containerClass() {
      if (this.groupType == "container") {
        switch (this.type) {
          case "container_tab":
            return this.class + "tab";
            break;
          case "container_grid":
            return this.class + " grid";
            break;
          case "container_top":
            return this.class + " form-part";
            break;
          case "container_bottom":
            return this.class + " bottom-zone";
            break;
        }
      } else {
        return "";
      }
    }
  },
  watch: {
    value: function value(val) {
      if (val !== this.newValue) {
        this.newValue = val;
      }
    },
    newValue: function newValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_Lead_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_Lead__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_User_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_BusinessKit__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_layouts_partials_Tabs__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_layouts_partials_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_layouts_partials_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LeadMask__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LeadMask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__LeadMask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__LeadUpdateMonitor__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__LeadUpdateMonitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__LeadUpdateMonitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LeadUpdateBusinessKit__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LeadUpdateBusinessKit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__LeadUpdateBusinessKit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeadUpdateStatistics__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeadUpdateStatistics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__LeadUpdateStatistics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_helpers_DataInput_CountrySelect__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_helpers_DataInput_CountrySelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_helpers_DataInput_CountrySelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__classes_Mask__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__classes_GetUrlQueries__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_project_leads_LeadMaskElement__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_project_leads_LeadMaskElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_pages_project_leads_LeadMaskElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_project_leads_LeadCreate__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_project_leads_LeadCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_pages_project_leads_LeadCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_project_leads_BusinessCardPopup__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_project_leads_BusinessCardPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_pages_project_leads_BusinessCardPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_helpers_Layout_PageSaver__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_helpers_Layout_PageSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_helpers_Layout_PageSaver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_deep_object_diff__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_deep_object_diff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_deep_object_diff__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























// This is an improved version of package "deep-object-diff" to find the differences 
// between to objects which we need to calculate the changes made to a project
var deepCompare = function deepCompare(obj1, obj2) {
  var occurences = 0;

  var diff = function diff(obj1, obj2) {
    var key = void 0;

    var arraysMatch = function arraysMatch(arr1, arr2) {
      if (arr1.hasOwnProperty('sort') && arr2.hasOwnProperty('sort')) {
        arr1 = arr1.sort();
        arr2 = arr2.sort();
      }

      for (var i = 0; i < arr1.length; i++) {
        var type1 = Object.prototype.toString.call(arr1);
        var type2 = Object.prototype.toString.call(arr2);

        if (type2 === "[object Undefined]") {
          occurences++;
        } else if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(arr1[i]) === 'object') {
          occurences += deepCompare(arr1[i], arr2[i]);
        } else if (Array.isArray(arr1[i])) {
          arraysMatch(arr1[i], arr2[i]);
        } else {
          if (arr2.indexOf(arr1[i]) === -1) {
            occurences++;
          }
        }
      }

      for (var _i = 0; _i < arr2.length; _i++) {
        var _type = Object.prototype.toString.call(arr1);
        var _type2 = Object.prototype.toString.call(arr2);

        if (_type2 === "[object Undefined]") {
          occurences++;
        } else if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(arr2[_i]) === 'object') {
          occurences += deepCompare(arr1[_i], arr2[_i]);
        } else if (Array.isArray(arr2[_i])) {
          arraysMatch(arr1[_i], arr2[_i]);
        } else {
          if (arr1.indexOf(arr2[_i]) === -1) {
            occurences++;
          }
        }
      }
    };

    var compare = function compare(item1, item2, key) {
      // Get the object type
      var type1 = Object.prototype.toString.call(item1);
      var type2 = Object.prototype.toString.call(item2);

      // If type2 is undefined it has been removed
      if (type2 === "[object Undefined]") {
        occurences++;

        return;
      }

      // If an object, compare recursively
      if (type1 === "[object Object]") {
        occurences += deepCompare(item1, item2);

        return;
      }

      // If an array, compare
      if (Array.isArray(item1)) {
        arraysMatch(item1, item2);

        return;
      }

      if (item1 !== item2) {
        occurences++;
      }
    };

    // Loop through the first object
    for (key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        compare(obj1[key], obj2[key], key);
      }
    }
  };

  diff(obj1, obj2);

  return occurences;
};

var WEB_APP_ORIGIN = "web_app";

var tabs = [{ name: "personnal", "is-fullfilled": true }, { name: "company" }, { name: "qualify" }, { name: "kits" }];

var onLeaving = function onLeaving(e) {
  var e = e || window.event;
  if (e) {
    e.returnValue = "";
  }
  return "";
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tabs: __WEBPACK_IMPORTED_MODULE_13__components_layouts_partials_Tabs___default.a,
    PageSaver: __WEBPACK_IMPORTED_MODULE_27__components_helpers_Layout_PageSaver___default.a,
    LeadUpdateMonitor: __WEBPACK_IMPORTED_MODULE_15__LeadUpdateMonitor___default.a,
    BusinessCardPopup: __WEBPACK_IMPORTED_MODULE_26__components_pages_project_leads_BusinessCardPopup___default.a,
    Field: __WEBPACK_IMPORTED_MODULE_18__components_helpers_DataInput_Field___default.a,
    CountrySelect: __WEBPACK_IMPORTED_MODULE_19__components_helpers_DataInput_CountrySelect___default.a,
    LeadUpdateBusinessKit: __WEBPACK_IMPORTED_MODULE_16__LeadUpdateBusinessKit___default.a,
    LeadUpdateStatistics: __WEBPACK_IMPORTED_MODULE_17__LeadUpdateStatistics___default.a,
    LeadMask: __WEBPACK_IMPORTED_MODULE_14__LeadMask___default.a,
    LeadCreate: __WEBPACK_IMPORTED_MODULE_25__components_pages_project_leads_LeadCreate___default.a
  },
  data: function data() {
    return {
      item: {},
      type: "update",
      errors: [],
      model: "project_leads",
      elements: [],
      level: 3,
      api: new __WEBPACK_IMPORTED_MODULE_8__api_Lead_js__["a" /* default */](),
      progress: 0,
      next_lead_id: "",
      previous_lead_id: "",
      item_saved: {},
      structure: {},
      language: "",
      users: [],
      fields: [],
      retrieve_method: "show",
      popup_business_card_open: false,
      businesskit_id: null,
      leadReviewEnabled: null,
      showUpdateMonitor: false
    };
  },

  watch: {
    item: {
      handler: function handler() {
        this.isSaved();
      },

      deep: true
    }
  },
  props: ["id", "lead_id", "is_existing"],
  computed: {
    activeTab: function activeTab() {
      return this.$store.state.active_tab;
    },
    title: function title() {
      return "ui.pages.lead-edit";
    },
    savedAt: function savedAt() {
      global.moment = moment;
      var date = moment(this.item.updated_at).fromNow();
      var str = "";
      str += this.$t("models.project_lead.message.changes_saved");
      str += " ";
      if (this.isSaved()) {
        str += date;
      } else {
        str += moment(new Date()).fromNow();
      }
      return str;
    },
    singular_model: function singular_model() {
      return this.model.slice(0, -1);
    },
    redirection: function redirection() {
      return this.model;
    }
  },
  mounted: function mounted() {
    var _this = this;

    // retrieve the lead
    this.retrieve(this.lead_id);

    this.init();
    this.item.project_id = this.id;
    if (!this.item.start_date) {
      this.item.start_date = this.item.created_at;
    }

    if (this.is_existing == true) {
      this.$store.commit("SET_NOTIFICATION", {
        title: "models.project_lead.message.leads_exists",
        type: "info"
      });
    }

    __WEBPACK_IMPORTED_MODULE_7__EventBus_js__["a" /* EventBus */].$on("action", this.handleAction);

    // set project settins
    var project_api = new __WEBPACK_IMPORTED_MODULE_10__api_Project_js__["a" /* default */]();
    project_api.show(this.id).then(function (item) {
      __WEBPACK_IMPORTED_MODULE_20__classes_Ui__["a" /* default */].setSubtitle({
        link: { name: "project_show", params: { id: item.id } },
        name: item.name
      });
      _this.leadReviewEnabled = item.enable_lead_review;
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_20__classes_Ui__["a" /* default */].setSubtitle({});
    });

    project_api.lead_mask(this.id).then(function (item) {
      _this.structure = item.structure;
      _this.language = item.language;
      _this.elements = __WEBPACK_IMPORTED_MODULE_22__classes_Mask__["a" /* default */].buildStructure(item.structure);
      _this.elements.push({
        name: "kits_tab",
        shouldNotChangeRoute: true,
        title: _this.$t("ui.tabs.kits_tab")
      });
      _this.elements.push({
        name: "stats_tab",
        shouldNotChangeRoute: true,
        title: _this.$t("ui.tabs.stats_tab")
      });
      _this.fields = __WEBPACK_IMPORTED_MODULE_22__classes_Mask__["a" /* default */].listFields(item.structure);
      _this.fields.push("tags");
      _this.$store.commit("SET_TABS", _this.elements);
      _this.$store.commit("SET_ACTIVE_TAB", _this.elements[0].name);
      __WEBPACK_IMPORTED_MODULE_20__classes_Ui__["a" /* default */].setSecondaryHeaderTabs(_this.elements);
    }).catch(function (error) {
      console.log(error);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit("EMPTY_TABS");
    this.$store.commit("EMPTY_NOTIFICATION");
    this.$store.commit("SET_SECONDARY_HEADER_TABS", []);
    window.removeEventListener("onbeforeunload", function () {});
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!this.isSaved()) {
      var str = this.$t("ui.global.lead_edit_abort");
      var answer = window.confirm(str);
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },

  methods: {
    init: function init() {
      this.item = {};
      var permissions = __WEBPACK_IMPORTED_MODULE_21__classes_Permission__["a" /* default */].loadPermissions();
      if (__WEBPACK_IMPORTED_MODULE_21__classes_Permission__["a" /* default */].can(permissions, this.model + "." + this.type)) {
        __WEBPACK_IMPORTED_MODULE_20__classes_Ui__["a" /* default */].setPageLevel(this.level);
        __WEBPACK_IMPORTED_MODULE_20__classes_Ui__["a" /* default */].startLoading();
        this.retrieveAssignedUsers();
      } else {
        this.$store.commit("ADD_ERROR", {
          type: "warning",
          message: "errors.unauthorized"
        });
        this.$router.push({ name: "unauthorized" });
      }
    },
    triggerPopup: function triggerPopup() {
      this.popup_business_card_open = !this.popup_business_card_open;
    },
    allowPdfDownload: function allowPdfDownload() {
      var plan = this.$store.getters.getCurrentOrganizationPlan;
      if (plan && plan.rules["allowed_lead_pdf_download"]) {
        return plan.rules["allowed_lead_pdf_download"];
      }
      return false;
    },

    // We set the BKId with the id and we save the new id in case it does not exist
    setBusinessKitId: function setBusinessKitId(id) {
      this.businesskit_id = id;
    },
    retrieveAssignedUsers: function retrieveAssignedUsers() {
      var _this2 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_11__api_User_js__["a" /* default */]();
      api.all_for_association("email", { project_id: this.id }).then(function (items) {
        _this2.users = items;
      }).catch(function (error) {
        console.log(error);
      });
    },
    sendBusinesskit: function sendBusinesskit(callback) {
      var _this3 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_12__api_BusinessKit__["a" /* default */]();

      this.save().then(function (item) {
        api.send(_this3.businesskit_id, _this3.lead_id).then(function (item) {
          setTimeout(function () {
            callback("message-success", "models.business_kit.sent");
          }, 500);
        }).catch(function (e) {
          callback("message-error", e.response.data.errors[0].code);
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    setNotification: function setNotification(res) {
      if (res.found_existing && res.found_existing.length > 0) {
        if (res.found_existing.includes("name")) {
          this.$store.commit("SET_NOTIFICATION", {
            title: "models.project_lead.predicted_name",
            type: "info"
          });
        }
        if (res.found_existing.includes("company_contact") || res.found_existing.includes("company")) {
          this.$store.commit("SET_NOTIFICATION", {
            title: "models.project_lead.found_existing",
            type: "info"
          });
        }
      }
    },
    undoChangesDeep: function undoChangesDeep(item, difference) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(item).forEach(function (key) {
        var value = item[key];
        if ((typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(value)) === "object" && value !== null) {
          item[key] = _this4.undoChangesDeep(value, difference);
        } else {
          if (key in difference) {
            item[key] = null;
            return item;
          }
        }
      });
    },
    cancel: function cancel() {
      var difference = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28_deep_object_diff__["diff"])(this.item, this.item_saved);

      this.undoChangesDeep(this.item, difference);
      this.item = _.cloneDeep(this.item_saved);
    },
    submit: function submit() {
      var _this5 = this;

      this.save().then(function (result) {
        _this5.$store.commit("SET_NOTIFICATION", {
          title: "models.project_lead.message.update",
          type: "success"
        });
      }).catch(function (error) {
        _this5.$store.commit("SET_NOTIFICATION", {
          title: "errors." + error.response.data.errors[0].code,
          type: "error"
        });
      });
    },
    saveIfNeeded: function saveIfNeeded() {
      if (!this.isSaved()) {
        this.save();
      }
    },
    save: function save() {
      var _this6 = this;

      var fields = this.fields.map(function (field) {
        return field.name;
      });
      var post_item = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.item).filter(function (key) {
        return fields.includes(key);
      }).reduce(function (obj, key) {
        obj[key] = _this6.item[key];
        return obj;
      }, {});

      post_item["project_id"] = this.id;
      post_item["tags"] = this.item.tags;
      post_item["id"] = this.item.id;
      post_item["classification"] = this.item.classification;
      post_item["status"] = this.item.status;
      post_item["user_id"] = this.item.user_id;
      post_item["start_date"] = this.item.start_date;
      post_item["sync_disabled"] = this.item.sync_disabled;
      post_item["opt_in_businesskit"] = this.item.opt_in_businesskit;
      post_item["origin"] = WEB_APP_ORIGIN;
      if (post_item["id"]) {
        return this.postItemPromise(post_item);
      }
    },
    postItemPromise: function postItemPromise(post_item) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.api.post(post_item).then(function (item) {
          _this7.handleRetrievedLead(item);
          _this7.errors = [];
          _this7.$router.push({
            name: "project_lead_edit",
            params: { project_id: _this7.id, lead_id: item.id }
          });
          resolve(item);
        }).catch(function (e) {
          _this7.errors = e.response.data.errors;
          _this7.$store.commit("PREV_TAB");
          reject(e);
        });
      });
    },
    handleAction: function handleAction(action) {
      var _this8 = this;

      if (action == "project_leads.download_pdf") {
        var api = new __WEBPACK_IMPORTED_MODULE_9__api_Lead__["a" /* default */]();
        api.download_pdf(this.item.id).then(function (item) {
          _this8.download_message = _this8.$t("ui.pages.lead-download-pdf-succeed");

          if (item["resource"]["pdf_download_path"]) {
            _this8.$store.commit("SET_NOTIFICATION", {
              title: "ui.pages.lead-download-pdf-succeed",
              type: "success"
            });
            // trigger pdf in new window
            window.open(item["resource"]["pdf_download_path"], "_blank");
          } else {
            _this8.$store.commit("SET_NOTIFICATION", {
              title: "ui.pages.lead-download-pdf-error",
              type: "error"
            });
          }
        }).catch(function (error) {});
      }
    },

    // When some item value key/s is/are object/s we need to deep-clone each key/s with their value to be able to track them (vue.js can't deep-watch changes)
    deepCloner: function deepCloner(item) {
      var clone = {};
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(item).forEach(function (key) {
        var value = item[key];
        if (Object.prototype.toString.call(value) === "[object Object]") {
          clone[key] = {};
          __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(value).forEach(function (second_key) {
            var second_value = value[second_key];
            clone[key][second_key] = second_value;
          });
        } else if (Object.prototype.toString.call(value) === "[object Array]") {
          clone[key] = [];
          value.forEach(function (arr_val) {
            clone[key].push(arr_val);
          });
        } else {
          clone[key] = value;
        }
      });
      return clone;
    },
    isSaved: function isSaved() {
      var diffLength = this.saveDiff();
      if (diffLength < 1) {
        window.removeEventListener("onbeforeunload", onLeaving);
        window.onbeforeunload = null;
        return true;
      } else {
        window.addEventListener("onbeforeunload", onLeaving);
        window.onbeforeunload = onLeaving;
        return false;
      }
    },
    saveDiff: function saveDiff() {
      if (!("opt_in_businesskit" in this.item_saved)) {
        this.$set(this.item_saved, "opt_in_businesskit", false);
      }
      if (!("opt_in_businesskit" in this.item)) {
        this.$set(this.item, "opt_in_businesskit", false);
      }
      var diff = this.difference(this.item_saved, this.item);

      return diff;
    },

    // lead retriving
    retrieve: function retrieve(id) {
      var _this9 = this;

      this.api[this.retrieve_method](this.lead_id).then(function (item) {
        _this9.handleRetrievedLead(item);

        // setting the UI Buttons here so we get access to the next and preivous lead id
        __WEBPACK_IMPORTED_MODULE_20__classes_Ui__["a" /* default */].setHeaderButtons([{
          name: "download_pdf",
          action: "project_leads.download_pdf",
          classes: "btn-tertiary",
          icon: "import",
          show: _this9.allowPdfDownload()
        }, {
          name: "previous_lead",
          action: "link",
          classes: "btn-tertiary",
          icon: "arrow_left",
          href: _this9.getPreviousLeadUrl(item.previous_lead_id),
          show: _this9.showPreviousLeadButton(item.previous_lead_id)
        }, {
          name: "next_lead",
          action: "link",
          classes: "btn-tertiary",
          icon: "arrow_right",
          href: _this9.getNextLeadUrl(item.next_lead_id),
          show: _this9.showNextLeadButton(item.next_lead_id)
        }, {
          name: "project_lead",
          action: "project_leads.add_popup",
          classes: "btn-primary",
          icon: ""
        }]);

        __WEBPACK_IMPORTED_MODULE_20__classes_Ui__["a" /* default */].setTitleName(_this9.item);
        __WEBPACK_IMPORTED_MODULE_20__classes_Ui__["a" /* default */].finishLoading();
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleRetrievedLead: function handleRetrievedLead(item) {
      // Insert custom Lead Mask attributes into Lead and insert into datastore
      item = this.insertCustomLeadMaskAttributes(item);
      item = this.sanitizeValues(item);
      this.item = item;
      this.item_saved = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item));

      // retrieve and remember next and previous lead_id
      this.next_lead_id = this.item.next_lead_id;
      this.previous_lead_id = this.item.previous_lead_id;

      // Check wrong email domain
      if (typeof this.item.has_valid_email != "undefined") {
        this.setWrongEmailDomain();
      }
      this.setNotification(item);
      this.setLeadMaskProgress();
    },
    sanitizeValues: function sanitizeValues(item) {
      // We had empty string values from backend, we want to convert these values to null, otherwise  when we just access a lead it can show unsaved changes without editing.
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(item).forEach(function (key) {
        var value = item[key];
        if (value === undefined || value === "") {
          item[key] = null;
        }
      });
      return item;
    },
    setLeadMaskProgress: function setLeadMaskProgress() {
      // Calculate attribute progress for Lead Mask
      this.progress = parseFloat(this.item.progress_indicator_lead_mask) * 100;
    },

    // Will initialisate data
    // with default values and all
    insertCustomLeadMaskAttributes: function insertCustomLeadMaskAttributes(item) {
      // init an empty array for checkbox
      for (var key in this.structure) {
        var field = this.structure[key];

        if (item[key] == undefined && field.element_type.includes("checkbox")) {
          item[key] = new Array();
        } else if (field.element_type.includes("quantity_selection")) {
          if (item[key] == undefined) {
            item[key] = new Object();
          }
          field.allowed_values.forEach(function (allowed_value) {
            if (!item[key][allowed_value.value]) {
              // When there is no value we initialize it with "0" instead 'null'. Then we can track changes well (including 0 when there is no value).
              // * All values in quantity selection type, are defined as '0' to 'x' numbers.
              item[key][allowed_value.value] = "0";
            }
          });
        }
        if (field["default_value"] && !item[key]) {
          item[key] = field["default_value"];
        }
        if (field.standard_field !== undefined && !(field.name in item)) {
          item[field.name] = null;
        }
        // When for other reasons, the key is not defined in the item, then we still can initialize it.
        if (item[key] == undefined) {
          item[field.name] = null;
        }
      }
      return item;
    },
    setWrongEmailDomain: function setWrongEmailDomain() {
      if (!this.item.has_valid_email) {
        this.errors.push({
          code: "lead.email.invalid_domain",
          field_name: "email"
        });
      }
    },

    //  We emit the change in (object, label, name) to include and track changes form botton to top (QuantitySelection < LeadMaskElement < LeadMask < LeadUpdate)
    change: function change(object, label, name) {
      var value = this.item[label];
      this.$set(this.item, label, {});
      value[name] = object[name];
      this.item[label] = value;

      this.$forceUpdate();
    },
    populateFields: function populateFields(companyFields) {
      var deepFields = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(companyFields));
      this.item = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.item, deepFields);
      this.saveDiff();
    },
    nestedUpdate: function nestedUpdate(name, value) {
      if (!(name in this.item_saved)) {
        this.$set(this.item_saved, name, undefined);
      }
      this.item[name] = value;
    },
    flattenObject: function flattenObject(ob) {
      var flattenedOb = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(function _flatten(o) {
        var _ref;

        return (_ref = []).concat.apply(_ref, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(o).map(function (k) {
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(o[k]) === "object" && o[k] !== null ? _flatten(o[k]) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, k, o[k]);
        })));
      }(ob))));
      return flattenedOb;
    },

    // Deep comparaison between objects
    difference: function difference(object, base) {
      var o = deepCompare(_.cloneDeep(base), _.cloneDeep(object));

      return o;
    },
    getPreviousLeadUrl: function getPreviousLeadUrl(previous_lead_id) {
      var url_queries = __WEBPACK_IMPORTED_MODULE_23__classes_GetUrlQueries__["a" /* default */].urlQueries(this.$route.query);
      return "/" + this.$t("routes.project") + "/" + this.item.project_id + "/" + this.$t("routes.project_leads") + "/" + previous_lead_id + "/edit" + url_queries;
    },
    getNextLeadUrl: function getNextLeadUrl(next_lead_id) {
      var url_queries = __WEBPACK_IMPORTED_MODULE_23__classes_GetUrlQueries__["a" /* default */].urlQueries(this.$route.query);
      return "/" + this.$t("routes.project") + "/" + this.item.project_id + "/" + this.$t("routes.project_leads") + "/" + next_lead_id + "/edit" + url_queries;
    },
    showPreviousLeadButton: function showPreviousLeadButton(previous_lead_id) {
      if (previous_lead_id) {
        return true;
      }
      return false;
    },
    showNextLeadButton: function showNextLeadButton(next_lead_id) {
      if (next_lead_id) {
        return true;
      }
      return false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(39)))

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_empty_business_card_svg__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_empty_business_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_empty_business_card_svg__);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return { image: __WEBPACK_IMPORTED_MODULE_0__assets_empty_business_card_svg___default.a };
  },

  props: ['lead'],
  methods: {
    openBusinessCard: function openBusinessCard() {
      this.$emit('openBusinessCard');
    }
  }
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_BusinessKit__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Lead__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_TagList__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_TagList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_TagList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_Permission__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    project_id: {
      type: [String, Number],
      required: true
    },
    id: {
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    business_kit_id: {
      required: true
    }
  },
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default.a,
    TagList: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_TagList___default.a
  },
  data: function data() {
    return {
      items: [],
      authorization: false,
      loading: false,
      messageType: '',
      messageContent: '',
      businesskit_history: [],
      selected_businesskit_url: "",
      redirect_url: undefined,
      errors: [],
      moment: moment
    };
  },

  computed: {
    allowedStatistics: function allowedStatistics() {
      return __WEBPACK_IMPORTED_MODULE_4__classes_Permission__["a" /* default */].planCan('allowed_statistics');
    }
  },
  created: function created() {
    this.retrieve();
  },
  mounted: function mounted() {
    this.authorization = this.item.opt_in_businesskit;
  },

  methods: {
    tagUpdate: function tagUpdate(content) {
      this.$emit("input", "tags", content);
    },
    send_businesskit: function send_businesskit() {
      var _this = this;

      if (this.authorization == true) {
        var callback = function callback(messageType, messageContent) {
          // Reset url
          _this.redirect_url = undefined;
          // If it's a missing template we want to link to where they can create it
          if (messageContent == 'models.business_kit.missing.email') {
            _this.redirect_url = 'https://businesskit.fanomena.io/events/' + _this.business_kit_id + '/schedules/new_email';
          }
          _this.messageContent = _this.$t(messageContent);
          _this.messageType = messageType;
          _this.loading = false;
        };
        this.loading = true;
        this.$emit("send_businesskit", callback);
      }
    },
    retrieve: function retrieve() {
      var _this2 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_0__api_BusinessKit__["a" /* default */]();
      api.all({ project_id: this.project_id }).then(function (result) {
        var items = [];
        result.resources.forEach(function (bk) {
          items.push({
            "name": bk.name,
            "value": bk.id,
            "url": bk.preview_url
          });
        });
        _this2.items = items;
        // We emit the specific item association
        if (items.length !== 0) {
          _this2.emitBusinessKitId(items[0].value);
        }
      });
      this.fetchBkStats();

      if (this.item.opt_in_businesskit) {
        this.authorization = this.item.opt_in_businesskit;
      }
    },
    fetchBkStats: function fetchBkStats() {
      var _this3 = this;

      if (this.allowedStatistics) {
        var lead_api = new __WEBPACK_IMPORTED_MODULE_2__api_Lead__["a" /* default */]();
        lead_api.statistics(this.id).then(function (item) {
          _this3.businesskit_history = item.businesskit_history;
        }).catch(function (error) {});
      }
    },
    emitBusinessKitId: function emitBusinessKitId(val) {
      this.$emit('bkIdChange', val);
    }
  },
  watch: {
    item: {
      deep: true,
      handler: function handler() {
        this.authorization = this.item.opt_in_businesskit;
      }
    },
    authorization: function authorization() {
      this.$emit("input", "opt_in_businesskit", this.authorization);
    },
    allowedStatistics: function allowedStatistics() {
      this.fetchBkStats();
    },

    // we are watching business kit id changes
    business_kit_id: function business_kit_id() {
      var _this4 = this;

      this.emitBusinessKitId(this.business_kit_id);
      this.items.forEach(function (item) {
        if (item.value == _this4.business_kit_id) {
          _this4.selected_businesskit_url = item.url;
        }
      });
    }
  }
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['lead', 'structure'],
  computed: {
    missingFieldsString: function missingFieldsString() {
      var _this = this;

      if (this.lead.missing_attributes_lead_mask) {
        var str = "";
        this.lead.missing_attributes_lead_mask.forEach(function (value) {
          var field = _this.structure[value];

          if (value[1] != null) {
            str += value[1] + ", ";
          } else {
            // fallback to i18n file if the label is not set in the lead mask
            str += _this.$t('models.project_lead.' + value[0]) + ", ";
          }
        });
        return str.slice(0, -2);
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_User__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeadUpdateBusinessCard__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeadUpdateBusinessCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LeadUpdateBusinessCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeadUpdateCrmStatus__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeadUpdateCrmStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LeadUpdateCrmStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Specific_UserImage__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Specific_UserImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_Specific_UserImage__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar___default.a,
    Field: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field___default.a,
    LeadUpdateBusinessCard: __WEBPACK_IMPORTED_MODULE_4__LeadUpdateBusinessCard___default.a,
    LeadUpdateCrmStatus: __WEBPACK_IMPORTED_MODULE_5__LeadUpdateCrmStatus___default.a,
    FormSwitch: __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch___default.a,
    UserImage: __WEBPACK_IMPORTED_MODULE_7__components_helpers_Specific_UserImage___default.a
  },
  props: {
    item: Object,
    type: String,
    progress: Number,
    errors: Array,
    structure: Object,
    leadReviewEnabled: Boolean
  },
  data: function data() {
    return {
      selectClass: "",
      popupVisible: false,
      showUpdateMonitor: false
    };
  },

  computed: {
    classificationCollection: function classificationCollection() {
      return [{
        name: this.$t("models.select_classification.hot"),
        value: "hot",
        color: "red"
      }, {
        name: this.$t("models.select_classification.warm"),
        value: "warm",
        color: "orange"
      }, {
        name: this.$t("models.select_classification.cold"),
        value: "cold",
        color: "blue"
      }];
    },
    statusCollection: function statusCollection() {
      var statusCollection = [{
        name: this.$t("models.select_status.review"),
        value: "review",
        color: "orange"
      }, {
        name: this.$t("models.select_status.active"),
        value: "active",
        color: "green"
      }];

      if (this.$store.getters.getCurrentUserIsRoot) {
        statusCollection.unshift({
          name: this.$t("models.select_status.pre_review"),
          value: "pre_review",
          color: "orange"
        });
      }

      return statusCollection;
    }
  },
  methods: {
    date: function date(value) {
      return moment(value).format("DD MMM YYYY");
    },
    inputClassification: function inputClassification(value) {
      if (!value) {
        value = "unclassified";
      }
      this.$emit("input", "classification", value);
    },
    inputStatus: function inputStatus(value) {
      this.$emit("input", "status", value);
    },
    inputUserId: function inputUserId(value) {
      this.$emit("input", "user_id", value);
    },
    inputStartDate: function inputStartDate(value) {
      this.$emit("input", "start_date", value);
    },
    inputCrmSync: function inputCrmSync(value) {
      this.$emit("input", "sync_disabled", value);
    },
    openBusinessCard: function openBusinessCard() {
      this.$emit("openBusinessCard");
    },
    userData: function userData() {
      if (this.item.user_email == "unknown") {
        return null;
      } else {
        if (this.item.user_firstname == "" && this.item.user_lastname == "" || !this.item.user_firstname && !this.item.user_lastname) {
          return this.item.user_email;
        } else {
          return this.item.user_firstname + " " + this.item.user_lastname;
        }
      }
    },
    userInitials: function userInitials() {
      if (this.item.user_email == "unknown") {
        return "?";
      } else {
        if (this.item.user_firstname == "" && this.item.user_lastname == "" || !this.item.user_firstname && !this.item.user_lastname) {
          return "?";
        } else {
          return "" + this.item.user_firstname.charAt(0) + this.item.user_lastname.charAt(0);
        }
      }
    },
    allowedLeadReview: function allowedLeadReview() {
      return this.$store.getters.getCurrentUserIsAdmin && this.leadReviewEnabled;
    },
    showCrmSyncSwitch: function showCrmSyncSwitch() {
      return this.$store.getters.getOrganizationConfig('crm_presence') || this.$store.getters.getOrganizationConfig('enable_crm_sync_switches');
    }
  }
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrackingTable__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrackingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TrackingTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_StatisticsOverview__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_StatisticsOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_StatisticsOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Gauge__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Gauge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Gauge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_RelativeDateChoser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_RelativeDateChoser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_RelativeDateChoser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Tracking__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_Lead__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Permission__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TrackingTable: __WEBPACK_IMPORTED_MODULE_1__TrackingTable___default.a, Gauge: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Gauge___default.a, Tracking: __WEBPACK_IMPORTED_MODULE_5__api_Tracking__["a" /* default */], StatisticsOverview: __WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_StatisticsOverview___default.a, RelativeDateChoser: __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataInput_RelativeDateChoser___default.a },
  props: ['leadId', 'projectId'],
  data: function data() {
    return {
      trackings: [],
      trackings_24h: [],
      tracking_api: new __WEBPACK_IMPORTED_MODULE_5__api_Tracking__["a" /* default */](),
      stats: [],
      lead_api: new __WEBPACK_IMPORTED_MODULE_6__api_Lead__["a" /* default */](),
      start_date: Object,
      end_date: Object
    };
  },

  computed: {
    allowedStatistics: function allowedStatistics() {
      return __WEBPACK_IMPORTED_MODULE_7__classes_Permission__["a" /* default */].planCan('allowed_statistics');
    }
  },
  mounted: function mounted() {
    this.newDate(7);
  },

  watch: {
    allowedStatistics: function allowedStatistics() {
      if (this.allowedStatistics) {
        this.retrieve();
      }
    }
  },
  methods: {
    newDate: function newDate(date) {
      this.end_date = moment();
      this.start_date = moment().subtract(date, 'days');
      if (this.allowedStatistics) {
        this.retrieve();
      }
    },
    retrieve: function retrieve() {
      var _this = this;

      var params = {
        start_date: this.start_date,
        end_date: this.end_date,
        sort_by: 'time',
        sort_order: 'DESC'
      };
      this.tracking_api.all(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ lead_id: this.leadId }, params)).then(function (items) {
        _this.trackings = items.resources;
      });
      this.lead_api.statistics(this.leadId, params).then(function (item) {
        _this.stats = item;
      });
    }
  }
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Lead__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_Collection__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProjectUserAssign__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProjectUserAssign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ProjectUserAssign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_project_leads_LeadCreate__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_project_leads_LeadCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_project_leads_LeadCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layouts_partials_Searchbar_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layouts_partials_Searchbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_layouts_partials_Searchbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_Specific_LeadsFiltering_vue__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_Specific_LeadsFiltering_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_helpers_Specific_LeadsFiltering_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_LeadsListing__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_LeadsListing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_LeadsListing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_helpers_DataDisplay_EmptyState__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_helpers_DataDisplay_EmptyState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_helpers_DataDisplay_EmptyState__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var default_sort_by = "start_date";
var default_sort_order = "DESC";
var default_filters = { sync_status: { value: [] }, origin: { value: [] }, import_origin: { value: [] }, sync_disabled: { value: [] }, start_date: { start: null, end: null, type: 'date' }, tags: { value: [], type: 'tag' } };

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ProjectUserAssign: __WEBPACK_IMPORTED_MODULE_5__ProjectUserAssign___default.a,
    LeadsFiltering: __WEBPACK_IMPORTED_MODULE_10__components_helpers_Specific_LeadsFiltering_vue___default.a,
    Searchbar: __WEBPACK_IMPORTED_MODULE_9__components_layouts_partials_Searchbar_vue___default.a,
    LeadCreate: __WEBPACK_IMPORTED_MODULE_8__components_pages_project_leads_LeadCreate___default.a,
    LeadsListing: __WEBPACK_IMPORTED_MODULE_11__components_helpers_Specific_LeadsListing___default.a,
    EmptyState: __WEBPACK_IMPORTED_MODULE_12__components_helpers_DataDisplay_EmptyState___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_Collection__["a" /* collectionMixin */]],
  props: {
    id: {
      required: true
    }
  },
  data: function data() {
    return {
      model: "project_leads",
      api: new __WEBPACK_IMPORTED_MODULE_2__api_Lead__["a" /* default */](),
      crmPresence: false,
      collectionData: {},
      level: 2,
      lead_mask: {},
      query: { project_id: this.id },
      download_message: '',
      loading: false,
      filterDisplay: false,
      projectReady: false,
      enableLeadReview: false,
      has_searched: false,
      correctedStructure: {},
      projectNavigation: [{ name: "project_leads", action: "project_leads.list", credential: "project_leads.list" }, { name: "project_statistics", action: "project_leads.statistics", credential: "projects.statistics", access: "allowed_statistics" }, { name: "project_edit", action: "project.edit", credential: "projects.update" }, { name: "project_assignments_edit", action: "project_assignments.edit", credential: "projects.update" }],
      structure: [{ name: 'id', sortable: true, credentials: 'root' }, { name: 'classification', type: "classification", class: "no-padding" }, { name: 'firstname', alias: 'name', type: 'lead_name', sortable: true }, { name: 'company', type: 'company', sortable: true }, { name: 'progress_indicator_lead_mask', type: 'progress' }, { name: 'updated_at', type: 'date', time: true, sortable: true }, { name: 'action', type: 'crud_action_folded', credentials: 'admin', exclude: ['show', 'duplicate'] }],
      structure_talents: [{ name: 'id', sortable: true, credentials: 'root' }, { name: 'classification', type: "classification", class: "no-padding" }, { name: 'firstname', alias: 'name', type: 'lead_name', sortable: true }, { name: 'progress_indicator_lead_mask', type: 'progress' }, { name: 'updated_at', type: 'date', time: true, sortable: true }, { name: 'action', type: 'crud_action_folded', credentials: 'admin', exclude: ['show', 'duplicate'] }],
      structure_mobile: [{ name: 'classification', type: "classification", class: "no-padding" }, { name: 'name', type: 'lead_name', sortable: true }, { name: 'company', type: 'company', sortable: true }, { name: 'progress_indicator_lead_mask', type: 'progress' }, { name: 'action', type: 'crud_action_folded', credentials: 'admin', exclude: ['show', 'duplicate'] }],
      status_structure: { name: 'status', type: 'status', sortable: true },
      crm_sync_structure: { name: 'sync_status', type: 'crm_status', class: "txtcenter", sortable: true },
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_LEADS',
        routerName: 'project_leads',
        emptyState: 'leads',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    };
  },

  computed: {
    storeQuery: function storeQuery() {
      return _.cloneDeep(this.$store.state.filters);
    },
    emptyState: function emptyState() {
      return this.$store.getters.getEmptyState;
    },
    currentPlanIsTalents: function currentPlanIsTalents() {
      return this.$store.getters.getCurrentPlanIsTalent;
    },
    emptyStateHeading: function emptyStateHeading() {
      return this.$t("ui.empty_state.leads.title");
    },
    emptyStateSubtitle: function emptyStateSubtitle() {
      return this.$t("ui.empty_state.leads.subtitle");
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.page != __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].getCurrentPageLeads()) {
      this.goToPage(__WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].getCurrentPageLeads());
    }

    this.setDefaultUiButtons();
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setSecondaryHeaderTabs(this.projectNavigation);

    __WEBPACK_IMPORTED_MODULE_7__EventBus_js__["a" /* EventBus */].$off('xls_export');
    __WEBPACK_IMPORTED_MODULE_7__EventBus_js__["a" /* EventBus */].$on('xls_export', function (payload) {
      if (payload == "project_leads.export") {
        _this.exportXls();
      }
    });

    this.setProjectInStore();
  },
  created: function created() {
    //  In case we generate a query, we create it before to be able to retrieve it in collection and display the specific list.
    this.initQuery();
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SET_SECONDARY_HEADER_TABS', []);
  },

  methods: {
    setCorrectStructure: function setCorrectStructure() {

      // reset correctedStructure
      this.correctedStructure = {};

      if (this.currentPlanIsTalents) {
        this.correctedStructure = this.structure_talents;
      } else {

        // add crm sync structure if crm is present
        if (this.projectReady && this.crmPresence) {
          var structure_length = this.structure.length;
          this.structure.splice(structure_length - 1, 0, this.crm_sync_structure);
        }

        // add status to the structure if lead filter is enabled in the project settings
        if (this.projectReady && this.enableLeadReview) {
          var _structure_length = this.structure.length;
          this.structure.splice(_structure_length - 1, 0, this.status_structure);
        }

        this.correctedStructure = this.structure;
      }

      return this.correctedStructure;
    },
    setDefaultUiButtons: function setDefaultUiButtons() {
      __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setHeaderButtons([{ name: "project_leads_export", event_name: 'xls_export', action: "project_leads.export", classes: "btn-tertiary", icon: "", debounce: 30000 }, { name: "project_lead", action: "project_leads.add_popup", classes: "btn-primary", icon: "" }]);
    },
    setLeadsEmptyStateButtons: function setLeadsEmptyStateButtons() {
      __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setHeaderButtons([{ name: "project_lead", action: "project_leads.add_popup", classes: "btn-primary", icon: "" }]);
    },
    exportXls: function exportXls() {
      var _this2 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_3__api_Project_js__["a" /* default */]();
      api.send_xls(this.id, null, 'en').then(function (item) {
        _this2.download_message = _this2.$t('ui.pages.project-download-data-suceed');
        _this2.$store.commit('SET_NOTIFICATION', {
          'title': 'ui.pages.project-download-data-suceed',
          'type': 'success'
        });
      }).catch(function (error) {});
    },
    setProjectInStore: function setProjectInStore() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var project;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_3__api_Project_js__["a" /* default */]().show(_this3.id);

              case 2:
                project = _context.sent;

                _this3.$store.commit('SET_CURRENT_PROJECT', project);
                __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setSubtitle({ link: { name: "projects" } });
                __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].setTitle({ label: project.name });

                if (project) {
                  _this3.projectReady = true;
                  _this3.enableLeadReview = _this3.$store.getters.getCurrentProject.enable_lead_review;
                  _this3.crmPresence = _this3.$store.getters.getOrganizationConfig('crm_presence');
                  _this3.setCorrectStructure();
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  },
  watch: {
    emptyState: function emptyState() {
      if (this.emptyState === null) {
        this.setDefaultUiButtons();
      } else if (this.emptyState === 'leads') {
        this.setLeadsEmptyStateButtons();
      }
    }
  }
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    trackings: Array,
    dateFormat: {
      type: String,
      default: "HH:mm"
    }
  },
  methods: {
    date: function date(_date) {
      return moment(_date).format(this.dateFormat);
    },
    leadName: function leadName(lead) {
      if (lead.firstname == '' && lead.lastname == '') {
        return lead.email;
      }
      return (lead.firstname + ' ' + lead.lastname).trim();
    }
  }
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_User_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_BusinessKit_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProjectUserAssignement__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProjectUserAssignement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ProjectUserAssignement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProjectBusinesskitAssignement__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProjectBusinesskitAssignement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ProjectBusinesskitAssignement__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ProjectUserAssignement: __WEBPACK_IMPORTED_MODULE_6__ProjectUserAssignement___default.a,
    ProjectBusinesskitAssignement: __WEBPACK_IMPORTED_MODULE_7__ProjectBusinesskitAssignement___default.a
  },
  data: function data() {
    return {
      users: [],
      assigned_users: [],
      user_to_assign: 0,
      businesskits: [],
      assigned_businesskits: [],
      businesskit_to_assign: 0,
      projectNavigation: [{ name: "project_leads", action: "project_leads.list", redential: "project_leads.list" }, { name: "project_statistics", action: "project_leads.statistics", credential: "projects.statistics", access: "allowed_statistics" }, { name: "project_edit", action: "project.edit", credential: "projects.update" }, { name: "project_assignments_edit", action: "project_assignments.edit", credential: "projects.update" }]
    };
  },

  computed: {
    currentProject: function currentProject() {
      return this.$store.getters.getCurrentProject;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].startLoading();

              if (_this.currentProject) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return _this.retrieveProject();

            case 4:
              _this.setupSecondaryHeader();
              _this.retrieveUsers();
              _this.retrieveBusinesskits();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setupSecondaryHeader: function setupSecondaryHeader() {
      __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].setSecondaryHeaderTabs(this.projectNavigation);
      __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].clearHeaderButtons();
      __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].setPageLevel("3");
      __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].setSubtitle({ link: { name: "projects" } });
      __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].setTitle({ label: "ui.pages.project-edit", params: { name: this.currentProject.name } });
      __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].setPageType('project');
    },
    retrieveProject: function retrieveProject() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var api, id, project;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                api = new __WEBPACK_IMPORTED_MODULE_2__api_Project_js__["a" /* default */]();
                id = _this2.$route.params.id;
                _context2.next = 4;
                return api['show'](id);

              case 4:
                project = _context2.sent;

                _this2.$store.commit('SET_CURRENT_PROJECT', project);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    retrieveUsers: function retrieveUsers() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var api, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Fetch all users in organizations
                api = new __WEBPACK_IMPORTED_MODULE_3__api_User_js__["a" /* default */]();
                _context3.next = 3;
                return api.all({ organization_id: _this3.currentProject.organization_id, per_page: 1000 });

              case 3:
                response = _context3.sent;

                _this3.users = response.resources;

                // Fetch which users are already assigned
                _context3.next = 7;
                return api.all({ project_id: _this3.currentProject.id, per_page: 1000 });

              case 7:
                response = _context3.sent;

                response.resources.forEach(function (user) {
                  _this3.assigned_users.push(user.id);
                });

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    retrieveBusinesskits: function retrieveBusinesskits() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var api, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Retrieve all businesskits
                api = new __WEBPACK_IMPORTED_MODULE_4__api_BusinessKit_js__["a" /* default */]();
                _context4.next = 3;
                return api.all({ organization_id: _this4.currentProject.organization, per_page: 1000 });

              case 3:
                response = _context4.sent;

                _this4.businesskits = response.resources;

                // Retrieve assigned businesskits
                _context4.next = 7;
                return api.all({ project_id: _this4.currentProject.id, per_page: 1000 });

              case 7:
                response = _context4.sent;

                response.resources.forEach(function (bk) {
                  _this4.assigned_businesskits.push(bk.id);
                });
                __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].finishLoading();

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    updateUsers: function updateUsers(users) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var api, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                api = new __WEBPACK_IMPORTED_MODULE_2__api_Project_js__["a" /* default */]();
                _context5.next = 4;
                return api.assign_users(users, _this5.currentProject.id);

              case 4:
                response = _context5.sent;

                _this5.assigned_users = users;
                _this5.$store.commit('SET_NOTIFICATION', {
                  'title': 'models.project.message.update',
                  'type': 'success'
                });
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                _this5.$store.commit('SET_NOTIFICATION', {
                  'title': 'errors.' + _context5.t0.response.data.errors[0].code,
                  'type': 'error'
                });

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9]]);
      }))();
    },
    updateBusinesskits: function updateBusinesskits(bks) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var api, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                api = new __WEBPACK_IMPORTED_MODULE_2__api_Project_js__["a" /* default */]();
                _context6.next = 4;
                return api.assign_businesskits(bks, _this6.currentProject.id);

              case 4:
                response = _context6.sent;

                _this6.assigned_businesskits = bks;
                _this6.$store.commit('SET_NOTIFICATION', {
                  'title': 'models.project.message.update',
                  'type': 'success'
                });
                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](0);

                _this6.$store.commit('SET_NOTIFICATION', {
                  'title': 'errors.' + _context6.t0.response.data.errors[0].code,
                  'type': 'error'
                });

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 9]]);
      }))();
    }
  },
  watch: {
    currentProject: function currentProject() {
      this.item = this.currentProject;
    }
  }
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModal__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    businesskits: {
      type: Array
    },
    assignedBusinesskits: {
      type: Array
    }
  },
  components: {
    AssignmentModal: __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModal___default.a
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  computed: {
    computedTitle: function computedTitle() {
      return "businesskit_assignment.title";
    },
    computedSubtitle: function computedSubtitle() {
      return "businesskit_assignment.subtitle";
    },
    assignedBusinessKitList: function assignedBusinessKitList() {
      var assignedBks = this.assignedBusinesskits;
      return this.businesskits.filter(function (bk) {
        return assignedBks.includes(bk.id);
      });
    },
    filteredBusinesskits: function filteredBusinesskits() {
      var _this = this;

      // Put assigned at the top
      var c = this.businesskits.filter(function (item) {
        return !_this.assignedBusinessKitList.includes(item);
      });
      // Merge both collections together in correct order
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.assignedBusinessKitList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(c));
    }
  },
  methods: {
    save: function save(items) {
      var assignedBusinesskits = items.map(function (item) {
        return item.id;
      });
      this.close();
      this.$emit('update', assignedBusinesskits);
    },
    close: function close() {
      this.isOpen = false;
    }
  }
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Tracking__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Statistic__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_Gauge__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_Gauge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_Gauge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_Project__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProjectStatisticsBkPerLead__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProjectStatisticsBkPerLead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ProjectStatisticsBkPerLead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProjectStatisticsBkSent__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProjectStatisticsBkSent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ProjectStatisticsBkSent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProjectStatisticsLeadsChart__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProjectStatisticsLeadsChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ProjectStatisticsLeadsChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProjectStatisticsLeadsClassification__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProjectStatisticsLeadsClassification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ProjectStatisticsLeadsClassification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProjectStatisticsRanking__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProjectStatisticsRanking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ProjectStatisticsRanking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_helpers_DataInput_RelativeDateChoser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_helpers_DataInput_RelativeDateChoser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_helpers_DataInput_RelativeDateChoser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_helpers_Specific_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TrackingTable__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TrackingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__TrackingTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__classes_Ui__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    Gauge: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_Gauge___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_13__components_helpers_Specific_Loading_vue___default.a,
    TrackingTable: __WEBPACK_IMPORTED_MODULE_14__TrackingTable___default.a,
    RelativeDateChoser: __WEBPACK_IMPORTED_MODULE_12__components_helpers_DataInput_RelativeDateChoser___default.a,
    'ranking': __WEBPACK_IMPORTED_MODULE_11__ProjectStatisticsRanking___default.a,
    'bk-per-lead': __WEBPACK_IMPORTED_MODULE_7__ProjectStatisticsBkPerLead___default.a,
    'bk-sent': __WEBPACK_IMPORTED_MODULE_8__ProjectStatisticsBkSent___default.a,
    'leads-chart': __WEBPACK_IMPORTED_MODULE_9__ProjectStatisticsLeadsChart___default.a,
    'leads-classification': __WEBPACK_IMPORTED_MODULE_10__ProjectStatisticsLeadsClassification___default.a
  },
  computed: {
    ranking_unable: function ranking_unable() {
      return this.$store.getters.getOrganizationConfig('ranking_display') == 'true';
    }
  },
  data: function data() {
    return {
      projectNavigation: [{ name: "project_leads", action: "project_leads.list", redential: "project_leads.list" }, { name: "project_statistics", action: "project_leads.statistics", credential: "projects.statistics", access: "allowed_statistics" }, { name: "project_edit", action: "project.edit", credential: "projects.update" }, { name: "project_assignments_edit", action: "project_assignments.edit", credential: "projects.update" }],
      is_loading: true,
      project_api: new __WEBPACK_IMPORTED_MODULE_6__api_Project__["a" /* default */](),
      project: null,
      statistics_api: new __WEBPACK_IMPORTED_MODULE_4__api_Statistic__["a" /* default */](),
      statistics: [],
      trackings: {},
      rankings: [],
      leads_count: {},
      queryParams: {
        sort_by: 'time',
        sort_order: 'DESC'
      }
    };
  },
  mounted: function mounted() {
    this.dateChange(1);
    __WEBPACK_IMPORTED_MODULE_16__classes_Ui__["a" /* default */].setSecondaryHeaderTabs(this.projectNavigation);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SET_SECONDARY_HEADER_TABS', []);
  },

  methods: {
    afterRetrieve: function afterRetrieve() {
      __WEBPACK_IMPORTED_MODULE_16__classes_Ui__["a" /* default */].setPageLevel("3");
      __WEBPACK_IMPORTED_MODULE_16__classes_Ui__["a" /* default */].setPageType(this.singular_model);
      __WEBPACK_IMPORTED_MODULE_16__classes_Ui__["a" /* default */].setSubtitle({ link: { name: "projects" } });
      __WEBPACK_IMPORTED_MODULE_16__classes_Ui__["a" /* default */].setTitle({ label: this.project.name });
      __WEBPACK_IMPORTED_MODULE_16__classes_Ui__["a" /* default */].clearHeaderButtons();
      this.$store.commit('SET_PAGE_TYPE', 'project_lead');
    },
    dateChange: function dateChange(number) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.is_loading = true;
                _this.queryParams.start_date = moment().subtract(60, 'd').format();
                _this.queryParams.end_date = moment().format();
                _this.statistics = [];
                _this.trackings = {};
                _this.rankings = [];
                _this.leads_count = {};
                _context.next = 9;
                return _this.retrieveProject();

              case 9:
                _this.project = _context.sent;
                _context.next = 12;
                return _this.retrieveStatistics();

              case 12:
                _this.statistics = _context.sent;
                _context.next = 15;
                return _this.retrieveStatisticsLeadsCount();

              case 15:
                _this.leads_count = _context.sent;
                _context.next = 18;
                return _this.retrieveTrackings();

              case 18:
                _this.trackings = _context.sent;
                _context.next = 21;
                return _this.retrieveRankings();

              case 21:
                _this.rankings = _context.sent;

                _this.afterRetrieve();
                _this.is_loading = false;

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    retrieveProject: function retrieveProject() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.project_api.show(_this2.id);

              case 2:
                return _context2.abrupt('return', _context2.sent);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    retrieveStatistics: function retrieveStatistics() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.queryParams.params = {
                  start_date: _this3.queryParams.start_date,
                  end_date: _this3.queryParams.end_date
                };
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.project_api.statistics(_this3.id, _this3.queryParams);

              case 4:
                return _context3.abrupt('return', _context3.sent);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](1);

                console.warn(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 7]]);
      }))();
    },
    retrieveStatisticsLeadsCount: function retrieveStatisticsLeadsCount() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this4.project_api.statistics_leads_count(_this4.id, _this4.queryParams);

              case 3:
                return _context4.abrupt('return', _context4.sent);

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](0);

                console.warn(_context4.t0);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 6]]);
      }))();
    },
    retrieveTrackings: function retrieveTrackings() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var params, tracking;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this5.queryParams, { project_id: _this5.id });
                tracking = new __WEBPACK_IMPORTED_MODULE_3__api_Tracking__["a" /* default */]();
                _context5.prev = 2;
                _context5.next = 5;
                return tracking.all(params);

              case 5:
                return _context5.abrupt('return', _context5.sent);

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](2);

                console.warn(_context5.t0);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[2, 8]]);
      }))();
    },
    retrieveRankings: function retrieveRankings() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return _this6.statistics_api.userRankings(_this6.id, _this6.queryParams);

              case 3:
                return _context6.abrupt('return', _context6.sent);

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6['catch'](0);

                console.warn(_context6.t0);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 6]]);
      }))();
    }
  }
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatisticsHelpers__ = __webpack_require__(356);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bk-per-lead',
  props: ['statistics'],
  methods: {},
  computed: {
    businessKitPerLead: function businessKitPerLead() {
      var leads = this.statistics.leads_count;
      var businesskits = this.statistics.sent_business_kits_count;
      if (leads == 0) {
        return 0;
      }
      var result = businesskits / leads;
      result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__StatisticsHelpers__["a" /* round */])(result, 2);
      return result;
    }
  }
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatisticsHelpers__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartist__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chartist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_Gauge__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_Gauge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_Gauge__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bk-sent',
  props: ['statistics'],
  components: { Gauge: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataDisplay_Gauge___default.a },
  computed: {
    businesskitSent: function businesskitSent() {
      return this.statistics.sent_business_kits_count;
    },
    businesskitOpened: function businesskitOpened() {
      return this.statistics.trackings_unique_bag_open_count;
    },
    businesskitSentOpenRatio: function businesskitSentOpenRatio() {
      if (this.businesskitSent == 0) {
        return 0;
      }
      var result = this.businesskitOpened / this.businesskitSent;
      return Math.round(result * 100);
    }
  }
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Specific_LeadsCountChart__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_Specific_LeadsCountChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_Specific_LeadsCountChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'leads-chart',
  props: ['statistics', 'leadsCount', 'trackings', 'startDate', 'endDate'],
  components: { LeadsCountChart: __WEBPACK_IMPORTED_MODULE_0__components_helpers_Specific_LeadsCountChart___default.a },
  computed: {
    leadsPerDay: function leadsPerDay() {
      var start_date = new moment(this.startDate);
      var end_date = new moment(this.endDate);

      var differenceDay = end_date.diff(start_date, 'days');

      var percent = this.statistics.leads_count / differenceDay;
      return Math.round(percent * 100) / 100;
    },
    leadsPerDetector: function leadsPerDetector() {
      var percent = this.statistics.leads_count / this.statistics.lead_detector_count;
      return Math.round(percent * 100) / 100;
    }
  }
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_DonutChart__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_DonutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_DonutChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'leads-classification',
  components: { DonutChart: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_DonutChart___default.a },
  props: ['statistics'],
  computed: {
    leadsCount: function leadsCount() {
      return this.statistics.leads_count;
    },
    leadsColdCount: function leadsColdCount() {
      return this.statistics.cold_leads_count;
    },
    leadsWarmCount: function leadsWarmCount() {
      return this.statistics.warm_leads_count;
    },
    leadsHotCount: function leadsHotCount() {
      return this.statistics.hot_leads_count;
    },
    classificationSeries: function classificationSeries() {
      return [this.leadsHotCount, this.leadsWarmCount, this.leadsColdCount];
    }
  }
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ProgressBar: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataDisplay_ProgressBar___default.a },
  props: ['rankings'],
  data: function data() {
    return {
      ready: false,
      current_user_id: null
    };
  },
  mounted: function mounted() {
    this.current_user_id = this.$store.state.current_user.user_id;
    if (this.rankings.length > 0) {
      this.initComputedPercentages();
    }
  },

  methods: {
    computedRankingClass: function computedRankingClass(ranking) {
      var str = 'ranking-' + ranking.position;
      if (ranking.user.id == this.current_user_id) {
        str += ' is-myself';
      }
      return str;
    },
    formatPercentage: function formatPercentage(number) {
      return Math.round(number * 100);
    },
    initComputedPercentages: function initComputedPercentages() {
      var _this = this;

      var maxPercentage = this.formatPercentage(this.rankings[0].ranking_percentage);
      var minPercentage = this.formatPercentage(this.rankings[this.rankings.length - 1].ranking_percentage);

      var factor = 100 / (maxPercentage - minPercentage);
      var maxOutput = 80;
      var minOutput = 5;
      var outputFactor = (maxOutput - minOutput) / 100;

      this.rankings.forEach(function (element) {
        var percentage = _this.formatPercentage(element.ranking_percentage);
        var outputPercentage = _this.computedPercentage(percentage, factor, minPercentage);

        var outputPercentageBase = _this.formatPercentage(outputPercentage) * outputFactor + minOutput;
        element.computed_percentage = outputPercentageBase;
      });

      this.ready = true;
    },
    computedPercentage: function computedPercentage(value, factor, minPercentage) {
      return (value - minPercentage) * factor / 100;
    }
  },
  watch: {
    rankings: function rankings() {
      this.ready = false;
      if (this.rankings.length > 0) {
        this.initComputedPercentages();
      }
    }
  }
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Tracking__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_RelativeDateChoser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_RelativeDateChoser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_RelativeDateChoser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_Pagination__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_projects_TrackingTable__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_projects_TrackingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_projects_TrackingTable__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    TrackingTable: __WEBPACK_IMPORTED_MODULE_5__components_pages_projects_TrackingTable___default.a,
    RelativeDateChoser: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_RelativeDateChoser___default.a,
    Pagination: __WEBPACK_IMPORTED_MODULE_4__components_helpers_Layout_Pagination___default.a
  },
  data: function data() {
    return {
      trackings: null,
      trackingsSorted: [],
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
      queryParams: {
        sort_by: 'time',
        sort_order: 'DESC'
      },
      returnedParams: {}
    };
  },
  mounted: function mounted() {
    this.dateChange(1);
  },

  methods: {
    goToPage: function goToPage(page) {
      this.queryParams.page = page;
      this.trackings = [];
      this.trackingsSorted = [];
      this.retrieveTrackings();
    },
    retrieveTrackings: function retrieveTrackings() {
      var _this = this;

      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.queryParams, { project_id: this.id });
      var tracking = new __WEBPACK_IMPORTED_MODULE_2__api_Tracking__["a" /* default */]();
      tracking.all(params).then(function (item) {
        _this.trackings = item;
        _this.returnedParams = item;
        _this.initTrackings();
      });
    },
    dateChange: function dateChange(number) {
      this.queryParams.end_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format();
      this.queryParams.start_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(number, 'd').format();
      this.trackings = [];
      this.trackingsSorted = [];
      this.retrieveTrackings();
    },
    initTrackings: function initTrackings() {
      var _this2 = this;

      if (_.isEmpty(this.trackings.resources)) {
        return true;
      }

      // sort trackings
      this.trackings.resources.sort(function (a, b) {
        var dateA = new Date(a.time);
        var dateB = new Date(b.time);
        if (dateA < dateB) return 1;else if (dateA > dateB) return -1;else return 0;
      });

      var currentTrackings = [];
      this.trackings.resources.forEach(function (tracking, index) {
        if (index == 0) {
          currentTrackings.push(tracking);
          return;
        }
        var currentDate = new Date(tracking.time);
        var lastDate = new Date(_this2.trackings.resources[index - 1].time);

        if (_this2.sameDay(currentDate, lastDate)) {
          currentTrackings.push(tracking);
        } else {
          _this2.trackingsSorted.push(currentTrackings);
          currentTrackings = [tracking];
        }
      });
      this.trackingsSorted.push(currentTrackings);
      console.log('trackings: ', this.trackings.resources);
      console.log('current trackings: ', currentTrackings);
      console.log('trackings sorted: ', this.trackingsSorted);
    },
    sameDay: function sameDay(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    }
  }
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Tracking__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_RelativeDateChoser__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_RelativeDateChoser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_RelativeDateChoser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_projects_TrackingTable__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_projects_TrackingTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_projects_TrackingTable__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    TrackingTable: __WEBPACK_IMPORTED_MODULE_4__components_pages_projects_TrackingTable___default.a,
    RelativeDateChoser: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataInput_RelativeDateChoser___default.a
  },
  data: function data() {
    return {
      trackings: null,
      trackingsSorted: [],
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
      queryParams: {
        sort_by: 'time',
        sort_order: 'DESC'
      }
    };
  },
  mounted: function mounted() {
    this.dateChange(1);
  },

  methods: {
    retrieveTrackings: function retrieveTrackings() {
      var _this = this;

      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.queryParams, { project_id: this.id });
      var tracking = new __WEBPACK_IMPORTED_MODULE_2__api_Tracking__["a" /* default */]();
      tracking.all(params).then(function (item) {
        _this.trackings = item;
        _this.initTrackings();
      });
    },
    dateChange: function dateChange(number) {
      this.queryParams.end_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format();
      this.queryParams.start_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(number, 'd').format();
      this.trackings = [];
      this.trackingsSorted = [];
      this.retrieveTrackings();
    },
    initTrackings: function initTrackings() {
      var _this2 = this;

      if (_.isEmpty(this.trackings.resources)) {
        return true;
      }
      // sort trackings
      this.trackings.resources.sort(function (a, b) {
        var dateA = new Date(a.time);
        var dateB = new Date(b.time);
        if (dateA < dateB) return 1;else if (dateA > dateB) return -1;else return 0;
      });

      var currentTrackings = [];
      this.trackings.resources.forEach(function (tracking, index) {
        if (index == 0) {
          currentTrackings.push(tracking);
          return;
        }
        var currentDate = new Date(tracking.time);
        var lastDate = new Date(_this2.trackings.resources[index - 1].time);

        if (_this2.sameDay(currentDate, lastDate)) {
          currentTrackings.push(tracking);
        } else {
          _this2.trackingsSorted.push(currentTrackings);
          currentTrackings = [tracking];
        }
      });
      this.trackingsSorted.push(currentTrackings);
      console.log('trackings: ', this.trackings.resources);
      console.log('current trackings: ', currentTrackings);
      console.log('trackings sorted: ', this.trackingsSorted);
    },
    sameDay: function sameDay(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    }
  }
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Organization_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_User_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_BusinessKit_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_LeadMask__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_data_project_categories__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classes_Ui__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var user_structure = [{ name: 'id', credentials: "is_root" }, { name: 'firstname' }, { name: 'lastname' }, { name: 'email', sortable: true }, { name: 'action', type: 'unassign', exclude: ['show'] }];

var businesskit_structure = [{ name: 'id', credentials: 'root' }, { name: 'name', sortable: true }, { name: 'action', type: 'unassign', exclude: ['show'] }];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_mixins_Update__["a" /* updateMixin */]],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker__["a" /* default */],
    Ui: __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */],
    FormSwitch: __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_FormSwitch___default.a
  },
  data: function data() {
    return {
      projectNavigation: [{ name: "project_leads", action: "project_leads.list", redential: "project_leads.list" }, { name: "project_statistics", action: "project_leads.statistics", credential: "projects.statistics", access: "allowed_statistics" }, { name: "project_edit", action: "project.edit", credential: "projects.update" }, { name: "project_assignments_edit", action: "project_assignments.edit", credential: "projects.update" }],
      model: "projects",
      api: new __WEBPACK_IMPORTED_MODULE_1__api_Project_js__["a" /* default */](),
      organizations: [],
      name: "project",
      project_categories: __WEBPACK_IMPORTED_MODULE_10__config_data_project_categories__["a" /* default */],
      start_date_error: "",
      end_date_error: "",
      leadMasks: [],
      user_structure: user_structure,
      businesskit_structure: businesskit_structure,
      additional_data_displayed: false,
      project_data_displayed: false,
      additional_data: {},
      selectClass: '',
      currentlySelected: null,
      item: {
        additional_data: {}
      }
    };
  },
  mounted: function mounted() {
    this.init();
    __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setSecondaryHeaderTabs(this.projectNavigation);
    this.clearSelected();
    this.retrieve_associations();
    this.item = { additional_data: {} };
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SET_SECONDARY_HEADER_TABS', []);
  },

  computed: {
    isCurrentlySelectedBasicOrAdvanced: {
      get: function get() {
        return ['basic', 'advanced'].includes(this.currentlySelected);
      }
    },
    classificationCollection: function classificationCollection() {
      return [{
        name: this.$t('models.select_classification.hot'),
        value: 'hot',
        color: 'red'
      }, {
        name: this.$t('models.select_classification.warm'),
        value: 'warm',
        color: 'orange'
      }, {
        name: this.$t('models.select_classification.cold'),
        value: 'cold',
        color: 'blue'
      }];
    },

    formattedStartDate: {
      get: function get() {
        if (this.item.start_date) {
          var startDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.item.start_date).format('YYYY-MM-DD');
          return startDate;
        }
      },
      set: function set(val) {
        this.item.start_date = val;
      }
    },
    formattedEndDate: {
      get: function get() {
        if (this.item.end_date) {
          var endDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.item.end_date).format('YYYY-MM-DD');
          return endDate;
        }
      },
      set: function set(val) {
        this.item.end_date = val;
      }
    },
    title: function title() {
      if (this.type == "update") {
        return "ui.pages.project-edit";
      } else {
        return "ui.pages.project-create";
      }
    },
    currentPlanIsTalents: function currentPlanIsTalents() {
      // Don't show lead sheet selection if current plan is talents
      return this.$store.getters.getCurrentPlanIsTalent;
    }
  },
  methods: {
    inputClassification: function inputClassification(value) {
      if (!!value) {
        if (!value) {
          value = 'unclassified';
        }
        this.selectClass = 'value--' + value;
        this.$emit('input', 'classification', value);
      }
    },
    setLeadSheet: function setLeadSheet(leadSheet) {
      this.clearSelected();
      var reference = this.$refs[leadSheet];
      if (reference) {
        if ('classes' in reference) {
          reference = reference.$el;
        }
        reference.classList.add('selected');
        if (leadSheet == 'none') {
          delete this.item.lead_sheet;
          this.currentlySelected = leadSheet;
        } else {
          this.item.lead_sheet = leadSheet;
          this.currentlySelected = leadSheet;
        }
      }
    },
    clearSelected: function clearSelected() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.getElementsByClassName('selected')).forEach(function (el) {
        el.classList.remove('selected');
      });
    },
    validate: function validate() {
      this.$store.commit('RESET_PROJECT_WIZARD_ERRORS');
      if (this.item.lead_sheet === undefined && this.item.lead_mask_id === undefined) {
        this.$store.commit('ADD_PROJECT_WIZARD_ERROR', {
          field_name: 'lead_mask_id',
          code: 'project.lead_mask_id.invalid'
        });
      }
      return this.errors.length == 0;
    },
    retrieve: function retrieve(id) {
      var _this = this;

      this.api[this.retrieve_method](id).then(function (item) {
        _this.item = item;
        __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setPageLevel("3");
        __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setSubtitle({ link: { name: "projects" } });
        __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setTitle({ label: _this.title, params: { name: item.name } });
        __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].setPageType(_this.singular_model);
        __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].clearHeaderButtons();
        __WEBPACK_IMPORTED_MODULE_12__classes_Ui__["a" /* default */].finishLoading();
        _this.handleLeadSheet();
      });
    },
    handleLeadSheet: function handleLeadSheet() {
      if (this.item.lead_mask && this.item.lead_mask.default) {
        var type = this.item.lead_mask.default_type;
        this.setLeadSheet(type);
      }
    },
    update: function update() {
      var _this2 = this;

      this.dropNonNumericBaseScore();
      this.api.post(this.item).then(function (item) {
        _this2.item = item;
        _this2.$store.commit('SET_CURRENT_PROJECT', item);
        _this2.$store.commit('SET_NOTIFICATION', {
          'title': 'models.' + _this2.singular_model + '.message.' + _this2.type,
          'type': 'success'
        });
        _this2.$router.push({ name: "project_leads", params: { id: item.id } });
      }).catch(function (e) {
        console.error(e);
        _this2.errors = e.response.data.errors;
        _this2.$store.commit('SET_NOTIFICATION', {
          'title': 'errors.' + e.response.data.errors[0].code,
          'type': 'error'
        });
      });
    },
    retrieve_associations: function retrieve_associations() {
      var _this3 = this;

      var permission = __WEBPACK_IMPORTED_MODULE_11__classes_Permission__["a" /* default */].loadPermissions();

      if (__WEBPACK_IMPORTED_MODULE_11__classes_Permission__["a" /* default */].can(permission, 'organizations.list')) {
        var api = new __WEBPACK_IMPORTED_MODULE_2__api_Organization_js__["a" /* default */]();
        api.all_for_association().then(function (items) {
          _this3.organizations = items;
        }).catch(function (error) {
          console.error(error);
        });
      }

      if (__WEBPACK_IMPORTED_MODULE_11__classes_Permission__["a" /* default */].can(permission, 'lead_masks.list')) {
        var _api = new __WEBPACK_IMPORTED_MODULE_7__api_LeadMask__["a" /* default */]();
        _api.all_for_association().then(function (items) {
          _this3.leadMasks = items;
        }).catch(function (error) {
          console.error(error);
        });
      }
    },
    additionalDataInitializer: function additionalDataInitializer() {
      if (typeof this.item.additional_data == 'undefined') {
        this.item.additional_data = {};
      }
    },
    baseScoreError: function baseScoreError() {
      if (this.item.additional_data.base_score == undefined || typeof this.item.additional_data.base_score === 'number' || this.item.additional_data.base_score == '') {
        return false;
      } else {
        return true;
      }
    },
    dropNonNumericBaseScore: function dropNonNumericBaseScore() {
      if (!(typeof this.item.additional_data.base_score === 'number')) {
        return this.item.additional_data.base_score = undefined;
      }
    },
    allowedLeadReview: function allowedLeadReview() {
      return this.$store.getters.getCurrentUserIsRoot;
    },
    showCrmSyncSwitch: function showCrmSyncSwitch() {
      return this.$store.getters.getOrganizationConfig('crm_presence') || this.$store.getters.getOrganizationConfig('enable_crm_sync_switches');
    }
  },
  watch: {
    errors: function errors(_errors) {
      var _this4 = this;

      this.error = undefined;
      this.errors.forEach(function (error) {
        if (error.field_name == "start_date") {
          _this4.start_date_error = _this4.$t(error.code);
        }
        if (error.field_name == "end_date") {
          _this4.end_date_error = _this4.$t(error.code);
        }
      });
    }
  }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Organization_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_User_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_BusinessKit_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_LeadMask__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataDisplay_Collection__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataDisplay_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_DataDisplay_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_Ui__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var user_structure = [{ name: 'id', credentials: "is_root" }, { name: 'firstname' }, { name: 'lastname' }, { name: 'email', sortable: true }, { name: 'action', type: 'unassign', exclude: ['show'] }];

var businesskit_structure = [{ name: 'id', credentials: 'root' }, { name: 'name', sortable: true }, { name: 'action', type: 'unassign', exclude: ['show'] }];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_Update__["a" /* updateMixin */]],
  components: { Collection: __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataDisplay_Collection___default.a, Ui: __WEBPACK_IMPORTED_MODULE_8__classes_Ui__["a" /* default */] },
  data: function data() {
    return {
      model: "projects",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_Project_js__["a" /* default */](),
      organizations: [],
      lead_masks: [],
      name: "project",
      users: [],
      assigned_users: [],
      user_to_assign: 0,
      businesskits: [],
      assigned_businesskits: [],
      businesskit_to_assign: 0,
      user_structure: user_structure,
      businesskit_structure: businesskit_structure
    };
  },

  computed: {
    title: function title() {
      return "ui.pages.project-create";
    }
  },
  methods: {
    finish: function finish() {
      this.$router.push({ name: 'projects' });
    },
    retrieve_associations: function retrieve_associations() {
      var _this = this;

      var permission = __WEBPACK_IMPORTED_MODULE_6__classes_Permission__["a" /* default */].loadPermissions();

      if (__WEBPACK_IMPORTED_MODULE_6__classes_Permission__["a" /* default */].can(permission, 'organizations.list')) {
        var api = new __WEBPACK_IMPORTED_MODULE_1__api_Organization_js__["a" /* default */]();
        api.all_for_association().then(function (items) {
          _this.organizations = items;
        }).catch(function (error) {
          console.log(error);
        });
      }

      if (__WEBPACK_IMPORTED_MODULE_6__classes_Permission__["a" /* default */].can(permission, 'lead_masks.list')) {
        var _api = new __WEBPACK_IMPORTED_MODULE_4__api_LeadMask__["a" /* default */]();
        _api.all_for_association().then(function (items) {
          _this.lead_masks = items;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    retrieveUsers: function retrieveUsers() {
      var _this2 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_2__api_User_js__["a" /* default */]();
      api.all_for_association("email", { organization_id: this.item.organization_id }).then(function (items) {
        _this2.users = items;
      });
    },
    retrieveAssignedUsers: function retrieveAssignedUsers() {
      var _this3 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_2__api_User_js__["a" /* default */]();
      api.all({ project_id: this.id }).then(function (items) {
        _this3.assigned_users = items.resources;
      });
    },
    unassignUser: function unassignUser(item) {
      var _this4 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_0__api_Project_js__["a" /* default */]();
      api.unassign_user(item.id, this.id).then(function (item) {
        _this4.retrieveAssignedUsers();
      });
    },
    assignUser: function assignUser(item) {
      var _this5 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_0__api_Project_js__["a" /* default */]();
      api.assign_user(this.user_to_assign, this.id).then(function (item) {
        _this5.retrieveAssignedUsers();
        _this5.user_to_assign = 0;
      });
    },
    retrieveBusinesskits: function retrieveBusinesskits() {
      var _this6 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_3__api_BusinessKit_js__["a" /* default */]();
      api.all_for_association().then(function (items) {
        _this6.businesskits = items;
      });
    },
    retrieveAssignedBusinesskits: function retrieveAssignedBusinesskits() {
      var _this7 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_3__api_BusinessKit_js__["a" /* default */]();
      api.all({ project_id: this.id }).then(function (items) {
        _this7.assigned_businesskits = items.resources;
      });
    },
    unassignBusinesskit: function unassignBusinesskit(item) {
      var _this8 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_0__api_Project_js__["a" /* default */]();
      api.unassign_businesskit(item.id, this.id).then(function (item) {
        _this8.retrieveAssignedBusinesskits();
      });
    },
    assignBusinesskit: function assignBusinesskit(item) {
      var _this9 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_0__api_Project_js__["a" /* default */]();
      api.assign_businesskit(this.businesskit_to_assign, this.id).then(function (item) {
        _this9.retrieveAssignedBusinesskits();
        _this9.businesskit_to_assign = 0;
      }).catch(function (error) {});
    }
  },
  watch: {
    errors: function errors(_errors) {
      var _this10 = this;

      this.error = undefined;
      this.errors.forEach(function (error) {
        if (error.field_name == "start_date") {
          _this10.start_date_error = _this10.$t(error.code);
        }
        if (error.field_name == "end_date") {
          _this10.end_date_error = _this10.$t(error.code);
        }
      });
    }
  },
  mounted: function mounted() {
    this.retrieve_associations();
    this.retrieveUsers();
    this.retrieveAssignedUsers();
    this.retrieveBusinesskits();
    this.retrieveAssignedBusinesskits();
  }
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModal__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    users: {
      type: Array
    },
    assignedUsers: {
      type: Array
    }
  },
  components: {
    AssignmentModal: __WEBPACK_IMPORTED_MODULE_1__components_layouts_partials_AssignmentModal___default.a
  },
  computed: {
    computedTitle: function computedTitle() {
      return "user_assignment.title";
    },
    computedSubtitle: function computedSubtitle() {
      return "user_assignment.subtitle";
    },
    assignedUsersList: function assignedUsersList() {
      var assignedUsers = this.assignedUsers;
      return this.users.filter(function (user) {
        return assignedUsers.includes(user.id);
      });
    },
    filteredUsers: function filteredUsers() {
      var _this = this;

      // Put assigned at the top
      var c = this.users.filter(function (item) {
        return !_this.assignedUsersList.includes(item);
      });
      // Merge both collections together in correct order
      var filteredUsers = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.assignedUsersList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(c));
      // If user has no name put their email as the display_name
      filteredUsers.forEach(function (item) {
        if (!item.display_name || item.display_name === '') {
          item.display_name = item.email;
        }
      });
      return filteredUsers;
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    save: function save(items) {
      var assignedUsers = items.map(function (item) {
        return item.id;
      });
      this.close();
      this.$emit('update', assignedUsers);
    },
    close: function close() {
      this.isOpen = false;
    }
  }
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Project_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_User_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_BusinessKit_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_LeadMask__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_Project__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProjectBusinesskitAssignement__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProjectBusinesskitAssignement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ProjectBusinesskitAssignement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_projects_wizard_StepOne__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_projects_wizard_StepOne___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pages_projects_wizard_StepOne__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_projects_wizard_StepTwo__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_projects_wizard_StepTwo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_pages_projects_wizard_StepTwo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_projects_wizard_Success__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_projects_wizard_Success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_pages_projects_wizard_Success__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Ui: __WEBPACK_IMPORTED_MODULE_10__classes_Ui__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_8__components_helpers_Layout_NewModal___default.a,
    StepOne: __WEBPACK_IMPORTED_MODULE_12__components_pages_projects_wizard_StepOne___default.a,
    StepTwo: __WEBPACK_IMPORTED_MODULE_13__components_pages_projects_wizard_StepTwo___default.a,
    Success: __WEBPACK_IMPORTED_MODULE_14__components_pages_projects_wizard_Success___default.a
  },
  data: function data() {
    return {
      model: "projects",
      isOpen: true,
      api: new __WEBPACK_IMPORTED_MODULE_2__api_Project_js__["a" /* default */](),
      item: {
        user_ids: []
      }, // The Project
      leadMasks: [], // Organization's Lead Masks
      organizations: [], // Possible Organizations (NOT IMPLEMENTED!)
      masterOrganizationId: undefined, // Allow overwriting user's org ID. This is needed for root accounts
      errors: [], // API errors
      businesskits: [], // Organization's Business Kits
      users: [] // Organization's users
    };
  },

  computed: {
    currentStep: function currentStep() {
      return this.$store.getters.getProjectWizardStep;
    },
    organization_id: function organization_id() {
      if (this.masterOrganizationId) {
        return this.masterOrganizationId;
      } else {
        return this.$store.state.current_user.organization_id;
      }
    }
  },
  mounted: function mounted() {
    this.$store.commit("SET_PROJECT_WIZARD_STEP", 1);
    this.retrieveLeadSheets();
    this.retrieveUsers();
    this.retrieveBusinesskits();
  },

  methods: {
    handleUserInvite: function handleUserInvite(user) {
      this.item.user_ids.push(user.id);
      this.retrieveUsers();
    },

    // Create the project
    create: function create() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var api, project;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                api = new __WEBPACK_IMPORTED_MODULE_6__api_Project__["a" /* default */]();
                _context.prev = 1;
                _context.next = 4;
                return api.post(_this.item);

              case 4:
                project = _context.sent;

                if (!_this.item.user_ids) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return api.assign_users(_this.item.user_ids, project.id);

              case 8:
                if (!_this.item.business_kit_id) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return api.assign_businesskit(_this.item.business_kit_id, project.id);

              case 11:
                _this.item = project;
                _this.nextStep();
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](1);

                console.warn(_context.t0);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 15]]);
      }))();
    },
    setIsOpen: function setIsOpen(bool) {
      this.isOpen = bool;
      if (!bool && !this.currentPlanIsTalent) {
        this.view = null;
      }
    },
    nextStep: function nextStep() {
      // Go to next step
      this.$store.commit("RESET_PROJECT_WIZARD_ERRORS");
      this.$store.commit("INCREMENT_PROJECT_WIZARD_STEP", 1);
    },
    retrieveLeadSheets: function retrieveLeadSheets() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var api;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                api = new __WEBPACK_IMPORTED_MODULE_5__api_LeadMask__["a" /* default */]();
                _context2.next = 3;
                return api.all_for_association();

              case 3:
                _this2.leadMasks = _context2.sent;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    retrieveUsers: function retrieveUsers() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var api, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                api = new __WEBPACK_IMPORTED_MODULE_3__api_User_js__["a" /* default */]();
                _context3.next = 3;
                return api.all({
                  organization_id: _this3.organization_id,
                  per_page: 1000
                });

              case 3:
                response = _context3.sent;

                _this3.users = response.resources;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    retrieveBusinesskits: function retrieveBusinesskits() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var params, api, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  organization_id: _this4.organization_id,
                  per_page: 1000
                };
                api = new __WEBPACK_IMPORTED_MODULE_4__api_BusinessKit_js__["a" /* default */]();
                _context4.next = 4;
                return api.all(params);

              case 4:
                response = _context4.sent;

                _this4.businesskits = response.resources;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    updateUsers: function updateUsers(payload) {
      this.assigned_users = payload;
    },
    updateBusinesskits: function updateBusinesskits(payload) {
      this.assigned_businesskits = payload;
    }
  },
  watch: {
    errors: function errors(_errors) {
      var _this5 = this;

      this.error = undefined;
      this.errors.forEach(function (error) {
        if (error.field_name == "start_date") {
          _this5.start_date_error = _this5.$t(error.code);
        }
        if (error.field_name == "end_date") {
          _this5.end_date_error = _this5.$t(error.code);
        }
      });
    },
    organization_id: function organization_id(id) {
      this.retrieveLeadSheets();
      this.retrieveUsers();
      this.retrieveBusinesskits();
    }
  }
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_eq__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Project__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Sendouts__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_Collection__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layouts_partials_Searchbar_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layouts_partials_Searchbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_layouts_partials_Searchbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_ProjectsListing__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_ProjectsListing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_ProjectsListing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layouts_partials_AddButton_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layouts_partials_AddButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_layouts_partials_AddButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_EmptyState__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_EmptyState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_EmptyState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_projects_ProjectWizard__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_projects_ProjectWizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_pages_projects_ProjectWizard__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var structure = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({ name: 'id', credentials: 'admin', sortable: true }, 'credentials', 'root'), { name: 'name', type: 'project_name', title: 'Name', sortable: true }, { name: 'period', title: 'Period', type: 'period', sortable: true }, { name: 'business_kits_count', class: "txtcenter", sortable: true }, { name: 'leads_count', class: "txtcenter", sortable: true }, { name: 'unsynced_leads_count', type: 'unsynced_count', class: "txtcenter", sortable: true }, { name: 'product', credentials: 'root', sortable: true }, { name: 'organization_name', sortable: true, credentials: 'root' }, { name: 'action', type: 'crud_action_folded', credentials: 'admin' }];
var structure_no_crm = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({ name: 'id', credentials: 'admin', sortable: true }, 'credentials', 'root'), { name: 'name', type: 'project_name', title: 'Name', sortable: true }, { name: 'period', title: 'Period', type: 'period', sortable: true }, { name: 'business_kits_count', class: "txtcenter", sortable: true }, { name: 'leads_count', class: "txtcenter", sortable: true }, { name: 'product', credentials: 'root', sortable: true }, { name: 'organization_name', sortable: true, credentials: 'root' }, { name: 'action', type: 'crud_action_folded', credentials: 'admin' }];
var default_sort_by = "id";
var default_sort_order = "DESC";
var default_filters = {};
var MAX_AGE_COOKIE = 60 * 60 * 24 * 7 * 4 * 12 * 10; // 10 years
var COOKIE_KEY_VALUE = 'emailReminder=true';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_Collection__["a" /* collectionMixin */]],
  components: {
    ProjectsListing: __WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_ProjectsListing___default.a,
    Searchbar: __WEBPACK_IMPORTED_MODULE_7__components_layouts_partials_Searchbar_vue___default.a,
    AddButton: __WEBPACK_IMPORTED_MODULE_9__components_layouts_partials_AddButton_vue___default.a,
    ProjectWizard: __WEBPACK_IMPORTED_MODULE_11__components_pages_projects_ProjectWizard___default.a,
    EmptyState: __WEBPACK_IMPORTED_MODULE_10__components_helpers_DataDisplay_EmptyState___default.a
  },
  data: function data() {
    return {
      model: "projects",
      api: new __WEBPACK_IMPORTED_MODULE_2__api_Project__["a" /* default */](),
      collectionData: structure,
      query: { web_application: true },
      title: "ui.pages.projects",
      item: {},
      loading: false,
      isSubmited: false,
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_PROJECTS',
        routerName: 'projects',
        emptyState: 'projects',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    };
  },

  computed: {
    emptyStateHeading: function emptyStateHeading() {
      return this.$t("ui.empty_state.projects.title");
    },
    emptyStateHeadingUser: function emptyStateHeadingUser() {
      return this.$t("ui.empty_state.projects.title-standard-user");
    },
    emptyStateSubtitle: function emptyStateSubtitle() {
      return this.$t("ui.empty_state.projects.subtitle");
    },
    emptyStateSubtitleUser: function emptyStateSubtitleUser() {
      return this.$t("ui.empty_state.projects.standard-user");
    },
    crmPresence: function crmPresence() {
      return this.$store.getters.getOrganizationConfig('crm_presence');
    },
    emptyState: function emptyState() {
      return this.$store.getters.getEmptyState;
    },
    onboardingModalShowing: function onboardingModalShowing() {
      // If the onboarding modal is being shown we don't want to show the background
      // getUserInBoarded - If false it means onboarding modal is shown
      return !this.$store.getters.getUserIsOnboarded;
    },
    wizardModalShowing: function wizardModalShowing() {
      return this.$route.meta.showModal;
    },
    currentUserIsAdmin: function currentUserIsAdmin() {
      return this.$store.getters.getCurrentUserIsAdmin;
    },
    invitedByUserId: function invitedByUserId() {
      return this.$store.state.current_user.invited_by_user_id;
    }
  },
  mounted: function mounted() {
    var email_reminder = cookie.get("emailReminder");
    if (email_reminder) {
      this.isSubmited = true;
    } else {
      this.isSubmited = false;
    }
    if (this.page != __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].getCurrentPageProjects()) {
      this.goToPage(__WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].getCurrentPageProjects());
    }
    this.emptyCurrentProject();
    __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].$off('project_duplicate');
    __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].$on('project_duplicate', this.duplicate);
    if (this.$store.getters.getOrganizationConfig('crm_presence')) {
      this.collectionData = structure;
    } else {
      this.collectionData = structure_no_crm;
    }
  },
  created: function created() {
    this.initQuery();
  },

  methods: {
    emptyCurrentProject: function emptyCurrentProject() {
      this.$store.commit('EMPTY_CURRENT_PROJECT');
    },
    sendEmail: function sendEmail() {
      var _this = this;

      var api = new __WEBPACK_IMPORTED_MODULE_3__api_Sendouts__["a" /* default */]();
      api.sendEmail().then(function () {
        document.cookie = COOKIE_KEY_VALUE + ';max-age=' + MAX_AGE_COOKIE;
        _this.isSubmited = true;
      }).catch(function () {
        _this.isSubmited = false;
      });
    },
    duplicate: function duplicate(payload) {
      var _this2 = this;

      this.api.duplicate(payload.id).then(function (data) {
        _this2.retrieve();
      });
    }
  },
  watch: {
    crmPresence: function crmPresence() {
      if (this.$store.getters.getOrganizationConfig('crm_presence')) {
        this.collectionData = structure;
      } else {
        this.collectionData = structure_no_crm;
      }
    }
  }
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_Organization_js__ = __webpack_require__(32);
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    var api = new __WEBPACK_IMPORTED_MODULE_0__api_Organization_js__["a" /* default */]();
    var organization_id = this.$store.state.current_user.organization_id;
    api.projects_crm_sync(organization_id).then(function (data) {
      _this.$store.commit('SET_NOTIFICATION', {
        'title': 'models.organizations.successfully_started_crm_sync',
        'type': 'success'
      });
      _this.$router.go(-1);
    });
  }
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    trackings: Array,
    projectId: [String, Number],
    dateFormat: {
      type: String,
      default: "HH:mm"
    }
  },
  methods: {
    date: function date(_date) {
      // return moment(date).format("DD.MM.YYYY HH:mm")
      return moment(_date).format(this.dateFormat);
    },
    leadName: function leadName(tracking) {
      if (tracking.lead_firstname == '' && tracking.lead_lastname == '') {
        return tracking.email;
      }
      return (tracking.lead_firstname + ' ' + tracking.lead_lastname).trim();
    }
  }
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_Field___default.a
  },
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    errors: function errors() {
      return this.$store.getters.getProjectWizardErrors;
    }
  },
  methods: {
    cancel: function cancel() {
      this.$store.commit("RESET_PROJECT_WIZARD_ERRORS");
      this.$store.commit("SET_PROJECT_WIZARD_STEP", 1);
      this.$router.push({
        name: "projects"
      });
    },
    nextStep: function nextStep() {
      var valid = this.validate();
      if (valid) {
        // Go to next step
        this.$store.commit("INCREMENT_PROJECT_WIZARD_STEP", 1);
      }
    },
    validate: function validate() {
      this.$store.commit("RESET_PROJECT_WIZARD_ERRORS");
      if (!this.item.name) {
        this.$store.commit("ADD_PROJECT_WIZARD_ERROR", {
          field_name: "name",
          code: "project.name.invalid"
        });
      }
      return this.errors.length == 0;
    }
  }
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DataInput_Field___default.a
  },
  data: function data() {
    return {
      hasLeadMasks: this.leadMasks.length > 0,
      currentlySelected: null
    };
  },

  props: {
    item: {
      type: Object
    },
    leadMasks: {
      type: Array
    },
    businesskits: {
      type: Array
    }
  },
  computed: {
    errors: function errors() {
      return this.$store.getters.getProjectWizardErrors;
    },
    businessKitList: function businessKitList() {
      return this.businesskits.map(function (item) {
        return { 'name': item.name, 'value': item.id };
      });
    },
    planIsTalent: function planIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent;
    }
  },
  mounted: function mounted() {
    this.clearSelected();
    this.setLeadSheet('basic');
  },

  methods: {
    setBusinessKit: function setBusinessKit(kit) {
      // sometimes the field calls this method with kit === undefined
      if (!kit) {
        return;
      }
      this.clearSelected();
      if (kit === 'custom') {
        var reference = this.$refs['custom'];
      } else {
        var reference = this.$refs['businesskit'].$el;
      }
      reference.classList.add('selected');
      this.item.business_kit_id = kit;
    },

    // When coming from the drop-down
    setLeadMaskId: function setLeadMaskId(maskId) {
      if (maskId) {
        this.clearSelected();
        var reference = this.$refs['leadMaskId'].$el;
        reference.classList.add('selected');
        this.item.lead_mask_id = maskId;
        this.item.lead_sheet = null;
        this.currentlySelected = null;
      }
    },

    // When clicking one of the big selectors
    setLeadSheet: function setLeadSheet(leadSheet) {
      this.clearSelected();
      var reference = this.$refs[leadSheet];
      reference.classList.add('selected');
      // Clear out lead_mask_id in case drop-down was selected before
      this.item.lead_mask_id = null;
      this.item.lead_sheet = leadSheet;
      this.currentlySelected = leadSheet;
    },
    clearSelected: function clearSelected() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$refs).forEach(function (key) {
        var el = _this.$refs[key];
        // Some refs are objects so we need to fetch the actual element
        if (el.$el) {
          el = el.$el;
        }
        el.classList.remove('selected');
      });
    },
    cancel: function cancel() {
      this.$store.commit('RESET_PROJECT_WIZARD_ERRORS');
      this.$store.commit('SET_PROJECT_WIZARD_STEP', 1);
      this.$router.push({
        name: "projects"
      });
    },
    previousStep: function previousStep() {
      this.$store.commit('INCREMENT_PROJECT_WIZARD_STEP', -1);
    },
    validate: function validate() {
      this.$store.commit('RESET_PROJECT_WIZARD_ERRORS');
      if (!this.planIsTalent && !this.item.lead_sheet && !this.item.lead_mask_id) {
        this.$store.commit('ADD_PROJECT_WIZARD_ERROR', {
          field_name: 'lead_mask_id',
          code: 'project.lead_mask_id.invalid'
        });
      } else if (this.planIsTalent && !this.item.business_kit_id) {
        this.$store.commit('ADD_PROJECT_WIZARD_ERROR', {
          field_name: 'business_kit_id',
          code: 'project.business_kit_id.invalid'
        });
      }
      return this.errors.length == 0;
    },
    create: function create() {
      var valid = this.validate();
      if (valid) {
        if (this.item.business_kit_id === 'custom') {
          delete this.item.business_kit_id;
          this.$store.commit('PROJECT_WIZARD_CUSTOM_BUSINESS_KIT', true);
        }
        this.$emit('create');
      }
    }
  }
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    shouldShowDefaultActions: function shouldShowDefaultActions() {
      var isTalents = this.$store.getters.getCurrentPlanIsTalent;
      return !isTalents;
    },
    customKit: function customKit() {
      return this.$store.getters.getProjectWizardCustomBusinessKit;
    },
    talentKitLink: function talentKitLink() {
      var link = this.$store.getters.getBusinessKitLink;
      return link;
    },
    talentButtonText: function talentButtonText() {
      if (this.customKit) {
        return 'ui.pages.project-create-talentkit';
      } else {
        return 'ui.pages.project-view-talentkit';
      }
    }
  }
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_FilterResults_Contacts__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_FilterResults_Contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_FilterResults_Contacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_Segments_BusinessKitModal__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_Segments_BusinessKitModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_Segments_BusinessKitModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_Segments_AddToProjectModal__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_Segments_AddToProjectModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_Segments_AddToProjectModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_Segments__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_Loading_vue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Contacts: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_FilterResults_Contacts___default.a, Loading: __WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_Loading_vue___default.a, BusinessKitModal: __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_Segments_BusinessKitModal___default.a, AddToProjectModal: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DataDisplay_Segments_AddToProjectModal___default.a },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data: function data() {
    return {
      segmentsApi: new __WEBPACK_IMPORTED_MODULE_6__api_Segments__["a" /* default */](),
      segment: null,
      segmentOriginal: null,
      segmentSave: null,
      changesPending: false,
      loading: false,
      sendBusinessKitModalOpen: false,
      addToProjectModalOpen: false,
      contactIds: [],
      totalTableCount: 0,
      selectedItems: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return _this.segmentsApi.getSegment(_this.id);

            case 3:
              _this.segment = _context.sent;

              _this.segmentOriginal = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.segment));
              _this.segmentSave = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.segment));

              __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setSecondaryHeaderTabs({});
              _this.setHeaderButtons();

              __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setTitle({ label: _this.segment.name });

              __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setBreadcrumbs([{
                label: 'ui.segment.breadcrumb_back',
                link: { name: "segments" }
              }]);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    activateBusinessKitModalCb: function activateBusinessKitModalCb(ids) {
      if (this.changesPending) {
        this.$store.commit("SET_NOTIFICATION", {
          title: "ui.segments.is_editing_state",
          type: "error"
        });
        return;
      }

      this.contactIds = ids;
      this.sendBusinessKitModalOpen = true;
    },
    activateAddToProjectModalCb: function activateAddToProjectModalCb(ids) {
      if (this.changesPending) {
        this.$store.commit("SET_NOTIFICATION", {
          title: "ui.segments.is_editing_state",
          type: "error"
        });
        return;
      }

      this.contactIds = ids;
      this.addToProjectModalOpen = true;
    },
    closeBusinessKitModal: function closeBusinessKitModal() {
      this.sendBusinessKitModalOpen = false;
    },
    closeAddToProjectModal: function closeAddToProjectModal() {
      this.addToProjectModalOpen = false;
    },
    setHeaderButtons: function setHeaderButtons() {
      __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setHeaderButtons([{
        name: "savesegment",
        action: "segments.save",
        classes: "btn-primary",
        disabled: this.changesPending == false || this.selectedItems.length != 0,
        function: this.saveSegment
      }]);
    },
    selectedItemsChange: function selectedItemsChange(items) {
      this.selectedItems = items;
      this.setHeaderButtons();
    },
    updateFilters: function updateFilters(filters) {
      this.segmentSave.filters = filters;
      this.segmentSave = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.segmentSave));
    },
    updateSearch: function updateSearch(searchkeywords) {
      this.segmentSave.search = searchkeywords;
      this.segmentSave = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.segmentSave));
    },
    saveSegment: function saveSegment() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.segmentsApi.updateSegment(_this2.id, _this2.segmentSave);

              case 2:
                _this2.segment = _context2.sent;

                _this2.segmentOriginal = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.segment));
                _this2.segmentSave = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.segment));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchDataComplete: function fetchDataComplete() {
      this.loading = false;
    },
    emitTotalTableCount: function emitTotalTableCount(totalTableCount) {
      this.totalTableCount = totalTableCount;
    }
  },
  watch: {
    segmentSave: {
      handler: function handler() {
        // Check if any changes have been made
        this.changesPending = _.isEqual(this.segmentSave, this.segmentOriginal) == false;

        // Re-render the header buttons so that we disable the save button if no chanegs have been made
        this.setHeaderButtons();
      }
    }
  }
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_XTable__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_XTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_XTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Segments__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_NewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_Specific_Loading_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_helpers_Specific_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_helpers_Specific_Loading_vue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { XTable: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_XTable___default.a, Modal: __WEBPACK_IMPORTED_MODULE_5__components_helpers_Layout_NewModal___default.a, Field: __WEBPACK_IMPORTED_MODULE_6__components_helpers_DataInput_Field___default.a, Loading: __WEBPACK_IMPORTED_MODULE_9__components_helpers_Specific_Loading_vue___default.a },
  data: function data() {
    return {
      segmentApi: new __WEBPACK_IMPORTED_MODULE_4__api_Segments__["a" /* default */](),
      loading: false,
      pageLoading: true,
      totalCount: 0,
      defaultPagination: {
        sortBy: 'name',
        descending: false
      },
      currentSegment: null,
      deleteSegmentModalOpen: false,
      segments: [],
      duplicateSegmentModalOpen: false,
      duplicateSegmentName: '',
      duplicateSegmentSource: null,
      columns: [{
        name: "name",
        field: function field(segment) {
          return segment.name;
        },
        label: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.columns.name'),
        required: true,
        isSticky: true,
        isBold: true
      }, {
        name: "id",
        label: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.columns.id'),
        field: function field(contact) {
          return contact.id;
        },
        credentials: "root",
        hideByDefault: true
      }, {
        name: "creator",
        field: function field(segment) {
          return segment["user"].firstname;
        },
        label: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.columns.creator')
      }, {
        name: "created_at",
        field: function field(segment) {
          return segment.created_at;
        },
        label: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.columns.created'),
        type: "dateTime"
      }, {
        name: "updated_at",
        field: function field(segment) {
          return segment.updated_at;
        },
        type: "dateTime",
        label: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.columns.updated')
      }],
      actions: [{
        name: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.actions.edit'),
        description: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.actions.edit_description'),
        icon: 'yule-icon-edit',
        function: this.actionEdit
      }, {
        name: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.actions.duplicate'),
        description: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.actions.duplicate_description'),
        icon: 'yule-icon-duplicate',
        function: this.actionDuplicate
      }, {
        name: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.actions.delete'),
        description: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].t('ui.segments.actions.delete_description'),
        icon: 'yule-icon-trash',
        function: this.actionDelete
      }]
    };
  },
  beforeMount: function beforeMount() {
    this.pageLoading = true;
  },
  destroyed: function destroyed() {
    this.currentSegment = null;
  },
  mounted: function mounted() {
    this.currentSegment = null;

    __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setPageLevel("2");
    __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setSecondaryHeaderTabs({});
    __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setTitle({ label: "ui.pages.segments" });
    __WEBPACK_IMPORTED_MODULE_7__classes_Ui__["a" /* default */].setHeaderButtons([{
      name: "segment",
      action: "segments.new",
      classes: "btn-primary"
    }]);

    this.fetchData();
  },

  methods: {
    actionDelete: function actionDelete() {
      var _this = this;

      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(ids.length != 1)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                id = ids[0];


                _this.currentSegment = _this.segments.find(function (segment) {
                  return segment.id == id;
                });

                _this.openDeleteSegmentModal();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    deleteSegment: function deleteSegment() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.segmentApi.deleteSegment(_this2.currentSegment.id);

              case 2:
                _this2.fetchData();
                _this2.closeDeleteSegmentModal();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    actionDuplicate: function actionDuplicate() {
      var _this3 = this;

      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(ids.length != 1)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                id = ids[0];


                _this3.duplicateSegmentSource = null;
                _this3.segments.forEach(function (segment) {
                  if (segment.id == id) {
                    _this3.duplicateSegmentSource = segment;
                  }
                });

                if (!(_this3.duplicateSegmentSource == null)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return");

              case 7:

                _this3.duplicateSegmentName = _this3.$t('ui.segments.actions.duplicate_name', { name: _this3.duplicateSegmentSource.name });

                _this3.openDuplicateSegmentModal();

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    actionEdit: function actionEdit() {
      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var id = null;
      if (Array.isArray(ids)) {
        if (ids.length != 1) {
          return;
        }
        id = ids[0];
      } else {
        id = ids;
      }
      this.$router.push({ name: 'segment_edit', params: { id: id } });
    },
    updatePagination: function updatePagination(pagination) {
      // We just respond to the updatePagination event so that we
      // get the whole default pagination, including any XTable defaults
      this.defaultPagination = pagination;
    },
    openDuplicateSegmentModal: function openDuplicateSegmentModal() {
      this.duplicateSegmentModalOpen = true;
    },
    closeDuplicateSegmentModal: function closeDuplicateSegmentModal() {
      this.duplicateSegmentModalOpen = false;
    },
    openDeleteSegmentModal: function openDeleteSegmentModal() {
      this.deleteSegmentModalOpen = true;
    },
    closeDeleteSegmentModal: function closeDeleteSegmentModal() {
      this.deleteSegmentModalOpen = false;
      this.currentSegment = null;
    },
    duplicateSegment: function duplicateSegment() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var newSegment, resource;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                newSegment = {
                  name: _this4.duplicateSegmentName,
                  filters: _this4.duplicateSegmentSource.filters,
                  search: _this4.duplicateSegmentSource.search
                };
                _context4.next = 3;
                return _this4.segmentApi.createSegment(newSegment);

              case 3:
                resource = _context4.sent;


                _this4.closeDuplicateSegmentModal();

                _this4.$router.push({ name: 'segment_edit', params: { id: resource.id } });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    fetchData: function fetchData() {
      var _this5 = this;

      var fetchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var request, requestResponse;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // Build the API request
                request = {
                  search: '',
                  page: _this5.defaultPagination.page,
                  per_page: _this5.defaultPagination.rowsPerPage,
                  sort_by: _this5.defaultPagination.sortBy,
                  sort_order: _this5.defaultPagination.descending ? 'DESC' : 'ASC'
                };


                if (fetchParams.searchKeywords) {
                  request.search = fetchParams.searchKeywords;
                }

                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(fetchParams.pagination) == 'object' && fetchParams.pagination) {
                  request.per_page = fetchParams.pagination.rowsPerPage;
                  request.sort_by = fetchParams.pagination.sortBy;
                  request.sort_order = fetchParams.pagination.descending ? 'DESC' : 'ASC';
                }

                _this5.loading = true;

                // Make the request
                requestResponse = null;
                _context5.prev = 5;
                _context5.next = 8;
                return _this5.segmentApi.getSegments(request);

              case 8:
                requestResponse = _context5.sent;

              case 9:
                _context5.prev = 9;

                _this5.loading = false;
                _this5.pageLoading = false;
                return _context5.finish(9);

              case 13:

                // Display both the returned contacts page and the total number of contacts
                _this5.segments = requestResponse.data.resources;
                _this5.totalCount = requestResponse.data.total_results;

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[5,, 9, 13]]);
      }))();
    }
  }
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_Statistic_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_Collection__ = __webpack_require__(62);
//
//
//
//
//




var structure = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_Collection__["a" /* collectionMixin */]],
  data: function data() {
    return {
      model: "statistics",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_Statistic_js__["a" /* default */](),
      collectionData: structure,
      button: ''
    };
  }
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_User__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Organization__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: {}
  },
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DataInput_Field___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_helpers_Layout_NewModal___default.a
  },
  data: function data() {
    return {
      isOpen: false,
      errors: [],
      item: {},
      organizations: [],
      roles: [{ name: 'user', value: 'user' }, { name: 'admin', value: 'admin' }]
    };
  },

  computed: {
    modalTitle: function modalTitle() {
      return this.$t('ui.users.invite');
    },
    modalSaveText: function modalSaveText() {
      return this.$t('ui.button.users.invite');
    }
  },
  mounted: function mounted() {
    this.item.status = "confirmed";
    this.retrieve_associations();
    __WEBPACK_IMPORTED_MODULE_5__EventBus_js__["a" /* EventBus */].$on('action', this.handleAction);
  },

  methods: {
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.errors = [];
                user = new __WEBPACK_IMPORTED_MODULE_3__api_User__["a" /* default */]();

                if (_this.item.lastname == undefined) {
                  _this.item.lastname = " ";
                }
                if (_this.item.firstname == undefined) {
                  _this.item.firstname = " ";
                }
                // the API needs the organization_id param so setting this here
                if (_this.item.organization_id == undefined && _this.item.organization) {
                  _this.item.organization_id = _this.item.organization;
                }
                _context.prev = 5;
                _context.next = 8;
                return user.invite(_this.item, _this.$i18n.locale);

              case 8:
                response = _context.sent;

                _this.item = {};
                _this.isOpen = false;
                _this.handleSuccess(response);
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](5);

                _this.errors = _context.t0.response.data.errors;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 14]]);
      }))();
    },
    handleSuccess: function handleSuccess(user) {
      this.$store.commit('SET_NOTIFICATION', {
        'title': this.$t('models.user.message.create'),
        'type': 'success'
      });
      this.$emit('user_invited', user);
    },
    handleAction: function handleAction(action) {
      this.isOpen = action == "users.invite";
    },
    cancel: function cancel() {
      this.isOpen = false;
    },
    retrieve_associations: function retrieve_associations() {
      var _this2 = this;

      var permission = __WEBPACK_IMPORTED_MODULE_6__classes_Permission__["a" /* default */].loadPermissions();

      if (__WEBPACK_IMPORTED_MODULE_6__classes_Permission__["a" /* default */].can(permission, 'organizations.list')) {
        var api = new __WEBPACK_IMPORTED_MODULE_4__api_Organization__["a" /* default */]();
        api.all_for_association().then(function (items) {
          _this2.organizations = items;
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_User_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Organization_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_SensualBadge__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_SensualBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_SensualBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserImage__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserImage__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_Update__["a" /* updateMixin */]],
  components: {
    SensualBadge: __WEBPACK_IMPORTED_MODULE_4__components_helpers_DataDisplay_SensualBadge___default.a,
    UserImage: __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserImage___default.a
  },
  data: function data() {
    return {
      model: "users",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_User_js__["a" /* default */](),
      organizations: []
    };
  },
  mounted: function mounted() {
    this.retrieve_organizations();
    __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].clearHeaderButtons();
  },

  methods: {
    retrieve_organizations: function retrieve_organizations() {
      var _this = this;

      var permission = __WEBPACK_IMPORTED_MODULE_3__classes_Permission__["a" /* default */].loadPermissions();
      if (__WEBPACK_IMPORTED_MODULE_3__classes_Permission__["a" /* default */].can(permission, 'organizations.list')) {
        var api = new __WEBPACK_IMPORTED_MODULE_1__api_Organization_js__["a" /* default */]();
        api.all_for_association('name').then(function (items) {
          _this.organizations = items;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    },
    userData: function userData() {
      if (this.currentUser.email == "unknown") {
        return null;
      } else {
        if (this.currentUser.firstname == "" && this.currentUser.lastname == "" || !this.currentUser.firstname && !this.currentUser.lastname) {
          return this.currentUser.email;
        } else {
          return this.currentUser.firstname + ' ' + this.currentUser.lastname;
        }
      }
    },
    userInitials: function userInitials() {
      if (this.currentUser.email == "unknown") {
        return '?';
      } else {
        if (this.currentUser.firstname == "" || this.currentUser.lastname == "" || !this.currentUser.firstname || !this.currentUser.lastname) {
          return '?';
        } else {
          return '' + this.currentUser.firstname.charAt(0) + this.currentUser.lastname.charAt(0);
        }
      }
    }
  },
  watch: {
    'item.firstname': function itemFirstname(firstName) {
      this.$store.commit('SET_CURRENT_USER_FIRSTNAME', firstName);
    },
    'item.lastname': function itemLastname(lastName) {
      this.$store.commit('SET_CURRENT_USER_LASTNAME', lastName);
    }
  },

  computed: {
    currentUser: {
      get: function get() {
        return this.$store.getters.currentUser;
      }
    },

    firstName: {
      get: function get() {
        return this.$store.getters.currentUser.firstname;
      },
      set: function set(value) {
        this.item.firstname = value;
      }
    },
    lastName: {
      get: function get() {
        return this.$store.getters.currentUser.lastname;
      },
      set: function set(value) {
        this.item.lastname = value;
      }
    }
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_User_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Organization_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_UserStatusSelect__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_UserStatusSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_UserStatusSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_Specific_UserRoleSelect__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_Specific_UserRoleSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_Specific_UserRoleSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Ui__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_Update__["a" /* updateMixin */]],
  components: { UserStatusSelect: __WEBPACK_IMPORTED_MODULE_2__components_helpers_Specific_UserStatusSelect___default.a, UserRoleSelect: __WEBPACK_IMPORTED_MODULE_3__components_helpers_Specific_UserRoleSelect___default.a },
  data: function data() {
    return {
      model: "users",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_User_js__["a" /* default */](),
      organizations: []
    };
  },

  methods: {
    retrieve_organizations: function retrieve_organizations() {
      var _this = this;

      var permission = __WEBPACK_IMPORTED_MODULE_4__classes_Permission__["a" /* default */].loadPermissions();

      if (__WEBPACK_IMPORTED_MODULE_4__classes_Permission__["a" /* default */].can(permission, 'organizations.list')) {
        var api = new __WEBPACK_IMPORTED_MODULE_1__api_Organization_js__["a" /* default */]();
        api.all_for_association('name').then(function (items) {
          _this.organizations = items;
        }).catch(function (error) {
          console.log(error.response);
        });
      }
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_6__classes_Ui__["a" /* default */].clearHeaderButtons();
    this.retrieve_organizations();
  }
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_UploadField__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_UploadField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_UploadField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_User__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UploadField: __WEBPACK_IMPORTED_MODULE_0__components_helpers_DataInput_UploadField___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_helpers_Layout_NewModal___default.a
  },
  data: function data() {
    return {
      file: null,
      error: '',
      isOpen: false
    };
  },

  computed: {
    modalSaveText: function modalSaveText() {
      return this.$t('ui.button.users.upload_xls');
    },
    modalTitle: function modalTitle() {
      return this.$t('ui.users.xls_invite');
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__EventBus_js__["a" /* EventBus */].$on('action', this.handleAction);
  },

  methods: {
    fileChange: function fileChange(payload) {
      this.file = payload;
      this.error = '';
    },
    fileUpload: function fileUpload() {
      var _this = this;

      var formData = new FormData();
      formData.append('xls_file', this.file);
      var user = new __WEBPACK_IMPORTED_MODULE_1__api_User__["a" /* default */]();
      user.inviteXls(formData, this.$i18n.locale).then(function (response) {
        _this.$store.commit('SET_NOTIFICATION', {
          'title': 'ui.users.invite_xls_success',
          'type': 'success'
        });
        _this.isOpen = false;
        _this.error = '';
        __WEBPACK_IMPORTED_MODULE_2__EventBus_js__["a" /* EventBus */].$emit('action', 'user_invited');
      }).catch(function (e) {
        _this.error = _this.$t("errors.users.xls_import.wrong_file");
        _this.$store.commit('SET_NOTIFICATION', {
          'title': _this.error,
          'type': 'error'
        });
      });
    },
    handleAction: function handleAction(action) {
      if (action == "users.invite_xls") {
        this.error = '';
        this.isOpen = true;
      }
    },
    cancel: function cancel() {
      this.isOpen = false;
      this.error = '';
    }
  }
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_User__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_Collection__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_users_UserInvite__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_users_UserInvite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_users_UserInvite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_users_UserXlsInvite__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_users_UserXlsInvite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_users_UserXlsInvite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserRoleSelect__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserRoleSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserRoleSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layouts_partials_Searchbar_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layouts_partials_Searchbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_layouts_partials_Searchbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_GeneralListing__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_GeneralListing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_GeneralListing__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var structure = [{ name: 'id', credentials: "is_root" }, { name: 'firstname', sortable: true }, { name: 'lastname', sortable: true }, { name: 'email', type: 'valid_email', sortable: true }, { name: 'role', credentials: 'admin' }, { name: 'created_at', type: 'date' }, { name: 'status', type: 'status' }, { name: 'organization.name', sortable: true, credentials: 'root', alias: 'organization_name' }, { name: 'action', type: 'crud_action_folded', exclude: ['show', 'duplicate'] }];

var default_sort_by = "id";
var default_sort_order = "DESC";
var default_filters = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_Collection__["a" /* collectionMixin */]],
  components: {
    UserInvite: __WEBPACK_IMPORTED_MODULE_4__components_pages_users_UserInvite___default.a,
    UserInviteXls: __WEBPACK_IMPORTED_MODULE_5__components_pages_users_UserXlsInvite___default.a,
    UserRoleSelect: __WEBPACK_IMPORTED_MODULE_6__components_helpers_Specific_UserRoleSelect___default.a,
    Searchbar: __WEBPACK_IMPORTED_MODULE_7__components_layouts_partials_Searchbar_vue___default.a,
    GeneralListing: __WEBPACK_IMPORTED_MODULE_8__components_helpers_Specific_GeneralListing___default.a
  },
  data: function data() {
    return {
      model: "users",
      api: new __WEBPACK_IMPORTED_MODULE_0__api_User__["a" /* default */](),
      collectionData: structure,
      title: "ui.pages.users",
      loading: false,
      query: {},
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_USERS',
        routerName: 'users',
        emptyState: 'users',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.page != __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].getCurrentPageUsers()) {
      this.goToPage(__WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].getCurrentPageUsers());
    }
    __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setSecondaryHeaderTabs({});
    __WEBPACK_IMPORTED_MODULE_1__classes_Ui__["a" /* default */].setHeaderButtons([{ name: "users_xls", action: "users.invite_xls", classes: "btn-tertiary", icon: "" }, { name: "users", action: "users.invite", classes: "btn-primary", icon: "" }]);
    // reload when a user is invited
    __WEBPACK_IMPORTED_MODULE_2__EventBus_js__["a" /* EventBus */].$on('action', function (payload) {
      if (payload == 'user_invited') {
        _this.retrieve();
      }
    });
  },
  created: function created() {
    //  In case we generate a query, we create it before to be able to retrieve it in collection and display the specific list.
    this.initQuery();
  },

  methods: {
    emailError: function emailError() {
      if (!this.has_valid_email) {
        document.getElementsByClassName("user-email").className += "warning-email";
      }
    }
  }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventBus__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataInput_Field__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataInput_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helpers_DataInput_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Project__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Organization__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_Permission__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Workflow__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Layout_NewModal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpers_Layout_NewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpers_Layout_NewModal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_1__helpers_DataInput_Field___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_helpers_Layout_NewModal___default.a
  },
  data: function data() {
    return {
      isOpen: false,
      item: {},
      errors: [],
      projects: [],
      organizations: [],
      workflowScope: 'organization',
      workflowScopes: [{ name: 'organization', value: 'organization' }, { name: 'project', value: 'project' }]
    };
  },

  computed: {
    modalTitle: function modalTitle() {
      return this.$t('ui.modals.workflow.create.title');
    },

    isRoot: {
      get: function get() {
        return this.$store.getters.getCurrentUserIsRoot;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__EventBus__["a" /* EventBus */].$off('action');
    __WEBPACK_IMPORTED_MODULE_0__EventBus__["a" /* EventBus */].$on('action', this.handleAction);
    this.retrieve_projects();
    this.retrieve_organizations();
    __WEBPACK_IMPORTED_MODULE_0__EventBus__["a" /* EventBus */].$on('open', function (open) {
      _this.isOpen = true;
    });
  },

  methods: {
    create: function create() {
      var _this2 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_5__api_Workflow__["a" /* default */]();
      var item = this.initItem(this.item);

      api.post(item).then(function (item) {
        _this2.$store.commit('SET_NOTIFICATION', {
          'title': 'models.workflow.message.create',
          'type': 'success'
        });
        _this2.$router.push({ name: 'workflow_edit', params: { id: item.id } });
      }).catch(function (e) {
        _this2.errors = e.response.data.errors;
      });
    },
    initItem: function initItem(item) {
      item.execute_on = {};
      item.configuration = {};
      return item;
    },
    handleAction: function handleAction(action) {
      this.isOpen = action == 'workflow.add_popup';
    },
    retrieve_projects: function retrieve_projects() {
      var _this3 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_2__api_Project__["a" /* default */]();
      api.all_for_association('name', { sort_by: 'name', sort_order: 'DESC' }).then(function (items) {
        _this3.projects = items;
      }).catch(function (error) {
        console.log(error);
      });
    },
    retrieve_organizations: function retrieve_organizations() {
      var _this4 = this;

      var permission = __WEBPACK_IMPORTED_MODULE_4__classes_Permission__["a" /* default */].loadPermissions();

      if (__WEBPACK_IMPORTED_MODULE_4__classes_Permission__["a" /* default */].can(permission, "organizations.list")) {
        var api = new __WEBPACK_IMPORTED_MODULE_3__api_Organization__["a" /* default */]();
        api.all_for_association().then(function (items) {
          _this4.organizations = items;
        }).catch(function (error) {});
      }
    },
    cancel: function cancel() {
      this.isOpen = false;
    },
    open: function open() {
      this.isOpen = true;
    }
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Workflow__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Project__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_Update__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_data_frequencies__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_data_hours__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_datetimepicker__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_datetimepicker__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__components_mixins_Update__["a" /* updateMixin */]],
  components: {
    datetime: __WEBPACK_IMPORTED_MODULE_10_vuejs_datetimepicker___default.a
  },
  computed: {
    executeOn: function executeOn() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.item.execute_on);
    },
    configuration: function configuration() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.item.configuration);
    },

    firstRun: {
      get: function get() {
        return moment(this.item.first_run).format("DD/MM/YYYY HH:mm:ss");
      },
      set: function set(value) {
        this.item.first_run = moment(value, 'DD/MM/YYYY HH:mm:ss').toDate();
      }
    },
    finalRun: {
      get: function get() {
        return moment(this.item.final_run).format("DD/MM/YYYY HH:mm:ss");
      },
      set: function set(value) {
        this.item.final_run = moment(value, 'DD/MM/YYYY HH:mm:ss').toDate();
      }
    },
    shouldShowDailyRuntime: function shouldShowDailyRuntime() {
      return this.item.frequency === 'daily';
    }
  },
  data: function data() {
    return {
      api: new __WEBPACK_IMPORTED_MODULE_3__api_Workflow__["a" /* default */](),
      model: "workflows",
      projects: [],
      temporaryProjectId: Number,
      frequencies: __WEBPACK_IMPORTED_MODULE_8__config_data_frequencies__["a" /* default */],
      hours: __WEBPACK_IMPORTED_MODULE_9__config_data_hours__["a" /* default */],
      workflowScope: 'organization',
      workflowScopes: [{ name: 'organization', value: 'organization' }, { name: 'project', value: 'project' }],
      headerButtons: [{ name: "workflow_trigger", action: "workflows.trigger", classes: "btn-primary", icon: "", debounce: 30000 }]
    };
  },
  mounted: function mounted() {
    this.setupHeader();
    this.retrieve_projects();
    __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].$off('action');
    __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].$on('action', this.trigger);
  },

  methods: {
    setupHeader: function setupHeader() {
      __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].setHeaderButtons(this.headerButtons);
      __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].setSubtitle({
        link: {
          name: "workflows"
        }
      });
      __WEBPACK_IMPORTED_MODULE_4__classes_Ui__["a" /* default */].setPageLevel(3);
    },
    trigger: function trigger(payload) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(payload == 'workflows.trigger')) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this.api.trigger(_this.$route.params.id);

              case 4:
                data = _context.sent;

                _this.$store.commit('SET_NOTIFICATION', {
                  'title': 'models.workflow.message.trigger_success',
                  'type': 'success'
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                _this.$store.commit('SET_NOTIFICATION', {
                  'title': 'models.workflow.message.trigger_failed',
                  'type': 'error'
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    retrieve_projects: function retrieve_projects() {
      var _this2 = this;

      var api = new __WEBPACK_IMPORTED_MODULE_5__api_Project__["a" /* default */]();
      api.all_for_association('name', { sort_by: 'updated_at', sort_order: 'DESC' }).then(function (items) {
        _this2.projects = items;
      }).catch(function (error) {
        console.log(error);
      });
    },
    executeOnChange: function executeOnChange(val) {
      try {
        this.item.execute_on = JSON.parse(val);
        this.errors = [];
      } catch (e) {
        this.errors.push({ code: "lead_mask.json.invalid", field_name: "execute_on" });
      }
    },
    configurationChange: function configurationChange(val) {
      try {
        this.item.configuration = JSON.parse(val);
        this.errors = [];
      } catch (e) {
        this.errors.push({ code: "lead_mask.json.invalid", field_name: "configuration" });
      }
    }
  },
  watch: {
    'item.project_id': function itemProject_id() {
      if (this.item.project_id) {
        // remember project id in case we switch scope to organization and back again to project
        this.temporaryProjectId = this.item.project_id;
        this.workflowScope = 'project';
      }
    },
    workflowScope: function workflowScope() {
      // reset project_id
      if (this.workflowScope === 'organization') {
        this.item.project_id = null;
      }
      if (this.workflowScope === 'project') {
        this.item.project_id = this.temporaryProjectId;
      }
    }
  }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Workflow__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventBus_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_Ui__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WorkflowCreate__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WorkflowCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__WorkflowCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_Collection__ = __webpack_require__(62);


//
//
//
//
//
//
//








var structure = [{ name: 'id', sortable: true, credentials: 'root' }, { name: 'name', type: 'show_with_edit_link', title: 'Name', sortable: true }, { name: 'status', sortable: true }, { name: 'last_execution', type: 'date', time: true, title: 'Last execution', sortable: true }, { name: 'frequency', type: 'show', i18n: true, title: 'Frequency', sortable: true }, { name: 'daily_runtime', type: 'show', title: 'Daily runtime', sortable: true }, { name: 'final_run', type: 'date', time: true, title: 'Final run', sortable: true }, { name: 'project.name', sortable: true, credentials: 'root', alias: 'project_name' }, { name: 'action', type: 'crud_action_folded', credentials: 'admin' }];

var default_sort_by = "id";
var default_sort_order = "DESC";
var default_filters = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__components_mixins_Collection__["a" /* collectionMixin */]],
  components: {
    WorkflowCreate: __WEBPACK_IMPORTED_MODULE_6__WorkflowCreate___default.a,
    Collection: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DataDisplay_Collection___default.a
  },
  data: function data() {
    return {
      loading: false,
      collectionData: structure,
      model: 'workflows',
      api: new __WEBPACK_IMPORTED_MODULE_2__api_Workflow__["a" /* default */](),
      title: 'ui.pages.workflows',
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_WORKFLOWS',
        routerName: 'workflows',
        emptyState: 'workflows',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$off('workflow_duplicate');
    __WEBPACK_IMPORTED_MODULE_4__EventBus_js__["a" /* EventBus */].$on('workflow_duplicate', this.duplicate);
    __WEBPACK_IMPORTED_MODULE_5__classes_Ui__["a" /* default */].setHeaderButtons([{ name: "workflow", action: "workflow.add_popup", classes: "btn-primary" }]);
  },

  methods: {
    duplicate: function duplicate(payload) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, newWorkflow, route;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.api.duplicate(payload.id);

              case 2:
                data = _context.sent;
                newWorkflow = data.resource;
                route = { name: 'workflow_edit', params: { id: newWorkflow.id } };

                _this.$router.push(route);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_Session__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_config__ = __webpack_require__(83);










var sendoutsApi = function (_Api) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(sendoutsApi, _Api);

  function sendoutsApi() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "v2";

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, sendoutsApi);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (sendoutsApi.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(sendoutsApi)).call(this, version));

    var jwt = __WEBPACK_IMPORTED_MODULE_7__classes_Session__["a" /* default */].getJwtCookie();

    _this.http = __WEBPACK_IMPORTED_MODULE_6_axios___default.a.create({
      baseURL: __WEBPACK_IMPORTED_MODULE_8__config_config__["a" /* apiUrl */] + version + "/",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (jwt === undefined) {
      __WEBPACK_IMPORTED_MODULE_7__classes_Session__["a" /* default */].logout();
      jwt = "";
    } else {
      _this.set_jwt(jwt);
    }
    _this.page_length = 25;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(sendoutsApi, [{
    key: "sendEmail",
    value: function sendEmail() {
      return this.http.post("users/project_allocation_reminder");
    }
  }]);

  return sendoutsApi;
}(__WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (sendoutsApi);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DragNDrop_DragContainer__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_DragNDrop_DragContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_helpers_DragNDrop_DragContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_EditorDragItem__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_EditorDragItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_EditorDragItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DragNDrop_DragActiveItemContainer__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_helpers_DragNDrop_DragActiveItemContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_helpers_DragNDrop_DragActiveItemContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DragNDrop_DragTabContainer__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_helpers_DragNDrop_DragTabContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_helpers_DragNDrop_DragTabContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DragNDrop_DragSubmitButton__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_helpers_DragNDrop_DragSubmitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_helpers_DragNDrop_DragSubmitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_Drag__ = __webpack_require__(179);








/*
 * Automatically add required functionality for drag'n'drop
 * Import mixin into component, pass a structure, and start using drag components.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    structure: {
      type: Array,
      required: true
    },
    // Array of elements that can be dropped into editor.
    // Should be an array containing Objects. Each Object
    // must have a title and an items Array
    dragElements: {
      type: Array,
      required: true
    },
    defaultElements: {
      type: Array
    },
    // Used for example for lead sheet elements
    extraElements: {
      type: Array
    },
    projectId: {
      required: false
    },
    showTabs: {
      type: Boolean,
      default: false
    },
    shouldIncludeSubmit: {
      // Include a submit button outside the normal editor that cannot be moved but can be edited.
      // Also removed any existing submit buttons in structure.
      type: Boolean,
      default: false
    }
  },
  components: {
    DragContainer: __WEBPACK_IMPORTED_MODULE_1__components_helpers_DragNDrop_DragContainer___default.a,
    DragActiveItemContainer: __WEBPACK_IMPORTED_MODULE_3__components_helpers_DragNDrop_DragActiveItemContainer___default.a,
    DragTabContainer: __WEBPACK_IMPORTED_MODULE_4__components_helpers_DragNDrop_DragTabContainer___default.a,
    DragSubmitButton: __WEBPACK_IMPORTED_MODULE_5__components_helpers_DragNDrop_DragSubmitButton___default.a,
    EditorDragItem: __WEBPACK_IMPORTED_MODULE_2__components_helpers_DragNDrop_EditorDragItem___default.a
  },
  data: function data() {
    return {
      internalDragElements: [],
      internalTabs: [],
      internalElementsToRemove: ["submit", "grid_container", "container_top", "container_bottom", "container_grid", "container_tab", "container"],
      defaultTabElement: {
        element_type: "container_tab",
        parent_element: "root",
        name: "main_tab",
        label: "Tab 1"
      }
    };
  },

  computed: {
    internalStructure: {
      get: function get() {
        return this.$store.getters.getDragEditorCurrentStructure;
      },
      set: function set(val) {
        this.$store.commit("SET_DRAG_EDITOR_CURRENT_STRUCTURE", val);
      }
    },
    internalSubmitButton: {
      get: function get() {
        return this.$store.getters.getDragEditorSubmitButton;
      },
      set: function set(val) {
        this.$store.commit("SET_DRAG_EDITOR_SUBMIT_BUTTON", val);
      }
    },
    activeTab: function activeTab() {
      var activeTab = this.$store.getters.getDragEditorActiveTab;
      if (activeTab) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(activeTab).length > 0) {
          return activeTab;
        } else {
          // Fall back to first tab
          return this.internalTabs[0];
        }
      }
    },
    internalStructureByTab: function internalStructureByTab() {
      var _this = this;

      if (!this.activeTab) {
        return this.internalStructure;
      }
      return this.internalStructure.filter(function (element) {
        return element.tab === _this.activeTab.name;
      });
    }
  },
  mounted: function mounted() {
    this.setupTabs();
    this.resetInternalStructure();
    this.setupDragElements();

    if (this.shouldIncludeSubmit) {
      this.setupSubmit();
    }
  },

  methods: {
    setupDragElements: function setupDragElements() {
      var _this2 = this;

      // Build internalDragElements from the ones received through props
      // Filter and set internally required values
      this.internalDragElements = [];
      this.dragElements.forEach(function (object) {
        // building the dynamic elements for the editor which come from the lead sheet
        if (!Array.isArray(object) && object.shouldBeFiltered) {
          var items = object.items;
          _this2.internalDragElements.push({
            title: object.title,
            items: _this2.buildElements(items, true)
          });

          // building the standard elements
        } else {
          object.forEach(function (itemGroup) {
            _this2.internalDragElements.push({
              title: itemGroup.title,
              items: _this2.buildElements(itemGroup.items, false)
            });
          });
        }
      });
    },
    setupTabs: function setupTabs() {
      // Find all tabs in structure and setup internaltabs
      var tabs = _.clone(this.structure).filter(function (e) {
        return e.element_type === "container_tab";
      });
      this.setTabs(tabs);
    },
    setupSubmit: function setupSubmit() {
      // Find existing submit button if present in structure and move it outside the editor itself
      var existingSubmit = this.structure.find(function (e) {
        return ["submit", "submit_button"].includes(e.element_type);
      });
      if (existingSubmit) {
        existingSubmit.element_type = "submit";
        existingSubmit.parent_element = this.activeTab.name;
        this.internalSubmitButton = existingSubmit;
      } else {
        this.internalSubmitButton = __WEBPACK_IMPORTED_MODULE_6__classes_Drag__["a" /* default */].generateDefaultSubmitButton();
      }
    },
    editElement: function editElement(element) {
      var e = this.findElementByPositionAndName(element);
      var idx = this.internalStructure.indexOf(e);
      this.internalStructure[idx] = element;
      this.setIsEdited();
    },
    deleteElement: function deleteElement(element) {
      var e = this.findElementByPositionAndName(element);
      var idx = this.internalStructure.indexOf(e);

      // remove tab and parent_element from element
      if (element.tab) {
        delete element.parent_element;
        delete element.tab;
      }

      // if this element is a tab remove the tab and all elements that belong to it
      if (this.showTabs && element.element_type == "container_tab" && element.parent_element == "root") {
        return this.deleteTabAndBelongingElements(element);
      }

      // for other elements
      if (idx === -1) {
        throw "Element was not found in internalStructure";
      }

      this.spliceInternalStructure(idx, 1);
      if (element.shouldBeDeleted && this.internalDragElements) {
        var dragElements = this.internalDragElements.find(function (object) {
          return object.title === element.parentTitle;
        });
        if (dragElements) {
          dragElements.items.push(element);
        }
      }
    },
    deleteTabAndBelongingElements: function deleteTabAndBelongingElements(element) {
      var newStructure = _.cloneDeep(this.internalStructure);
      var newTabs = _.cloneDeep(this.internalTabs);

      // Remove all elements that belong to the Tab
      var internalStructureOnTab = newStructure.filter(function (t) {
        return t.tab === element.name;
      });
      internalStructureOnTab.forEach(function (e) {
        _.remove(newStructure, e);
      });
      this.internalStructure = newStructure;

      var tab = newTabs.find(function (t) {
        return t.name === element.name;
      });
      _.remove(newTabs, tab);
      this.internalTabs = newTabs;
    },
    findElementByPositionAndName: function findElementByPositionAndName(element) {
      return this.internalStructure.find(function (e) {
        return e.tab === element.tab && e.name === element.name && e.element_type === element.element_type;
      });
    },
    setTabs: function setTabs(tabs) {
      // Clear tabs and set to what it passed as argument or defaultTab
      var tabArray = [];
      if (tabs.length > 0) {
        tabs.forEach(function (tab) {
          tabArray.push(tab);
        });
      } else {
        // Push a default tab
        tabArray.push(this.defaultTabElement);
      }
      this.internalTabs = tabArray;
    },
    resetInternalStructure: function resetInternalStructure() {
      var _this3 = this;

      var cloneStructure = _.cloneDeep(this.structure);
      // Set correct tabs and then remove top/bottom elements
      cloneStructure.forEach(function (item, idx) {
        if (item.element_type === "submit_button") {
          return;
        }

        // We need some logic for assigning which tabs each element should go under.
        // An element can have another element as its parent_element. If this happens
        // we have to go further up to find the correct tab.
        item.tab = _this3.findTabInStructure(item, cloneStructure);

        item = _this3.sanitizeDragItem(item);
      });
      cloneStructure = this.removeElements(cloneStructure);

      this.internalStructure = cloneStructure;
    },
    sanitizeDragItem: function sanitizeDragItem(item) {
      if (!this.showTabs) {
        item = __WEBPACK_IMPORTED_MODULE_6__classes_Drag__["a" /* default */].sanitizeOldFormElements(item, this.internalTabs, this.activeTab);
      }
      if (item["class"] && item["class"].includes("hidden")) {
        item.hidden = true;
        item["class"] = item["class"].replace(/hidden/, "");
      }
      return item;
    },
    findTabInStructure: function findTabInStructure(item, structure) {
      // Return name of top most tab for item

      var parentElement = structure.find(function (element) {
        return element.name === item.parent_element;
      });

      if (!parentElement) {
        // We reached the top of the stack so fall back to first container
        return this.internalTabs[0].name;
      } else if (parentElement.element_type === "container_tab") {
        return parentElement.name;
      } else {
        return this.findTabInStructure(parentElement, structure);
      }
    },
    buildElements: function buildElements(array, belongsToLeadSheet) {
      var cloneArray = _.cloneDeep(array);
      cloneArray.forEach(function (item, idx) {
        item.belongsToLeadSheet = belongsToLeadSheet;
        // Make sure label is set
        if (!item.label && item.name) {
          item.label = item.name.replace(/_/g, " ");
        }
      });
      cloneArray = this.removeElements(cloneArray);
      return cloneArray;
    },
    removeElements: function removeElements(array) {
      var _this4 = this;

      // Remove the element if needed or assert that correct tab is set
      return array.filter(function (item) {
        return !_this4.internalElementsToRemove.includes(item.element_type);
      });
    },
    validateDrop: function validateDrop(dropResult) {
      var addedIndex = dropResult.addedIndex,
          removedIndex = dropResult.removedIndex,
          payload = dropResult.payload;

      // we have to overwrite the addedIndex and removedIndex if we are in tabs

      if (dropResult.payload.isInTab && dropResult.payload.collectionByTab) {
        var itemAddedInCollection = dropResult.payload.collectionByTab[addedIndex];

        if (itemAddedInCollection) {
          dropResult.addedIndex = dropResult.payload.collection.indexOf(itemAddedInCollection);
          dropResult.removedIndex = dropResult.payload.collection.indexOf(dropResult.payload);
        } else {
          // if there is no item added yet
          var _itemAddedInCollection = dropResult.payload;

          dropResult.addedIndex = dropResult.payload.collection.indexOf(_itemAddedInCollection);
          dropResult.removedIndex = dropResult.payload.collection.indexOf(dropResult.payload);
        }

        delete dropResult.payload.collectionByTab;
        delete dropResult.payload.isInTab;
      }

      // If addedIndex is null item was not dropped into editor
      // Also in Javascript !0 is true ...
      if (addedIndex != 0 && !addedIndex) {
        return false;
      }
      // Dropped in same position
      if (addedIndex === removedIndex) {
        return false;
      }
      return true;
    },
    onDrop: function onDrop(dropResult) {
      var canDrop = this.validateDrop(dropResult);
      if (!canDrop) {
        if (dropResult.payload) {
          delete dropResult.payload.collection;
          delete dropResult.payload.collectionIdx;
        }
        return;
      }

      // We have to clone the object otherwise we can have multiple objects
      // that share the same pointer and therefore get updated together
      var droppedItem = _.clone(dropResult.payload);
      // Remove item from start position and then add back into array at dropped position
      var startIdx = dropResult.addedIndex;

      if (droppedItem.shouldBeDeleted) {
        droppedItem = this.removeDroppedItemFromOrigin(dropResult);
        if (droppedItem.class && droppedItem.class.length > 0) {
          droppedItem.class = "";
        }
      }

      if (!droppedItem.parent_element) {
        droppedItem.parent_element = this.activeTab.name;
        droppedItem.tab = this.activeTab.name;
      }
      if (!droppedItem.tab) {
        droppedItem.tab = this.findTabInStructure(droppedItem, this.internalStructure);
      }
      if (droppedItem.element_type.includes("_custom")) {
        droppedItem.element_type = droppedItem.element_type.replace(/_custom/, "");
      }
      if (!droppedItem.name) {
        // Generate a random name if none is set
        droppedItem.name = droppedItem.element_type + "-" + Math.random().toString(36).substring(7);
      }

      // remove not needed properties
      delete droppedItem.collectionDrag;
      delete droppedItem.collection;
      delete droppedItem.collectionIdx;
      delete droppedItem.parentTitle;

      this.spliceInternalStructure(startIdx, 0, droppedItem);

      this.setActiveItem(droppedItem);
      this.setIsEdited();
    },
    spliceInternalStructure: function spliceInternalStructure(startIdx, deleteAmount, item) {

      if (startIdx == -1) {
        startIdx = this.internalStructure.length;
      }

      var newStructure = _.cloneDeep(this.internalStructure);
      if (item) {
        newStructure.splice(startIdx, deleteAmount, item);
      } else {
        newStructure.splice(startIdx, deleteAmount);
      }
      this.internalStructure = newStructure;
    },
    setIsEdited: function setIsEdited() {
      this.$store.commit("SET_DRAG_EDITOR_EDITED", true);
    },
    setActiveItem: function setActiveItem(item) {
      this.$store.commit("SET_DRAG_EDITOR_ACTIVE", item);
    },
    removeDroppedItemFromOrigin: function removeDroppedItemFromOrigin(dropResult) {
      // Remove a dropped item from it's origin in internalDragElements
      // and clean up the resulting dropResult
      var startIdx = dropResult.payload.collectionIdx;

      if (startIdx == -1) {
        if (dropResult.payload.collectionDrag) {
          _.remove(dropResult.payload.collectionDrag, dropResult.payload);
        }
      } else {
        if (dropResult.payload.collection == this.internalStructure) {
          this.spliceInternalStructure(startIdx, 1);
        } else {
          dropResult.payload.collection.splice(startIdx, 1);
        }
      }

      // We have to remove collection or we will get an infinite loop when item is selected
      delete dropResult.payload.collectionDrag;
      delete dropResult.payload.collection;
      delete dropResult.payload.collectionIdx;
      return dropResult.payload;
    }
  },
  watch: {
    structure: function structure() {
      this.setupTabs();
      this.resetInternalStructure();
      if (this.shouldIncludeSubmit) {
        this.setupSubmit();
      }
    },
    dragElements: function dragElements() {
      this.setupDragElements();
    }
  }
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This mixin introduces a percentage filter

// @vue/component
/* harmony default export */ __webpack_exports__["a"] = ({
  filters: {
    percentage: function percentage(value) {
      return value + " %";
    }
  }
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultExternalFormElements;
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLeadMaskElementsStandard;
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultLeadMaskElementsAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(64);


function defaultExternalFormElements() {
  return [{
    element_type: 'paragraph',
    content: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.paragraph')
  }, {
    element_type: 'title',
    content: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.title')
  }, {
    element_type: 'confirmation',
    content: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.confirmation'),
    required: true
  }];
}

function defaultLeadMaskElementsStandard() {
  return [{
    element_type: 'radio',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.gender'),
    name: 'gender',
    allowed_values: [{
      name: "Male",
      value: "male"
    }, {
      name: "Female",
      value: "female"
    }],
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.firstname'),
    name: 'firstname',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.lastname'),
    name: 'lastname',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.email'),
    name: 'email',
    data_type: 'email',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.company'),
    name: 'company',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.street'),
    name: 'street',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.street_number'),
    name: 'street_number',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.zip'),
    name: 'zip',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.city'),
    name: 'city',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'country_select',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.country'),
    name: 'country',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.website'),
    name: 'company_website',
    data_type: 'url',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.phone_company'),
    name: 'phone_company',
    data_type: 'tel',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }, {
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.phone_mobile'),
    name: 'phone_mobile',
    data_type: 'tel',
    shouldBeDeleted: true,
    isUniqueInCollection: true
  }];
}

function defaultLeadMaskElementsAdvanced() {
  return [{
    element_type: 'text',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.textfield')
  }, {
    element_type: 'textarea',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.long_textfield')
  }, {
    element_type: 'paragraph',
    content: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.paragraph')
  }, {
    element_type: 'title',
    content: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.title')
  }, {
    element_type: 'checkbox',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.multi_select'),
    allowed_values: [{
      name: "Name",
      value: "value_1"
    }]
  }, {
    element_type: 'select',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.dropdown'),
    allowed_values: [{
      name: "Name",
      value: "value_1"
    }]
  }, {
    element_type: 'radio',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.single_select'),
    allowed_values: [{
      name: "Name",
      value: "value_1"
    }]
  }, {
    element_type: 'date',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.date')
  }, {
    element_type: 'readonly',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.readonly')
  }, {
    element_type: 'quantity_selection',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.quantity_selection')
  }, {
    element_type: 'drawing',
    label: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('ui.drag_elements.drawing')
  }];
}

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var frequencies = [{ name: 'Daily', value: 'daily', text: 'Daily' }, { name: 'Every hour', value: 'immediately', text: 'Every hour' }, { name: 'Only once', value: 'once', text: 'Only once' }];
/* harmony default export */ __webpack_exports__["a"] = (frequencies);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hours = [{ name: '00:00', value: '00:00' }, { name: '01:00', value: '01:00' }, { name: '02:00', value: '02:00' }, { name: '03:00', value: '03:00' }, { name: '04:00', value: '04:00' }, { name: '05:00', value: '05:00' }, { name: '06:00', value: '06:00' }, { name: '07:00', value: '07:00' }, { name: '08:00', value: '08:00' }, { name: '09:00', value: '09:00' }, { name: '10:00', value: '10:00' }, { name: '11:00', value: '11:00' }, { name: '12:00', value: '12:00' }, { name: '13:00', value: '13:00' }, { name: '14:00', value: '14:00' }, { name: '15:00', value: '15:00' }, { name: '16:00', value: '16:00' }, { name: '17:00', value: '17:00' }, { name: '18:00', value: '18:00' }, { name: '19:00', value: '19:00' }, { name: '20:00', value: '20:00' }, { name: '21:00', value: '21:00' }, { name: '22:00', value: '22:00' }, { name: '23:00', value: '23:00' }];
/* harmony default export */ __webpack_exports__["a"] = (hours);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ value: "exhibition", name: "exhibition" }, { value: "inbound", name: "inbound" }, { value: "other", name: "other" }]);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ value: "user", name: "Standard user" }, { value: "admin", name: "Admin" }]);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ value: "unconfirmed", name: "Unconfirmed" }, { value: "confirmed", name: "Confirmed" }, { value: "disabled", name: "Disabled" }]);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user_permission", function() { return user_permission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "admin_permission", function() { return admin_permission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "root_permission", function() { return root_permission; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _user_permission, _admin_permission;

// Note that all user permissions are inherited by admins
var user_permission = (_user_permission = {
  role: "user",
  is_user: true,
  user: true,
  link: true,
  organizations: {
    show: true
  },
  users: {
    me: true,
    update: true
  },
  contact_manager: {
    show: true
  },
  contacts: {
    show: true,
    import: true,
    save_as_segment: true
  },
  segments: {
    show: true,
    save: true,
    create: true,
    new: true,
    delete: true,
    list: true,
    open: true,
    update: true,
    search: true
  },
  companies: {
    show: true,
    create: true,
    delete: true
  },
  projects: {
    list: true,
    show: true,
    statistics: true,
    search: true
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user_permission, "projects", {
  list: true,
  show: true,
  statistics: true,
  search: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user_permission, "project_leads", {
  list: true,
  create: true,
  add_popup: true,
  new: true,
  create_from_businesscard: true,
  update: true,
  show: true,
  search: true,
  download_pdf: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user_permission, "eventbaxx_events", {
  list: true,
  show: true,
  send: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user_permission, "statistics", {
  projects: true
}), _user_permission);

// Admins inherit all user permissions, so there is no need to include them here again
var admin_permission = (_admin_permission = {
  role: "admin",
  admin: true,
  is_admin: true,
  is_user: true,
  link: true,
  organizations: {
    create: false,
    delete: true,
    disable: false,
    enable: false,
    list: false,
    show: true,
    update: true,
    search: true
  },
  users: {
    create: false,
    delete: true,
    disable: true,
    invite: true,
    list: true,
    me: true,
    show: true,
    update: true,
    invite_xls: true,
    update_status: false,
    update_role: true,
    search: true
  },
  lead_masks: {
    list: true,
    create: true,
    update: true,
    new: true,
    show: true,
    search: true
  },
  projects: {
    assign_users: true,
    close: true,
    create: true,
    new: true,
    delete: true,
    open: true,
    unassign_users: true,
    update: true,
    options: true,
    synchronize: true,
    search: true
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "lead_masks", {
  list: true,
  create: true,
  update: true,
  new: true,
  show: true,
  search: true,
  add_popup: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "lead_mask", {
  save: true,
  publish: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "project_leads", {
  list: true,
  add_popup: true,
  create_from_businesscard: true,
  update: true,
  create: true,
  export: true,
  new: true,
  show: true,
  update_date: true,
  update_user: true,
  search: true,
  download_pdf: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "business_kits", {
  list: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "project_business_kits", {
  list: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "external_forms", {
  list: true,
  create: true,
  update: true,
  new: true,
  show: true,
  search: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "external_form", {
  add_popup: true,
  save: true,
  publish: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "statistics", {
  list: false
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "email_templates", {
  list: true,
  create: true,
  new: true,
  update: true,
  search: true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_admin_permission, "workflows", {
  add_popup: true,
  trigger: true,
  list: true,
  create: true,
  new: true,
  update: true,
  search: true
}), _admin_permission);

var root_permission = {
  role: "root",
  is_root: true
};



/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_Permission__ = __webpack_require__(12);


/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var operation = binding.value;
    var permission = __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].loadPermissions();
    var can = __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].can(permission, operation);

    if (operation != undefined && can === false) {
      el.innerHTML = "";
      el.style.display = "none";
    }
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_Permission__ = __webpack_require__(12);


/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var operation = binding.value;
    var permission = __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].loadPermissions();
    var can = __WEBPACK_IMPORTED_MODULE_0__classes_Permission__["a" /* default */].can(permission, operation);

    if (operation != undefined && can === false) {
      el.classList.add('is-display-none');
    }
  }
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    el.event = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.event);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener('click', el.event);
  }
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return messages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return datetime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hileadzz_i18n__ = __webpack_require__(674);


var _ref;



var messages = (_ref = _).merge.apply(_ref, [{}].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__hileadzz_i18n__["a" /* default */])));
var datetime = __WEBPACK_IMPORTED_MODULE_1__hileadzz_i18n__["a" /* default */].Datetime;



/***/ }),
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Group-14.6cceecd.svg";

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apple-btn.e5127b7.png";

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/businesskit-header-modal.3b42d41.png";

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/company-card.6ab726d.svg";

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contacts.6cceecd.svg";

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/conversion-1.09586db.svg";

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/conversion-2.e654350.svg";

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/conversion-3.0372d8f.svg";

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/crm-integration.f0082b7.svg";

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dragable.2ee0fcb.svg";

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/google-btn.d20a16c.png";

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/goto-webinar.60bc11f.svg";

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/green-circle.c91a101.svg";

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hileadzz_logo.cb1656e.svg";

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-upload.8753e21.svg";

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-field-password.eb1f4b8.svg";

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-field-user.ca35a81.svg";

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kit-thumbnail.b2f132f.svg";

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/latest-activity-deleted.6cded6c.svg";

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/latest-activity-updated.cc598e5.svg";

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leads-app.5320d13.png";

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_fanomena.5e53a81.svg";

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_sign.32e4076.svg";

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_sign_grey.092e33b.svg";

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_sign_login.189246d.svg";

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_text.3d9ed66.svg";

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_text_black.5afbc1e.svg";

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/most-active-leads_empty.3c6462c.svg";

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/password-request-illustration.c2e279e.svg";

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plus-icon.1c1ffc8.svg";

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/segment-icon.327d28c.svg";

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sources-1.b1e19d9.svg";

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/static_tracking.c6d7e69.svg";

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/status-green.25e978f.svg";

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/status-grey.42f1e72.svg";

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/talents_logo.188a1a5.svg";

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/talents_logo_grey.67c5139.svg";

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/talents_logo_login.0e57ece.svg";

/***/ }),
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 517,
	"./af.js": 517,
	"./ar": 524,
	"./ar-dz": 518,
	"./ar-dz.js": 518,
	"./ar-kw": 519,
	"./ar-kw.js": 519,
	"./ar-ly": 520,
	"./ar-ly.js": 520,
	"./ar-ma": 521,
	"./ar-ma.js": 521,
	"./ar-sa": 522,
	"./ar-sa.js": 522,
	"./ar-tn": 523,
	"./ar-tn.js": 523,
	"./ar.js": 524,
	"./az": 525,
	"./az.js": 525,
	"./be": 526,
	"./be.js": 526,
	"./bg": 527,
	"./bg.js": 527,
	"./bm": 528,
	"./bm.js": 528,
	"./bn": 529,
	"./bn.js": 529,
	"./bo": 530,
	"./bo.js": 530,
	"./br": 531,
	"./br.js": 531,
	"./bs": 532,
	"./bs.js": 532,
	"./ca": 533,
	"./ca.js": 533,
	"./cs": 534,
	"./cs.js": 534,
	"./cv": 535,
	"./cv.js": 535,
	"./cy": 536,
	"./cy.js": 536,
	"./da": 537,
	"./da.js": 537,
	"./de": 540,
	"./de-at": 538,
	"./de-at.js": 538,
	"./de-ch": 539,
	"./de-ch.js": 539,
	"./de.js": 540,
	"./dv": 541,
	"./dv.js": 541,
	"./el": 542,
	"./el.js": 542,
	"./en-SG": 543,
	"./en-SG.js": 543,
	"./en-au": 544,
	"./en-au.js": 544,
	"./en-ca": 545,
	"./en-ca.js": 545,
	"./en-gb": 546,
	"./en-gb.js": 546,
	"./en-ie": 547,
	"./en-ie.js": 547,
	"./en-il": 548,
	"./en-il.js": 548,
	"./en-nz": 549,
	"./en-nz.js": 549,
	"./eo": 550,
	"./eo.js": 550,
	"./es": 553,
	"./es-do": 551,
	"./es-do.js": 551,
	"./es-us": 552,
	"./es-us.js": 552,
	"./es.js": 553,
	"./et": 554,
	"./et.js": 554,
	"./eu": 555,
	"./eu.js": 555,
	"./fa": 556,
	"./fa.js": 556,
	"./fi": 557,
	"./fi.js": 557,
	"./fo": 558,
	"./fo.js": 558,
	"./fr": 561,
	"./fr-ca": 559,
	"./fr-ca.js": 559,
	"./fr-ch": 560,
	"./fr-ch.js": 560,
	"./fr.js": 561,
	"./fy": 562,
	"./fy.js": 562,
	"./ga": 563,
	"./ga.js": 563,
	"./gd": 564,
	"./gd.js": 564,
	"./gl": 565,
	"./gl.js": 565,
	"./gom-latn": 566,
	"./gom-latn.js": 566,
	"./gu": 567,
	"./gu.js": 567,
	"./he": 568,
	"./he.js": 568,
	"./hi": 569,
	"./hi.js": 569,
	"./hr": 570,
	"./hr.js": 570,
	"./hu": 571,
	"./hu.js": 571,
	"./hy-am": 572,
	"./hy-am.js": 572,
	"./id": 573,
	"./id.js": 573,
	"./is": 574,
	"./is.js": 574,
	"./it": 576,
	"./it-ch": 575,
	"./it-ch.js": 575,
	"./it.js": 576,
	"./ja": 577,
	"./ja.js": 577,
	"./jv": 578,
	"./jv.js": 578,
	"./ka": 579,
	"./ka.js": 579,
	"./kk": 580,
	"./kk.js": 580,
	"./km": 581,
	"./km.js": 581,
	"./kn": 582,
	"./kn.js": 582,
	"./ko": 583,
	"./ko.js": 583,
	"./ku": 584,
	"./ku.js": 584,
	"./ky": 585,
	"./ky.js": 585,
	"./lb": 586,
	"./lb.js": 586,
	"./lo": 587,
	"./lo.js": 587,
	"./lt": 588,
	"./lt.js": 588,
	"./lv": 589,
	"./lv.js": 589,
	"./me": 590,
	"./me.js": 590,
	"./mi": 591,
	"./mi.js": 591,
	"./mk": 592,
	"./mk.js": 592,
	"./ml": 593,
	"./ml.js": 593,
	"./mn": 594,
	"./mn.js": 594,
	"./mr": 595,
	"./mr.js": 595,
	"./ms": 597,
	"./ms-my": 596,
	"./ms-my.js": 596,
	"./ms.js": 597,
	"./mt": 598,
	"./mt.js": 598,
	"./my": 599,
	"./my.js": 599,
	"./nb": 600,
	"./nb.js": 600,
	"./ne": 601,
	"./ne.js": 601,
	"./nl": 603,
	"./nl-be": 602,
	"./nl-be.js": 602,
	"./nl.js": 603,
	"./nn": 604,
	"./nn.js": 604,
	"./pa-in": 605,
	"./pa-in.js": 605,
	"./pl": 606,
	"./pl.js": 606,
	"./pt": 608,
	"./pt-br": 607,
	"./pt-br.js": 607,
	"./pt.js": 608,
	"./ro": 609,
	"./ro.js": 609,
	"./ru": 610,
	"./ru.js": 610,
	"./sd": 611,
	"./sd.js": 611,
	"./se": 612,
	"./se.js": 612,
	"./si": 613,
	"./si.js": 613,
	"./sk": 614,
	"./sk.js": 614,
	"./sl": 615,
	"./sl.js": 615,
	"./sq": 616,
	"./sq.js": 616,
	"./sr": 618,
	"./sr-cyrl": 617,
	"./sr-cyrl.js": 617,
	"./sr.js": 618,
	"./ss": 619,
	"./ss.js": 619,
	"./sv": 620,
	"./sv.js": 620,
	"./sw": 621,
	"./sw.js": 621,
	"./ta": 622,
	"./ta.js": 622,
	"./te": 623,
	"./te.js": 623,
	"./tet": 624,
	"./tet.js": 624,
	"./tg": 625,
	"./tg.js": 625,
	"./th": 626,
	"./th.js": 626,
	"./tl-ph": 627,
	"./tl-ph.js": 627,
	"./tlh": 628,
	"./tlh.js": 628,
	"./tr": 629,
	"./tr.js": 629,
	"./tzl": 630,
	"./tzl.js": 630,
	"./tzm": 632,
	"./tzm-latn": 631,
	"./tzm-latn.js": 631,
	"./tzm.js": 632,
	"./ug-cn": 633,
	"./ug-cn.js": 633,
	"./uk": 634,
	"./uk.js": 634,
	"./ur": 635,
	"./ur.js": 635,
	"./uz": 637,
	"./uz-latn": 636,
	"./uz-latn.js": 636,
	"./uz.js": 637,
	"./vi": 638,
	"./vi.js": 638,
	"./x-pseudo": 639,
	"./x-pseudo.js": 639,
	"./yo": 640,
	"./yo.js": 640,
	"./zh-cn": 641,
	"./zh-cn.js": 641,
	"./zh-hk": 642,
	"./zh-hk.js": 642,
	"./zh-tw": 643,
	"./zh-tw.js": 643
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1620;

/***/ }),
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart);
  this._canvas.addEventListener('touchmove', this._handleTouchMove);
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ __webpack_exports__["a"] = (SignaturePad);


/***/ }),
/* 1627 */,
/* 1628 */,
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(1882),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1266)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(1840),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23b1d2ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1303)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(1886),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1397)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(1992),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c9362ce8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1307)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(1889),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4620841a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1301)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(1880),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1264)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(1838),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2286fa1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1297)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(1875),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(1900),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1246)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(1814),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(1846),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1308)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(1890),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47a2f0f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(1825),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1340)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(1929),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69d0c814",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(1897),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1339)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(1928),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-663d1962",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(1909),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1257)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(1829),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(721),
  /* template */
  __webpack_require__(1851),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1321)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(1907),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51fc93eb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(1973),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(2002),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(1802),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1315)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(727),
  /* template */
  __webpack_require__(1899),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bf84e1b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1379)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(1970),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1310)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(729),
  /* template */
  __webpack_require__(1893),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-483d2363",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(1799),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1417)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(2012),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fbdfa64c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1289)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(1867),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1362)
  __webpack_require__(1361)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(733),
  /* template */
  __webpack_require__(1951),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bbff644",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(1832),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1396)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(1991),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1279)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(740),
  /* template */
  __webpack_require__(1856),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f16347f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1236)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(1800),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1249)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(1817),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1251)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(745),
  /* template */
  __webpack_require__(1820),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1328)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(747),
  /* template */
  __webpack_require__(1914),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a85780a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1341)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(750),
  /* template */
  __webpack_require__(1930),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ab1e30d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1238)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(755),
  /* template */
  __webpack_require__(1803),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07258e05",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1359)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(756),
  /* template */
  __webpack_require__(1949),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1241)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(757),
  /* template */
  __webpack_require__(1807),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07e4f327",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1406)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(1999),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d14223c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1272)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(1847),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1398)
  __webpack_require__(1399)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(763),
  /* template */
  __webpack_require__(1993),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1344)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(1934),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c8452f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1400)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(1994),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cbd0ff28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1355)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(1945),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73d0bd9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1371)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(767),
  /* template */
  __webpack_require__(1960),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-82284058",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1373)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(1962),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-885ffe7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1280)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(769),
  /* template */
  __webpack_require__(1857),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-304c45d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1333)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(1920),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d68ede6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1342)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(1931),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bf087e5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1383)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(773),
  /* template */
  __webpack_require__(1977),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b144b1dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1393)
  __webpack_require__(1394)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(774),
  /* template */
  __webpack_require__(1986),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bde514c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1346)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(1938),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f2ed914",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1408)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(777),
  /* template */
  __webpack_require__(2001),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d767dd70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(778),
  /* template */
  __webpack_require__(1921),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1357)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(1947),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1293)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(786),
  /* template */
  __webpack_require__(1872),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1314)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(1898),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1407)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(788),
  /* template */
  __webpack_require__(2000),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1414)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(790),
  /* template */
  __webpack_require__(2008),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(1813),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1353)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1943),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71da9cbb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1302)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1881),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1925),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1285)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1863),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-341faa44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1862),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(1937),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(800),
  /* template */
  __webpack_require__(1828),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1370)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(801),
  /* template */
  __webpack_require__(1959),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(1990),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1309)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(804),
  /* template */
  __webpack_require__(1892),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1252)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(807),
  /* template */
  __webpack_require__(1821),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-15eac0bf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1250)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(808),
  /* template */
  __webpack_require__(1819),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-115fbe64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(810),
  /* template */
  __webpack_require__(1989),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1316)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(811),
  /* template */
  __webpack_require__(1901),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1378)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(1969),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(1822),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1298)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(1876),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d9b5874",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1386)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(819),
  /* template */
  __webpack_require__(1980),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(820),
  /* template */
  __webpack_require__(1806),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1244)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(823),
  /* template */
  __webpack_require__(1810),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b2cedfe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(824),
  /* template */
  __webpack_require__(1932),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1343)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(1933),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c844fc8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1304)
  __webpack_require__(1305)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(826),
  /* template */
  __webpack_require__(1887),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1231)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(1791),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1300)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(1878),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1248)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(1816),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0fdadba0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1313)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(832),
  /* template */
  __webpack_require__(1896),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1387)
  __webpack_require__(1388)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(1982),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b95b95ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1347)
  __webpack_require__(1348)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(1939),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f9324fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(1849),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(1964),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(1996),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(840),
  /* template */
  __webpack_require__(1811),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1292)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(1871),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3933581a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1261)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(1834),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1372)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(1961),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1327)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(1913),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1235)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(1798),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1416)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(2011),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f67b431e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1375)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(1965),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1320)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(1906),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1332)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(1919),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1883),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(1879),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1237)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(1801),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1410)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(2004),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e43dc866",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1319)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(856),
  /* template */
  __webpack_require__(1905),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1366)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(857),
  /* template */
  __webpack_require__(1955),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1412)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(2006),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e7ba31a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(860),
  /* template */
  __webpack_require__(1796),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1273)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(861),
  /* template */
  __webpack_require__(1848),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(1918),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1296)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(1874),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b25ea5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1267)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(1841),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1282)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(1859),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31ad852e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(1884),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(1823),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(1891),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(1972),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(1987),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1290)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(1869),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37189162",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1286)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(1864),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1325)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(1911),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-579a8d31",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1281)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(1858),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1299)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(1877),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1322)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(1908),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-532180b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1317)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1903),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1354)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1944),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7368c31e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1368)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1957),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e3e2cf0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1268)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1842),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1295)
  __webpack_require__(1294)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(1873),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a91d16c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1360)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(1950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-782b2503",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1318)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(1904),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(1967),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1358)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(1948),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(1805),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0740241d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1275)
  __webpack_require__(1274)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1850),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b5f96b7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1284)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(1861),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1326)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(1912),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1376)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(1966),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1323)
  __webpack_require__(1324)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(1910),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5724acc8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1411)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(2005),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1269)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(1843),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-254476b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1390)
  __webpack_require__(1389)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(1984),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bd9e43e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(1818),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1352)
  __webpack_require__(1351)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(1942),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70c8802c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1415)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(2010),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ed9f9ddc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1413)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(2007),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1233)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1795),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03ec4eb3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1367)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(1956),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d4928d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(1971),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1365)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(1954),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1418)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(2013),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fc92e590",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1265)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(1839),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1255)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(1826),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(912),
  /* template */
  __webpack_require__(1804),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(913),
  /* template */
  __webpack_require__(1941),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(1812),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(915),
  /* template */
  __webpack_require__(1924),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.key,
    staticClass: "contact-page"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "contact-page-loader"
  }, [_c('loading')], 1) : _c('div', {
    staticClass: "row gutter-md"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-offset-4 col-lg-4 col-xl-4"
  }, [_c('div', {
    staticClass: "contact-info"
  }, [_c('user-image', {
    attrs: {
      "firstname": _vm.contact.firstname,
      "lastname": _vm.contact.lastname,
      "email": _vm.contact.email,
      "size": "medium"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.contact.name))]), _vm._v(" "), (!!_vm.contact.email) ? _c('p', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.contact.email))]) : _c('p', {
    staticClass: "email"
  }, [_vm._v("-")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.contact.created")) + "\n          " + _vm._s(_vm.formatDateTimeNatural(_vm.contact.created_at)) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.contact.updated")) + "\n          " + _vm._s(_vm.formatDateTimeNatural(_vm.contact.updated_at)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('div', {
    staticClass: "source-icon"
  }, [(_vm.contact.source == 'upload') ? _c('img', {
    attrs: {
      "src": __webpack_require__(442)
    }
  }) : (_vm.contact.source == 'web_app') ? _c('img', {
    attrs: {
      "src": __webpack_require__(445)
    }
  }) : (_vm.contact.source == 'mobile_app') ? _c('img', {
    attrs: {
      "src": __webpack_require__(443)
    }
  }) : (_vm.contact.source == 'crm_sync') ? _c('img', {
    attrs: {
      "src": __webpack_require__(440)
    }
  }) : (_vm.contact.source == 'external_form') ? _c('img', {
    attrs: {
      "src": __webpack_require__(441)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(444)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t("ui.contact.source")))]), _vm._v(" "), _c('p', {
    staticClass: "body-p"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("ui.contact.sources." + _vm.contact.source)) + "\n            ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "contact-details"
  }, [_c('div', {
    staticClass: "contact-details-header justify-between flex"
  }, [_c('h5', {
    staticClass: "block"
  }, [_vm._v(_vm._s(_vm.$t("ui.contact.contact_details")))]), _vm._v(" "), _c('a', {
    staticClass: "link block blue-text padding-left",
    on: {
      "click": function($event) {
        return _vm.setIsOpen(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.contact.edit")) + "\n          ")])]), _vm._v(" "), _vm._l((_vm.standardPersonalFields), function(entry) {
    return _c('div', {
      staticClass: "info-block"
    }, [_c('p', {
      staticClass: "caption"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.contact.caption" + "." + entry.internal_name)) + "\n          ")]), _vm._v(" "), (entry.val == '') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("-")]) : (entry.internal_name == 'language') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(_vm.language) + "\n          ")]) : _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
  }, [(_vm.contact.projects.length > 0) ? _c('div', {
    staticClass: "lead-panel"
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t("ui.contact.is_lead_on")))]), _vm._v(" "), _vm._l((_vm.contact.projects), function(project, index) {
    return _c('div', {
      key: 'lead-panel-' + project.id,
      staticClass: "project-wrapper"
    }, [_c('q-collapsible', {
      staticClass: "project-container",
      attrs: {
        "opened": index == 0
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('div', {
      staticClass: "project-title"
    }, [_c('div', {
      staticClass: "project-title-label"
    }, [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('div', {
      staticClass: "project-title-sublabel"
    }, [_vm._v("\n                  " + _vm._s(_vm.getProjectSubLabel(project)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "project-title-classification"
    }, [_c('span', {
      staticClass: "value-classification",
      class: project.classification || 'unclassified'
    }, [_vm._v(" ")]), _vm._v(" "), _c('a', {
      staticClass: "link padding-left",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.goToLead(project.id, project.lead_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("ui.contact.go_to_lead")))])])])]), _vm._v(" "), _c('div', {
      staticClass: "leadsheet-details"
    }, [(!!_vm.leadsheetTabs[project.id]) ? _c('div', {
      staticClass: "leadsheet-content"
    }, _vm._l((_vm.leadsheetTabs[project.id]), function(tab, tabName) {
      return _c('div', {
        key: tabName + project.id,
        staticClass: "leadsheet-tab-wrapper"
      }, [(tab.length > 0) ? _c('div', {
        staticClass: "leadsheet-tab"
      }, [_c('h5', [_vm._v(_vm._s(tabName))]), _vm._v(" "), _vm._l((tab), function(element) {
        return _c('span', {
          key: element.name + project.id
        }, [(element.type == 'title') ? _c('h6', {
          staticClass: "title-block"
        }, [_vm._v("\n                        " + _vm._s(element.content) + "\n                      ")]) : _c('div', {
          staticClass: "info-block"
        }, [_c('p', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(element.label))]), _vm._v(" "), (
          element.type == 'quantity_selection' &&
          element.value.length > 0
        ) ? _c('p', {
          staticClass: "body-p"
        }, _vm._l((element.value), function(quantityVal) {
          return _c('span', {
            key: quantityVal.value,
            staticClass: "info-aggregate"
          }, [_c('span', {
            staticClass: "info-aggregate-label"
          }, [_vm._v(_vm._s(quantityVal.label))]), _vm._v(" "), _c('span', {
            staticClass: "info-aggregate-value"
          }, [_vm._v(_vm._s(quantityVal.value))])])
        }), 0) : (
          Array.isArray(element.value) &&
          element.value.length > 0
        ) ? _c('p', {
          staticClass: "body-p"
        }, [_vm._v("\n                          " + _vm._s(_vm.convertArrayForDisplay(element.value)) + "\n                        ")]) : (
          Array.isArray(element.value) == false &&
          !!element.value
        ) ? _c('p', {
          staticClass: "body-p"
        }, [_vm._v("\n                          " + _vm._s(element.value) + "\n                        ")]) : _c('p', {
          staticClass: "body-p"
        }, [_vm._v("-")])])])
      })], 2) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (!!_vm.tags[project.id]) ? _c('div', {
      staticClass: "info-block"
    }, [_c('p', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(_vm.$t("ui.contact.tags")))]), _vm._v(" "), (
      Array.isArray(_vm.tags[project.id]) &&
      _vm.tags[project.id].length > 0
    ) ? _c('p', {
      staticClass: "body-p"
    }, _vm._l((_vm.tags[project.id]), function(tag) {
      return _c('span', {
        key: tag.id,
        staticClass: "tag-list--item"
      }, [_vm._v(_vm._s(tag.name))])
    }), 0) : _c('p', {
      staticClass: "body-p"
    }, [_vm._v("-")])]) : _vm._e()])], 2)], 1)
  })], 2) : _c('div', [_c('empty-state', {
    attrs: {
      "name": "contacts",
      "subtitle": _vm.$t('ui.contact.empty_state_text'),
      "button": true
    }
  }), _vm._v(" "), _c('h5')], 1)]), _vm._v(" "), (_vm.company && !_vm.planIsTalent) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
  }, [_c('div', {
    key: _vm.company.id,
    staticClass: "contact-details"
  }, [_c('div', {
    staticClass: "contact-details-header justify-between flex"
  }, [_c('h5', {
    staticClass: "block"
  }, [_vm._v(_vm._s(_vm.$t("ui.contact.company_details")))]), _vm._v(" "), _c('a', {
    staticClass: "link block blue-text padding-left",
    on: {
      "click": function($event) {
        return _vm.showCompanyChange(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.contact.change_company")) + "\n          ")])]), _vm._v(" "), _vm._l((_vm.standardCompanyFields), function(entry) {
    return _c('div', {
      staticClass: "info-block"
    }, [(entry.display_name) ? _c('p', {
      staticClass: "caption"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.company.caption" + "." + entry.internal_name)) + "\n          ")]) : _vm._e(), _vm._v(" "), (entry.val == '') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("-")]) : (entry.internal_name == 'name') ? _c('a', {
      staticClass: "link body-p",
      on: {
        "click": function($event) {
          return _vm.goToCompany(_vm.company.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")]) : (entry.internal_name == 'website') ? _c('a', {
      staticClass: "body-p",
      attrs: {
        "href": entry.val,
        "target": "_blank"
      }
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")]) : (entry.internal_name == 'country') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(_vm.country) + "\n          ")]) : _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")])])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('contact-edit', {
    attrs: {
      "isOpen": _vm.isOpen,
      "contact": _vm.contact
    },
    on: {
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      },
      "save": _vm.updateContact
    }
  }), _vm._v(" "), _c('change-company', {
    attrs: {
      "isOpen": _vm.companyChangeOpen
    },
    on: {
      "cancel": function($event) {
        return _vm.showCompanyChange(false)
      },
      "save": _vm.changeCompany
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts-section"
  }, [_c('x-table', {
    attrs: {
      "title": _vm.$t('ui.contacts.title'),
      "emptyStateLabel": _vm.$t('ui.contacts.empty_state_msg'),
      "columns": _vm.filteredColumns(_vm.columns),
      "tableData": _vm.contacts,
      "enableSearch": true,
      "searchKeywords": _vm.segment.search,
      "enableFilter": true,
      "filterDefinitions": _vm.getFilterDefinitions(),
      "filters": _vm.segment.filters,
      "selectionType": "multiple",
      "totalResults": _vm.totalCount,
      "pagination": _vm.defaultPagination,
      "showLoader": _vm.loading,
      "actions": _vm.actions,
      "tableSettingsName": _vm.tableSettingsName,
      "rowsPerPage": [5, 7, 10, 15, 25, 50]
    },
    on: {
      "updateSearch": _vm.updateSearch,
      "updateFilters": _vm.updateFilters,
      "updatePagination": _vm.updatePagination,
      "fetchData": _vm.fetchData,
      "clickCell": _vm.clickCell,
      "emitTotalTableCount": _vm.emitTotalTableCount,
      "selectedItemsChange": _vm.selectedItemsChange
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "open": _vm.deleteContactsModalOpen,
      "title": _vm.$t('ui.contacts.modals.delete.title'),
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": _vm.$t('ui.global.delete')
    },
    on: {
      "save": _vm.actionDelete,
      "cancel": _vm.closeDeleteContactsModal
    }
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$t("ui.global.delete_confirmation", {
    name: _vm.$tc("ui.contacts.enumeration", _vm.currentSelectedIds.length, {
      n: _vm.currentSelectedIds.length
    })
  })) + "\n    ")])]), _vm._v(" "), _c('change-company', {
    attrs: {
      "isOpen": _vm.companyChangeOpen,
      "idCount": _vm.selectedIdCount
    },
    on: {
      "cancel": function($event) {
        return _vm.showCompanyChange(false)
      },
      "save": _vm.emitId
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.computedClass
  }, [(_vm.label) ? _c('label', {
    staticClass: "text-label",
    class: {
      'no-padding': _vm.helpIcon
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + " "), (!_vm.required) ? _c('em', {
    staticClass: "optional"
  }, [_vm._v("optional")]) : _vm._e(), (_vm.required) ? _c('em', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), (_vm.helpIcon) ? _c('help-icon', {
    attrs: {
      "popperOptions": _vm.helpIconOptions,
      "size": "small"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [(_vm.type == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input text-input",
    attrs: {
      "readonly": _vm.readonly,
      "optional": !_vm.required,
      "type": "text",
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "autocomplete": _vm.autocomplete,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input text-input",
    attrs: {
      "readonly": _vm.readonly,
      "optional": !_vm.required,
      "type": "email",
      "id": _vm.name,
      "name": _vm.name,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input textarea-input",
    attrs: {
      "optional": !_vm.required,
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input password-input",
    attrs: {
      "id": _vm.name,
      "name": _vm.name,
      "type": "password",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.type == 'select') ? _c('div', {
    staticClass: "field--wrapper input--select-wrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "field--input field--select input--select",
    attrs: {
      "disabled": _vm.readonly || _vm.disabled,
      "id": _vm.name,
      "name": _vm.name
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChange($event)
      }]
    }
  }, [_c('option', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": undefined
    }
  }), _vm._v(" "), _vm._l((_vm.collection), function(option) {
    return _c('option', {
      key: option.value,
      attrs: {
        "disabled": (option.disabled == 'true'),
        "name": option.value
      },
      domProps: {
        "selected": option.value == _vm.newValue,
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.name) + "\n      ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.type == 'radio') ? _c('div', {
    staticClass: "field--wrapper"
  }, _vm._l((_vm.collection), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "field--radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newValue),
        expression: "newValue"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "input--radio",
      attrs: {
        "type": "radio",
        "name": _vm.name,
        "id": _vm.name + '-' + option.value,
        "item": _vm.value,
        "disabled": _vm.disabled
      },
      domProps: {
        "value": option.value,
        "checked": option.value == _vm.newValue,
        "checked": _vm._q(_vm.newValue, option.value)
      },
      on: {
        "click": function($event) {
          return _vm.onClick(option.value)
        },
        "change": function($event) {
          _vm.newValue = option.value
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.name + '-' + option.value
      }
    }, [_vm._v(_vm._s(option.name))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.type == 'checkbox') ? _c('div', {
    staticClass: "field--wrapper"
  }, _vm._l((_vm.collection), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "field--checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newValue),
        expression: "newValue"
      }],
      staticClass: "input--checkbox",
      attrs: {
        "type": "checkbox",
        "id": _vm.name + '-' + option.value,
        "item": _vm.value,
        "checked": "",
        "disabled": _vm.disabled
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.newValue) ? _vm._i(_vm.newValue, option.value) > -1 : (_vm.newValue)
      },
      on: {
        "click": function($event) {
          return _vm.onClick(option.value)
        },
        "change": function($event) {
          var $$a = _vm.newValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.newValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.newValue = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.name + '-' + option.value
      }
    }, [_vm._v(_vm._s(option.name))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('collection', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.data,
      "structure": _vm.structure,
      "has_searched": _vm.has_searched,
      "params": _vm.params,
      "model": _vm.model
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment-page"
  }, [_c('div', {
    class: _vm.loading ? 'hidden' : ''
  }, [(_vm.segment !== null) ? _c('contacts', {
    attrs: {
      "mode": "segment",
      "segment": _vm.segment,
      "tableSettingsName": "segmentContacts"
    },
    on: {
      "fetchDataComplete": _vm.fetchDataComplete,
      "updateSearch": _vm.updateSearch,
      "updateFilters": _vm.updateFilters,
      "activateBusinessKitModal": _vm.activateBusinessKitModalCb,
      "activateAddToProjectModal": _vm.activateAddToProjectModalCb,
      "emitTotalTableCount": _vm.emitTotalTableCount,
      "selectedItemsChange": _vm.selectedItemsChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "segment-page-loader",
    class: _vm.loading ? '' : 'hidden'
  }, [_c('loading')], 1), _vm._v(" "), _c('business-kit-modal', {
    attrs: {
      "segment": _vm.segment,
      "sendBusinessKitModalOpen": _vm.sendBusinessKitModalOpen,
      "contactIds": _vm.contactIds,
      "totalTableCount": _vm.totalTableCount
    },
    on: {
      "closeBusinessKitModal": _vm.closeBusinessKitModal
    }
  }), _vm._v(" "), _c('add-to-project-modal', {
    attrs: {
      "segment": _vm.segment,
      "addToProjectModalOpen": _vm.addToProjectModalOpen,
      "contactIds": _vm.contactIds,
      "totalTableCount": _vm.totalTableCount
    },
    on: {
      "closeAddToProjectModal": _vm.closeAddToProjectModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "is-margin-top-0"
  }, [_vm._v(_vm._s(_vm.$t('ui.lead_mask_editor.basic_config')))]), _vm._v(" "), _c('div', {
    staticClass: "row gutter-md"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('form', {
    staticClass: "lead-mask-update--form max-width",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('div', {
    staticClass: "has-gutter-l"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "name",
      "placeholder": "Lead Sheet Name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "language",
      "type": "select",
      "placeholder": "English",
      "collection": _vm.selectableLanguages
    },
    model: {
      value: (_vm.item.language),
      callback: function($$v) {
        _vm.$set(_vm.item, "language", $$v)
      },
      expression: "item.language"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "alwaysHidden"
  }, [_c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organization.list'),
      expression: "'organization.list'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "organization",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.organizations
    },
    model: {
      value: (_vm.item.organization_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "organization_id", $$v)
      },
      expression: "item.organization_id"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('is_root'),
      expression: "'is_root'"
    }],
    staticClass: "lead-mask-raw"
  }, [_c('div', {
    staticClass: "lead-mask-raw--title",
    on: {
      "click": function($event) {
        _vm.isRawDisplayed = !_vm.isRawDisplayed
      }
    }
  }, [(_vm.isRawDisplayed) ? _c('i', {
    staticClass: "icon yule-icon-chevron-down"
  }) : _c('i', {
    staticClass: "icon yule-icon-chevron-right"
  }), _vm._v("\n      " + _vm._s(_vm.$t('ui.lead_mask_editor.see_raw')) + "\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRawDisplayed),
      expression: "isRawDisplayed"
    }],
    staticClass: "lead-mask-raw--content"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "structure",
      "type": "textarea",
      "value": _vm.structure,
      "placeholder": "{json}"
    },
    on: {
      "input": _vm.structureChange
    }
  })], 1)]), _vm._v(" "), _c('page-saver', {
    staticClass: "page-saver-wrapper",
    on: {
      "save": _vm.update,
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading-spinner": false,
      "is-loading": _vm.isLoading
    }
  }, [
    [_c('div', {
      staticClass: "row gutter-sm"
    }, [_c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1 icon"
    }, [_c('img', {
      staticClass: "align-center",
      attrs: {
        "src": __webpack_require__(457)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10 col-sm-10 col-md-10 col-lg-2"
    }, [_c('h2', [_vm._v(_vm._s(_vm.leads))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.leads_collected_label')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1"
    }, [(_vm.isCharts) ? _c('pie-chart', {
      attrs: {
        "colors": ['#BF0711', '#3a3e50'],
        "values": _vm.charts.hot.absolute === 0 ? [0, 100] : [_vm.charts.hot.relative, 100 - 100 * (_vm.charts.hot.absolute / _vm.leads)],
        "labels": ['Residential', 'Non-Residential']
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-1"
    }, [_c('h4', [_vm._v(_vm._s(_vm.charts.hot.absolute))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.hot')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1"
    }, [(_vm.isCharts) ? _c('pie-chart', {
      attrs: {
        "rotation": _vm.percentageToDegrees(_vm.charts.hot.relative),
        "colors": ['#9C6F19', '#3a3e50'],
        "values": _vm.charts.warm.absolute === 0 ? [0, 100] : [_vm.charts.warm.relative, 100 - 100 * (_vm.charts.warm.absolute / _vm.leads)],
        "labels": ['Residential', 'Non-Residential']
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-1"
    }, [_c('h4', [_vm._v(_vm._s(_vm.charts.warm.absolute))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.warm')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1"
    }, [(_vm.isCharts) ? _c('pie-chart', {
      attrs: {
        "rotation": _vm.percentageToDegrees(_vm.charts.warm.relative + _vm.charts.hot.relative),
        "colors": ['#00828E', '#3a3e50'],
        "values": _vm.charts.cold.absolute === 0 ? [0, 100] : [_vm.charts.cold.relative, 100 - 100 * (_vm.charts.cold.absolute / _vm.leads)],
        "labels": ['Residential', 'Non-Residential']
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-1"
    }, [_c('h4', [_vm._v(_vm._s(_vm.charts.cold.absolute))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.cold')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1"
    }, [(_vm.isCharts) ? _c('pie-chart', {
      attrs: {
        "rotation": _vm.percentageToDegrees(_vm.charts.warm.relative + _vm.charts.hot.relative + _vm.charts.cold.relative),
        "colors": ['#9198AB', '#3a3e50'],
        "values": _vm.charts.unclassified.absolute === 0 ? [0, 100] : [_vm.charts.unclassified.relative, 100 - 100 * (_vm.charts.unclassified.absolute / _vm.leads)],
        "labels": ['Residential', 'Non-Residential']
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-1"
    }, [_c('h4', [_vm._v(_vm._s(_vm.charts.unclassified.absolute))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.unclassified')))])])])]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading": _vm.isLoading
    }
  }, [
    [_c('div', {
      staticClass: "active-leads-wrapper"
    }, [_c('div', {
      staticClass: "widget-header"
    }, [_c('h4', {
      staticClass: "inline-block"
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.label')))])]), _vm._v(" "), _c('div', {
      staticClass: "card-wrapper row"
    }, _vm._l((_vm.mostActiveLeads), function(mostActiveLead) {
      return _c('div', {
        key: mostActiveLead.index,
        staticClass: "lead-card col-xs-4 col-md-2"
      }, [_c('div', {
        staticClass: "icon-classification"
      }, [(mostActiveLead.classification === 'warm') ? _c('img', {
        staticClass: "align-center",
        attrs: {
          "src": __webpack_require__(460)
        }
      }) : (mostActiveLead.classification === 'hot') ? _c('img', {
        staticClass: "align-center",
        attrs: {
          "src": __webpack_require__(459)
        }
      }) : (mostActiveLead.classification === 'cold') ? _c('img', {
        staticClass: "align-center",
        attrs: {
          "src": __webpack_require__(456)
        }
      }) : _c('img', {
        staticClass: "align-center",
        attrs: {
          "src": __webpack_require__(458)
        }
      })]), _vm._v(" "), _c('div', [_c('p', {
        staticClass: "truncate-text"
      }, [_vm._v("\n                    " + _vm._s(mostActiveLead.name))]), _vm._v(" "), _c('p', {
        staticClass: "caption truncate-text"
      }, [_vm._v(_vm._s(mostActiveLead.company))])])])
    }), 0)])]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-valid-email",
    class: _vm.classes
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification"
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('div', {
      key: index
    }, [(notification.visible && notification.title) ? _c('div', {
      ref: notification.id,
      refInFor: true,
      staticClass: "toast add-margin",
      class: _vm.classes(notification)
    }, [_c('div', {
      staticClass: "toast__icon"
    }, [(notification.type == 'info') ? _c('div', [_vm._m(0, true)]) : (notification.type == 'error') ? _c('div', [_vm._m(1, true)]) : (notification.type == 'success') ? _c('div', [_vm._m(2, true)]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "toast__content"
    }, [_c('p', {
      staticClass: "toast__type"
    }, [_vm._v(_vm._s(_vm.$t(notification.title)))])]), _vm._v(" "), _c('div', {
      staticClass: "toast__close",
      on: {
        "click": function($event) {
          return _vm.close(notification)
        }
      }
    }, [_c('i', {
      staticClass: "icon yule-icon-close-small"
    })])]) : _vm._e()])
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "icon yule-icon-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "icon yule-icon-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "icon yule-icon-success"
  })])
}]}

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-between"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('div', {
    attrs: {
      "id": _vm.formId
    },
    on: {
      "hileadzz_form_loaded": _vm.disableForm
    }
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.$t('ui.external_form.preview_page.forms_cannot_be_submitted')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-5 col-xl-5"
  }, [_c('div', {
    staticClass: "preview-right-box"
  }, [_c('h3', {
    staticClass: "preview-title is-margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.title')) + "\n      ")]), _vm._v(" "), _c('h4', {
    staticClass: "is-margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.head_section_title')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "preview-paragraph"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.head_paragraph')) + "\n      ")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "preview-code",
    domProps: {
      "innerHTML": _vm._s(_vm.headCode)
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "is-margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.html_section_title')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "preview-paragraph"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.html_paragraph')) + "\n      ")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "preview-code",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlCode)
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "is-margin-bottom-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.script_section_title')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "preview-paragraph"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.preview_page.script_paragraph')) + "\n      ")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "preview-code",
    domProps: {
      "innerHTML": _vm._s(_vm.scriptCode)
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-show-with-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.routeParams,
      "data-action": _vm.model + '.show',
      "data-action-id": _vm.item.id
    }
  }, [_vm._v(_vm._s(_vm.value))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field free-drawing"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), (!_vm.required) ? _c('em', {
    staticClass: "optional"
  }, [_vm._v("optional")]) : _vm._e(), (_vm.required) ? _c('em', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "draw-canvas-wrapper",
    on: {
      "click": _vm.canvasExport,
      "touchend": _vm.canvasExport
    }
  }, [_c('canvas', {
    staticClass: "draw-canvas",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "draw-canvas-clear icon yule-icon-refresh",
    on: {
      "click": _vm.canvasClean
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "draw-canvas-navigation"
  }, [_c('div', {
    staticClass: "btn draw-canvas-navigation--left",
    class: {
      'is-disabled': !_vm.leftScrollable
    },
    on: {
      "click": function($event) {
        return _vm.scroll(-50)
      }
    }
  }, [_vm._v("left")]), _vm._v(" "), _c('div', {
    staticClass: "btn draw-canvas-navigation--right",
    class: {
      'is-disabled': !_vm.rightScrollable
    },
    on: {
      "click": function($event) {
        return _vm.scroll(50)
      }
    }
  }, [_vm._v("right")])]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t(_vm.error)))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-container"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  })], 1), _vm._v(" "), _c('general-listing', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.collectionData,
      "params": {
        global_sorting: true,
        sort_by: this.query.sort_by,
        sort_order: this.query.sort_order
      },
      "model": "user",
      "has_searched": _vm.has_searched
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  }), _vm._v(" "), _c('user-invite'), _vm._v(" "), _c('user-invite-xls')], 1)
},staticRenderFns: []}

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trackings && _vm.statistics) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card--content"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card--header-left"
  }, [_c('strong', [_vm._v(_vm._s(_vm.leadsPerDay))]), _vm._v(" " + _vm._s(_vm.$t('statistics.leads_per_day')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card--header-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.leadsPerDetector))]), _vm._v(" " + _vm._s(_vm.$t('statistics.leads_per_lead_detector')) + "\n      ")])]), _vm._v(" "), (_vm.trackings.resources) ? _c('div', [(_vm.leadsCount) ? _c('leads-count-chart', {
    attrs: {
      "start-date": _vm.startDate,
      "end-date": _vm.endDate,
      "leads-count": _vm.leadsCount
    }
  }) : _c('div', {
    staticClass: "is-empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.no_data')) + "\n      ")])], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "onboarding-modal"
    }
  }, [_c('div', {
    staticClass: "onboarding-modal"
  }, [(_vm.hasMask) ? _c('div', {
    staticClass: "onboarding-modal__mask",
    on: {
      "click": _vm.clickMask
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "onboarding-modal__wrapper"
  }, [_vm._t("default"), _vm._v(" "), (_vm.hasX) ? _c('div', {
    staticClass: "onboarding-modal__x",
    on: {
      "click": _vm.clickX
    }
  }, [_vm._v("×")]) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.newValue) ? _c('div', {
    staticClass: "quantity-selection--item"
  }, [_c('select', {
    staticClass: "quantity-selection--select notranslate",
    class: {
      'is-selected': this.newValue > 0
    },
    attrs: {
      "name": _vm.item.value,
      "id": _vm.item.value
    },
    on: {
      "change": _vm.change
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.item.name) + ": " + _vm._s(_vm.newValue))]), _vm._v(" "), _vm._l((_vm.selectRange), function(number) {
    return _c('option', {
      key: number - 1,
      domProps: {
        "value": number - 1
      }
    }, [_vm._v("\n      " + _vm._s(number - 1) + "\n    ")])
  })], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-route-tab', _vm._b({
    on: {
      "click": _vm.onClick
    }
  }, 'q-route-tab', _vm.objectBindings, false), [_vm._v("\n  " + _vm._s(_vm.translatedLabel) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-change-company"
  }, [_c('modal', {
    attrs: {
      "title": "",
      "open": _vm.isOpen,
      "saveText": "Confirm"
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('auto-complete', {
    attrs: {
      "model": "organization-companies",
      "label": "Select Company",
      "placeholder": "Search...",
      "name": "value",
      "item": _vm.item,
      "autofocus": true,
      "acMinCharacters": 3
    },
    on: {
      "change": _vm.updateVal
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "open": _vm.confirmUpdateOpen,
      "title": _vm.$t('ui.contacts.modals.update.title'),
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": _vm.$t('ui.global.save')
    },
    on: {
      "save": _vm.update,
      "cancel": _vm.cancel
    }
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.$t("ui.global.update_conformation", {
    name: _vm.$tc("ui.contacts.enumeration", _vm.selected, {
      n: _vm.selected
    })
  })) + "\n      ")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs--inner"
  }, _vm._l((_vm.tabs), function(tab) {
    return (tab.active !== false) ? _c('div', {
      key: tab.name,
      class: {
        'tab': true, 'is-active': _vm.activeTab == tab.name
      },
      on: {
        "click": function($event) {
          return _vm.setTab(tab.name)
        }
      }
    }, [_c('div', {
      staticClass: "tab--name"
    }, [_vm._v("\n        " + _vm._s(tab.title) + "\n      ")])]) : _vm._e()
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "50%",
      "margin-top": "6px"
    },
    attrs: {
      "id": _vm.identifier
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workflow-update update-form row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row gutter-lg"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_vm._v("\n        Status: " + _vm._s(_vm.item.status) + "\n        "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "workflow-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "name",
      "label": "models.workflow.name",
      "placeholder": "My Workflow"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "name": "scope",
      "type": "radio",
      "model": "workflow",
      "collection": _vm.workflowScopes
    },
    model: {
      value: (_vm.workflowScope),
      callback: function($$v) {
        _vm.workflowScope = $$v
      },
      expression: "workflowScope"
    }
  }), _vm._v(" "), (_vm.workflowScope == 'project') ? _c('div', [(_vm.projects.length > 0) ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.list'),
      expression: "'projects.list'"
    }],
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "workflow",
      "name": "project",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.projects
    },
    model: {
      value: (_vm.item.project_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "project_id", $$v)
      },
      expression: "item.project_id"
    }
  }) : _c('p', [_c('i', [_vm._v(_vm._s(_vm.$t('models.workflow.loading_projects')))])])], 1) : _vm._e(), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "workflow",
      "name": "frequency",
      "type": "select",
      "collection": _vm.frequencies
    },
    model: {
      value: (_vm.item.frequency),
      callback: function($$v) {
        _vm.$set(_vm.item, "frequency", $$v)
      },
      expression: "item.frequency"
    }
  }), _vm._v(" "), (_vm.shouldShowDailyRuntime) ? _c('field', {
    attrs: {
      "required": _vm.shouldShowDailyRuntime,
      "errors": _vm.errors,
      "model": "workflow",
      "name": "daily_runtime",
      "type": "select",
      "collection": _vm.hours,
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.item.daily_runtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "daily_runtime", $$v)
      },
      expression: "item.daily_runtime"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field field-text"
  }, [_c('label', {
    attrs: {
      "for": "first_run"
    }
  }, [_vm._v(_vm._s(_vm.$t('models.workflow.first_run')))]), _vm._v(" "), _c('datetime', {
    staticClass: "text-input",
    attrs: {
      "format": "DD/MM/YYYY H:i:s",
      "id": "first_run"
    },
    model: {
      value: (_vm.firstRun),
      callback: function($$v) {
        _vm.firstRun = $$v
      },
      expression: "firstRun"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field field-text"
  }, [_c('label', {
    attrs: {
      "for": "final_run"
    }
  }, [_vm._v(_vm._s(_vm.$t('models.workflow.final_run')))]), _vm._v(" "), _c('datetime', {
    staticClass: "text-input",
    attrs: {
      "format": "DD/MM/YYYY H:i:s",
      "id": "final_run"
    },
    model: {
      value: (_vm.finalRun),
      callback: function($$v) {
        _vm.finalRun = $$v
      },
      expression: "finalRun"
    }
  })], 1), _vm._v(" "), _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('is_root'),
      expression: "'is_root'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "workflow",
      "name": "execute_on",
      "type": "textarea",
      "required": true,
      "value": _vm.executeOn
    },
    on: {
      "input": _vm.executeOnChange
    }
  }), _vm._v(" "), _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('is_root'),
      expression: "'is_root'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "workflow",
      "name": "configuration",
      "type": "textarea",
      "required": true,
      "value": _vm.configuration
    },
    on: {
      "input": _vm.configurationChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('collection', _vm._b({
    attrs: {
      "loading": _vm.loading,
      "data": _vm.data,
      "structure": _vm.structure,
      "has_searched": _vm.has_searched,
      "params": _vm.params,
      "model": "project"
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  }, 'collection', _vm.data.id, false))
},staticRenderFns: []}

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "value-crud-action"
  }, [(!_vm.exclude.includes('show')) ? _c('collection-value-show-action', {
    attrs: {
      "item": _vm.item,
      "model": _vm.model
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.exclude.includes('edit')) ? _c('collection-value-edit-action', {
    attrs: {
      "item": _vm.item,
      "model": _vm.model
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.exclude.includes('delete')) ? _c('collection-value-delete-action', {
    attrs: {
      "item": _vm.item,
      "model": _vm.model
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "logo--text"
  }, [_c('logo', {
    attrs: {
      "logoType": "login"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-form"
  }, [(_vm.source == 'logout') ? _c('h2', [_vm._v(_vm._s(_vm.$t('ui.pages.logout')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('ui.pages.login')))]), _vm._v(" "), (_vm.source == 'logout') ? _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.logout_details')))]) : _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.login_details')))]), _vm._v(" "), _c('form', {
    staticClass: "login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "me@example.com",
      "label": "ui.auth.email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "name": "password",
      "autocomplete": "current-password",
      "type": "password",
      "placeholder": _vm.placeholder,
      "label": "ui.auth.password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-login",
    attrs: {
      "type": "submit",
      "data-action": "user.login"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.auth.button')))])]), _vm._v(" "), _c('form-switch', {
    attrs: {
      "model": "auth",
      "name": "remember_me"
    },
    model: {
      value: (_vm.remember_me),
      callback: function($$v) {
        _vm.remember_me = $$v
      },
      expression: "remember_me"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    staticClass: "forgot-password",
    attrs: {
      "to": {
        name: 'password_reset_request'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.auth.password_reset')))])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts-page"
  }, [_c('div', {
    class: _vm.loading ? 'hidden' : ''
  }, [_c('filter-results', {
    attrs: {
      "refresh": _vm.key,
      "filtersFromParams": _vm.filtersFromParams
    },
    on: {
      "updateFilters": _vm.updateFilters,
      "updateSearch": _vm.updateSearch,
      "fetchDataComplete": _vm.fetchDataComplete,
      "selectedItemsChange": _vm.selectedItemsChange,
      "companyId": _vm.bulkAddToCompany
    }
  }), _vm._v(" "), _c('upload-contacts', {
    attrs: {
      "isOpen": _vm.importOpen
    },
    on: {
      "contactUploadComplete": _vm.contactUploadComplete,
      "contactUploadCancelled": _vm.contactUploadCancelled
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "contacts-page-loader",
    class: _vm.loading ? '' : 'hidden'
  }, [_c('loading')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "title": _vm.$t('ui.segments.create_modal.title'),
      "open": _vm.createSegmentOpen
    },
    on: {
      "save": function($event) {
        return _vm.createSegmentCommit()
      },
      "cancel": function($event) {
        return _vm.closeCreateSegmentModal()
      }
    }
  }, [_c('field', {
    attrs: {
      "label": _vm.$t('ui.segments.create_modal.field_label'),
      "autofocus": true
    },
    model: {
      value: (_vm.createSegmentName),
      callback: function($$v) {
        _vm.createSegmentName = $$v
      },
      expression: "createSegmentName"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "businesskit-modal",
    attrs: {
      "title": _vm.$t('ui.segments.add_to_project_modal.title'),
      "open": _vm.addToProjectModalOpen,
      "saveText": _vm.$t('ui.segments.add_to_project_modal.add_button'),
      "saveDisabled": !_vm.project.id
    },
    on: {
      "save": function($event) {
        return _vm.addToProject()
      },
      "cancel": function($event) {
        return _vm.closeAddToProjectModalOpen()
      }
    }
  }, [(_vm.projects.length > 0) ? _c('div', [_c('auto-complete', {
    staticClass: "add_to_project-autocomplete",
    attrs: {
      "model": "organization-projects",
      "type": "text",
      "label": "empty",
      "name": "value",
      "item": _vm.project,
      "init": "none",
      "autofocus": true,
      "placeholder": _vm.$t('ui.segments.add_to_project_modal.search_label')
    },
    on: {
      "change": _vm.selectProject
    }
  })], 1) : _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('ui.segments.add_to_project.empty')) + "\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchbar--wrapper"
  }, [_c('span', {
    staticClass: "icon searchbar--icon yule-icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    ref: "searchbar",
    staticClass: "searchbar--input",
    attrs: {
      "type": "text",
      "placeholder": _vm.computedPlaceholder
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bk-modal-wrapper"
  }, [_c('modal', {
    staticClass: "businesskit-modal",
    attrs: {
      "title": _vm.$t('ui.segments.businesskits_modal.title'),
      "open": _vm.sendBusinessKitModalOpen,
      "saveText": _vm.$t('ui.segments.businesskits_modal.send'),
      "saveDisabled": !(_vm.selectedBusinessKitId && _vm.emailTemplatesChecked)
    },
    on: {
      "save": function($event) {
        return _vm.sendBusinessKits()
      },
      "cancel": function($event) {
        return _vm.closeSendBusinessKitModalOpen()
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "businesskit-header-modal"
        }, [_c('img', {
          attrs: {
            "src": __webpack_require__(1421)
          }
        })])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('p', {
    staticClass: "title-subtext"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('ui.segments.business_kit.subtext')) + "\n    ")]), _vm._v(" "), (_vm.businessKits.length > 0) ? _c('div', [_c('field', {
    staticClass: "businesskit-select",
    attrs: {
      "model": "business_kit",
      "name": "select",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.businessKits,
      "value": _vm.selectedBusinessKitId,
      "autofocus": true
    },
    on: {
      "input": _vm.selectBusinessKit
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-bk is-margin-top-10"
  }, [(_vm.selectedBusinessKitUrl) ? _c('a', {
    staticClass: "link",
    attrs: {
      "href": this.selectedBusinessKitUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ui.segments.business_kit.preview')) + "\n        ")]) : _vm._e()])], 1) : _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('ui.pages.lead-no-businesskit')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "segment-info"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('ui.segments.business_kit.segment_title')) + ":")]), _vm._v(" "), _c('h4', {
    staticClass: "info-text"
  }, [_vm._v("\n        " + _vm._s(this.segment && this.segment.name) + " (" + _vm._s(_vm.contactsCount) + " " + _vm._s(_vm.$t('ui.segments.business_kit.contacts')) + ")\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "email-template-info"
  }, [_c('p', {
    staticClass: "info-text"
  }, [_c('q-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$t('ui.segments.business_kit.email_templates_confirmation')
    },
    model: {
      value: (_vm.emailTemplatesChecked),
      callback: function($$v) {
        _vm.emailTemplatesChecked = $$v
      },
      expression: "emailTemplatesChecked"
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assignment-item",
    on: {
      "click": _vm.input
    }
  }, [_c('field', {
    ref: "input",
    staticClass: "no-margin assignment-input",
    attrs: {
      "type": "checkbox",
      "value": _vm.assigned,
      "collection": [{
        value: true
      }],
      "label": "empty",
      "name": _vm.item.id.toString(),
      "params": {
        'no_i18n': true
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "assignment-label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.shouldShowNotAllowedModal) ? _c('permission-not-allowed-modal') : _vm._e(), _vm._v(" "), (!_vm.current_plan_active) ? _c('upgrade-free-trial') : _vm._e(), _vm._v(" "), (this.shouldShowOnboarding) ? _c('onboarding') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [(_vm.isBoolean) ? _c('form-switch', {
    attrs: {
      "errors": _vm.errors,
      "model": "plan",
      "name": _vm.name,
      "value": _vm.value
    },
    model: {
      value: (_vm.rules[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.rules, _vm.name, $$v)
      },
      expression: "rules[name]"
    }
  }) : _c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "plan",
      "name": _vm.name,
      "value": _vm.value
    },
    model: {
      value: (_vm.rules[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.rules, _vm.name, $$v)
      },
      expression: "rules[name]"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popper', _vm._b({}, 'popper', _vm.optionsComputed, false), [_c('div', {
    staticClass: "popper"
  }, [_vm._v("\n    " + _vm._s(_vm.options.content) + "\n  ")]), _vm._v(" "), _vm._t("default", null, {
    "slot": "reference"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-show"
  }, [_vm._v(_vm._s(_vm.fullname))])
},staticRenderFns: []}

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "title": _vm.modalTitle,
      "open": _vm.isOpen,
      "saveText": _vm.modalSaveText
    },
    on: {
      "save": _vm.fileUpload,
      "cancel": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "user-xls-invite"
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$t('ui.users.xls_invite_description')) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('ui.users.xls_invite_format')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "xls-upload"
  }, [_c('upload-field', {
    on: {
      "change": _vm.fileChange
    }
  })], 1), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "errors"
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-wrapper"
  }, [_c('q-layout-header', {
    attrs: {
      "id": "navigation"
    }
  }, [_c('q-toolbar', {
    staticClass: "navigation",
    attrs: {
      "color": "brand"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('logo')], 1), _vm._v(" "), (_vm.compressed) ? _c('div', {
    staticClass: "navigation--compressed"
  }, [_c('div', {
    staticClass: "navigation-subtitle"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.compressedSubtitle.link
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "navigation-title no-margin"
  }, [_vm._v(_vm._s(_vm.compressedTitle))]), _vm._v(" "), _c('div', {
    staticClass: "right-align"
  }, [(_vm.compressedUnpublishedChanges > 0) ? _c('div', {
    staticClass: "unpublished-changes"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.drag_editor.unpublished_changes")) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('add-button')], 1)]) : _c('div', [_c('q-tabs', {
    attrs: {
      "color": "brand"
    }
  }, [_vm._l((_vm.mainNavigation), function(routes) {
    return (_vm.allowedInPlan(routes.label)) ? _c(Array.isArray(routes.submenu) ?
      'q-route-tab' :
      'authenticated-navigation-item', {
        directives: [{
          name: "can",
          rawName: "v-can",
          value: (routes.credential),
          expression: "routes.credential"
        }],
        key: routes.label,
        tag: "q-route-tab",
        class: Array.isArray(routes.submenu) ? 'submenu' : '',
        attrs: {
          "slot": "title",
          "exact": "",
          "bindings": _vm.getBindings(routes),
          "to": Array.isArray(routes.submenu) ? "" : '',
          "auth": routes.auth,
          "label": Array.isArray(routes.submenu) ?
            _vm.$t('ui.menu.' + routes.label) :
            routes.label
        },
        nativeOn: {
          "click": function($event) {
            return _vm.onClick(routes)
          }
        },
        slot: "title"
      }, [(Array.isArray(routes.submenu)) ? _c('q-popover', {
        staticClass: "navigation-dropdown",
        attrs: {
          "fit": ""
        }
      }, [_c('q-tabs', {
        staticClass: "dropdown",
        attrs: {
          "align": "center",
          "color": "brand"
        }
      }, _vm._l((routes.submenu), function(subroutes) {
        return (_vm.allowedInPlan(subroutes.label)) ? _c("authenticated-navigation-item", {
          directives: [{
            name: "can",
            rawName: "v-can",
            value: (subroutes.credential),
            expression: "subroutes.credential"
          }],
          key: subroutes.label,
          tag: "q-route-tab",
          attrs: {
            "slot": "title",
            "exact": "",
            "hidden": subroutes.disabled,
            "bindings": _vm.getBindings(subroutes),
            "auth": subroutes.auth,
            "label": subroutes.label
          },
          on: {
            "click": function($event) {
              return _vm.onClick(subroutes)
            },
            "close": function($event) {
              return _vm.close()
            }
          },
          slot: "title"
        }) : _vm._e()
      }), 1)], 1) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('q-route-tab', {
    staticClass: "submenu",
    attrs: {
      "slot": "title",
      "to": "",
      "exact": ""
    },
    slot: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.menu.content_manager")) + "\n            "), _c('q-popover', {
    ref: "contentManager",
    staticClass: "navigation-dropdown",
    attrs: {
      "fit": ""
    }
  }, [_c('q-tabs', {
    staticClass: "dropdown",
    attrs: {
      "align": "center",
      "color": "brand"
    }
  }, [_vm._l((_vm.contentManager), function(routes) {
    return (_vm.allowedInPlan(routes.label)) ? _c("authenticated-navigation-item", {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: (routes.credential),
        expression: "routes.credential"
      }],
      key: routes.label,
      tag: "q-route-tab",
      attrs: {
        "slot": "title",
        "exact": "",
        "bindings": _vm.getBindings(routes),
        "auth": routes.auth,
        "label": routes.label
      },
      on: {
        "close": function($event) {
          return _vm.close()
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.onClick()
        }
      },
      slot: "title"
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-title-tab"
  }, [_vm._v("Engagement")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.businessKitLink,
      "target": "_blank"
    }
  }, [_c('q-tab', {
    staticClass: "content-start businesskit-tab"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("ui.menu.businesskits")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(285),
      "alt": ""
    }
  })])], 1)], 2)], 1)], 1), _vm._v(" "), _c('q-route-tab', {
    staticClass: "submenu account",
    attrs: {
      "slot": "title",
      "to": "",
      "exact": ""
    },
    slot: "title"
  }, [_c('user-image', {
    attrs: {
      "firstname": _vm.currentUser.firstname,
      "lastname": _vm.currentUser.lastname,
      "email": _vm.currentUser.email == 'unknown' ? '' : _vm.currentUser.email,
      "theme": "sensual"
    }
  }), _vm._v(" "), _c('q-popover', {
    ref: "account",
    staticClass: "navigation-dropdown account-overlay dropdown",
    attrs: {
      "fit": ""
    }
  }, [_c('language-switcher'), _vm._v(" "), (_vm.userId) ? _c('q-tabs', {
    staticClass: "dropdown",
    attrs: {
      "align": "center",
      "color": "brand"
    }
  }, _vm._l((_vm.account), function(routes) {
    return (_vm.allowedInPlan(routes.label)) ? _c("authenticated-navigation-item", {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: (routes.credential),
        expression: "routes.credential"
      }],
      key: routes.label,
      tag: "q-route-tab",
      attrs: {
        "slot": "title",
        "exact": "",
        "bindings": _vm.getBindings(routes),
        "auth": routes.auth,
        "label": routes.label
      },
      on: {
        "close": function($event) {
          return _vm.close()
        }
      },
      slot: "title"
    }) : _vm._e()
  }), 1) : _vm._e()], 1)], 1)], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.computedClasses,
    attrs: {
      "id": "app"
    }
  }, [_c('q-layout', [_c('div', {
    staticClass: "header-container"
  }, [_c('navigation', {
    attrs: {
      "id": "desktop-nav"
    }
  }), _vm._v(" "), _c('mobile-navigation', {
    attrs: {
      "id": "mobile-nav"
    }
  })], 1), _vm._v(" "), (!_vm.isPageContent && !_vm.isShowingOnboarding) ? _c('secondary-header', {
    class: {
      'hidden': _vm.isRetrieving
    }
  }) : _vm._e(), _vm._v(" "), (this.isRetrieving) ? _c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('loading')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'main-content': true, 'main-content--lead': _vm.isPageLead, 'main-content--projects': _vm.isPageProjects, 'main-content--projects': _vm.isPageProjectNew, 'empty-state-projects': _vm.emptyStateProjects, 'empty-state-leads': _vm.emptyStateLeads, 'main-content--manager': _vm.isPageContent, 'hidden': _vm.isRetrieving
    }
  }, [_c('q-page-container', [_c('router-view', {
    key: _vm.$route.fullPath,
    staticClass: "router-view",
    on: {
      "logout": function($event) {
        return _vm.$emit('logout')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('app-footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-progress"
  }, [_c('progress-bar', {
    attrs: {
      "percentage": _vm.value,
      "isMini": true
    }
  }), _c('span', {
    staticClass: "progress-percentage"
  }, [_vm._v(_vm._s(_vm.value.toFixed(0)) + "%")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.hiddenElement()
  }, [(_vm.groupType == 'field' && _vm.name != 'company') ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('project_leads.update'),
      expression: "'project_leads.update'"
    }],
    class: _vm.elem_class,
    attrs: {
      "errors": _vm.errors,
      "model": "project_lead",
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.elem_type,
      "required": _vm.element.required,
      "params": _vm.element.params,
      "collection": _vm.element.allowed_values,
      "defaultValue": _vm.element.default_value,
      "placeholder": _vm.placeholder,
      "label": _vm.label,
      "fromLeadMask": true,
      "enrich_tags": _vm.element.enrich_tags
    },
    on: {
      "change": _vm.change,
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'field' && _vm.name == 'company') ? _c('auto-complete', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('project_leads.update'),
      expression: "'project_leads.update'"
    }],
    staticClass: "autofill",
    class: _vm.elem_class,
    attrs: {
      "model": "project_lead",
      "name": _vm.name,
      "item": _vm.item,
      "label": _vm.label,
      "fromLeadMask": true,
      "type": _vm.elem_type,
      "required": _vm.element.required,
      "params": _vm.element.params,
      "collection": _vm.items,
      "init": _vm.item[_vm.name],
      "placeholder": _vm.placeholder
    },
    on: {
      "populate-fields": _vm.populateFields,
      "change": _vm.updateName
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'readonly') ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('project_leads.update'),
      expression: "'project_leads.update'"
    }],
    class: _vm.elem_class,
    attrs: {
      "errors": _vm.errors,
      "model": "project_lead",
      "readonly": true,
      "name": _vm.name,
      "id": _vm.name,
      "type": "text",
      "required": _vm.element.required,
      "params": _vm.element.params,
      "collection": _vm.element.allowed_values,
      "defaultValue": _vm.element.default_value,
      "placeholder": _vm.placeholder,
      "label": _vm.label,
      "fromLeadMask": true
    },
    on: {
      "change": _vm.change,
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'quantity_selection') ? _c('quantity-selection', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('project_leads.update'),
      expression: "'project_leads.update'"
    }],
    class: _vm.elem_class,
    attrs: {
      "errors": _vm.errors,
      "model": "project_lead",
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.elem_type,
      "required": _vm.element.required,
      "params": _vm.element.params,
      "collection": _vm.element.allowed_values,
      "defaultValue": _vm.element.default_value,
      "label": _vm.label
    },
    on: {
      "change": _vm.change,
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'country_select') ? _c('country-select', {
    attrs: {
      "errors": _vm.errors,
      "name": _vm.name,
      "params": _vm.element.params,
      "id": _vm.name,
      "model": "project_lead",
      "label": _vm.label,
      "fromLeadMask": true,
      "required": _vm.required,
      "language": _vm.language
    },
    on: {
      "change": function($event) {
        return _vm.bus(_vm.data)
      },
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'tag_list') ? _c('tag-list', {
    attrs: {
      "errors": _vm.errors,
      "name": _vm.name,
      "model": "project_lead",
      "id": _vm.name,
      "required": _vm.required,
      "label": _vm.label,
      "fromLeadMask": true
    },
    on: {
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'free_drawing') ? _c('free-drawing', {
    attrs: {
      "errors": _vm.errors,
      "name": _vm.name,
      "id": _vm.name,
      "model": "project_lead",
      "required": _vm.required,
      "label": _vm.label
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'crawled_info') ? _c('crawled-infos', {
    class: _vm.elem_class,
    attrs: {
      "type": _vm.elem_type,
      "params": _vm.element.params,
      "item": _vm.item
    }
  }) : (_vm.groupType == 'date') ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('datepicker', {
    class: _vm.elem_class,
    attrs: {
      "item": _vm.item,
      "name": _vm.name,
      "id": _vm.name,
      "required": _vm.required,
      "errors": _vm.errors,
      "label": _vm.label,
      "clear-button": true,
      "language": _vm.getDatePickerLanguage()
    },
    on: {
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  })], 1) : (_vm.groupType == 'title') ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.element.content))])]) : (_vm.groupType == 'paragraph') ? _c('div', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.element.content)
    }
  })]) : (_vm.groupType == 'container') ? _c('div', {
    staticClass: "element",
    class: _vm.elem_class
  }, _vm._l((_vm.element.children), function(element) {
    return _c('lead-mask-element', {
      key: element.name,
      attrs: {
        "type": element.element_type,
        "element": element,
        "name": element.name,
        "label": element.label,
        "errors": _vm.errors,
        "language": _vm.language,
        "item": _vm.item
      },
      on: {
        "populate-fields": _vm.populateFields
      }
    })
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('modal', {
    attrs: {
      "open": _vm.isOpen,
      "title": _vm.createTitle
    },
    on: {
      "cancel": _vm.cancel,
      "save": _vm.save
    }
  }, [_c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "external_form",
      "name": "name",
      "placeholder": "Form Name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "external_form",
      "name": "language",
      "type": "radio",
      "collection": _vm.languageGetter,
      "defaultValue": _vm.currentLanguage
    },
    model: {
      value: (_vm.item.language),
      callback: function($$v) {
        _vm.$set(_vm.item, "language", $$v)
      },
      expression: "item.language"
    }
  }), _vm._v(" "), _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.list'),
      expression: "'projects.list'"
    }],
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "external_form",
      "name": "project_id",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.projects
    },
    model: {
      value: (_vm.item.project_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "project_id", $$v)
      },
      expression: "item.project_id"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.total > 0) ? _c('div', {
    ref: "donut_chart",
    staticClass: "donut-chart"
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "open": _vm.open
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "assignment-top"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(_vm.$t(("ui.modals." + _vm.title))) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t(("ui.modals." + _vm.subtitle))) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "assignment-content"
  }, [_c('assignment-modal-search-bar', {
    attrs: {
      "placeholder": _vm.searchPlaceholder,
      "shouldFocus": _vm.shouldFocusSearchbar
    },
    on: {
      "search": _vm.search,
      "shouldFocusChange": _vm.setShouldFocus
    }
  }), _vm._v(" "), _vm._l((_vm.filteredCollection), function(element) {
    return _c('assignment-modal-element', {
      key: element,
      attrs: {
        "item": element,
        "displayName": _vm.displayName,
        "assignedCollection": _vm.internalAssignedCollection
      },
      on: {
        "input": _vm.assign
      }
    })
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading": _vm.isLoading,
      "is-panel": ""
    }
  }, [
    [_c('div', {
      staticClass: "latest-activity"
    }, [(_vm.activities.length > 0 && !_vm.isError) ? _c('div', [_c('div', {
      staticClass: "widget-header"
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('ui.dashboard.kit_activity_label')))])]), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, _vm._l((_vm.activities), function(activity, index) {
      return _c('div', {
        key: index,
        staticClass: "activity-item"
      }, [_c('div', {
        staticClass: "icon"
      }, [_c('user-image', {
        attrs: {
          "firstname": activity.lead.firstname,
          "lastname": activity.lead.lastname,
          "email": activity.lead.email,
          "theme": activity.lead.classification
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('router-link', {
        staticClass: "link",
        attrs: {
          "to": {
            name: 'project_lead_edit',
            params: {
              id: activity.lead.project_id,
              lead_id: activity.lead.id
            }
          }
        }
      }, [_c('div', [_vm._v("\n                      " + _vm._s(activity.name) + "\n                    ")])]), _vm._v(" "), (activity.interactions.isOpened) ? _c('p', {
        staticClass: "truncate-text"
      }, [_vm._v("\n                  " + _vm._s(_vm.$t('ui.dashboard.kit_activity.opened_kit')) + " "), _c('span', [_vm._v(_vm._s(activity.business_kit_name))]), _vm._v(" " + _vm._s(_vm.$t('ui.dashboard.kit_activity.opened')) + "\n                ")]) : _c('p', {
        staticClass: "truncate-text"
      }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.kit_activity.interacted_with')) + " "), _c('span', [_vm._v(_vm._s(activity.business_kit_name))])]), _vm._v(" "), (!activity.interactions.isOpened) ? _c('ul', [(activity.interactions.clicks > 0) ? _c('li', [_c('span', [_vm._v(_vm._s(_vm.$tc('ui.dashboard.kit_activity.click_content_card', activity.interactions.clicks, {
        count: activity.interactions.clicks
      })))])]) : _vm._e(), _vm._v(" "), (activity.interactions.views > 0) ? _c('li', [_c('span', [_vm._v(_vm._s(_vm.$tc('ui.dashboard.kit_activity.view_content_card', activity.interactions.views, {
        count: activity.interactions.views
      })))])]) : _vm._e()]) : _vm._e()], 1)])
    }), 0)]) : (_vm.activities.length === 0 && !_vm.isError) ? _c('div', {
      staticClass: "aligner"
    }, [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(204)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.activity_list_widget.empty_state_headline')))]), _vm._v(" "), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'project_new'
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.activity_list_widget.empty_state_intro')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('div', [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(204)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.widget_error')))])])]) : _vm._e()])]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circle",
    class: [_vm.theme, _vm.size]
  }, [_c('span', {
    staticClass: "initials"
  }, [_vm._v(_vm._s(_vm.userInitials()))])])
},staticRenderFns: []}

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-edit"
  }, [_c('modal', {
    staticClass: "edit-company-modal",
    attrs: {
      "title": "",
      "open": _vm.isOpen
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "required": "",
      "name": "name",
      "label": _vm.$t('ui.company.fields.name'),
      "autofocus": true
    },
    model: {
      value: (_vm.workingCompany.name),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany, "name", $$v)
      },
      expression: "workingCompany.name"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "website",
      "label": _vm.$t('ui.company.fields.website')
    },
    model: {
      value: (_vm.workingCompany.website),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany, "website", $$v)
      },
      expression: "workingCompany.website"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "street",
      "label": _vm.$t('ui.company.fields.street')
    },
    model: {
      value: (_vm.workingCompany.address.street),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany.address, "street", $$v)
      },
      expression: "workingCompany.address.street"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "number",
      "label": _vm.$t('ui.company.fields.street_number')
    },
    model: {
      value: (_vm.workingCompany.address.street_number),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany.address, "street_number", $$v)
      },
      expression: "workingCompany.address.street_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "city",
      "label": _vm.$t('ui.company.fields.city')
    },
    model: {
      value: (_vm.workingCompany.address.city),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany.address, "city", $$v)
      },
      expression: "workingCompany.address.city"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "zip",
      "label": _vm.$t('ui.company.fields.postcode')
    },
    model: {
      value: (_vm.workingCompany.address.zip),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany.address, "zip", $$v)
      },
      expression: "workingCompany.address.zip"
    }
  })], 1), _vm._v(" "), _c('country-select', {
    staticClass: "field",
    attrs: {
      "value": _vm.workingCountry,
      "type": "text",
      "params": {
        favorites: ['DE']
      },
      "name": "country",
      "label": _vm.$t('ui.company.fields.country')
    },
    on: {
      "input": function($event) {
        return _vm.setCountry($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('field', {
    attrs: {
      "label": _vm.label,
      "required": _vm.required,
      "classes": _vm.classes,
      "collection": _vm.countries,
      "name": _vm.name,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "type": "select",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.newValue),
      callback: function($$v) {
        _vm.newValue = $$v
      },
      expression: "newValue"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "value-action-duplicate"
  }, [_c('i', {
    staticClass: "icon yule-icon-duplicate",
    attrs: {
      "title": _vm.$t('models.external_form.duplicate_desc')
    },
    on: {
      "click": _vm.duplicate
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "value-action-pending"
  }, [_c('i', {
    staticClass: "icon yule-icon-clock",
    attrs: {
      "title": _vm.$t('models.external_form.pending_cloning')
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-update update-form container row"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('models.user.edit_user')))]), _vm._v(" "), _c('form', {
    staticClass: "user-update--form col-xs-12 col-sm-12 col-md-6 col-lg-6",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "firstname",
      "label": "models.user.firstname",
      "placeholder": "Andy"
    },
    model: {
      value: (_vm.item.firstname),
      callback: function($$v) {
        _vm.$set(_vm.item, "firstname", $$v)
      },
      expression: "item.firstname"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "lastname",
      "label": "models.user.lastname",
      "placeholder": "Kaufman"
    },
    model: {
      value: (_vm.item.lastname),
      callback: function($$v) {
        _vm.$set(_vm.item, "lastname", $$v)
      },
      expression: "item.lastname"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "readonly": true,
      "name": "email",
      "label": "models.user.email",
      "placeholder": "andykaufman@googlemail.com"
    },
    model: {
      value: (_vm.item.email),
      callback: function($$v) {
        _vm.$set(_vm.item, "email", $$v)
      },
      expression: "item.email"
    }
  }), _vm._v(" "), (_vm.item.role == 'admin') ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organization.list'),
      expression: "'organization.list'"
    }],
    attrs: {
      "errors": _vm.errors,
      "name": "organization",
      "label": "Organization",
      "type": "select",
      "params": {
        'no_i18n': true
      },
      "collection": _vm.organizations
    },
    model: {
      value: (_vm.item.organization_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "organization_id", $$v)
      },
      expression: "item.organization_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('user-status-select', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('users.update_status'),
      expression: "'users.update_status'"
    }],
    attrs: {
      "errors": _vm.errors,
      "name": "status",
      "label": "models.user.status"
    },
    model: {
      value: (_vm.item.status),
      callback: function($$v) {
        _vm.$set(_vm.item, "status", $$v)
      },
      expression: "item.status"
    }
  }), _vm._v(" "), _c('user-role-select', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('users.update_role'),
      expression: "'users.update_role'"
    }],
    attrs: {
      "errors": _vm.errors,
      "name": "roles",
      "label": "models.user.role"
    },
    model: {
      value: (_vm.item.role),
      callback: function($$v) {
        _vm.$set(_vm.item, "role", $$v)
      },
      expression: "item.role"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datetime-picker",
    style: ({
      width: _vm.width
    }),
    on: {
      "click": function($event) {
        return _vm.calendarClicked($event)
      },
      "blur": _vm.toggleCal
    }
  }, [_c('div', [_c('input', {
    attrs: {
      "type": "text",
      "readonly": _vm.readonly,
      "id": "tj-datetime-input",
      "required": _vm.required,
      "name": _vm.name,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.date
    },
    on: {
      "click": _vm.toggleCal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calender-div",
    class: {
      noDisplay: _vm.hideCal
    }
  }, [_c('div', {
    class: {
      noDisplay: _vm.hideDate
    }
  }, [_c('div', {
    staticClass: "year-month-wrapper"
  }, [_c('div', {
    staticClass: "month-setter"
  }, [_c('button', {
    staticClass: "nav-l",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.leftYear
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "year"
  }, [_vm._v(_vm._s(_vm.year))]), _vm._v(" "), _c('button', {
    staticClass: "nav-r",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rightYear
    }
  }, [_vm._v(">")])]), _vm._v(" "), _c('div', {
    staticClass: "month-setter"
  }, [_c('button', {
    staticClass: "nav-l",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.leftMonth
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "month"
  }, [_vm._v(_vm._s(_vm.month))]), _vm._v(" "), _c('button', {
    staticClass: "nav-r",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rightMonth
    }
  }, [_vm._v(">")])])]), _vm._v(" "), _c('div', {
    staticClass: "headers"
  }, _vm._l((_vm.days), function(port) {
    return _c('span', {
      key: port,
      staticClass: "days"
    }, [_vm._v(_vm._s(port))])
  }), 0), _vm._v(" "), _c('div', _vm._l((_vm.weeks), function(week, weekIndex) {
    return _c('div', {
      key: weekIndex,
      staticClass: "week"
    }, _vm._l((week), function(day, dayIndex) {
      return _c('span', {
        key: dayIndex,
        staticClass: "port",
        class: {
          activePort: (weekIndex * 7 + dayIndex) === _vm.activePort
        },
        on: {
          "click": function($event) {
            return _vm.setDay(weekIndex * 7 + dayIndex, day)
          }
        }
      }, [_vm._v("\n              " + _vm._s(day) + "\n            ")])
    }), 0)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "time-picker",
    class: {
      noDisplay: _vm.hideTime
    }
  }, [_c('div', {
    staticClass: "hour-selector"
  }, [_c('div', {
    attrs: {
      "id": "j-hour"
    },
    on: {
      "click": _vm.showHourSelector
    }
  }, [_vm._v(_vm._s(_vm.periodStyle === 12 && _vm.hour > 12 ? _vm.hour - 12 : _vm.hour))]), _vm._v(" "), _c('div', {
    ref: "hourScrollerWrapper",
    staticClass: "scroll-hider",
    class: {
      showSelector: _vm.hourSelectorVisible
    }
  }, [_c('ul', {
    ref: "hourScroller"
  }, _vm._l((_vm.hours), function(h, index) {
    return _c('li', {
      key: index,
      class: {
        active: index === _vm.hourIndex
      },
      on: {
        "click": function($event) {
          return _vm.setHour(index, true)
        }
      }
    }, [_vm._v(_vm._s(h))])
  }), 0)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "minute-selector"
  }, [_c('div', {
    attrs: {
      "id": "j-minute"
    },
    on: {
      "click": _vm.showMinuteSelector
    }
  }, [_vm._v(_vm._s(_vm.minute))]), _vm._v(" "), _c('div', {
    ref: "minuteScrollerWrapper",
    staticClass: "scroll-hider",
    class: {
      showSelector: _vm.minuteSelectorVisible
    }
  }, [_c('ul', {
    ref: "minuteScroller"
  }, _vm._l((_vm.minutes), function(m, index) {
    return _c('li', {
      key: index,
      class: {
        active: index === _vm.minuteIndex
      },
      on: {
        "click": function($event) {
          return _vm.setMinute(index, true)
        }
      }
    }, [_vm._v(_vm._s(m))])
  }), 0)])]), _vm._v(" "), (_vm.periodStyle === 12) ? _c('div', {
    staticClass: "time-separator"
  }, [_c('span', [_vm._v(":")])]) : _vm._e(), _vm._v(" "), (_vm.periodStyle === 12) ? _c('div', {
    staticClass: "minute-selector"
  }, [_c('div', {
    on: {
      "click": _vm.changePeriod
    }
  }, [_vm._v(_vm._s(_vm.period))])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "okButton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearDate
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('button', {
    staticClass: "okButton ok",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setDate
    }
  }, [_vm._v("OK")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-separator"
  }, [_c('span', [_vm._v(":")])])
}]}

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organizations.list'),
      expression: "'organizations.list'"
    }]
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  })], 1), _vm._v(" "), _c('collection', {
    attrs: {
      "data": _vm.items,
      "structure": _vm.collectionData,
      "model": "organization"
    },
    on: {
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-update-statistics lead-mask gutter-xs"
  }, [_c('div', {
    staticClass: "title-grid"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('ui.pages.lead-statistics-overview')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'project_lead_stats',
        params: {
          id: _vm.projectId,
          leadId: _vm.leadId
        }
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('statistics.see_full_statistics')) + "\n    ")])], 1), _vm._v(" "), (_vm.trackings.length > 0) ? _c('div', [_c('statistics-overview', {
    attrs: {
      "start-date": _vm.start_date.format(),
      "end-date": _vm.end_date.format(),
      "trackings": _vm.trackings,
      "stats": _vm.stats
    }
  })], 1) : _c('div', [_vm._v("\n    " + _vm._s(_vm.$t('statistics.no_data_7_days')) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-user-assignement "
  }, [_c('assignment-modal', {
    attrs: {
      "collection": _vm.filteredUsers,
      "assignedCollection": _vm.assignedUsersList,
      "title": _vm.computedTitle,
      "subtitle": _vm.computedSubtitle,
      "open": _vm.isOpen,
      "searchPlaceholder": "users",
      "displayName": "display_name"
    },
    on: {
      "close": _vm.close,
      "save": _vm.save
    }
  }), _vm._v(" "), (this.assignedUsers.length === 0) ? _c('div', {
    staticClass: "empty-state-assignment"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(431)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.pages.project-no-assigned-user')))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('span', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.isOpen = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.project-assign-user')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (this.assignedUsers.length > 0) ? _c('div', {
    staticClass: "project-user-assignement--monitor"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(_vm.$t('ui.pages.project-assigned-user')) + ":\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.isOpen = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.project-assign-user')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.assignedUsersList), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "user"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "user-name"
    }, [_c('div', {
      staticClass: "circle"
    }, [(user.firstname && user.lastname) ? _c('span', {
      staticClass: "initials"
    }, [_vm._v(_vm._s(("" + (user.firstname.charAt(0)) + (user.lastname.charAt(0)))))]) : _c('span', {
      staticClass: "initials"
    }, [_vm._v("?")])]), _vm._v(" "), _c('div', [(user.firstname && user.lastname) ? _c('span', [_vm._v(_vm._s(((user.firstname) + " " + (user.lastname))))]) : _c('span'), _vm._v(" "), _c('p', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(user.email))])])])])])
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trackings) ? _c('div', {
    staticClass: "tracking-table"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', {
    staticClass: "tracking-date"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_time')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-kit"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_kit')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-activity"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_activity')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-kit-activity"
  }, [_vm._v(_vm._s(_vm.$t('statistics.kit_and_activity')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-hint"
  })]), _vm._v(" "), _vm._l((_vm.trackings), function(tracking) {
    return _c('tr', {
      key: tracking.id,
      class: 'tracking-list-' + tracking.id
    }, [_c('td', {
      staticClass: "tracking-date"
    }, [_vm._v(_vm._s(_vm.date(tracking.time)))]), _vm._v(" "), _c('td', {
      staticClass: "tracking-kit"
    }, [_vm._v(_vm._s(tracking.event_name))]), _vm._v(" "), _c('td', {
      staticClass: "tracking-activity"
    }, [_vm._v(_vm._s(tracking.advertisement_name) + " " + _vm._s(_vm.$t('models.tracking.specific.' + tracking.name)) + " "), (tracking.referrer_url) ? _c('a', {
      staticClass: "icon icon-external-link",
      attrs: {
        "href": tracking.referrer_url,
        "target": "_blank"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "tracking-kit-activity"
    }, [_vm._v("\n        " + _vm._s(tracking.event_name)), (tracking.event_name) ? _c('br') : _vm._e(), _vm._v("\n        " + _vm._s(tracking.advertisement_name) + " " + _vm._s(_vm.$t('models.tracking.specific.' + tracking.name)) + " "), (tracking.referrer_url) ? _c('a', {
      staticClass: "icon icon-external-link",
      attrs: {
        "href": tracking.referrer_url,
        "target": "_blank"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "tracking-hint"
    }, [_c('div', {
      staticClass: "hint"
    }, [_c('i', {
      staticClass: "icon icon-info trigger"
    }), _vm._v(" "), _c('div', {
      staticClass: "hint-content"
    }, [_c('p', [_c('i', {
      staticClass: "icon icon-map-pin"
    }), _vm._v("\n              " + _vm._s(tracking.city) + "\n            ")]), _vm._v(" "), _c('p', [_c('i', {
      staticClass: "icon icon-monitor"
    }), _vm._v("\n              " + _vm._s(tracking.browser) + " | " + _vm._s(tracking.os) + "\n            ")])])])])])
  })], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-saver-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isModified) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "page-saver--message notranslate"
  }, [(_vm.changeCount > 0) ? _c('p', [
    [_vm._v("\n              " + _vm._s(_vm.$tc('ui.pages.lead-change-count', _vm.changeCount, {
      num: ("" + _vm.changeCount)
    })) + "\n            ")]
  ], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-saver--actions actions"
  }, [_c('button', {
    staticClass: "btn btn-flat btn-cancel",
    attrs: {
      "data-action": "item.cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "data-action": "item.update"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-show"
  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (this.styleObject)
  }, [(_vm.devices.length > 1) ? _c('a', {
    staticClass: "device-switcher icon yule-icon-refresh btn btn-rounded",
    on: {
      "click": _vm.switchDevice
    }
  }) : _vm._e(), _vm._v(" "), (this.streamIsPresent) ? _c('video', {
    ref: "video",
    attrs: {
      "width": this.width,
      "height": this.height,
      "autoplay": this.autoplay
    },
    domProps: {
      "srcObject": this.stream
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.item.id) ? _c('router-view', {
    attrs: {
      "item": _vm.item,
      "item_saved": _vm.item_saved
    },
    on: {
      "update": _vm.update
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-filter', {
    attrs: {
      "is-disabled": _vm.isDisabled
    },
    on: {
      "change": _vm.emitHandler
    }
  }, _vm._l((_vm.organizations), function(organization) {
    return _c('option', {
      key: organization.id,
      domProps: {
        "value": organization.id,
        "selected": organization.id === _vm.organizationId
      }
    }, [_vm._v("\n    " + _vm._s(organization.name) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.statistics) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card--content"
  }, [_c('div', {
    staticClass: "card--number"
  }, [_c('div', {
    staticClass: "card--number-value"
  }, [_vm._v("\n        " + _vm._s(_vm.leadsCount) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card--number-key"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.leads')) + "\n      ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card--diagram"
  }, [_c('div', {
    staticClass: "grid classification"
  }, [_c('div', {
    staticClass: "hot"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.leadsHotCount))]), _vm._v("\n          " + _vm._s(_vm.$t('statistics.leads_hot')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "warm"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.leadsWarmCount))]), _vm._v("\n          " + _vm._s(_vm.$t('statistics.leads_warm')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cold"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.leadsColdCount))]), _vm._v("\n          " + _vm._s(_vm.$t('statistics.leads_cold')) + "\n        ")])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "value-project-link",
    attrs: {
      "to": _vm.routeParams,
      "data-action": _vm.model + '.show',
      "data-action-id": _vm.item.project_id
    }
  }, [_c('div', {
    staticClass: "value-project-name--name"
  }, [_vm._v(_vm._s(_vm.item.project_name))])])
},staticRenderFns: []}

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    class: _vm.btnClassComputed,
    on: {
      "click": _vm.open
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "modal-box-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event)
      }
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "modal-box clean-this"
  }, [_c('div', {
    staticClass: "modal-box--content"
  }, [(_vm.title) ? _c('h3', {
    staticClass: "modal-box--title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('p', {}, [_vm._v("\n          " + _vm._s(_vm.content) + "\n        ")])]), _vm._v(" "), (_vm.footer) ? _c('div', {
    staticClass: "modal-box--footer"
  }, [_vm._v("\n        " + _vm._s(_vm.footer) + "\n      ")]) : (_vm.actions) ? _c('div', {
    staticClass: "modal-box--footer"
  }, _vm._l((_vm.actions), function(action) {
    return _c('button', {
      key: action.name,
      class: action.class,
      attrs: {
        "data-action": action.action
      },
      on: {
        "click": function($event) {
          return _vm.actionTrigger(action.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('ui.global.' + action.name)) + "\n        ")])
  }), 0) : _vm._e()]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-tab', {
    on: {
      "click": _vm.changeLanguage
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trackings) ? _c('div', {
    staticClass: "tracking-table"
  }, [(_vm.trackings.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', {
    staticClass: "tracking-date"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_time')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-lead"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_lead')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-kit"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_kit')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-activity"
  }, [_vm._v(_vm._s(_vm.$t('statistics.tracking_activity')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-kit-activity"
  }, [_vm._v(_vm._s(_vm.$t('statistics.lead_kit_and_activity')))]), _vm._v(" "), _c('th', {
    staticClass: "tracking-hint"
  })]), _vm._v(" "), _vm._l((_vm.trackings), function(tracking) {
    return _c('tr', {
      key: tracking.id,
      class: 'tracking-list-' + tracking.id
    }, [_c('td', {
      staticClass: "tracking-date"
    }, [_vm._v(_vm._s(_vm.date(tracking.time)))]), _vm._v(" "), _c('td', {
      staticClass: "tracking-lead"
    }, [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'project_lead_edit',
          params: {
            id: _vm.projectId,
            lead_id: tracking.lead_id
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.leadName(tracking)) + "\n        ")])], 1), _vm._v(" "), _c('td', {
      staticClass: "tracking-kit-activity"
    }, [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'project_lead_edit',
          params: {
            id: _vm.projectId,
            lead_id: tracking.lead_id
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.leadName(tracking)))]), _c('br'), _vm._v("\n        " + _vm._s(tracking.event_name)), (tracking.event_name) ? _c('br') : _vm._e(), _vm._v("\n        " + _vm._s(tracking.advertisement_name) + " " + _vm._s(_vm.$t('models.tracking.specific.' + tracking.name)) + " "), (tracking.referrer_url) ? _c('a', {
      staticClass: "icon icon-external-link",
      attrs: {
        "href": tracking.referrer_url,
        "target": "_blank"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "tracking-kit"
    }, [_vm._v(_vm._s(tracking.event_name))]), _vm._v(" "), _c('td', {
      staticClass: "tracking-activity"
    }, [_vm._v(_vm._s(tracking.advertisement_name) + " " + _vm._s(_vm.$t('models.tracking.specific.' + tracking.name)) + " "), (tracking.referrer_url) ? _c('a', {
      staticClass: "icon icon-external-link",
      attrs: {
        "href": tracking.referrer_url,
        "target": "_blank"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "tracking-hint"
    }, [_c('div', {
      staticClass: "hint"
    }, [_c('i', {
      staticClass: "icon trigger yule-icon-info"
    }), _vm._v(" "), _c('div', {
      staticClass: "hint-content"
    }, [(tracking.city) ? _c('p', [_c('i', {
      staticClass: "icon icon-map-pin"
    }), _vm._v("\n              " + _vm._s(tracking.city) + "\n            ")]) : _vm._e(), _vm._v(" "), (tracking.browser || tracking.os) ? _c('p', [_c('i', {
      staticClass: "icon icon-monitor"
    }), _vm._v("\n              " + _vm._s(tracking.browser) + " | " + _vm._s(tracking.os) + "\n            ")]) : _vm._e()])])])])
  })], 2) : _vm._e()]) : _c('div', {
    staticClass: "is-empty"
  }, [_vm._v("\n  " + _vm._s(_vm.$t('statistics.no_data')) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      key: tab.name,
      staticClass: "tab",
      class: {
        'is-active': tab.name == _vm.active
      },
      on: {
        "click": function($event) {
          return _vm.changeTab(tab.name)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.$t(tab.code)) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pop-over', {
    attrs: {
      "options": _vm.popperOptionsComputed
    }
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "icon trigger yule-icon-info",
    class: _vm.size
  })])])
},staticRenderFns: []}

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row full-height"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-12 col-xl-12 full-height"
  }, [(!_vm.activeItem) ? _c('div', {
    staticClass: "image-wrapper"
  }, [_c('div', {
    staticClass: "active-empty-state"
  }, [_c('img', {
    attrs: {
      "src": _vm.emptyStateSrc
    }
  }), _vm._v("\n        Please select an element to edit\n      ")])]) : _c('drag-item-edit', {
    attrs: {
      "limitEditing": _vm.limitEditing,
      "editorName": _vm.editorName
    },
    on: {
      "delete": _vm.deleteElement,
      "input": _vm.editElement
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-mask row gutter-xs"
  }, _vm._l((_vm.elements), function(element) {
    return _c('lead-mask-element', {
      key: element.name,
      class: _vm.getItemGrid(element),
      attrs: {
        "type": element.element_type,
        "element": element,
        "errors": _vm.errors,
        "name": element.name,
        "language": _vm.language,
        "item": _vm.item
      },
      on: {
        "populate-fields": _vm.populateFields,
        "change": _vm.change
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, _vm._l((this.organizations), function(organization) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'organization_edit',
          params: {
            id: organization[0]
          }
        }
      }
    }, [_c('h3', {
      staticClass: "title--link"
    }, [_vm._v("\n        " + _vm._s(organization[0]) + " - " + _vm._s(organization[1]) + "\n      ")])])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    class: {
      'pagination--item': true, 'pagination--chevron': true, 'is-disabled': _vm.page == 1
    },
    on: {
      "click": function($event) {
        return _vm.prev()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._l((_vm.pages), function(number, key) {
    return _c('li', {
      key: key,
      class: {
        'pagination--item': true, 'is-active': number == _vm.page, 'is-diabled': number < 0
      }
    }, [(number > 0) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.goToPage(number)
        }
      }
    }, [_vm._v(_vm._s(number))]) : _c('a', [_vm._v("...")])])
  }), _vm._v(" "), _c('li', {
    class: {
      'pagination--item': true, 'pagination--chevron': true, 'is-disabled': _vm.page == _vm.totalPages
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._m(1)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "icon yule-icon-chevron-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "icon yule-icon-chevron-right"
  })])
}]}

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rankings.length > 0 && _vm.ready) ? _c('div', {
    staticClass: "project-statistics--ranking"
  }, _vm._l((_vm.rankings), function(ranking) {
    return _c('div', {
      key: ranking.position,
      staticClass: "ranking",
      class: _vm.computedRankingClass(ranking)
    }, [_c('div', {
      staticClass: "ranking--position"
    }, [_vm._v("\n      " + _vm._s(ranking.position) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "ranking--user"
    }, [_vm._v("\n      " + _vm._s(ranking.user.display_name) + "\n      "), (ranking.position == 1) ? _c('div', {
      staticClass: "ranking--user-count"
    }, [_vm._v("\n        " + _vm._s(ranking.leads_count) + " " + _vm._s(_vm.$t('statistics.leads')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ranking--count"
    }, [_vm._v("\n      " + _vm._s(ranking.leads_count) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "ranking--percentage"
    }, [_c('progress-bar', {
      attrs: {
        "percentage": _vm.formatPercentage(ranking.ranking_percentage),
        "title": _vm.formatPercentage(ranking.ranking_percentage) + '%',
        "is-mini": true
      }
    })], 1)])
  }), 0) : _c('div', {
    staticClass: "project-statistics--ranking is-empty"
  }, [_vm._v("\n  " + _vm._s(_vm.$t('statistics.no_data')) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "external-layout-app"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fluid-layout",
    class: {
      computedClasses: _vm.computedClasses, 'form-builder': _vm.isFormBuilder
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {}, [_c('q-layout', [_c('div', {
    staticClass: "header-container"
  }, [_c('navigation', {
    attrs: {
      "id": "desktop-nav"
    }
  }), _vm._v(" "), _c('mobile-navigation', {
    attrs: {
      "id": "mobile-nav"
    }
  })], 1), _vm._v(" "), _c('div', {}, [(this.isRetrieving) ? _c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('loading')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-container-fluid"
  }, [_c('div', {
    class: {
      'main-content': true,
      'main-content--lead': _vm.isPageLead,
      'main-content--projects': _vm.isPageProjects,
      'main-content--projects': _vm.isPageProjectNew,
      'empty-state-projects': _vm.emptyStateProjects,
      'empty-state-leads': _vm.emptyStateLeads,
      'main-content--manager': _vm.isPageContent,
      hidden: _vm.isRetrieving
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath,
    staticClass: "router-view",
    on: {
      "logout": function($event) {
        return _vm.$emit('logout')
      }
    }
  })], 1)])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-detailed-statistics"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "title-grid"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('statistics.lead_statistics')))]), _vm._v(" "), _c('relative-date-choser', {
    attrs: {
      "choices": [1, 7, 30, 60]
    },
    on: {
      "change": _vm.newDate
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'project_lead_edit',
        params: {
          id: _vm.id,
          leadId: this.lead_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t('statistics.get_back_to_lead')) + "\n    ")])], 1), _vm._v(" "), (_vm.trackings.length > 0) ? _c('div', [_c('tracking-chart', {
    attrs: {
      "start-date": _vm.start_date.format(),
      "end-date": _vm.end_date.format(),
      "trackings": _vm.trackings
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.trackingsSorted), function(trackings) {
    return _c('div', {
      key: trackings[0].time,
      staticClass: "tracking-table"
    }, [_c('div', {
      staticClass: "tracking-table--date"
    }, [_vm._v("\n        " + _vm._s(_vm.moment(trackings[0].time).format('MMMM Do')) + "\n      ")]), _vm._v(" "), _c('tracking-table', {
      attrs: {
        "project-id": _vm.id,
        "trackings": trackings
      }
    })], 1)
  })], 2) : _c('div', [_vm._v("\n    " + _vm._s(_vm.$t('statistics.no_data')) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.buttons) ? _c('div', {
    staticClass: "add-buttons"
  }, [_c('div', {
    staticClass: "actions"
  }, _vm._l((_vm.buttons), function(button) {
    return (_vm.can(button)) ? _c('div', {
      key: button.name,
      staticClass: "action"
    }, [(button.action == 'link') ? _c('router-link', {
      attrs: {
        "to": button.href
      }
    }, [(button.show) ? _c('button', {
      staticClass: "btn",
      class: button.classes,
      attrs: {
        "disabled": button.disabled,
        "data-action": button.action,
        "id": button.action
      },
      on: {
        "click": function($event) {
          return _vm.action(button)
        }
      }
    }, [(button.icon) ? _c('span', {
      staticClass: "icon"
    }, [(button.icon == 'arrow_left') ? _c('img', {
      attrs: {
        "src": __webpack_require__(429)
      }
    }) : _vm._e(), _vm._v(" "), (button.icon == 'arrow_right') ? _c('img', {
      attrs: {
        "src": __webpack_require__(430)
      }
    }) : _vm._e()]) : _c('div', [_vm._v("\n            " + _vm._s(_vm.$t("ui.button." + button.action)) + "\n          ")])]) : _vm._e()]) : (button.action != 'link') ? _c('button', {
      staticClass: "btn",
      class: button.classes,
      attrs: {
        "disabled": button.disabled,
        "data-action": button.action,
        "id": button.action
      },
      on: {
        "click": function($event) {
          return _vm.action(button)
        }
      }
    }, [(button.icon) ? _c('span', {
      staticClass: "icon"
    }, [(button.icon == 'import') ? _c('img', {
      attrs: {
        "src": __webpack_require__(451)
      }
    }) : _vm._e()]) : _c('div', [_vm._v("\n          " + _vm._s(_vm.$t("ui.button." + button.action)) + "\n        ")])]) : _vm._e()], 1) : _vm._e()
  }), 0)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row x-table-wrapper"
  }, [(_vm.enableFilter == true) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 mid-spacing filter-list"
  }, [(_vm.enableFilter == true) ? _c('x-filter', {
    attrs: {
      "filterDefinitions": _vm.filterDefinitions,
      "defaultfilters": _vm.fetchParams.searchFilters,
      "disabled": _vm.loading
    },
    on: {
      "update": _vm.updateFilters,
      "saveSearch": _vm.saveSearch
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.totalCount !== false) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 mid-spacing"
  }, [_c('h4', [_vm._v(_vm._s(_vm.totalCount) + " " + _vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.enableSearch == true) ? _c('div', {
    staticClass: "col-md-4 mid-spacing"
  }, [_c('div', {
    staticClass: "row items-end gutter-sm search-wrapper"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('q-search', {
    staticClass: "search",
    attrs: {
      "placeholder": _vm.$t('ui.xtable.search_placeholder'),
      "autofocus": "",
      "clearable": "",
      "hide-underline": "",
      "color": "secondary",
      "debounce": 600,
      "disabled": _vm.loading
    },
    on: {
      "input": function($event) {
        return _vm.updateSearch()
      }
    },
    model: {
      value: (_vm.fetchParams.searchKeywords),
      callback: function($$v) {
        _vm.$set(_vm.fetchParams, "searchKeywords", $$v)
      },
      expression: "fetchParams.searchKeywords"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('q-btn', {
    staticClass: "x-button",
    attrs: {
      "disabled": _vm.loading,
      "icon": "arrow_forward",
      "no-ripple": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateSearch(null, true)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 self-end mid-spacing x-table-menus"
  }, [_c('div', {
    staticClass: "column-toggle-menu dropdown-select float-right"
  }, [_c('q-table-columns', {
    staticClass: "columns",
    attrs: {
      "label": _vm.$t('ui.xtable.toggle_columns'),
      "color": "secondary",
      "columns": _vm.allColumns,
      "disabled": _vm.loading
    },
    on: {
      "input": _vm.columnChange
    },
    model: {
      value: (_vm.visibleColumns),
      callback: function($$v) {
        _vm.visibleColumns = $$v
      },
      expression: "visibleColumns"
    }
  })], 1), _vm._v(" "), (_vm.actions.length > 0 && _vm.actionsLocation == 'menu') ? _c('div', {
    staticClass: "actions-menu dropdown-select float-right"
  }, [_c('q-btn-dropdown', {
    staticClass: "x-table-actions-menu-button",
    attrs: {
      "label": _vm.$t('ui.xtable.actions'),
      "no-ripple": "",
      "no-caps": "",
      "disabled": _vm.loading
    }
  }, [_c('q-list', {
    attrs: {
      "link": ""
    }
  }, _vm._l((_vm.actions), function(action) {
    return _c('q-item', {
      directives: [{
        name: "close-overlay",
        rawName: "v-close-overlay"
      }],
      key: action.name,
      class: action.class,
      attrs: {
        "separator": action.separator ? true : false,
        "disabled": action.selectedOnly && _vm.selectedItems.length == 0
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleAction(action)
        }
      }
    }, [_c('q-item-main', {
      attrs: {
        "label": action.name
      }
    }), _vm._v(" "), (action.icon) ? _c('q-item-side', {
      attrs: {
        "icon": action.icon,
        "right": ""
      }
    }) : _vm._e(), _vm._v(" "), (action.description) ? _c('q-tooltip', [_vm._v(_vm._s(action.description))]) : _vm._e()], 1)
  }), 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "x-table col-xs-12 col-sm-12 col-lg-12 col-xl-12"
  }, [_c('q-table', {
    key: _vm.key,
    class: _vm.tableClasses,
    attrs: {
      "grid": "",
      "title": _vm.title,
      "data": _vm.tableData,
      "showLoader": _vm.loading,
      "disabled": _vm.loading,
      "pagination": _vm.fetchParams.pagination,
      "binary-state-sort": "",
      "columns": _vm.allColumns,
      "visible-columns": _vm.visibleColumns,
      "selection": _vm.selectionType,
      "selected": _vm.selectedItems,
      "separator": _vm.separator,
      "row-key": _vm.rowKey,
      "rows-per-page-label": _vm.$t('ui.xtable.page_size_label'),
      "no-data-label": _vm.emptyStateLabel,
      "rows-per-page-options": _vm.rowsPerPage
    },
    on: {
      "request": _vm.updatePagination,
      "update:selected": function($event) {
        _vm.selectedItems = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(props) {
        return _c('q-tr', {
          attrs: {
            "props": props
          }
        }, [(_vm.selectionType != 'none') ? _c('q-th', {
          staticClass: "column-selection",
          attrs: {
            "auto-width": ""
          }
        }, [_c('q-checkbox', {
          attrs: {
            "color": "primary"
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm._l((props.cols), function(col) {
          return _c('q-th', {
            key: col.name,
            class: col.classes,
            attrs: {
              "props": props
            }
          }, [_vm._v("\n          " + _vm._s(col.label) + "\n        ")])
        }), _vm._v(" "), (_vm.actions.length > 0 && _vm.actionsLocation == 'row') ? _c('q-th', {
          staticClass: "column-standard text-center",
          attrs: {
            "auto-width": ""
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.xtable.actions")) + "\n        ")]) : _vm._e()], 2)
      }
    }, {
      key: "body",
      fn: function(props) {
        return _c('q-tr', {
          class: _vm.rowsAreClickable ? 'cursor-pointer' : '',
          attrs: {
            "props": props
          },
          nativeOn: {
            "click": function($event) {
              return _vm.clickRow(props.row[_vm.rowKey])
            }
          }
        }, [(_vm.selectionType != 'none') ? _c('q-td', {
          staticClass: "column-selection",
          attrs: {
            "auto-width": ""
          }
        }, [_c('q-checkbox', {
          attrs: {
            "color": "primary"
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm._l((props.cols), function(col) {
          return _c('q-td', {
            key: col.name,
            class: col.classes,
            attrs: {
              "props": props
            },
            nativeOn: {
              "click": function($event) {
                return _vm.clickCell(props.row[_vm.rowKey], col.name)
              }
            }
          }, [(col.icon) ? _c('img', {
            staticClass: "cell-icon",
            attrs: {
              "src": col.icon
            }
          }) : _vm._e(), _vm._v(" "), (_vm.isEmpty(col.value)) ? _c('span', {
            staticClass: "cell-text cell-empty"
          }, [_vm._v(_vm._s(_vm.defaultValue(col)))]) : (col.isUrl) ? _c('span', {
            staticClass: "cell-text"
          }, [_c('a', {
            attrs: {
              "target": "_blank",
              "href": 'http://' + col.value
            }
          }, [_vm._v(_vm._s(col.value))])]) : _c('span', {
            staticClass: "cell-text"
          }, [_vm._v(_vm._s(col.value))])])
        }), _vm._v(" "), (_vm.actions.length > 0 && _vm.actionsLocation == 'row') ? _c('q-td', {
          staticClass: "actions-cell",
          attrs: {
            "auto-width": ""
          },
          model: {
            value: (props.actions),
            callback: function($$v) {
              _vm.$set(props, "actions", $$v)
            },
            expression: "props.actions"
          }
        }, _vm._l((_vm.actions), function(action) {
          return _c('span', {
            key: action.name || action.icon
          }, [(/^yule-/.test(action.icon)) ? _c('a', {
            staticClass: "x-table-yule-icon",
            class: action.class,
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.handleAction(action, [props.row[_vm.rowKey]])
              }
            }
          }, [_c('i', {
            staticClass: "icon",
            class: action.icon
          })]) : _c('q-btn', {
            class: action.class,
            attrs: {
              "icon": action.icon,
              "size": "md",
              "flat": "",
              "round": "",
              "no-ripple": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.handleAction(action, [props.row[_vm.rowKey]])
              }
            }
          }), _vm._v(" "), (action.description || action.name) ? _c('q-tooltip', [_vm._v(_vm._s(action.description || action.name))]) : _vm._e()], 1)
        }), 0) : _vm._e()], 2)
      }
    }])
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "title": _vm.savedSearchParams.title,
      "open": _vm.savedSearchModalOpen
    },
    on: {
      "save": function($event) {
        return _vm.saveSearchCommit()
      },
      "cancel": function($event) {
        return _vm.closeSavedSearchModal()
      }
    }
  }, [_c('field', {
    attrs: {
      "label": _vm.savedSearchParams.label
    },
    model: {
      value: (_vm.savedSearchName),
      callback: function($$v) {
        _vm.savedSearchName = $$v
      },
      expression: "savedSearchName"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('models.project_lead.crawled_infos.' + _vm.label)) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "crawled-info--value"
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('field', {
    attrs: {
      "label": _vm.$t(_vm.label),
      "classes": _vm.classes,
      "collection": _vm.roles,
      "name": _vm.name,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "type": "radio"
    },
    model: {
      value: (_vm.newValue),
      callback: function($$v) {
        _vm.newValue = $$v
      },
      expression: "newValue"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "modal-box-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closePopup($event)
      }
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "modal-box"
  }, [_c('div', {
    staticClass: "modal-box--content"
  }, [_c('span', {
    staticClass: "modal-box--closing-button icon yule-icon-close-small",
    on: {
      "click": _vm.closePopup
    }
  }), _vm._v(" "), (_vm.item.business_card_image_url) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.item.business_card_image_url,
      "alt": "business card",
      "onerror": 'this.onerror=null; this.src=\'' + this.image + '\';'
    }
  })]) : _c('div', {
    staticClass: "no_image"
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": "no image associated"
    }
  })])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('errors.' + _vm.error.code)) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.success == false) ? _c('form', {
    staticClass: "password-reset-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('ui.auth.password_reset_title')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.password_reset')))]), _vm._v(" "), _c('field', {
    attrs: {
      "label": " ",
      "name": "token",
      "type": "hidden"
    },
    model: {
      value: (_vm.token),
      callback: function($$v) {
        _vm.token = $$v
      },
      expression: "token"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "placeholder": _vm.$t('ui.auth.password'),
      "name": "password",
      "type": "password",
      "label": "ui.auth.password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "placeholder": _vm.$t('ui.auth.password_confirmation'),
      "name": "password_confirmation",
      "type": "password",
      "label": "ui.auth.password_confirmation"
    },
    model: {
      value: (_vm.password_confirmation),
      callback: function($$v) {
        _vm.password_confirmation = $$v
      },
      expression: "password_confirmation"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-login",
    attrs: {
      "type": "submit",
      "data-action": "user.password_reset"
    },
    domProps: {
      "value": _vm.$t('ui.auth.confirm')
    }
  })])], 1) : _c('div', {
    staticClass: "password-reset-confirm"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('ui.auth.password_reset_title_confirm')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.password_reset_confirm')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(293)
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t('ui.auth.return_to_login')))])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading": _vm.isLoading,
      "is-panel": ""
    }
  }, [
    [_c('div', {
      ref: "funnel-chart-animator",
      staticClass: "funnel-chart-animator"
    }, [_c('div', {
      key: _vm.key,
      staticClass: "funnel-chart"
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('ui.dashboard.conversion_funnel.label')))]), _vm._v(" "), _c('div', {
      staticClass: "row gutter-sm"
    }, [_c('div', {
      staticClass: "col-xs-8"
    }, [_c('div', {
      staticClass: "chart-data"
    }, [_c('div', {
      staticClass: "chart-funnel"
    }, _vm._l((_vm.chartSegments), function(segment, index) {
      return _c('div', {
        key: ("segment" + index),
        staticClass: "funnel-segment"
      }, [(index > 0) ? _c('div', {
        staticClass: "segment-spacer"
      }) : _vm._e(), _vm._v(" "), _c('svg', {
        staticStyle: {
          "border-radius": "4px"
        },
        attrs: {
          "viewBox": "0 0 100 100",
          "preserveAspectRatio": "none"
        }
      }, [_c('defs', [_c('linearGradient', {
        attrs: {
          "id": ("grad" + index),
          "x1": "0%",
          "y1": "0%",
          "x2": "0%",
          "y2": "100%"
        }
      }, [_c('stop', {
        style: (("stop-color: " + (_vm.segmentColors[index]))),
        attrs: {
          "offset": "0%"
        }
      }), _vm._v(" "), _c('stop', {
        style: (("stop-color: " + ((_vm.segmentColors[index])))),
        attrs: {
          "offset": "100%"
        }
      })], 1)], 1), _vm._v(" "), _c('polygon', {
        attrs: {
          "points": "",
          "fill": _vm.isGradientColors ? ("url(#grad" + index) : _vm.segmentColors[index]
        }
      }, [_c('animate', {
        attrs: {
          "attributeName": "points",
          "dur": _vm.isAnimated ? _vm.animationTime : '0.015s',
          "fill": "freeze",
          "from": '0,0 100,0 100,100 0,100',
          "keySplines": "\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1;\n                        0.1 0.8 0.2 1",
          "keyTimes": "0;0.22;0.33;0.55;0.66;0.88;1",
          "calcMode": "spline",
          "to": ("\n                        " + ((100 - segment.conversion)) + ",0\n                        100,0\n                        100,100\n                        " + ((_vm.chartSegments[index + 1] ? (100 - _vm.chartSegments[index + 1].conversion) : '100')) + ",100")
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "segment-text"
      }, [_c('p', {
        staticClass: "accent pre"
      }, [_vm._v(_vm._s(segment.value))]), _vm._v(" "), _c('p', {
        staticClass: "caption"
      }, [_vm._v(_vm._s(segment.label))])])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "acumulative-panel"
    }, _vm._l((_vm.chartSegments), function(step, index) {
      return (index > 0) ? _c('div', {
        key: ("step-" + index),
        class: ("data-" + index)
      }, [_c('h4', [_vm._v(_vm._s(_vm._f("percentage")(step.conversion)))])]) : _vm._e()
    }), 0)])])])])]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tracking-chart"
  }, [_c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "position": "relative",
      "height": "40vh",
      "width": "100%"
    }
  }, [_c('canvas', {
    ref: "chart",
    staticClass: "chart"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-show leads-listing"
  }, [_c('lead-create', {
    attrs: {
      "id": _vm.id
    }
  }), _vm._v(" "), (this.emptyState === 'leads') ? _c('empty-state', {
    attrs: {
      "name": "leads",
      "heading": _vm.emptyStateHeading,
      "subtitle": _vm.emptyStateSubtitle,
      "button": true
    }
  }) : _c('div', [_c('div', {
    staticClass: "search-container"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-trigger icon yule-icon-settings",
    attrs: {
      "title": _vm.$t('ui.filters.hint')
    },
    on: {
      "click": function($event) {
        _vm.filterDisplay = !_vm.filterDisplay
      }
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "test"
    }
  }, [(_vm.filterDisplay && _vm.query.filters) ? _c('leads-filtering', {
    attrs: {
      "filters": _vm.query
    },
    on: {
      "apply": _vm.filterUpdate,
      "reset": _vm.filterReset
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "leads-listing--desktop"
  }, [_c('leads-listing', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.correctedStructure,
      "params": {
        project_id: _vm.id,
        global_sorting: true,
        sort_by: this.query.sort_by,
        sort_order: this.query.sort_order
      },
      "model": "project_lead",
      "has_searched": _vm.has_searched
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "leads-listing--mobile"
  }, [_c('leads-listing', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.structure_mobile,
      "params": {
        project_id: _vm.id,
        global_sorting: true,
        sort_by: this.query.sort_by,
        sort_order: this.query.sort_order
      },
      "model": "project_lead",
      "has_searched": _vm.has_searched
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organization-update update-form"
  }, [_c('form', {
    staticClass: "organization-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('ui.organizations.general_settings')))]), _vm._v(" "), _c('div', {
    staticClass: "grid-2 has-gutter-l organization--base"
  }, [_c('div', [_c('field', {
    staticClass: "two-thirds",
    attrs: {
      "errors": _vm.errors,
      "name": "name",
      "label": "Name",
      "placeholder": "Google inc."
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "is-inline",
    attrs: {
      "errors": _vm.errors,
      "model": "organizations",
      "name": "locale",
      "label": "Language",
      "type": "radio",
      "params": {
        'no_i18n': true
      },
      "collection": [{
        value: 'en',
        name: 'en'
      }, {
        value: 'de',
        name: 'de'
      }]
    },
    model: {
      value: (_vm.item.locale),
      callback: function($$v) {
        _vm.$set(_vm.item, "locale", $$v)
      },
      expression: "item.locale"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "website",
      "label": "Website",
      "placeholder": "http://zombo.com/"
    },
    model: {
      value: (_vm.item.website),
      callback: function($$v) {
        _vm.$set(_vm.item, "website", $$v)
      },
      expression: "item.website"
    }
  }), _vm._v(" "), (_vm.currentUserIsRoot) ? _c('field', {
    attrs: {
      "errors": _vm.errors,
      "label": "Plan",
      "params": {
        no_i18n: true
      },
      "required": true,
      "collection": this.plans,
      "name": "plan",
      "type": "select"
    },
    model: {
      value: (_vm.item.plan),
      callback: function($$v) {
        _vm.$set(_vm.item, "plan", $$v)
      },
      expression: "item.plan"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "company-logo"
  }, [(_vm.company_logo_data) ? _c('img', {
    attrs: {
      "src": _vm.company_logo_data,
      "alt": "logo"
    }
  }) : (_vm.item.company_logo_url) ? _c('img', {
    attrs: {
      "src": _vm.item.company_logo_url,
      "alt": "logo"
    }
  }) : _vm._e(), _vm._v(" "), _c('upload-field', {
    on: {
      "change": _vm.logoUpload
    }
  })], 1), _vm._v(" "), _c('field', {
    staticClass: "is-inline",
    attrs: {
      "errors": _vm.errors,
      "name": "status",
      "type": "radio",
      "params": {
        'no_i18n': true
      },
      "label": "Active organization ?",
      "collection": [{
        value: 'active',
        name: 'Yes'
      }, {
        value: 'inactive',
        name: 'No'
      }]
    },
    model: {
      value: (_vm.item.status),
      callback: function($$v) {
        _vm.$set(_vm.item, "status", $$v)
      },
      expression: "item.status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid-2 has-gutter-l organization--address"
  }, [_c('div', [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "street",
      "label": "Street",
      "placeholder": "Hausburgstr"
    },
    model: {
      value: (_vm.item.street),
      callback: function($$v) {
        _vm.$set(_vm.item, "street", $$v)
      },
      expression: "item.street"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "city",
      "label": "City",
      "placeholder": "Berlin"
    },
    model: {
      value: (_vm.item.city),
      callback: function($$v) {
        _vm.$set(_vm.item, "city", $$v)
      },
      expression: "item.city"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grid-2 has-gutter-l"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "street_number",
      "label": "Street number",
      "placeholder": "30"
    },
    model: {
      value: (_vm.item.street_number),
      callback: function($$v) {
        _vm.$set(_vm.item, "street_number", $$v)
      },
      expression: "item.street_number"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "zip",
      "label": "Zip code",
      "placeholder": "10249"
    },
    model: {
      value: (_vm.item.zip),
      callback: function($$v) {
        _vm.$set(_vm.item, "zip", $$v)
      },
      expression: "item.zip"
    }
  })], 1), _vm._v(" "), _c('country-select', {
    attrs: {
      "errors": _vm.errors,
      "name": "country",
      "label": "Country"
    },
    model: {
      value: (_vm.item.country),
      callback: function($$v) {
        _vm.$set(_vm.item, "country", $$v)
      },
      expression: "item.country"
    }
  })], 1)]), _vm._v(" "), (_vm.type == 'update') ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('ui.organizations.configuration')))]), _vm._v(" "), _c('div', {
    staticClass: "grid-2 organization--configuration"
  }, [_c('div', [(_vm.configuration.ranking_display) ? _c('form-switch', {
    attrs: {
      "model": "organization_configuration",
      "name": "ranking_display"
    },
    model: {
      value: (_vm.configuration.ranking_display.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.ranking_display, "content", $$v)
      },
      expression: "configuration.ranking_display.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.configuration.enrichment_disabled) ? _c('form-switch', {
    attrs: {
      "reverse": true,
      "model": "organization_configuration",
      "name": "enrichment_disabled"
    },
    model: {
      value: (_vm.configuration.enrichment_disabled.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.enrichment_disabled, "content", $$v)
      },
      expression: "configuration.enrichment_disabled.content"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('ui.organizations.api')))]), _vm._v(" "), _c('div', {
    staticClass: "grid-2 has-gutter-l"
  }, [_c('div', [(_vm.configuration.eventbaxx_auth_token) ? _c('secret-field', {
    attrs: {
      "errors": _vm.errors,
      "model": "organization_configuration",
      "name": "eventbaxx_auth_token",
      "set_state": "api"
    },
    model: {
      value: (_vm.configuration.eventbaxx_auth_token.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.eventbaxx_auth_token, "content", $$v)
      },
      expression: "configuration.eventbaxx_auth_token.content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.configuration.api_token_eventbaxx) ? _c('secret-field', {
    attrs: {
      "errors": _vm.errors,
      "model": "organization_configuration",
      "name": "api_token_eventbaxx"
    },
    model: {
      value: (_vm.configuration.api_token_eventbaxx.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.api_token_eventbaxx, "content", $$v)
      },
      expression: "configuration.api_token_eventbaxx.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.configuration.mailchimp_api_key) ? _c('secret-field', {
    attrs: {
      "errors": _vm.errors,
      "model": "organization_configuration",
      "name": "mailchimp_api_key"
    },
    model: {
      value: (_vm.configuration.mailchimp_api_key.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.mailchimp_api_key, "content", $$v)
      },
      expression: "configuration.mailchimp_api_key.content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.configuration.xing_consumer_key) ? _c('secret-field', {
    attrs: {
      "errors": _vm.errors,
      "model": "organization_configuration",
      "name": "xing_consumer_key"
    },
    model: {
      value: (_vm.configuration.xing_consumer_key.content),
      callback: function($$v) {
        _vm.$set(_vm.configuration.xing_consumer_key, "content", $$v)
      },
      expression: "configuration.xing_consumer_key.content"
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "organization-update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    attrs: {
      "data-action": "organization.cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-save",
    attrs: {
      "type": "submit",
      "data-action": "organization.update"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])])])
},staticRenderFns: []}

/***/ }),
/* 1875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classification-wrapper"
  }, [_c('span', {
    staticClass: "value-classification",
    class: _vm.value
  }, [_vm._v(" ")])])
},staticRenderFns: []}

/***/ }),
/* 1876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disabled",
    on: {
      "click": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "menu-item-name"
  }, [_vm._v(_vm._s(_vm.$t("ui.menu." + _vm.item.name)))]), _vm._v(" "), _c('i', {
    staticClass: "icon yule-icon-lock"
  })])
},staticRenderFns: []}

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.elements), function(tab) {
    return (tab.children) ? _c('div', {
      key: tab.name,
      staticClass: "lead-update--tab",
      class: {
        'is-hidden': _vm.activeTab != tab.name
      }
    }, [_c('div', {
      staticClass: "row gutter-lg"
    }, [_c('div', {
      staticClass: "col-md-5 col-lg-5 offset-md-1"
    }, [_c('lead-update-monitor', {
      staticClass: "inside-content",
      class: {
        'hide': !_vm.showUpdateMonitor, 'show': _vm.showUpdateMonitor
      },
      attrs: {
        "structure": _vm.structure,
        "progress": _vm.progress,
        "errors": _vm.errors,
        "users": _vm.users,
        "item": _vm.item,
        "leadReviewEnabled": _vm.leadReviewEnabled
      },
      on: {
        "openBusinessCard": _vm.triggerPopup,
        "input": _vm.nestedUpdate
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.savedAt))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-5 col-ls-5 lead-mask"
    }, [_c('lead-mask', {
      attrs: {
        "language": _vm.language,
        "elements": tab.children,
        "item": _vm.item,
        "errors": _vm.errors
      },
      on: {
        "change": _vm.change,
        "populate-fields": _vm.populateFields
      }
    })], 1)])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "lead-update--tab lead-update--tab-kits",
    class: {
      'is-hidden': _vm.activeTab != 'kits_tab'
    }
  }, [_c('div', {
    staticClass: "row gutter-lg"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-5 offset-md-1"
  }, [_c('lead-update-monitor', {
    staticClass: "inside-content",
    class: {
      'hide': !_vm.showUpdateMonitor, 'show': _vm.showUpdateMonitor
    },
    attrs: {
      "structure": _vm.structure,
      "progress": _vm.progress,
      "errors": _vm.errors,
      "users": _vm.users,
      "item": _vm.item,
      "leadReviewEnabled": _vm.leadReviewEnabled
    },
    on: {
      "openBusinessCard": _vm.triggerPopup,
      "input": _vm.nestedUpdate
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.savedAt))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('lead-update-business-kit', {
    attrs: {
      "project_id": _vm.id,
      "errors": _vm.errors,
      "item": _vm.item,
      "business_kit_id": _vm.businesskit_id,
      "id": _vm.lead_id
    },
    on: {
      "send_businesskit": _vm.sendBusinesskit,
      "input": _vm.nestedUpdate,
      "bkIdChange": _vm.setBusinessKitId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "lead-update--tab lead-update--tab-kits",
    class: {
      'is-hidden': _vm.activeTab != 'stats_tab'
    }
  }, [_c('div', {
    staticClass: "row gutter-lg"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-5 offset-md-1"
  }, [_c('lead-update-monitor', {
    staticClass: "inside-content",
    class: {
      'hide': !_vm.showUpdateMonitor, 'show': _vm.showUpdateMonitor
    },
    attrs: {
      "structure": _vm.structure,
      "progress": _vm.progress,
      "errors": _vm.errors,
      "users": _vm.users,
      "item": _vm.item,
      "leadReviewEnabled": _vm.leadReviewEnabled
    },
    on: {
      "openBusinessCard": _vm.triggerPopup,
      "input": _vm.nestedUpdate
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.savedAt))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5"
  }, [_c('lead-update-statistics', {
    attrs: {
      "lead-id": _vm.lead_id,
      "project-id": _vm.id
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "visibility-icon"
  }, [_c('q-checkbox', {
    attrs: {
      "checked-icon": "visibility_off",
      "unchecked-icon": "visibility_on"
    },
    model: {
      value: (_vm.showUpdateMonitor),
      callback: function($$v) {
        _vm.showUpdateMonitor = $$v
      },
      expression: "showUpdateMonitor"
    }
  })], 1), _vm._v(" "), _c('page-saver', {
    attrs: {
      "sticky": true,
      "isModified": !this.isSaved(),
      "changeCount": _vm.saveDiff()
    },
    on: {
      "save": _vm.submit,
      "cancel": _vm.cancel
    }
  }), _vm._v(" "), _c('business-card-popup', {
    attrs: {
      "item": _vm.item,
      "open": _vm.popup_business_card_open
    }
  }), _vm._v(" "), _c('lead-create', {
    attrs: {
      "id": _vm.id
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-edit"
  }, [_c('modal', {
    staticClass: "edit-contact-modal",
    attrs: {
      "title": "",
      "open": _vm.isOpen
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "email",
      "label": _vm.$t('ui.contact.caption.email'),
      "autofocus": true
    },
    model: {
      value: (_vm.workingContact.email),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "email", $$v)
      },
      expression: "workingContact.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "firstname",
      "label": _vm.$t('ui.contact.caption.firstname')
    },
    model: {
      value: (_vm.workingContact.firstname),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "firstname", $$v)
      },
      expression: "workingContact.firstname"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "lastname",
      "label": _vm.$t('ui.contact.caption.lastname')
    },
    model: {
      value: (_vm.workingContact.lastname),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "lastname", $$v)
      },
      expression: "workingContact.lastname"
    }
  })], 1), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "business_card_job_title",
      "label": _vm.$t('ui.contact.caption.business_card_job_title')
    },
    model: {
      value: (_vm.workingContact.business_card_job_title),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "business_card_job_title", $$v)
      },
      expression: "workingContact.business_card_job_title"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "company_department",
      "label": _vm.$t('ui.contact.caption.company_department')
    },
    model: {
      value: (_vm.workingContact.company_department),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "company_department", $$v)
      },
      expression: "workingContact.company_department"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "phone_private",
      "label": _vm.$t('ui.contact.caption.phone_private')
    },
    model: {
      value: (_vm.workingContact.phone_private),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "phone_private", $$v)
      },
      expression: "workingContact.phone_private"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "phone",
      "label": _vm.$t('ui.contact.caption.phone_company')
    },
    model: {
      value: (_vm.workingContact.phone_company),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "phone_company", $$v)
      },
      expression: "workingContact.phone_company"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "mobile",
      "label": _vm.$t('ui.contact.caption.phone_mobile')
    },
    model: {
      value: (_vm.workingContact.phone_mobile),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "phone_mobile", $$v)
      },
      expression: "workingContact.phone_mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    attrs: {
      "name": "language",
      "label": _vm.$t('ui.contact.caption.language'),
      "type": "radio",
      "collection": [{
          value: 'en',
          name: 'English'
        },
        {
          value: 'de',
          name: 'German'
        }
      ]
    },
    model: {
      value: (_vm.workingContact.language),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "language", $$v)
      },
      expression: "workingContact.language"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "name": "gender",
      "label": _vm.$t('ui.contact.caption.gender'),
      "type": "radio",
      "collection": [{
          value: 'male',
          name: 'male'
        },
        {
          value: 'female',
          name: 'female'
        }
      ]
    },
    model: {
      value: (_vm.workingContact.gender),
      callback: function($$v) {
        _vm.$set(_vm.workingContact, "gender", $$v)
      },
      expression: "workingContact.gender"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "is-margin-top-0"
  }, [_vm._v(_vm._s(_vm.$t('ui.external_form.basic_config')))]), _vm._v(" "), _c('div', {
    staticClass: "row gutter-md"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('form', {
    staticClass: "lead-mask-update--form max-width",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('div', {
    staticClass: "has-gutter-l"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "external_form",
      "name": "name",
      "placeholder": "Form Name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "external_form",
      "name": "language",
      "type": "select",
      "placeholder": "English",
      "collection": _vm.languages[_vm.currentLanguage]
    },
    model: {
      value: (_vm.item.language),
      callback: function($$v) {
        _vm.$set(_vm.item, "language", $$v)
      },
      expression: "item.language"
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.projects.length > 1) ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.list'),
      expression: "'projects.list'"
    }],
    staticClass: "el-select",
    attrs: {
      "errors": _vm.errors,
      "model": "external_form",
      "name": "project_id",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.projects
    },
    model: {
      value: (_vm.item.project_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "project_id", $$v)
      },
      expression: "item.project_id"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "alwaysHidden"
  }, [(_vm.projects.length <= 1) ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.list'),
      expression: "'projects.list'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "external_form",
      "name": "project",
      "value": this.projects[0],
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.item.project_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "project_id", $$v)
      },
      expression: "item.project_id"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('external-form-configuration', {
    model: {
      value: (_vm.item.configuration),
      callback: function($$v) {
        _vm.$set(_vm.item, "configuration", $$v)
      },
      expression: "item.configuration"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('is_root'),
      expression: "'is_root'"
    }],
    staticClass: "lead-mask-raw"
  }, [_c('div', {
    staticClass: "lead-mask-raw--title",
    on: {
      "click": function($event) {
        _vm.isRawDisplayed = !_vm.isRawDisplayed
      }
    }
  }, [(_vm.isRawDisplayed) ? _c('i', {
    staticClass: "icon yule-icon-chevron-down"
  }) : _c('i', {
    staticClass: "icon yule-icon-chevron-right"
  }), _vm._v("\n      " + _vm._s(_vm.$t('ui.lead_mask_editor.see_raw')) + "\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRawDisplayed),
      expression: "isRawDisplayed"
    }],
    staticClass: "lead-mask-raw--content"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "structure",
      "type": "textarea",
      "value": _vm.structure,
      "placeholder": "{json}"
    },
    on: {
      "input": _vm.structureChange
    }
  })], 1)]), _vm._v(" "), _c('page-saver', {
    staticClass: "page-saver-wrapper",
    on: {
      "save": _vm.update,
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1880 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    class: _vm.classes
  }, [_c(_vm.subComponent, {
    tag: "component",
    attrs: {
      "params": _vm.params,
      "model": _vm.model,
      "item": _vm.item,
      "column": _vm.column,
      "duplicateDescriptionText": _vm.$t('models.duplicate_desc')
    },
    on: {
      "itemDelete": _vm.itemDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1881 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "upgrade-plan-wrapper"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('errors.plans.free_trial.expired_title')) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('errors.plans.free_trial.expired_description')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('button', {
    staticClass: "btn btn-flat added-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.navigateSalesPage
    }
  }, [_vm._v(_vm._s(_vm.$t('errors.plans.free_trial.expired_button')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('i', {
    staticClass: "icon icon-lock"
  })])
}]}

/***/ }),
/* 1882 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": this.id
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('editor', {
    attrs: {
      "structure": _vm.orderedUnpublishedStructure,
      "projectId": _vm.item.project_id,
      "dragElements": _vm.dragElements,
      "showTabs": false,
      "limitEditing": true,
      "shouldIncludeSubmit": true,
      "editorName": 'ExternalForm'
    },
    on: {
      "save": _vm.save,
      "publish": _vm.publish
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, _vm._l((_vm.rules), function(value, name) {
    return _c('plan-rule-list-item', {
      key: name,
      attrs: {
        "name": name,
        "value": value,
        "model": _vm.rules[name],
        "rules": _vm.rules
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editor', {
    attrs: {
      "structure": _vm.orderedUnpublishedStructure,
      "dragElements": _vm.dragElements,
      "showTabs": true,
      "limitEditing": false,
      "shouldIncludeSubmit": false,
      "editorName": 'LeadMask'
    },
    on: {
      "save": _vm.save,
      "publish": _vm.publish
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.is_ready) ? _c('div', {
    staticClass: "main-container",
    class: _vm.mainClasses
  }, [_c('notification'), _vm._v(" "), _c('modals'), _vm._v(" "), (_vm.layout == 'classic') ? _c('layout', {
    on: {
      "logout": _vm.logout
    }
  }) : (_vm.layout == 'fluid') ? _c('fluid-layout', {
    on: {
      "logout": _vm.logout
    }
  }) : (_vm.layout == 'public') ? _c('public-layout', {
    on: {
      "login": _vm.login
    }
  }) : (_vm.layout == 'dashboard') ? _c('dashboard-layout', {
    on: {
      "login": _vm.login
    }
  }) : (_vm.layout == 'empty') ? _c('empty-layout') : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-page"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "company-page-loader"
  }, [_c('loading')], 1) : _c('div', {
    staticClass: "row gutter-md"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 offset-md-2 col-lg-offset-4 col-lg-4 col-xl-4"
  }, [_c('div', {
    staticClass: "company-info"
  }, [_vm._m(0), _vm._v(" "), (!!_vm.company.name) ? _c('h4', {
    staticClass: "company-name"
  }, [_vm._v(_vm._s(_vm.company.name))]) : _vm._e(), _vm._v(" "), (!!_vm.company.website) ? _c('p', {
    staticClass: "company-website"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "link": "",
      "target": "_blank",
      "href": 'http://' + _vm.company.company_website
    }
  }, [_vm._v(_vm._s(_vm.company.company_website))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "title-subtext"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.company.created")) + "\n          " + _vm._s(_vm.formatDateTimeNatural(_vm.company.created_at)) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "title-subtext"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.company.updated")) + "\n          " + _vm._s(_vm.formatDateTimeNatural(_vm.company.updated_at)) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "company-details"
  }, [_c('div', {
    staticClass: "company-details-header justify-between flex"
  }, [_c('h5', {
    staticClass: "block"
  }, [_vm._v(_vm._s(_vm.$t("ui.company.company_details")))]), _vm._v(" "), _c('a', {
    staticClass: "link block blue-text padding-left",
    on: {
      "click": function($event) {
        return _vm.setIsOpen(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.company.edit")))])]), _vm._v(" "), _vm._l((_vm.standardCompanyFields), function(entry) {
    return _c('div', {
      staticClass: "info-block"
    }, [(entry.display_name) ? _c('p', {
      staticClass: "title-subtext"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.company.caption" + "." + entry.internal_name)) + "\n          ")]) : _vm._e(), _vm._v(" "), (entry.val == '') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("-")]) : (entry.internal_name == 'country') ? _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(_vm.country) + "\n          ")]) : _c('p', {
      staticClass: "body-p"
    }, [_vm._v("\n            " + _vm._s(entry.val) + "\n          ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
  }, [(_vm.contacts.length > 0) ? _c('div', {
    staticClass: "contact-panel"
  }, [_c('h5', {
    staticClass: "contact-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.company.contacts")) + "\n          (" + _vm._s(this.totalContacts) + ")\n        ")]), _vm._v(" "), _vm._l((_vm.contacts), function(contact) {
    return _c('div', {
      key: 'contact-' + contact.id,
      staticClass: "company-wrapper"
    }, [_c('q-card-title', {
      staticClass: "contact-card"
    }, [_c('user-image', {
      attrs: {
        "firstname": contact.firstname,
        "lastname": contact.lastname,
        "email": contact ? contact.email : '',
        "size": "small"
      }
    }), _vm._v(" "), (contact.name) ? _c('div', {
      staticClass: "contact-info"
    }, [_c('p', {
      staticClass: "contact-title-label"
    }, [_vm._v(_vm._s(contact.name))]), _vm._v(" "), (contact && contact.email) ? _c('p', {
      staticClass: "caption contact-title-sublabel",
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(contact.email) + "\n              ")]) : _c('p', {
      staticClass: "contact-title-sublabel missing-info",
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("ui.company.missing.email")) + "\n              ")])]) : (contact.company && contact.email) ? _c('div', {
      staticClass: "contact-info"
    }, [_c('p', {
      staticClass: "contact-title-label"
    }, [_vm._v("\n                " + _vm._s(contact.email) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "contact-title-sublabel missing-info",
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("ui.company.missing.name")) + "\n              ")])]) : _c('div', {
      staticClass: "contact-info"
    }, [_c('p', {
      staticClass: "contact-title-label"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("ui.company.missing.headline")) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "contact-title-sublabel missing-info",
      attrs: {
        "slot": "subtitle"
      },
      slot: "subtitle"
    }, [_vm._v("\n                " + _vm._s(_vm.$t("ui.company.missing.email_name")) + "\n              ")])]), _vm._v(" "), _c('q-icon', {
      attrs: {
        "slot": "right",
        "name": "more_horiz"
      },
      slot: "right"
    }, [_c('q-popover', {
      staticClass: "contact-actions-popover"
    }, [_c('q-list', {
      staticClass: "no-border",
      attrs: {
        "link": ""
      }
    }, [_c('q-item', {
      directives: [{
        name: "close-overlay",
        rawName: "v-close-overlay"
      }]
    }, [_c('q-item-main', {
      staticClass: "contact-action-item",
      attrs: {
        "label": _vm.$t('ui.company.contact.go_to_contact')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToContact(contact.id)
        }
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-link"
  }, [_c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.goToContacts()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.company.contact.view_all")) + "\n          ")])])], 2) : _c('div', [_c('empty-state', {
    attrs: {
      "name": "collaborators",
      "subtitle": _vm.$t('ui.company.empty_state_text')
    }
  })], 1)])]), _vm._v(" "), _c('company-edit', {
    attrs: {
      "isOpen": _vm.isOpen,
      "company": _vm.company
    },
    on: {
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      },
      "save": _vm.updateCompany
    }
  }), _vm._v(" "), _c('modal', {
    staticClass: "delete-modal",
    attrs: {
      "open": _vm.deleteModalOpen,
      "title": _vm.$t('ui.company.modals.delete.title'),
      "subtitle": _vm.deleteCompanySubtitle,
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": _vm.$t('ui.company.modals.delete.confirm'),
      "saveDisabled": _vm.deleteCompanyNameConfirm != _vm.$t('ui.company.modals.delete.confirm_word')
    },
    on: {
      "save": _vm.deleteCompany,
      "cancel": function($event) {
        return _vm.openDeleteModal(false)
      }
    }
  }, [_c('field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('ui.company.modals.delete.label')
    },
    model: {
      value: (_vm.deleteCompanyNameConfirm),
      callback: function($$v) {
        _vm.deleteCompanyNameConfirm = $$v
      },
      expression: "deleteCompanyNameConfirm"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source"
  }, [_c('div', {
    staticClass: "source-icon"
  }, [_c('img', {
    staticClass: "source-image",
    attrs: {
      "src": __webpack_require__(287)
    }
  })])])
}]}

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crud-action"
  }, [_c('ul', {
    staticClass: " right"
  }, [(!_vm.exclude.includes('duplicate')) ? _c('li', {
    staticClass: "content-item edit"
  }, [_c('div', {
    staticClass: "value-action-duplicate"
  }, [_c('i', {
    staticClass: "icon yule-icon-duplicate",
    on: {
      "click": _vm.duplicate
    }
  }), _vm._v(" "), _c('q-tooltip', [_vm._v(" " + _vm._s(_vm.$t('models.duplicate_action')) + " ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "value-action-pending"
  }, [_c('i', {
    staticClass: "icon yule-icon-clock",
    attrs: {
      "title": _vm.$t('models.external_form.pending_cloning')
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.exclude.includes('edit')) ? _c('li', {
    staticClass: "content-item edit"
  }, [_c('router-link', {
    staticClass: "icon yule-icon-edit",
    attrs: {
      "to": _vm.editRouteParams,
      "data-action": _vm.model + '.edit',
      "data-action-id": _vm.item.id
    },
    nativeOn: {
      "click": function($event) {
        return _vm.outsideClick($event)
      }
    }
  }, [_c('q-tooltip', [_vm._v(" " + _vm._s(_vm.$t('models.edit_action')) + " ")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.exclude.includes('delete')) ? _c('li', {
    staticClass: "content-item"
  }, [_c('modal', {
    attrs: {
      "title": _vm.$t('ui.global.delete_title'),
      "content": _vm.$t('ui.global.delete_confirmation', {
        name: _vm.item.name
      }),
      "actions": [{
          name: 'valid',
          class: 'btn btn-cancel',
          action: _vm.model + '.delete.confirm'
        },
        {
          name: 'cancel',
          class: 'btn btn-tertiary',
          action: _vm.model + '.delete.cancel'
        }
      ],
      "btn-class": " ",
      "data-action": _vm.model + '.delete',
      "data-action-id": _vm.item.id
    },
    on: {
      "action": _vm.action
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-trash"
  }, [_c('q-tooltip', [_vm._v(" " + _vm._s(_vm.$t('models.delete_action')) + " ")])], 1)])], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion"
  }, [_c('h4', {
    staticClass: "title",
    on: {
      "click": function($event) {
        return _vm.handleClick()
      }
    }
  }, [(_vm.active) ? _c('i', {
    staticClass: "icon yule-icon-chevron-down"
  }) : _c('i', {
    staticClass: "icon yule-icon-chevron-right"
  }), _vm._v("\n    " + _vm._s(_vm.$t(_vm.title)) + "\n  ")]), _vm._v(" "), (_vm.active) ? _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-form-slug"
  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n  "), _c('a', {
    staticClass: "icon yule-icon-external-link",
    attrs: {
      "target": "_blank",
      "href": _vm.url
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan-update"
  }, [_c('form', {
    staticClass: "plan-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('h1', [_vm._v("\n      " + _vm._s(this.item.name) + "\n    ")]), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "plan",
      "name": "name",
      "placeholder": "STARTER"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "plan",
      "name": "price",
      "placeholder": "249.99"
    },
    model: {
      value: (_vm.item.price),
      callback: function($$v) {
        _vm.$set(_vm.item, "price", $$v)
      },
      expression: "item.price"
    }
  }), _vm._v(" "), _c('accordion', {
    attrs: {
      "defaultActive": false,
      "title": "ui.pages.plan-rules"
    }
  }, [_c(_vm.accordionOne, _vm._b({
    tag: "component"
  }, 'component', _vm.accordionOneProps, false))], 1), _vm._v(" "), _c('accordion', {
    attrs: {
      "title": "ui.pages.plan-organizations"
    }
  }, [_c(_vm.accordionTwo, _vm._b({
    tag: "component"
  }, 'component', _vm.accordionTwoProps, false))], 1), _vm._v(" "), _c('page-saver', {
    on: {
      "save": _vm.update,
      "cancel": _vm.cancel
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-download"
    }
  }, [(_vm.modal.screenIsOpen) ? _c('app-download-modal', {
    on: {
      "toggle": _vm.toggleModal
    }
  }, [_c('div', {
    staticClass: "app-download-body"
  }, [_c('div', {
    staticClass: "leads-app-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1439),
      "alt": "Leads App"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('ui.modals.download_app.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.modals.download_app.subtitle')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/us/app/hileadzz/id1344775133",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "app-store-btn",
    attrs: {
      "src": __webpack_require__(1420),
      "alt": "Appel Store"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=de.fanomena.hileadzz.cordovaapp&hl=en",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "app-store-btn",
    attrs: {
      "src": __webpack_require__(1429),
      "alt": "Google Store"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('p', {
    attrs: {
      "id": "finish"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.modals.download_app.skip')))])]), _vm._v(" "), _c('div', {
    staticClass: "back-actions"
  })])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value > 0) ? _c('span', {
    class: _vm.computedClass
  }, [_vm._v(" " + _vm._s(_vm.value) + " ")]) : _c('span', {
    class: _vm.computedClass
  }, [_vm._v(" " + _vm._s(_vm.$t('models.project.unsynced_leads_count_success')) + " ")])])
},staticRenderFns: []}

/***/ }),
/* 1894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete"
  }, [_c('field', {
    staticClass: "field autofill",
    attrs: {
      "name": _vm.name,
      "model": _vm.model,
      "label": _vm.label,
      "type": "text",
      "autocomplete": _vm.autocomplete,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": function($event) {
        return _vm.debouncer(_vm.item[_vm.name])
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.onArrowDown($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        _vm.shouldQuery = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.onArrowUp($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }]
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }), _vm._v(" "), (_vm.results.length > 0) ? _c('ul', {
    class: _vm.classes,
    attrs: {
      "id": "autocomplete-results"
    }
  }, _vm._l((_vm.results), function(result, idx) {
    return _c('li', {
      key: idx,
      staticClass: "autocomplete-result",
      class: {
        'is-active': idx === _vm.arrowCounter
      },
      on: {
        "click": function($event) {
          return _vm.setResult(result)
        },
        "populateFields": _vm.populateFields
      }
    }, [_vm._v("\n      " + _vm._s(result.name) + " " + _vm._s(result.city) + " " + _vm._s(result.country) + "\n    ")])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tracking-chart"
  }, [_c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "position": "relative",
      "height": "40vh",
      "width": "100%"
    }
  }, [_c('canvas', {
    ref: "chart",
    staticClass: "chart"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts-uploader"
  }, [_c('modal', {
    attrs: {
      "title": _vm.modalTitle,
      "open": _vm.open,
      "saveText": _vm.modalSaveText
    },
    on: {
      "save": _vm.fileUpload,
      "cancel": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "contacts-uploader-dropbox"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("ui.contacts.import.description")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.contacts.import.format")))]), _vm._v(" "), _c('div', {
    staticClass: "xls-upload"
  }, [_c('upload-field', {
    on: {
      "change": _vm.fileChange
    }
  })], 1), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "errors"
  }, [_c('span', {
    staticClass: "errors-icon"
  }, [_c('q-icon', {
    attrs: {
      "name": "error_outline"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "errors-msg"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e()])]), _vm._v(" "), (_vm.uploading) ? _c('div', {
    staticClass: "contacts-uploader-loader"
  }, [_c('loading')], 1) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "title": _vm.$t('ui.contacts.import.success_modal_title'),
      "open": _vm.importReportOpen,
      "cancelText": "",
      "saveText": "ui.global.ok"
    },
    on: {
      "save": function($event) {
        return _vm.importReportClose()
      },
      "cancel": function($event) {
        return _vm.importReportClose()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('ui.contacts.import.success_modal_body')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.contacts.import.success_modal_report', {
    total: _vm.importReport.created_contacts + _vm.importReport.updated_contacts,
    new: _vm.importReport.created_contacts,
    updated: _vm.importReport.updated_contacts
  })))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-show"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: _vm.getLeadPathWithQueries(_vm.params.project_id, _vm.item.id)
      }
    }
  }, [(_vm.item.firstname || _vm.item.lastname) ? _c('div', [_c('span', {
    staticClass: "value-show--firstname"
  }, [_vm._v(_vm._s(_vm.item.firstname))]), _vm._v(" "), _c('span', {
    staticClass: "value-show--lastname"
  }, [_vm._v(_vm._s(_vm.item.lastname))]), _c('br')]) : _c('div', [_c('span', {
    staticClass: "value-show--firstname"
  }, [_vm._v(_vm._s(_vm.item.email))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leads-filtering"
  }, [_c('div', {
    staticClass: "leads-filtering--sync-status"
  }, [(_vm.$store.getters.getOrganizationConfig('crm_presence')) ? _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.sync_status')))]), _vm._v(" "), (_vm.newFilters.sync_status) ? _c('field', {
    staticClass: "is-inline",
    attrs: {
      "type": "checkbox",
      "name": "sync_status",
      "label": " ",
      "model": "leads",
      "collection": _vm.syncStatusCollection
    },
    model: {
      value: (_vm.newFilters.sync_status.value),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.sync_status, "value", $$v)
      },
      expression: "newFilters.sync_status.value"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.origin')))]), _vm._v(" "), (_vm.newFilters.origin) ? _c('field', {
    staticClass: "is-inline",
    attrs: {
      "type": "checkbox",
      "name": "origin",
      "label": " ",
      "model": "leads",
      "collection": _vm.originCollection
    },
    model: {
      value: (_vm.newFilters.origin.value),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.origin, "value", $$v)
      },
      expression: "newFilters.origin.value"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.import_origin')))]), _vm._v(" "), (_vm.newFilters.import_origin) ? _c('field', {
    staticClass: "is-inline",
    attrs: {
      "type": "checkbox",
      "name": "importOrigin",
      "label": " ",
      "model": "leads",
      "collection": _vm.importOriginCollection
    },
    model: {
      value: (_vm.newFilters.import_origin.value),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.import_origin, "value", $$v)
      },
      expression: "newFilters.import_origin.value"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.$store.getters.getOrganizationConfig('crm_presence')) ? _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.sync_disabled')))]), _vm._v(" "), (_vm.newFilters.sync_disabled) ? _c('field', {
    staticClass: "is-inline",
    attrs: {
      "type": "checkbox",
      "name": "sync_disabled",
      "label": " ",
      "model": "leads",
      "collection": _vm.syncDisabledCollection
    },
    model: {
      value: (_vm.newFilters.sync_disabled.value),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.sync_disabled, "value", $$v)
      },
      expression: "newFilters.sync_disabled.value"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.start_date')))]), _vm._v(" "), _c('div', {
    staticClass: "field grid has-gutter-xl"
  }, [(_vm.newFilters.start_date) ? _c('datepicker', {
    attrs: {
      "clear-button": true,
      "input-class": "input--datepicker",
      "id": "start_date",
      "name": "start_date",
      "language": _vm.getDatePickerLanguage()
    },
    model: {
      value: (_vm.newFilters.start_date.start),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.start_date, "start", $$v)
      },
      expression: "newFilters.start_date.start"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newFilters.start_date) ? _c('datepicker', {
    attrs: {
      "clear-button": true,
      "input-class": "input--datepicker",
      "id": "end_date",
      "name": "end_date",
      "language": _vm.getDatePickerLanguage()
    },
    model: {
      value: (_vm.newFilters.start_date.end),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.start_date, "end", $$v)
      },
      expression: "newFilters.start_date.end"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "leads-filter--validate"
  }, [_c('a', {
    on: {
      "click": _vm.reset
    }
  }, [_c('button', {
    staticClass: "btn btn-tertiary"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.reset')))])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.apply
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-save"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.apply')))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.computedClass
  }, [_vm._v("\n  " + _vm._s(_vm.$t(("models.user.statuses." + _vm.value))) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-show"
  }, [(_vm.item.company) ? _c('div', [_vm._v(_vm._s(_vm.item.company))]) : _vm._e(), _vm._v(" "), (_vm.item.city) ? _c('div', [_vm._v(_vm._s(_vm.item.city))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items.length > 0) ? _c('div', {
    staticClass: "folded-navigation"
  }, [_c('ul', {
    ref: "listContainer",
    staticClass: "folded-navigation--main"
  }, _vm._l((_vm.filteredItems), function(item) {
    return _c('folded-navigation-item', {
      key: item.name,
      attrs: {
        "item": item
      }
    })
  }), 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('field', {
    attrs: {
      "error": _vm.error,
      "autofocus": _vm.autofocus,
      "readonly": _vm.readonly,
      "label": _vm.$t(_vm.newLabel),
      "classes": _vm.classes,
      "collection": _vm.newCollection,
      "name": _vm.name,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "defaultValue": _vm.defaultValue,
      "type": _vm.type,
      "helpIcon": _vm.helpIcon,
      "helpIconOptions": _vm.helpIconOptions,
      "enrich_tags": _vm.enrich_tags,
      "autocomplete": _vm.autocomplete,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.newValue),
      callback: function($$v) {
        _vm.newValue = $$v
      },
      expression: "newValue"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-update-business-kits lead-mask gutter-xs row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('ui.business_kit.send')))]), _vm._v(" "), _c('tag-list', {
    attrs: {
      "label": "Tags",
      "name": "tags",
      "value": _vm.item.tags
    },
    on: {
      "input": _vm.tagUpdate
    }
  }), _vm._v(" "), (_vm.items.length > 0) ? _c('div', [_c('field', {
    staticClass: "businesskit-select",
    attrs: {
      "model": "business_kit",
      "name": "select",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.items,
      "value": _vm.business_kit_id
    },
    on: {
      "input": _vm.emitBusinessKitId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-bk"
  }, [_c('a', {
    staticClass: "link is-margin-bottom-20",
    attrs: {
      "href": this.selected_businesskit_url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ui.business_kit.preview')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "field field-checkbox"
  }, [_c('div', {
    staticClass: "field--wrapper"
  }, [_c('div', {
    staticClass: "field--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authorization),
      expression: "authorization"
    }],
    staticClass: "input--checkbox",
    attrs: {
      "type": "checkbox",
      "id": "authorization",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.authorization) ? _vm._i(_vm.authorization, "true") > -1 : (_vm.authorization)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.authorization,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.authorization = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.authorization = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.authorization = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "authorization"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.business_kit.confirmation')))])])])])], 1) : _c('div', [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.lead-no-businesskit')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'is-disabled': !_vm.business_kit_id || !_vm.authorization || _vm.loading, '': _vm.loading
    },
    attrs: {
      "disabled": !_vm.authorization
    },
    on: {
      "click": _vm.send_businesskit
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.business_kit.send_confirm')))])]), _vm._v(" "), (this.redirect_url) ? _c('div', {
    staticClass: "message"
  }, [_c('p', {
    class: _vm.messageType
  }, [_vm._v("\n          " + _vm._s(_vm.messageContent) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "link is-margin-bottom-20",
    attrs: {
      "href": this.redirect_url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(this.$t('models.business_kit.create_template')))])]) : _c('div', {
    staticClass: "message"
  }, [_c('p', {
    class: _vm.messageType
  }, [_vm._v("\n          " + _vm._s(_vm.messageContent) + "\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bk-activity col-xs-12 col-sm-12 col-md-5 col-lg-5 offset-md-1"
  }, [(!_vm.businesskit_history.length) ? _c('div', {
    staticClass: "empty-state-bk-history"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(157),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.business_kit.activity')))])]) : _vm._e(), _vm._v(" "), (_vm.businesskit_history.length) ? _c('h3', [_vm._v("\n        " + _vm._s(_vm.$t('ui.business_kit.history')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.businesskit_history.length) ? _c('div', {}, _vm._l((_vm.businesskit_history), function(bk) {
    return _c('div', {
      key: bk.eventbaxx_event_name,
      staticClass: "truncate-text"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": bk.bag_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(bk.eventbaxx_event_name))]), _vm._v(" "), _c('p', {
      staticClass: "bk-history--date"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('models.business_kit.status.' + bk.status)) + " on " + _vm._s(_vm.moment(bk.transferred_at).format("DD.MM.YYYY - HH:mm")) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "bk-history--mobile"
    }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.moment(bk.transferred_at).format("DD.MM.YYYY HH:mm"))), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": bk.bag_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(bk.eventbaxx_event_name) + " - " + _vm._s(_vm.$t('models.business_kit.status.' + bk.status)))])])])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-statistics"
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('loading')], 1), _vm._v(" "), _c('div', {
    staticClass: "statistics-global"
  }, [_c('div', {
    staticClass: "panel-container panel-container--mobile"
  }, [_c('div', {
    staticClass: "panel bk-sent"
  }, [(!_vm.is_loading) ? _c('bk-sent', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel leads-chart"
  }, [(!_vm.is_loading) ? _c('leads-chart', {
    attrs: {
      "start-date": _vm.queryParams.start_date,
      "end-date": _vm.queryParams.end_date,
      "leads-count": _vm.leads_count,
      "statistics": _vm.statistics,
      "trackings": _vm.trackings
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel leads-classification"
  }, [(!_vm.is_loading) ? _c('leads-classification', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel bk-per-lead"
  }, [(!_vm.is_loading) ? _c('bk-per-lead', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-container panel-container--desktop"
  }, [_c('div', {
    staticClass: "column column-left"
  }, [_c('div', {
    staticClass: "panel bk-sent"
  }, [(!_vm.is_loading) ? _c('bk-sent', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel leads-chart"
  }, [(!_vm.is_loading) ? _c('leads-chart', {
    attrs: {
      "start-date": _vm.queryParams.start_date,
      "end-date": _vm.queryParams.end_date,
      "leads-count": _vm.leads_count,
      "statistics": _vm.statistics,
      "trackings": _vm.trackings
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column column-right"
  }, [_c('div', {
    staticClass: "panel leads-classification"
  }, [(!_vm.is_loading) ? _c('leads-classification', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel bk-per-lead"
  }, [(!_vm.is_loading) ? _c('bk-per-lead', {
    attrs: {
      "statistics": _vm.statistics
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), (!_vm.is_loading) ? _c('div', {
    staticClass: "grid title-grid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('statistics.latest_trackings')))]), _vm._v(" "), _c('router-link', {
    staticClass: "link full-link",
    attrs: {
      "to": {
        name: 'project_statistics_trackings',
        params: {
          id: _vm.id
        }
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('statistics.see_full_tracking_history')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "icon yule-icon-chevron-right link short-link",
    attrs: {
      "to": {
        name: 'project_statistics_trackings',
        params: {
          id: _vm.id
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.trackings) ? _c('div', {
    staticClass: "statistics-trackings"
  }, [(!_vm.is_loading) ? _c('tracking-table', {
    attrs: {
      "date-format": "DD.MM.YYYY HH:mm",
      "project-id": _vm.id,
      "trackings": _vm.trackings.resources
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "is-empty"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('statistics.no_data')) + "\n  ")]), _vm._v(" "), (_vm.rankings && _vm.ranking_unable) ? _c('div', {
    staticClass: "statistics-ranking"
  }, [(!_vm.is_loading) ? _c('h3', [_vm._v(_vm._s(_vm.$t('statistics.lead_detectors_overview')))]) : _vm._e(), _vm._v(" "), (!_vm.is_loading) ? _c('ranking', {
    attrs: {
      "rankings": _vm.rankings
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('external_forms.list'),
      expression: "'external_forms.list'"
    }]
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  })], 1), _vm._v(" "), _c('general-listing', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.collectionData,
      "params": {
        global_sorting: true,
        sort_by: this.query.sort_by,
        sort_order: this.query.sort_order
      },
      "has_searched": _vm.has_searched,
      "model": "external_form"
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  }), _vm._v(" "), _c('external-form-create')], 1)
},staticRenderFns: []}

/***/ }),
/* 1906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('email_templates.list'),
      expression: "'email_templates.list'"
    }]
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  })], 1), _vm._v(" "), _c('collection', {
    attrs: {
      "data": _vm.items,
      "structure": _vm.collectionData,
      "model": "email_template"
    },
    on: {
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "value-project-name",
    attrs: {
      "to": _vm.routeParams,
      "data-action": _vm.model + '.show',
      "data-action-id": _vm.item.id
    }
  }, [_c('div', {
    staticClass: "value-project-name--name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), (_vm.item.lead_mask_name) ? _c('div', {
    staticClass: "value-project-name--lead-mask"
  }, [_vm._v(_vm._s(_vm.$t('models.project.lead_mask')) + ": " + _vm._s(_vm.item.lead_mask_name))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-update-business-card"
  }, [(_vm.lead.business_card_image_url) ? _c('div', {
    staticClass: "image_present",
    on: {
      "click": _vm.openBusinessCard
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.lead.business_card_image_url,
      "alt": "business card",
      "onerror": 'this.onerror=null; this.src=\'' + this.image + '\';'
    }
  })]) : _c('div', {
    staticClass: "no_image"
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": "no image associated"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-show"
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('div', {
    staticClass: "project-update row gutter-md"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row gutter-md justify-center"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-5"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "project",
      "name": "name",
      "placeholder": "Tech con 2016"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "location",
      "placeholder": "Berlin"
    },
    model: {
      value: (_vm.item.location),
      callback: function($$v) {
        _vm.$set(_vm.item, "location", $$v)
      },
      expression: "item.location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row gutter-sm"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "field",
    class: {
      'is-unvalid': _vm.start_date_error
    }
  }, [_c('label', {
    attrs: {
      "for": "start_date"
    }
  }, [_vm._v(_vm._s(_vm.$t('models.project.start_date')))]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "clear-button": true,
      "disabled-dates": {
        from: new Date(_vm.formattedEndDate)
      },
      "input-class": "input--datepicker",
      "id": "start_date",
      "name": "start_date",
      "language": _vm.getDatePickerLanguage()
    },
    model: {
      value: (_vm.formattedStartDate),
      callback: function($$v) {
        _vm.formattedStartDate = $$v
      },
      expression: "formattedStartDate"
    }
  }), _vm._v(" "), (_vm.start_date_error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t('errors.' + _vm.start_date_error)))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "field",
    class: {
      'is-unvalid': _vm.end_date_error
    }
  }, [_c('label', {
    attrs: {
      "for": "end_date"
    }
  }, [_vm._v(_vm._s(_vm.$t('models.project.end_date')))]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "clear-button": true,
      "disabled-dates": {
        to: new Date(_vm.formattedStartDate)
      },
      "input-class": "input--datepicker",
      "id": "end_date",
      "name": "end_date",
      "language": _vm.getDatePickerLanguage()
    },
    model: {
      value: (_vm.formattedEndDate),
      callback: function($$v) {
        _vm.formattedEndDate = $$v
      },
      expression: "formattedEndDate"
    }
  }), _vm._v(" "), (_vm.end_date_error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t('errors.' + _vm.end_date_error)))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "classification-container"
  }, [_c('field', {
    staticClass: "is-buttonned",
    class: _vm.selectClass,
    attrs: {
      "type": "radio",
      "collection": _vm.classificationCollection,
      "label": _vm.$t('models.project.default_classification'),
      "params": {
        'no_i18n': true
      },
      "model": "project",
      "name": "default_classification"
    },
    on: {
      "input": _vm.inputClassification
    },
    model: {
      value: (_vm.item.default_classification),
      callback: function($$v) {
        _vm.$set(_vm.item, "default_classification", $$v)
      },
      expression: "item.default_classification"
    }
  })], 1), _vm._v(" "), _c('form-switch', {
    attrs: {
      "id": "scope_leads",
      "label": "models.project.scope_leads",
      "value": _vm.item.scope_leads_to_user
    },
    model: {
      value: (_vm.item.scope_leads_to_user),
      callback: function($$v) {
        _vm.$set(_vm.item, "scope_leads_to_user", $$v)
      },
      expression: "item.scope_leads_to_user"
    }
  }), _vm._v(" "), (!_vm.currentPlanIsTalents) ? _c('div', [(_vm.showCrmSyncSwitch()) ? _c('form-switch', {
    attrs: {
      "errors": _vm.errors,
      "reverse": true,
      "model": "project",
      "name": "sync_disabled",
      "value": _vm.item.sync_disabled
    },
    model: {
      value: (_vm.item.sync_disabled),
      callback: function($$v) {
        _vm.$set(_vm.item, "sync_disabled", $$v)
      },
      expression: "item.sync_disabled"
    }
  }) : _vm._e(), _vm._v(" "), _c('form-switch', {
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "background_xml_export_enabled",
      "value": _vm.item.background_xml_export_enabled
    },
    model: {
      value: (_vm.item.background_xml_export_enabled),
      callback: function($$v) {
        _vm.$set(_vm.item, "background_xml_export_enabled", $$v)
      },
      expression: "item.background_xml_export_enabled"
    }
  }), _vm._v(" "), (_vm.allowedLeadReview()) ? _c('form-switch', {
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "enable_lead_review",
      "value": _vm.item.enable_lead_review
    },
    model: {
      value: (_vm.item.enable_lead_review),
      callback: function($$v) {
        _vm.$set(_vm.item, "enable_lead_review", $$v)
      },
      expression: "item.enable_lead_review"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.currentPlanIsTalents) ? _c('q-collapsible', {
    staticClass: "additional_data",
    attrs: {
      "label": _vm.$t('models.project.set_aditional_data_content')
    }
  }, [_c('div', [_c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organizations.list'),
      expression: "'organizations.list'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "organization_id",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.organizations
    },
    model: {
      value: (_vm.item.organization_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "organization_id", $$v)
      },
      expression: "item.organization_id"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "crm_campaign_id"
    },
    model: {
      value: (_vm.item.additional_data.crm_campaign_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "crm_campaign_foreign_id", $$v)
      },
      expression: "item.additional_data.crm_campaign_foreign_id"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "crm_sales_employee_id"
    },
    model: {
      value: (_vm.item.additional_data.crm_sales_employee_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "crm_sales_employee_foreign_id", $$v)
      },
      expression: "item.additional_data.crm_sales_employee_foreign_id"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "crm_marketing_employee_id"
    },
    model: {
      value: (_vm.item.additional_data.crm_marketing_employee_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "crm_marketing_employee_foreign_id", $$v)
      },
      expression: "item.additional_data.crm_marketing_employee_foreign_id"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "crm_group_code_id"
    },
    model: {
      value: (_vm.item.additional_data.crm_group_code_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "crm_group_code_foreign_id", $$v)
      },
      expression: "item.additional_data.crm_group_code_foreign_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: {
      'is-unvalid': _vm.baseScoreError()
    }
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "model": "project",
      "name": "base_score"
    },
    model: {
      value: (_vm.item.additional_data.base_score),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "base_score", _vm._n($$v))
      },
      expression: "item.additional_data.base_score"
    }
  }), _vm._v(" "), (_vm.baseScoreError()) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t('errors.base_score_error')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "mailchimp_list_id"
    },
    model: {
      value: (_vm.item.additional_data.mailchimp_list_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "mailchimp_list_id", $$v)
      },
      expression: "item.additional_data.mailchimp_list_id"
    }
  })], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticClass: "form-subtitle "
  }, [_vm._v(_vm._s(_vm.$t('ui.project_wizard.lead-sheets')))])]), _vm._v(" "), _c('form', {
    staticClass: "project-update--form right col-xs-12 col-sm-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row gutter-sm"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('div', {
    ref: "basic",
    staticClass: "leadsheet-box",
    on: {
      "click": function($event) {
        return _vm.setLeadSheet('basic')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(290)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Standard")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('div', {
    ref: "advanced",
    staticClass: "leadsheet-box",
    on: {
      "click": function($event) {
        return _vm.setLeadSheet('advanced')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(289)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Advanced")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    ref: "none",
    staticClass: "lead-sheet-selector"
  }, [(this.leadMasks.length > 0) ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('lead_masks.list'),
      expression: "'lead_masks.list'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "lead_mask_id",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.leadMasks
    },
    on: {
      "input": function($event) {
        return _vm.setLeadSheet('none')
      }
    },
    model: {
      value: (_vm.item.lead_mask_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "lead_mask_id", $$v)
      },
      expression: "item.lead_mask_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'lead_masks'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.project.create_leadsheet')))])], 1)])]), _vm._v(" "), (_vm.isCurrentlySelectedBasicOrAdvanced) ? _c('div', {
    staticClass: "info-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(452)
    }
  }), _vm._v(" "), (_vm.currentlySelected == 'basic') ? _c('div', {
    staticClass: "info info-standard"
  }, [_c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.standard_title')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.standard_subtitle_1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project.standard_description_1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.standard_subtitle_2')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project.standard_description_2')))])]) : _vm._e(), _vm._v(" "), (_vm.currentlySelected == 'advanced') ? _c('div', {
    staticClass: "info info-advanced"
  }, [_c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.advanced_title')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.advanced_subtitle_1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project.advanced_description_1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.advanced_subtitle_2')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project.advanced_description_2')))])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-12"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary btn-flat",
    attrs: {
      "data-action": "project.cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), (_vm.type) ? _c('button', {
    staticClass: "btn btn-primary btn-flat btn-save",
    attrs: {
      "type": "submit",
      "data-action": "project.update"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-' + _vm.type + '-button')))]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-detailed-statistics"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "title-grid"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('statistics.lead_statistics')))]), _vm._v(" "), _c('relative-date-choser', {
    attrs: {
      "choices": [1, 7, 30, 60]
    },
    on: {
      "change": _vm.newDate
    }
  })], 1)]), _vm._v(" "), (_vm.trackings.length > 0) ? _c('div', [_c('tracking-chart', {
    attrs: {
      "start-date": _vm.start_date.format(),
      "end-date": _vm.end_date.format(),
      "trackings": _vm.trackings
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.trackingsSorted), function(trackings) {
    return _c('div', {
      key: trackings[0].time,
      staticClass: "tracking-table"
    }, [_c('div', {
      staticClass: "tracking-table--date"
    }, [_vm._v("\n        " + _vm._s(_vm.moment(trackings[0].time).format('MMMM Do')) + "\n      ")]), _vm._v(" "), _c('tracking-table', {
      attrs: {
        "trackings": trackings
      }
    })], 1)
  })], 2) : _c('div', [_vm._v("\n    " + _vm._s(_vm.$t('statistics.no_data')) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.trackings) ? _c('div', {
    staticClass: "project-trackings"
  }, [_c('div', {
    staticClass: "statistics-global"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "title-grid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('statistics.latest_trackings')))]), _vm._v(" "), _c('relative-date-choser', {
    attrs: {
      "choices": [1, 7, 30, 60]
    },
    on: {
      "change": _vm.dateChange
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'project_statistics',
        params: {
          id: _vm.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t('statistics.get_back_to_statistics')) + "\n        ")])], 1), _vm._v(" "), (_vm.trackingsSorted.length > 0) ? _c('div', _vm._l((_vm.trackingsSorted), function(trackings) {
    return (trackings) ? _c('div', {
      key: trackings[0].time,
      staticClass: "tracking-table"
    }, [_c('div', {
      staticClass: "tracking-table--date"
    }, [_vm._v("\n            " + _vm._s(_vm.moment(trackings[0].time).format('MMMM Do')) + "\n          ")]), _vm._v(" "), _c('tracking-table', {
      attrs: {
        "project-id": _vm.id,
        "trackings": trackings
      }
    })], 1) : _vm._e()
  }), 0) : _c('div', {
    staticClass: "is-empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.no_data')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.returnedParams.total_pages,
      "page": _vm.returnedParams.current_page
    },
    on: {
      "goToPage": _vm.goToPage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    staticClass: "leads-over-time",
    attrs: {
      "is-loading": _vm.isLoading,
      "is-loading-spinner": ""
    }
  }, [
    [_c('div', {
      staticClass: "dark-charts m-bottom-base"
    }, [_c('h4', {}, [_vm._v(_vm._s(_vm.$t('ui.dashboard.leads_over_time.label')))]), _vm._v(" "), _c('div', {
      ref: _vm.identifier,
      staticStyle: {
        "height": "182px"
      },
      attrs: {
        "id": _vm.identifier
      },
      on: {
        "mouseleave": function($event) {
          return _vm.setItVisibleTooltip(false)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "dashboard-tooltip",
      style: (_vm.tooltip)
    }, [_c('span', {
      staticClass: "new"
    }, [_vm._v(_vm._s(_vm.chart.tooltip.leads) + " " + _vm._s(_vm.$t('ui.dashboard.leads_over_time.linear')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "cumulated"
    }, [_vm._v(_vm._s(_vm.chart.tooltip.cumulative) + " " + _vm._s(_vm.$t('ui.dashboard.leads_over_time.cumulated')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("format")(_vm.chart.tooltip.date, 'en', _vm.filter.period)))])]), _vm._v(" "), _c('leads-collected-widget', {
      attrs: {
        "filter": _vm.filter
      }
    })]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "user-api-choice-container body"
  }, [(_vm.title !== undefined && _vm.title !== null) ? _c('h4', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (!!_vm.caption) ? _c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.caption))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "choice-container"
  }, _vm._l((_vm.choices), function(choice) {
    return _c('div', {
      key: choice.index,
      staticClass: "choice-box-wrapper"
    }, [_c('div', {
      staticClass: "choice-box",
      on: {
        "click": function($event) {
          return _vm.resolve(choice)
        }
      }
    }, [(('name' in choice) && choice.name !== null && choice.name !== '') ? _c('h5', {
      staticClass: "title"
    }, [_vm._v("\n            " + _vm._s(choice.name) + "\n          ")]) : _c('h5', {
      staticClass: "title"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('errors.api_error_modal.no_name')) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "choice-info"
    }, [_c('ul', _vm._l((_vm.listItems), function(attribute) {
      return _c('li', {
        key: attribute
      }, [(choice[attribute]) ? _c('p', {
        staticClass: "caption list-item"
      }, [_vm._v("\n                  " + _vm._s(choice[attribute]) + "\n                ")]) : _vm._e()])
    }), 0)])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-state-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageSrc
    }
  }), _vm._v(" "), (_vm.heading) ? _c('h3', [_vm._v("\n    " + _vm._s(_vm.heading) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.subtitle) ? _c('p', [_vm._v("\n    " + _vm._s(_vm.subtitle) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.button) ? _c('add-button', {
    staticClass: "buttons"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "spinner spinner--yellow"
  }, [_c('div', {
    staticClass: "spinner__item1"
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner__item2"
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner__item3"
  })])])
}]}

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "logo--text"
  }, [_c('logo', {
    attrs: {
      "logoType": "login"
    }
  })], 1)]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('errors.' + _vm.error.code)) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.success == false) ? _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('ui.auth.password_reset_request_title')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.password_reset_request')))]), _vm._v(" "), _c('form', {
    staticClass: "password-reset-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "me@example.com",
      "label": "ui.auth.email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-login",
    attrs: {
      "type": "submit",
      "data-action": "user.password_reset_request"
    },
    domProps: {
      "value": _vm.$t('ui.auth.confirm')
    }
  })])], 1)]) : _c('div', {
    staticClass: "password-reset-confirm"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(293)
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('ui.auth.password_reset_request_title_confirm')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.password_reset_request_confirm')))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t('ui.auth.return_to_login')))])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('p', [_vm._v("Impossible to recover?")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$t('ui.pages.contact_us_email'),
      "target": "_blank"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.contact_us')) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 1918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('lead_masks.list'),
      expression: "'lead_masks.list'"
    }]
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  })], 1), _vm._v(" "), _c('general-listing', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.collectionData,
      "params": {
        global_sorting: true,
        sort_by: this.query.sort_by,
        sort_order: this.query.sort_order
      },
      "model": "lead_mask",
      "has_searched": _vm.has_searched
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  }), _vm._v(" "), _c('lead-mask-create')], 1)
},staticRenderFns: []}

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row gutter-md ext-form-config"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('h4', {
    staticClass: "separator"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('ui.external_form.frontend_actions')) + "\n    ")]), _vm._v(" "), _c('email-list', {
    attrs: {
      "label": _vm.$t('ui.external_form.send_notification_to')
    },
    model: {
      value: (_vm.config.actions.send_team_confirmation_mail.emails),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_team_confirmation_mail, "emails", $$v)
      },
      expression: "config.actions.send_team_confirmation_mail.emails"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-wrapper"
  }, [_c('div', [_c('div', {
    staticClass: "status-switch"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.success_message.status),
      expression: "config.actions.success_message.status"
    }],
    attrs: {
      "type": "radio",
      "id": "success_message",
      "value": "enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.config.actions.success_message.status, "enabled")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.config.actions.success_message, "status", "enabled")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "success_message"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.external_form.success_message')))])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.redirect_to.status),
      expression: "config.actions.redirect_to.status"
    }],
    attrs: {
      "type": "radio",
      "id": "redirect_to",
      "value": "enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.config.actions.redirect_to.status, "enabled")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.config.actions.redirect_to, "status", "enabled")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "redirect_to"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.external_form.redirection_url')))])])]), _vm._v(" "), _c('div', {
    class: {
      'hidden': _vm.config.actions.success_message.status === 'disabled'
    }
  }, [_c('field', {
    attrs: {
      "label": "empty",
      "placeholder": "Thank you!",
      "type": "textarea"
    },
    model: {
      value: (_vm.config.actions.success_message.content),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.success_message, "content", $$v)
      },
      expression: "config.actions.success_message.content"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'hidden': _vm.config.actions.redirect_to.status === 'disabled'
    }
  }, [_c('field', {
    attrs: {
      "label": "empty",
      "placeholder": "https://fanomena.io",
      "type": "text"
    },
    model: {
      value: (_vm.config.actions.redirect_to.url),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.redirect_to, "url", $$v)
      },
      expression: "config.actions.redirect_to.url"
    }
  })], 1)])])]), _vm._v(" "), _c('h4', {
    staticClass: "separator"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('ui.external_form.follow_up')) + "\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "vertical-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.board_businesskit.status),
      expression: "config.actions.board_businesskit.status"
    }],
    staticClass: "is-inline-block vertical-center",
    attrs: {
      "type": "checkbox",
      "id": "bk_status",
      "true-value": "enabled",
      "false-value": "disabled",
      "name": "business_kit_boarding_status"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.actions.board_businesskit.status) ? _vm._i(_vm.config.actions.board_businesskit.status, null) > -1 : _vm._q(_vm.config.actions.board_businesskit.status, "enabled")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.actions.board_businesskit.status,
          $$el = $event.target,
          $$c = $$el.checked ? ("enabled") : ("disabled");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.actions.board_businesskit, "status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.actions.board_businesskit, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.actions.board_businesskit, "status", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-text",
    attrs: {
      "for": "bk_status"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ui.external_form.bk_boarding')) + "\n        ")])]), _vm._v(" "), _c('field', {
    staticClass: "select-field",
    attrs: {
      "readonly": _vm.config.actions.board_businesskit.status === 'disabled' ? true : false,
      "collection": _vm.businessKitCollection,
      "type": "select",
      "name": "business_kit_boarding",
      "label": "empty",
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.config.actions.board_businesskit.eventbaxx_event_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.board_businesskit, "eventbaxx_event_foreign_id", $$v)
      },
      expression: "config.actions.board_businesskit.eventbaxx_event_foreign_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vertical-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.board_businesskit.send_directly),
      expression: "config.actions.board_businesskit.send_directly"
    }],
    staticClass: "is-inline-block",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.config.actions.board_businesskit.status === 'disabled' ? true : false,
      "true-value": false,
      "false-value": true,
      "id": "bk_send_directly"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.actions.board_businesskit.send_directly) ? _vm._i(_vm.config.actions.board_businesskit.send_directly, null) > -1 : _vm._q(_vm.config.actions.board_businesskit.send_directly, false)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.actions.board_businesskit.send_directly,
          $$el = $event.target,
          $$c = $$el.checked ? (false) : (true);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.actions.board_businesskit, "send_directly", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.actions.board_businesskit, "send_directly", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.actions.board_businesskit, "send_directly", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-text",
    class: {
      'text-disabled': _vm.config.actions.board_businesskit.status === 'disabled' ? true : false
    },
    attrs: {
      "for": "bk_send_directly"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.send_directly')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "is-block separator"
  }, [_c('div', {
    staticClass: "vertical-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.send_lead_confirmation_mail.status),
      expression: "config.actions.send_lead_confirmation_mail.status"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "enabled",
      "false-value": "disabled",
      "name": "send_team_confirmation_mail_status",
      "id": "lead_mail_status"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.actions.send_lead_confirmation_mail.status) ? _vm._i(_vm.config.actions.send_lead_confirmation_mail.status, null) > -1 : _vm._q(_vm.config.actions.send_lead_confirmation_mail.status, "enabled")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.actions.send_lead_confirmation_mail.status,
          $$el = $event.target,
          $$c = $$el.checked ? ("enabled") : ("disabled");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.actions.send_lead_confirmation_mail, "status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.actions.send_lead_confirmation_mail, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "status", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-text",
    attrs: {
      "for": "lead_mail_status"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ui.external_form.email_notification')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "max-width"
  }, [_c('field', {
    attrs: {
      "collection": _vm.emailTemplateCollection,
      "disabled": _vm.config.actions.send_lead_confirmation_mail.status === 'disabled' ? true : false,
      "type": "select",
      "name": "send_lead_confirmation_mail_template",
      "label": _vm.$t('ui.external_form.email_template'),
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.config.actions.send_lead_confirmation_mail.email_template_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "email_template_foreign_id", $$v)
      },
      expression: "config.actions.send_lead_confirmation_mail.email_template_foreign_id"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "disabled": _vm.NoPresentEmailTemplateOrDisabled(_vm.config),
      "name": "send_lead_confirmation_mail_subject",
      "label": _vm.$t('ui.external_form.mail_subject')
    },
    model: {
      value: (_vm.config.actions.send_lead_confirmation_mail.subject),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "subject", $$v)
      },
      expression: "config.actions.send_lead_confirmation_mail.subject"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "disabled": _vm.NoPresentEmailTemplateOrDisabled(_vm.config),
      "name": "send_lead_confirmation_mail_url",
      "label": _vm.$t('ui.external_form.mail_url')
    },
    model: {
      value: (_vm.config.actions.send_lead_confirmation_mail.url),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "url", $$v)
      },
      expression: "config.actions.send_lead_confirmation_mail.url"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "disabled": _vm.NoPresentEmailTemplateOrDisabled(_vm.config),
      "name": "send_lead_confirmation_mail_cta",
      "label": _vm.$t('ui.external_form.mail_cta')
    },
    model: {
      value: (_vm.config.actions.send_lead_confirmation_mail.cta_text),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "cta_text", $$v)
      },
      expression: "config.actions.send_lead_confirmation_mail.cta_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('h5', [_vm._v("\n      Integrations\n    ")]), _vm._v(" "), _c('go-to-webinar', {
    attrs: {
      "active": _vm.config.actions.board_citrix.status === 'enabled' ? true : false
    },
    on: {
      "activeInput": function($event) {
        return _vm.switchCitrixStatus()
      }
    },
    model: {
      value: (_vm.config.actions.board_citrix.citrix_webinar_keys),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.board_citrix, "citrix_webinar_keys", $$v)
      },
      expression: "config.actions.board_citrix.citrix_webinar_keys"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "options-container"
  }, [_c('div', {
    staticClass: "options-head"
  }, [_c('div', {
    staticClass: "options-heading drag-wrapper"
  }), _vm._v(" "), _c('div', {
    staticClass: "options-heading button-wrapper"
  }), _vm._v(" "), _c('div', {
    staticClass: "options-heading label-wrapper"
  }, [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.drag_editor.active_item.label')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "options-heading value-wrapper"
  }, [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.drag_editor.active_item.value')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "options-heading delete"
  })]), _vm._v(" "), _c('drag-container', {
    ref: "container",
    attrs: {
      "groupName": "optionsDrag",
      "collection": _vm.internalCollection,
      "shouldRemoveOnDrop": false,
      "shouldAcceptDrops": true,
      "nonDragAreaSelector": "input",
      "dropPlaceholderOptions": {
        className: 'drag-ghost-options'
      },
      "dragClass": "drag-dragging-options",
      "lockAxis": "y",
      "behaviour": "contain"
    },
    on: {
      "onDrop": _vm.onDrop
    }
  }, _vm._l((_vm.internalCollection), function(item, idx) {
    return _c('Draggable', {
      key: idx,
      staticClass: "drag-item option-row"
    }, [_c('div', {
      staticClass: "options-table-content"
    }, [_c('div', {
      staticClass: " drag-wrapper options-drag-icon"
    }, [_c('img', {
      staticClass: "drag-icon",
      attrs: {
        "src": _vm.dragIcon
      }
    })]), _vm._v(" "), (_vm.element_type != 'quantity_selection') ? _c('div', {
      staticClass: " button-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.internalDefaultValue),
        expression: "internalDefaultValue"
      }],
      attrs: {
        "type": "checkbox",
        "true-value": item.value,
        "false-value": null,
        "id": idx
      },
      domProps: {
        "value": item.value,
        "checked": true,
        "checked": Array.isArray(_vm.internalDefaultValue) ? _vm._i(_vm.internalDefaultValue, item.value) > -1 : _vm._q(_vm.internalDefaultValue, item.value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.internalDefaultValue,
            $$el = $event.target,
            $$c = $$el.checked ? (item.value) : (null);
          if (Array.isArray($$a)) {
            var $$v = item.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.internalDefaultValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.internalDefaultValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.internalDefaultValue = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), (!_vm.isEditing(item, 'name')) ? _c('div', {
      staticClass: " label-wrapper"
    }, [_c('span', {
      staticClass: "caption truncate-text v-align-super"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('i', {
      staticClass: "icon yule-icon-edit edit action-icon",
      on: {
        "click": function($event) {
          return _vm.setEditing(item, 'name')
        }
      }
    })]) : _c('div', {
      staticClass: "input label-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.internalCollection[idx].name),
        expression: "internalCollection[idx].name"
      }],
      ref: "editing",
      refInFor: true,
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.internalCollection[idx].name)
      },
      on: {
        "blur": _vm.removeEditing,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.internalCollection[idx], "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), (!_vm.isEditing(item, 'value') || _vm.limitEditing) ? _c('div', {
      staticClass: " value-wrapper"
    }, [_c('span', {
      staticClass: "caption truncate-text v-align-super"
    }, [_vm._v("\n            " + _vm._s(item.value) + "\n          ")]), _vm._v(" "), (!_vm.limitEditing) ? _c('i', {
      staticClass: "icon yule-icon-edit edit action-icon",
      on: {
        "click": function($event) {
          return _vm.setEditing(item, 'value')
        }
      }
    }) : _vm._e()]) : _c('div', {
      staticClass: " value-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.internalCollection[idx].value),
        expression: "internalCollection[idx].value"
      }],
      ref: "editing",
      refInFor: true,
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.internalCollection[idx].value)
      },
      on: {
        "blur": _vm.removeEditing,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.internalCollection[idx], "value", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: " delete"
    }, [(!_vm.limitEditing) ? _c('i', {
      staticClass: "icon yule-icon-trash action-icon",
      on: {
        "click": function($event) {
          return _vm.deleteElement(item)
        }
      }
    }) : _vm._e()])])])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.outsideClick),
      expression: "outsideClick"
    }],
    staticClass: "dot-navigation"
  }, [(_vm.items.length > 0) ? _c('div', {
    staticClass: "dot-navigation--trigger icon icon-more-vertical1",
    on: {
      "click": _vm.toggleVisible
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "dot-navigation--content"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.name,
      staticClass: "dot-navigation--content-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: item.name
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.outsideClick($event)
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "w-100 small",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event.target.value)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.open) ? _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "data-backdrop": "false"
    },
    on: {
      "click": _vm.clickOutside
    }
  }, [_c('div', {
    staticClass: "modal-wrapper mid-spacing",
    on: {
      "click": _vm.clickInside
    }
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "modal-inner",
    class: _vm.computedModalInnerClass
  }, [_c('div', {
    staticClass: "modal-component",
    class: _vm.computedModalComponentClass
  }, [_c('div', {
    staticClass: "modal-headers"
  }, [(_vm.type === 'warning') ? _c('img', {
    attrs: {
      "src": _vm.warningSrc
    }
  }) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.subtitle) ? _c('div', {
    staticClass: "modal-subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.buttons) ? _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.type == 'create' && _vm.cancelText != null) ? _c('a', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.cancelText)))]) : _vm._e(), _vm._v(" "), (_vm.saveText) ? _c('button', {
    staticClass: "btn btn-flat",
    class: _vm.computedModalFooterButtonClass.concat(_vm.type == 'warning' ? 'warning' : ''),
    attrs: {
      "disabled": _vm.saveDisabled
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.saveText)))]) : _vm._e(), _vm._v(" "), (_vm.type == 'warning' && _vm.showCancelForWarning && _vm.cancelText != null) ? _c('button', {
    staticClass: "btn btn-flat",
    class: _vm.computedModalFooterButtonClass,
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.cancelText)))]) : _vm._e()]) : _vm._e()])], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('collection', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.collectionData,
      "has_searched": _vm.has_searched,
      "params": _vm.params,
      "model": "workflow"
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  }), _vm._v(" "), _c('workflow-create')], 1)
},staticRenderFns: []}

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('field', {
    attrs: {
      "label": _vm.$t(_vm.label),
      "required": _vm.required,
      "classes": _vm.classes,
      "collection": _vm.statuses,
      "name": _vm.name,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "type": "radio"
    },
    model: {
      value: (_vm.newValue),
      callback: function($$v) {
        _vm.newValue = $$v
      },
      expression: "newValue"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.computedClass
  }, [_vm._v("\n  " + _vm._s(_vm.$t(("models.project_lead.sync_statuses." + _vm.label))) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secondary-header"
  }, [_c('div', {
    class: _vm.computedSecondaryHeaderClass
  }, [_c('div', {
    staticClass: "secondary-header--left"
  }, [(!_vm.compressed) ? _c('div', [(_vm.breadcrumbs.length > 0) ? _c('span', {
    staticClass: "secondary-header--breadcrumbs"
  }, _vm._l((_vm.breadcrumbs), function(crumb, idx) {
    return _c('span', {
      staticClass: "back-icon"
    }, [_c('router-link', {
      attrs: {
        "to": crumb.link
      }
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t(crumb.label)) + " ")])])], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.level == 3 && !_vm.projectLeadEdit()) ? _c('div', {
    staticClass: "secondary-header--subtitle",
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "back-icon"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.subtitle.link
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t("ui.breadcrump.back")) + " ")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.projectLeadEdit()) ? _c('div', [_c('div', {
    staticClass: "secondary-header--subtitle"
  }, [_c('span', {
    staticClass: "back-icon"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'projects'
      }
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t("ui.breadcrump.all_projects")) + " ")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "back-icon"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.getProjectPathWithQueries()
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.getProjectName()) + " ")])])], 1)])]) : (_vm.projectLeads()) ? _c('div', {
    staticClass: "secondary-header--subtitle",
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "back-icon"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.subtitle.link
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t("ui.breadcrump.all_projects")) + " ")])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "space-between"
  }, [_c('div', {
    staticClass: "secondary-header--title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "secondary-header--right"
  }, [(!_vm.compressed) ? _c('add-button') : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('folded-navigation', {
    ref: "foldedNavigation",
    attrs: {
      "items": _vm.headerTabs
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-origin",
    class: 'origin-' + _vm.value,
    attrs: {
      "title": _vm.$t('models.project_lead.origins.' + _vm.value)
    }
  }, [_c('i', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.icon))])])
},staticRenderFns: []}

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-import-origin",
    class: 'origin-' + _vm.value,
    attrs: {
      "title": _vm.$t('models.project_lead.import_origins.' + _vm.value)
    }
  }, [_c('i', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.icon))])])
},staticRenderFns: []}

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field email-list"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), (!_vm.required) ? _c('em', {
    staticClass: "optional"
  }, [_vm._v("optional")]) : _vm._e(), (_vm.required) ? _c('em', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tag),
      expression: "tag"
    }],
    staticClass: "email-list-input",
    attrs: {
      "type": "text",
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.tag)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.addTag($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.addTagKey($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "comma", undefined, $event.key, undefined)) { return null; }
        return _vm.addTagKey($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "backspace", undefined, $event.key, undefined)) { return null; }
        return _vm.handleBackspace($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tag = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "add icon yule-icon-circle-plus",
    on: {
      "click": _vm.addTag
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "email-list--input"
  }, _vm._l((_vm.newValue), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "email-list--item"
    }, [_c('span', [_vm._v(_vm._s(item))]), _c('i', {
      staticClass: "remove icon yule-icon-close-small",
      on: {
        "click": function($event) {
          return _vm.removeTag(index)
        }
      }
    })])
  }), 0), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t(_vm.error)))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active-item-wrapper"
  }, [_c('div', {
    staticClass: "active-item-header"
  }, [_c('h4', {
    staticClass: "active-item-title is-margin-top-0",
    on: {
      "click": function($event) {
        _vm.showExtraInfo = !_vm.showExtraInfo
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.drag_editor.active_item.edit')))]), _vm._v(" "), (_vm.canDelete) ? _c('double-opt-in-delete', {
    on: {
      "delete": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "active-item-content"
  }, [_c('sensual-badge', {
    staticClass: "active-item-type-badge",
    attrs: {
      "color": "grey",
      "text": _vm.badgeText,
      "popperOptions": _vm.popperOptions
    }
  }), _vm._v(" "), (_vm.editorName == 'LeadMask' && _vm.item.isUniqueInCollection) ? _c('sensual-badge', {
    staticClass: "active-item-type-badge",
    attrs: {
      "color": "grey",
      "text": _vm.$t('ui.lead_mask_editor.default_field'),
      "popperOptions": _vm.popperOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editorName == 'LeadMask' && !['container_tab', 'title', 'paragraph', 'drawing', 'crawled_info'].includes(_vm.item.element_type)) ? _c('div', {
    staticClass: "element-columns"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('ui.lead_mask_editor.element_width')))]), _vm._v(" "), _c('button', {
    staticClass: "btn-switch col-12",
    class: {
      'active': _vm.item.class == 'col-12' || _vm.item.class == ''
    },
    on: {
      "click": function($event) {
        return _vm.setClassGrid('col-12', _vm.item)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-switch col-6",
    class: {
      'active': _vm.item.class == 'col-6'
    },
    on: {
      "click": function($event) {
        return _vm.setClassGrid('col-6', _vm.item)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-switch col-4",
    class: {
      'active': _vm.item.class == 'col-4'
    },
    on: {
      "click": function($event) {
        return _vm.setClassGrid('col-4', _vm.item)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.canEdit('content') && ['paragraph', 'confirmation'].includes(_vm.item.element_type)) ? _c('field', {
    ref: "content",
    staticClass: "editor-textarea",
    attrs: {
      "type": "textarea",
      "value": _vm.content,
      "label": _vm.$t('ui.drag_editor.fields.text')
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('content') && ['title', 'submit'].includes(_vm.item.element_type)) ? _c('field', {
    ref: "content",
    staticClass: "editor-textarea",
    attrs: {
      "type": "text",
      "value": _vm.content,
      "label": _vm.$t('ui.drag_editor.fields.text')
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('content') && ['paragraph', 'confirmation'].includes(_vm.item.element_type)) ? _c('field-filler', {
    attrs: {
      "elements": _vm.$refs,
      "element-name": "content",
      "values": _vm.textAreaHtmlElements
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('label') && !['paragraph', 'title'].includes(_vm.item.element_type)) ? _c('field', {
    attrs: {
      "type": "text",
      "value": _vm.label,
      "label": _vm.$t('ui.drag_editor.fields.label')
    },
    model: {
      value: (_vm.label),
      callback: function($$v) {
        _vm.label = $$v
      },
      expression: "label"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('validation')) ? _c('field', {
    attrs: {
      "type": "text",
      "value": _vm.validation,
      "label": _vm.$t('ui.drag_editor.fields.validation')
    },
    model: {
      value: (_vm.validation),
      callback: function($$v) {
        _vm.validation = $$v
      },
      expression: "validation"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('placeholder')) ? _c('field', {
    attrs: {
      "type": "text",
      "value": _vm.placeholder,
      "label": _vm.$t('ui.drag_editor.fields.placeholder')
    },
    model: {
      value: (_vm.placeholder),
      callback: function($$v) {
        _vm.placeholder = $$v
      },
      expression: "placeholder"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('allowed_values')) ? _c('drag-editor-item-options', {
    attrs: {
      "collection": _vm.allowedValues,
      "limitEditing": _vm.limitEditingLocal,
      "element_type": _vm.item.element_type,
      "defaultValue": _vm.defaultValue
    },
    on: {
      "input": _vm.changeAllowedValues,
      "updateDefault": _vm.changeDefaultValue,
      "delete": _vm.deleteAllowedValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasAllowedValues() && !_vm.limitEditingLocal) ? _c('div', [_c('button', {
    staticClass: "button link",
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', {
    staticClass: "btn-plus"
  }, [_vm._v("+")]), _vm._v("\n        " + _vm._s(_vm.$t('ui.drag_editor.fields.add_item')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.canEdit('default_value') && _vm.canEdit('allowed_values')) ? _c('field', {
    attrs: {
      "type": "hidden",
      "value": _vm.defaultValueOptions,
      "label": _vm.$t('ui.drag_editor.fields.default_value_options'),
      "disabled": true,
      "readonly": true
    }
  }) : (_vm.item.element_type == 'country_select') ? _c('country-select', {
    attrs: {
      "label": _vm.$t('ui.drag_editor.fields.default_value'),
      "language": _vm.language
    },
    model: {
      value: (_vm.defaultValue),
      callback: function($$v) {
        _vm.defaultValue = $$v
      },
      expression: "defaultValue"
    }
  }) : (_vm.canEdit('default_value') && !_vm.canEdit('allowed_values')) ? _c('field', {
    attrs: {
      "type": _vm.item.element_type,
      "value": _vm.defaultValue,
      "label": _vm.$t('ui.drag_editor.fields.default_value'),
      "disabled": _vm.canEdit('allowed_values')
    },
    model: {
      value: (_vm.defaultValue),
      callback: function($$v) {
        _vm.defaultValue = $$v
      },
      expression: "defaultValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('class') && _vm.editorName == 'ExternalForm') ? _c('field', {
    attrs: {
      "type": "text",
      "value": _vm.klass,
      "label": _vm.$t('ui.drag_editor.fields.class')
    },
    model: {
      value: (_vm.klass),
      callback: function($$v) {
        _vm.klass = $$v
      },
      expression: "klass"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('required')) ? _c('field', {
    attrs: {
      "defaultValue": false,
      "collection": [{
        value: true,
        name: _vm.$t('ui.drag_editor.fields.required')
      }],
      "type": "checkbox",
      "value": _vm.required,
      "name": "required",
      "params": {
        no_i18n: true
      },
      "label": "empty"
    },
    model: {
      value: (_vm.required),
      callback: function($$v) {
        _vm.required = $$v
      },
      expression: "required"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('hidden')) ? _c('field', {
    attrs: {
      "defaultValue": false,
      "collection": [{
        value: true,
        name: _vm.$t('ui.drag_editor.fields.hidden')
      }],
      "type": "checkbox",
      "value": _vm.hidden,
      "name": "hidden",
      "params": {
        no_i18n: true
      },
      "label": "empty"
    },
    model: {
      value: (_vm.hidden),
      callback: function($$v) {
        _vm.hidden = $$v
      },
      expression: "hidden"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('show_as_buttons')) ? _c('field', {
    attrs: {
      "defaultValue": false,
      "collection": [{
        value: true,
        name: _vm.$t('ui.drag_editor.fields.show_as_buttons')
      }],
      "type": "checkbox",
      "value": _vm.show_as_buttons,
      "name": "show_as_buttons",
      "params": {
        no_i18n: true
      },
      "label": "empty"
    },
    model: {
      value: (_vm.show_as_buttons),
      callback: function($$v) {
        _vm.show_as_buttons = $$v
      },
      expression: "show_as_buttons"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('enrich_tags') && _vm.editorName == 'LeadMask' && _vm.hasPermission('is_root')) ? _c('field', {
    attrs: {
      "defaultValue": false,
      "collection": [{
        value: true,
        name: _vm.$t('ui.drag_editor.fields.enrich_tags')
      }],
      "type": "checkbox",
      "value": _vm.enrich_tags,
      "name": "enrich_tags",
      "params": {
        no_i18n: true
      },
      "label": "empty"
    },
    model: {
      value: (_vm.enrich_tags),
      callback: function($$v) {
        _vm.enrich_tags = $$v
      },
      expression: "enrich_tags"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEdit('data_type') && _vm.editorName == 'LeadMask') ? _c('field', {
    attrs: {
      "type": "select",
      "collection": _vm.dataTypes,
      "value": _vm.item.data_type,
      "label": _vm.$t('ui.drag_editor.fields.data_type')
    },
    model: {
      value: (_vm.data_type),
      callback: function($$v) {
        _vm.data_type = $$v
      },
      expression: "data_type"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldShowName(_vm.editorName)) ? _c('field', {
    attrs: {
      "type": "text",
      "readonly": _vm.item.isUniqueInCollection,
      "disabled": _vm.item.isUniqueInCollection,
      "value": _vm.item.name,
      "label": _vm.$t('ui.drag_editor.fields.internal_name')
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((Object.keys(_vm.item)), function(attribute) {
    return (_vm.showExtraInfo) ? _c('div', {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: ('is_root'),
        expression: "'is_root'"
      }],
      key: attribute
    }, [_vm._v(_vm._s(attribute) + ": " + _vm._s(_vm.item[attribute]))]) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unauthorized"
  }, [_vm._v("\n  " + _vm._s(_vm.$t(_vm.error)) + "\n  "), _c('div', {
    staticClass: "get-back"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('ui.global.back_to_home')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "companies-page"
  }, [_c('div', {
    class: _vm.loading ? 'hidden' : ''
  }, [_c('filter-results', {
    attrs: {
      "refresh": _vm.key
    },
    on: {
      "fetchDataComplete": _vm.fetchDataComplete
    }
  })], 1), _vm._v(" "), _c('company-create', {
    attrs: {
      "isOpen": _vm.open,
      "company": _vm.company
    },
    on: {
      "save": _vm.create,
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "companies-page-loader",
    class: _vm.loading ? '' : 'hidden'
  }, [_c('loading')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "x-filter-condition",
    class: 'x-filter-condition-' + _vm.getConditionType()
  }, [_vm._v("\n    " + _vm._s(_vm.getConditionSummary()) + "\n    "), _c('i', {
    staticClass: "x-filter-condition-remove icon yule-icon-close-small",
    on: {
      "click": function($event) {
        return _vm.removeCondition()
      }
    }
  })]), _vm._v(" "), (_vm.isLast == false) ? _c('span', {
    staticClass: "x-filter-operator",
    class: 'x-filter-operator-' + _vm.operator
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-state-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageSrc
    }
  }), _vm._v(" "), (_vm.heading) ? _c('h3', [_vm._v(_vm._s(_vm.heading))]) : _vm._e(), _vm._v(" "), (_vm.subtitle) ? _c('p', [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), (_vm.button) ? _c('add-button', {
    staticClass: "buttons"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar-container"
  }, [(_vm.title) ? _c('div', {
    staticClass: "progress-bar--title"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "progress-bar",
    class: [{
      'has-content': !_vm.isMini
    }, _vm.advancement]
  }, [_c('div', {
    staticClass: "progress-bar--progression",
    style: ('width: ' + _vm.percentage + '%')
  }, [(!_vm.isMini) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.percentage.toFixed(0)) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fluid-layout",
    class: {
      computedClasses: _vm.computedClasses, 'form-builder': _vm.isFormBuilder
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {}, [_c('q-layout', [_c('div', {
    staticClass: "header-container"
  }, [_c('navigation', {
    attrs: {
      "id": "desktop-nav"
    }
  }), _vm._v(" "), _c('mobile-navigation', {
    attrs: {
      "id": "mobile-nav"
    }
  })], 1), _vm._v(" "), _c('div', {}, [(!_vm.isPageContent && !_vm.isShowingOnboarding) ? _c('secondary-header', {
    class: {
      'hidden': _vm.isRetrieving || _vm.emptyStateProjects || _vm.emptyStateLeads
    }
  }) : _vm._e(), _vm._v(" "), (this.isRetrieving) ? _c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('loading')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid main-container-fluid"
  }, [_c('div', {
    class: {
      'main-content': true, 'main-content--lead': _vm.isPageLead, 'main-content--projects': _vm.isPageProjects, 'main-content--projects': _vm.isPageProjectNew, 'empty-state-projects': _vm.emptyStateProjects, 'empty-state-leads': _vm.emptyStateLeads, 'main-content--manager': _vm.isPageContent, 'hidden': _vm.isRetrieving
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath,
    staticClass: "router-view",
    on: {
      "logout": function($event) {
        return _vm.$emit('logout')
      }
    }
  })], 1)])], 1)]), _vm._v(" "), _c('app-footer')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row drag-tab-container"
  }, [_c('div', {
    staticClass: "col-xs-11 col-sm-11 col-lg-11 col-xl-11"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('drag-tab', {
      key: tab.name,
      attrs: {
        "tab": tab,
        "tabs": _vm.tabs
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-1 col-lg-1 col-xl-1"
  }, [_c('button', {
    staticClass: "btn-plus",
    on: {
      "click": _vm.addTab
    }
  }, [_vm._v("+")])])])
},staticRenderFns: []}

/***/ }),
/* 1939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dark-section"
  }), _vm._v(" "), _c('div', {
    staticClass: "row gutter-md dashboard"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "row gutter-xs items-center custom-space"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('span', {
    staticClass: "caption is-paper"
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.filter.dashboard')))])]), _vm._v(" "), (_vm.isRoot) ? _c('div', {
    staticClass: "col-xs-4 z-top",
    attrs: {
      "organizationId": _vm.organizationId
    }
  }, [_c('organization-filter', {
    attrs: {
      "organizationId": _vm.organizationId
    },
    on: {
      "change": _vm.onOrganizationChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 z-top"
  }, [_c('project-filter', {
    attrs: {
      "organizationId": _vm.organizationId
    },
    on: {
      "change": _vm.onProjectChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-auto z-top"
  }, [_c('period-filter', {
    on: {
      "change": _vm.onPeriodChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row gutter-md m-bottom-base"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('leads-over-time-widget', {
    attrs: {
      "filter": _vm.filter
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row gutter-md"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12"
  }, [_c('most-active-projects-widget', {
    attrs: {
      "filter": _vm.filter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12"
  }, [_c('conversion-funnel-widget', {
    attrs: {
      "filter": _vm.filter
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12 custom-padding-top"
  }, [_c('div', {
    staticClass: "row gutter-md sticky-column"
  }, [_c('div', {
    staticClass: "vertical-half reset-padding-top"
  }, [_c('latest-activity-widget', {
    staticClass: "panel-height",
    attrs: {
      "filter": _vm.filter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vertical-half reset-padding-top"
  }, [_c('kits-activity-widget', {
    staticClass: "panel-height",
    attrs: {
      "filter": _vm.filter
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Container', {
    staticClass: "drag-container",
    attrs: {
      "group-name": _vm.groupName,
      "drag-class": _vm.dragClass,
      "should-accept-drop": _vm.getShouldAcceptDrop,
      "get-child-payload": _vm.getChildPayload,
      "non-drag-area-selector": _vm.nonDragAreaSelector,
      "drop-placeholder": _vm.dropPlaceholderOptions,
      "remove-on-drop-out": _vm.shouldRemoveOnDrop,
      "tag": _vm.tag,
      "lock-axis": _vm.lockAxis,
      "orientation": _vm.orientation,
      "behaviour": _vm.behaviour
    },
    on: {
      "drop": _vm.onDrop
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "open": _vm.isOpen,
      "title": _vm.modalTitle
    },
    on: {
      "save": _vm.create,
      "cancel": _vm.cancel
    }
  }, [_c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "workflow",
      "name": "name",
      "placeholder": "Form Name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "name": "scope",
      "type": "radio",
      "model": "workflow",
      "collection": _vm.workflowScopes
    },
    model: {
      value: (_vm.workflowScope),
      callback: function($$v) {
        _vm.workflowScope = $$v
      },
      expression: "workflowScope"
    }
  }), _vm._v(" "), (_vm.workflowScope == 'project') ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.list'),
      expression: "'projects.list'"
    }],
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "workflow",
      "name": "project",
      "type": "select",
      "collection": _vm.projects,
      "params": {
        'no_i18n': true
      }
    },
    model: {
      value: (_vm.item.project_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "project_id", $$v)
      },
      expression: "item.project_id"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isRoot) ? _c('field', {
    attrs: {
      "required": false,
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "organization",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.organizations
    },
    model: {
      value: (_vm.item.organization),
      callback: function($$v) {
        _vm.$set(_vm.item, "organization", $$v)
      },
      expression: "item.organization"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "project-update"
  }, [_c('div', {
    staticClass: "wizard-toolbar"
  }, [_c('div', {
    staticClass: "grid-2"
  }, [_c('div', {
    staticClass: "progress-step-1 active"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.project_wizard.step1-title")))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-step-2 inactive"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.project_wizard.step2-title")))])])])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("ui.project_wizard.step1-title")))]), _vm._v(" "), _c('form', {
    staticClass: "project-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "project",
      "name": "name",
      "placeholder": "Tech con 2016"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions wizard-footer"
  }, [_c('a', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.global.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-flat btn-save",
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("ui.pages.project-next-button")) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statictics-overview grid"
  }, [_c('div', {
    staticClass: "card statistic-card tracking-chart"
  }, [_c('div', {
    staticClass: "card--top-title"
  }, [_vm._v(_vm._s(_vm.$t('statistics.7days_activity')))]), _vm._v(" "), _c('div', {
    staticClass: "card--content"
  }, [_c('tracking-chart', {
    attrs: {
      "start-date": _vm.startDate,
      "end-date": _vm.endDate,
      "trackings": _vm.trackings
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card--footer"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.actions')) + ": " + _vm._s(_vm.stats.trackings_count) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.average_per_day')) + ": " + _vm._s(_vm.actionsPerDay(_vm.stats.trackings_count)) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card statistic-card kits-stats"
  }, [_c('div', {
    staticClass: "card--top-title"
  }, [_vm._v(_vm._s(_vm.$t('statistics.kits')))]), _vm._v(" "), _c('div', {
    staticClass: "card--content"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('p', {
    staticClass: "number--big"
  }, [_vm._v(_vm._s(_vm.stats.trackings_bag_open_count) + "x")]), _vm._v(" "), _c('p', {
    staticClass: "number--subtext"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('statistics.total_businesskit_opened')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card--footer"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.businesskit_sent')) + ": " + _vm._s(_vm.stats.sent_business_kits_count) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card statistic-card coupons-stats"
  }, [_c('div', {
    staticClass: "card--top-title"
  }, [_vm._v(_vm._s(_vm.$t('statistics.coupons')))]), _vm._v(" "), _c('div', {
    staticClass: "card--content"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('p', {
    staticClass: "number--big"
  }, [_vm._v(_vm._s(_vm.stats.trackings_view_coupon_count))]), _vm._v(" "), _c('p', {
    staticClass: "number--subtext"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('statistics.coupons_viewed')) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lead.sync_status == 'not_sync_ready') ? _c('div', {
    staticClass: "crm-status",
    class: 'crm-status-' + _vm.lead.sync_status + ' ' + _vm.lead.sync_disabled
  }, [_c('div', [_c('img', {
    staticClass: "info-icon",
    attrs: {
      "src": __webpack_require__(453)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "missing-message"
  }, [_vm._v(_vm._s(_vm.$t('models.project_lead.sync_missing_fields')))]), _vm._v(" "), (_vm.missingFieldsString) ? _c('div', {
    staticClass: "crm-status--missing-fields missing-fields"
  }, [_c('span', [_vm._v(_vm._s(_vm.missingFieldsString))])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "x-filter-modal",
    attrs: {
      "open": _vm.open,
      "saveText": _vm.$t('ui.xfilters.add_filter_confirm'),
      "cancelText": null,
      "clickOutsideClose": true
    },
    on: {
      "cancel": _vm.closeModal,
      "save": _vm.addCondition
    }
  }, [_c('span', {
    staticClass: "x-filter-modal-label"
  }, [_vm._v("\n    " + _vm._s(_vm.filterDefinition.label) + "\n  ")]), _vm._v(" "), (Array.isArray(_vm.filterDefinition.predicate)) ? _c('span', {
    staticClass: "x-filter-modal-predicates"
  }, _vm._l((_vm.filterDefinition.predicate), function(predName, index) {
    return _c('q-radio', {
      key: index,
      staticClass: "x-filter-modal-predicate-item",
      attrs: {
        "val": predName,
        "label": _vm.$t('ui.xfilters.conditions.predicates.' + predName),
        "disable": _vm.hasNone
      },
      model: {
        value: (_vm.data.predicate),
        callback: function($$v) {
          _vm.$set(_vm.data, "predicate", $$v)
        },
        expression: "data.predicate"
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.type == 'text') ? _c('span', {
    staticClass: "x-filter-modal-text"
  }, [(_vm.filterDefinition.auto_complete) ? _c('auto-complete', {
    staticClass: "x-filter-modal-autocomplete",
    attrs: {
      "model": _vm.filterDefinition.auto_complete,
      "type": "text",
      "label": "empty",
      "name": "value",
      "item": _vm.data,
      "init": "none",
      "disabled": _vm.hasNone,
      "autofocus": true,
      "acMinCharacters": 3
    },
    on: {
      "change": _vm.autoSelect
    }
  }) : _c('field', {
    attrs: {
      "disabled": _vm.hasNone,
      "autofocus": true
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.type == 'set') ? _c('span', {
    staticClass: "x-filter-modal-set"
  }, [(_vm.filterDefinition.predicate == 'eq') ? _c('span', [(_vm.filterDefinition.method == 'select') ? _c('span', [_c('field', {
    attrs: {
      "type": "select",
      "collection": _vm.filterDefinition.options,
      "disabled": _vm.hasNone,
      "autofocus": true
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1) : (_vm.filterDefinition.attribute == 'country') ? _c('span', [_c('country-select', {
    attrs: {
      "disabled": _vm.hasNone,
      "autofocus": true,
      "language": _vm.$store.getters.getCurrentLanguage,
      "params": {
        favorites: ['DE']
      }
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1) : _c('span', _vm._l((_vm.filterDefinition.options), function(option, index) {
    return _c('q-radio', {
      key: index,
      attrs: {
        "val": option.value,
        "label": option.name,
        "disable": _vm.hasNone
      },
      model: {
        value: (_vm.data.value),
        callback: function($$v) {
          _vm.$set(_vm.data, "value", $$v)
        },
        expression: "data.value"
      }
    })
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.method == 'chips') ? _c('span', {
    staticClass: "x-filter-modal-chips"
  }, [_c('q-field', [_c('q-chips-input', {
    attrs: {
      "disable": _vm.hasNone,
      "autofocus": true,
      "hide-underline": "",
      "close-icon": "close"
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (['in', 'has_any', 'has_all'].includes(_vm.filterDefinition.predicate)) ? _c('span', _vm._l((_vm.filterDefinition.options), function(option, index) {
    return _c('q-checkbox', {
      key: index,
      staticClass: "x-filter-modal-checkbox",
      attrs: {
        "val": option.value,
        "label": option.name,
        "disable": _vm.hasNone
      },
      model: {
        value: (_vm.data.value),
        callback: function($$v) {
          _vm.$set(_vm.data, "value", $$v)
        },
        expression: "data.value"
      }
    })
  }), 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.type == 'date') ? _c('span', {
    staticClass: "x-filter-modal-date field"
  }, [(this.enableRelativeRanges()) ? _c('field', {
    attrs: {
      "type": "select",
      "collection": _vm.filterDefinition.options,
      "autofocus": true
    },
    on: {
      "input": _vm.dateRangeChange
    },
    model: {
      value: (_vm.data.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.data, "dateRange", $$v)
      },
      expression: "data.dateRange"
    }
  }) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('ui.xfilters.xfiltermodal.date_from')))]), _vm._v(" "), _c('datepicker', {
    key: 'from' + _vm.key,
    attrs: {
      "clear-button": true,
      "full-month-name": true,
      "format": "d MMMM, yyyy",
      "disabled-dates": {
        from: _vm.data.value2
      },
      "language": _vm.getDatePickerLanguage()
    },
    on: {
      "input": _vm.dateChanged
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('ui.xfilters.xfiltermodal.date_to')))]), _vm._v(" "), _c('datepicker', {
    key: 'to' + _vm.key,
    attrs: {
      "clear-button": true,
      "full-month-name": true,
      "format": "d MMMM, yyyy",
      "disabled-dates": {
        to: _vm.data.value
      },
      "language": _vm.getDatePickerLanguage()
    },
    on: {
      "input": _vm.dateChanged
    },
    model: {
      value: (_vm.data.value2),
      callback: function($$v) {
        _vm.$set(_vm.data, "value2", $$v)
      },
      expression: "data.value2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filterDefinition.include_none != null) ? _c('span', {
    staticClass: "x-filter-modal-has-none"
  }, [_c('q-checkbox', {
    staticClass: "x-filter-modal-checkbox",
    attrs: {
      "color": "primary",
      "label": _vm.filterDefinition.include_none
    },
    model: {
      value: (_vm.hasNone),
      callback: function($$v) {
        _vm.hasNone = $$v
      },
      expression: "hasNone"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative-date-choser"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('statistics.time_range')) + ":\n  ")]), _vm._v(" "), _vm._l((_vm.choices), function(choice) {
    return _c('div', {
      key: choice,
      staticClass: "relative-date-choser-choice",
      class: {
        'is-active': choice == _vm.date
      },
      on: {
        "click": function($event) {
          return _vm.choose(choice)
        }
      }
    }, [(choice == 1) ? _c('span', [_vm._v("\n      24 " + _vm._s(_vm.$t('statistics.hours')) + "\n    ")]) : _c('span', [_vm._v("\n      " + _vm._s(choice) + " " + _vm._s(_vm.$t('statistics.days')) + "\n    ")])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.reset),
      expression: "reset"
    }]
  }, [(_vm.hasClicked) ? _c('button', {
    staticClass: "btn btn-cancel double-optin-button",
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.button.double_optin')))]) : _c('i', {
    staticClass: "icon yule-icon-trash action-icon delete-icon",
    on: {
      "click": _vm.click
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.statistics) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card--content"
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$t('statistics.businesskit_sent')) + ": "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.businesskitSent))])]), _vm._v(" "), _c('div', {
    staticClass: "card--number"
  }, [_c('div', {
    staticClass: "card--number-value"
  }, [_vm._v("\n        " + _vm._s(_vm.businesskitOpened) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card--number-key"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.businesskit_opened')) + "\n      ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card--gauge"
  }, [_c('gauge', {
    attrs: {
      "percentage": _vm.businesskitSentOpenRatio
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quantity-selection field"
  }, [_c('div', {
    staticClass: "quantity-selection--title"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('div', {
    staticClass: "quantity-selection--content"
  }, _vm._l((_vm.collection), function(value) {
    return _c('quantity-selection-item', {
      key: value.value,
      attrs: {
        "value": _vm.newValue,
        "item": value
      },
      on: {
        "change": _vm.change
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row justify-center gutter-md"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('project-businesskit-assignement', {
    staticClass: "project-assignment-row",
    attrs: {
      "businesskits": _vm.businesskits,
      "assigned-businesskits": _vm.assigned_businesskits
    },
    on: {
      "update": _vm.updateBusinesskits
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('project-user-assignement', {
    staticClass: "project-assignment-row",
    attrs: {
      "users": _vm.users,
      "assigned-users": _vm.assigned_users
    },
    on: {
      "update": _vm.updateUsers
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data != undefined) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('models.project_lead.crawled_infos.more_infos')))]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [(_vm.data.logo) ? _c('div', {
    staticClass: "company-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.logo,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "social-networks"
  }, [(_vm.has(_vm.data, 'facebook.handle')) ? _c('div', [_c('a', {
    attrs: {
      "href": 'http://facebook.com/' + _vm.data.facebook.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(447),
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'twitter.handle')) ? _c('div', [_c('a', {
    attrs: {
      "href": 'http://twitter.com/' + _vm.data.twitter.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(449),
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'linkedin.handle')) ? _c('div', [_c('a', {
    attrs: {
      "href": 'http://linkedin.com/' + _vm.data.linkedin.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(448),
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'crunchbase.handle')) ? _c('div', [_c('a', {
    attrs: {
      "href": 'http://crunchbase.com/' + _vm.data.crunchbase.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(446),
      "alt": ""
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.has(_vm.data, 'name')) ? _c('crawled-info', {
    attrs: {
      "label": "name",
      "value": _vm.data.name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'domain')) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.crawled_infos.domain')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "crawled-info--value"
  }, [_c('a', {
    attrs: {
      "href": 'http://' + _vm.data.domain,
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.data.domain) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'foundedYear')) ? _c('crawled-info', {
    attrs: {
      "label": "foundedYear",
      "value": _vm.data.foundedYear
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'country')) ? _c('crawled-info', {
    attrs: {
      "label": "country",
      "value": _vm.data.country
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'location')) ? _c('crawled-info', {
    attrs: {
      "label": "location",
      "value": _vm.data.location
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'description')) ? _c('crawled-info', {
    attrs: {
      "label": "description",
      "value": _vm.data.description
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'category')) ? _c('crawled-info', {
    attrs: {
      "label": "category",
      "value": _vm.category
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'tags')) ? _c('crawled-info', {
    attrs: {
      "label": "tags",
      "value": _vm.tags
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'site.emailAddresses')) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.crawled_infos.emailAddresses')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.data.site.emailAddresses), function(item) {
    return _c('div', {
      key: item,
      staticClass: "crawled-info--value"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + item
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'site.phoneNumbers')) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.crawled_infos.phoneNumbers')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.data.site.phoneNumbers), function(item) {
    return _c('div', {
      key: item,
      staticClass: "crawled-info--value"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + item
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.has(_vm.data, 'metrics')) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.crawled_infos.metrics')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.data.metrics), function(item, key) {
    return (item) ? _c('div', {
      key: item,
      staticClass: "crawled-info--value"
    }, [_vm._v("\n        " + _vm._s(key) + ": " + _vm._s(item) + "\n      ")]) : _vm._e()
  })], 2) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shouldDisplay) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_c('logo', {
    attrs: {
      "logoType": "grey"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('copyright', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, _vm._l((_vm.footerLinks), function(link) {
    return _c('div', {
      key: link.title,
      staticClass: "footer-link"
    }, [_c('a', {
      attrs: {
        "href": link.href
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t(("ui.footer." + (link.title)))) + "\n        ")])])
  }), 0)], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['collection', _vm.model]
  }, [(_vm.loading == false) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.structure), function(column) {
    return _c('th', {
      directives: [{
        name: "can-dom",
        rawName: "v-can-dom",
        value: (column.credentials),
        expression: "column.credentials"
      }],
      key: column.name,
      staticClass: "heading",
      class: column.class
    }, [(column.icon) ? _c('span', {
      staticClass: "heading--title icon",
      attrs: {
        "title": _vm.$t('models.' + _vm.model + '.' + column.name)
      }
    }, [_vm._v("\n            " + _vm._s(column.icon) + "\n          ")]) : (column.alias) ? _c('span', {
      staticClass: "heading--title"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("models." + _vm.model + "." + column.alias)) + "\n          ")]) : ((column.name == 'classification')) ? _c('span', {
      staticClass: "heading--title"
    }) : _c('span', {
      staticClass: "heading--title"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("models." + _vm.model + "." + column.name)) + "\n          ")]), _vm._v(" "), (column.sortable && _vm.sortedData.length > 0) ? _c('div', {
      class: {
        'heading--sorting': true, 'is-active': _vm.sortKey == column.name
      }
    }, [(_vm.reverse && _vm.sortKey == column.name) ? _c('a', {
      staticClass: "icon yule-icon-chevron-down icon-tiny",
      on: {
        "click": function($event) {
          return _vm.sortBy(column.name)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.reverse && _vm.sortKey == column.name) ? _c('a', {
      staticClass: "icon yule-icon-chevron-top icon-tiny",
      on: {
        "click": function($event) {
          return _vm.sortBy(column.name)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.sortKey != column.name) ? _c('a', {
      staticClass: "icon yule-icon-chevron-right icon-tiny",
      on: {
        "click": function($event) {
          return _vm.sortBy(column.name)
        }
      }
    }) : _vm._e()]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.collectionPresent()) ? _c('tbody', _vm._l((_vm.sortedData), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "collection--row"
    }, _vm._l((_vm.structure), function(column) {
      return _c('collection-value', _vm._b({
        directives: [{
          name: "can-dom",
          rawName: "v-can-dom",
          value: (column.credentials),
          expression: "column.credentials"
        }],
        key: column.name,
        attrs: {
          "params": _vm.params,
          "model": _vm.model,
          "column": column,
          "item": item
        },
        on: {
          "itemDelete": _vm.itemDelete
        }
      }, 'collection-value', {
        toString: function () { return item.id; }
      }, false))
    }), 1)
  }), 0) : (_vm.loadingCollection()) ? _c('div', [_c('loading')], 1) : (_vm.noResultsHandler()) ? _c('tbody', [_c('tr', {
    staticClass: "txtcenter"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.structure.length
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.no_results')))])])]) : _c('tbody', [_c('tr', {
    staticClass: "txtcenter"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.structure.length
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.empty_collection')))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "open": _vm.isOpen,
      "title": _vm.modalTitle,
      "saveText": _vm.modalSaveText
    },
    on: {
      "save": _vm.submit,
      "cancel": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "user-invite"
  }, [_c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "type": "email",
      "name": "email",
      "model": "user"
    },
    model: {
      value: (_vm.item.email),
      callback: function($$v) {
        _vm.$set(_vm.item, "email", $$v)
      },
      expression: "item.email"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "user",
      "name": "role",
      "type": "radio",
      "collection": _vm.roles,
      "defaultValue": 'user'
    },
    model: {
      value: (_vm.item.role),
      callback: function($$v) {
        _vm.$set(_vm.item, "role", $$v)
      },
      expression: "item.role"
    }
  }), _vm._v(" "), _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organizations.list'),
      expression: "'organizations.list'"
    }],
    attrs: {
      "required": false,
      "errors": _vm.errors,
      "model": "user",
      "name": "organization",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.organizations
    },
    model: {
      value: (_vm.item.organization),
      callback: function($$v) {
        _vm.$set(_vm.item, "organization", $$v)
      },
      expression: "item.organization"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row gutter-md lead-mask-config"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  })])
}]}

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segments-page"
  }, [_c('div', {
    class: _vm.pageLoading ? 'hidden' : ''
  }, [_c('x-table', {
    attrs: {
      "title": _vm.$t('ui.segments.segments'),
      "columns": _vm.columns,
      "tableData": _vm.segments,
      "enableSearch": true,
      "enableFilter": false,
      "totalResults": _vm.totalCount,
      "pagination": _vm.defaultPagination,
      "showLoader": _vm.loading,
      "actions": _vm.actions,
      "actionsLocation": "row",
      "rowsAreClickable": true,
      "tableSettingsName": "segments"
    },
    on: {
      "updatePagination": _vm.updatePagination,
      "fetchData": _vm.fetchData,
      "clickRow": _vm.actionEdit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "segments-page-loader",
    class: _vm.pageLoading ? '' : 'hidden'
  }, [_c('loading')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "title": _vm.$t('ui.segments.duplicate_modal.title'),
      "saveText": _vm.$t('ui.segments.duplicate_modal.duplicate'),
      "open": _vm.duplicateSegmentModalOpen
    },
    on: {
      "save": function($event) {
        return _vm.duplicateSegment()
      },
      "cancel": function($event) {
        return _vm.closeDuplicateSegmentModal()
      }
    }
  }, [_c('field', {
    attrs: {
      "label": _vm.$t('ui.segments.duplicate_modal.name'),
      "autofocus": true
    },
    model: {
      value: (_vm.duplicateSegmentName),
      callback: function($$v) {
        _vm.duplicateSegmentName = $$v
      },
      expression: "duplicateSegmentName"
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "open": _vm.deleteSegmentModalOpen,
      "title": _vm.$t('ui.segments.delete_modal.title'),
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": _vm.$t('ui.global.delete')
    },
    on: {
      "save": _vm.deleteSegment,
      "cancel": _vm.closeDeleteSegmentModal
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('ui.global.delete_confirmation', {
    name: this.currentSegment ? this.currentSegment.name : ''
  })))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-update-monitor"
  }, [_c('div', {
    staticClass: "lead-update-monitor--section"
  }, [_c('div', {
    staticClass: "lead-update-monitor--advancement"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('progress-bar', {
    attrs: {
      "percentage": _vm.progress,
      "isMini": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "progress-percentage"
  }, [_vm._v(_vm._s(_vm.progress.toFixed()) + "%")])], 1), _vm._v(" "), (_vm.progress == 100) ? _c('div', {
    staticClass: "progress-complete"
  }, [_vm._v(_vm._s(_vm.$t('models.project_lead.progress_complete')))]) : _vm._e(), _vm._v(" "), (_vm.item.sync_status) ? _c('lead-update-crm-status', {
    class: {
      'inactive-status': _vm.item.sync_status == 'sync_ready' && _vm.$store.getters.getOrganizationConfig('crm_presence') == false
    },
    attrs: {
      "structure": _vm.structure,
      "lead": _vm.item
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lead-update-monitor--section no-padding"
  }, [_c('div', {
    class: [{
      'bordered': _vm.item.businesscard_image_url
    }, 'lead-update-monitor--business-card']
  }, [_c('lead-update-business-card', {
    attrs: {
      "lead": _vm.item
    },
    on: {
      "openBusinessCard": _vm.openBusinessCard
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lead-update-monitor--section"
  }, [_c('div', {
    staticClass: "classification-container"
  }, [_c('field', {
    staticClass: "is-buttonned",
    attrs: {
      "type": "radio",
      "collection": _vm.classificationCollection,
      "value": _vm.item.classification,
      "model": _vm.item.classification,
      "label": _vm.$t('models.project_lead.classification'),
      "params": {
        'no_i18n': true
      },
      "model": "project_lead"
    },
    on: {
      "input": _vm.inputClassification
    }
  })], 1), _vm._v(" "), (_vm.allowedLeadReview()) ? _c('div', {
    staticClass: "classification-container"
  }, [_c('field', {
    staticClass: "is-buttonned",
    attrs: {
      "type": "radio",
      "collection": _vm.statusCollection,
      "value": _vm.item.status,
      "model": _vm.item.status,
      "label": _vm.$t('models.project_lead.status'),
      "params": {
        'no_i18n': true
      },
      "model": "project_lead"
    },
    on: {
      "input": _vm.inputStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "capturer"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('models.project_lead.capturer')))]), _vm._v(" "), _c('user-image', {
    attrs: {
      "firstname": _vm.item.user_firstname,
      "lastname": _vm.item.user_lastname,
      "email": _vm.item.user_email,
      "theme": "sensual-lighter"
    }
  }), _vm._v(" "), (_vm.userData()) ? _c('div', {
    staticClass: "capturer-name"
  }, [_c('p', {}, [_vm._v(_vm._s(_vm.userData()))])]) : _c('div', {
    staticClass: "capturer-name"
  }, [_vm._v(_vm._s(_vm.$t('models.project_lead.capturer_unknown')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "crm-switch"
  }, [(_vm.showCrmSyncSwitch()) ? _c('form-switch', {
    attrs: {
      "reverse": true,
      "name": "sync_disabled",
      "value": _vm.item.sync_disabled,
      "model": "project_lead"
    },
    on: {
      "input": _vm.inputCrmSync
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.item.start_date) ? _c('div', [_c('p', {
    staticClass: "caption"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('models.project_lead.start_date')) + "\n        " + _vm._s(_vm.date(_vm.item.start_date)) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.screenSizeIsTooSmall) ? _c('div', {
    staticClass: "row editor"
  }, [_c('div', {
    staticClass: "menu editor-column col-md-3 col-lg-3 col-xl-3"
  }, _vm._l((_vm.internalDragElements), function(section) {
    return _c('div', {
      key: section.title
    }, [_c('h4', [_vm._v("\n        " + _vm._s(section.title) + "\n      ")]), _vm._v(" "), _c('drag-container', {
      attrs: {
        "groupName": "menu-default",
        "shouldRemoveOnDrop": false,
        "shouldAcceptDrops": false,
        "dragClass": _vm.dragClass,
        "showTabs": _vm.showTabs,
        "collectionDrag": _vm.cleanSectionItems(section.items, _vm.internalStructure),
        "collection": _vm.internalStructure,
        "collectionByTab": _vm.internalStructureByTab
      },
      on: {
        "onDrop": _vm.onDrop
      }
    }, _vm._l((_vm.cleanSectionItems(section.items, _vm.internalStructure)), function(item, idx) {
      return _c('EditorDragItem', {
        key: ((item.name) + "-" + idx),
        attrs: {
          "size": "small",
          "item": item
        }
      })
    }), 1)], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "editor-column col-md-5 col-lg-5 col-xl-5"
  }, [(_vm.showTabs && _vm.tabsAvailable()) ? _c('drag-tab-container', {
    attrs: {
      "tabs": _vm.internalTabs,
      "editorName": _vm.editorName
    }
  }) : _vm._e(), _vm._v(" "), _c('drag-container', {
    class: _vm.getMainDragContainerClass(_vm.editorName),
    attrs: {
      "groupName": "getGroupName()",
      "shouldRemoveOnDrop": true,
      "shouldAcceptDrops": true,
      "dragClass": _vm.dragClass,
      "showTabs": _vm.showTabs,
      "collection": _vm.internalStructure,
      "collectionByTab": _vm.internalStructureByTab
    },
    on: {
      "onDrop": _vm.onDrop
    }
  }, [_vm._l((_vm.internalStructureItems()), function(item, idx) {
    return _c('EditorDragItem', {
      key: ((item.name) + "-" + idx),
      class: _vm.getItemGrid(item, _vm.editorName),
      attrs: {
        "size": "big",
        "item": item,
        "setActiveOnClick": true
      }
    })
  }), _vm._v(" "), (_vm.internalSubmitButton) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "drag-submit-button",
    class: {
      'active': _vm.submitButtonIsActive
    },
    on: {
      "click": _vm.setSubmitActive
    }
  }, [_c('drag-submit-button', {
    attrs: {
      "button": _vm.internalSubmitButton
    }
  })], 1)])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "editor-column active-container col-md-4 col-lg-4 col-xl-4"
  }, [_c('drag-active-item-container', {
    attrs: {
      "editorName": _vm.editorName,
      "limitEditing": _vm.limitEditing
    },
    on: {
      "delete": _vm.deleteElement,
      "edit": _vm.editElement
    }
  })], 1)]) : _c('div', [_c('empty-state', {
    attrs: {
      "heading": _vm.emptyStateOptions.heading,
      "subtitle": _vm.emptyStateOptions.subtitle
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "public-app"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('router-view', {
    key: _vm.$route.fullPath,
    on: {
      "login": function($event) {
        return _vm.$emit('login')
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('integration', {
    attrs: {
      "logoSrc": _vm.logoSrc,
      "label": _vm.label
    },
    on: {
      "input": function($event) {
        return _vm.updateActive()
      }
    },
    model: {
      value: (_vm.internalActive),
      callback: function($$v) {
        _vm.internalActive = $$v
      },
      expression: "internalActive"
    }
  }, [_c('tag-list', {
    attrs: {
      "label": "Webinar key",
      "disabled": !_vm.internalActive,
      "value": _vm.internalKeys,
      "classes": ['no-margin']
    },
    on: {
      "input": function($event) {
        return _vm.updateKeys()
      }
    },
    model: {
      value: (_vm.internalKeys),
      callback: function($$v) {
        _vm.internalKeys = $$v
      },
      expression: "internalKeys"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading": _vm.isLoading,
      "is-panel": ""
    }
  }, [
    [_c('div', {
      staticClass: "latest-activity"
    }, [(_vm.activities.length > 0 && !_vm.isError) ? _c('div', [_c('div', {
      staticClass: "widget-header"
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('ui.dashboard.latest_activity.label')))])]), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, _vm._l((_vm.activities), function(activity, index) {
      return _c('div', {
        key: index,
        staticClass: "activity-item"
      }, [_c('div', {
        staticClass: "icon"
      }, [(activity.activity === _vm.LEAD_CREATE) ? _c('img', {
        attrs: {
          "src": __webpack_require__(454)
        }
      }) : (activity.activity === _vm.LEAD_UPDATE) ? _c('img', {
        attrs: {
          "src": __webpack_require__(455)
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('router-link', {
        staticClass: "link",
        attrs: {
          "to": {
            name: 'project_lead_edit',
            params: {
              id: activity.project.identifier,
              lead_id: activity.lead.identifier
            }
          }
        }
      }, [(activity.person.name) ? _c('div', [_vm._v("\n                        " + _vm._s(activity.person.name) + "\n                      ")]) : _c('div', [_vm._v("\n                        " + _vm._s(_vm.$t('ui.dashboard.latest_activity.incomplete_lead')) + "\n                      ")])]), _vm._v(" "), (activity.activity === _vm.LEAD_CREATE) ? _c('p', {
        staticClass: "activity-description truncate-text link"
      }, [_vm._v("\n                      " + _vm._s(_vm.$t('ui.dashboard.latest_activity.added_to')) + " "), _c('router-link', {
        attrs: {
          "to": {
            name: 'project_leads',
            params: {
              id: activity.project.identifier
            }
          }
        }
      }, [_vm._v("\n                        " + _vm._s(activity.project.name) + "\n                      ")])], 1) : (activity.activity === _vm.LEAD_UPDATE) ? _c('p', {
        staticClass: "activity-description truncate-text link"
      }, [_vm._v("\n                      " + _vm._s(_vm.$t('ui.dashboard.latest_activity.edited_in')) + " "), _c('router-link', {
        attrs: {
          "to": {
            name: 'project_leads',
            params: {
              id: activity.project.identifier
            }
          }
        }
      }, [_vm._v("\n                        " + _vm._s(activity.project.name) + "\n                      ")])], 1) : _vm._e(), _vm._v(" "), (activity.by !== void 0) ? _c('p', {
        staticClass: "activity-details caption"
      }, [_vm._v("\n                      " + _vm._s(_vm.$t('ui.dashboard.latest_activity.by')) + " "), _c('span', [_vm._v(_vm._s(activity.by))]), _vm._v(" - " + _vm._s(_vm._f("date")(activity.at)) + "\n                    ")]) : _c('p', {
        staticClass: "activity-details caption"
      }, [_vm._v("\n                      " + _vm._s(_vm._f("date")(activity.at)) + "\n                    ")])], 1)])
    }), 0)]) : (_vm.activities.length === 0 && !_vm.isError) ? _c('div', {
      staticClass: "aligner"
    }, [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(157)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('ui.dashboard.activity_list_widget.empty_state_headline')) + "\n          ")]), _vm._v(" "), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'project_new'
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('ui.dashboard.activity_list_widget.empty_state_intro')) + "\n          ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('div', {
      staticClass: "aligner"
    }, [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(157)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('ui.dashboard.widget_error')) + "\n          ")])])]) : _vm._e()])]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row wrapper"
  }, [_c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "integration-section"
  }, [_c('img', {
    attrs: {
      "src": _vm.computedLogoSrc
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "integration-section"
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.$t(("ui.integrations." + _vm.label))) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "integration-section"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-1 switch"
  }, [_c('form-switch', {
    ref: "switch",
    attrs: {
      "label": "empty",
      "value": _vm.value
    },
    on: {
      "input": _vm.updateActive
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field tag-list"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.labelText) + " "), (!_vm.required) ? _c('em', {
    staticClass: "optional"
  }, [_vm._v("optional")]) : _vm._e(), (_vm.required) ? _c('em', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tag-list--input"
  }, [_c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tag),
      expression: "tag"
    }],
    class: _vm.getClass(),
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.tag)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.addOrRemoveTag($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.addTagKey($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "comma", undefined, $event.key, undefined)) { return null; }
        return _vm.addTagKey($event)
      }],
      "focus": _vm.emitFocus,
      "blur": _vm.emitBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tag = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "add icon yule-icon-circle-plus",
    on: {
      "click": _vm.addOrRemoveTag
    }
  })]), _vm._v(" "), _vm._l((_vm.value), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tag-list--item"
    }, [_c('span', [_vm._v(_vm._s(item.length > 15 ? ((item.slice(0, 15)) + "…") : item))]), _vm._v(" "), (!_vm.isProtected(item)) ? _c('i', {
      staticClass: "icon tag-list--icon remove yule-icon-close-small",
      on: {
        "click": function($event) {
          return _vm.removeTag(index)
        }
      }
    }) : _c('i', {
      staticClass: "icon tag-list--icon yule-icon-lock"
    })])
  })], 2), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t(_vm.error)))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-filter', {
    attrs: {
      "is-disabled": _vm.isDisabled
    },
    on: {
      "change": _vm.emitHandler
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.today')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.last_7')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.last_month')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "365"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.last_year')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.all
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.all_time')))])])
},staticRenderFns: []}

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organization-update update-form"
  }, [_c('form', {
    staticClass: "email-template-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "email_template",
      "name": "name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "language",
      "required": true,
      "placeholder": "en"
    },
    model: {
      value: (_vm.item.language),
      callback: function($$v) {
        _vm.$set(_vm.item, "language", $$v)
      },
      expression: "item.language"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "from",
      "placeholder": "John Smith"
    },
    model: {
      value: (_vm.item.from),
      callback: function($$v) {
        _vm.$set(_vm.item, "from", $$v)
      },
      expression: "item.from"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "reply_to",
      "placeholder": "noreply@example.com"
    },
    model: {
      value: (_vm.item.reply_to),
      callback: function($$v) {
        _vm.$set(_vm.item, "reply_to", $$v)
      },
      expression: "item.reply_to"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('field', {
    ref: "salutation",
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "salutation",
      "placeholder": "Hi [[firstname]]"
    },
    model: {
      value: (_vm.item.salutation),
      callback: function($$v) {
        _vm.$set(_vm.item, "salutation", $$v)
      },
      expression: "item.salutation"
    }
  }), _vm._v(" "), _c('field-filler', {
    attrs: {
      "elements": _vm.$refs,
      "element-name": "salutation",
      "values": _vm.placeholderSalutationCollection
    },
    model: {
      value: (_vm.item.salutation),
      callback: function($$v) {
        _vm.$set(_vm.item, "salutation", $$v)
      },
      expression: "item.salutation"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "salutation_fallback",
      "placeholder": "Hi dear"
    },
    model: {
      value: (_vm.item.salutation_fallback),
      callback: function($$v) {
        _vm.$set(_vm.item, "salutation_fallback", $$v)
      },
      expression: "item.salutation_fallback"
    }
  }), _vm._v(" "), _c('field', {
    ref: "body",
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "body",
      "type": "textarea",
      "required": true
    },
    model: {
      value: (_vm.item.body),
      callback: function($$v) {
        _vm.$set(_vm.item, "body", $$v)
      },
      expression: "item.body"
    }
  }), _vm._v(" "), _c('field-filler', {
    attrs: {
      "elements": _vm.$refs,
      "element-name": "body",
      "values": _vm.placeholderBodyCollection
    },
    model: {
      value: (_vm.item.body),
      callback: function($$v) {
        _vm.$set(_vm.item, "body", $$v)
      },
      expression: "item.body"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "imprint_url"
    },
    model: {
      value: (_vm.item.imprint_url),
      callback: function($$v) {
        _vm.$set(_vm.item, "imprint_url", $$v)
      },
      expression: "item.imprint_url"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "privacy_url"
    },
    model: {
      value: (_vm.item.privacy_url),
      callback: function($$v) {
        _vm.$set(_vm.item, "privacy_url", $$v)
      },
      expression: "item.privacy_url"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    attrs: {
      "data-action": "email-templates.cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-save",
    attrs: {
      "type": "submit",
      "data-action": "email-templates.update"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trackings) ? _c('div', {
    staticClass: "project-trackings"
  }, [_c('div', {
    staticClass: "statistics-global"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "title-grid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('statistics.latest_trackings')))]), _vm._v(" "), _c('relative-date-choser', {
    attrs: {
      "choices": [1, 7, 30, 60]
    },
    on: {
      "change": _vm.dateChange
    }
  })], 1)]), _vm._v(" "), (_vm.trackingsSorted.length > 0) ? _c('div', _vm._l((_vm.trackingsSorted), function(trackings) {
    return _c('div', {
      key: trackings[0].time,
      staticClass: "tracking-table"
    }, [_c('div', {
      staticClass: "tracking-table--date"
    }, [_vm._v("\n          " + _vm._s(_vm.moment(trackings[0].time).format('MMMM Do')) + "\n        ")]), _vm._v(" "), _c('tracking-table', {
      attrs: {
        "project-id": _vm.id,
        "trackings": trackings
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "is-empty"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('statistics.no_data')) + "\n    ")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.statistics) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card--content"
  }, [_c('div', {
    staticClass: "card--number"
  }, [_c('div', {
    staticClass: "card--number-value"
  }, [_vm._v("\n        " + _vm._s(_vm.businessKitPerLead) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card--number-key"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.businesskit_per_lead')) + "\n      ")])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-dropzone",
    class: {
      'is-active': !_vm.file
    }
  }, [(!_vm.file) ? _c('div', {
    staticClass: "upload-dropzone--text"
  }, [_c('div', {
    staticClass: "upload-dropzone--icon"
  }), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('ui.upload.dropzone_message')) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.file) ? _c('div', {
    staticClass: "upload-dropzone--text"
  }, [_vm._v("\n    " + _vm._s(_vm.file.name) + " / " + _vm._s(_vm.formatBytes(_vm.file.size, 2)) + " "), _c('i', {
    staticClass: "icon icon-x",
    attrs: {
      "title": _vm.$t('ui.upload.empty_file')
    },
    on: {
      "click": _vm.emptyFile
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.file) ? _c('input', {
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.fileUpload
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.item.shouldNotChangeRoute) ? _c('li', {
    class: _vm.itemClasses,
    attrs: {
      "data-action": _vm.item.action
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.allowedAccess) ? _c('div', {
    staticClass: "clickable",
    attrs: {
      "to": {
        name: _vm.item.name
      }
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.item.icon))]) : _vm._e(), _vm._v(" "), (this.item.label) ? _c('div', [_vm._v(_vm._s(this.item.label) + " ")]) : (this.item.title) ? _c('div', [_vm._v(_vm._s(this.item.title) + " ")]) : _c('div', [_vm._v(_vm._s(_vm.$t(("ui.menu." + (_vm.item.name)))))])]) : _c('navigation-locked-item', {
    attrs: {
      "item": _vm.item
    }
  })], 1) : _c('span', {
    class: _vm.itemClasses,
    attrs: {
      "data-action": _vm.item.action
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.allowedAccess) ? _c('router-link', {
    attrs: {
      "to": {
        name: _vm.item.name
      }
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.item.icon))]) : _vm._e(), _vm._v(" "), (this.item.title) ? _c('div', [_vm._v(_vm._s(this.item.title) + " ")]) : _c('div', [_vm._v(_vm._s(_vm.$t(("ui.menu." + (_vm.item.name)))))])]) : _c('navigation-locked-item', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "value-crud-action--delete"
  }, [_c('a', {
    on: {
      "click": _vm.unassign
    }
  }, [_c('i', {
    staticClass: "icon status-inactive"
  }, [_vm._v("clear")])])])
},staticRenderFns: []}

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.items) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('collection', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.collectionData,
      "has_searched": _vm.has_searched,
      "params": _vm.params,
      "model": "plan"
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-show"
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    class: _vm.classes,
    attrs: {
      "src": _vm.logoSrc
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-switch",
    class: _vm.newClasses
  }, [_c('label', {
    staticClass: "form-switch--label",
    attrs: {
      "for": 'switch-' + _vm.name
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.newLabel)))]), _vm._v(" "), _c('div', {
    staticClass: "switch-container",
    attrs: {
      "id": 'switch-' + _vm.name
    },
    on: {
      "click": _vm.valueSwitch
    }
  }, [_c('div', {
    staticClass: "switch-button"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-filler"
  }, _vm._l((_vm.values), function(value) {
    return _c('div', {
      key: value.name,
      staticClass: "field-filler--value",
      on: {
        "click": function($event) {
          return _vm.fill(value)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.$t(value.code)) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-secondary editor-submit"
  }, [_vm._v("\n  " + _vm._s(_vm.button.content) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchbar"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "searchbar--input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('ui.searchbar.placeholder.' + _vm.model)
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon searchbar--icon yule-icon-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-arrow",
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-arrow-right"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-businesskit-assignement "
  }, [_c('assignment-modal', {
    attrs: {
      "collection": _vm.filteredBusinesskits,
      "assignedCollection": _vm.assignedBusinessKitList,
      "title": _vm.computedTitle,
      "subtitle": _vm.computedSubtitle,
      "open": _vm.isOpen,
      "searchPlaceholder": "bk",
      "displayName": "name"
    },
    on: {
      "close": _vm.close,
      "save": _vm.save
    }
  }), _vm._v(" "), (this.assignedBusinesskits.length === 0) ? _c('div', {
    staticClass: "empty-state-assignment"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(286)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.pages.project-no-assigned-businesskit')))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('span', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.isOpen = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.project-assign-businesskit')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (this.assignedBusinesskits.length > 0) ? _c('div', {
    staticClass: "project-businesskit-assignement--monitor"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(_vm.$t('ui.pages.project-assigned-businesskit')) + ":\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.isOpen = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.project-assign-businesskit')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.assignedBusinessKitList), function(businesskit) {
    return _c('div', {
      key: businesskit.id,
      staticClass: "businesskit"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(285)
      }
    }), _vm._v(" "), _c('div', [_c('h4', {
      staticClass: "businesskit-name"
    }, [_vm._v("\n          " + _vm._s(businesskit.name) + "\n        ")]), _vm._v(" "), (businesskit.preview_url) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": businesskit.preview_url,
        "target": "_blank"
      }
    }, [_vm._v("\n          Preview\n        ")]) : _vm._e()])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding"
  }, [(_vm.modal.isOpen) ? _c('onboarding-modal', {
    attrs: {
      "has-mask": _vm.modal.hasMask,
      "can-click-mask": _vm.modal.canClickMask,
      "has-x": _vm.modal.hasX
    },
    on: {
      "toggle": _vm.toggleModal
    }
  }, [_c('article', {
    staticClass: "onboarding-body"
  }, [_c('section', [_c('div', {
    staticClass: "modal-top"
  }, [_c('img', {
    staticClass: "first-step",
    attrs: {
      "src": __webpack_require__(462)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-bottom"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step1.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step1.subtitle")))])]), _vm._v(" "), _c('footer', {
    staticClass: "onboarding-footer"
  }, [_c('div', {
    staticClass: "forward-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "primary next",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": function($event) {
        return _vm.skip(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.next")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLastStep),
      expression: "isLastStep"
    }],
    staticClass: "accent save",
    attrs: {
      "disabled": !_vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.start")))])]), _vm._v(" "), (_vm.hasDots) ? _c('div', {
    staticClass: "step-dots"
  }, _vm._l((_vm.max), function(n) {
    return _c('div', {
      staticClass: "step-dot",
      class: {
        active: n == _vm.step
      },
      on: {
        "click": function($event) {
          return _vm.goToStep(n)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "secondary skip",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.skip")))])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "modal-top"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(463)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-bottom"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step2.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step2.subtitle")) + " ")])]), _vm._v(" "), _c('footer', {
    staticClass: "onboarding-footer"
  }, [_c('div', {
    staticClass: "forward-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "primary next",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": function($event) {
        return _vm.skip(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.next")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLastStep),
      expression: "isLastStep"
    }],
    staticClass: "accent save",
    attrs: {
      "disabled": !_vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.start")))])]), _vm._v(" "), (_vm.hasDots) ? _c('div', {
    staticClass: "step-dots"
  }, _vm._l((_vm.max), function(n) {
    return _c('div', {
      staticClass: "step-dot",
      class: {
        active: n == _vm.step
      },
      on: {
        "click": function($event) {
          return _vm.goToStep(n)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "secondary skip",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.skip")))])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "modal-top"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(464)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-bottom"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step3.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.onboarding.step3.subtitle")))])]), _vm._v(" "), _c('footer', {
    staticClass: "onboarding-footer"
  }, [_c('div', {
    staticClass: "forward-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "primary next",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": function($event) {
        return _vm.skip(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.next")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLastStep),
      expression: "isLastStep"
    }],
    staticClass: "accent save",
    attrs: {
      "disabled": !_vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.start")))])]), _vm._v(" "), (_vm.hasDots) ? _c('div', {
    staticClass: "step-dots"
  }, _vm._l((_vm.max), function(n) {
    return _c('div', {
      staticClass: "step-dot",
      class: {
        active: n == _vm.step
      },
      on: {
        "click": function($event) {
          return _vm.goToStep(n)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-actions"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLastStep),
      expression: "!isLastStep"
    }],
    staticClass: "secondary skip",
    attrs: {
      "disabled": _vm.isLastStep
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.onboarding.skip")))])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "value-crud-action--show"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.routeParams,
      "data-action": _vm.model + '.show',
      "data-action-id": _vm.item.id
    }
  }, [_vm._v("show")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('admin'),
      expression: "'admin'"
    }],
    staticClass: "content-manager"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card col col-3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(286)
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("ui.content_manager.first-card.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.content_manager.first-card.subtitle")))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.businessKitLink(),
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.content_manager.first-card.btn")) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "card col col-3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(438)
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("ui.content_manager.second-card.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.content_manager.second-card.subtitle")))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openForms()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.content_manager.second-card.btn")))]), _vm._v(" "), _c('external-form-create')], 1), _vm._v(" "), (!_vm.currentPlanIsTalent) ? _c('div', {
    staticClass: "card col col-3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(461)
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("ui.content_manager.third-card.title")))]), _vm._v(" "), _c('p', [_vm._v("  " + _vm._s(_vm.$t("ui.content_manager.third-card.subtitle")))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "https://fanomena.io",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.content_manager.third-card.btn")))])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "value-crud-action--edit"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-action": _vm.model + '.edit',
      "data-action-id": _vm.item.id,
      "to": _vm.routeParams
    }
  }, [_vm._v("Edit")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!this.onboardingModalShowing) ? _c('div', [_c('router-view'), _vm._v(" "), (this.emptyState === 'projects' && this.currentUserIsAdmin) ? _c('empty-state', {
    attrs: {
      "name": "projects",
      "heading": _vm.emptyStateHeading,
      "subtitle": _vm.emptyStateSubtitle,
      "button": true
    }
  }) : (this.emptyState === 'projects' && !this.currentUserIsAdmin) ? _c('div', {
    staticClass: "collaborator-empty-state"
  }, [_c('empty-state', {
    attrs: {
      "name": "projects",
      "heading": _vm.emptyStateHeadingUser,
      "subtitle": _vm.emptyStateSubtitleUser,
      "button": false
    }
  }), _vm._v(" "), (_vm.invitedByUserId && !_vm.isSubmited) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.empty_state.projects.btn')))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [(_vm.isSubmited) ? _c('div', {
    class: {
      'success-msg': _vm.isSubmited
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(466)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.empty_state.projects.success_message')))])]) : _vm._e()])], 1) : _c('div', {
    staticClass: "project-show project-collection"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('projects-listing', {
    class: {
      'hideScroll': _vm.wizardModalShowing
    },
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.collectionData,
      "params": {
        global_sorting: true,
        sort_by: this.query.sort_by,
        sort_order: this.query.sort_order
      },
      "model": "project_lead",
      "has_searched": _vm.has_searched
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-download-screen'), _vm._v(" "), (_vm.view === null) ? _c('modal', {
    attrs: {
      "title": _vm.modalTitleCreate,
      "open": _vm.isOpen,
      "buttons": false
    },
    on: {
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('div', {
    staticClass: "action-box",
    attrs: {
      "data-action": "lead.create-from-email"
    },
    on: {
      "click": function($event) {
        return _vm.changeView('email')
      }
    }
  }, [_c('img', {
    staticClass: "enter-email",
    attrs: {
      "src": __webpack_require__(437)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("models.project_lead.message.create_from_email")))])]), _vm._v(" "), (
    _vm.browser.name == 'crios' ||
    _vm.browser.name == 'fxios' ||
    _vm.browser.name == 'ios'
  ) ? _c('div', {
    staticClass: "ios-workaround"
  }, [_c('label', {
    staticClass: "action-box",
    attrs: {
      "for": "businesscard_upload",
      "data-action": "lead.create-from-card"
    }
  }, [_c('img', {
    staticClass: "capture-card",
    attrs: {
      "src": __webpack_require__(292)
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "ios_only ios-photo-input",
    attrs: {
      "id": "businesscard_upload",
      "type": "file",
      "accept": "image/*",
      "capture": "camera"
    },
    on: {
      "change": _vm.uploadedImage
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("models.project_lead.message.create_from_card")))])])]) : _c('div', [_c('div', {
    staticClass: "action-box",
    attrs: {
      "data-action": "lead.create-from-card"
    },
    on: {
      "click": function($event) {
        return _vm.changeView('card')
      }
    }
  }, [_c('img', {
    staticClass: "capture-card",
    attrs: {
      "src": __webpack_require__(292)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("models.project_lead.message.create_from_card")))])])])]) : (_vm.view === 'email') ? _c('modal', {
    attrs: {
      "title": _vm.modalTitleCreate,
      "saveText": _vm.modalSaveTextEmail,
      "open": _vm.isOpen
    },
    on: {
      "save": _vm.confirmEmail,
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "project_lead",
      "name": "email",
      "placeholder": "lead@company.com"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1) : (_vm.view === 'card') ? _c('modal', {
    staticClass: "lead-create-modal",
    attrs: {
      "title": _vm.modalTitleCreate,
      "open": _vm.isOpen,
      "saveText": _vm.modalSaveTextWebcam
    },
    on: {
      "save": _vm.takePhoto,
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('vue-webcam', {
    ref: "webcam"
  })], 1) : (_vm.view === 'api-error') ? _c('modal', {
    attrs: {
      "title": _vm.$t('errors.api_error_modal.select_company'),
      "saveText": _vm.modalSaveTextContinue,
      "open": _vm.isOpen
    },
    on: {
      "save": function($event) {
        return _vm.resolveApiError(true)
      },
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('user-api-choice', {
    attrs: {
      "error": _vm.apiError,
      "listItems": _vm.apiErrorAttributes,
      "includeCtaButton": true,
      "ctaButtonText": "Continue",
      "caption": _vm.$t('errors.api_error_modal.select_company_caption')
    },
    on: {
      "resolve": _vm.resolveApiError
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-btn-dropdown', {
    class: _vm.klass,
    attrs: {
      "hover-reveal": false,
      "split": "",
      "label": _vm.getLabel,
      "no-hover": "",
      "no-ripple": true
    },
    on: {
      "click": _vm.click
    }
  }, [_c('q-list', {
    attrs: {
      "link": ""
    }
  }, [_c('q-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.moveLeft($event)
      }
    }
  }, [_c('q-item-main', [_c('q-item-tile', {
    attrs: {
      "label": ""
    }
  }, [_vm._v("Move left")])], 1)], 1), _vm._v(" "), _c('q-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.moveRight($event)
      }
    }
  }, [_c('q-item-main', [_c('q-item-tile', {
    attrs: {
      "label": ""
    }
  }, [_vm._v("Move right")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project_user_assign"
  }, [_vm._v("\n  hey\n  " + _vm._s(_vm.project_id) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gauge"
  }, [_c('div', {
    staticClass: "meter",
    style: ('transform: rotate(' + _vm.rotation + 'turn);')
  }), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_vm._v("\n    " + _vm._s(_vm.percentage) + "%\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "copyright"
  }, [_vm._v("\n    © Copyright Fanomena " + _vm._s(_vm.currentYear) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "app-download-modal"
    }
  }, [_c('div', {
    staticClass: "app-download-modal"
  }, [(_vm.hasMask) ? _c('div', {
    staticClass: "app-download-modal__mask",
    on: {
      "click": _vm.clickMask
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-download-modal__wrapper"
  }, [_vm._t("default"), _vm._v(" "), (_vm.hasX) ? _c('span', {
    staticClass: "app-download-modal__x",
    attrs: {
      "id": "finish"
    },
    on: {
      "click": _vm.clickX
    }
  }, [_vm._v("×")]) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "companys-section"
  }, [_c('x-table', {
    attrs: {
      "title": _vm.$t('ui.company.title'),
      "emptyStateLabel": _vm.$t('ui.company.empty_state_label'),
      "columns": _vm.columns,
      "tableData": _vm.companies,
      "enableSearch": true,
      "searchKeywords": _vm.searchKeywords,
      "totalResults": _vm.totalCount,
      "pagination": _vm.defaultPagination,
      "showLoader": _vm.loading,
      "tableSettingsName": 'companies',
      "rowsPerPage": [5, 7, 10, 15, 25, 50]
    },
    on: {
      "updateSearch": _vm.updateSearch,
      "updatePagination": _vm.updatePagination,
      "fetchData": _vm.fetchData,
      "clickCell": _vm.clickCell,
      "emitTotalTableCount": _vm.emitTotalTableCount
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [(_vm.userFoundByToken) ? _c('div', [(!_vm.success) ? _c('form', {
    staticClass: "invitation-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkFields($event)
      }
    }
  }, [_c('div', {
    staticClass: "title_group"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('ui.auth.create_account_title')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.auth.create_account_subtitle')))])]), _vm._v(" "), _c('field', {
    attrs: {
      "label": " ",
      "name": "token",
      "type": "hidden"
    },
    model: {
      value: (_vm.token),
      callback: function($$v) {
        _vm.token = $$v
      },
      expression: "token"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "placeholder": _vm.$t('ui.auth.firstname'),
      "name": "firstname",
      "label": "ui.auth.firstname"
    },
    model: {
      value: (_vm.firstname),
      callback: function($$v) {
        _vm.firstname = $$v
      },
      expression: "firstname"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "placeholder": _vm.$t('ui.auth.lastname'),
      "name": "lastname",
      "label": "ui.auth.lastname"
    },
    model: {
      value: (_vm.lastname),
      callback: function($$v) {
        _vm.lastname = $$v
      },
      expression: "lastname"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "placeholder": _vm.$t('ui.auth.password'),
      "name": "password",
      "type": "password",
      "label": "ui.auth.password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "placeholder": _vm.$t('ui.auth.password_confirmation'),
      "name": "password_confirmation",
      "type": "password",
      "label": "ui.auth.password_confirmation"
    },
    model: {
      value: (_vm.password_confirmation),
      callback: function($$v) {
        _vm.password_confirmation = $$v
      },
      expression: "password_confirmation"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-login",
    attrs: {
      "type": "submit",
      "data-action": "user.password_reset"
    },
    domProps: {
      "value": _vm.$t('ui.auth.confirm')
    }
  })])], 1) : _c('div', {
    staticClass: "invitation-confirm"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('ui.auth.create_account_title_confirm')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('ui.auth.create_account_subtitle_confirm')))]), _vm._v(" "), _c('i', {
    staticClass: "icon yule-icon-success"
  })])]) : _c('div', {
    staticClass: "invitation-confirm"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('ui.auth.user_not_found')))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ui.auth.user_not_found_subtitle'))
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon yule-icon-error"
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t('ui.auth.go_to_login')) + " ")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "x-filter"
  }, [(_vm.getRootGroup()) ? _c('x-filter-group', {
    attrs: {
      "group": _vm.getRootGroup(),
      "index": 0,
      "filterDefinitions": _vm.workingFilterDefinitions
    },
    on: {
      "updateGroup": _vm.updateGroup
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "x-filter-group"
  }, [_c('transition-group', {
    attrs: {
      "name": "x-filter-transition"
    }
  }, _vm._l((_vm.getAllConditions()), function(condition, index) {
    return _c('x-filter-condition', {
      key: condition.attribute + index,
      attrs: {
        "condition": condition,
        "operator": _vm.getOperator(),
        "isLast": index == _vm.getAllConditions().length - 1
      },
      on: {
        "removeCondition": _vm.removeCondition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('q-btn-dropdown', {
    staticClass: "x-filter-add-btn",
    attrs: {
      "label": _vm.$t('ui.xfilters.add_filter'),
      "no-ripple": "",
      "no-caps": ""
    }
  }, [_c('q-list', {
    ref: "deflist",
    staticClass: "x-filter-add-list",
    attrs: {
      "link": ""
    }
  }, _vm._l((_vm.filterDefinitions), function(definition, index) {
    return _c('q-item', {
      directives: [{
        name: "close-overlay",
        rawName: "v-close-overlay"
      }],
      key: index,
      staticClass: "x-filter-add-list-item",
      attrs: {
        "separator": definition.separator ? true : false,
        "disabled": definition.disabled ? true : false
      },
      nativeOn: {
        "click": function($event) {
          return _vm.openAddConditionModal(definition)
        }
      }
    }, [_vm._v(_vm._s(definition.label))])
  }), 1)], 1), _vm._v(" "), _c('x-filter-modal', {
    key: _vm.modalKey,
    attrs: {
      "filterDefinition": _vm.filterDefinition,
      "isOpen": _vm.filterModalOpen
    },
    on: {
      "addCondition": _vm.addCondition
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "open": _vm.confirmationModalOpen,
      "title": _vm.$t('ui.global.warning'),
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": "ui.xfilters.confirm_removal"
    },
    on: {
      "save": _vm.deleteConfirmed,
      "cancel": _vm.deleteCancelled
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('ui.xfilters.delete_filter_warning')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.xfilters.delete_filter_confirmation')))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-navigation"
  }, [_c('q-layout-header', {
    attrs: {
      "id": "mobile-navigation"
    }
  }, [_c('q-toolbar', {
    staticClass: "navigation",
    attrs: {
      "color": "brand"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'projects'
      }
    }
  }, [_c('logo')], 1), _vm._v(" "), (_vm.compressed) ? _c('div', {
    staticClass: "navigation--compressed"
  }, [_c('div', {
    staticClass: "right-align"
  }, [(_vm.compressedUnpublishedChanges > 0) ? _c('div', {
    staticClass: "unpublished-changes"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.drag_editor.unpublished_changes")) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('add-button')], 1)]) : _vm._e(), _vm._v(" "), _c('q-btn', {
    attrs: {
      "flat": "",
      "round": "",
      "dense": "",
      "icon": "menu"
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  })], 1)], 1), _vm._v(" "), _c('q-layout-drawer', {
    attrs: {
      "side": "right",
      "content-style": {
        fontSize: '16px',
        backgroundColor: '#212736'
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('q-list-header', [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'projects'
      }
    }
  }, [_c('logo')], 1)], 1), _vm._v(" "), _c('q-tabs', {
    attrs: {
      "color": "brand"
    }
  }, [_vm._l((_vm.mobileNavigation), function(routes) {
    return _c("authenticated-navigation-item", {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: (routes.credential),
        expression: "routes.credential"
      }],
      key: routes.label,
      tag: "q-route-tab",
      attrs: {
        "slot": "title",
        "exact": "",
        "bindings": _vm.getBindings(routes),
        "auth": routes.auth,
        "label": routes.label
      },
      on: {
        "close": function($event) {
          return _vm.close()
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.onClick()
        }
      },
      slot: "title"
    })
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.businessKitLink(),
      "target": "_blank"
    }
  }, [_c('q-tab', [_vm._v("Businesskits")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('q-route-tab', {
    attrs: {
      "to": {
        name: 'user_profile',
        params: {
          id: _vm.userId
        }
      },
      "label": _vm.$t('ui.menu.profile')
    }
  })], 2), _vm._v(" "), (_vm.userId) ? _c('q-tabs', {
    attrs: {
      "color": "brand"
    }
  }, [_vm._l((_vm.account), function(routes) {
    return _c("authenticated-navigation-item", {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: (routes.credential),
        expression: "routes.credential"
      }],
      key: routes.label,
      tag: "q-route-tab",
      attrs: {
        "slot": "title",
        "exact": "",
        "bindings": _vm.getBindings(routes),
        "auth": routes.auth,
        "label": routes.label
      },
      slot: "title"
    })
  }), _vm._v(" "), _c('q-tab', [_c('language-switcher')], 1)], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-filter', {
    attrs: {
      "is-disabled": _vm.isDisabled
    },
    on: {
      "change": _vm.emitHandler
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('ui.dashboard.filter.all_projects')) + "\n  ")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n      " + _vm._s(project.name) + "\n    ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "open": _vm.isOpen
    },
    on: {
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(this.currentStep == 1) ? _c('div', {
    staticClass: "wizard step-1"
  }, [_c('step-one', {
    attrs: {
      "item": _vm.item
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.currentStep == 2) ? _c('div', {
    staticClass: "wizard step-2"
  }, [_c('step-two', {
    attrs: {
      "item": _vm.item,
      "leadMasks": _vm.leadMasks,
      "businesskits": _vm.businesskits
    },
    on: {
      "create": function($event) {
        return _vm.create()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.currentStep == 3) ? _c('div', {
    staticClass: "wizard step-3"
  }, [_c('success', {
    attrs: {
      "item": _vm.item
    }
  })], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'widget-panel': _vm.isPanel
    }
  }, [_c('div', {
    staticClass: "loader-container"
  }, [(_vm.isLoadingSpinner) ? _c('q-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "size": "50px",
      "color": "primary"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "widget-chart-container"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "field field-text"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.newLabel)))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state != 'field'),
      expression: "state != 'field'"
    }],
    staticClass: "secret"
  }, [_c('input', {
    staticClass: "field--input password-input",
    attrs: {
      "type": "text",
      "disabled": "",
      "id": _vm.name,
      "placeholder": _vm.placeholder
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "switch btn btn-tertiary btn-tiny btn-flat",
    on: {
      "click": _vm.stateSwitch
    }
  }, [_vm._v("\n        Edit\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state == 'field'),
      expression: "state == 'field'"
    }],
    staticClass: "real-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    ref: "real-field",
    staticClass: "field--input text-input",
    attrs: {
      "type": "text",
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "switch icon yule-icon-close-small",
    on: {
      "click": _vm.stateSwitch
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "field-error"
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leads-listing"
  }, [_c('collection', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.data,
      "structure": _vm.structure,
      "params": _vm.params,
      "model": "project_lead",
      "has_searched": _vm.has_searched
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Draggable', [_c('div', {
    staticClass: "drag-item",
    class: _vm.classes,
    on: {
      "click": _vm.setActive
    }
  }, [_c('div', {
    staticClass: "drag-zone"
  }, [_c('img', {
    staticClass: "drag-icon",
    attrs: {
      "src": _vm.dragIcon
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-zone"
  }, [(_vm.size === 'small') ? _c('p', {
    staticClass: "truncate-text"
  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.size === 'big') ? _c('div', [_c('div', {
    staticClass: "form-container"
  }, [(_vm.item.element_type === 'confirmation') ? _c('div', [_c('div', {
    staticClass: "checkbox-container no-margin"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', [_vm._v(" " + _vm._s(_vm.name) + " ")])])]) : _c('label', {
    class: _vm.labelClasses(_vm.item)
  }, [(_vm.name) ? _c('div', [_vm._v(_vm._s(_vm.name))]) : _c('div', [_c('i', [_vm._v(_vm._s(_vm.$t('ui.drag_editor.no_label')))])]), _vm._v(" "), (_vm.item.hidden) ? _c('sensual-badge', {
    attrs: {
      "color": "grey-dark",
      "text": _vm.$t('ui.drag_editor.badges.hidden')
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.item.element_type === 'text') ? _c('div', [_c('input', _vm._b({
    attrs: {
      "readonly": "",
      "type": "text"
    }
  }, 'input', _vm.textBindings, false))]) : (_vm.item.element_type === 'select') ? _c('div', [_c('select', [(_vm.defaultValueSelect) ? _c('div', [_c('option', [_vm._v(_vm._s(_vm.defaultValueSelect))])]) : _vm._e()])]) : (_vm.item.element_type === 'country_select') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultValueSelectCountry),
      expression: "defaultValueSelectCountry"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.defaultValueSelectCountry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country['value']
      }
    }, [_vm._v(_vm._s(country['name']))])
  }), 0)]) : (_vm.item.element_type === 'textarea') ? _c('div', [_c('textarea', _vm._b({}, 'textarea', _vm.textBindings, false))]) : (_vm.item.element_type.includes('radio') && _vm.item.allowed_values.length > 0) ? _c('div', [_vm._l((_vm.shownAllowedValues), function(value) {
    return _c('div', {
      staticClass: "radio-container"
    }, [(_vm.item.show_as_buttons) ? _c('div', {
      staticClass: "custom_select"
    }, [_vm._v("\n                " + _vm._s(value.name) + "\n              ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "radio"
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'checked': _vm.isSelected(value)
      }
    }, [_vm._v(_vm._s(value.name))])])])
  }), _vm._v(" "), (_vm.item.allowed_values.length > 5) ? _c('div', [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n                " + _vm._s(_vm.extraAllowedValuesText) + "\n              ")])]) : _vm._e()], 2) : ((_vm.item.element_type.includes('checkbox')) && _vm.item.allowed_values.length > 0) ? _c('div', [_vm._l((_vm.shownAllowedValues), function(value) {
    return _c('div', {
      staticClass: "checkbox-container"
    }, [(_vm.item.show_as_buttons) ? _c('div', {
      staticClass: "custom_select"
    }, [_vm._v("\n                " + _vm._s(value.name) + "\n              ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'checked': _vm.isSelected(value)
      }
    }, [_vm._v(_vm._s(value.name))])])])
  }), _vm._v(" "), (_vm.item.allowed_values && (_vm.item.allowed_values.length > 5)) ? _c('div', [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n                " + _vm._s(_vm.extraAllowedValuesText) + "\n              ")])]) : _vm._e()], 2) : ((_vm.item.element_type === 'quantity_selection') && _vm.item.allowed_values.length > 0) ? _c('div', [_vm._l((_vm.shownAllowedValues), function(value) {
    return _c('div', [_c('select', {
      staticClass: "quantity-selection--editor"
    }, [_c('option', [_vm._v(_vm._s(value.name) + ": 0")])])])
  }), _vm._v(" "), (_vm.item.allowed_values && (_vm.item.allowed_values.length > 5)) ? _c('div', [_c('span', {
    staticClass: "caption"
  }, [_vm._v("\n                " + _vm._s(_vm.extraAllowedValuesText) + "\n              ")])]) : _vm._e()], 2) : ((_vm.item.element_type === 'date')) ? _c('div', [_c('input', {
    attrs: {
      "disabled": true,
      "type": "text"
    },
    domProps: {
      "value": "19 Aug 2019"
    }
  })]) : ((_vm.item.element_type === 'readonly')) ? _c('div', [_c('input', _vm._b({
    attrs: {
      "type": "text"
    }
  }, 'input', _vm.textBindings, false))]) : ((_vm.item.element_type === 'drawing')) ? _c('div', [_c('div', {
    staticClass: "drawing"
  })]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-show-with-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.routeParams,
      "data-action": _vm.model + '.edit',
      "data-action-id": _vm.item.id
    }
  }, [_vm._v(_vm._s(_vm.value))])], 1)
},staticRenderFns: []}

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "value-crud-action--delete"
  }, [_c('modal', {
    attrs: {
      "title": _vm.$t('ui.global.delete_title', {
        name: _vm.model
      }),
      "content": _vm.$t('ui.global.delete_confirmation', {
        name: _vm.item.name
      }),
      "actions": [{
          name: 'valid',
          class: 'btn btn-cancel',
          action: _vm.model + '.delete.confirm'
        },
        {
          name: 'cancel',
          class: 'btn',
          action: _vm.model + '.delete.cancel'
        }
      ],
      "btn-class": "btn btn-tertiary",
      "data-action": _vm.model + '.delete',
      "data-action-id": _vm.item.id
    },
    on: {
      "action": _vm.action
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t("ui.global.unassign")) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 2004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.item.id) ? _c('router-view', {
    attrs: {
      "item": _vm.item,
      "item_saved": _vm.item_saved
    },
    on: {
      "update": _vm.update
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-update-assignement"
  }, [_c('div', {
    staticClass: "grid-2 has-gutter-xl"
  }, [_c('div', [_c('form', {
    staticClass: "assign_user",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.assignUser($event)
      }
    }
  }, [_c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.options'),
      expression: "'projects.options'"
    }],
    attrs: {
      "type": "select",
      "collection": _vm.users,
      "model": "project",
      "name": "user_to_assign",
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.user_to_assign),
      callback: function($$v) {
        _vm.user_to_assign = $$v
      },
      expression: "user_to_assign"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-assign')))])])], 1), _vm._v(" "), _c('collection', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.options'),
      expression: "'projects.options'"
    }],
    attrs: {
      "data": _vm.assigned_users,
      "structure": _vm.user_structure,
      "model": "user"
    },
    on: {
      "itemDelete": _vm.unassignUser
    }
  })], 1), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "assign_businesskit",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.assignBusinesskit($event)
      }
    }
  }, [_c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.options'),
      expression: "'projects.options'"
    }],
    attrs: {
      "type": "select",
      "collection": _vm.businesskits,
      "model": "project",
      "name": "businesskit_to_assign",
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.businesskit_to_assign),
      callback: function($$v) {
        _vm.businesskit_to_assign = $$v
      },
      expression: "businesskit_to_assign"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-assign')))])])], 1), _vm._v(" "), _c('collection', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.options'),
      expression: "'projects.options'"
    }],
    attrs: {
      "data": _vm.assigned_businesskits,
      "structure": _vm.businesskit_structure,
      "model": "business_kit"
    },
    on: {
      "itemDelete": _vm.unassignBusinesskit
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-action": "project.update"
    },
    on: {
      "click": function($event) {
        return _vm.finish()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-' + _vm.type + '-button')))])])])
},staticRenderFns: []}

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('modal', {
    attrs: {
      "open": _vm.isOpen,
      "title": _vm.createTitle
    },
    on: {
      "cancel": _vm.cancel,
      "save": _vm.save
    }
  }, [_c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "name",
      "placeholder": "Form Name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "required": true,
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "language",
      "type": "radio",
      "collection": _vm.languageGetter,
      "defaultValue": _vm.currentLanguage
    },
    model: {
      value: (_vm.item.language),
      callback: function($$v) {
        _vm.$set(_vm.item, "language", $$v)
      },
      expression: "item.language"
    }
  }), _vm._v(" "), _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organizations.list'),
      expression: "'organizations.list'"
    }],
    attrs: {
      "required": false,
      "errors": _vm.errors,
      "model": "lead_mask",
      "name": "organization",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.organizations
    },
    model: {
      value: (_vm.item.organization),
      callback: function($$v) {
        _vm.$set(_vm.item, "organization", $$v)
      },
      expression: "item.organization"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "project-update"
  }, [_c('div', {
    staticClass: "wizard-toolbar"
  }, [_c('div', {
    staticClass: "grid-2"
  }, [_c('div', {
    staticClass: "progress-step-1 done"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step1-title')))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-step-2 done"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step2-title')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "project-created"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(465)
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.success-title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.success-subtitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "actions wizard-footer"
  }, [(_vm.shouldShowDefaultActions) ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'project_leads',
        params: {
          id: this.item.id.toString()
        }
      }
    }
  }, [_c('a', {
    staticClass: "cancel"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-capture-leads')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'content_manager'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat btn-save"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-create-content')))])])], 1) : _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    attrs: {
      "href": _vm.talentKitLink
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat btn-save"
  }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.talentButtonText)) + "\n          ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'project_leads',
        params: {
          id: this.item.id.toString()
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat btn-save"
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-capture-leads')))])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "upgrade-plan-wrapper"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('i', {
    staticClass: "icon yule-icon-lock"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('errors.plans.not_allowed_modal.title')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('errors.plans.not_allowed_modal.description')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('button', {
    staticClass: "btn btn-flat added-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.navigateSalesPage
    }
  }, [_vm._v(_vm._s(_vm.$t('errors.plans.not_allowed_modal.button')))])])])])])
},staticRenderFns: []}

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.popperOptions) ? _c('div', [_c('pop-over', {
    attrs: {
      "options": _vm.popperOptionsComputed
    }
  }, [_c('span', {
    class: _vm.computedClasses
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")])])], 1) : _c('span', {
    class: _vm.computedClasses
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "project-update"
  }, [_c('div', {
    staticClass: "wizard-toolbar"
  }, [_c('div', {
    staticClass: "grid-2"
  }, [_c('div', {
    staticClass: "progress-step-1 done"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step1-title')))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-step-2 active"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step2-title')))])])])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('ui.project_wizard.step2-title')))]), _vm._v(" "), (_vm.planIsTalent) ? _c('form', {
    staticClass: "project-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', {
    staticClass: "form-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.project_wizard.businesskits'))), _c('i', {
    staticClass: "icon icon-help-circle"
  })]), _vm._v(" "), _c('field', {
    ref: "businesskit",
    staticClass: "lead-sheet-selector",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "rel": "businessKitId",
      "name": "business_kit_id",
      "type": "select",
      "params": {
        no_i18n: true
      },
      "collection": _vm.businessKitList
    },
    on: {
      "input": _vm.setBusinessKit
    },
    model: {
      value: (_vm.item.business_kit_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "business_kit_id", $$v)
      },
      expression: "item.business_kit_id"
    }
  }), _vm._v(" "), _c('div', {
    ref: "custom",
    staticClass: "lead-sheet-custom",
    on: {
      "click": function($event) {
        return _vm.setBusinessKit('custom')
      }
    }
  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('ui.project_wizard.leadsheet-create')) + "\n        ")])])], 1) : _c('form', {
    staticClass: "project-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', {
    staticClass: "form-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.project_wizard.lead-sheets'))), _c('i', {
    staticClass: "icon icon-help-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row justify-between"
  }, [_c('div', {
    ref: "basic",
    staticClass: "leadsheet-box leadsheet-basic",
    on: {
      "click": function($event) {
        return _vm.setLeadSheet('basic');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(290)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Standard")])]), _vm._v(" "), _c('div', {
    ref: "advanced",
    staticClass: "leadsheet-box leadsheet-advanced",
    on: {
      "click": function($event) {
        return _vm.setLeadSheet('advanced')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(289)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Advanced")])])]), _vm._v(" "), (_vm.hasLeadMasks) ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('lead_masks.list'),
      expression: "'lead_masks.list'"
    }],
    ref: "leadMaskId",
    staticClass: "lead-sheet-selector",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "lead_mask_id",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.leadMasks
    },
    on: {
      "input": _vm.setLeadMaskId
    },
    model: {
      value: (_vm.item.lead_mask_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "lead_mask_id", $$v)
      },
      expression: "item.lead_mask_id"
    }
  }) : _vm._e(), _vm._v(" "), (['basic', 'advanced'].includes(_vm.currentlySelected)) ? _c('div', {
    staticClass: "lead-sheet-info"
  }, [_c('p', {
    staticClass: "tip"
  }, [_c('i', {
    staticClass: "icon yule-icon-info"
  }), _vm._v(" "), (_vm.currentlySelected == 'basic') ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('ui.project_wizard.leadsheet-basic')) + "\n          ")]) : (_vm.currentlySelected == 'advanced') ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('ui.project_wizard.leadsheet-advanced')) + "\n          ")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "actions wizard-footer"
  }, [_c('button', {
    staticClass: "btn btn-tertiary btn-flat",
    on: {
      "click": function($event) {
        return _vm.previousStep()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.previous')) + "\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.global.cancel')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-flat btn-save",
    on: {
      "click": function($event) {
        return _vm.create()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.project-create-button')) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading": _vm.isLoading,
      "is-panel": ""
    }
  }, [
    [_c('div', {
      staticClass: "latest-activity"
    }, [(_vm.projects.length > 0 && !_vm.isError) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('ui.dashboard.most_active_projects')))]), _vm._v(" "), _vm._l((_vm.projects), function(project, index) {
      return _c('div', {
        key: index,
        staticClass: "project-panel"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'project_leads',
            params: {
              id: project.project.id
            }
          },
          "tag": "div"
        }
      }, [_c('div', {
        staticClass: "project-header"
      }, [_c('h5', {
        staticClass: "truncate-text"
      }, [_vm._v(_vm._s(project.project.name))])]), _vm._v(" "), _c('div', {
        staticClass: "project-body"
      }, [_c('div', {
        staticClass: "row gutter-sm"
      }, [_c('div', {
        staticClass: "col-auto"
      }, [_c('p', {
        staticClass: "caption pre"
      }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.kits')))]), _vm._v(" "), _c('p', {
        staticClass: "accent truncate-text"
      }, [_vm._v(_vm._s(project.project.business_kits_count))])]), _vm._v(" "), _c('div', {
        staticClass: "col-auto"
      }, [_c('p', {
        staticClass: "caption pre"
      }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.leads')))]), _vm._v(" "), _c('p', {
        staticClass: "accent truncate-text"
      }, [_vm._v(_vm._s(project.leads_count))])]), _vm._v(" "), _c('div', {
        staticClass: "col-auto"
      }, [_c('p', {
        staticClass: "caption pre"
      }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.my_leads')))]), _vm._v(" "), _c('p', {
        staticClass: "accent truncate-text"
      }, [_vm._v(_vm._s(project.users_leads_count))])]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('p', {
        staticClass: "caption pre"
      }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.lead_sheet')))]), _vm._v(" "), _c('p', {
        staticClass: "accent truncate-text"
      }, [_vm._v(_vm._s(project.project.lead_mask.name))])])])])])], 1)
    })], 2) : (_vm.projects.length === 0 && !_vm.isError) ? _c('div', {
      staticClass: "aligner"
    }, [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(291)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.empty_state')))]), _vm._v(" "), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'project_new'
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.activity_list_widget.empty_state_intro')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('div', {
      staticClass: "aligner"
    }, [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(291)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.widget_error')))])])]) : _vm._e()])]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circle"
  }, [_c('span', {
    staticClass: "initials"
  }, [_vm._v(_vm._s(_vm.userInitials()))])])
},staticRenderFns: []}

/***/ }),
/* 2013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-update update-form container row"
  }, [_c('div', {
    staticClass: "center col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "profile"
  }, [_c('user-image', {
    attrs: {
      "firstname": _vm.currentUser.firstname,
      "lastname": _vm.currentUser.lastname,
      "email": _vm.currentUser.email == 'unknown' ? '' : _vm.currentUser.email,
      "size": "medium",
      "theme": "sensual-lighter"
    }
  }), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.item.email) + " ")]), _vm._v(" "), (_vm.item.organization) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.item.organization.name) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.item.role) ? _c('sensual-badge', {
    attrs: {
      "color": "dark",
      "text": _vm.item.role
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "forgot-password",
    attrs: {
      "to": {
        name: 'password_reset_request'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.meta_info.reset_password')))])], 1), _vm._v(" "), _c('form', {
    staticClass: "profile-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "firstname",
      "label": "models.user.firstname",
      "placeholder": "Andy"
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "lastname",
      "label": "models.user.lastname",
      "placeholder": "Kaufman"
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = $$v
      },
      expression: "lastName"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */
/***/ (function(module, exports) {

module.exports = {
	"de": {
		"long": {
			"day": "numeric",
			"hour": "numeric",
			"minute": "numeric",
			"month": "short",
			"weekday": "short",
			"year": "numeric"
		},
		"short": {
			"day": "2-digit",
			"month": "2-digit",
			"year": "2-digit"
		}
	}
};

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

module.exports = {
	"en": {
		"long": {
			"day": "numeric",
			"hour": "numeric",
			"minute": "numeric",
			"month": "short",
			"weekday": "short",
			"year": "numeric"
		},
		"short": {
			"day": "2-digit",
			"month": "2-digit",
			"year": "2-digit"
		}
	}
};

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

module.exports = {
	"de": {
		"errors": {
			"contact": {
				"not_found": "Dieser Kontakt existiert nicht"
			},
			"plans": {
				"free_trial": {
					"expired_title": "Ihre kostenfreie Testversion ist abgelaufen.",
					"expired_description": "Bitte klicken Sie auf den Button unten, um mit uns Kontakt aufzunehmen und Fanomena Leads weiterhin zu nutzen.",
					"expired_button": "Vertrieb Kontaktieren"
				},
				"not_allowed_modal": {
					"title": "Erweitern Sie Ihren Leistungsumfang.",
					"description": "Die von Ihnen gewählte Funktion ist in Ihrem aktuellen Leistungsumfang nicht verfügbar. Bitte kontaktieren Sie uns über den Chat oder über den untenstehenden Link und wechseln Sie ins nächste Paket.",
					"button": "Vertrieb Kontaktieren"
				},
				"not_found": "Bitte wählen Sie ein Paket."
			},
			"api_error_modal": {
				"no_name": "Kein Name",
				"select_company": "Wählen Sie das Unternehmen für Ihren Lead aus"
			},
			"emailtemplate": {
				"name": {
					"invalid": "Bitte trag einen Namen ein"
				},
				"body": {
					"invalid": "Bitte trag einen Text ein"
				}
			},
			"externalform": {
				"name": {
					"invalid": "Bitte trag einen Namen ein"
				},
				"language": {
					"invalid": "Bitte wähle eine Sprache"
				},
				"project_id": {
					"invalid": "Bitte wählen Sie ein Projekt aus"
				}
			},
			"users": {
				"xls_import": {
					"wrong_file": "Bitte wähle eine gültige Datei"
				}
			},
			"organization": {
				"name": {
					"valid": "Bitte trag einen Namen ein"
				}
			},
			"authentication": {
				"empty_firstname": "Der Vorname ist leer. Bitte trag ein Vorname ein.",
				"empty_lastname": "Der Nachname ist leer. Bitte trag ein Nachname ein.",
				"empty_password": "Das Passwort ist leer. Bitte trag ein Passwort ein.",
				"logout": "Danke, dass Du Fanomena Leads benutzt hast. Bis bald.",
				"unauthorized": "Falsche Benutzername/Passwort Kombination! Der Benutzer konnte nicht angemeldet weden.",
				"wrong_email": "Das Format der E-Mail ist falsch",
				"wrong_jwt": "Deine Anmeldung ist abgelaufen. Bitte logge Dich erneut ein.",
				"wrong_password": "Das eingetragene Passwort ist ungültig. Bitte trage mindestens 8 Zeichen ein, wovon mindestens ein Buchstabe und eine Zahl enthalten sein muss.",
				"wrong_password_confirmation": "Die Passwörter stimmen nicht überein.",
				"please_contact_fanomena": "Es tut uns Leid aber es gibt ein Problem mit Ihrem Zugang. Bitte kontaktieren Sie Fanomena."
			},
			"base_score_error": "Die Basisbewertung sollte nur Zahlen enthalten",
			"compatibility": {
				"webcam": {
					"ios": "iPhone unterstützt die webcam API nicht. Bitte lade ein Bild aus Deiner Gallerie hoch.",
					"safari": "Vielen Dank für die Nutzung von Fanomena Leads. Für die beste Nutzung des Produkts zur Erfassung neuer Leads empfehlen wir unsere mobile App. Alternativ können Sie auch mit dem Browser Google Chrome fortfahren.",
					"firefox": "Vielen Dank für die Nutzung von Fanomena Leads. Bitte nutzen Sie als Browser Google Chrome, damit Sie auf alle Funktionalitäten von Fanomena Leads zugreifen können."
				}
			},
			"external_form": {
				"json": {
					"invalid": "Das json-Format ist ungültig."
				}
			},
			"lead": {
				"duplicate_email": "Diese E-Mail existiert bereits.",
				"email": {
					"empty": " ",
					"invalid": "",
					"taken": "Diese E-Mail Adresse existiert bereits"
				},
				"phone_company": {
					"invalid": "Ungültiges Format der Telefonnummer"
				},
				"wrong_tag_format": "Ein Tag kann nur aus Buchstaben und Zahlen bestehen."
			},
			"lead_mask": {
				"json": {
					"invalid": "Das json-Format ist ungültig."
				},
				"missing_elements": {
					"firstname": "Ihr Berichtsbogen hat kein \"Vorname\" Feld. Bitte fügen Sie es hinzu.",
					"lastname": "Ihr Berichtsbogen hat kein \"Nachname\" Feld. Bitte fügen Sie es hinzu.",
					"email": "Ihr Berichtsbogen hat kein \"E-Mail\" Feld. Bitte fügen Sie es hinzu."
				},
				"missing_values": "Ein Feld in Ihrem Berichtsbogen hat keine zusätzlichen Werte. Bitte fügen Sie mindestens eins hinzu."
			},
			"leadmask": {
				"name": {
					"invalid": "Bitte einen Namen eingeben"
				},
				"language": {
					"invalid": "Bitte gib eine Sprache an"
				}
			},
			"project": {
				"category": {
					"invalid": "Die Kategorie ist ungültig"
				},
				"end_date": {
					"invalid": "Das Enddatum ist ungültig"
				},
				"name": {
					"invalid": "Name ist ungültig"
				},
				"start_date": {
					"invalid": "Das Startdatum ist ungültig"
				},
				"not_found": "Das gesuchte Projekt konnte nicht gefunden werden",
				"lead_mask_id": {
					"invalid": "Bitte wähle einen Berichtsbogen"
				}
			},
			"server_unreachable": "Der Server antwortet nicht",
			"unauthorized": "Die Seite die Du aufrufen willst ist für Dich gesperrt.",
			"token": {
				"invalid": "Dein Anmelde-Token ist ungültig oder abgelaufen"
			},
			"user": {
				"duplicate_email": "Diese E-Mail Adresse ist bereits registriert. Bitte wähle eine andere E-Mail.",
				"email": {
					"empty": "Die E-Mail Adresse fehlt",
					"invalid": "Die E-Mail Adresse ist ungültig"
				},
				"organization": {
					"invalid_plan": "Der Plan dieser Organisation ist ungültig oder abgelaufen."
				},
				"xls_import": {
					"wrong_file": "Diese Datei kann nicht verwendet werden"
				}
			}
		},
		"eventbaxx_event": {
			"association_mismatch": "Fehlercode'eventbaxx_event.association_mismatch'. Bitte kontaktieren unser Kundendienstteam.",
			"lead": {
				"email": {
					"invalid": "Das Business Kit kann nicht gesendet werden weil die E-Mailadresse fehlerhaft ist"
				}
			}
		}
	}
};

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

module.exports = {
	"en": {
		"errors": {
			"contact": {
				"not_found": "The contact you are looking for does not exist"
			},
			"plans": {
				"free_trial": {
					"expired_title": "Your free trial has expired.",
					"expired_description": "Your Fanomena account has been paused, but will be reactivated once you upgrade your plan. Please click the button below to contact us and continue using Fanomena.",
					"expired_button": "Contact Sales"
				},
				"not_allowed_modal": {
					"title": "Please upgrade your plan.",
					"description": "The feature that you have selected is not available in your current plan. Please contact us via Intercom chat or through the link below to connect with a member of our team who can assist in upgrading your existing plan at Fanomena.",
					"button": "Contact Sales"
				},
				"not_found": "Please select a plan."
			},
			"api_error_modal": {
				"no_name": "No name",
				"select_company": "Select a company",
				"select_company_caption": "The following companies match with the domoain of the email. Please select one to continue"
			},
			"emailtemplate": {
				"name": {
					"invalid": "Please enter a name"
				},
				"body": {
					"invalid": "Please enter a body text"
				}
			},
			"externalform": {
				"name": {
					"invalid": "Please enter a name"
				},
				"language": {
					"invalid": "Please select a language"
				},
				"project_id": {
					"invalid": "Please select a project"
				}
			},
			"users": {
				"xls_import": {
					"wrong_file": "Please select a valid file"
				}
			},
			"organization": {
				"name": {
					"valid": "Please enter a name"
				}
			},
			"wrong_email_format": "The email is incorrect",
			"authentication": {
				"empty_firstname": "The first name is empty. Please enter a first name.",
				"empty_lastname": "The last name is empty. Please enter a last name.",
				"empty_password": "The password is empty. Please enter a password.",
				"logout": "Thank you for using Fanomena Leads, see you soon",
				"unauthorized": "Incorrect user/password combination! Could not authenticate user!",
				"wrong_email": "The email format is incorrect.",
				"wrong_jwt": "Your authentification credentials expired, please login again",
				"wrong_password": "The password is not valid. Must contain at least 8 characters, one letter and one number.",
				"wrong_password_confirmation": "The passwords do not match.",
				"please_contact_fanomena": "We're sorry but there is an issue with your account. Please contact Fanomena for help."
			},
			"base_score_error": "Base score should only contain numbers",
			"compatibility": {
				"webcam": {
					"ios": "iPhone doesn't support the webcam API. Please upload a picture from your gallery.",
					"safari": "Thank you for using Fanomena Leads. For full use of the product to capture new leads please download our mobile app or switch your browser to Google Chrome.",
					"firefox": "Thank you for using Fanomena Leads. Please switch your browser to Google Chrome for full use of the product to capture new leads."
				}
			},
			"external_form": {
				"json": {
					"invalid": "The json format is invalid."
				}
			},
			"lead": {
				"duplicate_email": "This email already exists",
				"email": {
					"empty": " ",
					"invalid": "The email is invalid",
					"invalid_domain": "The email domain is invalid",
					"taken": "This email address is already taken"
				},
				"phone_company": {
					"invalid": "Invalid phone number format"
				},
				"wrong_tag_format": "A tag can only contains letters and numbers"
			},
			"lead_mask": {
				"json": {
					"invalid": "The json format is invalid."
				},
				"missing_elements": {
					"firstname": "Your lead sheet is missing the \"firstname\" field. Please add it.",
					"lastname": "Your lead sheet is missing the \"lastname\" field. Please add it.",
					"email": "Your lead sheet is missing the \"email\" field. Please add it."
				},
				"missing_values": "One of your lead sheet fields is missing additional values. Please add at least one."
			},
			"leadmask": {
				"name": {
					"invalid": "Please add a name"
				},
				"language": {
					"invalid": "Please add a language"
				}
			},
			"project": {
				"category": {
					"invalid": "The category is invalid"
				},
				"end_date": {
					"invalid": "The end date is invalid"
				},
				"name": {
					"invalid": "Name is invalid"
				},
				"start_date": {
					"invalid": "The start date is invalid"
				},
				"not_found": "The project you were looking for could not be found",
				"lead_mask_id": {
					"invalid": "Please select a lead sheet"
				}
			},
			"server_unreachable": "The server does not respond",
			"token": {
				"invalid": "The token is invalid or expired."
			},
			"unauthorized": "The page you're trying to access is unauthorized",
			"user": {
				"duplicate_email": "The email is already registered. Please choose another.",
				"organization": {
					"invalid_plan": "The plan of this organization is either invalid or expired."
				},
				"email": {
					"empty": "The email is empty",
					"invalid": "The email is invalid"
				},
				"xls_import": {
					"wrong_file": "This file can't be used for user import."
				}
			}
		},
		"eventbaxx_event": {
			"association_mismatch": "Error-code 'eventbaxx_event.association_mismatch'. Please contact our customer support team.",
			"lead": {
				"email": {
					"invalid": "The businesskit cannot be sent because this lead's email address is not valid"
				}
			}
		}
	}
};

/***/ }),
/* 2028 */
/***/ (function(module, exports) {

module.exports = {
	"de": {
		"models": {
			"duplicate_action": "Duplizieren",
			"edit_action": "Editieren",
			"delete_action": "Löschen",
			"auth": {
				"remember_me": "Für 7 Tage angemeldet bleiben"
			},
			"business_kit": {
				"action": "",
				"date": "Datum",
				"fail": "Das Versenden des Businesskits ist fehlgeschlagen",
				"id": "id",
				"name": "Name",
				"select": "BusinessKit",
				"sent": "Dein Businesskit wurde verschickt",
				"create_template": "Template erstellen",
				"status": {
					"email_sent": "Gesendet",
					"sendout_enqueued": "Gesendet",
					"transferred": "Übermittelt"
				},
				"missing": {
					"email": "Versenden fehlgeschlagen. Möglicherweise musst Du erst ein Businesskit-E-Mail-Template erstellen bevor Du dieses Businesskit verschicken kannst."
				}
			},
			"external_form": {
				"action": "Aktion",
				"configuration": "Konfiguration",
				"additional_data": "Erweiterte Daten",
				"email_recipient_address": "Schicke an",
				"id": "#",
				"language": "Sprache",
				"message": {
					"create": "Das Formular wurde erfolgreich erstellt",
					"update": "Das Formular wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"project_id": "Projekt",
				"project_name": "Projekt",
				"project__name": "Projekt",
				"slug": "ID",
				"structure": "Struktur",
				"title": "Formular Titel",
				"duplicate": "",
				"duplicate_desc": "Formular duplizieren",
				"duplicate_project_desc": "Projekt duplizieren"
			},
			"lead_mask": {
				"action": "Aktion",
				"default": "Standard Berichtsbogen?",
				"yes": "Ja",
				"no": "Nein",
				"id": "#",
				"language": "Sprache",
				"message": {
					"create": "Die Berichtsbogen wurde erfolgreich erstellt.",
					"update": "Die Berichtsbogen wurde erfolgreich aktualisiert."
				},
				"name": "Name",
				"project_id": "Projekt",
				"organization": "Organisation",
				"organization_name": "Organisation",
				"project": "Projekt",
				"slug": "Slug",
				"structure": "Struktur",
				"duplicate": "",
				"duplicate_desc": "Berichtsbogen duplizieren"
			},
			"opt-in": {
				"businesskit__name": "Businesskit Name",
				"id": "#",
				"project__name": "Projekt Name",
				"subdomain": "Subdomain",
				"template_name": "Template Name"
			},
			"organization": {
				"action": "",
				"action_delete": "",
				"city": "Stadt",
				"country": "Land",
				"id": "Id",
				"message": {
					"create": "Die Organisation wurde erfolgreich erstellt",
					"update": "Die Organisation wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"status": "",
				"street": "Straße",
				"street_number": "Hausnummer",
				"users__count": "Benutzer",
				"website": "Webseite",
				"zip": "PLZ"
			},
			"organizations": {
				"successfully_started_crm_sync": "CRM Synchronisation erfolgreich gestartet"
			},
			"project": {
				"action": "Aktion",
				"background_xml_export_enabled": "Leads App Synchronisation aktivieren",
				"base_score": "Basisbewertung",
				"business_kits_count": "Businesskits",
				"businesskit_to_assign": "Businesskit zuweisen",
				"enable_lead_review": "Aktiviere manuellen Review von Leads aus der Leads App",
				"scope_leads": "Benutzer können nur ihre eigenen Leads sehen",
				"category": "Kategorie",
				"crm_campaign_id": "CRM Kampagnen ID",
				"crm_sales_employee_id": "CRM Vertriebsmitarbeiter ID",
				"crm_marketing_employee_id": "CRM Marketingmitarbeiter ID",
				"crm_group_code_id": "CRM Gruppencode ID",
				"end_date": "Enddatum der Kampagne",
				"hot_leads_count": "Heiße Leads",
				"id": "#",
				"is_opt_in": "Ist Opt-In?",
				"lead_mask": "Berichtsbogen",
				"lead_mask_id": "Wähle einen vorhandenen Berichtsbogen aus",
				"leads_count": "Leads",
				"product": "Product",
				"leads_not_synced_count": "Pending Leads",
				"location": "Ort",
				"mailchimp_list_id": "Mailchimp-Liste ID",
				"message": {
					"create": "Das Projekt wurde erfolgreich erstellt",
					"update": "Das Projekt wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"organization": "Organisation",
				"organization_name": "Organisation",
				"period": "Zeitraum",
				"set_aditional_data_content": "Zusätzliche Daten anzeigen und einstellen",
				"start_date": "Startdatum der Kampagne",
				"sync_disabled": "CRM Syncronisation",
				"unsynced_leads_count": "Sync Status",
				"user_to_assign": "Benutzer zuweisen",
				"unsynced_leads_count_success": "Synchronisiert",
				"duplicate": "",
				"default_classification": "Standard-Klassifizierung",
				"business_kit_id": "Businesskits",
				"project_label": "Projekt-Label"
			},
			"project_lead": {
				"academic_title": "Titel",
				"action": "Aktion",
				"advancement": "Fortschritt",
				"branch": "Zielgruppe",
				"business_card_job_title": "Job-Titel",
				"capturer": "Erfasser",
				"capturer_unknown": "Nicht zugeordnet",
				"city": "Stadt",
				"classification": "Klassifizierung",
				"company": "Firma",
				"company-name": "Firmenname",
				"company_department": "Abteilung",
				"company_function": "Funktion",
				"company_role": "Rolle",
				"company_website": "Firmen-Webseite",
				"conversation_notes": "Notizen",
				"country": "Land",
				"crawled_infos": {
					"by": "von",
					"founded": "Gegründet",
					"linkedin": "LinkedIn Profil",
					"more_infos": "Mehr Informationen",
					"phone_number": "Telefonnummer",
					"tags": "Tags",
					"title_website": "Titel der Webseite",
					"tweets": "Tweets",
					"category": "Kategoien",
					"description": "Beschreibung",
					"domain": "Webseite",
					"emailAddresses": "E-Mails",
					"foundedYear": "Gegründet",
					"location": "Location",
					"metrics": "Metrics",
					"name": "Firmenname",
					"phoneNumbers": "Telefonnummern"
				},
				"found_existing": "Wir haben bereits existierende Daten für diesen Lead gefunden und diese übernommen.",
				"predicted_name": "Basierend auf der E-Mail Adresse konnten wir bereits Daten zum Kontakt ermitteln.",
				"created": "Der Lead wurde erfolgreich erstellt.",
				"created_at": "Erstellt",
				"email": "E-Mail",
				"exhibition_visitor_count": "Anzahl Messebesucher",
				"firstname": "Vorname",
				"full_street": "Straße & Nr",
				"gender": "Anrede",
				"id": "#",
				"import_origin": "",
				"interested_in": "Interessiert an",
				"kit_status": "",
				"language": "Sprache",
				"lastname": "Nachname",
				"message": {
					"changes_pending": "Es gibt Änderungen. Zuletzt gespeichert",
					"changes_saved": "Letzte Änderungen:",
					"create": "Der Lead wurde erfolgreich erstellt",
					"create_from_card": "Visitenkarte scannen",
					"create_from_email": "E-Mail Adresse eintragen",
					"leads_exists": "Der Lead existiert bereits aber er wurde zum aktuellen Projekt hinzugefügt",
					"no_business_card": "Keine Visistenkarte hochgeladen",
					"update": "Der Lead wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"origin": "",
				"phone_company": "Firmen-Telefon",
				"phone_mobile": "Mobiltelefon",
				"progress_complete": "Alle Pflichtfelder wurden ausgefüllt",
				"progress_indicator_businesskit": "Fortschritt",
				"progress_indicator_crm": "Status",
				"progress_indicator_lead_mask": "Status",
				"project_planned": "Projekt geplant",
				"salutation": "Ansprasche",
				"start_date": "Erstellt am",
				"status": "Status",
				"street": "Straße",
				"street_number": "Nummer",
				"sync_disabled": "CRM Sync",
				"sync_status": "CRM",
				"sync_statuses": {
					"no_crm": "Kein CRM konfiguriert",
					"no_crm_desc": "Die Organisation hat kein CRM konfiguriert",
					"not_sync_ready": "Nicht bereit",
					"not_sync_ready_desc": "Der Lead hat nicht alle für den CRM Sync notwendigen Felder ausgefüllt",
					"not_synced": "Nicht synchronisiert",
					"not_synced_desc": "Der Lead wurde aus dem CRM importiert aber noch nicht bearbeitet.",
					"processing": "Synchronisiere",
					"processing_desc": "Der Lead synchronisiert gerade",
					"sync_disabled": "Deaktiviert",
					"sync_disabled_desc": "Der Lead ist bereit zum Synchronisieren aber die Lead Synchronisation ist deaktiviert",
					"sync_error": "Fehler",
					"sync_error_desc": "Die Lead Synchronisation hat zu einem Fehler geführt",
					"sync_ready": "Bereit",
					"sync_ready_desc": "Der Lead ist bereit zum Synchronisieren",
					"synced": "Synchronisiert",
					"synced_desc": "Der Lead wurde synchronisiert"
				},
				"title": "Titel",
				"updated_at": "Letzte Bearbeitung",
				"user_id": "Lead-Erfasser",
				"zip": "PLZ",
				"import_origins": {
					"crm": "Vom CRM importiert"
				},
				"origins": {
					"mobile_app": "Via App",
					"web_app": "Via Cloud"
				},
				"sync_missing_fields": "Unvollständige Werte:"
			},
			"select_role": {
				"user": "Standard Benutzer",
				"admin": "Administrator"
			},
			"select_status": {
				"pre_review": "Pre Review",
				"review": "Überarbeitung",
				"active": "Akzeptiert"
			},
			"select_academic_title": {
				"ba": "Ba",
				"dr": "Dr",
				"mba": "MBA",
				"phd": "PhD",
				"prof": "Prof.",
				"prof_dr": "Prof. Dr."
			},
			"select_background_xml_export_enabled": {
				"false": "Nein",
				"no": "Nein",
				"true": "Ja",
				"yes": "Ja"
			},
			"select_branch": {
				"automotive": "Automotive",
				"culture": "Kultur",
				"education": "Bildung",
				"electronics": "Electronil",
				"event": "Event",
				"finance": "Finanzen",
				"food": "Gastro",
				"health": "Gesundheit",
				"import": "Import",
				"insurance": "Versicherungen",
				"it": "IT",
				"law": "Recht",
				"marketing": "Marketing",
				"non_profit": "Non profit",
				"other": "Andere",
				"print": "Druck",
				"public": "Öffentlicht",
				"real_estate": "Real estate",
				"service": "Service"
			},
			"select_category": {
				"exhibition": "Messe",
				"inbound": "Inbound",
				"other": "Andere"
			},
			"select_scope": {
				"organization": "Organisation",
				"project": "Projekt"
			},
			"select_frequency": {
				"daily": "Täglich",
				"immediately": "Stündlich",
				"once": "Nur einmal"
			},
			"select_classification": {
				"cold": "Kalt",
				"hot": "Heiß",
				"warm": "Warm",
				"unclassified": "–"
			},
			"select_default_classification": {
				"cold": "Kalt",
				"hot": "Heiß",
				"warm": "Warm",
				"unclassified": "–"
			},
			"select_company_department": {
				"finance": "Finanzen",
				"human_resources": "Human Resources",
				"it": "IT",
				"marketing": "Marketing",
				"other": "Andere",
				"sales": "Verkauf",
				"secretariat": "Sekretariat",
				"service_management": "Service Management"
			},
			"select_company_function": {
				"CEO": "Vorstandschef",
				"consultant": "Berater",
				"head_of": "Abteilungsleiter",
				"manager": "Manager",
				"managing_director": "Geschäftsführung",
				"other": "Other",
				"person_in_charge": "Sachbearbeiter"
			},
			"select_company_role": {
				"decision_maker": "Entscheider",
				"decision_maker_budget": "Entscheider mit Budget",
				"non_decision_maker": "Kein Entscheider",
				"other": "Andere"
			},
			"select_gender": {
				"female": "Weiblich",
				"male": "Männlich",
				"undefined": "-"
			},
			"select_importOrigin": {
				"crm": "CRM",
				"xls": "XLS"
			},
			"select_interested_in": {
				"meeting": "Meeting",
				"other": "Andere",
				"presentation": "Präsentation",
				"pricing": "Preise",
				"product_informations": "Produkt Information"
			},
			"select_is_opt_in": {
				"false": "Nein",
				"no": "Nein",
				"true": "Ja",
				"yes": "Ja"
			},
			"select_language": {
				"de": "Deutsch",
				"en": "Englisch"
			},
			"select_origin": {
				"mobile_app": "Lead App",
				"opt_in_email": "Opt-in email",
				"opt_in_linked_in": "Opt-in linkedin",
				"opt_in_xing": "Opt-in xing",
				"web_app": "Cloud",
				"external_form": "External Form"
			},
			"select_project_planned": {
				"0-3months": "0-3 Monate",
				"3-6months": "3-6 Monate",
				"6-12months": "6-12 Monate",
				"no_plan": "Nichts geplant"
			},
			"select_sync_disabled": {
				"false": "Aktiviert",
				"no": "Aktiviert",
				"true": "Deaktiviert",
				"yes": "Deaktiviert"
			},
			"select_sync_status": {
				"no_crm": "Kein CRM",
				"not_sync_ready": "Nicht 100%",
				"not_synced": "Unbearbeitet",
				"processing": "Gestartet",
				"sync_error": "Fehler",
				"sync_ready": "100%",
				"synced": "Erfolgreich"
			},
			"tracking": {
				"activity": "Ereignis",
				"date": "Datum",
				"kit": "Kit",
				"specific": {
					"confirm_redeem_coupon": "Klick auf Einlöse-Button",
					"click_event_pdf": "Klick auf Businesskit PDF",
					"cta_coupon": "Klick auf Content CTA",
					"embed_visit_url": "Webseite URL tracking",
					"open_bag": "Businesskit geöffnet",
					"view_coupon": "Inhalt angesehen",
					"view_website": "CTA geklickt",
					"view_website_coupon": "Klick auf 'Webseite ansehen'",
					"visit_website": "Webseite besucht",
					"toggle_event_info": "Klick auf Businesskit Mehr Informationen"
				}
			},
			"plan": {
				"id": "ID",
				"name": "Name",
				"price": "Preis",
				"organizations_count": "Organisationen",
				"action": "Actions",
				"max_users": "Maximale Benutzer",
				"max_admins": "Maximale Admins",
				"max_businesskits": "Maximale Businesskits",
				"message": {
					"update": "Plan erfolgreich aktualisiert"
				},
				"allowed_forms": "Formulare erlaubt",
				"allowed_statistics": "Statistiken erlaubt",
				"allowed_custom_leadsheets": "Angepasste Berichtsbögen erlaubt",
				"allowed_email_templates": "Angepasste E-Mail Templates erlaubt",
				"allowed_clearbit": "Clearbit Benutzung erlaubt",
				"allowed_crm": "CRM Nutzung erlaubt",
				"allowed_api": "API Nutzung erlaubt",
				"allowed_eb_whitelabel": "Benutzerdefiniertes eventbaxx Whitelabel erlaubt",
				"allowed_lead_pdf_download": "PDF Download für Leads erlaubt"
			},
			"user": {
				"action": "Aktion",
				"email": "E-Mail",
				"firstname": "Vorname",
				"id": "id",
				"invite-role": "Rolle",
				"lastname": "Nachname",
				"fullname": "Voller Name",
				"edit_user": "Benutzer bearbeiten",
				"role": "Rolle",
				"message": {
					"create": "Der Benutzer wurde erfolgreich erstellt",
					"update": "Der Benutzer wurde erfolgreich aktualisisert"
				},
				"organization_id": "Organisation",
				"organization": "Organisation",
				"organization_name": "Organisation",
				"password": "Passwort",
				"status": "Status",
				"created_at": "Datum",
				"name": "Name",
				"statuses": {
					"active": "Akzeptiert",
					"confirmed": "Akzeptiert",
					"inactive": "Inaktiv",
					"unconfirmed": "Unbestätigt",
					"pending": "Pending",
					"review": "Überarbeitung",
					"pre_review": "Pre Review"
				}
			},
			"select_type": {
				"title_h1": "H1 Titel",
				"title_h2": "H2 Titel",
				"title_h3": "H3 Titel",
				"title_h4": "H4 Titel",
				"image": "Bild",
				"paragraph": "Paragraph",
				"hidden": "Hidden field",
				"text": "Text field",
				"textarea": "Textarea",
				"select": "Select field",
				"radio": "Radio field",
				"radio_custom": "Radio custom field",
				"checkbox": "Checkbox field",
				"checkbox_custom": "Checkbox custom field",
				"country_select": "Country select field",
				"confirmation": "Confirmation field",
				"free_drawing": "Zeichnung",
				"submit": "Submit",
				"container": "Container",
				"container_grid": "Grid container",
				"container_top": "Container top",
				"container_bottom": "Container bottom",
				"container_tab": "Container tab",
				"crawled_infos": "Crawled Infos"
			},
			"email_template": {
				"id": "",
				"name": "Name",
				"language": "Sprache",
				"action": "Aktion",
				"organization": "Organisation",
				"body": "Inhalt",
				"salutation": "Ansprache",
				"salutation_fallback": "Fallback Ansprache",
				"from": "E-Mail Von",
				"reply_to": "Antwort an",
				"imprint_url": "Impressum URL",
				"privacy_url": "Datenschutz URL",
				"primary_color": "Primärfarbe",
				"message": {
					"create": "Das E-Mail Template wurde erfolgreich erstellt.",
					"update": "Das E-Mail Template wurde erfolgreich aktualisiert."
				},
				"duplicate": "",
				"duplicate_desc": "E-Mail Template duplizieren"
			},
			"organization_configuration": {
				"api_token_eventbaxx": "Eventbaxx api token",
				"enrichment_disabled": "Clearbit enrichment",
				"mailchimp_api_key": "Mailchimp api key",
				"ranking_display": "Zeige das Lead-Hunter Ranking?",
				"xing_consumer_key": "Xing consumer key",
				"eventbaxx_auth_token": "Eventbaxx authentication key"
			},
			"workflow": {
				"id": "ID",
				"name": "Name",
				"status": "Status",
				"last_execution": "Letzte Ausführung",
				"frequency": "Frequenz",
				"first_run": "Erste Ausführung (UTC)",
				"final_run": "Finale Ausführung (UTC)",
				"daily_runtime": "Uhrzeit (UTC)",
				"action": "Aktion",
				"project": "Projekt",
				"project_name": "Projekt",
				"execute_on": "Bedingung",
				"configuration": "Konfiguration",
				"scope": "Berücksichtige Leads aus:",
				"loading_projects": "Projekte werden geladen…",
				"message": {
					"create": "Workflow erfolgreich erstellt",
					"trigger_success": "Workflow erfolgreich ausgeführt",
					"update": "Workflow erfolgreich aktualisiert"
				},
				"collection": {
					"frequency": {
						"daily": "Täglich",
						"immediately": "Stündlich",
						"once": "Einmalig",
						"undefined": "–"
					}
				}
			}
		}
	}
};

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

module.exports = {
	"en": {
		"models": {
			"duplicate_action": "Duplicate",
			"edit_action": "Edit",
			"delete_action": "Delete",
			"add_to_project": {
				"select": "Select Project"
			},
			"select_type": {
				"title_h1": "H1 title",
				"title_h2": "H2 title",
				"title_h3": "H3 title",
				"title_h4": "H4 title",
				"image": "Image",
				"paragraph": "Paragraph",
				"hidden": "Hidden field",
				"text": "Text field",
				"textarea": "Textarea",
				"select": "Select field",
				"radio": "Radio field",
				"radio_custom": "Radio custom field",
				"checkbox": "Checkbox field",
				"checkbox_custom": "Checkbox custom field",
				"country_select": "Country select field",
				"confirmation": "Confirmation field",
				"free_drawing": "Free drawing",
				"submit": "Submit",
				"container": "Container",
				"container_grid": "Grid container",
				"container_top": "Container top",
				"container_bottom": "Container bottom",
				"container_tab": "Container tab",
				"crawled_infos": "Crawled info",
				"read_only": "Read only"
			},
			"select_role": {
				"user": "Standard user",
				"admin": "Administrator"
			},
			"select_status": {
				"pre_review": "Pre Revision",
				"review": "Needs revision",
				"active": "Accepted"
			},
			"select_frequency": {
				"daily": "Daily",
				"immediately": "Every hour",
				"once": "Only once"
			},
			"select_scope": {
				"organization": "Organization",
				"project": "Project"
			},
			"auth": {
				"remember_me": "Stay logged 7 days"
			},
			"business_kit": {
				"action": "",
				"date": "Date",
				"fail": "The sending of the Businesskit failed",
				"id": "id",
				"name": "Name",
				"select": "BusinessKit",
				"sent": "Your Businesskit has been sent",
				"create_template": "Create template",
				"status": {
					"email_sent": "Sent",
					"sendout_enqueued": "Sent",
					"transferred": "Transferred"
				},
				"missing": {
					"email": "Sending failed. You probably have to create an email template before sending the Businesskit."
				}
			},
			"external_form": {
				"action": "Actions",
				"additional_data": "Additional data",
				"configuration": "Configuration",
				"email_recipient_address": "Send to",
				"id": "#",
				"language": "Language",
				"message": {
					"create": "The form has been added successfully",
					"update": "The form has been updated successfully"
				},
				"name": "Name",
				"project_id": "Project",
				"project_name": "Project",
				"project__name": "Project",
				"slug": "ID",
				"structure": "Structure",
				"duplicate": "",
				"duplicate_desc": "Duplicate the form",
				"duplicate_project_desc": "Duplicate the project",
				"title": "Form title"
			},
			"email_template": {
				"id": "",
				"name": "Name",
				"language": "Language",
				"duplicate": "",
				"action": "Actions",
				"organization": "Organization",
				"body": "Email content",
				"salutation": "Salutation",
				"salutation_fallback": "Fallback salutation",
				"from": "Email from",
				"reply_to": "Reply to",
				"imprint_url": "Imprint url",
				"privacy_url": "Privacy url",
				"primary_color": "Primary color",
				"message": {
					"create": "The email template was successfully created.",
					"update": "The email template was successfully updated."
				},
				"duplicate_desc": "Duplicate email template"
			},
			"lead_mask": {
				"action": "Actions",
				"default": "Default mask ?",
				"yes": "Yes",
				"no": "No",
				"id": "#",
				"language": "Language",
				"message": {
					"create": "The lead sheet was successfully created.",
					"update": "The lead sheet was successfully updated."
				},
				"name": "Name",
				"project_id": "Project",
				"organization": "Organization",
				"organization_name": "Organization",
				"project": "Project",
				"slug": "Slug",
				"structure": "Structure",
				"duplicate": "",
				"duplicate_desc": "Duplicate lead sheet"
			},
			"opt-in": {
				"businesskit__name": "Businesskit name",
				"id": "#",
				"project__name": "Project name",
				"subdomain": "Subdomain",
				"template_name": "Template name"
			},
			"organization": {
				"action": "",
				"action_delete": "",
				"city": "City",
				"country": "Country",
				"id": "Id",
				"message": {
					"create": "The organization has been added successfully",
					"update": "The organization has been updated successfully"
				},
				"name": "Name",
				"status": "",
				"street": "Street",
				"street_number": "Street number",
				"users__count": "Users",
				"website": "Website",
				"zip": "Zip code"
			},
			"organization_configuration": {
				"api_token_eventbaxx": "Eventbaxx api token",
				"enrichment_disabled": "Clearbit enrichment",
				"mailchimp_api_key": "Mailchimp api key",
				"ranking_display": "Display the lead hunter rankings?",
				"xing_consumer_key": "Xing consumer key",
				"eventbaxx_auth_token": "Eventbaxx authentication key"
			},
			"organizations": {
				"successfully_started_crm_sync": "CRM synchronisation successfully started"
			},
			"project": {
				"action": "Actions",
				"background_xml_export_enabled": "Enable Leads app synchronisation",
				"base_score": "Base score",
				"scope_leads": "Users can only view their own leads",
				"business_kits_count": "Businesskits",
				"businesskit_to_assign": "Assign a Businesskit",
				"category": "Category",
				"crm_campaign_id": "CRM campaign ID",
				"crm_sales_employee_id": "CRM sales employee ID",
				"crm_marketing_employee_id": "CRM marketing employee ID",
				"crm_group_code_id": "CRM group code foreign ID",
				"enable_lead_review": "Enable manual lead review from the Leads app",
				"end_date": "Campaign end date",
				"hot_leads_count": "Hot leads",
				"id": "#",
				"is_opt_in": "Is opt-in?",
				"lead_mask": "Lead sheet",
				"lead_mask_id": "Select an existing lead sheet",
				"leads_count": "Leads",
				"product": "Product",
				"leads_not_synced_count": "Pending leads",
				"location": "Location",
				"mailchimp_list_id": "Mailchimp list ID",
				"message": {
					"create": "The project has been added successfully",
					"update": "The project has been updated successfully"
				},
				"name": "Name",
				"organization": "Organization",
				"organization_name": "Organization",
				"organization_id": "Organization",
				"period": "Period",
				"set_aditional_data_content": "Show and set additional data",
				"start_date": "Campaign start date",
				"sync_disabled": "CRM synchronisation",
				"unsynced_leads_count": "Sync status",
				"unsynced_leads_count_success": "Synced",
				"user_to_assign": "Assign a user",
				"duplicate": "",
				"default_classification": "Default classification",
				"business_kit_id": "Businesskits",
				"project_label": "Project labels"
			},
			"project_lead": {
				"academic_title": "Title",
				"action": "Actions",
				"advancement": "Advancement",
				"branch": "Industry",
				"business_card_job_title": "Job title",
				"capturer": "Capturer",
				"capturer_unknown": "Unassigned",
				"city": "City",
				"classification": "Classification",
				"company": "Company",
				"company-name": "Company name",
				"company_department": "Department",
				"company_function": "Function",
				"company_role": "Role",
				"company_website": "Company website",
				"conversation_notes": "Notes",
				"country": "Country",
				"crawled_infos": {
					"by": "by",
					"category": "Categories",
					"description": "Description",
					"domain": "Website",
					"emailAddresses": "Emails",
					"foundedYear": "Founded",
					"linkedin": "Linkedin profile",
					"location": "Location",
					"metrics": "Metrics",
					"more_infos": "More information",
					"name": "Company name",
					"phoneNumbers": "Phone numbers",
					"phone_number": "Phone given in the web",
					"tags": "Tags",
					"title_website": "Title of the website",
					"tweets": "Tweets",
					"founded": ""
				},
				"found_existing": "We found some existing data for this lead and have applied it automatically.",
				"predicted_name": "We have automatically filled in some of your lead's data based on their email address.",
				"created": "Lead was successfully created.",
				"created_at": "Created",
				"email": "Email",
				"exhibition_visitor_count": "Exhibition visitor count",
				"firstname": "Firstname",
				"full_street": "Street & No.",
				"gender": "Gender",
				"id": "#",
				"import_origin": "",
				"import_origins": {
					"crm": "Imported from CRM"
				},
				"interested_in": "Interested in",
				"kit_status": "",
				"language": "Language",
				"lastname": "Lastname",
				"message": {
					"changes_pending": "There are pending changes. Last saved",
					"changes_saved": "Last changes:",
					"create": "The lead has been added successfully",
					"create_from_card": "Scan business card",
					"create_from_email": "Enter email address",
					"leads_exists": "The lead exists already but it has been added to the current project",
					"no_business_card": "No business card uploaded yet",
					"update": "The lead was been updated successfully"
				},
				"name": "Name",
				"origin": "",
				"origins": {
					"mobile_app": "Lead captured via mobile app",
					"web_app": "Lead captured via web app"
				},
				"phone_company": "Company phone",
				"phone_mobile": "Mobile phone",
				"progress_complete": "All required fields have been filled",
				"progress_indicator_businesskit": "Progress",
				"progress_indicator_crm": "Progress",
				"progress_indicator_lead_mask": "Progress",
				"project_planned": "Project planned",
				"salutation": "Salutation",
				"start_date": "Created on",
				"status": "Status",
				"street": "Street",
				"street_number": "Number",
				"sync_disabled": "CRM sync",
				"sync_missing_fields": "Incomplete fields:",
				"sync_status": "CRM",
				"sync_statuses": {
					"no_crm": "No CRM configured",
					"no_crm_desc": "The organization doesn't have a CRM configured",
					"not_sync_ready": "Not ready",
					"not_sync_ready_desc": "The lead misses some fields required for CRM sync",
					"not_synced": "Unsynced",
					"not_synced_desc": "The lead has been imported from CRM but has not been modified",
					"null": "–",
					"processing": "Syncing",
					"processing_desc": "The lead is syncing right now",
					"sync_disabled": "Disabled",
					"sync_disabled_desc": "The lead is ready to be synchronized but the lead sync is disabled",
					"sync_error": "Error",
					"sync_error_desc": "The lead sync produced an error",
					"sync_ready": "Ready",
					"sync_ready_desc": "The lead is ready to be synchronized",
					"synced": "Synced",
					"synced_desc": "The lead has been synced"
				},
				"title": "Title",
				"updated_at": "Last updated",
				"user_id": "Lead detector",
				"zip": "ZIP"
			},
			"select_academic_title": {
				"ba": "Ba",
				"dr": "Dr",
				"mba": "MBA",
				"phd": "PhD",
				"prof": "Prof.",
				"prof_dr": "Prof. Dr."
			},
			"select_background_xml_export_enabled": {
				"false": "No",
				"no": "No",
				"true": "Yes",
				"yes": "Yes"
			},
			"select_branch": {
				"automotive": "Automotive",
				"culture": "Culture",
				"education": "Education",
				"electronics": "Electronics",
				"event": "Event",
				"finance": "Finance",
				"food": "Food / Gastro",
				"health": "Health",
				"import": "Import",
				"insurance": "Insurances",
				"it": "IT",
				"law": "Law",
				"marketing": "Marketing",
				"non_profit": "Non profit",
				"other": "Other",
				"print": "Print",
				"public": "Public",
				"real_estate": "Real estate",
				"service": "Service"
			},
			"select_category": {
				"exhibition": "Exhibition",
				"inbound": "Inbound",
				"other": "Other"
			},
			"select_classification": {
				"cold": "Cold",
				"hot": "Hot",
				"warm": "Warm",
				"unclassified": "–"
			},
			"select_default_classification": {
				"cold": "Cold",
				"hot": "Hot",
				"warm": "Warm",
				"unclassified": "–"
			},
			"select_company_department": {
				"finance": "Finance",
				"human_resources": "Human Resources",
				"it": "IT",
				"marketing": "Marketing",
				"other": "Other",
				"sales": "Sales",
				"secretariat": "Secretariat",
				"service_management": "Service Management"
			},
			"select_company_function": {
				"CEO": "CEO",
				"consultant": "Consultant",
				"head_of": "Head of department",
				"manager": "Manager",
				"managing_director": "Managing director",
				"other": "Other",
				"person_in_charge": "Person in charge"
			},
			"select_company_role": {
				"decision_maker": "Decision maker",
				"decision_maker_budget": "Decision maker with budget",
				"non_decision_maker": "Non decision maker",
				"other": "Other"
			},
			"select_gender": {
				"female": "Female",
				"male": "Male",
				"undefined": "-"
			},
			"select_importOrigin": {
				"crm": "CRM",
				"xls": "XLS"
			},
			"select_interested_in": {
				"meeting": "Meeting",
				"other": "Other",
				"presentation": "Presentation",
				"pricing": "Pricing",
				"product_informations": "Product information"
			},
			"select_is_opt_in": {
				"false": "No",
				"no": "No",
				"true": "Yes",
				"yes": "Yes"
			},
			"select_language": {
				"de": "German",
				"en": "English"
			},
			"select_origin": {
				"mobile_app": "Lead app",
				"opt_in_email": "Opt-in email",
				"opt_in_linked_in": "Opt-in linkedin",
				"opt_in_xing": "Opt-in xing",
				"web_app": "Cloud",
				"external_form": "External Form"
			},
			"select_project_planned": {
				"0-3months": "0-3 months",
				"3-6months": "3-6 months",
				"6-12months": "6-12 months",
				"no_plan": "No plan"
			},
			"select_sync_disabled": {
				"false": "Activated",
				"no": "Activated",
				"true": "Deactivated",
				"yes": "Deactivated"
			},
			"select_sync_status": {
				"no_crm": "No CRM configured",
				"not_sync_ready": "Not 100%",
				"not_synced": "Not edited",
				"processing": "Started",
				"sync_error": "Error",
				"sync_ready": "100%",
				"synced": "Successful"
			},
			"tracking": {
				"activity": "Action",
				"date": "Date",
				"kit": "Kit",
				"specific": {
					"confirm_redeem_coupon": "Click on redeem button",
					"click_event_pdf": "Click Businesskit PDF",
					"cta_coupon": "Click on content CTA",
					"embed_visit_url": "Website URL tracking",
					"open_bag": "Businesskit opened",
					"view_coupon": "Content viewed",
					"view_website": "Clicked on CTA",
					"view_website_coupon": "Clicked on 'visit website'",
					"visit_website": "Website visited",
					"toggle_event_info": "Click Businesskit more information"
				}
			},
			"plan": {
				"id": "ID",
				"name": "Name",
				"price": "Price",
				"organizations_count": "Organizations",
				"action": "Actions",
				"max_users": "Maximum users",
				"message": {
					"update": "Plan successfully updated"
				},
				"max_admins": "Maximum admins",
				"max_businesskits": "Maximum Businesskits",
				"allowed_forms": "Allowed form usage",
				"allowed_statistics": "Allowed statistics usage",
				"allowed_custom_leadsheets": "Allowed custom leadsheets",
				"allowed_email_templates": "Allowed custom email templates",
				"allowed_clearbit": "Allowed Clearbit usage",
				"allowed_crm": "Allowed CRM usage",
				"allowed_api": "Allowed API usage",
				"allowed_eb_whitelabel": "Allowed custom eventbaxx whitelabel",
				"allowed_lead_pdf_download": "Allowed PDF Download for leads"
			},
			"user": {
				"action": "Actions",
				"created_at": "Date",
				"email": "Email",
				"invite-role": "Role",
				"firstname": "First Name",
				"id": "id",
				"lastname": "Last Name",
				"fullname": "Full Name",
				"edit_user": "Edit user",
				"role": "Role",
				"has_valid_email": "validation",
				"message": {
					"create": "The user has been added successfully",
					"update": "The user has been updated successfully"
				},
				"name": "Name",
				"organization": "Organization",
				"organization_id": "Organization",
				"organization_name": "Organization",
				"password": "Password",
				"status": "Status",
				"statuses": {
					"active": "Accepted",
					"confirmed": "Confirmed",
					"inactive": "Inactive",
					"unconfirmed": "Unconfirmed",
					"pending": "Pending",
					"review": "Needs revision",
					"pre_review": "Pre Revision",
					"statuses": {
						"active": "Active",
						"confirmed": "Confirmed",
						"inactive": "Inactive",
						"unconfirmed": "Unconfirmed",
						"pending": "Pending"
					}
				}
			},
			"workflow": {
				"id": "ID",
				"name": "Name",
				"status": "Status",
				"last_execution": "Last execution",
				"frequency": "Frequency",
				"first_run": "First run (UTC)",
				"final_run": "Final run (UTC)",
				"daily_runtime": "Daily runtime (UTC)",
				"action": "Action",
				"project": "Project",
				"project_name": "Project",
				"execute_on": "Condition",
				"configuration": "Configuration",
				"scope": "Retrieve leads from:",
				"loading_projects": "Loading projects…",
				"message": {
					"create": "Workflow successfully created",
					"trigger_success": "Workflow successfully triggered",
					"update": "Workflow successfully updated"
				},
				"collection": {
					"frequency": {
						"daily": "Daily",
						"immediately": "Hourly",
						"once": "Once",
						"undefined": "–"
					}
				}
			}
		}
	}
};

/***/ }),
/* 2030 */
/***/ (function(module, exports) {

module.exports = {
	"de": {
		"routes": {
			"project": "project",
			"projects": "projects",
			"project_leads": "leads"
		}
	},
	"en": {
		"routes": {
			"project": "project",
			"projects": "projects",
			"project_leads": "leads"
		}
	}
};

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

module.exports = {
	"de": {
		"statistics": {
			"24h_activity": "24h Aktivität",
			"7days_activity": "7 Tage Aktivität",
			"actions": "Aktionen",
			"activity": "Aktivität",
			"average_per_day": "Durchschnitt pro Tag",
			"businesskit_opened": "Eindeutige Businesskit-Öffnungen",
			"total_businesskit_opened": "Geöffnet",
			"businesskit_per_lead": "Businesskits pro Lead",
			"businesskit_sent": "Businesskits verschickt",
			"coupon": "Content card",
			"coupons": "Content cards",
			"coupons_opened": "Content-Cards geöffnet",
			"coupons_sent": "Content-Cards verschickt",
			"coupons_viewed": "Content Card Ansichten",
			"cta_clicked": "CTA geklickt",
			"day": "Tag",
			"days": "Tage",
			"get_back_to_lead": "Zurück zum Lead",
			"get_back_to_statistics": "Zurück zu den Statistiken",
			"hour": "Stunde",
			"hours": "Stunden",
			"kit_and_activity": "Kit & Aktivität",
			"kits": "Kits",
			"latest_trackings": "Letzte Aktivitäten",
			"lead_detectors_overview": "Lead-Hunter Übersicht",
			"lead_kit_and_activity": "Lead, Kit & Aktivität",
			"lead_statistics": "Lead-Trackings",
			"leads": "Leads",
			"leads_cold": "Kalt",
			"leads_hot": "Heiß",
			"leads_per_day": "Leads pro Tag",
			"leads_per_lead_detector": "Leads pro Lead-Hunter",
			"leads_warm": "Warm",
			"no_data": "Es gibt noch keine Daten. Versuche eine andere Zeitspanne.",
			"no_data_24_hours": "Es gibt keine Daten innerhalb der letzten 24h.",
			"no_data_7_days": "Es gibt keine Daten innerhalb der letzten 7 Tage.",
			"per_bk_opened": "pro geöffnetem Businesskit",
			"project_statistics": "Projekt Statistiken",
			"see_full_report": "Vollständiger Report ansehen",
			"see_full_statistics": "Siehe vollständige Statistiken",
			"see_full_tracking_history": "Siehe komplett Tracking Historie",
			"time_range": "Zeitspanne",
			"tracking_activity": "Aktivität",
			"tracking_kit": "Kit",
			"tracking_lead": "Lead",
			"tracking_time": "Zeit"
		}
	}
};

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

module.exports = {
	"en": {
		"statistics": {
			"24h_activity": "24h activity",
			"7days_activity": "7 days activity",
			"actions": "Actions",
			"activity": "Activity",
			"average_per_day": "Average per day",
			"businesskit_opened": "Unique Businesskits opened",
			"total_businesskit_opened": "Opened",
			"businesskit_per_lead": "Businesskits per lead",
			"businesskit_sent": "Businesskits sent",
			"coupon": "Content card",
			"coupons": "Content cards",
			"coupons_opened": "Content cards opened",
			"coupons_sent": "Content cards sent",
			"coupons_viewed": "Content Card views",
			"cta_clicked": "CTA clicked",
			"day": "Day",
			"days": "Days",
			"get_back_to_lead": "Back to lead",
			"get_back_to_statistics": "Back to statistics",
			"hour": "Hour",
			"hours": "Hours",
			"kit_and_activity": "Kit & activity",
			"kits": "Kits",
			"latest_trackings": "Latest activities",
			"lead_detectors_overview": "Lead hunters overview",
			"lead_kit_and_activity": "Lead, kit & activity",
			"lead_statistics": "Lead trackings",
			"leads": "Leads",
			"leads_cold": "Cold",
			"leads_hot": "Hot",
			"leads_per_day": "leads per day",
			"leads_per_lead_detector": "per lead hunter",
			"leads_warm": "Warm",
			"no_data": "There is no data yet. Try another time time range.",
			"no_data_24_hours": "There is no data for the last 24 hours.",
			"no_data_7_days": "There is no data for the last 7 days.",
			"per_bk_opened": "per businesskit open",
			"project_statistics": "Project statistics",
			"see_full_report": "See full report",
			"see_full_statistics": "See full statistics",
			"see_full_tracking_history": "See full tracking history",
			"time_range": "Time range",
			"tracking_activity": "Activity",
			"tracking_kit": "Kit",
			"tracking_lead": "Lead",
			"tracking_time": "Time"
		}
	}
};

/***/ }),
/* 2033 */
/***/ (function(module, exports) {

module.exports = {
	"de": {
		"ui": {
			"companies": {
				"create": "Neu erstellen"
			},
			"company": {
				"fields": {
					"name": "Name",
					"website": "Webseite",
					"street": "Straße",
					"street_number": "Hausnummer",
					"city": "Stadt",
					"postcode": "PLZ",
					"country": "Land"
				},
				"edit": "Editieren",
				"empty_state_label": "Keine Firmen stimmen mit Deiner Sucher überein",
				"contact": {
					"go_to_contact": "Zum Kontakt",
					"view_all": "Kontakte ansehen"
				},
				"title": "Firmen",
				"actions": {
					"success": "Das Unternehmen wurde erfolgreich aktualisiert",
					"error": "Es ist ein Fehler während des Aktualisierens aufgetreten",
					"success_create": "Die Firma wurde erfolgreich erstellt",
					"error_create": "Es ist ein Fehler beim Erstellen der Firma aufgetreten",
					"success_delete": "Die Firma wurde erfolgreich gelöscht",
					"error_delete": "Es ist ein Fehler beim Löschen der Firma aufgetreten"
				},
				"breadcrumb_back": "Alle Firmen",
				"empty_state": "Keine Firmen gefunden",
				"contacts": "Kontakte",
				"empty_state_text": "Es gibt keine Kontakte zu diesem Unternehmen",
				"created": "Erstellt am",
				"company_details": "Firmen-Details",
				"updated": "Aktualisiert am",
				"missing": {
					"headline": "Daten fehlen",
					"email": "E-Mail fehlt",
					"name": "Name fehlt",
					"email_name": "Keine Namen oder E-Mail gefunden"
				},
				"columns": {
					"name": "Name",
					"id": "Id",
					"website": "Webseite",
					"created": "Erstellt",
					"updated": "Aktualisiert"
				},
				"caption": {
					"name": "Name",
					"website": "Webseite",
					"street": "Straße",
					"street_number": "Hausnummer",
					"city": "Stadt",
					"zip": "PLZ",
					"country": "Land"
				},
				"modals": {
					"delete": {
						"title": "Diese Aktion kann nicht rückgängig gemacht werden",
						"subtitle": "Sie wollen die Firma {companyName} löschen",
						"warning": "Wenn Sie diese Firma löschen werden auch {things} gelöscht. Möchten Sie fortfahren?",
						"label": "Tragen Sie das Wort \"Löschen\" ein um fortzufahren",
						"confirm_word": "Löschen",
						"confirm": "Unwiderruflich löschen"
					}
				}
			},
			"project": {
				"standard_title": "Der Standard Berichtsbogen enthält:",
				"standard_subtitle_1": "Persönlich",
				"standard_subtitle_2": "Unternehmen",
				"standard_description_1": "Sprache, Geschlecht, Titel, Vorname, Nachname, E-Mail, Abteilung, Funktion, Rolle, Job",
				"standard_description_2": "Firmenname, Branche, Telefon, Webseite, Straße, Nummer, PLZ, Stadt, Land",
				"advanced_title": "Der erweiterte Berichtsbogen enthält die selben Tabs und Felder die auch der Standard Berichtsbogen enthält. Außerdem:",
				"advanced_subtitle_1": "Projekt Termin",
				"advanced_subtitle_2": "Qualifizierung",
				"advanced_description_1": "Kundenanfragen, Information, E-Mail Marketing (Newsletter, Event und E-Mail Abonnement)",
				"advanced_description_2": "Notizen, Interesse an, Projekt geplant (Dauer in Monaten)",
				"create_leadsheet": "Erstelle einen neuen Berichtsbogen"
			},
			"segments": {
				"segments": "Segmente",
				"is_editing_state": "Speichere das Segment bevor du fortfährst",
				"add_to_project": {
					"empty": "Keine Projekte",
					"success": "Ihre Kontakte werden dem Projekt hinzugefügt. Dies kann einige Minuten dauern.",
					"error": "Beim Hinzufügen von Kontakten zu Projekten ist ein Fehler aufgetreten"
				},
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Erstellt am",
					"updated": "Zuletzt aktualisiert",
					"creator": "Ersteller"
				},
				"actions": {
					"success": "Segment erfolgreich gespeichert!",
					"error": "Segment konnte nicht gespeichert werden.",
					"edit": "Editieren",
					"edit_description": "Editieren",
					"duplicate": "Duplizieren",
					"duplicate_description": "Duplizieren",
					"duplicate_name": "Kopie von {name}",
					"delete": "Löschen",
					"delete_description": "Löschen"
				},
				"business_kit": {
					"segment_title": "Senden an",
					"subtext": "Stellen Sie sicher, dass Ihr Businesskit korrekt eingerichtet ist, bevor Sie es versenden",
					"contacts": "Kontakte",
					"success": "Businesskit erfolgreich verschickt",
					"error": "Beim Businesskit-Verschicken ist ein Fehler aufgetreten",
					"preview": "Vorschau",
					"email_templates_confirmation": "Bestätigen Sie, dass es eine E-Mail-Vorlage für dieses Businesskit gibt. Wenn keine E-Mail-Vorlage erstellt wurde, wird dieses Businesskit nicht versendet."
				},
				"create_modal": {
					"title": "Segment erstellen",
					"field_label": "Neuer Segment Name",
					"duplicate": "Erstellen",
					"name": "Name"
				},
				"delete_modal": {
					"title": "Segment löschen"
				},
				"duplicate_modal": {
					"title": "Segment duplizieren",
					"duplicate": "Duplizieren",
					"name": "Neuer Segment Name"
				},
				"bbusinesskits_modal": {
					"title": "Bereit zum Versenden",
					"send": "Kit versenden"
				},
				"add_to_project_modal": {
					"title": "Zum Projekt hinzufügen",
					"search_label": "Projekt durchsuchen",
					"add_button": "Hinzufügen"
				},
				"export": {
					"success": "Export abgeschlossen. Sie sollten in Kürze eine E-Mail mit Ihren Kontakten erhalten.",
					"error": "Beim Exportieren ist ein Fehler aufgetreten, bitte versuchen Sie es erneut."
				},
				"delete": {
					"success": "Kontakte erfolgreich gelöscht",
					"error": "Einer oder mehrere Kontakte konnten nicht gelöscht werden."
				}
			},
			"segment": {
				"breadcrumb_back": "Alle Segmente"
			},
			"contacts": {
				"enumeration": "Keine Kontakte | {n} Kontakt | {n} Kontakte",
				"modals": {
					"delete": {
						"title": "Kontakte löschen"
					}
				},
				"title": "Kontakte",
				"create": "Kontakt erstellen",
				"empty_state_msg": "Keine Kontakte auf Basis der Filtereinstellungen gefunden",
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Erstellt am",
					"updated": "Zuletzt aktualisiert",
					"company": "Unternehmen",
					"source": "Quelle",
					"email": "E-Mail",
					"gender": "Geschlecht"
				},
				"actions": {
					"export": "Exportieren",
					"update_company": "Zum Unternehmen hinzufügen",
					"save_to_project": "Zum Projekt hinzufügen",
					"send_businesskit": "Ein Businesskit verschicken",
					"delete": "Löschen",
					"error": "Es gab einen Fehler beim Aktualisieren des Kontakts",
					"success": "Der Kontakt wurde erfolgreich aktualisiert"
				},
				"filters": {
					"custom_placeholder": "Projekt Attribute...",
					"general": {
						"none": "Keine zugeordnet"
					},
					"project": {
						"label": "Projekt Name",
						"none": "Gehört zu keinen Projekten"
					},
					"company": {
						"label": "Unternehmen",
						"none": "Gehört zu keinen Projekten"
					},
					"gender": {
						"label": "Geschlecht",
						"options": {
							"male": "Männlich",
							"female": "Weiblich"
						}
					},
					"language": {
						"label": "Sprache",
						"options": {
							"en": "Englisch",
							"de": "Deutsch"
						}
					},
					"invalid_email": {
						"label": "E-Mail ist gültig",
						"condition_label": "E-Mail",
						"options": {
							"valid": "Gültig",
							"not_valid": "Ungültig"
						}
					},
					"created": {
						"label": "Erstellt"
					},
					"updated": {
						"label": "Aktualisiert"
					},
					"city": {
						"label": "Stadt"
					},
					"country": {
						"label": "Land"
					},
					"tags": {
						"label": "Tags"
					}
				},
				"import": {
					"title": "Kontakte importierne",
					"description": "Laden Sie eine CSV-Datei mit den zu importierenden Kontakten hoch.",
					"format": "Die Datei sollte mindestens drei Spalten enthalten: Vorname, Nachname und E-Mail. Nur die E-Mail ist obligatorisch, aber Vorname und Nachname sind sehr empfehlenswert.",
					"success_flash": "Kontakte wurden erfolgreich importiert",
					"success_modal_title": "Import abgeschlossen",
					"success_modal_body": "Deine Kontakte wurden erfolgreich importiert.",
					"success_modal_report": "Von {total} importieren Kontaten wurden {new} erstellt und {updated} aktualisiert."
				}
			},
			"contact": {
				"edit": "Editieren",
				"change_company": "Änderung",
				"breadcrumb_back": "Alle Kontakte",
				"empty_state_text": "Dieser Kontakt wurde noch nicht als Lead erfasst.",
				"contact_details": "Kontakt Details",
				"company_details": "Unternehmen Details",
				"created": "Erstellt am",
				"updated": "Aktualisiert am",
				"is_lead_on": "Ist Lead von",
				"go_to_lead": "Zum Lead",
				"tags": "Tags",
				"source": "Quelle",
				"sources": {
					"web_app": "Web App",
					"mobile_app": "Mobile App",
					"external_form": "Formular",
					"crm_sync": "CRM Sync",
					"upload": "Hochgeladen",
					"unknown": "Unbekannt"
				},
				"caption": {
					"email": "E-Mail",
					"firstname": "Vorname",
					"lastname": "Name",
					"business_card_job_title": "Job-Titel",
					"company_department": "Abteilung",
					"phone_mobile": "Mobiltelefon",
					"phone_company": "Firmen-Telefon",
					"phone_private": "Privates Telefon",
					"gender": "Anrede",
					"language": "Sprache"
				}
			},
			"xtable": {
				"toggle_columns": "Spalten bearbeiten",
				"actions": "Aktionen",
				"page_size_label": "Ansicht",
				"search_placeholder": "Suchen",
				"save_search_title": "Suche speichern",
				"save_search_label": "Name",
				"empty_state_label": "Keine Daten entsprechen den Filtern",
				"empty_cell_value": "Kein {name} zugeordnet"
			},
			"xfilters": {
				"confirm_removal": "Ja, Filter entfernen",
				"add_filter": "Filter hinzufügen",
				"add_filter_confirm": "Hinzufügen",
				"delete_filter_warning": "Sie sind dabei, eine Filterbedingung zu entfernen oder zu ersetzen, von der andere Bedingungen abhängen. Wenn Sie fortfahren, dann werden auch alle diese abhängigen Bedingungen entfernt.",
				"delete_filter_confirmation": "Sind Sie sicher, dass Sie weitermachen wollen?",
				"conditions": {
					"operators": {
						"and": "und",
						"or": "oder"
					},
					"predicates": {
						"has_any": "hat einen",
						"has_all": "hat alle"
					},
					"summary": {
						"is": "{0} ist {1}",
						"has_all": "{0} hat alle {1}",
						"has_any": "{0} hat einen von {1}",
						"includes": "{0} enthält {1}",
						"is_not_assigned": "{0} ist nicht zugeordnet",
						"date_on": "{0} am {1}",
						"date_between": "{0} zwischen {1} und {2}",
						"date_since": "{0} seit {1}",
						"date_before": "{0} am oder vor {1}",
						"date_in_range": "{1} {0}",
						"date_in_range_simple": "{1} {0}"
					}
				},
				"xfiltermodal": {
					"date_from": "Von",
					"date_to": "Bis"
				},
				"date_ranges": {
					"custom": "Angepasste",
					"today": "Heute",
					"yesterday": "Gestern",
					"past_week": "Letzte Woche",
					"past_month": "Letzten Monat",
					"past_year": "Letztes Jahr"
				}
			},
			"drag_elements": {
				"gender": "Geschlecht/Anrede",
				"paragraph": "Paragraph",
				"title": "Titel",
				"confirmation": "Bestätigung",
				"firstname": "Vorname",
				"lastname": "Nachname",
				"email": "E-Mail",
				"company": "Unternehmen",
				"street": "Straße",
				"street_number": "Hausnummer",
				"zip": "PLZ",
				"city": "Stadt",
				"country": "Land",
				"website": "Webseite",
				"phone_company": "Telefon (Firma)",
				"phone_mobile": "Telefon (Mobil)",
				"textfield": "Textfeld",
				"long_textfield": "Langes Textfeld",
				"multi_select": "Mehrfachauswahl",
				"dropdown": "Dropdown",
				"single_select": "Einfachauswahl",
				"date": "Datum",
				"readonly": "Schreibgeschützt",
				"quantity_selection": "Mengenauswahl",
				"drawing": "Zeichnung"
			},
			"breadcrump": {
				"back": "Zurück"
			},
			"dashboard": {
				"widget_error": "Es gab einen Fehler beim Laden Ihrer Daten",
				"filter": {
					"dashboard": "Dashboardfilter",
					"all_projects": "Alle Projekte"
				},
				"leads_collected_label": "Erfasste Leads",
				"hot": "Heiß",
				"warm": "Warm",
				"cold": "Kalt",
				"unclassified": "Nicht klassifiziert",
				"most_active_projects": "Aktivste Projekte",
				"conversion_funnel": {
					"label": "Conversion Funnel",
					"cumulative_conversion": "Kumulative Umwandlung",
					"leads": "Leads",
					"sendouts": "Sendouts",
					"visits": "Kit-Ansichten",
					"interactions": "Interaktionen"
				},
				"kit_activity_label": "Letzte Interaktionen",
				"latest_activity": {
					"label": "Neuste Leads",
					"edited_in": "Bearbeitet in",
					"added_to": "Hinzugefügt zu",
					"by": "Von",
					"incomplete_lead": "Unvollständiger Lead"
				},
				"leads_by_project_label": "Leads in Projekten",
				"leads_by_most_active_projects_label": "Leads in den aktivsten Projekten",
				"leads_by_most_active_projects": {
					"me": "Meine",
					"org": "Org"
				},
				"empty_state_headline": "Das Dashboard wird angezeigt sobald genügend Daten zur Verfügung stehen",
				"empty_state_intro": "Erstellen Sie Ihre ersten Inhalte",
				"empty_state_cta": "Projekt erstellen",
				"top_sources_label": "Top Quellen",
				"active_leads": {
					"label": "Aktivste Leads",
					"today": "Heute",
					"last_7": "Letzte 7 Tage",
					"last_month": "Letzten Monat",
					"last_year": "Letztes Jahr",
					"all_time": "Gesamt"
				},
				"leads_over_time": {
					"linear": "Leads",
					"cumulated": "Kumuliert",
					"label": "Leads gesamt"
				},
				"axischart": {
					"last_week": "Letzte Woche",
					"last_month": "Letzten Monat",
					"last_year": "Letztes Jahr"
				},
				"top_projects": {
					"kits": "Kits",
					"leads": "Leads",
					"my_leads": "Meine Leads",
					"lead_sheet": "Berichtsbogen",
					"empty_state": "Noch keine Projekte"
				},
				"top_sources": {
					"last_week": "Letzte Woche",
					"last_month": "Letzten Monat",
					"last_year": "Letztes Jahr",
					"web_app": "Web app",
					"external_forms": "Formulare",
					"mobile_app": "Mobil"
				},
				"kit_activity": {
					"all": "Alle",
					"opened_kit": "Hat",
					"opened": "geöffnet",
					"updated_a_lead": "hat ein Lead aktualisiert",
					"empty_state_headline": "Noch keine Businesskit Aktivität",
					"empty_state_intro": "Erstellen Sie ansprechende und personalisierte Inhalte, die Ihnen helfen, sich wirklich mit Ihrem Unternehmen zu verbinden.",
					"interacted_with": "Interagierte mit",
					"view_content_card": "Hat eine Content-Card angeschaut | Hat {count} Content-Cards angeschaut",
					"click_content_card": "Klickte auf einen Call-to-Action | Klickte auf {count} Call-to-Actions"
				},
				"activity_list_widget": {
					"created_a_lead": "hat einen Lead erstellt",
					"updated_a_lead": "hat einen Lead aktualisiert",
					"on": "am",
					"latest_activity": "Neuste Leads",
					"empty_state_headline": "Noch keine Aktivität",
					"empty_state_intro": "Projekt erstellen"
				}
			},
			"email_template": {
				"placeholders": {
					"firstname": "Firstname",
					"lastname": "Last name",
					"formal": "Formal salutation",
					"informal": "Informal salutation",
					"gender": "Mr/Mrs",
					"form_title": "Formular Titel"
				}
			},
			"meta_info": {
				"invitation": "Willkommen zu Leads",
				"reset_password": "Passwort zurücksetzen"
			},
			"auth": {
				"button": "Anmelden",
				"confirm": "Passwort setzen",
				"create_account_subtitle": "Wähle ein Passwort",
				"create_account_subtitle_confirm": "Du hast Deinen Account erfolgreich erstellt. Bitte melde Dich nun bei Leads an.",
				"create_account_title": "Erstelle Deinen Account",
				"create_account_title_confirm": "Glückwunsch",
				"email": "E-Mail Adresse",
				"firstname": "Vorname",
				"go_to_login": "Zum Login",
				"password": "Passwort",
				"password_confirmation": "Passwort bestätigen",
				"password_reset": "Passwort vergessen?",
				"password_reset_request_title": "Setze Dein Passwort zurück",
				"password_reset_request_title_confirm": "Schau in Dein E-Mail Postfach",
				"password_reset_sent": "Eine E-Mail mit weiteren Anweisungen, wie Du Dein Passwort zurücksetzen kannst, wurde geschickt.",
				"password_reset_title": "Passwort zurücksetzen",
				"password_reset_title_confirm": "Glückwunsch",
				"lastname": "Nachname",
				"return_to_login": "Zurück zum Login",
				"success": "Dein Passwort wurde erfolgreich gesetzt. Du kannst dich nun in alle Fanomena Leads Produkte einloggen.",
				"user_not_found": "Benutzer nicht gefunden",
				"user_not_found_subtitle": "Es tut uns Leid aber wir konnten diesen Benutzer nicht finden.<br/>Vermutlich ist Ihr Einladungs-Link abgelaufen oder der Benutzer wurde gelöscht."
			},
			"auth_illustration": {
				"contact_us": "Kontaktiere uns",
				"get_access": "Erhalte Deinen Zugang",
				"invitation_subtitle": "Entdecke Deine Möglichkeiten",
				"invitation_title": "Möchtest Du mehr über Fanomena Leads erfahren?",
				"login_subtitle": "Wir zeigen Dir Fanomena Leads",
				"login_title": "Neu hier und willst Du Dich umsehen?",
				"reset_request_subtitle": "Wir helfen Dir",
				"reset_request_title": "Keine Möglichkeit zurückzusetzen?",
				"reset_subtitle": "Wir helfen Dir",
				"reset_title": "Keine Möglichkeit zurückzusetzen?"
			},
			"business_kit": {
				"preview": "Vorschau Businesskit",
				"confirmation": "Hiermit wird bestätigt, dass Informationsmaterial angefordert und verschickt werden darf.",
				"history": "Businesskits verschickt",
				"send": "Ein Businesskit verschicken",
				"send_confirm": "Businesskit senden",
				"activity": "Noch nichts verschickt"
			},
			"button": {
				"double_optin": "Sicher?",
				"contacts": {
					"create": "Kontakt erstellen",
					"import": "Importieren",
					"save_as_segment": "Als Segment speichern"
				},
				"companies": {
					"create": "Unternehmen erstellen",
					"delete": "Firma löschen"
				},
				"segments": {
					"new": "Segment erstellen",
					"save": "Segment speichern"
				},
				"segment": {
					"save": "Segment speichern"
				},
				"plans": {
					"new": "Plan hinzufügen"
				},
				"external_forms": {
					"new": "Formular hinzufügen"
				},
				"external_form": {
					"add_popup": "Formular erstellen",
					"save": "Speichern",
					"publish": "Veröffentlichen"
				},
				"lead_mask": {
					"save": "Speichern",
					"publish": "Veröffentlichen"
				},
				"lead_masks": {
					"add_popup": "Berichtsbogen hinzufügen"
				},
				"opt-ins": {
					"new": "Opt-In hinzufügen"
				},
				"organizations": {
					"new": "Neue Organisation hinzufügen"
				},
				"project_leads": {
					"add_popup": "Lead hinzufügen",
					"confirm_mail": "E-Mail Adresse bestätigen",
					"confirm_picture": "Speichern & weiter",
					"continue": "Neues Unternehmen",
					"create": "Lead erfassen",
					"export": "XLS exportieren",
					"make_another_picture": "Wiederholen",
					"new": "Lead hinzufügen",
					"take_picture": "Visitenkarte aufnehmen"
				},
				"projects": {
					"new": "Projekt erstellen"
				},
				"users": {
					"new": "Benutzer hinzufügen",
					"invite": "Einladen",
					"invite_xls": "Via XLS einladen",
					"upload_xls": "Weiter"
				},
				"email_templates": {
					"new": "Template hinzufügen"
				},
				"workflow": {
					"trigger": "Workflow jetzt ausführen",
					"add_popup": "Neuen Workflow erstellen"
				},
				"workflows": {
					"new": "Neuer Workflow erstellen",
					"trigger": "Workflow ausführen"
				}
			},
			"filters": {
				"apply": "Anwenden",
				"import_origin": "Importquelle",
				"origin": "Leadquelle",
				"start_date": "Erstellung",
				"sync_disabled": "CRM Sync",
				"sync_status": "Sync Status",
				"hint": "Suchergebnisse filtern",
				"reset": "Zurücksetzen",
				"categories": "Kategorien"
			},
			"footer": {
				"imprint": "Impressum",
				"privacy": "Datenschutz",
				"terms": "Geschäftsbedingungen",
				"security": "Sicherheit"
			},
			"onboarding": {
				"next": "Weiter",
				"skip": "Überspringen",
				"start": "Starten",
				"step1": {
					"title": "Projekt erstellen",
					"subtitle": "Erstellen Sie mit nur wenigen Klicks Ihr erstes Projekt und digitalisieren Sie Ihre Veranstaltungen und Marketing Kampagnen."
				},
				"step2": {
					"title": "Leads erfassen",
					"subtitle": "Speichern Sie Ihre Kontaktdaten digital, indem Sie Visitenkarten mit einem beliebigen Endgerät abscannen oder mit Hilfe eines Berichtsbogen erfassen."
				},
				"step3": {
					"title": "Inhalte erstellen",
					"subtitle": "Erstellen und teilen Sie personalisierte Inhalte mit Ihren Leads, um diese zu qualifizieren und so mehr Kunden zu generieren."
				}
			},
			"content_manager": {
				"first-card": {
					"title": "Businesskits",
					"subtitle": "Erstellen Sie einzigartige und personalisierte Inhalte, mit denen Sie aus der Masse herausstechen und Ihre Interaktionsrate steigern.",
					"btn": "Businesskit erstellen"
				},
				"second-card": {
					"title": "Formulare",
					"subtitle": "Erstellen Sie Fanomena Leads Formulare, die Sie ganz einfach in Ihrer Website einbinden können. Integrieren Sie gleichzeitig Ihre Marketing Tools (Webinar Tools, CRM) und automatisieren Sie Folgeprozesse.",
					"btn": "Formulare erstellen"
				},
				"third-card": {
					"title": "Berichtsbogen",
					"subtitle": "Erstellen Sie individuelle Berichtsbögen und fragen Sie alle Informationen ab, die Sie für Ihren Qualifizierungsprozess benötigen.",
					"btn": "Support kontaktieren"
				}
			},
			"empty_state": {
				"projects": {
					"title": "Mit der Erstellung eines neuen Projektes beginnen",
					"title-standard-user": "Willkommen bei Leads",
					"subtitle": "Digitalisieren Sie Ihren Lead Management Prozess und erhalten Sie noch mehr Informationen über Ihre Leads.",
					"standard-user": "Sie sind noch keinem Projekt zugeordnet. Bitte kontaktieren Sie Ihren Administrator, um zu starten.",
					"btn": "E-Mail Erinnerung senden",
					"success_message": "Die Erinnerung wurde erfolgreich gesendet."
				},
				"leads": {
					"title": "Erfassen Sie Ihre ersten Leads im Projekt.",
					"subtitle": "Fragen Sie alle Informationen ab, die Sie dabei Unterstützen Ihre Leads in Kunden umzuwandeln."
				}
			},
			"taglist": {
				"label": "Art des Projektes"
			},
			"global": {
				"add": "Und",
				"assign": "Zuordnen",
				"back": "Zurück",
				"back_to_home": "Zurück zur Homepage",
				"cancel": "Abbrechen",
				"confirm": "Bestätigen",
				"continue": "Weiter",
				"delete": "Löschen",
				"delete_confirmation": "Bist Du sicher dass Du {name} löschen willst?",
				"delete_title": "Wirklich löschen?",
				"lead_edit_abort": "Willst Du wirklich zurück? Es gibt ungespeicherte Änderungen.",
				"edit": "Editieren",
				"empty_collection": "Es gibt noch keine Einträge",
				"no_results": "Leider keine Ergebnisse.",
				"no": "Nein",
				"save": "Speichern",
				"show": "Anzeigen",
				"take_picture": "Foto aufnehmen",
				"unassign": "Entfernen",
				"valid": "Bestätigen",
				"yes": "Ja",
				"ok": "Ok",
				"warning": "Achtung",
				"date_time": {
					"today": "heute",
					"yesterday": "gestern",
					"seconds_ago": "vor ein paar Sekunden",
					"less_than_minute": "vor weniger als einer Minute",
					"minutes_ago": "vor ein paar Minuten",
					"now": "jetzt",
					"at": "um"
				}
			},
			"header": {
				"add-lead": "Lead hinzufügen",
				"add-project": "Projekt hinzufügen"
			},
			"language": {
				"change": "Sprache ändern:",
				"de": "DE",
				"en": "EN /"
			},
			"menu": {
				"project_assignments_edit": "Zuweisungen",
				"businesskits": "Businesskits",
				"plans": "Plans",
				"change-language": "Ändere Sprache zu Englisch",
				"profile": "Profil",
				"business_kits": "Alle Businesskits",
				"dashboard": "Dashboard",
				"external_forms": "Formulare",
				"external_form_editor": "Editor",
				"external_form_options": "Optionen",
				"external_form_preview": "Vorschau",
				"general_settings": "Allgemeine Einstellungen",
				"lead_masks": "Berichtsbögen",
				"lead_mask_editor": "Editor",
				"lead_mask_options": "Optionen",
				"logout": "Abmelden",
				"manage_projects": "Projekte verwalten",
				"organizations": "Organisationen",
				"project_edit": "Einstellungen",
				"project_leads": "Leads",
				"project_statistics": "Statistiken",
				"projects": "Projekte",
				"projects_synchronize": "Sync mit CRM",
				"settings": "Benutzer verwalten",
				"statistics": "Statistiken",
				"trackings": "Trackings",
				"user_profile": "Profileinstellungen",
				"users": "Benutzer",
				"email_templates": "E-Mail Templates",
				"content_manager": "Manage",
				"contact_manager": "Kontaktmanager",
				"contacts": "Kontakte",
				"companies": "Unternehmen",
				"segments": "Segmente",
				"sync": "Sync",
				"workflows": "Workflows",
				"people": "Kontakte",
				"menu_tab_lead_capture": "Leaderfassung",
				"menu_tab_settings": "Einstellungen"
			},
			"pages": {
				"plans": "Plans",
				"plan-rules": "Regeln",
				"plan-organizations": "Organisationen",
				"businesskits": "Alle Businesskits",
				"contact_us": "Kontaktiere uns",
				"contact_us_email": "mailto:leads@fanomena.io?subject=Account%20wiederherstellen&body=Liebes%20Fanomena%20Team%2C%0A%0ALeider%20kann%20ich%20mich%20weder%20zu%20meinen%20Account%20anmelden%20noch%20mein%20Passwort%20erfolgreich%20zur%C3%BCcksetzen.%20K%C3%B6nnt%20ihr%20mir%20bitte%20helfen%3F%0A%0ADanke%2C",
				"external-forms": "Formulare",
				"external-forms--button": "Ein Formular hinzufügen",
				"external-forms-create-button": "Formular erstellen",
				"external-forms-update-button": "Formular editieren",
				"get_your_access": "Zugang erhalten",
				"item-create": "Erstellen",
				"item-new": "Neu",
				"item-update": "Editiere {name}",
				"lead-create": "Lead erfassen",
				"lead-download-pdf-succeed": "PDF erfolgreich heruntergeladen. Es öffnet in einem neuen Fenster.",
				"lead-download-pdf-error": "PDF konnte wegen eines Fehlers mit der Visitenkarte nicht heruntergeladen werden.",
				"lead-edit": "Editiere einen Lead",
				"lead-mask-create-button": "Berichtsbogen erstellen",
				"lead-mask-edit": "Editiere {name}",
				"lead-mask-update-button": "Berichtsbogen aktualisieren",
				"lead-masks": "Berichtsbogen",
				"lead-no-businesskit": "Diesem Projekt ist noch kein Businesskit zugewiesen.",
				"lead-statistics": "Lead-Statistiken",
				"lead-statistics-overview": "Übersicht",
				"lead-statistics-trackings": "Trackings",
				"lead-change-count": "Durchgeführte Änderung: {num} | Durchgeführte Änderungen: {num}",
				"login": "Willkommen",
				"login_details": "Trage Deine Details ein um fortzufahren",
				"logout": "Danke",
				"logout_details": "Danke dass Du ein Produkt von Fanomena benutzt hast.",
				"opt-ins": "Alle Opt-Ins",
				"organization-edit": "Editiere {name}",
				"organization-edit-button": "Organisation aktualisieren",
				"organization-new": "Organisation erstellen",
				"organization-new-button": "Organisation erstellen",
				"organization-create-button": "Organisation erstellen",
				"organization-update-button": "Organisation aktualisieren",
				"organizations": "Alle Organisationen",
				"password_reset": "Trage hier ein neues Passwort ein",
				"password_reset_confirm": "Dein Passwort wurde erfolgreich zurückgesetzt",
				"password_reset_request": "Trage Deine E-Mail Adresse ein und wir senden Dir einen Link, mit dem Du Dein Passwort wiederherstellen kannst.",
				"password_reset_request_confirm": "Eine E-Mail mit einem Passwort-Zurücksetzen-Link wurde an die E-Mail Adresse geschickt sofern sie existiert.",
				"project-assign": "Zum Projekt hinzufügen",
				"project-create": "Neues Projekt hinzufügen",
				"project-create-button": "Projekt erstellen",
				"project-download-data": "Daten als XLS herunterladen",
				"project-download-data-suceed": "Die XLS-Datei wurde an Deine E-Mail Adresse geschickt",
				"project-edit": "Editiere {name}",
				"project-options": "Projekt Optionen",
				"project-show": "{name}",
				"project-update-button": "Speichern",
				"projects": "Projekte",
				"statistic-show": "Statistik Details: {name}",
				"statistics": "Statistiken",
				"take_a_tour": "Zur Webseite",
				"user-edit": "Editiere {name}",
				"user-edit-button": "Benutzer aktualisieren",
				"user-new-button": "Benutzer hinzufügen",
				"user-show": "Benutzer: {name}",
				"user-update-button": "Benutzer aktualisieren",
				"users": "Benutzer",
				"email-templates": "E-Mail Templates",
				"email-templates-update": "Template editieren",
				"email-templates-create": "Template erstellen",
				"email-templates-new": "Erstelle ein Template",
				"email-templates-update-button": "Template editieren",
				"email-templates-create-button": "Erstelle Template",
				"email-templates-new-button": "Erstelle ein Template",
				"project-assign-businesskit": "Businesskits zuweisen",
				"project-assign-user": "Benutzer zuweisen",
				"project-no-assigned-user": "Diesem Projekt sind keine Benutzer zugewiesen",
				"project-no-assigned-businesskit": "Diesem Projekt sind keine Businesskits zugewiesen",
				"project-assigned-businesskit": "Businesskits",
				"project-assigned-user": "Benutzer",
				"project-assignments": "Projekt Zuweisungen",
				"project-edit-user": "Editieren",
				"user-invite": "Benutzer einladen",
				"project-next-button": "Weiter",
				"project-capture-leads": "Zum Projekt",
				"project-view-talentkit": "Businesskit zuweisen",
				"project-create-talentkit": "Businesskit zuweisen",
				"project-create-content": "Inhalte erstellen",
				"previous": "Zurück",
				"workflow-update-button": "Workflow aktualisieren",
				"workflows": "Workflows",
				"contacts": "Alle Kontakte",
				"companies": "Alle Firmen",
				"segments": "Alle Segmente"
			},
			"project_wizard": {
				"step1-title": "Projekt anlegen",
				"step2-title": "Berichtsbogen wählen",
				"step2-invite-users": "Lade neue Benutzer zu Fanomena Leads ein",
				"step2-assign-users": "Füge einen weiteren Benutzer zu diesem Projekt hinzu",
				"lead-sheets": "Berichtsbogen",
				"leadsheet-create": "Individuellen Berichtsbogen erstellen",
				"leadsheet-create-tip": "Bitte nehmen Sie Kontakt mit uns auf, wenn Sie einen individuelle Berichtsbogen erstellen möchten.",
				"leadsheet-basic": "Digitaler Berichtsbogen zur Erfassung von personenbezogenen und geschäftlichen Daten.",
				"leadsheet-advanced": "Digitaler Berichtsbogen, der alle Elemente des Standard Berichtsbogen und zusätzliche Fragen zur Qualifizierung Ihres Leads enthält.",
				"success-title": "Herzlichen Glückwunsche. Sie haben Ihr Projekt erfolgreich erstellt.",
				"success-subtitle": "Wie möchten Sie fortfahren?",
				"step2-invite": "Um bestehende Fanomena Leads Benutzer diesem Projekt zuzuordnen, gehen Sie nach der Erstellung Ihres Projekts zu den Projekteinstellungen."
			},
			"searchbar": {
				"placeholder": {
					"bk": "Trag einen Businesskit Namen ein…",
					"email_templates": "Trag einen Namen ein.…",
					"external_forms": "Trag einen Namen oder Projekt ein…",
					"lead_masks": "Trag einen Namen ein…",
					"organizations": "Trag einen Namen ein.…",
					"projects": "Suche nach einem Projekt…",
					"project_leads": "Suche Leads oder Unternehmen…",
					"users": "Trag einen Vornamen, Nachnamen oder E-Mail ein…"
				}
			},
			"tabs": {
				"company_tab": "Firmendaten",
				"kits_tab": "Kits",
				"personal_tab": "Persönlich",
				"qualify_tab": "Qualifikation",
				"stats_tab": "Stats"
			},
			"external_form": {
				"preview_page": {
					"title": "Einbetten",
					"head_paragraph": "Um das Formular auf Ihrer Webseite einzubinden, laden Sie bitte folgenden Script in Ihren <head>-Tag.",
					"html_paragraph": "Binden Sie danach das Formular via html-Tag dort ein, wo Sie es auf Ihrer Seite anzeigen wollen.",
					"script_paragraph": "Laden Sie danach das Formular via Javascript.",
					"head_section_title": "Head",
					"html_section_title": "HTML",
					"script_section_title": "Script",
					"forms_cannot_be_submitted": "Formulare können in der Vorschau nicht abgesendet werden. Das Aussehen des Formulars kann über die Webseite auf der es eingebettet wird individuell gesteuert werden."
				},
				"follow_up": "Folgeaktionen",
				"tabs": {
					"general": "Allgemein",
					"config": "Konfiguration",
					"editor": "Editor",
					"preview": "Vorschau"
				},
				"basic_config": "Grundeinstellungen",
				"form_editor": "Formular Editor",
				"frontend_actions": "Aktion wenn der Besucher das Formular abschickt:",
				"backend_actions": "Follow up Aktionen:",
				"bk_boarding": "Businesskit Boarding",
				"send_directly": "Verschicke das Businesskit manuell?",
				"email_notification": "E-Mail Benachrichtigung",
				"add_to_mailchimp": "Zu Mailchimp Liste hinzufügen",
				"field_assignation": "Felder-Zuweisungen Mailchimp",
				"board_bk": "Businesskit Boarding",
				"success_message": "Erfolgs-Nachricht:",
				"redirection_url": "Weiterleiten zu URL:",
				"send_notification_to": "Verschicke Benachrichtung an E-mail Adressen:",
				"mailchimp_list_id": "Mailchimp Listen ID",
				"board_citrix": "Citrix Boarding",
				"citrix_keys": "Citrix Webinar Keys",
				"send_lead_confirmation_mail": "Verschicke Benachrichtigung an Lead",
				"email_template": "E-Mail Template",
				"mail_subject": "E-Mail Betreff",
				"mail_url": "CTA URL",
				"mail_cta": "CTA Text"
			},
			"lead_mask_editor": {
				"see_raw": "Berichtsbogen Original Content",
				"edit_element": "Element editieren",
				"delete_element": "Element löschen",
				"cancel": "Abbrechen",
				"valid": "Bestätigen",
				"chose_element": "Wähle ein Element",
				"name": "Name",
				"type": "Typ",
				"default_value": "Standardwert",
				"default_field": "Standardfeld",
				"element_width": "Element Breite",
				"required": "Pflichtfeld",
				"class": "Klasse",
				"label": "Label",
				"placeholder": "Platzhalter",
				"children": "Children",
				"displayed_name": "Angezeigt",
				"value": "Wert",
				"add_line": "Hinzufügen",
				"collection": "Collection",
				"delete": "Löschen",
				"set_default_value": "Als Standard setzen",
				"basic_config": "Grundeinstellungen"
			},
			"organizations": {
				"api": "Externe Anbindungen",
				"configuration": "Konfiguration",
				"general_settings": "Allgemeine Einstellungen"
			},
			"upload": {
				"dropzone_message": "Ziehen Sie eine Datei hinein oder klicken Sie zum Hochladen",
				"empty_file": "Datei entfernen"
			},
			"users": {
				"invite": "Benutzer einladen",
				"invite_xls_success": "Benutzer wurden erfolgreich hinzugefügt",
				"xls_invite": "Via XLS einladen",
				"xls_invite_description": "Du kannst eine XLS Datei mit den Benutzern die Du einladen willst bereitstellen. Diese werden dann eine Einladungs-E-Mail erhalten.",
				"xls_invite_format": "Die XLS Datei sollte drei Spalten beinhalten: firstname, lastname und email. Nur das E-Mail Feld ist Pflicht aber firstname und lastname sind empfohlen."
			},
			"integrations": {
				"go-to-webinar": "Füge automatisch alle Leads, die dein Formular ausfüllen, zu einem Webinar hinzu."
			},
			"modals": {
				"download_app": {
					"title": "Laden Sie die mobile App herunter",
					"subtitle": "Verbessern Sie Ihr Erlebnis bei der Erfassung von Leads mit unserer mobilen Anwendung.",
					"skip": "Vielleicht später"
				},
				"businesskit_assignment": {
					"title": "Businesskits verwalten",
					"subtitle": "Wählen Sie die Businesskits aus, die Sie der aktuellen Kampagne zuordnen möchten."
				},
				"user_assignment": {
					"title": "Benutzer verwalten",
					"subtitle": "Wählen Sie die Benutzer aus, die Sie der aktuellen Kampagne zuordnen möchten."
				},
				"workflow": {
					"create": {
						"title": "Erstellen eines Workflow"
					}
				},
				"warning": {
					"button": "Ich verstehe"
				}
			},
			"drag_editor": {
				"no_label": "Kein Etikett",
				"extra_values": "und {num} extra.",
				"unpublished_changes": "Es gibt unveröffentlichte Änderungen",
				"popup": {
					"unsaved_changes": "Du hast nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?"
				},
				"active_item": {
					"edit": "Ausgewähltes Element bearbeiten",
					"label": "Etikett",
					"value": "Wert"
				},
				"fields": {
					"add_item": "Eintrag hinzufügen",
					"label": "Etikett",
					"text": "Text",
					"placeholder": "Platzhaltertext",
					"required": "Dieses Feld muss ausgefüllt werden",
					"hidden": "Dieses Feld ausblenden",
					"class": "CSS-Klasse",
					"default_value": "Vorauswahl",
					"default_value_options": "Standardwert",
					"validation": "Fehlermeldung",
					"internal_name": "Interner Name",
					"show_as_buttons": "Stelle Elemente als Buttons dar",
					"enrich_tags": "Speichere Selektierung als Tags",
					"data_type": "Datentyp",
					"data_types": {
						"text": "Text",
						"number": "Nummer",
						"email": "E-Mail",
						"tel": "Telefonnummer",
						"url": "Url"
					}
				},
				"dragElements": {
					"generic": "Allgemeine Felder",
					"leadMask": "Berichtsbogen Felder",
					"basic": "Basic Elemente",
					"fields": "Felder",
					"advanced": "Erweiterte Felder",
					"standard": "Standard Felder"
				},
				"badges": {
					"hidden": "Verstecktes Feld"
				},
				"placeholders": {
					"anchor": "Link",
					"bold": "Fett",
					"italic": "Kursiv",
					"underline": "Unterstrichen"
				},
				"screenTooSmall": {
					"title": "Es tut uns Leid!",
					"subtitle": "Um unseren Editor effizient zu nutzen müssen Sie eine höhere Auflösung auf Ihrem Bildschirm einstellen."
				}
			}
		}
	}
};

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

module.exports = {
	"en": {
		"ui": {
			"companies": {
				"create": "New company"
			},
			"company": {
				"fields": {
					"name": "Name",
					"website": "Website",
					"street": "Street",
					"street_number": "Street Number",
					"city": "City",
					"postcode": "Postcode",
					"country": "Country"
				},
				"edit": "Edit",
				"empty_state_label": "No Companies matched search",
				"contact": {
					"go_to_contact": "Go to contact",
					"view_all": "View contacts"
				},
				"title": "Companies",
				"actions": {
					"success": "The company has been successfully updated",
					"error": "There has been an error updating the company",
					"success_create": "The company has been successfully created",
					"error_create": "There has been an error creating the company",
					"success_delete": "The company has been successfully deleted",
					"error_delete": "There has been an error deleting the company"
				},
				"breadcrumb_back": "All Companies",
				"empty_state": "No companies found",
				"contacts": "Contacts",
				"empty_state_text": "This company has no contacts attached",
				"created": "Created",
				"company_details": "Company details",
				"updated": "Updated",
				"missing": {
					"headline": "Contact missing data",
					"email": "Contact missing email",
					"name": "Contact missing name",
					"email_name": "No names nor email found"
				},
				"columns": {
					"name": "Name",
					"id": "Id",
					"website": "Website",
					"created": "Created",
					"updated": "Updated"
				},
				"caption": {
					"name": "Name",
					"website": "Website",
					"street": "Street",
					"street_number": "Street Number",
					"city": "City",
					"zip": "Post Code",
					"country": "Country"
				},
				"modals": {
					"delete": {
						"title": "This action cannot be undone",
						"subtitle": "You are about to delete the company {companyName}",
						"warning": "Deleting the company will also delete {things}. Are you sure you want to continue?",
						"label": "Type the word \"delete\" to continue",
						"confirm_word": "delete",
						"confirm": "Delete permanently"
					}
				}
			},
			"project": {
				"advanced_subtitle_2": "Qualification",
				"standard_title": "The standard lead sheet includes:",
				"standard_subtitle_1": "Personal",
				"standard_subtitle_2": "Company",
				"standard_description_1": "Language, Gender, Title, Name, Last name, E-mail, Position, Function, Role, Job",
				"standard_description_2": "Company name, Branch, Phone, Website, Street, Number, Postal code, State, Country",
				"advanced_title": "The advanced lead sheet includes the same tabs and fields as the standard lead sheet and in addition:",
				"advanced_description_1": "Customer enquiries, Information, E-mail marketing (newsletter, event and e-mail subscriptions)",
				"advanced_description_2": "Notes, Interested in, Project planned (duration in months)",
				"advanced_subtitle_1": "Project Appointment",
				"create_leadsheet": "Create a new lead sheet"
			},
			"segments": {
				"segments": "Segments",
				"is_editing_state": "Save the segment before proceeding",
				"add_to_project": {
					"empty": "No Projects",
					"success": "Your contacts are being added to the project. This may take a few minutes.",
					"error": "Something went wrong while adding contacts to projects"
				},
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Created on",
					"updated": "Last updated",
					"creator": "Creator"
				},
				"actions": {
					"success": "Successfully saved segment!",
					"error": "Could not save the segment.",
					"edit": "Edit",
					"edit_description": "Edit",
					"duplicate": "Duplicate",
					"duplicate_description": "Duplicate",
					"duplicate_name": "Copy of {name}",
					"delete": "Delete",
					"delete_description": "Delete"
				},
				"business_kit": {
					"segment_title": "Send to",
					"subtext": "Make sure your BusinessKit is set up correctly before sending",
					"contacts": "Contacts",
					"success": "Successfully sent businesskits",
					"error": "Something went wrong while sending businesskits",
					"preview": "Preview",
					"email_templates_confirmation": "Confirm that there is an email template for this BusinessKit. If an email template has not been created this BusinessKit will not be sent."
				},
				"create_modal": {
					"title": "Create segment",
					"field_label": "New segment name",
					"duplicate": "Create",
					"name": "Name"
				},
				"delete_modal": {
					"title": "Delete segment"
				},
				"duplicate_modal": {
					"title": "Duplicate segment",
					"duplicate": "Duplicate",
					"name": "New segment name"
				},
				"businesskits_modal": {
					"title": "Send out ready",
					"send": "Send Kit"
				},
				"add_to_project_modal": {
					"title": "Add to project",
					"search_label": "Search for project",
					"add_button": "Add"
				},
				"export": {
					"success": "Export complete. You should receive an email with your contacts shortly.",
					"error": "Something went wrong with the export, please try again."
				},
				"delete": {
					"success": "Contacts successfully deleted",
					"error": "One or more contacts could not be deleted"
				}
			},
			"segment": {
				"breadcrumb_back": "All segments"
			},
			"contacts": {
				"enumeration": "no contacts | {n} contact | {n} contacts",
				"modals": {
					"update": {
						"title": "Update Contacts"
					},
					"delete": {
						"title": "Delete Contacts"
					}
				},
				"title": "Contacts",
				"create": "Create contact",
				"empty_state_msg": "No contacts match filters",
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Created on",
					"updated": "Last updated",
					"company": "Company",
					"source": "Source",
					"email": "Email",
					"gender": "Gender"
				},
				"actions": {
					"export": "Export",
					"update_company": "Add To Company",
					"save_to_project": "Add to project",
					"send_businesskit": "Send a businesskit",
					"error": "There has been an error updating the contact",
					"success": "The contact has been updated successfully",
					"delete": "Delete"
				},
				"filters": {
					"custom_placeholder": "Project attributes...",
					"general": {
						"none": "None assigned"
					},
					"project": {
						"label": "Project name",
						"none": "Belongs to no projects"
					},
					"company": {
						"label": "Company",
						"none": "Belongs to no company"
					},
					"gender": {
						"label": "Gender",
						"options": {
							"male": "Male",
							"female": "Female"
						}
					},
					"language": {
						"label": "Language",
						"options": {
							"en": "English",
							"de": "German"
						}
					},
					"invalid_email": {
						"label": "Email is valid",
						"condition_label": "Email",
						"options": {
							"valid": "valid",
							"not_valid": "not valid"
						}
					},
					"created": {
						"label": "Created"
					},
					"updated": {
						"label": "Updated"
					},
					"city": {
						"label": "City"
					},
					"country": {
						"label": "Country"
					},
					"tags": {
						"label": "Tags"
					},
					"classification": {
						"label": "Classification",
						"options": [
							{
								"value": "unclassified",
								"name": "Unclassified"
							},
							{
								"value": "hot",
								"name": "Hot"
							},
							{
								"value": "warm",
								"name": "Warm"
							},
							{
								"value": "cold",
								"name": "Cold"
							}
						]
					}
				},
				"import": {
					"title": "Import Contacts",
					"description": "Upload a CSV or XLS file containing the contacts to be imported.",
					"format": "The file should contain at least three columns: firstname, lastname and email. Only the email is mandatory but first name and last name are highly recommended.",
					"success_flash": "Contacts were successfully imported",
					"success_modal_title": "Import complete",
					"success_modal_body": "Your contacts have been successfully imported.",
					"success_modal_report": "From the {total} contacts imported, {new} new contacts were created, and {updated} were updated."
				}
			},
			"contact": {
				"edit": "Edit",
				"change_company": "Change",
				"breadcrumb_back": "All contacts",
				"empty_state_text": "This contact has not been captured as a lead yet.",
				"contact_details": "Contact details",
				"company_details": "Company details",
				"created": "Created",
				"updated": "Updated",
				"is_lead_on": "Is lead on",
				"go_to_lead": "Go to lead",
				"tags": "Tags",
				"source": "Source",
				"sources": {
					"web_app": "Web App",
					"mobile_app": "Mobile App",
					"external_form": "External Form",
					"crm_sync": "CRM Sync",
					"upload": "Upload",
					"unknown": "Unknown"
				},
				"caption": {
					"email": "Email",
					"firstname": "First Name",
					"lastname": "Last Name",
					"business_card_job_title": "Job Title",
					"company_department": "Department",
					"phone_mobile": "Mobile Phone",
					"phone_company": "Company Phone",
					"phone_private": "Private Phone",
					"gender": "Gender",
					"language": "Language"
				}
			},
			"xtable": {
				"toggle_columns": "Toggle Columns",
				"actions": "Actions",
				"page_size_label": "View",
				"search_placeholder": "Search",
				"save_search_title": "Save search",
				"save_search_label": "Name",
				"empty_state_label": "No data matches filters",
				"empty_cell_value": "No {name} assigned"
			},
			"xfilters": {
				"confirm_removal": "Yes, remove filter",
				"add_filter": "Add Filter",
				"add_filter_confirm": "Add",
				"delete_filter_warning": "You are about to remove or replace a filter condition which other conditions depend on. If you continue, then all of those dependant conditions will also be removed.",
				"delete_filter_confirmation": "Are you sure you want to continue?",
				"conditions": {
					"operators": {
						"and": "and",
						"or": "or"
					},
					"predicates": {
						"has_any": "has any of",
						"has_all": "has all of"
					},
					"summary": {
						"is": "{0} is {1}",
						"has_all": "{0} has all of {1}",
						"has_any": "{0} has any of {1}",
						"includes": "{0} includes {1}",
						"is_not_assigned": "{0} is not assigned",
						"date_on": "{0} on {1}",
						"date_between": "{0} between {1} and {2}",
						"date_since": "{0} since {1}",
						"date_before": "{0} on or before {1}",
						"date_in_range": "{0} in the {1}",
						"date_in_range_simple": "{0} {1}"
					}
				},
				"xfiltermodal": {
					"date_from": "From",
					"date_to": "To"
				},
				"date_ranges": {
					"custom": "Custom",
					"today": "Today",
					"yesterday": "Yesterday",
					"past_week": "Past week",
					"past_month": "Past month",
					"past_year": "Past year"
				}
			},
			"drag_elements": {
				"gender": "Gender/Salutation",
				"paragraph": "Paragraph",
				"title": "Title",
				"confirmation": "Confirmation",
				"firstname": "Firstname",
				"lastname": "Lastname",
				"email": "Email",
				"company": "Company",
				"street": "Street",
				"street_number": "Street number",
				"zip": "Post code",
				"city": "City",
				"country": "Country",
				"website": "Website",
				"phone_company": "Phone (Company)",
				"phone_mobile": "Phone (Mobile)",
				"textfield": "Textfield",
				"long_textfield": "Long textfield",
				"multi_select": "Multi select",
				"dropdown": "Dropdown",
				"single_select": "Single select",
				"date": "Date",
				"readonly": "Readonly",
				"quantity_selection": "Quantity selection",
				"drawing": "Drawing"
			},
			"breadcrump": {
				"back": "Back",
				"all_projects": "All projects"
			},
			"dashboard": {
				"widget_error": "There was an error loading your data",
				"filter": {
					"dashboard": "Dashboard filter",
					"all_projects": "All projects"
				},
				"leads_collected_label": "Leads collected",
				"hot": "Hot",
				"warm": "Warm",
				"cold": "Cold",
				"unclassified": "Unclassified",
				"most_active_projects": "Most active projects",
				"conversion_funnel": {
					"label": "Conversion funnel",
					"cumulative_conversion": "Cumulative conversion",
					"leads": "Leads",
					"sendouts": "Sendouts",
					"visits": "Kit visits",
					"interactions": "Interactions"
				},
				"kit_activity_label": "Latest interactions",
				"latest_activity": {
					"label": "Newest leads",
					"edited_in": "Edited in",
					"added_to": "Added to",
					"by": "By",
					"incomplete_lead": "Incomplete lead"
				},
				"leads_by_project_label": "Leads by project",
				"leads_by_most_active_projects_label": "Leads by most active projects",
				"leads_by_most_active_projects": {
					"me": "Me",
					"org": "Org"
				},
				"empty_state_headline": "The dashboard will show up once there is enough date",
				"empty_state_intro": "Start creating your first content",
				"empty_state_cta": "Create a project",
				"top_sources_label": "Top sources",
				"active_leads": {
					"label": "Most active leads",
					"today": "Today",
					"last_7": "Last 7 days",
					"last_month": "Last month",
					"last_year": "Last year",
					"all_time": "All time"
				},
				"leads_over_time": {
					"linear": "Leads",
					"cumulated": "Cumulated",
					"label": "Leads over time"
				},
				"axischart": {
					"last_week": "Last week",
					"last_month": "Last month",
					"last_year": "Last year"
				},
				"top_projects": {
					"kits": "Kits",
					"leads": "Leads",
					"my_leads": "My Leads",
					"lead_sheet": "Lead Sheet",
					"empty_state": "You don't have projects yet"
				},
				"top_sources": {
					"last_week": "Last week",
					"last_month": "Last month",
					"last_year": "Last year",
					"web_app": "Web app",
					"external_forms": "External forms",
					"mobile_app": "Mobile app"
				},
				"kit_activity": {
					"all": "All",
					"opened_kit": "Visited",
					"opened": "",
					"updated_a_lead": "updated a lead",
					"empty_state_headline": "No kit activity yet",
					"empty_state_intro": "Create an engaging and personalized content experience that helps genuinely connect with your company.",
					"interacted_with": "Interacted with",
					"view_content_card": "Viewed {count} content card | Viewed {count} content cards",
					"click_content_card": "Clicked one call to action | Clicked {count} call to actions"
				},
				"activity_list_widget": {
					"created_a_lead": "created a lead",
					"updated_a_lead": "updated a lead",
					"on": "on",
					"latest_activity": "Latest activity",
					"empty_state_headline": "No activity yet",
					"empty_state_intro": "Start a project"
				}
			},
			"meta_info": {
				"invitation": "Welcome to Leads",
				"reset_password": "Reset your password"
			},
			"email_template": {
				"placeholders": {
					"firstname": "Firstname",
					"lastname": "Last name",
					"formal": "Formal salutation",
					"informal": "Informal salutation",
					"gender": "Mr/Mrs",
					"form_title": "Form title"
				}
			},
			"external_form": {
				"preview_page": {
					"title": "Embed",
					"head_paragraph": "To include the form on your website, please load the following script into your <head> tag.",
					"html_paragraph": "Then insert the form via html tag where you want it to appear on your page.",
					"script_paragraph": "Then load the form via Javascript.",
					"head_section_title": "Head",
					"html_section_title": "HTML",
					"script_section_title": "Script",
					"forms_cannot_be_submitted": "Please note that forms cannot be submitted in preview mode. You can easily control the form styling via the page on which you embed it."
				},
				"follow_up": "Follow up actions",
				"tabs": {
					"options": "Options",
					"config": "Configuration",
					"editor": "Editor",
					"preview": "Preview"
				},
				"add_element": "Add Elements",
				"add_container": "Add a container",
				"add_field": "Add Fields",
				"preview": "Preview form",
				"empty": "None",
				"fileds": "Leadmask fields",
				"basic_config": "Form configuration",
				"lead_mask_field": "Lead sheet field",
				"form_editor": "Form editor",
				"frontend_actions": "What should happen after a visitor submits the form",
				"backend_actions": "Follow up actions",
				"bk_boarding": "Connect with a businesskit",
				"send_directly": "Send the Businesskit manually?",
				"email_notification": "Send an email notification to lead",
				"add_to_mailchimp": "Add to a mailchimp list",
				"field_assignation": "Field assignments",
				"board_bk": "Board a Businesskit",
				"empty_label": null,
				"success_message": "Display a thank you message",
				"redirection_url": "Redirect URL",
				"send_notification_to": "Send submission email notifications to",
				"mailchimp_list_id": "Mailchimp list id",
				"board_citrix": "Board Citrix",
				"citrix_keys": "Citrix webinar keys",
				"send_lead_confirmation_mail": "Send notification mail to lead",
				"email_template": "Email template",
				"mail_subject": "Email subject",
				"mail_url": "CTA URL",
				"mail_cta": "CTA text"
			},
			"lead_mask_editor": {
				"see_raw": "See lead sheet raw content",
				"edit_element": "Edit selected element",
				"delete_element": "Delete element",
				"title": "Title",
				"cancel": "Cancel",
				"valid": "Confirm",
				"chose_element": "Please choose an element",
				"name": "Name",
				"type": "Type",
				"content": "Content",
				"field": "Field",
				"default_value": "Default value",
				"default_field": "Default field",
				"element_width": "Element width",
				"required": "Required",
				"class": "Class",
				"label": "Label",
				"placeholder": "Placeholder",
				"children": "Children",
				"displayed_name": "Displayed name",
				"value": "Value",
				"add_line": "Add a line",
				"collection": "Collection",
				"delete": "Delete",
				"set_default_value": "Set as default value",
				"basic_config": "Grundeinstellungen",
				"tabs": {
					"general": "General",
					"editor": "Editor"
				}
			},
			"auth": {
				"button": "Login",
				"confirm": "Set password",
				"create_account_subtitle": "Setup your password below",
				"create_account_subtitle_confirm": "You have setup your account successfully. Please login to Leads now.",
				"create_account_title": "Create your account",
				"create_account_title_confirm": "Congratulations",
				"email": "Email address",
				"firstname": "First Name",
				"go_to_login": "To the login",
				"password": "Password",
				"password_confirmation": "Confirm password",
				"password_reset": "Password forgotten ?",
				"password_reset_request_title": "Reset your password",
				"password_reset_request_title_confirm": "Check your email inbox",
				"password_reset_sent": "An email with a password reset link has been sent to the given email if it exists.",
				"password_reset_title": "Password reset",
				"password_reset_title_confirm": "Congratulations",
				"lastname": "Last Name",
				"return_to_login": "Get back to login page",
				"success": "Your password has been set successfully. You can now login into the Fanomena Leads products.",
				"user_not_found": "User not found",
				"user_not_found_subtitle": "We're sorry but the user you are trying to access was not found in our system.<br/>Maybe your invitation link has expired or the user has been deleted."
			},
			"auth_illustration": {
				"contact_us": "Contact us",
				"get_access": "Get your access",
				"invitation_subtitle": "Explore your opportunities",
				"invitation_title": "Want to know more about Fanomena Leads?",
				"login_subtitle": "Let us show you Fanomena Leads",
				"login_title": "New here and want to look around?",
				"reset_request_subtitle": "Let us help you",
				"reset_request_title": "Impossible to recover?",
				"reset_subtitle": "Let us help you",
				"reset_title": "Impossible to recover?"
			},
			"business_kit": {
				"preview": "Preview Businesskit",
				"confirmation": "This confirms that information material has been requested and may be sent.",
				"history": "Businesskits sent",
				"send": "Send a businesskit",
				"send_confirm": "Send businesskit",
				"activity": "No send out activity yet"
			},
			"button": {
				"double_optin": "Sure?",
				"contacts": {
					"create": "Create new",
					"import": "Import",
					"save_as_segment": "Save as segment"
				},
				"companies": {
					"create": "Create new",
					"delete": "Delete company"
				},
				"segments": {
					"new": "Create Segment",
					"save": "Save Segment"
				},
				"segment": {
					"save": "Save segment"
				},
				"plans": {
					"new": "Add a plan"
				},
				"external_forms": {
					"new": "Add a form"
				},
				"external_form": {
					"add_popup": "Add a form",
					"save": "Save",
					"publish": "Publish"
				},
				"lead_mask": {
					"save": "Save",
					"publish": "Publish"
				},
				"lead_masks": {
					"add_popup": "Add a lead sheet"
				},
				"opt-ins": {
					"new": "Add an opt-in"
				},
				"organizations": {
					"new": "Add an organization"
				},
				"email_templates": {
					"new": "Add a template"
				},
				"project_leads": {
					"add_popup": "Add lead",
					"confirm_mail": "Confirm email address",
					"confirm_picture": "Save & continue",
					"continue": "New Company",
					"create": "Create lead",
					"export": "Export xls",
					"make_another_picture": "Make another",
					"new": "Add lead",
					"take_picture": "Take a picture of a business card"
				},
				"projects": {
					"new": "Create a project"
				},
				"users": {
					"invite": "Invite",
					"invite_xls": "Invite via xls",
					"import_contacts": "Import Contacts",
					"new": "Add a user",
					"upload_xls": "Proceed"
				},
				"workflow": {
					"trigger": "Trigger workflow now",
					"add_popup": "Create new workflow"
				},
				"workflows": {
					"new": "Create new workflow",
					"trigger": "Trigger workflow"
				}
			},
			"filters": {
				"apply": "Apply",
				"hint": "Filter search results",
				"import_origin": "Import origin",
				"origin": "Lead origin",
				"reset": "Reset",
				"start_date": "Start date",
				"sync_disabled": "CRM sync",
				"sync_status": "Sync status",
				"categories": "Categories"
			},
			"footer": {
				"imprint": "Imprint",
				"privacy": "Privacy",
				"terms": "Terms",
				"security": "Security"
			},
			"onboarding": {
				"next": "Next",
				"skip": "Skip",
				"start": "Start",
				"step1": {
					"title": "Create a Project",
					"subtitle": "Create a project in just a few clicks and start digitizing your next event or marketing campaign."
				},
				"step2": {
					"title": "Start Capturing Leads",
					"subtitle": "Automatically save lead contact details by using your smart phone to scan business cards or connect Fanomena Leads customizable web forms to your next digital marketing campaign."
				},
				"step3": {
					"title": "Create Content",
					"subtitle": "Create and distribute personalized digital content to enhance the nurturing process and  convert more leads to customers."
				}
			},
			"content_manager": {
				"first-card": {
					"title": "Businesskits",
					"subtitle": "Create an engaging and personalized content experience that helps genuinely connect with your company.",
					"btn": "Create a businesskit"
				},
				"second-card": {
					"title": "Forms",
					"subtitle": "Create custom web forms that connect directly to your existing marketing solutions (webinar tool, CRM,etc.) to onboard new prospects and automate the follow-up process.",
					"btn": "Create a form"
				},
				"third-card": {
					"title": "Lead Sheets",
					"subtitle": "Create a custom digital lead sheet to gather everything you need for the lead nurturing process.",
					"btn": "Contact support"
				}
			},
			"empty_state": {
				"projects": {
					"title": "Start Creating a New Project",
					"title-standard-user": "Welcome to Leads",
					"subtitle": "Digitize your lead management process and start tracking your data all in one place.",
					"standard-user": "You're not assigned to any project yet, please contact your administrator to get started.",
					"btn": "Send e-mail reminder",
					"success_message": "The e-mail reminder has been successfully sent."
				},
				"leads": {
					"title": "Start capturing leads for your project.",
					"subtitle": "Capture the information you need to nurture prospects into customers."
				}
			},
			"taglist": {
				"label": "Project Labels"
			},
			"global": {
				"add": "Add",
				"assign": "Assign",
				"back": "Back",
				"back_to_home": "Go back to the homepage",
				"cancel": "Cancel",
				"confirm": "Confirm",
				"continue": "Continue",
				"delete": "Delete",
				"delete_confirmation": "Are you sure you want to delete {name}?",
				"update_conformation": "Are you sure you want to update {name}?",
				"delete_title": "Delete this item?",
				"lead_edit_abort": "Do you really want to leave? There are unsaved changes!",
				"edit": "Edit",
				"empty_collection": "There are no items yet",
				"no_results": "Sorry, there are no results.",
				"no": "No",
				"save": "Save",
				"show": "Show",
				"take_picture": "Take a picture",
				"unassign": "Remove",
				"valid": "Confirm",
				"yes": "Yes",
				"ok": "Ok",
				"warning": "Warning",
				"date_time": {
					"today": "today",
					"yesterday": "yesterday",
					"seconds_ago": "a few seconds ago",
					"less_than_minute": "less than a minute ago",
					"minutes_ago": "a few minutes ago",
					"now": "now",
					"at": "at"
				}
			},
			"header": {
				"add-lead": "Add a lead",
				"add-project": "Add a project"
			},
			"language": {
				"change": "Change language:",
				"de": "DE",
				"en": "EN /"
			},
			"menu": {
				"project_assignments_edit": "Assignments",
				"businesskits": "Businesskits",
				"plans": "Plans",
				"change-language": "Change language to German",
				"profile": "Profile",
				"business_kits": "All Businesskits",
				"dashboard": "Dashboard",
				"editor": "Editor",
				"external_forms": "Forms",
				"external_form_editor": "Editor",
				"external_form_options": "Options",
				"external_form_preview": "Preview",
				"general_settings": "General settings",
				"lead_masks": "Lead Sheets",
				"lead_mask_editor": "Editor",
				"lead_mask_options": "Options",
				"logout": "Logout",
				"manage_projects": "Manage projects",
				"organizations": "Organizations",
				"options": "Options",
				"project_edit": "Project settings",
				"preview": "Preview",
				"project_leads": "Leads",
				"project_statistics": "Statistics",
				"projects": "Projects",
				"projects_synchronize": "Sync with CRM",
				"settings": "Manage users",
				"statistics": "Statistics",
				"trackings": "Trackings",
				"email_templates": "Email Templates",
				"user_profile": "Profile settings",
				"users": "Collaborators",
				"content_manager": "Manage",
				"contact_manager": "Contact Manager",
				"contacts": "Contacts",
				"companies": "Companies",
				"segments": "Segments",
				"sync": "Sync",
				"workflows": "Workflows",
				"people": "People",
				"menu_tab_lead_capture": "Lead Capture",
				"menu_tab_settings": "Settings"
			},
			"organizations": {
				"api": "External services",
				"configuration": "Configuration",
				"general_settings": "General settings"
			},
			"pages": {
				"plans": "Plans",
				"plan-rules": "Rules",
				"plan-organizations": "Organizations",
				"businesskits": "All businesskits",
				"contact_us": "Contact us",
				"contact_us_email": "mailto:leads@fanomena.io?subject=Account%20recovery&body=Dear%20Fanomena%20Team%2C%0A%0AI%20am%20not%20able%20to%20log%20into%20my%20account%2C%20and%20have%20not%20been%20able%20to%20successfully%20reset%20my%20password.%20Can%20you%20please%20assist%20me%3F%0A%0ABest%2C",
				"email-templates": "Email templates",
				"email-templates-update": "Edit a template",
				"email-templates-create": "Create a template",
				"email-templates-new": "Create a template",
				"email-templates-create-button": "Create template",
				"email-templates-update-button": "Update template",
				"email-templates-new-button": "Create a template",
				"external-forms": "External forms",
				"external-forms--button": "Add a form",
				"external-forms-create-button": "Create form",
				"external-forms-update-button": "Edit form",
				"get_your_access": "Get your access",
				"item-create": "Create",
				"item-new": "New",
				"item-update": "Edit {name}",
				"lead-create": "Capture a lead",
				"lead-download-pdf-succeed": "PDF successfully downloaded. It will open in a new window.",
				"lead-download-pdf-error": "PDF cannot be downloaded due to an error with the Businesscard image.",
				"lead-edit": "Edit a lead",
				"lead-mask-create-button": "Create lead sheet",
				"lead-mask-edit": "Edit {name}",
				"lead-mask-update-button": "Update lead sheet",
				"lead-masks": "Lead Sheets",
				"lead-no-businesskit": "There is no Businesskit assigned to this project",
				"lead-statistics": "Lead statistics",
				"lead-statistics-overview": "Overview",
				"lead-statistics-trackings": "Trackings",
				"lead-change-count": "Change made: {num} | Changes Made: {num}",
				"login": "Welcome",
				"login_details": "Enter you details to continue",
				"logout": "Thank you",
				"logout_details": "Thank you for using a product by Fanomena.",
				"opt-ins": "All opt-ins",
				"organization-edit": "Edit {name}",
				"organization-edit-button": "Update organization",
				"organization-new": "Create an organization",
				"organization-new-button": "Create organization",
				"organization-create-button": "Create organization",
				"organization-update-button": "Update organization",
				"organizations": "All organizations",
				"password_reset": "Enter your new password below",
				"password_reset_confirm": "Your password has been reset successfully",
				"password_reset_request": "Enter your email and we will send you a link, where you can recover your password",
				"password_reset_request_confirm": "An email with a password reset link has been sent to the given email if it exists.",
				"project-assign": "Assign to project",
				"project-assign-businesskit": "Assign businesskits",
				"project-assign-user": "Assign collaborators",
				"project-assigned-businesskit": "Businesskits",
				"project-no-assigned-user": "There are no collaborators assigned to this project",
				"project-no-assigned-businesskit": "There are no businesskits assigned to this project",
				"project-assigned-user": "Collaborators",
				"project-assignments": "Project assignments",
				"project-create": "Add a new project",
				"project-create-button": "Create project",
				"project-download-data": "Receive data as xls",
				"project-download-data-suceed": "The xls had been sent to your email address",
				"project-edit": "Edit {name}",
				"project-edit-user": "Edit",
				"project-options": "Project options",
				"project-show": "{name}",
				"project-update-button": "Save",
				"projects": "Projects",
				"statistic-show": "Statistic details: {name}",
				"statistics": "Statistics",
				"take_a_tour": "To the website",
				"user-edit": "Edit {name}",
				"user-edit-button": "Update collaborator",
				"user-invite": "Invite a collaborator",
				"user-new-button": "Add collaborator",
				"user-show": "collaborator: {name}",
				"user-update-button": "Update collaborator",
				"users": "Collaborators",
				"project-next-button": "Next",
				"project-capture-leads": "Capture Leads",
				"project-create-content": "Create Content",
				"previous": "Back",
				"workflow-update-button": "Update workflow",
				"workflows": "Workflows",
				"contacts": "All contacts",
				"companies": "Companies",
				"segments": "All segments"
			},
			"project_wizard": {
				"step1-title": "Setup Project",
				"step2-title": "Choose Lead Sheet",
				"step2-invite-users": "Invite new collaborator to Fanomena Leads",
				"step2-assign-users": "Assign an existing Fanomena Leads user to this project",
				"lead-sheets": "Lead Sheets",
				"leadsheet-create": "Create Custom Lead Sheet",
				"leadsheet-create-tip": "Contact us if you are interested in creating a custom lead sheet.",
				"leadsheet-basic": "Digital lead sheet to capture personal and company lead details",
				"leadsheet-advanced": "Digital lead sheet that includes all standard lead sheet elements and additional questions to qualify your lead.",
				"success-title": "Congratulations! You have successfully created your project.",
				"success-subtitle": "What would you like to do next?",
				"step2-invite": "To assign existing Fanomena Leads users to this project, go to the Project Settings after setting up your project."
			},
			"searchbar": {
				"placeholder": {
					"bk": "Enter a businesskit name…",
					"email_templates": "Enter a specific name…",
					"external_forms": "Enter a specific name or project…",
					"lead_masks": "Enter a specific name…",
					"organizations": "Enter a specific organization name…",
					"projects": "Search for a project…",
					"contacts": "Search for a contact…",
					"project_leads": "Search for lead or company…",
					"users": "Enter a firstname, lastname or email…"
				}
			},
			"tabs": {
				"company_tab": "Company",
				"kits_tab": "Kits",
				"personal_tab": "Personal",
				"qualify_tab": "Qualify",
				"stats_tab": "Stats"
			},
			"upload": {
				"dropzone_message": "Drag and drop or click to upload a file",
				"empty_file": "Remove the file"
			},
			"users": {
				"invite": "Invite a collaborator",
				"invite_xls_success": "Users were successfully invited",
				"xls_invite": "Invite via xls",
				"xls_invite_description": "You can provide a xls file containing the user you want to invite. They will receive an invitation email.",
				"xls_invite_format": "The xls file should contains three columns: firstname, lastname and email. Only the email is mandatory but first name and last name are highly recomended."
			},
			"integrations": {
				"go-to-webinar": "Automatically add all leads that fills out your form to a webinar"
			},
			"modals": {
				"download_app": {
					"title": "Download the mobile App",
					"subtitle": "Enhance your experience for capturing leads with our mobile application",
					"skip": "Maybe later"
				},
				"businesskit_assignment": {
					"title": "Manage Businesskits",
					"subtitle": "Select the Businesskits that you want to assign to the current project."
				},
				"user_assignment": {
					"title": "Manage collaborators",
					"subtitle": "Select the collaborators that you want to assign to the current project."
				},
				"workflow": {
					"create": {
						"title": "Create a workflow"
					}
				},
				"warning": {
					"button": "I understand"
				}
			},
			"drag_editor": {
				"no_label": "No label",
				"extra_values": "and {num} extra.",
				"unpublished_changes": "There are unpublished changes",
				"popup": {
					"unsaved_changes": "You have unsaved changes. Do you really wish to leave?"
				},
				"active_item": {
					"edit": "Edit selected element",
					"label": "Label",
					"value": "Value"
				},
				"fields": {
					"add_item": "Add item",
					"label": "Label",
					"text": "Text",
					"placeholder": "Placeholder text",
					"required": "Make this field required",
					"hidden": "Make this field hidden",
					"class": "CSS class",
					"default_value": "Default value",
					"default_value_options": "Preselect",
					"validation": "Error message",
					"internal_name": "Internal name",
					"show_as_buttons": "Show elements in button style",
					"enrich_tags": "Save selection as tags",
					"data_type": "Data type",
					"data_types": {
						"text": "Text",
						"number": "Number",
						"email": "Email",
						"tel": "Telephone number",
						"url": "Url"
					}
				},
				"dragElements": {
					"generic": "Generic Elements",
					"leadMask": "Lead Mask Elements",
					"basic": "Basic elements",
					"fields": "Fields",
					"advanced": "Custom fields",
					"standard": "Standard fields"
				},
				"badges": {
					"hidden": "Hidden Field"
				},
				"placeholders": {
					"anchor": "Link",
					"bold": "Bold",
					"italic": "Italic",
					"underline": "Underline"
				},
				"screenTooSmall": {
					"title": "Sorry!",
					"subtitle": "In order to use our editor please switch to a higher resolution."
				}
			}
		}
	}
};

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

module.exports = {
	"de-tal": {
		"errors": {
			"contact": {
				"not_found": "Dieser Kontakt existiert nicht"
			},
			"plans": {
				"free_trial": {
					"expired_title": "Ihre kostenfreie Testversion ist abgelaufen.",
					"expired_description": "Bitte klicken Sie auf den Button unten, um mit uns Kontakt aufzunehmen und Fanomena Talent weiterhin zu nutzen.",
					"expired_button": "Vertrieb Kontaktieren"
				},
				"not_allowed_modal": {
					"title": "Erweitern Sie Ihren Leistungsumfang.",
					"description": "Die von Ihnen gewählte Funktion ist in Ihrem aktuellen Leistungsumfang nicht verfügbar. Bitte kontaktieren Sie uns über den Chat oder über den untenstehenden Link und wechseln Sie ins nächste Paket.",
					"button": "Vertrieb Kontaktieren"
				},
				"not_found": "Bitte wählen Sie ein Paket."
			},
			"api_error_modal": {
				"no_name": "Kein Name",
				"select_company": "Wählen Sie das Unternehmen für Ihr Talent aus"
			},
			"emailtemplate": {
				"name": {
					"invalid": "Bitte trag einen Namen ein"
				},
				"body": {
					"invalid": "Bitte trag einen Text ein"
				}
			},
			"externalform": {
				"name": {
					"invalid": "Bitte trag einen Namen ein"
				},
				"language": {
					"invalid": "Bitte wähle eine Sprache"
				},
				"project_id": {
					"invalid": "Bitte wählen Sie eine Kampagne aus"
				}
			},
			"users": {
				"xls_import": {
					"wrong_file": "Bitte wähle eine gültige Datei"
				}
			},
			"organization": {
				"name": {
					"valid": "Bitte trag einen Namen ein"
				}
			},
			"authentication": {
				"empty_firstname": "Der Vorname ist leer. Bitte trag ein Vorname ein.",
				"empty_lastname": "Der Nachname ist leer. Bitte trag ein Nachname ein.",
				"empty_password": "Das Passwort ist leer. Bitte trag ein Passwort ein.",
				"logout": "Danke, dass Du Fanomena Talent benutzt hast. Bis bald.",
				"unauthorized": "Falsche Benutzername/Passwort Kombination! Der Benutzer konnte nicht angemeldet weden.",
				"wrong_email": "Das Format der E-Mail ist falsch",
				"wrong_jwt": "Deine Anmeldung ist abgelaufen. Bitte logge Dich erneut ein.",
				"wrong_password": "Das eingetragene Passwort ist ungültig. Bitte trage mindestens 8 Zeichen ein, wovon mindestens ein Buchstabe und eine Zahl enthalten sein muss.",
				"wrong_password_confirmation": "Die Passwörter stimmen nicht überein."
			},
			"base_score_error": "Die Basisbewertung sollte nur Zahlen enthalten",
			"compatibility": {
				"webcam": {
					"ios": "iPhone unterstützt die webcam API nicht. Bitte lade ein Bild aus Deiner Gallerie hoch.",
					"safari": "Vielen Dank für die Nutzung von Fanomena Talent. Für die beste Nutzung des Produkts zur Erfassung neuer Talente empfehlen wir unsere mobile App. Alternativ können Sie auch mit dem Browser Google Chrome fortfahren.",
					"firefox": "Vielen Dank für die Nutzung von Fanomena Talent. Bitte nutzen Sie als Browser Google Chrome, damit Sie auf alle Funktionalitäten von Fanomena Talent zugreifen können."
				}
			},
			"external_form": {
				"json": {
					"invalid": "Das json-Format ist ungültig."
				}
			},
			"lead": {
				"duplicate_email": "Diese E-Mail existiert bereits.",
				"email": {
					"empty": " ",
					"invalid": "",
					"taken": "Diese E-Mail Adresse existiert bereits"
				},
				"phone_company": {
					"invalid": "Ungültiges Format der Telefonnummer"
				},
				"wrong_tag_format": "Ein Tag kann nur aus Buchstaben und Zahlen bestehen."
			},
			"lead_mask": {
				"json": {
					"invalid": "Das json-Format ist ungültig."
				},
				"missing_elements": {
					"firstname": "Ihr Berichtsbogen hat kein \"Vorname\" Feld. Bitte fügen Sie es hinzu.",
					"lastname": "Ihr Berichtsbogen hat kein \"Nachname\" Feld. Bitte fügen Sie es hinzu.",
					"email": "Ihr Berichtsbogen hat kein \"E-Mail\" Feld. Bitte fügen Sie es hinzu."
				},
				"missing_values": "Ein Feld in Ihrem Berichtsbogen hat keine zusätzlichen Werte. Bitte fügen Sie mindestens eins hinzu."
			},
			"leadmask": {
				"name": {
					"invalid": "Bitte einen Namen eingeben"
				},
				"language": {
					"invalid": "Bitte gib eine Sprache an"
				}
			},
			"project": {
				"category": {
					"invalid": "Die Kategorie ist ungültig"
				},
				"end_date": {
					"invalid": "Das Enddatum ist ungültig"
				},
				"name": {
					"invalid": "Name ist ungültig"
				},
				"start_date": {
					"invalid": "Das Startdatum ist ungültig"
				},
				"not_found": "Die gesuchte Kampagne konnte nicht gefunden werden",
				"lead_mask_id": {
					"invalid": "Bitte wähle einen Berichtsbogen"
				}
			},
			"server_unreachable": "Der Server antwortet nicht",
			"unauthorized": "Die Seite die Du aufrufen willst ist für Dich gesperrt.",
			"token": {
				"invalid": "Dein Anmelde-Token ist ungültig oder abgelaufen"
			},
			"user": {
				"duplicate_email": "Diese E-Mail Adresse ist bereits registriert. Bitte wähle eine andere E-Mail.",
				"email": {
					"empty": "Die E-Mail Adresse fehlt",
					"invalid": "Die E-Mail Adresse ist ungültig"
				},
				"organization": {
					"invalid_plan": "Der Plan dieser Organisation ist ungültig oder abgelaufen."
				},
				"xls_import": {
					"wrong_file": "Diese Datei kann nicht verwendet werden"
				}
			}
		},
		"eventbaxx_event": {
			"association_mismatch": "Fehlercode'eventbaxx_event.association_mismatch'. Bitte kontaktieren unser Kundendienstteam.",
			"lead": {
				"email": {
					"invalid": "Das Business Kit kann nicht gesendet werden weil die E-Mailadresse fehlerhaft ist"
				}
			}
		}
	}
};

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

module.exports = {
	"en-tal": {
		"errors": {
			"contact": {
				"not_found": "The contact you are looking for does not exist"
			},
			"plans": {
				"free_trial": {
					"expired_title": "Your free trial has expired.",
					"expired_description": "Your Fanomena Talent account has been paused, but will be reactivated once you upgrade your plan. Please click the button below to contact us and continue using Fanomena Talent.",
					"expired_button": "Contact Sales"
				},
				"not_allowed_modal": {
					"title": "Please upgrade your plan.",
					"description": "The feature that you have selected is not available in your current plan. Please contact us via intercom chat or through the link below to connect with a member of our team who can assist in upgrading your existing plan in Fanomena Talent.",
					"button": "Contact Sales"
				},
				"not_found": "Please select a plan."
			},
			"api_error_modal": {
				"no_name": "No name",
				"select_company": "Select a company",
				"select_company_caption": "The following companies match with the domoain of the email. Please select one to continue"
			},
			"emailtemplate": {
				"name": {
					"invalid": "Please enter a name"
				},
				"body": {
					"invalid": "Please enter a body text"
				}
			},
			"externalform": {
				"name": {
					"invalid": "Please enter a name"
				},
				"language": {
					"invalid": "Please select a language"
				},
				"project_id": {
					"invalid": "Please select a campaign"
				}
			},
			"users": {
				"xls_import": {
					"wrong_file": "Please select a valid file"
				}
			},
			"organization": {
				"name": {
					"valid": "Please enter a name"
				}
			},
			"wrong_email_format": "The email is incorrect",
			"authentication": {
				"empty_firstname": "The first name is empty. Please enter a first name.",
				"empty_lastname": "The last name is empty. Please enter a last name.",
				"empty_password": "The password is empty. Please enter a password.",
				"logout": "Thank you for using Fanomena Talent, see you soon",
				"unauthorized": "Incorrect user/password combination! Could not authenticate user!",
				"wrong_email": "The email format is incorrect.",
				"wrong_jwt": "Your authentification credentials expired, please login again",
				"wrong_password": "The password is not valid. Must contain at least 8 characters, one letter and one number.",
				"wrong_password_confirmation": "The passwords do not match."
			},
			"base_score_error": "Base score should only contain numbers",
			"compatibility": {
				"webcam": {
					"ios": "iPhone doesn't support the webcam API. Please upload a picture from your gallery.",
					"safari": "Thank you for using Fanomena Talent. For full use of the product to capture new talents please download our mobile app or switch your browser to Google Chrome.",
					"firefox": "Thank you for using Fanomena Talent. Please switch your browser to Google Chrome for full use of the product to capture new talents."
				}
			},
			"external_form": {
				"json": {
					"invalid": "The json format is invalid."
				}
			},
			"lead": {
				"duplicate_email": "This email already exists",
				"email": {
					"empty": " ",
					"invalid": "The email is invalid",
					"invalid_domain": "The email domain is invalid",
					"taken": "This email address is already taken"
				},
				"phone_company": {
					"invalid": "Invalid phone number format"
				},
				"wrong_tag_format": "A tag can only contains letters and numbers"
			},
			"lead_mask": {
				"json": {
					"invalid": "The json format is invalid."
				},
				"missing_elements": {
					"firstname": "Your talent sheet is missing the \"firstname\" field. Please add it.",
					"lastname": "Your talent sheet is missing the \"lastname\" field. Please add it.",
					"email": "Your talent sheet is missing the \"email\" field. Please add it."
				},
				"missing_values": "One of your talentsheet fields is missing additional values. Please add at least one."
			},
			"leadmask": {
				"name": {
					"invalid": "Please add a name"
				},
				"language": {
					"invalid": "Please add a language"
				}
			},
			"project": {
				"category": {
					"invalid": "The category is invalid"
				},
				"end_date": {
					"invalid": "The end date is invalid"
				},
				"name": {
					"invalid": "Name is invalid"
				},
				"start_date": {
					"invalid": "The start date is invalid"
				},
				"not_found": "The campaign you were looking for could not be found",
				"lead_mask_id": {
					"invalid": "Please select a talent sheet"
				}
			},
			"server_unreachable": "The server does not respond",
			"token": {
				"invalid": "The token is invalid or expired."
			},
			"unauthorized": "The page you're trying to access is unauthorized",
			"user": {
				"duplicate_email": "The email is already registered. Please choose another.",
				"organization": {
					"invalid_plan": "The plan of this organization is either invalid or expired."
				},
				"email": {
					"empty": "The email is empty",
					"invalid": "The email is invalid"
				},
				"xls_import": {
					"wrong_file": "This file can't be used for user import."
				}
			}
		},
		"eventbaxx_event": {
			"association_mismatch": "Error-code 'eventbaxx_event.association_mismatch'. Please contact our customer support team.",
			"lead": {
				"email": {
					"invalid": "The businesskit cannot be sent because this talent's email address is not valid"
				}
			}
		}
	}
};

/***/ }),
/* 2037 */
/***/ (function(module, exports) {

module.exports = {
	"de-tal": {
		"models": {
			"auth": {
				"remember_me": "Für 7 Tage angemeldet bleiben"
			},
			"business_kit": {
				"action": "",
				"date": "Datum",
				"fail": "Das Versenden des Talentkits ist fehlgeschlagen",
				"id": "id",
				"name": "Name",
				"select": "Wähle ein Talentkit",
				"sent": "Dein Talentkit wurde verschickt",
				"create_template": "Template erstellen",
				"status": {
					"email_sent": "Gesendet",
					"sendout_enqueued": "Gesendet",
					"transferred": "Übermittelt"
				},
				"missing": {
					"email": "Du musst erst ein Talentkit-E-Mail-Template erstellen bevor Du dieses Talentkit verschicken kannst."
				}
			},
			"external_form": {
				"action": "Aktion",
				"configuration": "Konfiguration",
				"additional_data": "Erweiterte Daten",
				"email_recipient_address": "Schicke an",
				"id": "#",
				"language": "Sprache",
				"message": {
					"create": "Das Formular wurde erfolgreich erstellt",
					"update": "Das Formular wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"project_id": "Kampagne",
				"project_name": "Kampagne",
				"project__name": "Kampagne",
				"slug": "Slug",
				"structure": "Struktur",
				"title": "Formular Titel",
				"duplicate": "",
				"duplicate_desc": "Formular duplizieren",
				"duplicate_project_desc": "Kampagne duplizieren"
			},
			"lead_mask": {
				"action": "Aktion",
				"default": "Standard Maske ?",
				"yes": "Ja",
				"no": "Nein",
				"id": "#",
				"language": "Sprache",
				"message": {
					"create": "Die Berichtsbogen wurde erfolgreich erstellt.",
					"update": "Die Berichtsbogen wurde erfolgreich aktualisiert."
				},
				"name": "Name",
				"organization": "Organisation",
				"organization_name": "Organisation",
				"project": "Kampagne",
				"slug": "Slug",
				"structure": "Struktur",
				"duplicate": "",
				"duplicate_desc": "Berichtsbogen duplizieren"
			},
			"opt-in": {
				"businesskit__name": "Talentkit Name",
				"id": "#",
				"project__name": "Kampagnen Name",
				"subdomain": "Subdomain",
				"template_name": "Template Name"
			},
			"organization": {
				"action": "",
				"action_delete": "",
				"city": "Stadt",
				"country": "Land",
				"id": "Id",
				"message": {
					"create": "Die Organisation wurde erfolgreich erstellt",
					"update": "Die Organisation wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"status": "",
				"street": "Straße",
				"street_number": "Hausnummer",
				"users__count": "Benutzer",
				"website": "Webseite",
				"zip": "PLZ"
			},
			"organizations": {
				"successfully_started_crm_sync": "CRM Synchronisation erfolgreich gestartet"
			},
			"project": {
				"action": "Aktion",
				"background_xml_export_enabled": "Talent App Synchronisation aktivieren",
				"base_score": "Basisbewertung",
				"business_kits_count": "Talentkits",
				"businesskit_to_assign": "Talentkit zuweisen",
				"scope_leads": "Benutzer können nur ihre eigenen Talente sehen",
				"category": "Kategorie",
				"crm_campaign_id": "CRM Kampagnen ID",
				"crm_sales_employee_id": "CRM Vertriebsmitarbeiter ID",
				"crm_marketing_employee_id": "CRM Marketingmitarbeiter ID",
				"crm_group_code_id": "CRM Gruppencode ID",
				"enable_lead_review": "Aktiviere manuellen Review von Talenten für Root",
				"end_date": "Enddatum der Kampagne",
				"hot_leads_count": "Heiße Talents",
				"id": "#",
				"is_opt_in": "Ist Opt-In?",
				"lead_mask": "Berichtsbogen",
				"lead_mask_id": "Wähle eine vorhandene Talentmaske aus",
				"leads_count": "Talente",
				"leads_not_synced_count": "Pending Talents",
				"location": "Ort",
				"mailchimp_list_id": "Mailchimp-Liste ID",
				"message": {
					"create": "Die Kampagne wurde erfolgreich erstellt",
					"update": "Die Kampagne wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"organization": "Organisation",
				"organization_name": "Organisation",
				"organization_id": "Organisation",
				"period": "Zeitraum",
				"set_aditional_data_content": "Zusätzliche Daten anzeigen und einstellen",
				"start_date": "Startdatum der Kampagne",
				"sync_disabled": "CRM Syncronisation",
				"unsynced_leads_count": "Sync Status",
				"user_to_assign": "Benutzer zuweisen",
				"unsynced_leads_count_success": "Synchronisiert",
				"duplicate": "",
				"default_classification": "Standard-Klassifizierung",
				"business_kit_id": "Talentkits"
			},
			"project_lead": {
				"location": "Standort",
				"situation": "Situation",
				"employed_by": "Beschäftigt bei",
				"career_level": "Karrierestufe",
				"academic_title": "Titel",
				"action": "Aktion",
				"advancement": "Fortschritt",
				"branch": "Zielgruppe",
				"business_card_job_title": "Job-Titel",
				"capturer": "Erfasser",
				"capturer_unknown": "Nicht zugeordnet",
				"city": "Stadt",
				"classification": "Einordnung",
				"company": "Firma",
				"company-name": "Firmenname",
				"company_department": "Abteilung",
				"company_function": "Funktion",
				"company_role": "Rolle",
				"company_website": "Firmen-Webseite",
				"conversation_notes": "Notizen",
				"country": "Land",
				"crawled_infos": {
					"by": "von",
					"founded": "Gegründet",
					"linkedin": "LinkedIn Profil",
					"more_infos": "Mehr Informationen",
					"phone_number": "Telefonnummer",
					"tags": "Tags",
					"title_website": "Titel der Webseite",
					"tweets": "Tweets",
					"category": "Kategoien",
					"description": "Beschreibung",
					"domain": "Webseite",
					"emailAddresses": "E-Mails",
					"foundedYear": "Gegründet",
					"location": "Location",
					"metrics": "Metrics",
					"name": "Firmenname",
					"phoneNumbers": "Telefonnummern"
				},
				"found_existing": "Wir haben bereits existierende Daten für diesen Talent gefunden und diese übernommen.",
				"predicted_name": "Basierend auf der E-Mail Adresse konnten wir bereits Daten zum Kontakt ermitteln.",
				"created": "Der Talent wurde erfolgreich erstellt.",
				"created_at": "Erstellt",
				"email": "E-Mail",
				"exhibition_visitor_count": "Anzahl Messebesucher",
				"firstname": "Vorname",
				"full_street": "Straße & Nr",
				"gender": "Anrede",
				"id": "#",
				"import_origin": "",
				"interested_in": "Interessiert an",
				"kit_status": "",
				"language": "Sprache",
				"lastname": "Nachname",
				"message": {
					"changes_pending": "Es gibt Änderungen. Zuletzt gespeichert",
					"changes_saved": "Letzte Änderungen:",
					"create": "Der Talent wurde erfolgreich erstellt",
					"create_from_card": "Visitenkarte scannen",
					"create_from_email": "E-Mail Adresse eintragen",
					"leads_exists": "Der Talent existiert bereits aber er wurde zur aktuellen Kampagne hinzugefügt",
					"no_business_card": "Keine Visistenkarte hochgeladen",
					"update": "Der Talent wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"origin": "",
				"phone_company": "Firmen-Telefon",
				"phone_mobile": "Mobiltelefon",
				"progress_complete": "Alle Pflichtfelder wurden ausgefüllt",
				"progress_indicator_businesskit": "Fortschritt",
				"progress_indicator_crm": "Status",
				"progress_indicator_lead_mask": "Status",
				"project_planned": "Kampagne geplant",
				"salutation": "Ansprasche",
				"start_date": "Erstellt am",
				"status": "Status",
				"street": "Straße",
				"street_number": "Nummer",
				"sync_disabled": "CRM Sync",
				"sync_status": "CRM",
				"sync_statuses": {
					"no_crm": "Kein CRM konfiguriert",
					"no_crm_desc": "Die Organisation hat kein CRM konfiguriert",
					"not_sync_ready": "Nicht bereit",
					"not_sync_ready_desc": "Das Talent hat nicht alle für den CRM Sync notwendigen Felder ausgefüllt",
					"not_synced": "Nicht synchronisiert",
					"not_synced_desc": "Das Talent wurde aus dem CRM importiert aber noch nicht bearbeitet.",
					"processing": "Synchronisiere",
					"processing_desc": "Das Talent synchronisiert gerade",
					"sync_disabled": "Deaktiviert",
					"sync_disabled_desc": "Das Talent ist bereit zum Synchronisieren aber die Talent Synchronisation ist deaktiviert",
					"sync_error": "Fehler",
					"sync_error_desc": "Die Talent Synchronisation hat zu einem Fehler geführt",
					"sync_ready": "Bereit",
					"sync_ready_desc": "Das Talent ist bereit zum Synchronisieren",
					"synced": "Synchronisiert",
					"synced_desc": "Das Talent wurde synchronisiert"
				},
				"title": "Titel",
				"updated_at": "Letzte Bearbeitung",
				"user_id": "Talent-Erfasser",
				"zip": "PLZ",
				"import_origins": {
					"crm": "Vom CRM importiert"
				},
				"origins": {
					"mobile_app": "Via App",
					"web_app": "Via Cloud"
				},
				"sync_missing_fields": "Noch nicht vollständig:"
			},
			"select_role": {
				"user": "Standard Benutzer",
				"admin": "Administrator"
			},
			"select_situation": {
				"seeking": "Suchend",
				"interested_in": "Interessiert",
				"employed_by": "Beschäftigt bei"
			},
			"select_scope": {
				"organization": "Organisation",
				"project": "Kampagne"
			},
			"select_career_level": {
				"secondary_education": "Sekundarschulbildung",
				"higher_education": "Hochschulbildung",
				"young_professional": "Young Professional",
				"professional": "Professionell"
			},
			"select_academic_title": {
				"ba": "Ba",
				"dr": "Dr",
				"mba": "MBA",
				"phd": "PhD",
				"prof": "Prof.",
				"prof_dr": "Prof. Dr."
			},
			"select_background_xml_export_enabled": {
				"false": "Nein",
				"no": "Nein",
				"true": "Ja",
				"yes": "Ja"
			},
			"select_branch": {
				"automotive": "Automotive",
				"culture": "Kultur",
				"education": "Bildung",
				"electronics": "Electronil",
				"event": "Event",
				"finance": "Finanzen",
				"food": "Gastro",
				"health": "Gesundheit",
				"import": "Import",
				"insurance": "Versicherungen",
				"it": "IT",
				"law": "Recht",
				"marketing": "Marketing",
				"non_profit": "Non profit",
				"other": "Andere",
				"print": "Druck",
				"public": "Öffentlicht",
				"real_estate": "Real estate",
				"service": "Service"
			},
			"select_category": {
				"exhibition": "Messe",
				"inbound": "Inbound",
				"other": "Andere"
			},
			"select_classification": {
				"cold": "Nicht interessiert",
				"hot": "Interessiert",
				"warm": "Sehr interessiert",
				"unclassified": "–"
			},
			"select_default_classification": {
				"cold": "Nicht interessiert",
				"hot": "Interessiert",
				"warm": "Sehr interessiert",
				"unclassified": "–"
			},
			"select_company_department": {
				"finance": "Finanzen",
				"human_resources": "Human Resources",
				"it": "IT",
				"marketing": "Marketing",
				"other": "Andere",
				"sales": "Verkauf",
				"secretariat": "Sekretariat",
				"service_management": "Service Management"
			},
			"select_company_function": {
				"CEO": "Vorstandschef",
				"consultant": "Berater",
				"head_of": "Abteilungsleiter",
				"manager": "Manager",
				"managing_director": "Geschäftsführung",
				"other": "Other",
				"person_in_charge": "Sachbearbeiter"
			},
			"select_company_role": {
				"decision_maker": "Entscheider",
				"decision_maker_budget": "Entscheider mit Budget",
				"non_decision_maker": "Kein Entscheider",
				"other": "Andere"
			},
			"select_gender": {
				"female": "Weiblich",
				"male": "Männlich",
				"undefined": "-"
			},
			"select_importOrigin": {
				"crm": "CRM",
				"xls": "XLS"
			},
			"select_interested_in": {
				"marketing": "Marketing",
				"consulting": "Beratung",
				"it": "IT",
				"sales": "Vertrieb",
				"administration": "Verwaltung",
				"production": "Produktion",
				"logistics": "Logistik",
				"meeting": "Meeting",
				"other": "Andere",
				"presentation": "Präsentation",
				"pricing": "Preise",
				"product_informations": "Produkt Information"
			},
			"select_is_opt_in": {
				"false": "Nein",
				"no": "Nein",
				"true": "Ja",
				"yes": "Ja"
			},
			"select_language": {
				"de": "Deutsch",
				"en": "Englisch"
			},
			"select_origin": {
				"mobile_app": "Talent App",
				"opt_in_email": "Opt-in email",
				"opt_in_linked_in": "Opt-in linkedin",
				"opt_in_xing": "Opt-in xing",
				"web_app": "Cloud",
				"external_form": "External Form"
			},
			"select_project_planned": {
				"0-3months": "0-3 Monate",
				"3-6months": "3-6 Monate",
				"6-12months": "6-12 Monate",
				"no_plan": "Nichts geplant"
			},
			"select_sync_disabled": {
				"false": "Aktiviert",
				"no": "Aktiviert",
				"true": "Deaktiviert",
				"yes": "Deaktiviert"
			},
			"select_sync_status": {
				"no_crm": "Kein CRM",
				"not_sync_ready": "Nicht 100%",
				"not_synced": "Unbearbeitet",
				"processing": "Gestartet",
				"sync_error": "Fehler",
				"sync_ready": "100%",
				"synced": "Erfolgreich"
			},
			"tracking": {
				"activity": "Ereignis",
				"date": "Datum",
				"kit": "Kit",
				"specific": {
					"confirm_redeem_coupon": "Klick auf Einlöse-Button",
					"click_event_pdf": "Klick auf Talentkit PDF",
					"cta_coupon": "Klick auf Content CTA",
					"embed_visit_url": "Webseite URL tracking",
					"open_bag": "Talentkit geöffnet",
					"view_coupon": "Inhalt angesehen",
					"view_website": "CTA geklickt",
					"view_website_coupon": "Klick auf 'Webseite ansehen'",
					"visit_website": "Webseite besucht",
					"toggle_event_info": "Klick auf Talentkit Mehr Informationen"
				}
			},
			"user": {
				"action": "Aktion",
				"email": "E-Mail",
				"firstname": "Vorname",
				"id": "id",
				"invite-role": "Rolle",
				"lastname": "Nachname",
				"fullname": "Voller Name",
				"role": "Rolle",
				"message": {
					"create": "Der Benutzer wurde erfolgreich erstellt",
					"update": "Der Benutzer wurde erfolgreich aktualisisert"
				},
				"organization_id": "Organisation",
				"organization": "Organisation",
				"organization_name": "Organisation",
				"password": "Passwort",
				"status": "Status",
				"created_at": "Datum",
				"name": "Name",
				"statuses": {
					"active": "Akzeptiert",
					"confirmed": "Akzeptiert",
					"inactive": "Inaktiv",
					"unconfirmed": "Unbestätigt",
					"pending": "Pending",
					"review": "Überarbeitung",
					"pre_review": "Pre Review"
				}
			},
			"select_type": {
				"title_h1": "H1 Titel",
				"title_h2": "H2 Titel",
				"title_h3": "H3 Titel",
				"title_h4": "H4 Titel",
				"image": "Bild",
				"paragraph": "Paragraph",
				"hidden": "Hidden field",
				"text": "Text field",
				"textarea": "Textarea",
				"select": "Select field",
				"radio": "Radio field",
				"radio_custom": "Radio custom field",
				"checkbox": "Checkbox field",
				"checkbox_custom": "Checkbox custom field",
				"country_select": "Country select field",
				"confirmation": "Confirmation field",
				"free_drawing": "Zeichnung",
				"submit": "Submit",
				"container": "Container",
				"container_grid": "Grid container",
				"container_top": "Container top",
				"container_bottom": "Container bottom",
				"container_tab": "Container tab",
				"crawled_infos": "Crawled Infos"
			},
			"email_template": {
				"id": "",
				"name": "Name",
				"language": "Sprache",
				"action": "Aktion",
				"organization": "Organisation",
				"body": "Inhalt",
				"salutation": "Ansprache",
				"salutation_fallback": "Fallback Ansprache",
				"from": "E-Mail Von",
				"reply_to": "Antwort an",
				"imprint_url": "Impressum URL",
				"privacy_url": "Datenschutz URL",
				"primary_color": "Primärfarbe",
				"message": {
					"create": "Das E-Mail Template wurde erfolgreich erstellt.",
					"update": "Das E-Mail Template wurde erfolgreich aktualisiert."
				},
				"duplicate": "",
				"duplicate_desc": "E-Mail Template duplizieren"
			},
			"organization_configuration": {
				"api_token_eventbaxx": "Eventbaxx api token",
				"enrichment_disabled": "Clearbit enrichment",
				"mailchimp_api_key": "Mailchimp api key",
				"ranking_display": "Zeige das Talent-Hunter Ranking?",
				"xing_consumer_key": "Xing consumer key",
				"eventbaxx_auth_token": "Eventbaxx authentication key"
			},
			"workflow": {
				"id": "ID",
				"name": "Name",
				"status": "Status",
				"last_execution": "Letzte Ausführung",
				"frequency": "Frequenz",
				"first_run": "Erste Ausführung (UTC)",
				"final_run": "Finale Ausführung (UTC)",
				"daily_runtime": "Uhrzeit (UTC)",
				"action": "Aktion",
				"project": "Kampagne",
				"project_name": "Kampagne",
				"execute_on": "Bedingung",
				"configuration": "Konfiguration",
				"scope": "Berücksichtige Talente von:",
				"loading_projects": "Kampagnen werden geladen…",
				"message": {
					"create": "Workflow erfolgreich erstellt",
					"trigger_success": "Workflow erfolgreich ausgeführt",
					"update": "Workflow erfolgreich aktualisiert"
				},
				"collection": {
					"frequency": {
						"daily": "Täglich",
						"immediately": "Stündlich",
						"once": "Einmalig",
						"undefined": "–"
					}
				}
			}
		}
	}
};

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

module.exports = {
	"en-tal": {
		"models": {
			"select_type": {
				"title_h1": "H1 title",
				"title_h2": "H2 title",
				"title_h3": "H3 title",
				"title_h4": "H4 title",
				"image": "Image",
				"paragraph": "Paragraph",
				"hidden": "Hidden field",
				"text": "Text field",
				"textarea": "Textarea",
				"select": "Select field",
				"radio": "Radio field",
				"radio_custom": "Radio custom field",
				"checkbox": "Checkbox field",
				"checkbox_custom": "Checkbox custom field",
				"country_select": "Country select field",
				"confirmation": "Confirmation field",
				"free_drawing": "Free drawing",
				"submit": "Submit",
				"container": "Container",
				"container_grid": "Grid container",
				"container_top": "Container top",
				"container_bottom": "Container bottom",
				"container_tab": "Container tab",
				"crawled_infos": "Crawled info",
				"read_only": "Read only"
			},
			"select_scope": {
				"organization": "Organization",
				"project": "Campaign"
			},
			"auth": {
				"remember_me": "Stay logged 7 days"
			},
			"business_kit": {
				"action": "",
				"date": "Date",
				"fail": "The sending of the Talentkit failed",
				"id": "id",
				"name": "Name",
				"select": "Select a Talentkit",
				"sent": "Your Talentkit has been sent",
				"create_template": "Create template",
				"status": {
					"email_sent": "Sent",
					"sendout_enqueued": "Sent",
					"transferred": "Transferred"
				},
				"missing": {
					"email": "Sending failed. You probably have to create an email template before sending the Talentkit."
				}
			},
			"external_form": {
				"action": "Actions",
				"additional_data": "Additional data",
				"configuration": "Configuration",
				"email_recipient_address": "Send to",
				"id": "#",
				"language": "Language",
				"message": {
					"create": "The form has been added successfully",
					"update": "The form has been updated successfully"
				},
				"name": "Name",
				"project_id": "Campaign",
				"project_name": "Campaign",
				"project__name": "Campaign",
				"slug": "Slug",
				"structure": "Structure",
				"duplicate": "",
				"duplicate_desc": "Duplicate the form",
				"duplicate_project_desc": "Duplicate the campaign",
				"title": "Form title"
			},
			"email_template": {
				"id": "",
				"name": "Name",
				"language": "Language",
				"duplicate": "",
				"action": "Actions",
				"organization": "Organization",
				"body": "Email content",
				"salutation": "Salutation",
				"salutation_fallback": "Fallback salutation",
				"from": "Email from",
				"reply_to": "Reply to",
				"imprint_url": "Imprint url",
				"privacy_url": "Privacy url",
				"primary_color": "Primary color",
				"message": {
					"create": "The email template was successfully created.",
					"update": "The email template was successfully updated."
				},
				"duplicate_desc": "Duplicate email template"
			},
			"lead_mask": {
				"action": "Actions",
				"default": "Default mask ?",
				"yes": "Yes",
				"no": "No",
				"id": "#",
				"language": "Language",
				"message": {
					"create": "The talent sheet was successfully created.",
					"update": "The talent sheet was successfully updated."
				},
				"name": "Name",
				"organization": "Organization",
				"organization_name": "Organization",
				"project": "Campaign",
				"slug": "Slug",
				"structure": "Structure",
				"duplicate": "",
				"duplicate_desc": "Duplicate talent sheet"
			},
			"opt-in": {
				"businesskit__name": "Businesskit name",
				"id": "#",
				"project__name": "Campaign name",
				"subdomain": "Subdomain",
				"template_name": "Template name"
			},
			"organization": {
				"action": "",
				"action_delete": "",
				"city": "City",
				"country": "Country",
				"id": "Id",
				"message": {
					"create": "The organization has been added successfully",
					"update": "The organization has been updated successfully"
				},
				"name": "Name",
				"status": "",
				"street": "Street",
				"street_number": "Street number",
				"users__count": "Users",
				"website": "Website",
				"zip": "Zip code"
			},
			"organization_configuration": {
				"api_token_eventbaxx": "Eventbaxx api token",
				"enrichment_disabled": "Clearbit enrichment",
				"mailchimp_api_key": "Mailchimp api key",
				"ranking_display": "Display the talent hunter rankings?",
				"xing_consumer_key": "Xing consumer key",
				"eventbaxx_auth_token": "Eventbaxx authentication key"
			},
			"organizations": {
				"successfully_started_crm_sync": "CRM synchronisation successfully started"
			},
			"project": {
				"action": "Actions",
				"background_xml_export_enabled": "Enable Fanomena Talent app synchronisation",
				"base_score": "Base score",
				"scope_leads": "Users can only view their own talents",
				"business_kits_count": "Talentkits",
				"businesskit_to_assign": "Assign a Businesskit",
				"category": "Category",
				"crm_campaign_id": "CRM campaign ID",
				"crm_sales_employee_id": "CRM sales employee ID",
				"crm_marketing_employee_id": "CRM marketing employee ID",
				"crm_group_code_id": "CRM group code foreign ID",
				"enable_lead_review": "Enable manual talent review by Root",
				"end_date": "Campaign end date",
				"hot_leads_count": "Hot talents",
				"id": "#",
				"is_opt_in": "Is opt-in?",
				"lead_mask": "Talent sheet",
				"lead_mask_id": "Select an existing talent sheet",
				"leads_count": "Talents",
				"leads_not_synced_count": "Pending talents",
				"location": "Location",
				"mailchimp_list_id": "Mailchimp list ID",
				"message": {
					"create": "The campaign has been added successfully",
					"update": "The campaign has been updated successfully"
				},
				"name": "Name",
				"organization": "Organization",
				"organization_name": "Organization",
				"organization_id": "Organization",
				"period": "Period",
				"set_aditional_data_content": "Show and set additional data",
				"start_date": "Campaign start date",
				"sync_disabled": "CRM synchronisation",
				"unsynced_leads_count": "Sync status",
				"unsynced_leads_count_success": "Synced",
				"user_to_assign": "Assign a user",
				"duplicate": "",
				"default_classification": "Default classification",
				"business_kit_id": "Talentkits"
			},
			"project_lead": {
				"location": "Location",
				"situation": "Situation",
				"employed_by": "Employed by",
				"career_level": "Career level",
				"academic_title": "Title",
				"action": "Actions",
				"advancement": "Advancement",
				"branch": "Industry",
				"business_card_job_title": "Job title",
				"capturer": "Capturer",
				"capturer_unknown": "Unassigned",
				"city": "City",
				"classification": "Classification",
				"company": "Company",
				"company-name": "Company name",
				"company_department": "Department",
				"company_function": "Function",
				"company_role": "Role",
				"company_website": "Company website",
				"conversation_notes": "Notes",
				"country": "Country",
				"crawled_infos": {
					"by": "by",
					"category": "Categories",
					"description": "Description",
					"domain": "Website",
					"emailAddresses": "Emails",
					"foundedYear": "Founded",
					"linkedin": "Linkedin profile",
					"location": "Location",
					"metrics": "Metrics",
					"more_infos": "More information",
					"name": "Company name",
					"phoneNumbers": "Phone numbers",
					"phone_number": "Phone given in the web",
					"tags": "Tags",
					"title_website": "Title of the website",
					"tweets": "Tweets",
					"founded": ""
				},
				"found_existing": "We found some existing data for this talent and have applied it automatically.",
				"predicted_name": "We have automatically filled in some of your talents's data based on their email address.",
				"created": "Talent was successfully created.",
				"created_at": "Created",
				"email": "Email",
				"exhibition_visitor_count": "Exhibition visitor count",
				"firstname": "Firstname",
				"full_street": "Street & No.",
				"gender": "Gender",
				"id": "#",
				"import_origin": "",
				"import_origins": {
					"crm": "Imported from CRM"
				},
				"interested_in": "Interested in",
				"kit_status": "",
				"language": "Language",
				"lastname": "Lastname",
				"message": {
					"changes_pending": "There are pending changes. Last saved",
					"changes_saved": "Last changes:",
					"create": "The talent has been added successfully",
					"create_from_card": "Scan business card",
					"create_from_email": "Enter email address",
					"leads_exists": "The talent exists already but it has been added to the current campaign",
					"no_business_card": "No business card uploaded yet",
					"update": "The talent was been updated successfully"
				},
				"name": "Name",
				"origin": "",
				"origins": {
					"mobile_app": "Talent captured via mobile app",
					"web_app": "Talent captured via web app"
				},
				"phone_company": "Company phone",
				"phone_mobile": "Mobile phone",
				"progress_complete": "All required fields have been filled",
				"progress_indicator_businesskit": "Progress",
				"progress_indicator_crm": "Progress",
				"progress_indicator_lead_mask": "Progress",
				"project_planned": "Campaign planned",
				"salutation": "Salutation",
				"start_date": "Created on",
				"status": "Status",
				"street": "Street",
				"street_number": "Number",
				"sync_disabled": "CRM sync",
				"sync_missing_fields": "Still not completed:",
				"sync_status": "CRM",
				"sync_statuses": {
					"no_crm": "No CRM configured",
					"no_crm_desc": "The organization doesn't have a CRM configured",
					"not_sync_ready": "Not ready",
					"not_sync_ready_desc": "The talent misses some fields required for CRM sync",
					"not_synced": "Unsynced",
					"not_synced_desc": "The talent has been imported from CRM but has not been modified",
					"processing": "Syncing",
					"processing_desc": "The talent is syncing right now",
					"sync_disabled": "Disabled",
					"sync_disabled_desc": "The talent is ready to be synchronized but the talent sync is disabled",
					"sync_error": "Error",
					"sync_error_desc": "The talent sync produced an error",
					"sync_ready": "Ready",
					"sync_ready_desc": "The talent is ready to be synchronized",
					"synced": "Synced",
					"synced_desc": "The talent has been synced"
				},
				"title": "Title",
				"updated_at": "Last updated",
				"user_id": "Talent detector",
				"zip": "ZIP"
			},
			"select_role": {
				"user": "Standard user",
				"admin": "Administrator"
			},
			"select_situation": {
				"seeking": "Seeking",
				"interested_in": "Interested in",
				"employed_by": "Employed by"
			},
			"select_career_level": {
				"secondary_education": "Secondary Education",
				"higher_education": "Higher Education",
				"young_professional": "Young Professional",
				"professional": "Professional"
			},
			"select_academic_title": {
				"ba": "Ba",
				"dr": "Dr",
				"mba": "MBA",
				"phd": "PhD",
				"prof": "Prof.",
				"prof_dr": "Prof. Dr."
			},
			"select_background_xml_export_enabled": {
				"false": "No",
				"no": "No",
				"true": "Yes",
				"yes": "Yes"
			},
			"select_branch": {
				"automotive": "Automotive",
				"culture": "Culture",
				"education": "Education",
				"electronics": "Electronics",
				"event": "Event",
				"finance": "Finance",
				"food": "Food / Gastro",
				"health": "Health",
				"import": "Import",
				"insurance": "Insurances",
				"it": "IT",
				"law": "Law",
				"marketing": "Marketing",
				"non_profit": "Non profit",
				"other": "Other",
				"print": "Print",
				"public": "Public",
				"real_estate": "Real estate",
				"service": "Service"
			},
			"select_category": {
				"exhibition": "Exhibition",
				"inbound": "Inbound",
				"other": "Other"
			},
			"select_classification": {
				"cold": "Not interested",
				"hot": "Interested",
				"warm": "Very interested",
				"unclassified": "–"
			},
			"select_default_classification": {
				"cold": "Not interested",
				"hot": "Interested",
				"warm": "Very interested",
				"unclassified": "–"
			},
			"select_company_department": {
				"finance": "Finance",
				"human_resources": "Human Resources",
				"it": "IT",
				"marketing": "Marketing",
				"other": "Other",
				"sales": "Sales",
				"secretariat": "Secretariat",
				"service_management": "Service Management"
			},
			"select_company_function": {
				"CEO": "CEO",
				"consultant": "Consultant",
				"head_of": "Head of department",
				"manager": "Manager",
				"managing_director": "Managing director",
				"other": "Other",
				"person_in_charge": "Person in charge"
			},
			"select_company_role": {
				"decision_maker": "Decision maker",
				"decision_maker_budget": "Decision maker with budget",
				"non_decision_maker": "Non decision maker",
				"other": "Other"
			},
			"select_gender": {
				"female": "Female",
				"male": "Male",
				"undefined": "-"
			},
			"select_importOrigin": {
				"crm": "CRM",
				"xls": "XLS"
			},
			"select_interested_in": {
				"marketing": "Marketing",
				"consulting": "Consulting",
				"it": "IT",
				"sales": "Sales",
				"administration": "Administration",
				"production": "Production",
				"logistics": "Logistics",
				"meeting": "Meeting",
				"other": "Other",
				"presentation": "Presentation",
				"pricing": "Pricing",
				"product_informations": "Product information"
			},
			"select_is_opt_in": {
				"false": "No",
				"no": "No",
				"true": "Yes",
				"yes": "Yes"
			},
			"select_language": {
				"de": "German",
				"en": "English"
			},
			"select_origin": {
				"mobile_app": "Talent app",
				"opt_in_email": "Opt-in email",
				"opt_in_linked_in": "Opt-in linkedin",
				"opt_in_xing": "Opt-in xing",
				"web_app": "Cloud",
				"external_form": "External Form"
			},
			"select_project_planned": {
				"0-3months": "0-3 months",
				"3-6months": "3-6 months",
				"6-12months": "6-12 months",
				"no_plan": "No plan"
			},
			"select_sync_disabled": {
				"false": "Activated",
				"no": "Activated",
				"true": "Deactivated",
				"yes": "Deactivated"
			},
			"select_sync_status": {
				"no_crm": "No CRM configured",
				"not_sync_ready": "Not 100%",
				"not_synced": "Not edited",
				"processing": "Started",
				"sync_error": "Error",
				"sync_ready": "100%",
				"synced": "Successful"
			},
			"tracking": {
				"activity": "Action",
				"date": "Date",
				"kit": "Kit",
				"specific": {
					"confirm_redeem_coupon": "Click on redeem button",
					"click_event_pdf": "Click Businesskit PDF",
					"cta_coupon": "Click on content CTA",
					"embed_visit_url": "Website URL tracking",
					"open_bag": "Businesskit opened",
					"view_coupon": "Content viewed",
					"view_website": "Clicked on CTA",
					"view_website_coupon": "Clicked on 'visit website'",
					"visit_website": "Website visited",
					"toggle_event_info": "Click Businesskit more information"
				}
			},
			"user": {
				"action": "Actions",
				"created_at": "Date",
				"email": "Email",
				"invite-role": "Role",
				"firstname": "First Name",
				"id": "id",
				"lastname": "Last Name",
				"fullname": "Full Name",
				"role": "Role",
				"has_valid_email": "validation",
				"message": {
					"create": "The user has been added successfully",
					"update": "The user has been updated successfully"
				},
				"name": "Name",
				"organization_id": "Organization",
				"organization": "Organization",
				"organization_name": "Organization",
				"password": "Password",
				"status": "Status",
				"statuses": {
					"active": "Accepted",
					"confirmed": "Confirmed",
					"inactive": "Inactive",
					"unconfirmed": "Unconfirmed",
					"pending": "Pending",
					"review": "Needs revision",
					"pre_review": "Pre Revision"
				}
			},
			"workflow": {
				"id": "ID",
				"name": "Name",
				"status": "Status",
				"last_execution": "Last execution",
				"frequency": "Frequency",
				"first_run": "First run (UTC)",
				"final_run": "Final run (UTC)",
				"daily_runtime": "Daily runtime (UTC)",
				"action": "Action",
				"project": "Campaign",
				"project_name": "Campaign",
				"execute_on": "Condition",
				"configuration": "Configuration",
				"scope": "Retrieve talents from:",
				"loading_projects": "Loading campaigns…",
				"message": {
					"create": "Workflow successfully created",
					"trigger_success": "Workflow successfully triggered",
					"update": "Workflow successfully updated"
				},
				"collection": {
					"frequency": {
						"daily": "Daily",
						"immediately": "Hourly",
						"once": "Once",
						"undefined": "–"
					}
				}
			}
		}
	}
};

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

module.exports = {
	"de-tal": {
		"routes": {
			"project": "campaign",
			"projects": "campaigns",
			"project_leads": "talents"
		}
	},
	"en-tal": {
		"routes": {
			"project": "campaign",
			"projects": "campaigns",
			"project_leads": "talents"
		}
	}
};

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

module.exports = {
	"de-tal": {
		"statistics": {
			"24h_activity": "24h Aktivität",
			"7days_activity": "7 Tage Aktivität",
			"actions": "Aktionen",
			"activity": "Aktivität",
			"average_per_day": "Durchschnitt pro Tag",
			"businesskit_opened": "Eindeutige Talentkit-Öffnungen",
			"total_businesskit_opened": "Geöffnet",
			"businesskit_per_lead": "Talentkits pro Talent",
			"businesskit_sent": "Talentkits verschickt",
			"coupon": "Content card",
			"coupons": "Content cards",
			"coupons_opened": "Content-Cards geöffnet",
			"coupons_sent": "Content-Cards verschickt",
			"coupons_viewed": "Content Card Ansichten",
			"cta_clicked": "CTA geklickt",
			"day": "Tag",
			"days": "Tage",
			"get_back_to_lead": "Zurück zum Talent",
			"get_back_to_statistics": "Zurück zu den Statistiken",
			"hour": "Stunde",
			"hours": "Stunden",
			"kit_and_activity": "Kit & Aktivität",
			"kits": "Kits",
			"latest_trackings": "Letzte Aktivitäten",
			"lead_detectors_overview": "Talent-Hunter Übersicht",
			"lead_kit_and_activity": "Talent, Kit & Aktivität",
			"lead_statistics": "Talent-Trackings",
			"leads": "Talents",
			"leads_cold": "Kalt",
			"leads_hot": "Heiß",
			"leads_per_day": "Talents pro Tag",
			"leads_per_lead_detector": "Talents pro Talent-Hunter",
			"leads_warm": "Warm",
			"no_data": "Es gibt noch keine Daten. Versuche eine andere Zeitspanne.",
			"no_data_24_hours": "Es gibt keine Daten innerhalb der letzten 24h.",
			"no_data_7_days": "Es gibt keine Daten innerhalb der letzten 7 Tage.",
			"per_bk_opened": "pro geöffnetem Businesskit",
			"project_statistics": "Projekt Statistiken",
			"see_full_report": "Vollständiger Report ansehen",
			"see_full_statistics": "Siehe vollständige Statistiken",
			"see_full_tracking_history": "Siehe komplett Tracking Historie",
			"time_range": "Zeitspanne",
			"tracking_activity": "Aktivität",
			"tracking_kit": "Kit",
			"tracking_lead": "Talent",
			"tracking_time": "Zeit"
		}
	}
};

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

module.exports = {
	"en-tal": {
		"statistics": {
			"24h_activity": "24h activity",
			"7days_activity": "7 days activity",
			"actions": "Actions",
			"activity": "Activity",
			"average_per_day": "Average per day",
			"businesskit_opened": "Unique Talentkits opened",
			"total_businesskit_opened": "Opened",
			"businesskit_per_lead": "Talentkits per talent",
			"businesskit_sent": "Talentkits sent",
			"coupon": "Content card",
			"coupons": "Content cards",
			"coupons_opened": "Content cards opened",
			"coupons_sent": "Content cards sent",
			"coupons_viewed": "Content Card views",
			"cta_clicked": "CTA clicked",
			"day": "Day",
			"days": "Days",
			"get_back_to_lead": "Back to talent",
			"get_back_to_statistics": "Back to statistics",
			"hour": "Hour",
			"hours": "Hours",
			"kit_and_activity": "Kit & activity",
			"kits": "Kits",
			"latest_trackings": "Latest activities",
			"lead_detectors_overview": "Talent hunters overview",
			"lead_kit_and_activity": "Talent, kit & activity",
			"lead_statistics": "Talent trackings",
			"leads": "Talents",
			"leads_cold": "Cold",
			"leads_hot": "Hot",
			"leads_per_day": "talents per day",
			"leads_per_lead_detector": "per talent hunter",
			"leads_warm": "Warm",
			"no_data": "There is no data yet. Try another time time range.",
			"no_data_24_hours": "There is no data for the last 24 hours.",
			"no_data_7_days": "There is no data for the last 7 days.",
			"per_bk_opened": "per talentkit open",
			"project_statistics": "Campaign statistics",
			"see_full_report": "See full report",
			"see_full_statistics": "See full statistics",
			"see_full_tracking_history": "See full tracking history",
			"time_range": "Time range",
			"tracking_activity": "Activity",
			"tracking_kit": "Kit",
			"tracking_lead": "Talent",
			"tracking_time": "Time"
		}
	}
};

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

module.exports = {
	"de-tal": {
		"ui": {
			"project": {
				"standard_title": "Die Standard Talentmaske enthält:",
				"standard_subtitle_1": "Persönlich",
				"standard_subtitle_2": "Unternehmen",
				"standard_description_1": "Sprache, Geschlecht, Titel, Vorname, Nachname, E-Mail, Abteilung, Funktion, Rolle, Job",
				"standard_description_2": "Firmenname, Branche, Telefon, Webseite, Straße, Nummer, PLZ, Stadt, Land",
				"advanced_title": "Die erweiterte Talentmaske enthält die selben Tabs und Felder die auch die Standard Talentmaske enthält. Außerdem:",
				"advanced_subtitle_1": "Kampagnen Termin",
				"advanced_subtitle_2": "Qualifizierung",
				"advanced_description_1": "Kundenanfragen, Information, E-Mail Marketing (Newsletter, Event und E-Mail Abonnement)",
				"advanced_description_2": "Notizen, Interesse an, Kampagne geplant (Dauer in Monaten)",
				"create_leadsheet": "Erstelle eine neue Talentmaske"
			},
			"segments": {
				"segments": "Segmente",
				"is_editing_state": "Speichere das Segment bevor du fortfährst",
				"add_to_project": {
					"empty": "Keine Kampagnen",
					"success": "Ihre Kontakte werden der Kampagne hinzugefügt. Dies kann einige Minuten dauern.",
					"error": "Beim Hinzufügen von Kontakten zur Kampagne ist ein Fehler aufgetreten"
				},
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Erstellt am",
					"updated": "Zuletzt aktualisiert",
					"creator": "Ersteller"
				},
				"actions": {
					"success": "Segment erfolgreich gespeichert!",
					"error": "Segment konnte nicht gespeichert werden.",
					"edit": "Editieren",
					"edit_description": "Editieren",
					"duplicate": "Duplizieren",
					"duplicate_description": "Duplizieren",
					"duplicate_name": "Kopie von {name}",
					"delete": "Löschen",
					"delete_description": "Löschen"
				},
				"business_kit": {
					"segment_title": "Senden an",
					"subtext": "Stellen Sie sicher, dass Ihr Talentkit korrekt eingerichtet ist, bevor Sie es versenden",
					"contacts": "Kontakte",
					"success": "Talentkit erfolgreich verschickt",
					"error": "Beim Talentkit-Verschicken ist ein Fehler aufgetreten",
					"preview": "Vorschau",
					"email_templates_confirmation": "Bestätigen Sie, dass es eine E-Mail-Vorlage für dieses Talentkit gibt. Wenn keine E-Mail-Vorlage erstellt wurde, wird dieses Talentkit nicht versendet."
				},
				"create_modal": {
					"title": "Segment erstellen",
					"field_label": "Neuer Segment Name",
					"duplicate": "Erstellen",
					"name": "Name"
				},
				"delete_modal": {
					"title": "Segment löschen"
				},
				"duplicate_modal": {
					"title": "Segment duplizieren",
					"duplicate": "Duplizieren",
					"name": "Neuer Segment Name"
				},
				"bbusinesskits_modal": {
					"title": "Bereit zum Versenden",
					"send": "Kit versenden"
				},
				"add_to_project_modal": {
					"title": "Zur Kampagne hinzufügen",
					"search_label": "Kampagne durchsuchen",
					"add_button": "Hinzufügen"
				},
				"export": {
					"success": "Export abgeschlossen. Sie sollten in Kürze eine E-Mail mit Ihren Kontakten erhalten.",
					"error": "Beim Exportieren ist ein Fehler aufgetreten, bitte versuchen Sie es erneut."
				},
				"delete": {
					"success": "Kontakte erfolgreich gelöscht",
					"error": "Einer oder mehrere Kontakte konnten nicht gelöscht werden."
				}
			},
			"segment": {
				"breadcrumb_back": "Alle Segmente"
			},
			"contacts": {
				"modals": {
					"delete": {
						"title": "Kontakte löschen"
					}
				},
				"title": "Kontakte",
				"create": "Kontakt erstellen",
				"empty_state_msg": "Keine Kontakte auf Basis der Filtereinstellungen gefunden",
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Erstellt am",
					"updated": "Zuletzt aktualisiert",
					"company": "Firma",
					"source": "Quelle",
					"email": "E-Mail",
					"gender": "Geschlecht"
				},
				"actions": {
					"export": "Exportieren",
					"save_to_project": "Zur Kampagne hinzufügen",
					"send_businesskit": "Ein Businesskit verschicken",
					"delete": "Löschen",
					"error": "Es gab einen Fehler beim Aktualisieren des Kontakts",
					"success": "Der Kontakt wurde erfolgreich aktualisiert"
				},
				"filters": {
					"custom_placeholder": "Kampagnen Attribute...",
					"general": {
						"none": "Keine zugeordnet"
					},
					"project": {
						"label": "Kampagnen Name",
						"none": "Gehört zu keinen Kampagnen"
					},
					"company": {
						"label": "Firma",
						"none": "Gehört zu keinen Kampagnen"
					},
					"gender": {
						"label": "Geschlecht",
						"options": {
							"male": "Männlich",
							"female": "Weiblich"
						}
					},
					"language": {
						"label": "Sprache",
						"options": {
							"en": "Englisch",
							"de": "Deutsch"
						}
					},
					"invalid_email": {
						"label": "E-Mail ist gültig",
						"condition_label": "E-Mail",
						"options": {
							"valid": "Gültig",
							"not_valid": "Ungültig"
						}
					},
					"created": {
						"label": "Erstellt"
					},
					"updated": {
						"label": "Aktualisiert"
					},
					"city": {
						"label": "Stadt"
					},
					"country": {
						"label": "Land"
					},
					"tags": {
						"label": "Tags"
					}
				},
				"import": {
					"title": "Kontakte importierne",
					"description": "Laden Sie eine CSV-Datei mit den zu importierenden Kontakten hoch.",
					"format": "Die Datei sollte mindestens drei Spalten enthalten: Vorname, Nachname und E-Mail. Nur die E-Mail ist obligatorisch, aber Vorname und Nachname sind sehr empfehlenswert.",
					"success_flash": "Kontakte wurden erfolgreich importiert",
					"success_modal_title": "Import abgeschlossen",
					"success_modal_body": "Deine Kontakte wurden erfolgreich importiert.",
					"success_modal_report": "Von {total} importieren Kontaten wurden {new} erstellt und {updated} aktualisiert."
				}
			},
			"contact": {
				"edit": "Editieren",
				"change_company": "Änderung",
				"breadcrumb_back": "Alle Kontakte",
				"empty_state_text": "Dieser Kontakt wurde noch nicht als Lead erfasst.",
				"contact_details": "Kontakt Details",
				"company_details": "Firma Details",
				"created": "Erstellt am",
				"updated": "Aktualisiert am",
				"is_lead_on": "Ist Lead von",
				"go_to_lead": "Zum Lead",
				"tags": "Tags",
				"source": "Quelle",
				"sources": {
					"web_app": "Web App",
					"mobile_app": "Mobile App",
					"external_form": "Formular",
					"crm_sync": "CRM Sync",
					"upload": "Hochgeladen",
					"unknown": "Unbekannt"
				},
				"caption": {
					"email": "E-Mail",
					"firstname": "Vorname",
					"lastname": "Name",
					"business_card_job_title": "Job-Titel",
					"company_department": "Abteilung",
					"phone_mobile": "Mobiltelefon",
					"phone_company": "Firmen-Telefon",
					"phone_private": "Privates Telefon",
					"gender": "Anrede",
					"language": "Sprache"
				}
			},
			"xtable": {
				"toggle_columns": "Spalten bearbeiten",
				"actions": "Aktionen",
				"page_size_label": "Ansicht",
				"search_placeholder": "Suchen",
				"save_search_title": "Suche speichern",
				"save_search_label": "Name",
				"empty_state_label": "Keine Daten entsprechen den Filtern",
				"empty_cell_value": "Kein {name} zugeordnet"
			},
			"xfilters": {
				"confirm_removal": "Ja, Filter entfernen",
				"add_filter": "Filter hinzufügen",
				"add_filter_confirm": "Hinzufügen",
				"delete_filter_warning": "Sie sind dabei, eine Filterbedingung zu entfernen oder zu ersetzen, von der andere Bedingungen abhängen. Wenn Sie fortfahren, dann werden auch alle diese abhängigen Bedingungen entfernt.",
				"delete_filter_confirmation": "Sind Sie sicher, dass Sie weitermachen wollen?",
				"conditions": {
					"operators": {
						"and": "und",
						"or": "oder"
					},
					"predicates": {
						"has_any": "hat einen",
						"has_all": "hat alle"
					},
					"summary": {
						"is": "{0} ist {1}",
						"has_all": "{0} hat alle {1}",
						"has_any": "{0} hat einen von {1}",
						"includes": "{0} enthält {1}",
						"is_not_assigned": "{0} ist nicht zugeordnet",
						"date_on": "{0} am {1}",
						"date_between": "{0} zwischen {1} und {2}",
						"date_since": "{0} seit {1}",
						"date_before": "{0} am oder vor {1}",
						"date_in_range": "{1} {0}",
						"date_in_range_simple": "{1} {0}"
					}
				},
				"xfiltermodal": {
					"date_from": "Von",
					"date_to": "Bis"
				},
				"date_ranges": {
					"custom": "Angepasste",
					"today": "Heute",
					"yesterday": "Gestern",
					"past_week": "Letzte Woche",
					"past_month": "Letzten Monat",
					"past_year": "Letztes Jahr"
				}
			},
			"drag_elements": {
				"gender": "Geschlecht/Anrede",
				"paragraph": "Paragraph",
				"title": "Titel",
				"confirmation": "Bestätigung",
				"firstname": "Vorname",
				"lastname": "Nachname",
				"email": "E-Mail",
				"company": "Unternehmen",
				"street": "Straße",
				"street_number": "Hausnummer",
				"zip": "PLZ",
				"city": "Stadt",
				"country": "Land",
				"website": "Webseite",
				"phone_company": "Telefon (Firma)",
				"phone_mobile": "Telefon (Mobil)",
				"textfield": "Textfeld",
				"long_textfield": "Langes Textfeld",
				"multi_select": "Mehrfachauswahl",
				"dropdown": "Dropdown",
				"single_select": "Einfachauswahl",
				"date": "Datum",
				"readonly": "Schreibgeschützt",
				"quantity_selection": "Mengenauswahl",
				"drawing": "Zeichnung"
			},
			"breadcrump": {
				"back": "Zurück",
				"all_projects": "Alle Kampagnen"
			},
			"dashboard": {
				"filter": {
					"all_projects": "Alle Kampagnen"
				},
				"leads_collected_label": "Erfasste Talente",
				"most_active_projects": "Aktivste Kampagnen",
				"leads_over_time": {
					"label": "Talente gesamt",
					"linear": "Talente",
					"cumulated": "Kumuliert"
				},
				"hot": "Heiß",
				"warm": "Warm",
				"cold": "Kalt",
				"unclassified": "Nicht klassifiziert",
				"top_projects_label": "Top Kampagnen",
				"kit_activity_label": "Letzte Interaktionen",
				"latest_activity_label": "Letzte Aktivität",
				"leads_by_project_label": "Talente in Kampagnen",
				"leads_by_most_active_projects_label": "Talente in den aktivsten Kampagnen",
				"leads_by_most_active_projects": {
					"me": "Meine",
					"org": "Org"
				},
				"empty_state_headline": "Das Dashboard wird angezeigt sobald genügend Daten zur Verfügung stehen",
				"empty_state_intro": "Erstellen Sie Ihre ersten Inhalte",
				"empty_state_cta": "Kampagne erstellen",
				"top_sources_label": "Top Quellen",
				"active_leads": {
					"label": "Aktivste Talente",
					"today": "Heute",
					"last_7": "Letzte 7 Tage",
					"last_month": "Letzten Monat",
					"last_year": "Letztes Jahr",
					"all_time": "Gesamt"
				},
				"leads_over_time_label": "Talente gesamt",
				"axischart": {
					"last_week": "Letzte Woche",
					"last_month": "Letzten Monat",
					"last_year": "Letztes Jahr"
				},
				"top_projects": {
					"kits": "Kits",
					"leads": "Talente",
					"my_leads": "Meine Talente",
					"lead_sheet": "Talentmaske"
				},
				"top_sources": {
					"last_week": "Letzte Woche",
					"last_month": "Letzten Monat",
					"last_year": "Letztes Jahr",
					"web_app": "Web app",
					"external_forms": "Formulare",
					"mobile_app": "Mobil"
				},
				"kit_activity": {
					"all": "Alle",
					"opened_kit": "Öffnete",
					"updated_a_lead": "hat ein Talent aktualisiert",
					"empty_state_headline": "Noch keine Businesskit Aktivität",
					"empty_state_intro": "Erstellen Sie ansprechende und personalisierte Inhalte, die Ihnen helfen, sich wirklich mit Ihrem Unternehmen zu verbinden.",
					"interacted_with": "Interagierte mit",
					"view_content_card": "Hat eine Content-Card angeschaut | Hat {count} Content-Cards angeschaut",
					"click_content_card": "Klickte auf einen Call-to-Action | Klickte auf {count} Call-to-Actions"
				},
				"latest_activity": {
					"label": "Neuste Talente",
					"edited_in": "Bearbeitet in",
					"added_to": "Hinzugefügt zu",
					"by": "Von",
					"incomplete_lead": "Unvollständiges Talent"
				},
				"conversion_funnel": {
					"label": "Conversion Funnel",
					"cumulative_conversion": "Kumulative Umwandlung",
					"leads": "Talente",
					"sendouts": "Sendouts",
					"visits": "Öffnungen",
					"interactions": "Interaktionen"
				},
				"activity_list_widget": {
					"created_a_lead": "hat ein Talent erstellt",
					"updated_a_lead": "hat ein Talent aktualisiert",
					"on": "am",
					"latest_activity": "Letzte Aktivität",
					"empty_state_headline": "Noch keine Aktivität",
					"empty_state_intro": "Kampagne erstellen"
				}
			},
			"email_template": {
				"placeholders": {
					"firstname": "Firstname",
					"lastname": "Last name",
					"formal": "Formal salutation",
					"informal": "Informal salutation",
					"gender": "Mr/Mrs",
					"form_title": "Formular Titel"
				}
			},
			"meta_info": {
				"invitation": "Willkommen zu Talent",
				"reset_password": "Passwort zurücksetzen"
			},
			"auth": {
				"button": "Anmelden",
				"confirm": "Passwort setzen",
				"create_account_subtitle": "Wähle ein Passwort",
				"create_account_subtitle_confirm": "Du hast Deinen Account erfolgreich erstellt. Bitte melde Dich nun bei Talent an.",
				"create_account_title": "Erstelle Deinen Account",
				"create_account_title_confirm": "Glückwunsch",
				"email": "E-Mail Adresse",
				"firstname": "Vorname",
				"go_to_login": "Zum Login",
				"password": "Passwort",
				"password_confirmation": "Passwort bestätigen",
				"password_reset": "Passwort vergessen?",
				"password_reset_request_title": "Setze Dein Passwort zurück",
				"password_reset_request_title_confirm": "Schau in Dein E-Mail Postfach",
				"password_reset_sent": "Eine E-Mail mit weiteren Anweisungen, wie Du Dein Passwort zurücksetzen kannst, wurde geschickt.",
				"password_reset_title": "Passwort zurücksetzen",
				"password_reset_title_confirm": "Glückwunsch",
				"lastname": "Nachname",
				"return_to_login": "Zurück zum Login",
				"success": "Dein Passwort wurde erfolgreich gesetzt. Du kannst dich nun in alle Fanomena Talent Produkte einloggen.",
				"user_not_found": "Benutzer nicht gefunden",
				"user_not_found_subtitle": "Es tut uns Leid aber wir konnten diesen Benutzer nicht finden.<br/>Vermutlich ist Ihr Einladungs-Link abgelaufen oder der Benutzer wurde gelöscht."
			},
			"auth_illustration": {
				"contact_us": "Kontaktiere uns",
				"get_access": "Erhalte Deinen Zugang",
				"invitation_subtitle": "Entdecke Deine Möglichkeiten",
				"invitation_title": "Möchtest Du mehr über Fanomena Talent erfahren?",
				"login_subtitle": "Wir zeigen Dir Fanomena Talent",
				"login_title": "Neu hier und willst Du Dich umsehen?",
				"reset_request_subtitle": "Wir helfen Dir",
				"reset_request_title": "Keine Möglichkeit zurückzusetzen?",
				"reset_subtitle": "Wir helfen Dir",
				"reset_title": "Keine Möglichkeit zurückzusetzen?"
			},
			"business_kit": {
				"preview": "Vorschau Talentkit",
				"confirmation": "Hiermit wird bestätigt, dass Informationsmaterial angefordert und verschickt werden darf.",
				"history": "Talentkits verschickt",
				"send": "Ein Talentkit verschicken",
				"send_confirm": "Talentkit senden"
			},
			"button": {
				"double_optin": "Sicher?",
				"external_forms": {
					"new": "Formular hinzufügen"
				},
				"contacts": {
					"create": "Kontakt erstellen",
					"import": "Importieren",
					"save_as_segment": "Als Segment speichern"
				},
				"segments": {
					"new": "Segment erstellen",
					"save": "Segment speichern"
				},
				"external_form": {
					"add_popup": "Formular erstellen",
					"save": "Speichern",
					"publish": "Veröffentlichen"
				},
				"lead_mask": {
					"save": "Speichern",
					"publish": "Veröffentlichen"
				},
				"lead_masks": {
					"add_popup": "Talentmaske hinzufügen"
				},
				"opt-ins": {
					"new": "Opt-In hinzufügen"
				},
				"organizations": {
					"new": "Neue Organisation hinzufügen"
				},
				"project_leads": {
					"add_popup": "Talent hinzufügen",
					"confirm_mail": "E-Mail Adresse bestätigen",
					"confirm_picture": "Speichern & weiter",
					"continue": "Neues Unternehmen",
					"create": "Talent erfassen",
					"export": "XLS exportieren",
					"make_another_picture": "Wiederholen",
					"new": "Talent hinzufügen",
					"take_picture": "Visitenkarte aufnehmen"
				},
				"projects": {
					"new": "Kampagnen erstellen"
				},
				"users": {
					"new": "Benutzer hinzufügen",
					"invite": "Einladen",
					"invite_xls": "Via XLS einladen",
					"upload_xls": "Weiter"
				},
				"email_templates": {
					"new": "Template hinzufügen"
				},
				"workflows": {
					"new": "Neuer Workflow erstellen",
					"trigger": "Workflow ausführen"
				}
			},
			"filters": {
				"apply": "Anwenden",
				"import_origin": "Importquelle",
				"origin": "Talentquelle",
				"start_date": "Erstellung",
				"sync_disabled": "CRM Sync",
				"sync_status": "Sync Status",
				"hint": "Suchergebnisse filtern",
				"reset": "Zurücksetzen",
				"categories": "Kategorien"
			},
			"footer": {
				"imprint": "Impressum",
				"privacy": "Datenschutz",
				"terms": "Geschäftsbedingungen",
				"security": "Sicherheit"
			},
			"onboarding": {
				"next": "Weiter",
				"skip": "Überspringen",
				"start": "Starten",
				"step1": {
					"title": "Kampagne erstellen",
					"subtitle": "Erstellen Sie mit nur wenigen Klicks Ihr erstes Kampagne und digitalisieren Sie Ihre Veranstaltungen und Marketing Kampagnen."
				},
				"step2": {
					"title": "Talent erfassen",
					"subtitle": "Erstellen und verbinden Sie die anpassbaren Formulare mit Ihrer nächsten digitalen Talent-Acquisitions Kampagne."
				},
				"step3": {
					"title": "Inhalte erstellen",
					"subtitle": "Erstellen und teilen Sie personalisierte Inhalte mit Ihren Talents, um diese zu qualifizieren und so mehr Kunden zu generieren."
				}
			},
			"content_manager": {
				"first-card": {
					"title": "Talentkits",
					"subtitle": "Erstellen Sie einzigartige und personalisierte Inhalte, mit denen Sie aus der Masse herausstechen und Ihre Interaktionsrate steigern.",
					"btn": "Talentkit erstellen"
				},
				"second-card": {
					"title": "Formulare",
					"subtitle": "Erstellen Sie Fanomena Talent Formulare, die Sie ganz einfach in Ihrer Website einbinden können. Integrieren Sie gleichzeitig Ihre Marketing Tools (Webinar Tools, CRM) und automatisieren Sie Folgeprozesse.",
					"btn": "Formulare erstellen"
				},
				"third-card": {
					"title": "Talentmasken",
					"subtitle": "Erstellen Sie individuelle Talentmasken und fragen Sie alle Informationen ab, die Sie für Ihren Qualifizierungsprozess benötigen.",
					"btn": "Support kontaktieren"
				}
			},
			"empty_state": {
				"projects": {
					"title": "Neue Kampagne starten",
					"title-standard-user": "Willkommen bei Talents",
					"subtitle": "Digitalisieren Sie Ihren Talent Acquistion Prozess und analysieren Sie alle Daten an einem Ort",
					"standard-user": "Bislang wurden Sie zu keinem Kampagne hinzugefügt. Bitte kontaktieren Sie Ihren Administrator, um mit der Bearbeitung starten zu können."
				},
				"leads": {
					"title": "Erfassen Sie Ihren ersten Kandidaten in der Kampagne.",
					"subtitle": "Bislang wurden Sie zu keinem Kampagne hinzugefügt. Bitte kontaktieren Sie Ihren Administrator, um mit der Bearbeitung starten zu können."
				}
			},
			"taglist": {
				"label": "Art des Kampagnees"
			},
			"global": {
				"assign": "Zuordnen",
				"back": "Zurück",
				"cancel": "Abbrechen",
				"confirm": "Bestätigen",
				"continue": "Weiter",
				"delete": "Löschen",
				"delete_confirmation": "Bist Du sicher dass Du {name} löschen willst?",
				"delete_title": "Wirklich löschen?",
				"edit": "Editieren",
				"empty_collection": "Es gibt noch keine Einträge",
				"no_results": "Leider keine Ergebnisse.",
				"no": "Nein",
				"save": "Speichern",
				"show": "Anzeigen",
				"take_picture": "Foto aufnehmen",
				"unassign": "Entfernen",
				"valid": "Bestätigen",
				"yes": "Ja",
				"back_to_home": "Zurück zur Homepage",
				"lead_edit_abort": "Willst Du wirklich zurück? Es gibt ungespeicherte Änderungen.",
				"date_time": {
					"today": "heute",
					"yesterday": "gestern",
					"seconds_ago": "vor ein paar Sekunden",
					"less_than_minute": "vor weniger als einer Minute",
					"minutes_ago": "vor ein paar Minuten",
					"now": "jetzt",
					"at": "um"
				}
			},
			"header": {
				"add-lead": "Talent hinzufügen",
				"add-project": "Kampagne hinzufügen"
			},
			"language": {
				"change": "Sprache ändern:",
				"de-tal": "DE",
				"en-tal": "EN /"
			},
			"menu": {
				"project_assignments_edit": "Zuweisungen",
				"businesskits": "Talentkits",
				"plans": "Plans",
				"change-language": "Ändere Sprache zu Englisch",
				"profile": "Profil",
				"business_kits": "Alle Talentkits",
				"dashboard": "Dashboard",
				"external_forms": "Formulare",
				"external_form_editor": "Editor",
				"external_form_options": "Optionen",
				"external_form_preview": "Vorschau",
				"general_settings": "Allgemeine Einstellungen",
				"lead_masks": "Talentmasken",
				"lead_mask_editor": "Editor",
				"lead_mask_options": "Optionen",
				"logout": "Abmelden",
				"manage_projects": "Kampagnen verwalten",
				"organizations": "Organisationen",
				"project_edit": "Einstellungen",
				"project_leads": "Talente",
				"project_statistics": "Statistiken",
				"projects": "Kampagnen",
				"projects_synchronize": "Sync mit CRM",
				"settings": "Benutzer verwalten",
				"statistics": "Statistiken",
				"trackings": "Trackings",
				"user_profile": "Profileinstellungen",
				"users": "Benutzer",
				"email_templates": "E-Mail Templates",
				"content_manager": "Manage",
				"contact_manager": "Kontaktmanager",
				"contacts": "Kontakte",
				"companies": "Unternehmen",
				"segments": "Segmente",
				"sync": "Sync",
				"workflows": "Workflows",
				"people": "Kontakte",
				"menu_tab_lead_capture": "Talenterfassung",
				"menu_tab_settings": "Einstellungen"
			},
			"pages": {
				"businesskits": "Alle Talentkits",
				"contact_us": "Kontaktiere uns",
				"contact_us_email": "mailto:talent@fanomena.io?subject=Account%20wiederherstellen&body=Liebes%20Fanomena%20Team%2C%0A%0ALeider%20kann%20ich%20mich%20weder%20zu%20meinen%20Account%20anmelden%20noch%20mein%20Passwort%20erfolgreich%20zur%C3%BCcksetzen.%20K%C3%B6nnt%20ihr%20mir%20bitte%20helfen%3F%0A%0ADanke%2C",
				"external-forms": "Formulare",
				"external-forms--button": "Ein Formular hinzufügen",
				"external-forms-create-button": "Formular erstellen",
				"external-forms-update-button": "Formular editieren",
				"get_your_access": "Zugang erhalten",
				"item-create": "Erstellen",
				"item-new": "Neu",
				"item-update": "Editiere {name}",
				"lead-create": "Talente zur Kampagne hinzufügen",
				"lead-edit": "Editiere ein Talent",
				"lead-mask-create-button": "Talentmaske aktualisieren",
				"lead-mask-edit": "Editiere {name}",
				"lead-mask-update-button": "Talentmaske aktualisieren",
				"lead-masks": "Talentmaske",
				"lead-no-businesskit": "Diesem Kampagne ist noch kein Talentkit zugewiesen.",
				"lead-statistics": "Talent-Statistiken",
				"lead-statistics-overview": "Übersicht",
				"lead-statistics-trackings": "Trackings",
				"lead-change-count": "{num} Änderung durchgeführt | {num} Änderungen durchgeführt",
				"login": "Willkommen",
				"login_details": "Trage Deine Details ein um fortzufahren",
				"logout": "Danke",
				"logout_details": "dass Du Fanomena Talent benutzt hast. Bis bald!",
				"opt-ins": "Alle Opt-Ins",
				"organization-edit": "Editiere {name}",
				"organization-edit-button": "Organisation aktualisieren",
				"organization-new": "Organisation erstellen",
				"organization-new-button": "Organisation erstellen",
				"organization-create-button": "Organisation erstellen",
				"organization-update-button": "Organisation aktualisieren",
				"organizations": "Alle Organisationen",
				"password_reset": "Trage hier ein neues Passwort ein",
				"password_reset_confirm": "Dein Passwort wurde erfolgreich zurückgesetzt",
				"password_reset_request": "Trage Deine E-Mail Adresse ein und wir senden Dir einen Link, mit dem Du Dein Passwort wiederherstellen kannst.",
				"password_reset_request_confirm": "Eine E-Mail mit einem Passwort-Zurücksetzen-Link wurde an die E-Mail Adresse geschickt sofern sie existiert.",
				"project-assign": "Zum Kampagne hinzufügen",
				"project-create": "Neues Kampagne hinzufügen",
				"project-create-button": "Kampagnen erstellen",
				"project-download-data": "Daten als XLS herunterladen",
				"project-download-data-suceed": "Die XLS-Datei wurde an Deine E-Mail Adresse geschickt",
				"project-edit": "Editiere {name}",
				"project-options": "Kampagne Optionen",
				"project-show": "{name}",
				"project-update-button": "Speichern",
				"projects": "Kampagnen",
				"statistic-show": "Statistik Details: {name}",
				"statistics": "Statistiken",
				"take_a_tour": "Zur Webseite",
				"user-edit": "Editiere {name}",
				"user-edit-button": "Benutzer aktualisieren",
				"user-new-button": "Benutzer hinzufügen",
				"user-show": "Benutzer: {name}",
				"user-update-button": "Benutzer aktualisieren",
				"users": "Benutzer",
				"email-templates": "E-Mail Templates",
				"email-templates-update": "Template editieren",
				"email-templates-create": "Template erstellen",
				"email-templates-new": "Erstelle ein Template",
				"email-templates-update-button": "Template editieren",
				"email-templates-create-button": "Erstelle Template",
				"email-templates-new-button": "Erstelle ein Template",
				"project-assign-businesskit": "Talentkits zuweisen",
				"project-assign-user": "Benutzer zuweisen",
				"project-assigned-businesskit": "Talentkits",
				"project-assigned-user": "Benutzer",
				"project-assignments": "Kampagne Zuweisungen",
				"project-edit-user": "Editieren",
				"user-invite": "Benutzer einladen",
				"project-next-button": "Weiter",
				"project-capture-leads": "Zum Kampagne",
				"project-view-talentkit": "Talentkit zuweisen",
				"project-create-talentkit": "Talentkit zuweisen",
				"project-create-content": "Inhalte erstellen",
				"previous": "Zurück",
				"workflow-update-button": "Workflow aktualisieren",
				"workflows": "Workflows",
				"contacts": "Alle Kontakte",
				"companies": "Unternehmen",
				"segments": "Alle Segmente"
			},
			"project_wizard": {
				"step1-title": "Kampagne anlegen",
				"step2-title": "Talentkit wählen",
				"step2-invite-users": "Lade neue Benutzer zu Fanomena Talent ein",
				"step2-assign-users": "Füge einen weiteren Benutzer zu diesem Kampagne hinzu",
				"businesskits": "Jede Kampagne ist mit einem Talentkit verknüpft.",
				"lead-sheets": "Talentmasken",
				"leadsheet-create": "Individuelle Talentkit erstellen",
				"leadsheet-create-tip": "Bitte nehmen Sie Kontakt mit uns auf, wenn Sie eine individuelle Talentmaske erstellen möchten.",
				"leadsheet-basic": "Digitale Talentmaske zur Erfassung von personenbezogenen und geschäftlichen Daten.",
				"leadsheet-advanced": "Digitale Talentmaske, die alle Elemente der Standard Talentmaske und zusätzliche Fragen zur Qualifizierung Ihrer Talente enthält.",
				"success-title": "Herzlichen Glückwunsch. Sie haben Ihr Kampagne erfolgreich erstellt.",
				"success-subtitle": "Wie möchten Sie fortfahren?",
				"step2-invite": "Um bestehende Talent Benutzer diesem Kampagne zuzuordnen, gehen Sie nach der Erstellung Ihrer Kampagne zu den Kampagneneinstellungen."
			},
			"searchbar": {
				"placeholder": {
					"bk": "Trag einen Talentkit Namen ein…",
					"email_templates": "Trag einen Namen ein…",
					"external_forms": "Trag einen Namen oder Kampagne ein…",
					"lead_masks": "Trag einen Namen ein…",
					"organizations": "Trag einen Namen ein…",
					"projects": "Suche nach einer Kampagne…",
					"project_leads": "Suche nach Talenten…",
					"users": "Trag einen Vornamen, Nachnamen oder E-Mail ein…"
				}
			},
			"tabs": {
				"company_tab": "Firmendaten",
				"kits_tab": "Kits",
				"personal_tab": "Persönlich",
				"qualify_tab": "Qualifikation",
				"stats_tab": "Stats"
			},
			"external_form": {
				"preview_page": {
					"title": "Einbetten",
					"head_paragraph": "Um das Formular auf Ihrer Webseite einzubinden, laden Sie bitte folgenden Script in Ihren <head>-Tag.",
					"html_paragraph": "Binden Sie danach das Formular via html-Tag dort ein, wo Sie es auf Ihrer Seite anzeigen wollen.",
					"script_paragraph": "Laden Sie danach das Formular via Javascript.",
					"head_section_title": "Head",
					"html_section_title": "HTML",
					"script_section_title": "Script",
					"forms_cannot_be_submitted": "Formulare können in der Vorschau nicht abgesendet werden. Das Aussehen des Formulars kann über die Webseite auf der es eingebettet wird individuell gesteuert werden."
				},
				"follow_up": "Folgeaktionen",
				"tabs": {
					"general": "Allgemein",
					"config": "Konfiguration",
					"editor": "Editor",
					"preview": "Vorschau"
				},
				"basic_config": "Grundeinstellungen",
				"form_editor": "Formular Editor",
				"frontend_actions": "Aktion wenn der Besucher das Formular abschickt:",
				"backend_actions": "Follow up Aktionen:",
				"bk_boarding": "Talentkit Boarding",
				"send_directly": "Verschicke das Talentkit manuell?",
				"email_notification": "E-Mail Benachrichtigung",
				"add_to_mailchimp": "Zu Mailchimp Liste hinzufügen",
				"field_assignation": "Felder-Zuweisungen Mailchimp",
				"board_bk": "Talentkit Boarding",
				"success_message": "Erfolgs-Nachricht:",
				"redirection_url": "Weiterleiten zu URL:",
				"send_notification_to": "Verschicke Benachrichtung an E-mail Adressen:",
				"mailchimp_list_id": "Mailchimp Listen ID",
				"board_citrix": "Citrix Boarding",
				"citrix_keys": "Citrix Webinar Keys",
				"send_lead_confirmation_mail": "Verschicke Benachrichtigung an Talent",
				"email_template": "E-Mail Template",
				"mail_subject": "E-Mail Betreff",
				"mail_url": "CTA URL",
				"mail_cta": "CTA Text"
			},
			"lead_mask_editor": {
				"see_raw": "Talentmask Original Content",
				"edit_element": "Element editieren",
				"delete_element": "Element löschen",
				"cancel": "Abbrechen",
				"valid": "Bestätigen",
				"chose_element": "Wähle ein Element",
				"name": "Name",
				"type": "Typ",
				"default_value": "Standardwert",
				"default_field": "Standardfeld",
				"element_width": "Element Breite",
				"required": "Pflichtfeld",
				"class": "Klasse",
				"label": "Label",
				"placeholder": "Platzhalter",
				"children": "Children",
				"displayed_name": "Angezeigt",
				"value": "Wert",
				"add_line": "Hinzufügen",
				"collection": "Collection",
				"delete": "Löschen",
				"set_default_value": "Als Standard setzen",
				"basic_config": "Grundeinstellungen"
			},
			"organizations": {
				"api": "Externe Anbindungen",
				"configuration": "Konfiguration",
				"general_settings": "Allgemeine Einstellungen"
			},
			"upload": {
				"dropzone_message": "Dateien hineinziehen oder zum Hochladen Klicken",
				"empty_file": "Datei entfernen"
			},
			"users": {
				"invite": "Benutzer einladen",
				"invite_xls_success": "Benutzer wurden erfolgreich hinzugefügt",
				"xls_invite": "Via XLS einladen",
				"xls_invite_description": "Du kannst eine XLS Datei mit den Benutzern die Du einladen willst bereitstellen. Diese werden dann eine Einladungs-E-Mail erhalten.",
				"xls_invite_format": "Die XLS Datei sollte drei Spalten beinhalten: firstname, lastname und email. Nur das E-Mail Feld ist Pflicht aber firstname und lastname sind empfohlen."
			},
			"integrations": {
				"go-to-webinar": "Füge automatisch alle Talent, die dein Formular ausfüllen, zu einem Webinar hinzu."
			},
			"modals": {
				"businesskit_assignment": {
					"title": "Talentkits verwalten",
					"subtitle": "Wählen Sie die Talentktis aus, die Sie der aktuellen Kampagne zuordnen möchte"
				},
				"user_assignment": {
					"title": "Benutzer verwalten",
					"subtitle": "Wählen Sie die Benutzer aus, die Sie der aktuellen Kampagne zuordnen möchten."
				},
				"workflow": {
					"create": {
						"title": "Erstellen eines Workflow"
					}
				},
				"warning": {
					"button": "Ich verstehe"
				}
			},
			"drag_editor": {
				"extra_values": "und {num} extra.",
				"unpublished_changes": "Es gibt unveröffentlichte Änderungen",
				"popup": {
					"unsaved_changes": "Du hast nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?"
				},
				"active_item": {
					"edit": "Ausgewähltes Element bearbeiten",
					"label": "Etikett",
					"value": "Wert"
				},
				"fields": {
					"add_item": "Eintrag hinzufügen",
					"label": "Etikett",
					"text": "Text",
					"placeholder": "Platzhaltertext",
					"required": "Dieses Feld muss ausgefüllt werden",
					"hidden": "Dieses Feld ausblenden",
					"class": "CSS-Klasse",
					"default_value": "Vorauswahl",
					"default_value_options": "Standardwert",
					"validation": "Fehlermeldung",
					"internal_name": "Interner Name",
					"show_as_buttons": "Stelle Elemente als Buttons dar",
					"enrich_tags": "Speichere Selektierung als Tags",
					"data_type": "Datentyp",
					"data_types": {
						"text": "Text",
						"number": "Nummer",
						"email": "E-Mail",
						"tel": "Telefonnummer",
						"url": "Url"
					}
				},
				"dragElements": {
					"generic": "Allgemeine Felder",
					"leadMask": "Talentmasken Felder",
					"basic": "Basic Elemente",
					"fields": "Felder",
					"advanced": "Erweiterte Felder",
					"standard": "Standard Felder"
				},
				"badges": {
					"hidden": "Verstecktes Feld"
				},
				"placeholders": {
					"anchor": "Link",
					"bold": "Fett",
					"italic": "Kursiv",
					"underline": "Unterstrichen"
				},
				"screenTooSmall": {
					"title": "Es tut uns Leid!",
					"subtitle": "Um unseren Editor effizient zu nutzen müssen Sie eine höhere Auflösung auf Ihrem Bildschirm einstellen."
				}
			}
		}
	}
};

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

module.exports = {
	"en-tal": {
		"ui": {
			"project": {
				"advanced_subtitle_2": "Qualification",
				"standard_title": "The standard talent sheet includes:",
				"standard_subtitle_1": "Personal",
				"standard_subtitle_2": "Company",
				"standard_description_1": "Language, Gender, Title, Name, Last name, E-mail, Position, Function, Role, Job",
				"standard_description_2": "Company name, Branch, Phone, Website, Street, Number, Postal code, State, Country",
				"advanced_title": "The advanced talent sheet includes the same tabs and fields as the standard talent sheet and in addition:",
				"advanced_description_1": "Customer enquiries, Information, E-mail marketing (newsletter, event and e-mail subscriptions)",
				"advanced_description_2": "Notes, Interested in, Campaign planned (duration in months)",
				"advanced_subtitle_1": "Campaign Appointment",
				"create_leadsheet": "Create a new talent sheet"
			},
			"segments": {
				"segments": "Segments",
				"is_editing_state": "Save the segment before proceeding",
				"add_to_project": {
					"empty": "No campaigns",
					"success": "Your contacts are being added to the campaign. This may take a few minutes.",
					"error": "Something went wrong while adding contacts to campaigns"
				},
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Created on",
					"updated": "Last updated",
					"creator": "Creator"
				},
				"actions": {
					"success": "Succesfully saved segment!",
					"error": "Could not save the segment.",
					"edit": "Edit",
					"edit_description": "Edit",
					"duplicate": "Duplicate",
					"duplicate_description": "Duplicate",
					"duplicate_name": "Copy of {name}",
					"delete": "Delete",
					"delete_description": "Delete"
				},
				"business_kit": {
					"segment_title": "Send to",
					"subtext": "Make sure your BusinessKit is set up correctly before sending",
					"contacts": "Contacts",
					"success": "Successfully sent businesskits",
					"error": "Something went wrong while sending businesskits",
					"preview": "Preview",
					"email_templates_confirmation": "Confirm that there is an email template for this BusinessKit. If an email template has not been created this BusinessKit will not be sent."
				},
				"create_modal": {
					"title": "Create segment",
					"field_label": "New segment name",
					"duplicate": "Create",
					"name": "Name"
				},
				"delete_modal": {
					"title": "Delete segment"
				},
				"duplicate_modal": {
					"title": "Duplicate segment",
					"duplicate": "Duplicate",
					"name": "New segment name"
				},
				"businesskits_modal": {
					"title": "Send out ready",
					"send": "Send Kit"
				},
				"add_to_project_modal": {
					"title": "Add to campaign",
					"search_label": "Search for campaign",
					"add_button": "Add"
				},
				"export": {
					"success": "Export complete. You should receive an email with your contacts shortly.",
					"error": "Something went wrong with the export, please try again."
				},
				"delete": {
					"success": "Contacts successfully deleted",
					"error": "One or more contacts could not be deleted"
				}
			},
			"segment": {
				"breadcrumb_back": "All segments"
			},
			"contacts": {
				"modals": {
					"delete": {
						"title": "Delete Contacts"
					}
				},
				"title": "Contacts",
				"create": "Create contact",
				"empty_state_msg": "No contacts match filters",
				"columns": {
					"name": "Name",
					"id": "ID",
					"created": "Created on",
					"updated": "Last updated",
					"company": "Company",
					"source": "Source",
					"email": "Email",
					"gender": "Gender"
				},
				"actions": {
					"export": "Export",
					"save_to_project": "Add to campaign",
					"send_businesskit": "Send a businesskit",
					"error": "There has been an error updating the contact",
					"success": "The contact has been updated successfully",
					"delete": "Delete"
				},
				"filters": {
					"custom_placeholder": "Campaign attributes...",
					"general": {
						"none": "None assigned"
					},
					"project": {
						"label": "Campaign name",
						"none": "Belongs to no campaigns"
					},
					"company": {
						"label": "Company",
						"none": "Belongs to no company"
					},
					"gender": {
						"label": "Gender",
						"options": {
							"male": "Male",
							"female": "Female"
						}
					},
					"language": {
						"label": "Language",
						"options": {
							"en": "English",
							"de": "German"
						}
					},
					"invalid_email": {
						"label": "Email is valid",
						"condition_label": "Email",
						"options": {
							"valid": "valid",
							"not_valid": "not valid"
						}
					},
					"created": {
						"label": "Created"
					},
					"updated": {
						"label": "Updated"
					},
					"city": {
						"label": "City"
					},
					"country": {
						"label": "Country"
					},
					"tags": {
						"label": "Tags"
					},
					"classification": {
						"label": "Classification",
						"options": [
							{
								"value": "unclassified",
								"name": "Unclassified"
							},
							{
								"value": "hot",
								"name": "Hot"
							},
							{
								"value": "warm",
								"name": "Warm"
							},
							{
								"value": "cold",
								"name": "Cold"
							}
						]
					}
				},
				"import": {
					"title": "Import Contacts",
					"description": "Upload a CSV or XLS file containing the contacts to be imported.",
					"format": "The file should contain at least three columns: firstname, lastname and email. Only the email is mandatory but first name and last name are highly recommended.",
					"success_flash": "Contacts were successfully imported",
					"success_modal_title": "Import complete",
					"success_modal_body": "Your contacts have been successfully imported.",
					"success_modal_report": "From the {total} contacts imported, {new} new contacts were created, and {updated} were updated."
				}
			},
			"contact": {
				"edit": "Edit",
				"change_company": "Change",
				"breadcrumb_back": "All contacts",
				"empty_state_text": "This contact has not been captured as a talent yet.",
				"contact_details": "Contact details",
				"company_details": "Company details",
				"created": "Created",
				"updated": "Updated",
				"is_lead_on": "Is talent on",
				"go_to_lead": "Go to talent",
				"tags": "Tags",
				"source": "Source",
				"sources": {
					"web_app": "Web App",
					"mobile_app": "Mobile App",
					"external_form": "External Form",
					"crm_sync": "CRM Sync",
					"upload": "Upload",
					"unknown": "Unknown"
				},
				"caption": {
					"email": "Email",
					"firstname": "First Name",
					"lastname": "Last Name",
					"business_card_job_title": "Job Title",
					"company_department": "Department",
					"phone_mobile": "Mobile Phone",
					"phone_company": "Company Phone",
					"phone_private": "Private Phone",
					"gender": "Gender",
					"language": "Language"
				}
			},
			"xtable": {
				"toggle_columns": "Toggle Columns",
				"actions": "Actions",
				"page_size_label": "View",
				"search_placeholder": "Search",
				"save_search_title": "Save search",
				"save_search_label": "Name",
				"empty_state_label": "No data matches filters",
				"empty_cell_value": "No {name} assigned"
			},
			"xfilters": {
				"confirm_removal": "Yes, remove filter",
				"add_filter": "Add Filter",
				"add_filter_confirm": "Add",
				"delete_filter_warning": "You are about to remove or replace a filter condition which other conditions depend on. If you continue, then all of those dependant conditions will also be removed.",
				"delete_filter_confirmation": "Are you sure you want to continue?",
				"conditions": {
					"operators": {
						"and": "and",
						"or": "or"
					},
					"predicates": {
						"has_any": "has any of",
						"has_all": "has all of"
					},
					"summary": {
						"is": "{0} is {1}",
						"has_all": "{0} has all of {1}",
						"has_any": "{0} has any of {1}",
						"includes": "{0} includes {1}",
						"is_not_assigned": "{0} is not assigned",
						"date_on": "{0} on {1}",
						"date_between": "{0} between {1} and {2}",
						"date_since": "{0} since {1}",
						"date_before": "{0} on or before {1}",
						"date_in_range": "{0} in the {1}",
						"date_in_range_simple": "{0} {1}"
					}
				},
				"xfiltermodal": {
					"date_from": "From",
					"date_to": "To"
				},
				"date_ranges": {
					"custom": "Custom",
					"today": "Today",
					"yesterday": "Yesterday",
					"past_week": "Past week",
					"past_month": "Past month",
					"past_year": "Past year"
				}
			},
			"drag_elements": {
				"gender": "Gender/Salutation",
				"paragraph": "Paragraph",
				"title": "Title",
				"confirmation": "Confirmation",
				"firstname": "Firstname",
				"lastname": "Lastname",
				"email": "Email",
				"company": "Company",
				"street": "Street",
				"street_number": "Street number",
				"zip": "Post code",
				"city": "City",
				"country": "Country",
				"website": "Website",
				"phone_company": "Phone (Company)",
				"phone_mobile": "Phone (Mobile)",
				"textfield": "Textfield",
				"long_textfield": "Long textfield",
				"multi_select": "Multi select",
				"dropdown": "Dropdown",
				"single_select": "Single select",
				"date": "Date",
				"readonly": "Readonly",
				"quantity_selection": "Quantity selection",
				"drawing": "Drawing"
			},
			"breadcrump": {
				"back": "Back",
				"all_projects": "All campaigns"
			},
			"dashboard": {
				"filter": {
					"all_projects": "All campaigns"
				},
				"leads_collected_label": "Talents collected",
				"most_active_projects": "Most active campaigns",
				"leads_over_time": {
					"label": "Talent over time",
					"linear": "Talents"
				},
				"conversion_funnel": {
					"label": "Conversion funnel",
					"leads": "Talente"
				},
				"hot": "Hot",
				"warm": "Warm",
				"cold": "Cold",
				"unclassified": "Unclassified",
				"top_projects_label": "Top campaigns",
				"kit_activity_label": "Latest interactions",
				"latest_activity_label": "Latest activity",
				"leads_by_project_label": "Contacts by campaigns",
				"leads_by_most_active_projects_label": "Talents by most active Campaign",
				"leads_by_most_active_projects": {
					"me": "Me",
					"org": "Org"
				},
				"empty_state_headline": "The dashboard will show up once there is enough date",
				"empty_state_intro": "Start creating your first content",
				"empty_state_cta": "Create a campaign",
				"top_sources_label": "Top sources",
				"active_leads": {
					"label": "Most active contacts",
					"today": "Today",
					"last_7": "Last 7 days",
					"last_month": "Last month",
					"last_year": "Last year",
					"all_time": "All time"
				},
				"leads_over_time_label": "Contacts over time",
				"axischart": {
					"last_week": "Last week",
					"last_month": "Last month",
					"last_year": "Last year"
				},
				"top_projects": {
					"kits": "Kits",
					"leads": "Talente",
					"my_leads": "My Talents",
					"lead_sheet": "Talent sheet"
				},
				"top_sources": {
					"last_week": "Last week",
					"last_month": "Last month",
					"last_year": "Last year",
					"web_app": "Web app",
					"external_forms": "External forms",
					"mobile_app": "Mobile app"
				},
				"kit_activity": {
					"all": "All",
					"opened_a_kit": "opened a kit",
					"updated_a_lead": "updated a contact",
					"empty_state_headline": "No kit activity yet",
					"empty_state_intro": "Create an engaging and personalized content experience that helps genuinely connect with your company."
				},
				"latest_activity": {
					"label": "Newest Talents"
				},
				"activity_list_widget": {
					"created_a_lead": "created a contact",
					"updated_a_lead": "updated a contact",
					"on": "on",
					"latest_activity": "Latest activity",
					"empty_state_headline": "No activity yet",
					"empty_state_intro": "Start a campaign"
				}
			},
			"meta_info": {
				"invitation": "Welcome to Talent",
				"reset_password": "Reset your password"
			},
			"email_template": {
				"placeholders": {
					"firstname": "Firstname",
					"lastname": "Last name",
					"formal": "Formal salutation",
					"informal": "Informal salutation",
					"gender": "Mr/Mrs",
					"form_title": "Form title"
				}
			},
			"external_form": {
				"preview_page": {
					"title": "Embed",
					"head_paragraph": "To include the form on your website, please load the following script into your <head> tag.",
					"html_paragraph": "Then insert the form via html tag where you want it to appear on your page.",
					"script_paragraph": "Then load the form via Javascript.",
					"head_section_title": "Head",
					"html_section_title": "HTML",
					"script_section_title": "Script",
					"forms_cannot_be_submitted": "Please note that forms cannot be submitted in preview mode. You can easily control the form styling via the page on which you embed it."
				},
				"follow_up": "Follow up actions",
				"tabs": {
					"general": "General",
					"config": "Configuration",
					"editor": "Editor",
					"preview": "Preview"
				},
				"add_element": "Add an element",
				"add_container": "Add a container",
				"add_field": "Add a field",
				"preview": "Preview form",
				"empty": "None",
				"fileds": "Talentmask fields",
				"basic_config": "Basic configuration",
				"lead_mask_field": "Talent sheet field",
				"form_editor": "Form editor",
				"frontend_actions": "Action when visitor submits the form:",
				"backend_actions": "Follow up actions:",
				"bk_boarding": "Talentkit boarding",
				"send_directly": "Send the Talentkit manually?",
				"email_notification": "Notification by email",
				"add_to_mailchimp": "Add to a mailchimp list",
				"field_assignation": "Field assignments",
				"board_bk": "Board a Talentkit",
				"success_message": "Success message",
				"redirection_url": "Redirect URL",
				"send_notification_to": "Send notifications to email adresses:",
				"mailchimp_list_id": "Mailchimp list id",
				"board_citrix": "Board Citrix",
				"citrix_keys": "Citrix webinar keys",
				"send_lead_confirmation_mail": "Send notification mail to talent",
				"email_template": "Email template",
				"mail_subject": "Email subject",
				"mail_url": "CTA URL",
				"mail_cta": "CTA text"
			},
			"lead_mask_editor": {
				"see_raw": "See talent sheet raw content",
				"edit_element": "Edit an element",
				"delete_element": "Delete element",
				"title": "Title",
				"cancel": "Cancel",
				"valid": "Confirm",
				"chose_element": "Please choose an element",
				"name": "Name",
				"type": "Type",
				"content": "Content",
				"field": "Field",
				"default_value": "Default value",
				"default_field": "Default field",
				"element_width": "Element width",
				"required": "Required",
				"class": "Class",
				"label": "Label",
				"placeholder": "Placeholder",
				"children": "Children",
				"displayed_name": "Displayed name",
				"value": "Value",
				"add_line": "Add a line",
				"collection": "Collection",
				"delete": "Delete",
				"set_default_value": "Set as default value",
				"basic_config": "Grundeinstellungen",
				"tabs": {
					"general": "General",
					"editor": "Editor"
				}
			},
			"auth": {
				"button": "Login",
				"confirm": "Set password",
				"create_account_subtitle": "Setup your password below",
				"create_account_subtitle_confirm": "You have setup your account successfully. Please login to Talent now.",
				"create_account_title": "Create your account",
				"create_account_title_confirm": "Congratulations",
				"email": "Email address",
				"firstname": "First Name",
				"go_to_login": "To the login",
				"password": "Password",
				"password_confirmation": "Confirm password",
				"password_reset": "Password forgotten ?",
				"password_reset_request_title": "Reset your password",
				"password_reset_request_title_confirm": "Check your email inbox",
				"password_reset_sent": "An email with a password reset link has been sent to the given email if it exists.",
				"password_reset_title": "Password reset",
				"password_reset_title_confirm": "Congratulations",
				"lastname": "Last Name",
				"return_to_login": "Get back to login page",
				"success": "Your password has been set successfully. You can now login into the Fanomena Talent products.",
				"user_not_found": "User not found",
				"user_not_found_subtitle": "We're sorry but the user you are trying to access was not found in our system.<br/>Maybe your invitation link has expired or the user has been deleted."
			},
			"auth_illustration": {
				"contact_us": "Contact us",
				"get_access": "Get your access",
				"invitation_subtitle": "Explore your opportunities",
				"invitation_title": "Want to know more about Fanomena Talent?",
				"login_subtitle": "Let us show you Fanomena Talent",
				"login_title": "New here and want to look around?",
				"reset_request_subtitle": "Let us help you",
				"reset_request_title": "Impossible to recover?",
				"reset_subtitle": "Let us help you",
				"reset_title": "Impossible to recover?"
			},
			"business_kit": {
				"preview": "Preview Talentkit",
				"confirmation": "This confirms that information material has been requested and may be sent.",
				"history": "Talentkits sent",
				"send": "Send a Talentkit",
				"send_confirm": "Send Talentkit"
			},
			"button": {
				"double_optin": "Sure?",
				"external_forms": {
					"new": "Add a form"
				},
				"external_form": {
					"add_popup": "Add a form"
				},
				"lead_mask": {
					"save": "Save",
					"publish": "Publish"
				},
				"lead_masks": {
					"add_popup": "Add a talent sheet"
				},
				"opt-ins": {
					"new": "Add an opt-in"
				},
				"organizations": {
					"new": "Add an organization"
				},
				"email_templates": {
					"new": "Add a template"
				},
				"project_leads": {
					"add_popup": "Add talent",
					"confirm_mail": "Confirm email address",
					"confirm_picture": "Save & continue",
					"continue": "New Company",
					"create": "Add talent",
					"export": "Export xls",
					"make_another_picture": "Make another",
					"new": "Add talent",
					"take_picture": "Take a picture of a business card"
				},
				"projects": {
					"new": "Create a campaign"
				},
				"users": {
					"invite": "Invite",
					"invite_xls": "Invite via xls",
					"new": "Add a user",
					"upload_xls": "Proceed"
				},
				"workflows": {
					"new": "Create new workflow",
					"trigger": "Trigger workflow"
				}
			},
			"filters": {
				"apply": "Apply",
				"hint": "Filter search results",
				"import_origin": "Import origin",
				"origin": "Talent origin",
				"reset": "Reset",
				"start_date": "Start date",
				"sync_disabled": "CRM sync",
				"sync_status": "Sync status",
				"categories": "Categories"
			},
			"footer": {
				"imprint": "Imprint",
				"privacy": "Privacy",
				"terms": "Terms",
				"security": "Security"
			},
			"onboarding": {
				"next": "Next",
				"skip": "Skip",
				"start": "Start",
				"step1": {
					"title": "Create a Campaign",
					"subtitle": "Create a campaign in just a few clicks and start digitizing your next event or marketing campaign."
				},
				"step2": {
					"title": "Start Capturing Talent",
					"subtitle": "Create sign up forms and connect Talent's customizable web forms to your next digital Talent acquisition campaign."
				},
				"step3": {
					"title": "Create Content",
					"subtitle": "Create and distribute personalized digital content to enhance the nurturing process and  convert more talents to customers."
				}
			},
			"content_manager": {
				"first-card": {
					"title": "Talentkits",
					"subtitle": "Create an engaging and personalized content experience that helps genuinely connect with your company.",
					"btn": "Create a talentkit"
				},
				"second-card": {
					"title": "Forms",
					"subtitle": "Create custom web forms that connect directly to your existing marketing solutions (webinar tool, CRM,etc.) to onboard new prospects and automate the follow-up process.",
					"btn": "Create a form"
				},
				"third-card": {
					"title": "Talent Sheets",
					"subtitle": "Create a custom digital talent sheet to gather everything you need for the talent nurturing process.",
					"btn": "Contact support"
				}
			},
			"empty_state": {
				"projects": {
					"title": "Start Creating a New Campaign",
					"title-standard-user": "Welcome to Talent",
					"subtitle": "Digitize your talent acquisition process and start tracking your data all in one place.",
					"standard-user": "Please contact your admin to create a new campaign to get started."
				},
				"leads": {
					"title": "Start capturing talent for your next campaign.",
					"subtitle": "Capture the information you need to qualify and track new talent."
				}
			},
			"taglist": {
				"label": "Campaign Labels"
			},
			"global": {
				"add": "Add",
				"assign": "Assign",
				"back": "Back",
				"back_to_home": "Go back to the homepage",
				"cancel": "Cancel",
				"confirm": "Confirm",
				"continue": "Continue",
				"delete": "Delete",
				"delete_confirmation": "Are you sure you want to delete {name}?",
				"delete_title": "Delete this item?",
				"lead_edit_abort": "Do you really want to leave? There are unsaved changes!",
				"edit": "Edit",
				"empty_collection": "There are no items yet",
				"no_results": "Sorry, there are no results.",
				"no": "No",
				"save": "Save",
				"show": "Show",
				"take_picture": "Take a picture",
				"unassign": "Unassign",
				"valid": "Confirm",
				"yes": "Yes"
			},
			"header": {
				"add-lead": "Add a talent",
				"add-project": "Add a campaign"
			},
			"language": {
				"change": "Change language:",
				"de-tal": "DE",
				"en-tal": "EN /"
			},
			"menu": {
				"project_assignments_edit": "Assignments",
				"plans": "Plans",
				"profile": "Profile",
				"change-language": "Change language to German",
				"business_kits": "All Talentkits",
				"dashboard": "Dashboard",
				"external_forms": "Forms",
				"external_form_editor": "Editor",
				"external_form_options": "Options",
				"external_form_preview": "Preview",
				"general_settings": "General settings",
				"lead_masks": "Talent Sheets",
				"lead_mask_editor": "Editor",
				"lead_mask_options": "Options",
				"logout": "Logout",
				"businesskits": "Talentkits",
				"manage_projects": "Manage campaigns",
				"organizations": "Organizations",
				"project_edit": "Campaign settings",
				"project_leads": "Talents",
				"project_statistics": "Statistics",
				"projects": "Campaigns",
				"projects_synchronize": "Sync with CRM",
				"settings": "Manage users",
				"statistics": "Statistics",
				"trackings": "Trackings",
				"email_templates": "Email Templates",
				"user_profile": "Profile settings",
				"users": "Collaborators",
				"content_manager": "Content Manager"
			},
			"organizations": {
				"api": "External services",
				"configuration": "Configuration",
				"general_settings": "General settings"
			},
			"pages": {
				"businesskits": "All businesskits",
				"contact_us": "Contact us",
				"contact_us_email": "mailto:talent@fanomena.io?subject=Account%20recovery&body=Dear%20Fanomena%20Team%2C%0A%0AI%20am%20not%20able%20to%20log%20into%20my%20account%2C%20and%20have%20not%20been%20able%20to%20successfully%20reset%20my%20password.%20Can%20you%20please%20assist%20me%3F%0A%0ABest%2C",
				"email-templates": "Email templates",
				"email-templates-update": "Edit a template",
				"email-templates-create": "Create a template",
				"email-templates-new": "Create a template",
				"email-templates-create-button": "Create template",
				"email-templates-update-button": "Update template",
				"email-templates-new-button": "Create a template",
				"external-forms": "External forms",
				"external-forms--button": "Add a form",
				"external-forms-create-button": "Create form",
				"external-forms-update-button": "Edit form",
				"get_your_access": "Get your access",
				"item-create": "Create",
				"item-new": "New",
				"item-update": "Edit {name}",
				"lead-create": "Add talent to campaign",
				"lead-edit": "Edit a talent",
				"lead-mask-create-button": "Create talent sheet",
				"lead-mask-edit": "Edit {name}",
				"lead-mask-update-button": "Update talent sheet",
				"lead-masks": "Talent Sheets",
				"lead-no-businesskit": "There is no Talentkit assigned to this campaign",
				"lead-statistics": "Talent statistics",
				"lead-statistics-overview": "Overview",
				"lead-statistics-trackings": "Trackings",
				"lead-change-count": "Change made: {num} | Changes Made: {num}",
				"login": "Welcome",
				"login_details": "Enter you details to continue",
				"logout": "Thank you",
				"logout_details": "Thank you for using a product by Fanomena.",
				"opt-ins": "All opt-ins",
				"organization-edit": "Edit {name}",
				"organization-edit-button": "Update organization",
				"organization-new": "Create an organization",
				"organization-new-button": "Create organization",
				"organization-create-button": "Create organization",
				"organization-update-button": "Update organization",
				"organizations": "All organizations",
				"password_reset": "Enter your new password below",
				"password_reset_confirm": "Your password has been reset successfully",
				"password_reset_request": "Enter your email and we will send you a link, where you can recover your password",
				"password_reset_request_confirm": "An email with a password reset link has been sent to the given email if it exists.",
				"project-assign": "Assign to campaign",
				"project-assign-businesskit": "Assign Talenkits",
				"project-assign-user": "Assign collaborators",
				"project-assigned-businesskit": "Talentkits",
				"project-assigned-user": "Collaborators",
				"project-assignments": "Campaign assignments",
				"project-create": "Add a new campaign",
				"project-create-button": "Create campaign",
				"project-download-data": "Receive data as xls",
				"project-download-data-suceed": "The xls had been sent to your email address",
				"project-edit": "Edit {name}",
				"project-edit-user": "Edit",
				"project-options": "Campaign options",
				"project-show": "{name}",
				"project-update-button": "Save",
				"projects": "Campaigns",
				"statistic-show": "Statistic details: {name}",
				"statistics": "Statistics",
				"take_a_tour": "To the website",
				"user-edit": "Edit {name}",
				"user-edit-button": "Update collaborator",
				"user-invite": "Invite a collaborator",
				"user-new-button": "Add collaborator",
				"user-show": "collaborator: {name}",
				"user-update-button": "Update collaborator",
				"users": "Collaborators",
				"project-next-button": "Next",
				"project-capture-leads": "Go to campaign",
				"project-view-talentkit": "Go to Talentkit",
				"project-create-talentkit": "Create Talentkit",
				"project-create-content": "Create Content",
				"previous": "Back"
			},
			"project_wizard": {
				"step1-title": "Setup Campaign",
				"step2-title": "Choose Talentkit",
				"step2-invite-users": "Invite new collaborator to Fanomena Talent",
				"step2-assign-users": "Assign an existing Fanomena Talent user to this campaign",
				"businesskits": "Every campaign is connected to a Talentkit.",
				"lead-sheets": "Talent Sheets",
				"leadsheet-create": "Create Custom Talentkit",
				"leadsheet-create-tip": "Contact us if you are interested in creating a custom talent sheet.",
				"leadsheet-basic": "Digital talent sheet to capture personal and company talent details",
				"leadsheet-advanced": "Digital talent sheet that includes all standard talent sheet elements and additional questions to qualify your talent.",
				"success-title": "Congratulations, you have just created your first campaign!",
				"success-subtitle": "What would you like to do next?",
				"step2-invite": "To assign existing Talent users to this campaign, go to the Campaign Settings after setting up your campaign."
			},
			"searchbar": {
				"placeholder": {
					"bk": "Enter a talentkit name…",
					"email_templates": "Enter a specific name…",
					"external_forms": "Enter a specific name or campaign…",
					"lead_masks": "Enter a specific name…",
					"organizations": "Enter a specific organization name…",
					"projects": "Search for a campaign…",
					"contacts": "Search for a contact…",
					"project_leads": "Search for a talent…",
					"users": "Enter a firstname, lastname or email…"
				}
			},
			"tabs": {
				"company_tab": "Company",
				"kits_tab": "Kits",
				"personal_tab": "Personal",
				"qualify_tab": "Qualify",
				"stats_tab": "Stats"
			},
			"upload": {
				"dropzone_message": "Drag files or click to upload a file",
				"empty_file": "Remove the file"
			},
			"users": {
				"invite": "Invite a collaborator",
				"invite_xls_success": "Users were succesfully invited",
				"xls_invite": "Invite via xls",
				"xls_invite_description": "You can provide a CSV file containing the user you want to invite. They will receive an invitation email.",
				"xls_invite_format": "The file should contain at least three columns: firstname, lastname and email. Only the email is mandatory but first name and last name are highly recommended."
			},
			"integrations": {
				"go-to-webinar": "Automatically add all talent that fills out your form to a webinar"
			},
			"modals": {
				"businesskit_assignment": {
					"title": "Manage Talentkits",
					"subtitle": "Select the Talentktis that you want to assign to the current campaign"
				},
				"user_assignment": {
					"title": "Manage collaborators",
					"subtitle": "Select the collaborators that you want to assign to the current campaign."
				},
				"workflow": {
					"create": {
						"title": "Create a workflow"
					}
				},
				"warning": {
					"button": "I understand"
				}
			},
			"drag_editor": {
				"extra_values": "and {num} extra.",
				"unpublished_changes": "There are unpublished changes",
				"popup": {
					"unsaved_changes": "You have unsaved changes. Do you really wish to leave?"
				},
				"active_item": {
					"edit": "Edit selected element",
					"label": "Label",
					"value": "Value"
				},
				"fields": {
					"add_item": "Add item",
					"label": "Label",
					"text": "Text",
					"placeholder": "Placeholder text",
					"required": "Make this field required",
					"hidden": "Make this field hidden",
					"class": "CSS class",
					"default_value": "Default value",
					"default_value_options": "Preselect",
					"validation": "Error message",
					"internal_name": "Internal name",
					"show_as_buttons": "Show elements in button style",
					"enrich_tags": "Save selection as tags",
					"data_type": "Data type",
					"data_types": {
						"text": "Text",
						"number": "Number",
						"email": "Email",
						"tel": "Telephone number",
						"url": "Url"
					}
				},
				"dragElements": {
					"generic": "Generic Elements",
					"leadMask": "Talent Sheet Elements",
					"basic": "Basic elements",
					"fields": "Fields",
					"advanced": "Custom fields",
					"standard": "Standard fields"
				},
				"badges": {
					"hidden": "Hidden Field"
				},
				"placeholders": {
					"anchor": "Link",
					"bold": "Bold",
					"italic": "Italic",
					"underline": "Underline"
				},
				"screenTooSmall": {
					"title": "Sorry!",
					"subtitle": "In order to use our editor please switch to a higher resolution."
				}
			}
		}
	}
};

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./empty-business-card.svg": 203,
	"./empty-dashboard.svg": 432,
	"./empty-default.svg": 157,
	"./empty-funnel.svg": 433,
	"./empty-kit-activity.svg": 204,
	"./empty-kit.svg": 434,
	"./empty-leads.svg": 435,
	"./empty-projects.svg": 436
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2044;

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(344);
__webpack_require__(343);
__webpack_require__(671);
__webpack_require__(672);
module.exports = __webpack_require__(673);


/***/ })
],[2045]);


// WEBPACK FOOTER //
// static/js/app.257bc3d566adae7fe127.js